(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("81tj9", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $2PhsF = parcelRequire("2PhsF");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    var context = new $hBrVA(defaultConfig);
    var instance = $cG9HX($hBrVA.prototype.request, context);
    // Copy axios.prototype to instance
    $eFc3n.extend(instance, $hBrVA.prototype, context);
    // Copy context to instance
    $eFc3n.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance($1nuTH);
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = $hBrVA;
// Factory for creating new instances
$5d7526a7a1e5b3fb$var$axios.create = function create(instanceConfig) {
    return $5d7526a7a1e5b3fb$var$createInstance($2PhsF($5d7526a7a1e5b3fb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.Cancel = (parcelRequire("anxHC"));

$5d7526a7a1e5b3fb$var$axios.CancelToken = (parcelRequire("4iFhx"));

$5d7526a7a1e5b3fb$var$axios.isCancel = (parcelRequire("lCgfr"));
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5d7526a7a1e5b3fb$var$axios.spread = (parcelRequire("albzn"));

// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (parcelRequire("1YbHN"));
module.exports = $5d7526a7a1e5b3fb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {
'use strict';

var $cG9HX = parcelRequire("cG9HX");
// utils is a library of generic helper functions non-specific to axios
var $aace3e920a0f1e4d$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $aace3e920a0f1e4d$var$isArray(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $aace3e920a0f1e4d$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBuffer(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aace3e920a0f1e4d$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $aace3e920a0f1e4d$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $aace3e920a0f1e4d$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isPlainObject(val) {
    if ($aace3e920a0f1e4d$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $aace3e920a0f1e4d$var$isDate(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $aace3e920a0f1e4d$var$isFile(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $aace3e920a0f1e4d$var$isBlob(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $aace3e920a0f1e4d$var$isFunction(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $aace3e920a0f1e4d$var$isStream(val) {
    return $aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $aace3e920a0f1e4d$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $aace3e920a0f1e4d$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $aace3e920a0f1e4d$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($aace3e920a0f1e4d$var$isPlainObject(result[key]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[key] = $aace3e920a0f1e4d$var$merge(result[key], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[key] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $aace3e920a0f1e4d$var$extend(a, b, thisArg) {
    $aace3e920a0f1e4d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $cG9HX(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $aace3e920a0f1e4d$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isStandardBrowserEnv: $aace3e920a0f1e4d$var$isStandardBrowserEnv,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM
};

});
parcelRegister("cG9HX", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("hBrVA", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $iOHZJ = parcelRequire("iOHZJ");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");

var $2PhsF = parcelRequire("2PhsF");

var $8zXsW = parcelRequire("8zXsW");
var $cd0b8e3cbef64068$var$validators = $8zXsW.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $cd0b8e3cbef64068$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $9ltoJ(),
        response: new $9ltoJ()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $cd0b8e3cbef64068$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $2PhsF(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $8zXsW.assertOptions(transitional, {
        silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean, '1.0.0'),
        forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean, '1.0.0'),
        clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean, '1.0.0')
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $cUzFg,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $cUzFg(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$cd0b8e3cbef64068$var$Axios.prototype.getUri = function getUri(config) {
    config = $2PhsF(this.defaults, config);
    return $iOHZJ(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$eFc3n.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request($2PhsF(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eFc3n.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($2PhsF(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("iOHZJ", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eFc3n.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eFc3n.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($eFc3n.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $eFc3n.forEach(val, function parseValue(v) {
                if ($eFc3n.isDate(v)) v = v.toISOString();
                else if ($eFc3n.isObject(v)) v = JSON.stringify(v);
                parts.push($db2f05ec923f2ee7$var$encode(key) + '=' + $db2f05ec923f2ee7$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("9ltoJ", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
function $01c17f80085c95b1$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eFc3n.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $kgh03.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eFc3n.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eFc3n.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $1nuTH.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $kgh03.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$lCgfr(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $kgh03.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("kgh03", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $1nuTH;
    /*eslint no-param-reassign:0*/ $eFc3n.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("1nuTH", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $elOvr = parcelRequire("elOvr");

var $fEfFg = parcelRequire("fEfFg");
var $100fe7fc4c7b4810$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, value) {
    if (!$eFc3n.isUndefined(headers) && $eFc3n.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}


function $100fe7fc4c7b4810$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("8nTSD"));
    else if (typeof $ibaza !== 'undefined' && Object.prototype.toString.call($ibaza) === '[object process]') // For node use HTTP adapter
    adapter = (parcelRequire("8nTSD"));
    return adapter;
}
function $100fe7fc4c7b4810$var$stringifySafely(rawValue, parser, encoder) {
    if ($eFc3n.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eFc3n.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $100fe7fc4c7b4810$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $100fe7fc4c7b4810$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $elOvr(headers, 'Accept');
            $elOvr(headers, 'Content-Type');
            if ($eFc3n.isFormData(data) || $eFc3n.isArrayBuffer(data) || $eFc3n.isBuffer(data) || $eFc3n.isStream(data) || $eFc3n.isFile(data) || $eFc3n.isBlob(data)) return data;
            if ($eFc3n.isArrayBufferView(data)) return data.buffer;
            if ($eFc3n.isURLSearchParams(data)) {
                $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($eFc3n.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, 'application/json');
                return $100fe7fc4c7b4810$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $eFc3n.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $fEfFg(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$100fe7fc4c7b4810$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$eFc3n.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $100fe7fc4c7b4810$var$defaults.headers[method] = {};
});
$eFc3n.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $100fe7fc4c7b4810$var$defaults.headers[method] = $eFc3n.merge($100fe7fc4c7b4810$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $100fe7fc4c7b4810$var$defaults;

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});

parcelRegister("elOvr", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eFc3n.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("fEfFg", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("8nTSD", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $6D8uh = parcelRequire("6D8uh");

var $iOHZJ = parcelRequire("iOHZJ");

var $cgfHI = parcelRequire("cgfHI");

var $4Ik1V = parcelRequire("4Ik1V");

var $4YUSN = parcelRequire("4YUSN");

var $hYe4p = parcelRequire("hYe4p");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($eFc3n.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $cgfHI(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $iOHZJ(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $4Ik1V(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gyIfz(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hYe4p('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hYe4p('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hYe4p(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eFc3n.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $4YUSN(fullPath)) && config.xsrfCookieName ? $6D8uh.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $eFc3n.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eFc3n.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {
'use strict';

var $hYe4p = parcelRequire("hYe4p");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hYe4p('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hYe4p", function(module, exports) {
'use strict';

var $fEfFg = parcelRequire("fEfFg");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $fEfFg(error, config, code, request, response);
};

});


parcelRegister("6D8uh", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($eFc3n.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($eFc3n.isString(path)) cookie.push('path=' + path);
            if ($eFc3n.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("cgfHI", function(module, exports) {
'use strict';

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$uAxSn(requestedURL)) return $aFAjA(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("uAxSn", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("aFAjA", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("4Ik1V", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $36eacf0f5ae88424$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eFc3n.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $eFc3n.trim(line.substr(0, i)).toLowerCase();
        val = $eFc3n.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("4YUSN", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eFc3n.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("lCgfr", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("2PhsF", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($eFc3n.isPlainObject(target) && $eFc3n.isPlainObject(source)) return $eFc3n.merge(target, source);
        else if ($eFc3n.isPlainObject(source)) return $eFc3n.merge({}, source);
        else if ($eFc3n.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$eFc3n.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $eFc3n.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $eFc3n.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $eFc3n.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$eFc3n.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $eFc3n.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $eFc3n.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("8zXsW", function(module, exports) {
'use strict';

var $9lIsF = parcelRequire("9lIsF");
var $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $63efb8494987aa98$var$deprecatedWarnings = {};
var $63efb8494987aa98$var$currentVerArr = $9lIsF.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $63efb8494987aa98$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split('.') : $63efb8494987aa98$var$currentVerArr;
    var destVer = version.split('.');
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $63efb8494987aa98$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return '[Axios v' + $9lIsF.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed in ' + version));
        if (isDeprecated && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    isOlderVersion: $63efb8494987aa98$var$isOlderVersion,
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};

});
parcelRegister("9lIsF", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

});



parcelRegister("anxHC", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $78e631f68b7e223f$var$Cancel(message) {
    this.message = message;
}
$78e631f68b7e223f$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$78e631f68b7e223f$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $78e631f68b7e223f$var$Cancel;

});

parcelRegister("4iFhx", function(module, exports) {
'use strict';

var $anxHC = parcelRequire("anxHC");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $3218dd97b5460664$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $anxHC(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $3218dd97b5460664$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $3218dd97b5460664$var$CancelToken.source = function source() {
    var cancel;
    var token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("1YbHN", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});



var $3f4c5ccf8da2a18c$var$_a;
var $3f4c5ccf8da2a18c$var$_w = window;
$3f4c5ccf8da2a18c$var$_w._current_culture = "";
var $3f4c5ccf8da2a18c$var$culture = ($3f4c5ccf8da2a18c$var$_a = $3f4c5ccf8da2a18c$var$_w._culture) !== null && $3f4c5ccf8da2a18c$var$_a !== void 0 ? $3f4c5ccf8da2a18c$var$_a : {
    info: {
        thousandSep: ",",
        decimalSep: ".",
        dateFormat: "yy-mm-dd",
        numberFormat: "#,0.####"
    },
    /**
     * sets a culture
     * @param c  culture as string for example 'de' or 'en-us'
     */ set: function(c) {
        var cult_vals = $3f4c5ccf8da2a18c$var$culture.cultures[c.toLowerCase()];
        if (cult_vals === undefined) throw "unknown culture '" + c + "'";
        $3f4c5ccf8da2a18c$var$culture.info.decimalSep = cult_vals[0];
        $3f4c5ccf8da2a18c$var$culture.info.thousandSep = cult_vals[1];
        $3f4c5ccf8da2a18c$var$culture.info.dateFormat = cult_vals[2];
        $3f4c5ccf8da2a18c$var$_w.current_culture = c;
    },
    /**
     * returns current culture
     */ get: function() {
        return $3f4c5ccf8da2a18c$var$_w.current_culture;
    },
    cultures: {
        //         'ar':['.',',','dd/mm/y'],
        // 'bg':[',',' ','d.m.yy \'г.\''],
        // 'ca':[',','.','dd/mm/yy'],
        // 'zh-hans':['.',',','yy/m/d'],
        // 'cs':[',',' ','d.m.yy'],
        // 'da':[',','.','dd-mm-yy'],
        'de': [
            ',',
            '.',
            'dd.mm.yy'
        ],
        // 'el':[',','.','d/m/yy'],
        // 'es':[',','.','dd/mm/yy'],
        // 'fi':[',',' ','d.m.yy'],
        // 'fr':[',',' ','dd/mm/yy'],
        // 'he':['.',',','dd/mm/yy'],
        // 'hu':[',',' ','yy.mm.dd.'],
        // 'is':[',','.','d.m.yy'],
        // 'it':[',','.','dd/mm/yy'],
        // 'ja':['.',',','yy/mm/dd'],
        // 'ko':['.',',','yy-mm-dd'],
        // 'nl':[',','.','d-m-yy'],
        // 'no':[',',' ','dd.mm.yy'],
        // 'pl':[',',' ','yy-mm-dd'],
        // 'pt':[',','.','dd/mm/yy'],
        // 'rm':['.','\'','dd/mm/yy'],
        // 'ro':[',','.','dd.mm.yy'],
        // 'ru':[',',' ','dd.mm.yy'],
        // 'hr':[',','.','d.m.yy.'],
        // 'sk':[',',' ','d. m. yy'],
        // 'sq':[',','.','yy-mm-dd'],
        // 'sv':[',',' ','yy-mm-dd'],
        // 'th':['.',',','d/m/yy'],
        // 'tr':[',','.','dd.mm.yy'],
        // 'ur':['.',',','dd/mm/yy'],
        // 'id':[',','.','dd/mm/yy'],
        // 'uk':[',',' ','dd.mm.yy'],
        // 'be':[',',' ','dd.mm.yy'],
        // 'sl':[',','.','d.m.yy'],
        // 'et':[',',' ','d.mm.yy'],
        // 'lv':[',',' ','yy.mm.dd.'],
        // 'lt':[',','.','yy.mm.dd'],
        // 'tg':[',',' ','dd.mm.y'],
        // 'fa':['.',',','mm/dd/yy'],
        // 'vi':[',','.','dd/mm/yy'],
        // 'hy':['.',',','dd.mm.yy'],
        // 'az':[',',' ','dd.mm.yy'],
        // 'eu':[',','.','yy/mm/dd'],
        // 'hsb':[',','.','d. m. yy'],
        // 'mk':[',','.','dd.mm.yy'],
        // 'tn':['.',',','yy/mm/dd'],
        // 'xh':['.',',','yy/mm/dd'],
        // 'zu':['.',',','yy/mm/dd'],
        // 'af':['.',',','yy/mm/dd'],
        // 'ka':[',',' ','dd.mm.yy'],
        // 'fo':[',','.','dd-mm-yy'],
        // 'hi':['.',',','dd-mm-yy'],
        // 'mt':['.',',','dd/mm/yy'],
        // 'se':[',',' ','dd.mm.yy'],
        // 'ga':['.',',','dd/mm/yy'],
        // 'ms':['.',',','dd/mm/yy'],
        // 'kk':[',',' ','dd.mm.yy'],
        // 'ky':[',',' ','dd.mm.y'],
        // 'sw':['.',',','m/d/yy'],
        // 'tk':[',',' ','dd.mm.y'],
        // 'uz':[',',' ','dd/mm yy'],
        // 'tt':[',',' ','dd.mm.yy'],
        // 'bn':['.',',','dd-mm-y'],
        // 'pa':['.',',','dd-mm-y'],
        // 'gu':['.',',','dd-mm-y'],
        // 'or':['.',',','dd-mm-y'],
        // 'ta':['.',',','dd-mm-yy'],
        // 'te':['.',',','dd-mm-y'],
        // 'kn':['.',',','dd-mm-y'],
        // 'ml':['.',',','dd-mm-y'],
        // 'as':['.',',','dd-mm-yy'],
        // 'mr':['.',',','dd-mm-yy'],
        // 'sa':['.',',','dd-mm-yy'],
        // 'mn':[',',' ','y.mm.dd'],
        // 'bo':['.',',','yy/m/d'],
        // 'cy':['.',',','dd/mm/yy'],
        // 'km':['.',',','yy-mm-dd'],
        // 'lo':['.',',','dd/mm/yy'],
        // 'gl':[',','.','dd/mm/yy'],
        // 'kok':['.',',','dd-mm-yy'],
        // 'syr':['.',',','dd/mm/yy'],
        // 'si':['.',',','yy-mm-dd'],
        // 'iu':['.',',','d/mm/yy'],
        // 'am':['.',',','d/m/yy'],
        // 'tzm':[',','.','dd-mm-yy'],
        // 'ne':['.',',','m/d/yy'],
        // 'fy':[',','.','d-m-yy'],
        // 'ps':[',','،','dd/mm/y'],
        // 'fil':['.',',','m/d/yy'],
        // 'dv':['.',',','dd/mm/y'],
        // 'ha':['.',',','d/m/yy'],
        // 'yo':['.',',','d/m/yy'],
        // 'quz':[',','.','dd/mm/yy'],
        // 'nso':['.',',','yy/mm/dd'],
        // 'ba':[',',' ','dd.mm.y'],
        // 'lb':[',',' ','dd/mm/yy'],
        // 'kl':[',','.','dd-mm-yy'],
        // 'ig':['.',',','d/m/yy'],
        // 'ii':['.',',','yy/m/d'],
        // 'arn':[',','.','dd-mm-yy'],
        // 'moh':['.',',','m/d/yy'],
        // 'br':[',',' ','dd/mm/yy'],
        // 'ug':['.',',','yy-m-d'],
        // 'mi':['.',',','dd/mm/yy'],
        // 'oc':[',',' ','dd/mm/yy'],
        // 'co':[',',' ','dd/mm/yy'],
        // 'gsw':[',',' ','dd/mm/yy'],
        // 'sah':[',',' ','mm.dd.yy'],
        // 'qut':['.',',','dd/mm/yy'],
        // 'rw':[',',' ','m/d/yy'],
        // 'wo':[',',' ','dd/mm/yy'],
        // 'prs':[',','.','dd/mm/y'],
        // 'gd':['.',',','dd/mm/yy'],
        // 'ar-sa':['.',',','dd/mm/y'],
        // 'bg-bg':[',',' ','d.m.yy \'г.\''],
        // 'ca-es':[',','.','dd/mm/yy'],
        // 'zh-tw':['.',',','yy/m/d'],
        // 'cs-cz':[',',' ','d.m.yy'],
        // 'da-dk':[',','.','dd-mm-yy'],
        // 'de-de':[',','.','dd.mm.yy'],
        // 'el-gr':[',','.','d/m/yy'],
        'en-us': [
            '.',
            ',',
            'm/d/yy'
        ],
        // 'fi-fi':[',',' ','d.m.yy'],
        // 'fr-fr':[',',' ','dd/mm/yy'],
        // 'he-il':['.',',','dd/mm/yy'],
        // 'hu-hu':[',',' ','yy.mm.dd.'],
        // 'is-is':[',','.','d.m.yy'],
        // 'it-it':[',','.','dd/mm/yy'],
        // 'ja-jp':['.',',','yy/mm/dd'],
        // 'ko-kr':['.',',','yy-mm-dd'],
        // 'nl-nl':[',','.','d-m-yy'],
        // 'nb-no':[',',' ','dd.mm.yy'],
        // 'pl-pl':[',',' ','yy-mm-dd'],
        // 'pt-br':[',','.','dd/mm/yy'],
        // 'rm-ch':['.','\'','dd/mm/yy'],
        // 'ro-ro':[',','.','dd.mm.yy'],
        // 'ru-ru':[',',' ','dd.mm.yy'],
        // 'hr-hr':[',','.','d.m.yy.'],
        // 'sk-sk':[',',' ','d. m. yy'],
        // 'sq-al':[',','.','yy-mm-dd'],
        // 'sv-se':[',',' ','yy-mm-dd'],
        // 'th-th':['.',',','d/m/yy'],
        // 'tr-tr':[',','.','dd.mm.yy'],
        // 'ur-pk':['.',',','dd/mm/yy'],
        // 'id-id':[',','.','dd/mm/yy'],
        // 'uk-ua':[',',' ','dd.mm.yy'],
        // 'be-by':[',',' ','dd.mm.yy'],
        // 'sl-si':[',','.','d.m.yy'],
        // 'et-ee':[',',' ','d.mm.yy'],
        // 'lv-lv':[',',' ','yy.mm.dd.'],
        // 'lt-lt':[',','.','yy.mm.dd'],
        // 'tg-cyrl-tj':[',',' ','dd.mm.y'],
        // 'fa-ir':['.',',','mm/dd/yy'],
        // 'vi-vn':[',','.','dd/mm/yy'],
        // 'hy-am':['.',',','dd.mm.yy'],
        // 'az-latn-az':[',',' ','dd.mm.yy'],
        // 'eu-es':[',','.','yy/mm/dd'],
        // 'hsb-de':[',','.','d. m. yy'],
        // 'mk-mk':[',','.','dd.mm.yy'],
        // 'tn-za':['.',',','yy/mm/dd'],
        // 'xh-za':['.',',','yy/mm/dd'],
        // 'zu-za':['.',',','yy/mm/dd'],
        // 'af-za':['.',',','yy/mm/dd'],
        // 'ka-ge':[',',' ','dd.mm.yy'],
        // 'fo-fo':[',','.','dd-mm-yy'],
        // 'hi-in':['.',',','dd-mm-yy'],
        // 'mt-mt':['.',',','dd/mm/yy'],
        // 'se-no':[',',' ','dd.mm.yy'],
        // 'ms-my':['.',',','dd/mm/yy'],
        // 'kk-kz':[',',' ','dd.mm.yy'],
        // 'ky-kg':[',',' ','dd.mm.y'],
        // 'sw-ke':['.',',','m/d/yy'],
        // 'tk-tm':[',',' ','dd.mm.y'],
        // 'uz-latn-uz':[',',' ','dd/mm yy'],
        // 'tt-ru':[',',' ','dd.mm.yy'],
        // 'bn-in':['.',',','dd-mm-y'],
        // 'pa-in':['.',',','dd-mm-y'],
        // 'gu-in':['.',',','dd-mm-y'],
        // 'or-in':['.',',','dd-mm-y'],
        // 'ta-in':['.',',','dd-mm-yy'],
        // 'te-in':['.',',','dd-mm-y'],
        // 'kn-in':['.',',','dd-mm-y'],
        // 'ml-in':['.',',','dd-mm-y'],
        // 'as-in':['.',',','dd-mm-yy'],
        // 'mr-in':['.',',','dd-mm-yy'],
        // 'sa-in':['.',',','dd-mm-yy'],
        // 'mn-mn':[',',' ','y.mm.dd'],
        // 'bo-cn':['.',',','yy/m/d'],
        // 'cy-gb':['.',',','dd/mm/yy'],
        // 'km-kh':['.',',','yy-mm-dd'],
        // 'lo-la':['.',',','dd/mm/yy'],
        // 'gl-es':[',','.','dd/mm/yy'],
        // 'kok-in':['.',',','dd-mm-yy'],
        // 'syr-sy':['.',',','dd/mm/yy'],
        // 'si-lk':['.',',','yy-mm-dd'],
        // 'iu-cans-ca':['.',',','d/m/yy'],
        // 'am-et':['.',',','d/m/yy'],
        // 'ne-np':['.',',','m/d/yy'],
        // 'fy-nl':[',','.','d-m-yy'],
        // 'ps-af':[',','،','dd/mm/y'],
        // 'fil-ph':['.',',','m/d/yy'],
        // 'dv-mv':['.',',','dd/mm/y'],
        // 'ha-latn-ng':['.',',','d/m/yy'],
        // 'yo-ng':['.',',','d/m/yy'],
        // 'quz-bo':[',','.','dd/mm/yy'],
        // 'nso-za':['.',',','yy/mm/dd'],
        // 'ba-ru':[',',' ','dd.mm.y'],
        // 'lb-lu':[',',' ','dd/mm/yy'],
        // 'kl-gl':[',','.','dd-mm-yy'],
        // 'ig-ng':['.',',','d/m/yy'],
        // 'ii-cn':['.',',','yy/m/d'],
        // 'arn-cl':[',','.','dd-mm-yy'],
        // 'moh-ca':['.',',','m/d/yy'],
        // 'br-fr':[',',' ','dd/mm/yy'],
        // 'ug-cn':['.',',','yy-m-d'],
        // 'mi-nz':['.',',','dd/mm/yy'],
        // 'oc-fr':[',',' ','dd/mm/yy'],
        // 'co-fr':[',',' ','dd/mm/yy'],
        // 'gsw-fr':[',',' ','dd/mm/yy'],
        // 'sah-ru':[',',' ','mm.dd.yy'],
        // 'qut-gt':['.',',','dd/mm/yy'],
        // 'rw-rw':[',',' ','m/d/yy'],
        // 'wo-sn':[',',' ','dd/mm/yy'],
        // 'prs-af':[',','.','dd/mm/y'],
        // 'gd-gb':['.',',','dd/mm/yy'],
        // 'ar-iq':['.',',','dd/mm/yy'],
        // 'zh-cn':['.',',','yy/m/d'],
        // 'de-ch':['.','\'','dd.mm.yy'],
        'en-gb': [
            '.',
            ',',
            'dd/mm/yy'
        ],
        // 'es-mx':['.',',','dd/mm/yy'],
        // 'fr-be':[',','.','d/mm/yy'],
        // 'it-ch':['.','\'','dd.mm.yy'],
        // 'nl-be':[',','.','d/mm/yy'],
        // 'nn-no':[',',' ','dd.mm.yy'],
        // 'pt-pt':[',','.','dd-mm-yy'],
        // 'sr-latn-cs':[',','.','d.m.yy'],
        // 'sv-fi':[',',' ','d.m.yy'],
        // 'az-cyrl-az':[',',' ','dd.mm.yy'],
        // 'dsb-de':[',','.','d. m. yy'],
        // 'se-se':[',',' ','yy-mm-dd'],
        // 'ga-ie':['.',',','dd/mm/yy'],
        // 'ms-bn':[',','.','dd/mm/yy'],
        // 'uz-cyrl-uz':[',',' ','dd.mm.yy'],
        // 'bn-bd':['.',',','dd-mm-y'],
        // 'mn-mong-cn':['.',',','yy/m/d'],
        // 'iu-latn-ca':['.',',','d/mm/yy'],
        // 'tzm-latn-dz':[',','.','dd-mm-yy'],
        // 'quz-ec':[',','.','dd/mm/yy'],
        // 'ar-eg':['.',',','dd/mm/yy'],
        // 'zh-hk':['.',',','d/m/yy'],
        // 'de-at':[',','.','dd.mm.yy'],
        // 'en-au':['.',',','d/mm/yy'],
        // 'es-es':[',','.','dd/mm/yy'],
        // 'fr-ca':[',',' ','yy-mm-dd'],
        // 'sr-cyrl-cs':[',','.','d.m.yy'],
        // 'se-fi':[',',' ','d.m.yy'],
        // 'quz-pe':['.',',','dd/mm/yy'],
        // 'ar-ly':['.',',','dd/mm/yy'],
        // 'zh-sg':['.',',','d/m/yy'],
        // 'de-lu':[',','.','dd.mm.yy'],
        // 'en-ca':['.',',','dd/mm/yy'],
        // 'es-gt':['.',',','dd/mm/yy'],
        // 'fr-ch':['.','\'','dd.mm.yy'],
        // 'hr-ba':[',','.','d.m.yy.'],
        // 'smj-no':[',',' ','dd.mm.yy'],
        // 'ar-dz':['.',',','dd-mm-yy'],
        // 'zh-mo':['.',',','d/m/yy'],
        // 'de-li':['.','\'','dd.mm.yy'],
        // 'en-nz':['.',',','d/mm/yy'],
        // 'es-cr':[',','.','dd/mm/yy'],
        // 'fr-lu':[',',' ','dd/mm/yy'],
        // 'bs-latn-ba':[',','.','d.m.yy'],
        // 'smj-se':[',',' ','yy-mm-dd'],
        // 'ar-ma':['.',',','dd-mm-yy'],
        // 'en-ie':['.',',','dd/mm/yy'],
        // 'es-pa':['.',',','mm/dd/yy'],
        // 'fr-mc':[',',' ','dd/mm/yy'],
        // 'sr-latn-ba':[',','.','d.m.yy'],
        // 'sma-no':[',',' ','dd.mm.yy'],
        // 'ar-tn':['.',',','dd-mm-yy'],
        // 'en-za':['.',' ','yy/mm/dd'],
        // 'es-do':['.',',','dd/mm/yy'],
        // 'sr-cyrl-ba':[',','.','d.m.yy'],
        // 'sma-se':[',',' ','yy-mm-dd'],
        // 'ar-om':['.',',','dd/mm/yy'],
        // 'en-jm':['.',',','dd/mm/yy'],
        // 'es-ve':[',','.','dd/mm/yy'],
        // 'bs-cyrl-ba':[',','.','d.m.yy'],
        // 'sms-fi':[',',' ','d.m.yy'],
        // 'ar-ye':['.',',','dd/mm/yy'],
        // 'en-029':['.',',','mm/dd/yy'],
        // 'es-co':[',','.','dd/mm/yy'],
        // 'sr-latn-rs':[',','.','d.m.yy'],
        // 'smn-fi':[',',' ','d.m.yy'],
        // 'ar-sy':['.',',','dd/mm/yy'],
        // 'en-bz':['.',',','dd/mm/yy'],
        // 'es-pe':['.',',','dd/mm/yy'],
        // 'sr-cyrl-rs':[',','.','d.m.yy'],
        // 'ar-jo':['.',',','dd/mm/yy'],
        // 'en-tt':['.',',','dd/mm/yy'],
        // 'es-ar':[',','.','dd/mm/yy'],
        // 'sr-latn-me':[',','.','d.m.yy'],
        // 'ar-lb':['.',',','dd/mm/yy'],
        // 'en-zw':['.',',','m/d/yy'],
        // 'es-ec':[',','.','dd/mm/yy'],
        // 'sr-cyrl-me':[',','.','d.m.yy'],
        // 'ar-kw':['.',',','dd/mm/yy'],
        // 'en-ph':['.',',','m/d/yy'],
        // 'es-cl':[',','.','dd-mm-yy'],
        // 'ar-ae':['.',',','dd/mm/yy'],
        // 'es-uy':[',','.','dd/mm/yy'],
        // 'ar-bh':['.',',','dd/mm/yy'],
        // 'es-py':[',','.','dd/mm/yy'],
        // 'ar-qa':['.',',','dd/mm/yy'],
        // 'en-in':['.',',','dd-mm-yy'],
        // 'es-bo':[',','.','dd/mm/yy'],
        // 'en-my':['.',',','d/m/yy'],
        // 'es-sv':['.',',','dd/mm/yy'],
        // 'en-sg':['.',',','d/m/yy'],
        // 'es-hn':['.',',','dd/mm/yy'],
        // 'es-ni':['.',',','dd/mm/yy'],
        // 'es-pr':['.',',','dd/mm/yy'],
        // 'es-us':['.',',','m/d/yy'],
        // 'bs-cyrl':[',','.','d.m.yy'],
        // 'bs-latn':[',','.','d.m.yy'],
        // 'sr-cyrl':[',','.','d.m.yy'],
        // 'sr-latn':[',','.','d.m.yy'],
        // 'smn':[',',' ','d.m.yy'],
        // 'az-cyrl':[',',' ','dd.mm.yy'],
        // 'sms':[',',' ','d.m.yy'],
        // 'zh':['.',',','yy/m/d'],
        // 'nn':[',',' ','dd.mm.yy'],
        // 'bs':[',','.','d.m.yy'],
        // 'az-latn':[',',' ','dd.mm.yy'],
        // 'sma':[',',' ','yy-mm-dd'],
        // 'uz-cyrl':[',',' ','dd.mm.yy'],
        // 'mn-cyrl':[',',' ','y.mm.dd'],
        // 'iu-cans':['.',',','d/m/yy'],
        // 'zh-hant':['.',',','d/m/yy'],
        // 'nb':[',',' ','dd.mm.yy'],
        // 'sr':[',','.','d.m.yy'],
        // 'tg-cyrl':[',',' ','dd.mm.y'],
        // 'dsb':[',','.','d. m. yy'],
        // 'smj':[',',' ','yy-mm-dd'],
        // 'uz-latn':[',',' ','dd/mm yy'],
        // 'mn-mong':['.',',','yy/m/d'],
        // 'iu-latn':['.',',','d/mm/yy'],
        // 'tzm-latn':[',','.','dd-mm-yy'],
        // 'ha-latn':['.',',','d/m/yy'],
        // 'zh-chs':['.',',','yy/m/d'],
        // 'zh-cht':['.',',','d/m/yy'],
        '': [
            '.',
            ',',
            'yy-mm-dd'
        ]
    }
};
$3f4c5ccf8da2a18c$var$_w._culture = $3f4c5ccf8da2a18c$var$culture;
var /**
 * culture info for date and number formatting and parsing
 */ $3f4c5ccf8da2a18c$export$2e2bcd8739ae039 = $3f4c5ccf8da2a18c$var$culture;


/*
 * export public types
 */ var $83d498fca38a60e6$var$__assign = undefined && undefined.__assign || function() {
    $83d498fca38a60e6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $83d498fca38a60e6$var$__assign.apply(this, arguments);
};
function $83d498fca38a60e6$export$2d6e9b4c68afb6c8() {
    if ($83d498fca38a60e6$export$8beec2e5b8623754.lastCreatedRenderer != null) $83d498fca38a60e6$export$8beec2e5b8623754.lastCreatedRenderer.refresh();
}
function $83d498fca38a60e6$var$isFnc(f) {
    return typeof f === "function";
}
function $83d498fca38a60e6$var$isComponent(node) {
    return node != null && $83d498fca38a60e6$var$isFnc(node.render);
}
function $83d498fca38a60e6$var$areEqual(a, b) {
    if (b.isEqual != null) return b.isEqual(a);
    return a === b;
// return (a as any).__proto__ !== (b as any).__proto__;
}
function $83d498fca38a60e6$var$swapDomElements(obj1, obj2) {
    // save the location of obj2
    var parent2 = obj2.parentElement;
    var next2 = obj2.nextElementSibling;
    // special case for obj1 is the next sibling of obj2
    if (next2 === obj1) // just put obj1 before obj2
    parent2.insertBefore(obj1, obj2);
    else {
        // insert obj2 right before obj1
        obj1.parentNode.insertBefore(obj2, obj1);
        // now insert obj1 where obj2 was
        if (next2) // if there was an element after obj2, then insert obj1 right before that
        parent2.insertBefore(obj1, next2);
        else // otherwise, just append as last child
        parent2.appendChild(obj1);
    }
}
function $83d498fca38a60e6$var$findComponentIdx(children, component) {
    for(var i = 0; i < children.length; i++){
        if (children[i].dom._component === component) return i;
    }
    return -1;
}
function $83d498fca38a60e6$var$findNodeIdx(children, node) {
    for(var i = 0; i < children.length; i++)if (children[i].dom._component == null) {
        if (node.attr != null && children[i].dom.id === node.attr.id) return i;
    }
    return -1;
}
function $83d498fca38a60e6$var$switchChildren(newIdx, oldIdx, node) {
    while(node.children.length <= newIdx){
        // newIdx is outside of bounds of node.children
        var dummyDom = document.createElement("span");
        node.dom.appendChild(dummyDom);
        node.dom.insertBefore(dummyDom, node.dom.children[oldIdx]);
        node.children.splice(oldIdx, 0, {
            tag: "span",
            dom: dummyDom,
            children: []
        });
        oldIdx++;
    }
    if (oldIdx === newIdx) return;
    $83d498fca38a60e6$var$swapDomElements(node.dom.children[newIdx], node.dom.children[oldIdx]);
    // switch in node.children as well (not just in DOM)
    var tmp = node.children[oldIdx];
    node.children[oldIdx] = node.children[newIdx];
    node.children[newIdx] = tmp;
}
function $83d498fca38a60e6$var$areAttributesEqual(attr, v, a) {
    if (a === v) return true;
    if (attr === "style" && typeof v === "object" && typeof a === "string") {
        var s = "";
        for(var style in v)if (v.hasOwnProperty(style) && v[style] != null) s += v[s] + ";";
        return s === a;
    }
    return false;
}
var $83d498fca38a60e6$export$8beec2e5b8623754 = /** @class */ function() {
    function JSLRender(container, globalRefresh) {
        this.container = container;
        this.repaintScheduled = false;
        if (globalRefresh) JSLRender.lastCreatedRenderer = this;
    }
    JSLRender.animate = function(vnode, animation) {
        if (Array.isArray(animation)) for(var i = 0; i < animation.length; i++)JSLRender.animateSingle(vnode, animation[i]);
        else JSLRender.animateSingle(vnode, animation);
    };
    JSLRender.toHTMLString = function(vnode) {
        var dom = document.createElement("div");
        new JSLRender(dom, false).render(vnode);
        return dom.innerHTML;
    };
    JSLRender.animateSingle = function(vnode, animation) {
        var status = {
            current: animation.from,
            timeout: 20,
            start: 0,
            now: 0
        };
        if (vnode.attr.style == null) vnode.attr.style = {};
        var fnc = function() {
            var _a;
            status.now = performance.now();
            if (!status.start) status.start = status.now;
            $83d498fca38a60e6$var$addStep(animation, status);
            var done = status.now - status.start >= (_a = animation.duration, _a !== null && _a !== void 0 ? _a : JSLRender.DefaultAnimationDuration);
            if (done) status.current = animation.to;
            if (typeof vnode.attr.style === "string") {
                var parts = vnode.attr.style.split(";");
                vnode.attr.style = "";
                var found = false;
                for(var i = 0; i < parts; i++){
                    var entry = parts[i].split(":");
                    if (entry.length === 2) {
                        var key = entry[0];
                        var value = entry[1];
                        if (key.trim() === animation.attr) {
                            found = true;
                            value = status.current;
                        }
                        vnode.attr.style += key + ":" + value + ";";
                    } else vnode.attr.style += parts[i] + ";";
                }
                if (!found) vnode.attr.style += animation.attr + ":" + status.current;
            } else vnode.attr.style[animation.attr] = status.current;
            vnode.dom.style[animation.attr] = status.current;
            if (!done) requestAnimationFrame(fnc);
        };
        if (animation.delay) setTimeout(fnc, animation.delay);
        else fnc();
    };
    JSLRender.prototype.render = function(node) {
        if (JSLRender.PrintRenderTime) // tslint:disable-next-line: no-console
        console.time("JSL render");
        this.rootNode = node || this.rootNode;
        if (this.rootNode != null) this.renderVNode(this.container, this.rootNode);
        if (JSLRender.PrintRenderTime) // tslint:disable-next-line: no-console
        console.timeEnd("JSL render");
    };
    JSLRender.prototype.refresh = function() {
        var _this = this;
        if (this.repaintScheduled) return;
        this.repaintScheduled = true;
        window.requestAnimationFrame(function() {
            if (!_this.repaintScheduled) return;
            _this.repaintScheduled = false;
            _this.render();
        });
    };
    JSLRender.prototype.renderVNode = function(container, node) {
        if (this.renderedVNode == null) this.renderedVNode = this.createNode(container, node);
        else this.renderedVNode = this.updateNode(this.renderedVNode, node);
    };
    JSLRender.prototype.createNode = function(container, node, replaceWith) {
        // console.log("createNode");
        var vnode;
        var isComp = $83d498fca38a60e6$var$isComponent(node);
        if (isComp) {
            // we have a component
            if (node.onInit) node.onInit.call(node, this);
            vnode = this.cloneVNode(node.render());
        } else // we have a vNode
        vnode = this.cloneVNode(node);
        this.sanitize(vnode);
        var dom = vnode.dom = document.createElement(vnode.tag);
        for(var attr in vnode.attr)if (vnode.attr.hasOwnProperty(attr)) this.setAttribute(vnode, node, attr);
        if (vnode.children.length > 0) {
            for(var idx = 0; idx < vnode.children.length; idx++)if (vnode.children[idx] != null) vnode.children[idx] = this.createNode(dom, vnode.children[idx]);
        } else if (vnode.raw) dom.innerHTML = vnode.content || "";
        else dom.textContent = vnode.content || "";
        if (isComp) dom._component = node;
        if (replaceWith != null) {
            container.insertBefore(dom, replaceWith.nextSibling);
            container.removeChild(replaceWith);
        } else container.appendChild(dom);
        if (isComp && node.onCreate) node.onCreate.call(node, vnode);
        if (vnode.animation != null) JSLRender.animate(vnode, vnode.animation);
        return vnode;
    };
    JSLRender.prototype.cloneVNode = function(vnode) {
        return {
            tag: vnode.tag,
            attr: $83d498fca38a60e6$var$__assign({}, vnode.attr),
            children: (vnode.children || []).slice(),
            dom: vnode.dom,
            raw: vnode.raw,
            content: vnode.content,
            animation: vnode.animation
        };
    };
    JSLRender.prototype.sanitize = function(vnode) {
        if (!$83d498fca38a60e6$var$isComponent(vnode)) {
            vnode.children = (vnode.children || []).filter(function(c) {
                return c != null;
            });
            vnode.attr = vnode.attr || [];
        }
    };
    JSLRender.prototype.updateNode = function(renderedNode, node) {
        if (renderedNode.dom == null || renderedNode.dom.parentElement == null) // does not exist anymore
        // -> was probably modified outside of jsl-render code
        // -> needs to be removed now, so return undefined
        return;
        var vnode;
        var isComp = $83d498fca38a60e6$var$isComponent(node);
        var oldComponent = renderedNode.dom._component;
        var isOldNodeAComponent = oldComponent != null;
        if (isOldNodeAComponent || isComp) {
            var recreateNode = false;
            if (!isComp || !isOldNodeAComponent) recreateNode = true;
            else {
                // we had a component in last render cycle and we still have a component
                // ... but is it the same component or do we need to recreate it
                if (!$83d498fca38a60e6$var$areEqual(node, oldComponent)) recreateNode = true;
                if (node.__proto__ === oldComponent.__proto__) node.State = oldComponent.State;
            }
            if (recreateNode) {
                this.callRemoveEvents(renderedNode, true);
                var parent_1 = renderedNode.dom.parentElement;
                return this.createNode(parent_1, node, renderedNode.dom);
            }
        }
        if (isComp) vnode = this.cloneVNode(node.render());
        else // we have a vNode
        vnode = this.cloneVNode(node);
        this.sanitize(vnode);
        vnode.dom = renderedNode.dom;
        // if (isComp) {
        vnode.dom._component = isComp ? node : undefined;
        // }
        if (renderedNode.tag !== vnode.tag || renderedNode.raw !== vnode.raw) {
            // tag changed -> delete and recreate
            this.callRemoveEvents(renderedNode, true);
            var parent_2 = renderedNode.dom.parentElement;
            return this.createNode(parent_2, node, renderedNode.dom);
        }
        var attributesChanged = this.updateAttributes(renderedNode, vnode, node);
        var contentChanged = this.updateContent(renderedNode, vnode);
        if ((contentChanged || attributesChanged) && isComp && node.onUpdate) node.onUpdate.call(node, vnode);
        if (renderedNode.animation == null && vnode.animation != null) JSLRender.animate(vnode, vnode.animation);
        return vnode;
    };
    // private refreshHandlers(renderedNode: IJSLVNode, vnode: IJSLVNode, node: IJSLVNode | IJSLComponent) {
    //     for (const attr in vnode.attr) {
    //         if (isFnc(vnode.attr[attr]) &&
    //             renderedNode.attr[attr] !== vnode.attr[attr]) {
    //             if (renderedNode.dom["_" + attr + "_"] != null) {
    //                 renderedNode.dom.removeEventListener(attr, renderedNode.dom["_" + attr + "_"]);
    //             }
    //             this.setAttribute(vnode, node, attr);
    //         }
    //     }
    // }
    JSLRender.prototype.updateContent = function(renderedNode, vnode) {
        this.tryToReorderChildren(renderedNode, vnode);
        if (renderedNode.children.length !== vnode.children.length || renderedNode.content !== vnode.content) {
            if (renderedNode.children.length > 0) this.callRemoveEvents(renderedNode);
            if (vnode.children.length > 0) {
                vnode.dom.innerHTML = "";
                for(var idx = 0; idx < vnode.children.length; idx++)vnode.children[idx] = this.createNode(vnode.dom, vnode.children[idx]);
            } else if (vnode.raw) vnode.dom.innerHTML = vnode.content || "";
            else vnode.dom.textContent = vnode.content || "";
            return true;
        } else {
            var newChildren = [];
            for(var idx = 0; idx < renderedNode.children.length; idx++){
                var tmp = this.updateNode(renderedNode.children[idx], vnode.children[idx]);
                if (tmp != null) newChildren.push(tmp);
            }
            vnode.children = newChildren;
            return false;
        }
    };
    JSLRender.prototype.tryToReorderChildren = function(renderedNode, vnode) {
        var _a, _b;
        if (renderedNode.children.length > 1 && vnode.children.length > 1 && vnode.children.length <= JSLRender.MaxReorderChildren) {
            var idx = void 0;
            var l = void 0;
            var anyMatchesFound = false;
            for(idx = 0, l = vnode.children.length; idx < l; idx++){
                var c = vnode.children[idx];
                if ($83d498fca38a60e6$var$isComponent(c)) {
                    var oldCompIdx = idx;
                    if (((_b = (_a = renderedNode.children[oldCompIdx]) === null || _a === void 0 ? void 0 : _a.dom) === null || _b === void 0 ? void 0 : _b._component) !== c) oldCompIdx = $83d498fca38a60e6$var$findComponentIdx(renderedNode.children, c);
                    if (oldCompIdx >= 0) {
                        if (oldCompIdx !== idx) $83d498fca38a60e6$var$switchChildren(idx, oldCompIdx, renderedNode);
                        anyMatchesFound = true;
                    }
                } else if (c != null && c.attr != null && c.attr.id != null) {
                    var oldNodeIdx = idx;
                    if (renderedNode.attr != null && renderedNode.attr.id !== c.attr.id) oldNodeIdx = $83d498fca38a60e6$var$findNodeIdx(renderedNode.children, c);
                    if (oldNodeIdx >= 0) {
                        if (oldNodeIdx !== idx) $83d498fca38a60e6$var$switchChildren(idx, oldNodeIdx, renderedNode);
                        anyMatchesFound = true;
                    }
                }
            }
            if (anyMatchesFound) {
                if (l < renderedNode.children.length) {
                    // dispose everything that is "left" and shorten renderedNode.children array to size l
                    for(var i = l; i < renderedNode.children.length; i++){
                        this.callRemoveEvents(renderedNode.children[i], true);
                        var dom = renderedNode.children[i].dom;
                        if (dom != null && dom.parentElement != null) dom.parentElement.removeChild(dom);
                    }
                    renderedNode.children.length = l;
                } else if (l > renderedNode.children.length) // add dummy nodes to make renderedNode same size
                for(var i = renderedNode.children.length; i < l; i++){
                    var dummyDom = document.createElement("span");
                    renderedNode.children.push({
                        tag: "span",
                        dom: dummyDom,
                        children: []
                    });
                    renderedNode.dom.appendChild(dummyDom);
                }
            }
        }
    };
    JSLRender.prototype.callRemoveEvents = function(vnode, includeOwnTag) {
        for(var idx = 0; idx < vnode.children.length; idx++){
            var cnode = vnode.children[idx];
            if (cnode && cnode.dom) {
                execute(cnode);
                this.callRemoveEvents(cnode);
            }
        }
        if (includeOwnTag && vnode.dom) execute(vnode);
        function execute(node) {
            var component = node.dom._component;
            if (component && component.onRemove) component.onRemove.call(component, {
                container: node.dom.parentElement,
                dom: node.dom,
                node: node
            });
        }
    };
    JSLRender.prototype.updateAttributes = function(rendered, vnode, node) {
        var result = false;
        for(var attribute in vnode.attr)if (vnode.attr.hasOwnProperty(attribute) && !$83d498fca38a60e6$var$areAttributesEqual(attribute, vnode.attr[attribute], rendered.attr[attribute])) {
            if ($83d498fca38a60e6$var$isFnc(rendered.attr[attribute])) {
                if (rendered.dom["_" + attribute + "_"] != null) rendered.dom.removeEventListener(attribute, rendered.dom["_" + attribute + "_"]);
            } else result = true;
            this.setAttribute(vnode, node, attribute);
        }
        // check for attributes present in rendered but not in vnode (new node)
        for(var attribute in rendered.attr)if (rendered.attr.hasOwnProperty(attribute) && !vnode.attr.hasOwnProperty(attribute)) {
            if ($83d498fca38a60e6$var$isFnc(rendered.attr[attribute])) {
                if (rendered.dom["_" + attribute + "_"] != null) rendered.dom.removeEventListener(attribute, rendered.dom["_" + attribute + "_"]);
            } else {
                rendered.dom.removeAttribute(attribute);
                result = true;
            }
        }
        return result;
    };
    JSLRender.prototype.setAttribute = function(vnode, node, attr) {
        var _this = this;
        if ($83d498fca38a60e6$var$isFnc(vnode.attr[attr])) {
            var eventHandler_1 = function(args) {
                var closestComponent = args.currentTarget;
                var component;
                // tslint:disable-next-line: no-conditional-assignment
                while(!(component = closestComponent._component)){
                    closestComponent = closestComponent.parentElement;
                    if (closestComponent == null) break;
                }
                var fnc = vnode.attr[attr];
                if (fnc != null) {
                    if (fnc.call(component || node, args, vnode) !== false) _this.refresh();
                } else vnode.dom.removeEventListener(attr, eventHandler_1);
            };
            vnode.dom.addEventListener(attr, eventHandler_1);
            vnode.dom["_" + attr + "_"] = eventHandler_1;
        } else {
            var value = vnode.attr[attr];
            if (attr === "style" && typeof value === "object") {
                var s = "";
                for(var style in value)if (value.hasOwnProperty(style) && value[style] != null) s += style + ":" + value[style] + ";";
                value = s;
            }
            if (value != null) vnode.dom.setAttribute(attr, value);
            else vnode.dom.removeAttribute(attr);
        }
    };
    JSLRender.MaxReorderChildren = 500;
    JSLRender.DefaultAnimationDuration = 500;
    JSLRender.lastCreatedRenderer = null;
    JSLRender.PrintRenderTime = true;
    return JSLRender;
}();
function $83d498fca38a60e6$var$addStep(animation, status) {
    var _a, _b;
    var easingFnc = $83d498fca38a60e6$var$easingFunctions[_a = animation.easing, _a !== null && _a !== void 0 ? _a : "linear"];
    if (easingFnc == null) throw new Error("easing function " + animation.easing + " does not exist");
    var duration = (_b = animation.duration, _b !== null && _b !== void 0 ? _b : $83d498fca38a60e6$export$8beec2e5b8623754.DefaultAnimationDuration);
    if (typeof status.current === "number") status.current = easingFnc(status.now - status.start, animation.from, animation.to - animation.from, duration);
    var value = parseFloat(status.current);
    if (status.current.toString().indexOf(value.toString()) === 0) {
        value = easingFnc(status.now - status.start, parseFloat(animation.from), parseFloat(animation.to) - parseFloat(animation.from), duration);
        status.current = value + status.current.toString().replace(/[0-9.-]/g, "");
    }
    if (status.current && status.current[0] === "#") {
        // color
        var rval = parseInt(animation.from.substr(1, 2), 16);
        var gval = parseInt(animation.from.substr(3, 2), 16);
        var bval = parseInt(animation.from.substr(5, 2), 16);
        var rval2 = parseInt(animation.to.substr(1, 2), 16);
        var gval2 = parseInt(animation.to.substr(3, 2), 16);
        var bval2 = parseInt(animation.to.substr(5, 2), 16);
        var rval3 = easingFnc(status.now - status.start, rval, rval2 - rval, duration);
        var gval3 = easingFnc(status.now - status.start, gval, gval2 - gval, duration);
        var bval3 = easingFnc(status.now - status.start, bval, bval2 - bval, duration);
        status.current = "#" + $83d498fca38a60e6$var$padLeft(Math.round(rval3).toString(16), "0", 2) + $83d498fca38a60e6$var$padLeft(Math.round(gval3).toString(16), "0", 2) + $83d498fca38a60e6$var$padLeft(Math.round(bval3).toString(16), "0", 2);
    }
// TODO: not supported -> for example color in other format than '#xxxxxx' or anything that does not start with a number
}
function $83d498fca38a60e6$var$padLeft(str, padStr, minLength) {
    var result = str;
    while(result.length < minLength)result = padStr + result;
    return result;
}
// t: current time, b: begInnIng value, c: change In value, d: duration
/* BSD Licensed - taken from https://github.com/danro/jquery-easing/blob/master/jquery.easing.js */ var $83d498fca38a60e6$var$easingFunctions = {
    linear: function(t, b, c, d) {
        return c / d * t + b; // correct?
    },
    easeInQuad: function(t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    easeOutQuad: function(t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    easeInOutQuad: function(t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    easeInCubic: function(t, b, c, d) {
        return c * (t /= d) * t * t + b;
    },
    easeOutCubic: function(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    },
    easeInOutCubic: function(t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t + 2) + b;
    },
    easeInQuart: function(t, b, c, d) {
        return c * (t /= d) * t * t * t + b;
    },
    easeOutQuart: function(t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    },
    easeInOutQuart: function(t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    },
    // easeInQuint(t, b, c, d) {
    //     return c * (t /= d) * t * t * t * t + b;
    // },
    // easeOutQuint(t, b, c, d) {
    //     return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    // },
    // easeInOutQuint(t, b, c, d) {
    //     if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
    //     return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    // },
    easeInSine: function(t, b, c, d) {
        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    },
    easeOutSine: function(t, b, c, d) {
        return c * Math.sin(t / d * (Math.PI / 2)) + b;
    },
    easeInOutSine: function(t, b, c, d) {
        return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    },
    easeInExpo: function(t, b, c, d) {
        return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    },
    easeOutExpo: function(t, b, c, d) {
        return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    },
    easeInOutExpo: function(t, b, c, d) {
        if (t == 0) return b;
        if (t == d) return b + c;
        if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    },
    // easeInCirc(t, b, c, d) {
    //     return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    // },
    // easeOutCirc(t, b, c, d) {
    //     return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    // },
    // easeInOutCirc(t, b, c, d) {
    //     if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    //     return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    // },
    easeInElastic: function(t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d) == 1) return b + c;
        if (!p) p = d * .3;
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    easeOutElastic: function(t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d) == 1) return b + c;
        if (!p) p = d * .3;
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    easeInOutElastic: function(t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d / 2) == 2) return b + c;
        if (!p) p = d * (.3 * 1.5);
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
    },
    // easeInBack: function (t, b, c, d, s) {
    //     if (s == undefined) s = 1.70158;
    //     return c * (t /= d) * t * ((s + 1) * t - s) + b;
    // },
    // easeOutBack: function (t, b, c, d, s) {
    //     if (s == undefined) s = 1.70158;
    //     return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    // },
    // easeInOutBack: function (t, b, c, d, s) {
    //     if (s == undefined) s = 1.70158;
    //     if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
    //     return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
    // },
    easeInBounce: function(t, b, c, d) {
        return c - $83d498fca38a60e6$var$easingFunctions.easeOutBounce(d - t, 0, c, d) + b;
    },
    easeOutBounce: function(t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
    },
    easeInOutBounce: function(t, b, c, d) {
        if (t < d / 2) return $83d498fca38a60e6$var$easingFunctions.easeInBounce(t * 2, 0, c, d) * .5 + b;
        return $83d498fca38a60e6$var$easingFunctions.easeOutBounce(t * 2 - d, 0, c, d) * .5 + c * .5 + b;
    }
};


function $94d9b987c06daf61$export$dda1d9f60106f0e9(componentOrTag, attr) {
    var children = [];
    for(var _i = 2; _i < arguments.length; _i++)children[_i - 2] = arguments[_i];
    if (componentOrTag.render != null) return componentOrTag;
    var result = {
        tag: componentOrTag,
        attr: attr
    };
    if (children.length > 0) {
        if (children.length === 1 && typeof children[0] === "string") result.content = children[0];
        else {
            result.children = [];
            for(var _a = 0, children_1 = children; _a < children_1.length; _a++){
                var child = children_1[_a];
                if (Array.isArray(child)) child.map(function(c) {
                    return result.children.push(c);
                });
                else if (child != null && child.tag === undefined && child.render === undefined) // TODO: this is not what React does -> needs to change in future version
                result.children.push({
                    tag: "span",
                    content: child.toString()
                });
                else result.children.push(child);
            }
        }
    }
    if (result.attr && result.attr.animation) result.animation = result.attr.animation;
    return result;
}
var $94d9b987c06daf61$export$7679def1e07eb2d1 = {
    createElement: $94d9b987c06daf61$export$dda1d9f60106f0e9
};
window.React = $94d9b987c06daf61$export$7679def1e07eb2d1;




/*
 * export public types
 */ var $0c412a07a28a0d02$var$routesStore = {};
var $0c412a07a28a0d02$var$notFoundHandler;
var $0c412a07a28a0d02$var$watchers = [];
var $0c412a07a28a0d02$var$lazyLoadedUrls = {};
function $0c412a07a28a0d02$var$updateRoute(hash) {
    var route = (hash || location.hash || "#").substr(1).split("/");
    var routeLower = (hash || location.hash || "#").substr(1).toLowerCase().split("/");
    for(var i = 0; i < $0c412a07a28a0d02$var$watchers.length; i++){
        if ($0c412a07a28a0d02$var$watchers[i](hash) === false) return;
    }
    var paramCounter = 0;
    var matchedRoute;
    while(!$0c412a07a28a0d02$var$routesStore[matchedRoute = routeLower.slice(0, routeLower.length - paramCounter).join("/")]){
        paramCounter++;
        if (paramCounter >= routeLower.length) {
            // not found
            if ($0c412a07a28a0d02$var$notFoundHandler) $0c412a07a28a0d02$var$notFoundHandler(route[0], route.slice(1));
            return;
        }
    }
    if ($0c412a07a28a0d02$var$routesStore[matchedRoute]) $0c412a07a28a0d02$var$routesStore[matchedRoute](route.slice(route.length - paramCounter));
}
function $0c412a07a28a0d02$var$lazyLoadLib(url, type, finished) {
    var tag = document.createElement(type);
    tag.onload = function() {
        finished();
    };
    if (type === "link") {
        tag.href = url;
        tag.rel = "stylesheet";
    } else tag.src = url;
    document.head.appendChild(tag);
}
function $0c412a07a28a0d02$var$endsWith(str, search) {
    return str.substring(str.length - search.length, str.length) === search;
}
var $0c412a07a28a0d02$export$f6ff04b41b36f7bc = {
    setup: function(routes, notFound) {
        $0c412a07a28a0d02$var$notFoundHandler = notFound;
        $0c412a07a28a0d02$var$routesStore = {};
        for(var r in routes)if (routes.hasOwnProperty(r)) $0c412a07a28a0d02$var$routesStore[r.toLowerCase()] = routes[r];
        window.addEventListener("hashchange", function() {
            return $0c412a07a28a0d02$var$updateRoute();
        });
        $0c412a07a28a0d02$var$updateRoute();
    },
    navigate: function(route, noHashUpdate) {
        if (!route || route[0] !== "#") route = "#" + (route || "");
        if (noHashUpdate) $0c412a07a28a0d02$var$updateRoute(route);
        else window.location.hash = route;
    },
    onNavigate: function(fnc) {
        $0c412a07a28a0d02$var$watchers.push(fnc);
    },
    lazyLoad: function(url, type) {
        if ($0c412a07a28a0d02$var$lazyLoadedUrls.hasOwnProperty(url)) return $0c412a07a28a0d02$var$lazyLoadedUrls[url];
        var t = type || ($0c412a07a28a0d02$var$endsWith(url, ".css") ? "link" : "script");
        if (!window.Promise) // promise not supported by browser
        throw new Error("Promise is not supported by your browser. This feature is required for JSLRoute.lazyLoad");
        else return $0c412a07a28a0d02$var$lazyLoadedUrls[url] = new Promise(function(resolve, reject) {
            $0c412a07a28a0d02$var$lazyLoadLib(url, t, resolve);
        });
    }
};








/*
 * contains function to parse and format numeric values
 */ //*** all following parts are extracted out of jquery-ui library (GPL/MIT license) ***/
var $f697fe55e25cf9d4$var$_helper = {
    _defaults: {
        shortYearCutoff: "+10",
        dayNames: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        dayNamesShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]
    },
    _ticksTo1970: (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)) * 864000000000,
    _daylightSavingAdjust: function(date) {
        if (!date) return null;
        date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
        return date;
    },
    _getDaysInMonth: function(year, month) {
        return 32 - $f697fe55e25cf9d4$var$_helper._daylightSavingAdjust(new Date(year, month, 32)).getDate();
    }
};
var $f697fe55e25cf9d4$export$324d90190a8b822a = /** @class */ function() {
    function date() {}
    /* Parse a string value into a date object.
See formatDate below for the possible formats.

@param  format    string - the expected format of the date
@param  value     string - the date in the above format
@param  settings  Object - attributes include:
shortYearCutoff  number - the cutoff year for determining the century (optional)
dayNamesShort    string[7] - abbreviated names of the days from Sunday (optional)
dayNames         string[7] - names of the days from Sunday (optional)
monthNamesShort  string[12] - abbreviated names of the months (optional)
monthNames       string[12] - names of the months (optional)
@return  Date - the extracted date value or null if value is blank */ date.parse = function(value, format, settings) {
        if (value === null) return null;
        if (value === undefined) return undefined;
        if (value == "") return null;
        format = format || (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.dateFormat;
        //value = (typeof value == 'object' ? value.toString() : value + '');
        var shortYearCutoff = (settings ? settings.shortYearCutoff : null) || $f697fe55e25cf9d4$var$_helper._defaults.shortYearCutoff;
        shortYearCutoff = typeof shortYearCutoff != "string" ? shortYearCutoff : new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10);
        var dayNamesShort = (settings ? settings.dayNamesShort : null) || $f697fe55e25cf9d4$var$_helper._defaults.dayNamesShort;
        var dayNames = (settings ? settings.dayNames : null) || $f697fe55e25cf9d4$var$_helper._defaults.dayNames;
        var monthNamesShort = (settings ? settings.monthNamesShort : null) || $f697fe55e25cf9d4$var$_helper._defaults.monthNamesShort;
        var monthNames = (settings ? settings.monthNames : null) || $f697fe55e25cf9d4$var$_helper._defaults.monthNames;
        var year = -1;
        var month = -1;
        var day = -1;
        var doy = -1;
        var literal = false;
        // Check whether a format character is doubled
        var lookAhead = function(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) == match;
            if (matches) iFormat++;
            return matches;
        };
        // Extract a number from the string value
        var getNumber = function(match) {
            var isDoubled = lookAhead(match);
            var size = match == "@" ? 14 : match == "!" ? 20 : match == "y" && isDoubled ? 4 : match == "o" ? 3 : 2;
            var digits = new RegExp("^\\d{1," + size + "}");
            var num = value.substring(iValue).match(digits);
            if (!num) throw "Missing number at position " + iValue;
            iValue += num[0].length;
            return parseInt(num[0], 10);
        };
        // Extract a name from the string value and convert to an index
        var getName = function(match, shortNames, longNames) {
            var names = lookAhead(match) ? longNames : shortNames;
            for(var i = 0; i < names.length; i++)if (value.substr(iValue, names[i].length).toLowerCase() == names[i].toLowerCase()) {
                iValue += names[i].length;
                return i + 1;
            }
            throw new Error("Unknown name at position " + iValue);
        };
        // Confirm that a literal character matches the string value
        var checkLiteral = function() {
            if (value.charAt(iValue) != format.charAt(iFormat)) throw "Unexpected literal at position " + iValue;
            iValue++;
        };
        var iValue = 0;
        for(var iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
            if (format.charAt(iFormat) == "'" && !lookAhead("'")) literal = false;
            else checkLiteral();
        } else switch(format.charAt(iFormat)){
            case "d":
                day = getNumber("d");
                break;
            case "D":
                getName("D", dayNamesShort, dayNames);
                break;
            case "o":
                doy = getNumber("o");
                break;
            case "m":
                month = getNumber("m");
                break;
            case "M":
                month = getName("M", monthNamesShort, monthNames);
                break;
            case "y":
                year = getNumber("y");
                break;
            case "@":
                var date = new Date(getNumber("@"));
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "!":
                var date = new Date((getNumber("!") - $f697fe55e25cf9d4$var$_helper._ticksTo1970) / 10000);
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "'":
                if (lookAhead("'")) checkLiteral();
                else literal = true;
                break;
            default:
                checkLiteral();
        }
        if (year == -1) year = new Date().getFullYear();
        else if (year < 100) year += new Date().getFullYear() - new Date().getFullYear() % 100 + (year <= shortYearCutoff ? 0 : -100);
        if (doy > -1) {
            month = 1;
            day = doy;
            do {
                var dim = $f697fe55e25cf9d4$var$_helper._getDaysInMonth(year, month - 1);
                if (day <= dim) break;
                month++;
                day -= dim;
            }while (true);
        }
        var result = $f697fe55e25cf9d4$var$_helper._daylightSavingAdjust(new Date(year, month - 1, day));
        if (result.getFullYear() != year || result.getMonth() + 1 != month || result.getDate() != day) throw new Error("Invalid date");
         // E.g. 31/02/*
        return result;
    };
    /* Format a date object into a string value.
The format can be combinations of the following:
d  - day of month (no leading zero)
dd - day of month (two digit)
o  - day of year (no leading zeros)
oo - day of year (three digit)
D  - day name short
DD - day name long
m  - month of year (no leading zero)
mm - month of year (two digit)
M  - month name short
MM - month name long
y  - year (two digit)
yy - year (four digit)
@ - Unix timestamp (ms since 01/01/1970)
! - Windows ticks (100ns since 01/01/0001)
'...' - literal text
'' - single quote

@param  format    string - the desired format of the date
@param  date      Date - the date value to format
@param  settings  Object - attributes include:
dayNamesShort    string[7] - abbreviated names of the days from Sunday (optional)
dayNames         string[7] - names of the days from Sunday (optional)
monthNamesShort  string[12] - abbreviated names of the months (optional)
monthNames       string[12] - names of the months (optional)
@return  string - the date in the above format */ date.format = function(date, format, settings) {
        if (!date || isNaN(date)) return "";
        format = format || (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.dateFormat;
        var dayNamesShort = (settings ? settings.dayNamesShort : null) || $f697fe55e25cf9d4$var$_helper._defaults.dayNamesShort;
        var dayNames = (settings ? settings.dayNames : null) || $f697fe55e25cf9d4$var$_helper._defaults.dayNames;
        var monthNamesShort = (settings ? settings.monthNamesShort : null) || $f697fe55e25cf9d4$var$_helper._defaults.monthNamesShort;
        var monthNames = (settings ? settings.monthNames : null) || $f697fe55e25cf9d4$var$_helper._defaults.monthNames;
        // Check whether a format character is doubled
        var lookAhead = function(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) == match;
            if (matches) iFormat++;
            return matches;
        };
        // Format a number, with leading zero if necessary
        var formatNumber = function(match, value, len) {
            var num = "" + value;
            if (lookAhead(match)) while(num.length < len)num = "0" + num;
            return num;
        };
        // Format a name, short or long as requested
        var formatName = function(match, value, shortNames, longNames) {
            return lookAhead(match) ? longNames[value] : shortNames[value];
        };
        var output = "";
        var literal = false;
        if (date) {
            for(var iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) == "'" && !lookAhead("'")) literal = false;
                else output += format.charAt(iFormat);
            } else switch(format.charAt(iFormat)){
                case "d":
                    output += formatNumber("d", date.getDate(), 2);
                    break;
                case "D":
                    output += formatName("D", date.getDay(), dayNamesShort, dayNames);
                    break;
                case "o":
                    output += formatNumber("o", (date.getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000, 3);
                    break;
                case "m":
                    output += formatNumber("m", date.getMonth() + 1, 2);
                    break;
                case "M":
                    output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
                    break;
                case "y":
                    output += lookAhead("y") ? date.getFullYear() : (date.getFullYear() % 100 < 10 ? "0" : "") + date.getFullYear() % 100;
                    break;
                case "@":
                    output += date.getTime();
                    break;
                case "!":
                    output += date.getTime() * 10000 + $f697fe55e25cf9d4$var$_helper._ticksTo1970;
                    break;
                case "'":
                    if (lookAhead("'")) output += "'";
                    else literal = true;
                    break;
                default:
                    output += format.charAt(iFormat);
            }
        }
        return output;
    };
    date.formatTime = function(value, inputMode) {
        if (inputMode === "HourMinute") return value ? $f697fe55e25cf9d4$var$pad(value.getHours()) + ":" + $f697fe55e25cf9d4$var$pad(value.getMinutes()) : "";
        else if (inputMode === "HourMinuteSecond") return value ? $f697fe55e25cf9d4$var$pad(value.getHours()) + ":" + $f697fe55e25cf9d4$var$pad(value.getMinutes()) + ":" + $f697fe55e25cf9d4$var$pad(value.getSeconds()) : "";
        return "";
    };
    date.now = function() {
        return new Date();
    };
    date.addSeconds = function(d, seconds) {
        var future = new Date(d);
        future.setSeconds(d.getSeconds() + seconds);
        return future;
    };
    date.addMinutes = function(d, minutes) {
        var future = new Date(d);
        future.setMinutes(d.getMinutes() + minutes);
        return future;
    };
    date.addHours = function(d, hours) {
        var future = new Date(d);
        future.setHours(d.getHours() + hours);
        return future;
    };
    date.addDays = function(d, days) {
        var future = new Date(d);
        future.setDate(d.getDate() + days);
        return future;
    };
    date.getDaysBetween = function(startDate, endDate) {
        return Math.round((endDate - startDate) / 86400000);
    };
    date.getMsBetween = function(startDate, endDate) {
        return endDate.getTime() - startDate.getTime();
    };
    date.onlyDate = function(d) {
        if (d == null) return d;
        var result = new Date(d);
        result.setHours(0, 0, 0, 0);
        return result;
    };
    date.equal = function(date1, date2) {
        return (date1 && date1.getTime()) === (date2 && date2.getTime());
    };
    return date;
}();
function $f697fe55e25cf9d4$var$pad(nr) {
    if (nr < 10) return "0" + nr.toString();
    else return nr.toString();
}


var $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f = /** @class */ function() {
    function helper() {}
    helper.random = function() {
        return Math.random() * (new Date().getTime() || 1) % 1;
    };
    helper.newGuid = function() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = helper.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    };
    helper.newSeqGuid = function() {
        var d = new Date().getTime().toString(16);
        while(d.length < 12)d = "0" + d;
        if (d.length > 12) d = d.substring(0, 12);
        return "xxxxxxxx-xxxx-4xxx-yxxx-".replace(/[xy]/g, function(c) {
            var r = helper.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        }) + d;
    };
    helper.newDomGuid = function() {
        return "axxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = helper.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    };
    helper.isObject = function(obj) {
        return obj ? Object.prototype.toString.call(obj) === "[object Object]" : false;
    };
    helper.isGuid = function(id) {
        if (!id) return false;
        return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(id);
    };
    helper.getParams = function() {
        var match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function(s) {
            return decodeURIComponent(s.replace(pl, " "));
        }, query = window.location.search.substring(1);
        var urlParams = {};
        while(match = search.exec(query))urlParams[decode(match[1])] = decode(match[2]);
        return urlParams;
    };
    helper.isCyclic = function(o) {
        var seenObjects = [];
        function detect(obj) {
            if (obj && typeof obj === 'object') {
                if (seenObjects.indexOf(obj) !== -1) return true;
                seenObjects.push(obj);
                for(var key in obj){
                    if (obj.hasOwnProperty(key) && detect(obj[key])) return true;
                }
            }
            return false;
        }
        return detect(o);
    };
    helper.correctDates = function(data) {
        for(var key in data){
            if (data[key] && typeof data[key] === "object") data[key] = helper.correctDates(data[key]);
            else if (data[key] && $49e64dbd3190ba7b$var$dateISO.test(data[key].toString())) {
                var x = Date.fromString(data[key]);
                data[key] = new Date(x.getTime() + x.getTimezoneOffset() * 60000);
            }
        }
        return data;
    };
    helper.emptyGuid = "00000000-0000-0000-0000-000000000000";
    return helper;
}();
var $49e64dbd3190ba7b$var$dateISO = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*/i;
(function() {
    var d = window.Date;
    var regexIso8601 = /^(\d{4})-(\d{2})-(\d{2})((T)(\d{2}):(\d{2})(:(\d{2})(\.\d*)?)?)?(Z)?$/;
    d._myparse = function(v) {
        if (v.charAt(v.length - 1) !== "Z") v += "Z";
        var m = regexIso8601.exec(v);
        if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt(+m[10] * 1000) || 0));
        return d.parse.apply(this, arguments);
    };
    d.fromString = function(v) {
        return d._myparse(v);
    };
})();


function $b96b48278b8efa92$var$deepExtend(out) {
    var a = [];
    for(var _i = 1; _i < arguments.length; _i++)a[_i - 1] = arguments[_i];
    out = out || {};
    for(var i = 1; i < arguments.length; i++){
        var obj = arguments[i];
        if (!obj) continue;
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (obj[key] !== null && typeof obj[key] === 'object') out[key] = $b96b48278b8efa92$var$deepExtend(Array.isArray(obj[key]) && out[key] === undefined ? [] : out[key], obj[key]);
            else out[key] = obj[key];
        }
    }
    return out;
}
function $b96b48278b8efa92$var$getParentWithClass(el, c, stopAt) {
    if (el.classList.contains(c)) return el;
    if (stopAt !== undefined && el.classList.contains(stopAt)) return undefined;
    if (el.parentElement) return $b96b48278b8efa92$var$getParentWithClass(el.parentElement, c);
    return undefined;
}
function $b96b48278b8efa92$var$jQWrapper(elements) {
    var _elements = elements;
    _elements.empty = function() {
        for(var _i = 0, _elements_1 = _elements; _i < _elements_1.length; _i++){
            var x = _elements_1[_i];
            x.innerHTML = '';
        }
        return this;
    };
    _elements.appendTo = function(selector) {
        for(var i = 0; i < _elements.length; i++){
            if (selector instanceof HTMLElement) selector.appendChild(_elements[i]);
            else if (typeof selector === "string") {
                var parents = document.querySelectorAll(selector);
                for(var i_1 = 0, len = parents.length; i_1 < len; i_1++)parents[i_1].appendChild(_elements[i_1]);
            } else for(var j = 0; j < selector.length; j++)selector[j].appendChild(_elements[i]);
        }
        return this;
    };
    _elements.append = function(el) {
        for(var i = 0; i < _elements.length; i++)_elements[i].appendChild(el);
        return this;
    };
    _elements.add = function(selector) {
        if (selector !== undefined) {
            if (selector instanceof HTMLElement) _elements.push(selector);
            else for(var i = 0; i < selector.length; i++)_elements.push(selector[i]);
        }
        return this;
    };
    _elements.css = function(key, value) {
        // TODO: support object instead of just simple keys
        if (value === undefined) {
            if (typeof key === "string") {
                if (!_elements.length) return undefined;
                var computed = [
                    "borderLeftWidth",
                    "borderRightWidth",
                    "paddingLeft",
                    "paddingRight",
                    "borderTopWidth",
                    "borderBottomWidth",
                    "paddingTop",
                    "paddingBottom"
                ];
                if (computed.indexOf(key) < 0) return _elements[0].style[key];
                return window.getComputedStyle(_elements[0])[key];
            } else for(var keyEl in key){
                if (!key.hasOwnProperty(keyEl)) continue;
                for(var i = 0; i < _elements.length; i++)if ([
                    "height",
                    "width",
                    "top",
                    "left",
                    "bottom",
                    "right"
                ].indexOf(keyEl) >= 0 && typeof key[keyEl] === "number") _elements[i].style[keyEl] = key[keyEl] + "px";
                else _elements[i].style[keyEl] = key[keyEl];
            }
        }
        for(var i = 0; i < _elements.length; i++)if ([
            "height",
            "width",
            "top",
            "left",
            "bottom",
            "right"
        ].indexOf(key) >= 0 && typeof value === "number") _elements[i].style[key] = value + "px";
        else _elements[i].style[key] = value;
        return this;
    };
    _elements.attr = function(key, value) {
        if (value === undefined) return _elements.length ? _elements[0][key] : undefined;
        for(var i = 0; i < _elements.length; i++)_elements[i][key] = value;
        return this;
    };
    _elements.closestClass = function(name, stopAt) {
        var result = $b96b48278b8efa92$export$f01a81549a0f632f();
        for(var i = 0; i < _elements.length; i++){
            var match = $b96b48278b8efa92$var$getParentWithClass(_elements[i], name, stopAt);
            result.add(match);
        }
        return result;
    };
    _elements.remove = function() {
        for(var i = 0; i < _elements.length; i++){
            var el = _elements[i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    };
    _elements.data = function(name, value) {
        if (_elements.length === 0) return undefined;
        if (value === undefined) return _elements[0][name];
        for(var i = 0; i < _elements.length; i++)_elements[i][name] = value;
        return this;
    };
    _elements.html = function(value) {
        if (value === undefined) return _elements.length ? _elements[0].innerHTML : undefined;
        for(var i = 0; i < _elements.length; i++)_elements[i].innerHTML = value;
        return this;
    };
    _elements.text = function(value) {
        for(var i = 0; i < _elements.length; i++)_elements[i].innerText = value;
        return this;
    };
    _elements.height = function(value) {
        if (value === undefined) {
            if (!_elements.length) return undefined;
            var cssHeight = parseInt(_elements[0].style.height);
            if (isNaN(cssHeight)) return _elements[0].offsetHeight;
            else return cssHeight;
        }
        for(var i = 0; i < _elements.length; i++)if (typeof value === "string") _elements[i].style.height = value;
        else //_elements[i].offsetHeight = value;
        _elements[i].style.height = value + "px";
        return this;
    };
    _elements.width = function(value) {
        if (value === undefined) {
            if (!_elements.length) return undefined;
            // let cssHeight = parseInt(_elements[0].style.width);
            // if (isNaN(cssHeight)) {
            return _elements[0].offsetWidth;
        // } else {
        //     return cssHeight;
        // }
        }
        for(var i = 0; i < _elements.length; i++)if (typeof value === "string") _elements[i].style.width = value;
        else //_elements[i].offsetWidth = value;
        _elements[i].style.width = value + "px";
        return this;
    };
    _elements.removeClass = function(name) {
        for(var i = 0; i < _elements.length; i++)if (name.indexOf(' ') > 0) {
            var names = name.split(' ');
            for(var nIdx = 0; nIdx < names.length; nIdx++)_elements[i].classList.remove(names[nIdx]);
        } else _elements[i].classList.remove(name);
        return this;
    };
    _elements.offset = function() {
        if (_elements.length === 0) return undefined;
        var el = _elements[0];
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        };
    };
    _elements.children = function() {
        var result = [];
        for(var i = 0; i < _elements.length; i++)for(var cidx = 0; cidx < _elements[i].children.length; cidx++)result.push(_elements[i].children[cidx]);
        return $b96b48278b8efa92$var$jQWrapper(result);
    };
    _elements.on = function(eventname, fnc) {
        for(var i = 0; i < _elements.length; i++)_elements[i].addEventListener(eventname, fnc);
        return this;
    };
    _elements.toggleClass = function(name, state) {
        for(var i = 0; i < _elements.length; i++){
            if (state === false || _elements[i].classList.contains(name)) _elements[i].classList.remove(name);
            else if (state === true || !_elements[i].classList.contains(name)) _elements[i].classList.add(name);
        }
        return this;
    };
    _elements.find = function(selector) {
        var result = $b96b48278b8efa92$export$f01a81549a0f632f();
        for(var i = 0; i < _elements.length; i++){
            var found = _elements[i].querySelectorAll(selector);
            for(var j = 0; j < found.length; j++)result.add(found[j]);
        }
        return result;
    };
    _elements.slideDown = function(speed, done) {
        //TODO
        for(var i = 0; i < _elements.length; i++)_elements[i].style.display = '';
        return this;
    };
    _elements.slideUp = function(speed, done) {
        //TODO
        for(var i = 0; i < _elements.length; i++)_elements[i].style.display = 'none';
        return this;
    };
    _elements.addClass = function(name) {
        if (name) for(var i = 0; i < _elements.length; i++)_elements[i].classList.add(name);
        return this;
    };
    _elements.hasClass = function(name) {
        for(var i = 0; i < _elements.length; i++){
            if (_elements[i].classList.contains(name)) return true;
        }
        return false;
    };
    _elements.index = function() {
        var index = 0;
        var node = _elements[0];
        if (!node) return -1;
        while(node = node.previousElementSibling)index++;
        return index;
    };
    return _elements;
}
var $b96b48278b8efa92$var$jqueryCreate = function(selector) {
    var elements = [];
    if (typeof selector === "string") {
        if (selector[0] === '<') {
            var tmp = document.createElement("div");
            tmp.innerHTML = selector;
            elements.push(tmp.firstElementChild);
        } else {
            var q = document.querySelectorAll(selector);
            if (q) for(var i = 0; i < q.length; i++){
                var node = q[i];
                if (node.nodeType === Node.ELEMENT_NODE) elements.push(node);
            }
        }
    } else if (selector !== undefined) elements.push(selector);
    return $b96b48278b8efa92$var$jQWrapper(elements);
};
function $b96b48278b8efa92$var$each(array, fnc) {
    for(var i = 0; i < array.length; i++)fnc(i, array[i]);
}
function $b96b48278b8efa92$var$shallowExtend(out) {
    var rest = [];
    for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
    out = out || {};
    for(var i = 1; i < arguments.length; i++){
        if (!arguments[i]) continue;
        for(var key in arguments[i])if (arguments[i].hasOwnProperty(key)) out[key] = arguments[i][key];
    }
    return out;
}
$b96b48278b8efa92$var$jqueryCreate.deepExtend = $b96b48278b8efa92$var$deepExtend;
$b96b48278b8efa92$var$jqueryCreate.each = $b96b48278b8efa92$var$each;
$b96b48278b8efa92$var$jqueryCreate.shallowExtend = $b96b48278b8efa92$var$shallowExtend;
var $b96b48278b8efa92$export$f01a81549a0f632f = $b96b48278b8efa92$var$jqueryCreate;



var $b075d9931c098fde$export$b7a508fa8dae59fc = /** @class */ function() {
    function numeric() {}
    numeric.parse = function(nrAsString) {
        if (nrAsString === "" || nrAsString === undefined || nrAsString === null) return undefined;
        if (!nrAsString) return undefined;
        if ((0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.decimalSep && (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.decimalSep.length > 1) throw "DecimalSep cannot be more than one character";
        if ((0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.thousandSep && (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.thousandSep.length > 1) throw "ThousandSep cannot be more than one character";
        var str = "";
        var comma_sep = (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.decimalSep;
        for(var i = 0; i < nrAsString.length; i++){
            var c = nrAsString.charAt(i);
            if (c === comma_sep) str += '.';
            else if (c === '0' || c === '1' || c === '2' || c === '3' || c === '4' || c === '5' || c === '6' || c === '7' || c === '8' || c === '9' || c === '-' && str === "") str += c;
        }
        return parseFloat(str);
    };
    numeric.format = function(nr, format) {
        if (isNaN(nr) || nr === null || nr === undefined) return "";
        if ((0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.decimalSep && (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.decimalSep.length > 1) throw "DecimalSep cannot be more than one character";
        if ((0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.thousandSep && (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.thousandSep.length > 1) throw "ThousandSep cannot be more than one character";
        var f = format || (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.numberFormat;
        var cacheEntry = numeric.formatCache[f];
        if (!cacheEntry) numeric.formatCache[f] = cacheEntry = numeric.parseNrFormat(f);
        return numeric.formatNumber(nr, cacheEntry);
    };
    numeric.parseNrFormat = function(format) {
        var prefix = "";
        var suffix = "";
        var show_sep = format.indexOf(',#') > 0 || format.indexOf(',0') > 0;
        var min_length = 0;
        for(var i = 0; i < format.length; i++){
            if (format.charAt(i) === '.') break;
            if (format.charAt(i) === '0') min_length++;
            if (min_length === 0 && format.charAt(i) !== ',' && format.charAt(i) !== '0' && format.charAt(i) !== '.' && format.charAt(i) !== '#') prefix += format.charAt(i);
        }
        var max_comma_places = 0;
        var min_comma_places = 0;
        var comma_pos = format.indexOf('.');
        if (comma_pos >= 0) for(var j = comma_pos + 1; j < format.length; j++){
            if (format.charAt(j) === '0') min_comma_places++;
            else if (format.charAt(j) === '#') max_comma_places++;
            else if (format.charAt(j) !== ',' && format.charAt(j) !== '.') suffix += format.charAt(j);
        }
        max_comma_places += min_comma_places;
        return {
            max_comma_places: max_comma_places,
            min_comma_places: min_comma_places,
            min_length: min_length,
            prefix: prefix,
            suffix: suffix,
            show_sep: show_sep
        };
    };
    numeric.formatNumber = function(nr, format) {
        //defaults
        var comma_separator = (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.decimalSep;
        var thousand_separator = (0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).info.thousandSep;
        var cp_min = format.min_comma_places || 0;
        var cp_max = format.max_comma_places || 0;
        var ml = format.min_length || 0;
        //check if number is negative
        var negative = nr < 0;
        if (negative) nr = -nr;
        //convert number to a string and round
        var nr_str_raw = nr.toFixed(cp_max);
        var cp = cp_max;
        //remove comma-places which are not necessary
        var end = nr_str_raw.indexOf('.') + cp_min;
        if (end >= 0) {
            var x = nr_str_raw.length - 1;
            while(x > end){
                if (nr_str_raw.charAt(x) === '0') {
                    cp--;
                    nr_str_raw = nr_str_raw.slice(0, -1);
                } else break;
                x--;
            }
            if (nr_str_raw.charAt(x) === '.') nr_str_raw = nr_str_raw.slice(0, -1);
        }
        var nr_str = comma_separator !== "." ? nr_str_raw.replace(".", comma_separator) : nr_str_raw;
        var t = cp ? cp + 1 : 0;
        // add "0" at the front if necessary
        while(nr_str.length < ml + t)nr_str = "0" + nr_str;
        // insert thousand-separator if necessary
        t += 3;
        while(nr_str.length > t && format.show_sep){
            nr_str = nr_str.substr(0, nr_str.length - t) + thousand_separator + nr_str.substr(nr_str.length - t);
            t += 4;
        }
        //remove first 0 if necessary
        if (ml === 0 && nr_str.charAt(0) === '0') nr_str = nr_str.slice(1);
        //return number
        if (negative && parseFloat(nr_str_raw) !== 0) return (format.prefix || "") + "-" + nr_str + (format.suffix || "");
        else return (format.prefix || "") + nr_str + (format.suffix || "");
    };
    numeric.formatCache = {};
    return numeric;
}();


// source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function() {
    if (typeof window.CustomEvent === "function") return false;
    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
    if (!("remove" in Element.prototype)) Element.prototype.remove = function() {
        if (this.parentNode) this.parentNode.removeChild(this);
    };
})();




var $5fd26a1369f72280$export$ce0ba2422a1c7815 = /** @class */ function() {
    function EventHandler(fnc) {
        this.handlers = [];
        if (fnc != null) this.handlers.push(fnc);
    }
    EventHandler.Create = function(click) {
        if (click == null) return new EventHandler();
        if (typeof click === "function") {
            var res = new EventHandler();
            res.subscribe(click);
            return res;
        }
        return click;
    };
    EventHandler.prototype.subscribe = function(fnc) {
        this.handlers.push(fnc);
    };
    EventHandler.prototype.notify = function(val, val2) {
        for(var _i = 0, _a = this.handlers; _i < _a.length; _i++){
            var h = _a[_i];
            h(val, val2);
        }
    };
    EventHandler.prototype.count = function() {
        return this.handlers.length;
    };
    EventHandler.prototype.unSubscribe = function(fnc) {
        if (this.handlers.indexOf(fnc) >= 0) this.handlers.splice(this.handlers.indexOf(fnc), 1);
        else // TODO? throw exception?
        console.warn("handler not found in EventHandler.unSubscribe");
    };
    return EventHandler;
}();


var $e452221c07eb14a0$var$__assign = undefined && undefined.__assign || function() {
    $e452221c07eb14a0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e452221c07eb14a0$var$__assign.apply(this, arguments);
};
var $e452221c07eb14a0$var$defaultOptions = {
    resizeHandlePrefix: "rs-",
    onStart: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(),
    onStop: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(),
    onResize: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(),
    resizeDelta: 0
};
var $e452221c07eb14a0$export$e6b97407fcdac315 = /** @class */ function() {
    function ResizeContainer(container, options) {
        var _this = this;
        this.container = container;
        this.options = options;
        this.startSize = {
            x: null,
            y: null
        };
        this.mouseDownContainer = function(evt) {
            var target = evt.target;
            if ((" " + target.className).indexOf(" " + _this.options.resizeHandlePrefix) < 0) return; // not a resize handle
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            _this.resizeX = target.classList.contains(_this.options.resizeHandlePrefix + "r") || target.classList.contains(_this.options.resizeHandlePrefix + "l");
            _this.resizeY = target.classList.contains(_this.options.resizeHandlePrefix + "t") || target.classList.contains(_this.options.resizeHandlePrefix + "b");
            _this.element = target.parentElement; // TODO change to closest class
            _this.options.onStart.notify({
                evt: evt,
                target: _this.element,
                x: _this.extractArg(evt, "pageX"),
                y: _this.extractArg(evt, "pageY")
            });
            // register event listeners
            window.addEventListener("mousemove", _this.mouseMove, false);
            window.addEventListener("mouseup", _this.mouseUp, false);
            window.addEventListener("touchmove", _this.mouseMove, false);
            window.addEventListener("touchend", _this.mouseUp, false);
        };
        this.mouseMove = function(evt) {
            var raiseEvt = false;
            if (_this.resizeX) {
                var val = _this.extractArg(evt, "clientX") - _this.element.getBoundingClientRect().left;
                if (_this.options.minWidth && val < _this.options.minWidth) val = _this.options.minWidth;
                else if (_this.options.maxWidth && val > _this.options.maxWidth) val = _this.options.maxWidth;
                if (_this.startSize != null && _this.startSize.x == null) _this.startSize.x = val;
                if (_this.startSize == null || Math.abs(_this.startSize.x - val) >= _this.options.resizeDelta) {
                    // if (!this.options.gridX || Math.round(val) % this.options.gridX === 0) {
                    if (_this.options.gridX) val = Math.round(val / _this.options.gridX) * _this.options.gridX;
                    _this.element.style.width = Math.round(val) + "px";
                    raiseEvt = true;
                    _this.startSize = null;
                // }
                }
            }
            if (_this.resizeY) {
                var val = _this.extractArg(evt, "clientY") - _this.element.getBoundingClientRect().top;
                if (_this.options.minHeight && val < _this.options.minHeight) val = _this.options.minHeight;
                else if (_this.options.maxHeight && val > _this.options.maxHeight) val = _this.options.maxHeight;
                if (_this.startSize != null && _this.startSize.y == null) _this.startSize.y = val;
                if (_this.startSize == null || Math.abs(_this.startSize.y - val) >= _this.options.resizeDelta) {
                    // if (!this.options.gridY || Math.round(val) % this.options.gridY === 0) {
                    if (_this.options.gridY) val = Math.round(val / _this.options.gridY) * _this.options.gridY;
                    _this.element.style.height = Math.round(val) + "px";
                    raiseEvt = true;
                    _this.startSize = null;
                // }
                }
            }
            if (raiseEvt) _this.options.onResize.notify({
                evt: evt,
                target: _this.element,
                x: _this.extractArg(evt, "pageX"),
                y: _this.extractArg(evt, "pageY")
            });
        };
        this.mouseUp = function(evt) {
            window.removeEventListener("mousemove", _this.mouseMove, false);
            window.removeEventListener("mouseup", _this.mouseUp, false);
            window.removeEventListener("touchmove", _this.mouseMove, false);
            window.removeEventListener("touchend", _this.mouseUp, false);
            _this.options.onStop.notify({
                evt: evt,
                target: _this.element,
                x: _this.extractArg(evt, "pageX"),
                y: _this.extractArg(evt, "pageY")
            });
            _this.startSize = {
                x: null,
                y: null
            };
        };
        this.init();
    }
    ResizeContainer.prototype.init = function() {
        this.container.classList.add("resizable");
        this.container.addEventListener("mousedown", this.mouseDownContainer, false);
        this.container.addEventListener("touchstart", this.mouseDownContainer, false);
    };
    ResizeContainer.prototype.extractArg = function(evt, key) {
        return evt[key] != null ? evt[key] : (evt.touches.length > 0 ? evt.touches : evt.changedTouches)[0][key];
    };
    return ResizeContainer;
}();
function $e452221c07eb14a0$export$e82068809229c83c(selector, options) {
    return new $e452221c07eb14a0$export$e6b97407fcdac315(typeof selector === "string" ? document.querySelector(selector) : selector, $e452221c07eb14a0$var$__assign($e452221c07eb14a0$var$__assign({}, $e452221c07eb14a0$var$defaultOptions), options));
}





var $13f81d53256d6031$var$__assign = undefined && undefined.__assign || function() {
    $13f81d53256d6031$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13f81d53256d6031$var$__assign.apply(this, arguments);
};
var $13f81d53256d6031$var$defaultOptions = {
    onStart: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(),
    onStop: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(),
    onMove: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(),
    direction: "both",
    moveDelta: 0,
    containInParent: true
};
var $13f81d53256d6031$export$8c93dc81a030f4e4 = /** @class */ function() {
    function MoveableContainer(container, options) {
        var _this = this;
        this.container = container;
        this.options = options;
        this.resizeX = false;
        this.resizeY = false;
        this.initialX = null;
        this.initialY = null;
        this.startSize = {
            x: null,
            y: null
        };
        this.mouseDownContainer = function(evt) {
            var target = evt.target;
            var directChild = target;
            while(directChild.parentElement != null && directChild.parentElement !== _this.container){
                if (_this.options.selector != null && directChild.matches(_this.options.selector)) break;
                directChild = directChild.parentElement;
            }
            if (directChild.parentElement == null) return;
            if (_this.options.selector != null && !directChild.matches(_this.options.selector)) return;
            _this.element = directChild;
            var canceled = false;
            var args = {
                evt: evt,
                target: _this.element,
                x: _this.element.offsetLeft,
                y: _this.element.offsetTop,
                cancelEvent: function() {
                    canceled = true;
                }
            };
            _this.options.onStart.notify(args);
            if (canceled) return;
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            _this.initialX = _this.extractArg(evt, "clientX") - _this.element.offsetLeft;
            _this.initialY = _this.extractArg(evt, "clientY") - _this.element.offsetTop;
            // register event listeners
            window.addEventListener("mousemove", _this.mouseMove, false);
            window.addEventListener("mouseup", _this.mouseUp, false);
            window.addEventListener("touchmove", _this.mouseMove, false);
            window.addEventListener("touchend", _this.mouseUp, false);
        };
        this.mouseMove = function(evt) {
            var raiseEvt = false;
            var x = 0;
            if (_this.resizeX) {
                var val = _this.extractArg(evt, "clientX");
                if (_this.startSize != null && _this.startSize.x == null) _this.startSize.x = val;
                if (_this.startSize == null || Math.abs(_this.startSize.x - val) >= _this.options.moveDelta) {
                    //if (!this.options.gridX || Math.round(val) % this.options.gridX === 0) {
                    x = val - _this.initialX;
                    if (_this.options.gridX) x = Math.round(x / _this.options.gridX) * _this.options.gridX;
                    if (_this.options.containInParent) {
                        if (x < 0) x = 0;
                        var maxX = _this.container.clientWidth - _this.element.offsetWidth;
                        if (x > maxX) x = maxX;
                    }
                    _this.element.style.left = x + "px";
                    raiseEvt = true;
                    _this.startSize = null;
                //}
                }
            }
            var y = 0;
            if (_this.resizeY) {
                var val = _this.extractArg(evt, "clientY");
                if (_this.startSize != null && _this.startSize.y == null) _this.startSize.y = val;
                if (_this.startSize == null || Math.abs(_this.startSize.y - val) >= _this.options.moveDelta) {
                    //if (!this.options.gridY || Math.round(val) % this.options.gridY === 0) {
                    y = val - _this.initialY;
                    if (_this.options.gridY) y = Math.round(y / _this.options.gridY) * _this.options.gridY;
                    if (y < 0) y = 0;
                    var maxY = _this.container.clientHeight - _this.element.offsetHeight;
                    if (y > maxY) y = maxY;
                    _this.element.style.top = y + "px";
                    raiseEvt = true;
                    _this.startSize = null;
                //}
                }
            }
            if (raiseEvt) _this.options.onMove.notify({
                evt: evt,
                target: _this.element,
                x: x,
                y: y,
                cancelEvent: function() {}
            });
        };
        this.mouseUp = function(evt) {
            window.removeEventListener("mousemove", _this.mouseMove, false);
            window.removeEventListener("mouseup", _this.mouseUp, false);
            window.removeEventListener("touchmove", _this.mouseMove, false);
            window.removeEventListener("touchend", _this.mouseUp, false);
            _this.options.onStop.notify({
                evt: evt,
                target: _this.element,
                x: _this.element.offsetLeft,
                y: _this.element.offsetTop,
                cancelEvent: function() {}
            });
            _this.startSize = {
                x: null,
                y: null
            };
        };
        if (options.direction === "x" || options.direction === "both") this.resizeX = true;
        if (options.direction === "y" || options.direction === "both") this.resizeY = true;
        this.init();
    }
    MoveableContainer.prototype.init = function() {
        this.container.addEventListener("mousedown", this.mouseDownContainer, false);
        this.container.addEventListener("touchstart", this.mouseDownContainer, false);
    };
    MoveableContainer.prototype.extractArg = function(evt, key) {
        return evt[key] != null ? evt[key] : (evt.touches.length > 0 ? evt.touches : evt.changedTouches)[0][key];
    };
    return MoveableContainer;
}();
function $13f81d53256d6031$export$4f463cee1ac70b5b(selector, options) {
    return new $13f81d53256d6031$export$8c93dc81a030f4e4(typeof selector === "string" ? document.querySelector(selector) : selector, $13f81d53256d6031$var$__assign($13f81d53256d6031$var$__assign({}, $13f81d53256d6031$var$defaultOptions), options));
}



/**
 * @file Responsible for sanitizing and creating date picker options.
 */ /**
 * @file A generic set of mutation-free date functions.
 */ /**
 * now returns the current date without any time values
 *
 * @returns {Date}
 */ function $d9f79920db6e19e8$export$461939dd4422153() {
    var dt = new Date();
    dt.setHours(0, 0, 0, 0);
    return dt;
}
function $d9f79920db6e19e8$export$4e19448a5552da7(date1, date2) {
    return (date1 && date1.toDateString()) === (date2 && date2.toDateString());
}
function $d9f79920db6e19e8$export$1072e3f9fb71c263(dt, n) {
    dt = new Date(dt);
    dt.setDate(dt.getDate() + n);
    return dt;
}
function $d9f79920db6e19e8$export$7621dcaaa4455741(dt, n, wrap) {
    dt = new Date(dt);
    var dayOfMonth = dt.getDate();
    var month = dt.getMonth() + n;
    dt.setDate(1);
    dt.setMonth(wrap ? (12 + month) % 12 : month);
    dt.setDate(dayOfMonth);
    // If dayOfMonth = 31, but the target month only has 30 or 29 or whatever...
    // head back to the max of the target month
    if (dt.getDate() < dayOfMonth) dt.setDate(0);
    return dt;
}
function $d9f79920db6e19e8$export$b416d7c64afeefdd(dt, n) {
    dt = new Date(dt);
    dt.setFullYear(dt.getFullYear() + n);
    return dt;
}
function $d9f79920db6e19e8$export$a8408b6c5639cab7(dt, year) {
    dt = new Date(dt);
    dt.setFullYear(year);
    return dt;
}
function $d9f79920db6e19e8$export$63264690f8e36790(dt, month) {
    return $d9f79920db6e19e8$export$7621dcaaa4455741(dt, month - dt.getMonth());
}
function $d9f79920db6e19e8$export$655befd4ae4101f7(parse) {
    return function(dt) {
        return $d9f79920db6e19e8$var$dropTime(typeof dt === 'string' ? parse(dt) : dt);
    };
}
function $d9f79920db6e19e8$export$cfa0771de6e21a5a(dt, min, max) {
    return dt < min ? min : dt > max ? max : dt;
}
function $d9f79920db6e19e8$var$dropTime(dt) {
    dt = new Date(dt);
    dt.setHours(0, 0, 0, 0);
    return dt;
}


/**
 * @file Utility functions for function manipulation.
 */ /**
 * bufferFn buffers calls to fn so they only happen every ms milliseconds
 *
 * @param {number} ms number of milliseconds
 * @param {function} fn the function to be buffered
 * @returns {function}
 */ function $712229d871045015$export$7033eecc3ec7e0a5(ms, fn) {
    var timeout = undefined;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(fn, ms);
    };
}
function $712229d871045015$export$8793edee2d425525() {}
function $712229d871045015$export$cd571ca6d1702b73() {
    var params = [];
    for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
    var args = arguments;
    var o1 = args[0];
    for(var i = 1; i < args.length; ++i){
        var o2 = args[i] || {};
        for(var key in o2)o1[key] = o2[key];
    }
    return o1;
}



var $49b77b2b12375aa8$var$english = {
    days: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    today: 'Today',
    clear: 'Clear',
    close: 'Close'
};
function $49b77b2b12375aa8$export$2e2bcd8739ae039(opts) {
    opts = opts || {};
    opts = (0, $712229d871045015$export$cd571ca6d1702b73)($49b77b2b12375aa8$var$defaults(), opts);
    var parse = (0, $d9f79920db6e19e8$export$655befd4ae4101f7)(opts.parse);
    opts.lang = (0, $712229d871045015$export$cd571ca6d1702b73)($49b77b2b12375aa8$var$english, opts.lang);
    opts.parse = parse;
    opts.inRange = $49b77b2b12375aa8$var$makeInRangeFn(opts);
    opts.min = parse(opts.min || (0, $d9f79920db6e19e8$export$b416d7c64afeefdd)((0, $d9f79920db6e19e8$export$461939dd4422153)(), -100));
    opts.max = parse(opts.max || (0, $d9f79920db6e19e8$export$b416d7c64afeefdd)((0, $d9f79920db6e19e8$export$461939dd4422153)(), 100));
    opts.hilightedDate = opts.parse(opts.hilightedDate);
    return opts;
}
function $49b77b2b12375aa8$var$defaults() {
    return {
        lang: $49b77b2b12375aa8$var$english,
        // Possible values: dp-modal, dp-below, dp-permanent
        mode: 'dp-below',
        // The date to hilight initially if the date picker has no
        // initial value.
        hilightedDate: (0, $d9f79920db6e19e8$export$461939dd4422153)(),
        format: function(dt) {
            return (0, $f697fe55e25cf9d4$export$324d90190a8b822a).format(dt);
        //return (dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear();
        },
        parse: function(str) {
            //var date = new Date(str);
            var d = (0, $f697fe55e25cf9d4$export$324d90190a8b822a).parse(str);
            return !d ? (0, $d9f79920db6e19e8$export$461939dd4422153)() : d;
        },
        dateClass: function() {},
        inRange: function() {
            return true;
        },
        appendTo: document.body,
        dayOffset: 1
    };
}
function $49b77b2b12375aa8$var$makeInRangeFn(opts) {
    var inRange = opts.inRange; // Cache this version, and return a variant
    return function(dt, dp) {
        return inRange(dt, dp) && opts.min <= dt && opts.max >= dt;
    };
}


/**
 * @file Defines the various date picker modes (modal, dropdown, permanent)
 */ /**
 * @file Defines the modal date picker behavior.
 */ /**
 * @file Defines the base date picker behavior, overridden by various modes.
 */ /**
 * @file Manages the calendar / day-picker view.
 */ 
var $1b218e9eae2bf5fa$export$cd0f44441c3b7719 = {
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    enter: 13,
    esc: 27
};
function $1b218e9eae2bf5fa$export$af631764ddc44097(evt, el, handler) {
    el.addEventListener(evt, handler, true);
    return function() {
        el.removeEventListener(evt, handler, true);
    };
}
var $1b218e9eae2bf5fa$export$9d2aa32114ab0612 = window.CustomEvent;



var $94ed3e327e2bf01e$export$2e2bcd8739ae039 = {
    onKeyDown: $94ed3e327e2bf01e$var$keyDown,
    onClick: {
        'dp-day': $94ed3e327e2bf01e$var$selectDay,
        'dp-next': $94ed3e327e2bf01e$var$gotoNextMonth,
        'dp-prev': $94ed3e327e2bf01e$var$gotoPrevMonth,
        'dp-today': $94ed3e327e2bf01e$var$selectToday,
        'dp-clear': $94ed3e327e2bf01e$var$clear,
        'dp-close': $94ed3e327e2bf01e$var$close,
        'dp-cal-month': $94ed3e327e2bf01e$var$showMonthPicker,
        'dp-cal-year': $94ed3e327e2bf01e$var$showYearPicker
    },
    render: $94ed3e327e2bf01e$var$render
};
/**
 * view renders the calendar (day picker) as an HTML string.
 *
 * @param {DatePickerContext} context the date picker being rendered
 * @returns {string}
 */ function $94ed3e327e2bf01e$var$render(dp) {
    var opts = dp.opts;
    var lang = opts.lang;
    var state = dp.state;
    var dayNames = lang.days;
    var dayOffset = opts.dayOffset || 0;
    var selectedDate = state.selectedDate;
    var hilightedDate = state.hilightedDate;
    var hilightedMonth = hilightedDate.getMonth();
    var today = (0, $d9f79920db6e19e8$export$461939dd4422153)().getTime();
    return '<div class="dp-cal"><header class="dp-cal-header"><button tabindex="-1" type="button" class="dp-prev">Prev</button><button tabindex="-1" type="button" class="dp-cal-month">' + lang.months[hilightedMonth] + '</button>' + '<button tabindex="-1" type="button" class="dp-cal-year">' + hilightedDate.getFullYear() + '</button>' + '<button tabindex="-1" type="button" class="dp-next">Next</button>' + '</header>' + '<div class="dp-days">' + dayNames.map(function(name, i) {
        return '<span class="dp-col-header">' + dayNames[(i + dayOffset) % dayNames.length] + '</span>';
    }).join('') + $94ed3e327e2bf01e$var$mapDays(hilightedDate, dayOffset, function(date) {
        var isNotInMonth = date.getMonth() !== hilightedMonth;
        var isDisabled = !opts.inRange(date);
        var isToday = date.getTime() === today;
        var className = 'dp-day';
        className += isNotInMonth ? ' dp-edge-day' : '';
        className += (0, $d9f79920db6e19e8$export$4e19448a5552da7)(date, hilightedDate) ? ' dp-current' : '';
        className += (0, $d9f79920db6e19e8$export$4e19448a5552da7)(date, selectedDate) ? ' dp-selected' : '';
        className += isDisabled ? ' dp-day-disabled' : '';
        className += isToday ? ' dp-day-today' : '';
        className += ' ' + opts.dateClass(date, dp);
        return '<button tabindex="-1" type="button" class="' + className + '" data-date="' + date.getTime() + '">' + date.getDate() + '</button>';
    }) + '</div>' + '<footer class="dp-cal-footer">' + '<button tabindex="-1" type="button" class="dp-today">' + lang.today + '</button>' + '<button tabindex="-1" type="button" class="dp-clear">' + lang.clear + '</button>' + '<button tabindex="-1" type="button" class="dp-close">' + lang.close + '</button>' + '</footer>' + '</div>';
}
/**
 * keyDown handles the key down event for the day-picker
 *
 * @param {Event} e
 * @param {DatePickerContext} dp
 */ function $94ed3e327e2bf01e$var$keyDown(e, dp) {
    var key = e.keyCode;
    var shiftBy = key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).left ? -1 : key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).right ? 1 : key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).up ? -7 : key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).down ? 7 : 0;
    if (key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).esc) dp.close();
    else if (shiftBy) {
        e.preventDefault();
        dp.setState({
            hilightedDate: (0, $d9f79920db6e19e8$export$1072e3f9fb71c263)(dp.state.hilightedDate, shiftBy)
        });
    }
}
function $94ed3e327e2bf01e$var$selectToday(e, dp) {
    dp.setState({
        selectedDate: (0, $d9f79920db6e19e8$export$461939dd4422153)()
    });
}
function $94ed3e327e2bf01e$var$clear(e, dp) {
    dp.setState({
        selectedDate: null
    });
}
function $94ed3e327e2bf01e$var$close(e, dp) {
    dp.close();
}
function $94ed3e327e2bf01e$var$showMonthPicker(e, dp) {
    dp.setState({
        view: 'month'
    });
}
function $94ed3e327e2bf01e$var$showYearPicker(e, dp) {
    dp.setState({
        view: 'year'
    });
}
function $94ed3e327e2bf01e$var$gotoNextMonth(e, dp) {
    var hilightedDate = dp.state.hilightedDate;
    dp.setState({
        hilightedDate: (0, $d9f79920db6e19e8$export$7621dcaaa4455741)(hilightedDate, 1)
    });
}
function $94ed3e327e2bf01e$var$gotoPrevMonth(e, dp) {
    var hilightedDate = dp.state.hilightedDate;
    dp.setState({
        hilightedDate: (0, $d9f79920db6e19e8$export$7621dcaaa4455741)(hilightedDate, -1)
    });
}
function $94ed3e327e2bf01e$var$selectDay(e, dp) {
    dp.setState({
        selectedDate: new Date(parseInt(e.target.getAttribute('data-date')))
    });
}
function $94ed3e327e2bf01e$var$mapDays(currentDate, dayOffset, fn) {
    var result = '';
    var iter = new Date(currentDate);
    iter.setDate(1);
    iter.setDate(1 - iter.getDay() + dayOffset);
    // If we are showing monday as the 1st of the week,
    // and the monday is the 2nd of the month, the sunday won't
    // show, so we need to shift backwards
    if (dayOffset && iter.getDate() === dayOffset + 1) iter.setDate(dayOffset - 6);
    // We are going to have 6 weeks always displayed to keep a consistent
    // calendar size
    for(var day = 0; day < 42; ++day){
        result += fn(iter);
        iter.setDate(iter.getDate() + 1);
    }
    return result;
}


/**
 * @file Manages the month-picker view.
 */ 

var $083f2505aa162c3b$export$2e2bcd8739ae039 = {
    onKeyDown: $083f2505aa162c3b$var$keyDown,
    onClick: {
        'dp-month': $083f2505aa162c3b$var$onChooseMonth
    },
    render: $083f2505aa162c3b$var$render
};
function $083f2505aa162c3b$var$onChooseMonth(e, dp) {
    dp.setState({
        hilightedDate: (0, $d9f79920db6e19e8$export$63264690f8e36790)(dp.state.hilightedDate, parseInt(e.target.getAttribute('data-month'))),
        view: 'day'
    });
}
/**
 * render renders the month picker as an HTML string
 *
 * @param {DatePickerContext} dp the date picker context
 * @returns {string}
 */ function $083f2505aa162c3b$var$render(dp) {
    var opts = dp.opts;
    var lang = opts.lang;
    var months = lang.months;
    var currentDate = dp.state.hilightedDate;
    var currentMonth = currentDate.getMonth();
    return '<div class="dp-months">' + months.map(function(month, i) {
        var className = 'dp-month';
        className += currentMonth === i ? ' dp-current' : '';
        return '<button tabindex="-1" type="button" class="' + className + '" data-month="' + i + '">' + month + '</button>';
    }).join('') + '</div>';
}
/**
 * keyDown handles keydown events that occur in the month picker
 *
 * @param {Event} e
* @param {DatePickerContext} dp
 */ function $083f2505aa162c3b$var$keyDown(e, dp) {
    var key = e.keyCode;
    var shiftBy = key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).left ? -1 : key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).right ? 1 : key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).up ? -3 : key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).down ? 3 : 0;
    if (key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).esc) dp.setState({
        view: 'day'
    });
    else if (shiftBy) {
        e.preventDefault();
        dp.setState({
            hilightedDate: (0, $d9f79920db6e19e8$export$7621dcaaa4455741)(dp.state.hilightedDate, shiftBy, true)
        });
    }
}


/**
 * @file Manages the year-picker view.
 */ 

var $227ad83fd78efff0$export$2e2bcd8739ae039 = {
    render: $227ad83fd78efff0$var$render,
    onKeyDown: $227ad83fd78efff0$var$keyDown,
    onClick: {
        'dp-year': $227ad83fd78efff0$var$onChooseYear
    }
};
/**
 * view renders the year picker as an HTML string.
 *
 * @param {DatePickerContext} dp the date picker context
 * @returns {string}
 */ function $227ad83fd78efff0$var$render(dp) {
    var state = dp.state;
    var currentYear = state.hilightedDate.getFullYear();
    var selectedYear = state.selectedDate.getFullYear();
    return '<div class="dp-years">' + $227ad83fd78efff0$var$mapYears(dp, function(year) {
        var className = 'dp-year';
        className += year === currentYear ? ' dp-current' : '';
        className += year === selectedYear ? ' dp-selected' : '';
        return '<button tabindex="-1" type="button" class="' + className + '" data-year="' + year + '">' + year + '</button>';
    }) + '</div>';
}
function $227ad83fd78efff0$var$onChooseYear(e, dp) {
    dp.setState({
        hilightedDate: (0, $d9f79920db6e19e8$export$a8408b6c5639cab7)(dp.state.hilightedDate, parseInt(e.target.getAttribute('data-year'))),
        view: 'day'
    });
}
function $227ad83fd78efff0$var$keyDown(e, dp) {
    var key = e.keyCode;
    var opts = dp.opts;
    var shiftBy = key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).left || key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).up ? 1 : key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).right || key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).down ? -1 : 0;
    if (key === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).esc) dp.setState({
        view: 'day'
    });
    else if (shiftBy) {
        e.preventDefault();
        var shiftedYear = (0, $d9f79920db6e19e8$export$b416d7c64afeefdd)(dp.state.hilightedDate, shiftBy);
        dp.setState({
            hilightedDate: (0, $d9f79920db6e19e8$export$cfa0771de6e21a5a)(shiftedYear, opts.min, opts.max)
        });
    }
}
function $227ad83fd78efff0$var$mapYears(dp, fn) {
    var result = '';
    var max = dp.opts.max.getFullYear();
    for(var i = max; i >= dp.opts.min.getFullYear(); --i)result += fn(i);
    return result;
}





var $6d828da9baecfeea$var$views = {
    day: (0, $94ed3e327e2bf01e$export$2e2bcd8739ae039),
    year: (0, $227ad83fd78efff0$export$2e2bcd8739ae039),
    month: (0, $083f2505aa162c3b$export$2e2bcd8739ae039)
};
function $6d828da9baecfeea$export$2e2bcd8739ae039(input, emit, opts) {
    var detatchInputEvents; // A function that detaches all events from the input
    var closing = false; // A hack to prevent calendar from re-opening when closing.
    var selectedDate; // The currently selected date
    var dp = {
        // The root DOM element for the date picker, initialized on first open.
        el: undefined,
        opts: opts,
        shouldFocusOnBlur: true,
        shouldFocusOnRender: true,
        state: initialState(),
        adjustPosition: (0, $712229d871045015$export$8793edee2d425525),
        containerHTML: '<div class="dp"></div>',
        attachToDom: function() {
            opts.appendTo.appendChild(dp.el);
        },
        updateInput: function(selectedDate) {
            var e = new (0, $1b218e9eae2bf5fa$export$9d2aa32114ab0612)('change', {
                bubbles: true
            });
            e.simulated = true;
            input.value = selectedDate ? opts.format(selectedDate) : '';
            input.dispatchEvent(e);
        },
        computeSelectedDate: function() {
            return opts.parse(input.value);
        },
        currentView: function() {
            return $6d828da9baecfeea$var$views[dp.state.view];
        },
        open: function() {
            if (closing) return;
            if (!dp.el) {
                dp.el = $6d828da9baecfeea$var$createContainerElement(opts, dp.containerHTML);
                $6d828da9baecfeea$var$attachContainerEvents(dp);
            }
            selectedDate = (0, $d9f79920db6e19e8$export$cfa0771de6e21a5a)(dp.computeSelectedDate(), opts.min, opts.max);
            dp.state.hilightedDate = selectedDate || opts.hilightedDate;
            dp.state.view = 'day';
            dp.attachToDom();
            dp.render();
            emit('open');
        },
        isVisible: function() {
            return !!dp.el && !!dp.el.parentNode;
        },
        hasFocus: function() {
            var focused = document.activeElement;
            return dp.el && dp.el.contains(focused) && focused.className.indexOf('dp-focuser') < 0;
        },
        shouldHide: function() {
            return dp.isVisible();
        },
        close: function(becauseOfBlur) {
            var el = dp.el;
            if (!dp.isVisible()) return;
            if (el) {
                var parent = el.parentNode;
                parent && parent.removeChild(el);
            }
            closing = true;
            if (becauseOfBlur && dp.shouldFocusOnBlur) $6d828da9baecfeea$var$focusInput(input);
            // When we close, the input often gains refocus, which
            // can then launch the date picker again, so we buffer
            // a bit and don't show the date picker within N ms of closing
            setTimeout(function() {
                closing = false;
            }, 100);
            emit('close');
        },
        destroy: function() {
            dp.close();
            detatchInputEvents();
        },
        render: function() {
            if (!dp.el) return;
            var hadFocus = dp.hasFocus();
            var html = dp.currentView().render(dp);
            html && (dp.el.firstChild.innerHTML = html);
            dp.adjustPosition();
            if (hadFocus || dp.shouldFocusOnRender) $6d828da9baecfeea$var$focusCurrent(dp);
        },
        // Conceptually similar to setState in React, updates
        // the view state and re-renders.
        setState: function(state) {
            for(var key in state)dp.state[key] = state[key];
            emit('statechange');
            dp.render();
        }
    };
    detatchInputEvents = $6d828da9baecfeea$var$attachInputEvents(input, dp);
    // Builds the initial view state
    // selectedDate is a special case and causes changes to hilightedDate
    // hilightedDate is set on open, so remains undefined initially
    // view is the current view (day, month, year)
    function initialState() {
        return {
            get selectedDate () {
                return selectedDate;
            },
            set selectedDate (dt){
                if (dt && !opts.inRange(dt)) return;
                if (dt) {
                    selectedDate = new Date(dt);
                    dp.state.hilightedDate = selectedDate;
                } else selectedDate = dt;
                dp.updateInput(selectedDate);
                emit('select');
                dp.close();
            },
            view: 'day',
            hilightedDate: undefined
        };
    }
    return dp;
}
function $6d828da9baecfeea$var$createContainerElement(opts, containerHTML) {
    var el = document.createElement('div');
    el.className = opts.mode;
    el.innerHTML = containerHTML;
    return el;
}
function $6d828da9baecfeea$var$attachInputEvents(input, dp) {
    var bufferShow = (0, $712229d871045015$export$7033eecc3ec7e0a5)(5, function() {
        if (dp.shouldHide()) dp.close();
        else dp.open();
    });
    var off = [
        (0, $1b218e9eae2bf5fa$export$af631764ddc44097)('blur', input, (0, $712229d871045015$export$7033eecc3ec7e0a5)(150, function() {
            if (!dp.hasFocus()) dp.close(true);
        })),
        (0, $1b218e9eae2bf5fa$export$af631764ddc44097)('mousedown', input, function() {
            if (input === document.activeElement && !dp.isVisible()) bufferShow();
        }),
        (0, $1b218e9eae2bf5fa$export$af631764ddc44097)('focus', input, bufferShow),
        (0, $1b218e9eae2bf5fa$export$af631764ddc44097)('input', input, function(e) {
            try {
                var date = dp.opts.parse(e.target.value);
                dp.setState({
                    hilightedDate: date
                });
            } catch (e) {
            //ignore invalid dates while input
            }
        })
    ];
    // Unregister all events that were registered above.
    return function() {
        off.forEach(function(f) {
            f();
        });
    };
}
function $6d828da9baecfeea$var$focusCurrent(dp) {
    var current = dp.el.querySelector('.dp-current');
    return current && current.focus();
}
function $6d828da9baecfeea$var$attachContainerEvents(dp) {
    var el = dp.el;
    var calEl = el.querySelector('.dp');
    // Hack to get iOS to show active CSS states
    el.ontouchstart = (0, $712229d871045015$export$8793edee2d425525);
    function onClick(e) {
        e.target.className.split(' ').forEach(function(evt) {
            var handler = dp.currentView().onClick[evt];
            handler && handler(e, dp);
        });
    }
    // The calender fires a blur event *every* time we redraw
    // this means we need to buffer the blur event to see if
    // it still has no focus after redrawing, and only then
    // do we return focus to the input. A possible other approach
    // would be to set context.redrawing = true on redraw and
    // set it to false in the blur event.
    (0, $1b218e9eae2bf5fa$export$af631764ddc44097)('blur', calEl, (0, $712229d871045015$export$7033eecc3ec7e0a5)(150, function() {
        if (!dp.hasFocus()) dp.close(true);
    }));
    (0, $1b218e9eae2bf5fa$export$af631764ddc44097)('keydown', el, function(e) {
        if (e.keyCode === (0, $1b218e9eae2bf5fa$export$cd0f44441c3b7719).enter) onClick(e);
        else dp.currentView().onKeyDown(e, dp);
    });
    // If the user clicks in non-focusable space, but
    // still within the date picker, we don't want to
    // hide, so we need to hack some things...
    (0, $1b218e9eae2bf5fa$export$af631764ddc44097)('mousedown', calEl, function(e) {
        e.target.focus && e.target.focus(); // IE hack
        if (document.activeElement !== e.target) {
            e.preventDefault();
            $6d828da9baecfeea$var$focusCurrent(dp);
        }
    });
    (0, $1b218e9eae2bf5fa$export$af631764ddc44097)('click', el, onClick);
}
function $6d828da9baecfeea$var$focusInput(input) {
    // When the modal closes, we need to focus the original input so the
    // user can continue tabbing from where they left off.
    input.focus();
    // iOS zonks out if we don't blur the input, so...
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) input.blur();
}


function $d3bd1ecc06a013a4$export$2e2bcd8739ae039(input, emit, opts) {
    var dp = (0, $6d828da9baecfeea$export$2e2bcd8739ae039)(input, emit, opts);
    // In modal mode, users really shouldn't be able to type in
    // the input, as all input is done via the calendar.
    input.readonly = true;
    // In modal mode, we need to know when the user has tabbed
    // off the end of the calendar, and set focus to the original
    // input. To do this, we add a special element to the DOM.
    // When the user tabs off the bottom of the calendar, they
    // will tab onto this element.
    dp.containerHTML += '<a href="#" class="dp-focuser">.</a>';
    return dp;
}


/**
 * @file Defines the dropdown date picker behavior.
 */ 
function $1c083861155a3802$export$2e2bcd8739ae039(input, emit, opts) {
    var dp = (0, $6d828da9baecfeea$export$2e2bcd8739ae039)(input, emit, opts);
    dp.shouldFocusOnBlur = false;
    Object.defineProperty(dp, 'shouldFocusOnRender', {
        get: function() {
            return input !== document.activeElement;
        }
    });
    dp.adjustPosition = function() {
        $1c083861155a3802$var$autoPosition(input, dp);
    };
    return dp;
}
function $1c083861155a3802$var$autoPosition(input, dp) {
    var inputPos = input.getBoundingClientRect();
    var win = window;
    $1c083861155a3802$var$adjustCalY(dp, inputPos, win);
    $1c083861155a3802$var$adjustCalX(dp, inputPos, win);
    dp.el.style.visibility = '';
}
function $1c083861155a3802$var$adjustCalX(dp, inputPos, win) {
    var cal = dp.el;
    var scrollLeft = win.pageXOffset;
    var inputLeft = inputPos.left + scrollLeft;
    var maxRight = win.innerWidth + scrollLeft;
    var offsetWidth = cal.offsetWidth;
    var calRight = inputLeft + offsetWidth;
    var shiftedLeft = maxRight - offsetWidth;
    var left = calRight > maxRight && shiftedLeft > 0 ? shiftedLeft : inputLeft;
    cal.style.left = left + 'px';
}
function $1c083861155a3802$var$adjustCalY(dp, inputPos, win) {
    var cal = dp.el;
    var scrollTop = win.pageYOffset;
    var inputTop = scrollTop + inputPos.top;
    var calHeight = cal.offsetHeight;
    var belowTop = inputTop + inputPos.height + 8;
    var aboveTop = inputTop - calHeight - 8;
    var isAbove = aboveTop > 0 && belowTop + calHeight > scrollTop + win.innerHeight;
    var top = isAbove ? aboveTop : belowTop;
    if (cal.classList) {
        cal.classList.toggle('dp-is-above', isAbove);
        cal.classList.toggle('dp-is-below', !isAbove);
    }
    cal.style.top = top + 'px';
}


/**
 * @file Defines the permanent date picker behavior.
 */ 

function $f09bd699a68b77b3$export$2e2bcd8739ae039(root, emit, opts) {
    var dp = (0, $6d828da9baecfeea$export$2e2bcd8739ae039)(root, emit, opts);
    dp.close = (0, $712229d871045015$export$8793edee2d425525);
    dp.updateInput = (0, $712229d871045015$export$8793edee2d425525);
    dp.shouldFocusOnRender = opts.shouldFocusOnRender;
    dp.computeSelectedDate = function() {
        return opts.hilightedDate;
    };
    dp.attachToDom = function() {
        root.appendChild(dp.el);
    };
    dp.open();
    return dp;
}


function $26160db66fe0dbd6$export$2e2bcd8739ae039(input, emit, opts) {
    input = input && input.tagName ? input : document.querySelector(input);
    if (opts.mode === 'dp-modal') return (0, $d3bd1ecc06a013a4$export$2e2bcd8739ae039)(input, emit, opts);
    if (opts.mode === 'dp-below') return (0, $1c083861155a3802$export$2e2bcd8739ae039)(input, emit, opts);
    if (opts.mode === 'dp-permanent') return (0, $f09bd699a68b77b3$export$2e2bcd8739ae039)(input, emit, opts);
}


/**
 * @file Defines simple event emitter behavior.
 */ /**
 * Emitter constructs a new emitter object which has on/off methods.
 *
 * @returns {EventEmitter}
 */ function $7a3534c391020e9b$export$2e2bcd8739ae039() {
    var handlers = {};
    function onOne(name, handler) {
        (handlers[name] = handlers[name] || []).push(handler);
    }
    function onMany(fns) {
        for(var name in fns)onOne(name, fns[name]);
    }
    return {
        on: function(name, handler) {
            if (handler) onOne(name, handler);
            else onMany(name);
            return this;
        },
        emit: function(name, arg) {
            (handlers[name] || []).forEach(function(handler) {
                handler(name, arg);
            });
        },
        off: function(name, handler) {
            if (!name) handlers = {};
            else if (!handler) handlers[name] = [];
            else handlers[name] = (handlers[name] || []).filter(function(h) {
                return h !== handler;
            });
            return this;
        }
    };
}



function $ce1e5b161faa04c4$export$5109c6dd95d8fb00(input, opts) {
    var emitter = (0, $7a3534c391020e9b$export$2e2bcd8739ae039)();
    var options = (0, $49b77b2b12375aa8$export$2e2bcd8739ae039)(opts);
    var mode = (0, $26160db66fe0dbd6$export$2e2bcd8739ae039)(input, emit, options);
    var me = {
        get state () {
            return mode.state;
        },
        on: emitter.on,
        off: emitter.off,
        setState: mode.setState,
        open: mode.open,
        close: mode.close,
        destroy: mode.destroy,
        isVisible: mode.isVisible
    };
    function emit(evt) {
        emitter.emit(evt, me);
    }
    return me;
}



var $7e905aba0f97004b$var$__assign = undefined && undefined.__assign || function() {
    $7e905aba0f97004b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e905aba0f97004b$var$__assign.apply(this, arguments);
};
var $7e905aba0f97004b$var$defaultOptions = {
    autoOpen: false,
    autoFocus: "input,button,textarea",
    closeOnOverlayClick: true,
    modal: true,
    closeOnEscape: true
};
var $7e905aba0f97004b$export$c1acf93689d2f351 = /** @class */ function() {
    function JSLDialog(el, options) {
        var _this = this;
        this.options = options;
        this.overlay = el;
        this.el = el.firstElementChild;
        if (this.options.closeOnOverlayClick) {
            this.overlay.addEventListener("mousedown", function(evt) {
                if (evt.target === _this.overlay) _this.close();
            });
            this.overlay.addEventListener("touchstart", function(evt) {
                if (evt.target === _this.overlay) _this.close();
            });
        }
    }
    JSLDialog.prototype.open = function(modal) {
        var _this = this;
        if (modal !== undefined && !modal || !this.options.modal) {
            this.overlay.style.background = "transparent";
            this.overlay.style.pointerEvents = "none";
        }
        this.overlay.style.display = "block";
        var $footer = this.el.querySelector(".dlg-footer");
        var $body = this.el.querySelector(".dlg-body");
        $footer != null && $body;
        if (this.options.autoFocus) setTimeout(function() {
            var firstInput = _this.el.querySelector(_this.options.autoFocus);
            if (firstInput != null) firstInput.focus();
        }, 0);
        if (this.options.closeOnEscape || this.options.OkOnEnter) {
            this.onKeydownEvent = function(args) {
                var _a;
                if (args.keyCode === 27 && _this.options.closeOnEscape) _this.close();
                else if (args.keyCode === 13 && _this.options.OkOnEnter) {
                    var ok_btn = _this.el.querySelector(".dlg-ok-btn");
                    if (ok_btn != null) {
                        (_a = document.activeElement) === null || _a === void 0 || _a.blur();
                        ok_btn.click();
                    }
                }
            };
            document.addEventListener("keydown", this.onKeydownEvent);
        }
        if (this.options.onOpen) this.options.onOpen();
    };
    JSLDialog.prototype.close = function() {
        if (this.options.onClose) {
            if (this.options.onClose() === false) return;
        }
        this.overlay.style.display = "none";
        if (this.onKeydownEvent != null) document.removeEventListener("keydown", this.onKeydownEvent);
    };
    JSLDialog.prototype.getOverlay = function() {
        return this.overlay;
    };
    return JSLDialog;
}();
function $7e905aba0f97004b$export$3ddf2d174ce01153(input, options) {
    var o = $7e905aba0f97004b$var$__assign($7e905aba0f97004b$var$__assign({}, $7e905aba0f97004b$var$defaultOptions), options);
    var el;
    if (typeof input === "string") el = document.querySelector(input);
    else el = input;
    var result = new $7e905aba0f97004b$export$c1acf93689d2f351(el, o);
    if (!o.autoOpen) el.style.display = "none";
    else result.open();
    return result;
}


/*!
 * Selectr 2.4.12
 * http://mobius.ovh/docs/selectr
 *
 * Released under the MIT license
 */ 
var $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208 = /** @class */ function() {
    function UILang() {}
    UILang.core = {
        All: "All",
        Ok: "Ok",
        Cancel: "Cancel"
    };
    UILang.grid = {
        Sort: "Sort",
        Asc: "Ascending",
        Desc: "Descending",
        Filter: "Filter",
        ClearFilter: "Clear Filter",
        Search: "Search"
    };
    UILang.dropDown = {
        SelectOption: "Select an option...",
        SelectOptionMultiple: "Enter options...",
        NoResults: "No results",
        NoOptions: "No options available",
        MaxSelection: "A maximum of {max} items can be selected",
        AlreadyInUse: "That tag is already in use",
        Search: "Search ..."
    };
    return UILang;
}();


var $17159033e823ecc2$var$Selectr;
(function() {
    /**
     * Event Emitter
     */ var Events = function() {};
    /**
     * Event Prototype
     * @type {Object}
     */ Events.prototype = {
        /**
         * Add custom event listener
         * @param  {String} event Event type
         * @param  {Function} func   Callback
         * @return {Void}
         */ on: function(event, func) {
            this._events = this._events || {};
            this._events[event] = this._events[event] || [];
            this._events[event].push(func);
        },
        /**
         * Remove custom event listener
         * @param  {String} event Event type
         * @param  {Function} func   Callback
         * @return {Void}
         */ off: function(event, func) {
            this._events = this._events || {};
            if (event in this._events === false) return;
            this._events[event].splice(this._events[event].indexOf(func), 1);
        },
        /**
         * Fire a custom event
         * @param  {String} event Event type
         * @return {Void}
         */ emit: function(event /* , args... */ ) {
            this._events = this._events || {};
            if (event in this._events === false) return;
            for(var i = 0; i < this._events[event].length; i++)this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
        }
    };
    /**
     * Event mixin
     * @param  {Object} obj
     * @return {Object}
     */ Events.mixin = function(obj) {
        var props = [
            'on',
            'off',
            'emit'
        ];
        for(var i = 0; i < props.length; i++)if (typeof obj === 'function') obj.prototype[props[i]] = Events.prototype[props[i]];
        else obj[props[i]] = Events.prototype[props[i]];
        return obj;
    };
    /**
     * Helpers
     * @type {Object}
     */ var util = {
        escapeRegExp: function(str) {
            // source from lodash 3.0.0
            var _reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
            var _reHasRegExpChar = new RegExp(_reRegExpChar.source);
            return str && _reHasRegExpChar.test(str) ? str.replace(_reRegExpChar, '\\$&') : str;
        },
        extend: function(src, props) {
            for(var prop in props)if (props.hasOwnProperty(prop)) {
                var val = props[prop];
                if (val && Object.prototype.toString.call(val) === "[object Object]") {
                    src[prop] = src[prop] || {};
                    util.extend(src[prop], val);
                } else src[prop] = val;
            }
            return src;
        },
        each: function(a, b, c) {
            if ("[object Object]" === Object.prototype.toString.call(a)) {
                for(var d in a)if (Object.prototype.hasOwnProperty.call(a, d)) b.call(c, d, a[d], a);
            } else for(var e = 0, f = a.length; e < f; e++)b.call(c, e, a[e], a);
        },
        createElement: function(e, a) {
            var d = document, el = d.createElement(e);
            if (a && "[object Object]" === Object.prototype.toString.call(a)) {
                var i;
                for(i in a)if (a[i] !== undefined) {
                    if (i in el) el[i] = a[i];
                    else if ("html" === i) el.innerHTML = a[i];
                    else el.setAttribute(i, a[i]);
                }
            }
            return el;
        },
        hasClass: function(a, b) {
            if (a) // if (a.classList == null) {
            //     debugger;
            // }
            return a.classList ? a.classList.contains(b) : !!a.className && !!a.className.match(new RegExp("(\\s|^)" + b + "(\\s|$)"));
        },
        addClass: function(a, b) {
            if (!util.hasClass(a, b)) {
                if (a.classList) a.classList.add(b);
                else a.className = a.className.trim() + " " + b;
            }
        },
        removeClass: function(a, b) {
            if (util.hasClass(a, b)) {
                if (a.classList) a.classList.remove(b);
                else a.className = a.className.replace(new RegExp("(^|\\s)" + b.split(" ").join("|") + "(\\s|$)", "gi"), " ");
            }
        },
        closest: function(el, fn) {
            return el && el !== document.body && (fn(el) ? el : util.closest(el.parentNode, fn));
        },
        isInt: function(val) {
            return typeof val === 'number' && isFinite(val) && Math.floor(val) === val;
        },
        debounce: function(a, b, c) {
            var d;
            return function() {
                var e = this, f = arguments, g = function() {
                    d = null;
                    if (!c) a.apply(e, f);
                }, h = c && !d;
                clearTimeout(d);
                d = setTimeout(g, b);
                if (h) a.apply(e, f);
            };
        },
        rect: function(el, abs) {
            var w = window;
            var r = el.getBoundingClientRect();
            var x = abs ? w.pageXOffset : 0;
            var y = abs ? w.pageYOffset : 0;
            return {
                bottom: r.bottom + y,
                height: r.height,
                left: r.left + x,
                right: r.right + x,
                top: r.top + y,
                width: r.width
            };
        },
        includes: function(a, b) {
            return a.indexOf(b) > -1;
        },
        startsWith: function(a, b) {
            return a.substr(0, b.length) === b;
        },
        truncate: function(el) {
            while(el.firstChild)el.removeChild(el.firstChild);
        },
        toDom: function(item) {
            var elementData = {
                class: "jsl-option",
                role: "treeitem",
                "aria-selected": false,
                html: item.html,
                textContent: item.html ? undefined : item.text
            };
            var opt = util.createElement("li", elementData);
            opt.idx = item.idx;
            if (item.disabled) {
                opt.disabled = true;
                util.addClass(opt, "disabled");
            }
            if (item.active) util.addClass(opt, "active");
            if (item.selected) {
                util.addClass(opt, "selected");
                opt.selected = true;
            }
            return opt;
        }
    };
    function isset(obj, prop) {
        return obj.hasOwnProperty(prop) && (obj[prop] === true || obj[prop].length);
    }
    /**
     * Append an item to the list
     * @param  {Object} item
     * @param  {Object} custom
     * @return {Void}
     */ function appendItem(vitem, parent, custom) {
        var item = vitem.dom = util.toDom(vitem);
        if (vitem.optgroup && vitem.optgroup.parentNode == null) parent.appendChild(vitem.optgroup);
        parent.appendChild(item);
        // if (item.parentNode) {
        //     if (!item.parentNode.parentNode) {
        //         parent.appendChild(item.parentNode);
        //     }
        // } else 
        // {
        //     parent.appendChild(item);
        // }
        // util.removeClass(item, "excluded");
        if (!custom) // remove any <span> highlighting, without xss
        item.textContent = item.textContent;
    }
    /**
     * Render the item list
     * @return {Void}
     */ var render = function() {
        if (this.items.length) {
            var f = document.createDocumentFragment();
            if (this.config.pagination) {
                var pages = this.pages.slice(0, this.pageIndex);
                util.each(pages, function(i, items) {
                    util.each(items, function(j, item) {
                        appendItem(item, f, this.customOption);
                    }, this);
                }, this);
            } else util.each(this.items, function(i, item) {
                appendItem(item, f, this.customOption);
            }, this);
            // highlight first selected option if any; first option otherwise
            if (f.childElementCount || f.childNodes.length) {
                removeActive(this.tree);
                this.navIndex = (f.querySelector(".jsl-option.selected") || f.querySelector(".jsl-option")).idx;
                if (!this.config.multiple) {
                    util.addClass(this.items[this.navIndex].dom, "active");
                    this.items[this.navIndex].active = true;
                }
            }
            this.tree.appendChild(f);
        }
    };
    /**
     * Dismiss / close the dropdown
     * @param  {obj} e
     * @return {void}
     */ var dismiss = function(e) {
        var target = e.target;
        if (!this.container.contains(target) && (this.opened || util.hasClass(this.container, "notice"))) this.close();
    };
    /**
     * Build a list item from the HTMLOptionElement
     * @param  {int} i      HTMLOptionElement index
     * @param  {HTMLOptionElement} option
     * @param  {bool} group  Has parent optgroup
     * @return {void}
     */ var createItem = function(option, data) {
        data = data || option;
        var elementData = {
            class: "jsl-option",
            role: "treeitem",
            "aria-selected": option.selected,
            html: undefined,
            textContent: undefined
        };
        if (this.customOption) elementData.html = this.config.renderOption(data); // asume xss prevention in custom render function
        else elementData.textContent = option.textContent; // treat all as plain text
        // var opt = util.createElement("li",elementData);
        var opt = {
            idx: 0,
            disabled: option.disabled,
            html: elementData.html,
            text: elementData.textContent,
            parent: null,
            selected: option.selected
        };
        opt.idx = option.idx;
        opt.parent = option.parent;
        this.items.push(opt);
        if (option.defaultSelected) this.defaultSelected.push(option.idx);
        // if (option.disabled) {
        //     opt.disabled = true;
        //     // util.addClass(opt, "disabled");
        // }
        // if (option.selected) {
        //     opt.selected = true;
        //     // util.addClass(opt, "selected");
        // }
        return opt;
    };
    var removeActive = function(container) {
        var items = container.querySelectorAll("li.active");
        for(var i = 0; i < items.length; i++)items[i].classList.remove("active");
    };
    /**
     * Build the container
     * @return {Void}
     */ var build = function() {
        this.requiresPagination = this.config.pagination && this.config.pagination > 0;
        // Set width
        if (isset(this.config, "width")) {
            if (util.isInt(this.config.width)) this.width = this.config.width + "px";
            else if (this.config.width === "auto") this.width = "100%";
            else this.width = this.config.width;
        }
        this.container = util.createElement("div", {
            class: "jsl-container"
        });
        // Custom className
        if (this.config.customClass) util.addClass(this.container, this.config.customClass);
        // Mobile device
        if (this.mobileDevice) util.addClass(this.container, "jsl-mobile");
        else util.addClass(this.container, "jsl-desktop");
        // Hide the HTMLSelectElement and prevent focus
        this.el.tabIndex = -1;
        // Native dropdown
        if (this.config.nativeDropdown || this.mobileDevice) util.addClass(this.el, "jsl-visible");
        else util.addClass(this.el, "jsl-hidden");
        this.selected = util.createElement("div", {
            class: "jsl-selected",
            disabled: this.disabled,
            tabIndex: 0,
            "aria-expanded": false
        });
        this.label = util.createElement(this.el.multiple ? "ul" : "span", {
            class: "jsl-label"
        });
        var dropdown = util.createElement("div", {
            class: "jsl-options-container"
        });
        this.tree = util.createElement("ul", {
            class: "jsl-options",
            role: "tree",
            "aria-hidden": true,
            "aria-expanded": false
        });
        this.notice = util.createElement("div", {
            class: "jsl-notice"
        });
        this.el.setAttribute("aria-hidden", true);
        if (this.disabled) this.el.disabled = true;
        if (this.el.multiple) {
            util.addClass(this.label, "jsl-tags");
            util.addClass(this.container, "multiple");
            // Collection of tags
            this.tags = [];
            // Collection of selected values
            // #93 defaultSelected = false did not work as expected
            this.selectedValues = this.config.defaultSelected ? this.getSelectedProperties('value') : [];
            // Collection of selected indexes
            this.selectedIndexes = this.getSelectedProperties('idx');
        } else {
            // #93 defaultSelected = false did not work as expected
            // these values were undefined
            this.selectedValue = null;
            this.selectedIndex = -1;
        }
        this.selected.appendChild(this.label);
        if (this.config.clearable) {
            this.selectClear = util.createElement("button", {
                class: "jsl-clear",
                type: "button"
            });
            this.container.appendChild(this.selectClear);
            util.addClass(this.container, "clearable");
        }
        if (this.config.taggable) {
            var li = util.createElement('li', {
                class: 'input-tag'
            });
            this.input = util.createElement("input", {
                class: "jsl-tag-input",
                placeholder: this.config.tagPlaceholder,
                tagIndex: 0,
                autocomplete: "off",
                autocorrect: "off",
                autocapitalize: "off",
                spellcheck: "false",
                role: "textbox",
                type: "search"
            });
            li.appendChild(this.input);
            this.label.appendChild(li);
            util.addClass(this.container, "taggable");
            this.tagSeperators = [
                ","
            ];
            if (this.config.tagSeperators) {
                this.tagSeperators = this.tagSeperators.concat(this.config.tagSeperators);
                var _aTempEscapedSeperators = [];
                for(var _nTagSeperatorStepCount = 0; _nTagSeperatorStepCount < this.tagSeperators.length; _nTagSeperatorStepCount++)_aTempEscapedSeperators.push(util.escapeRegExp(this.tagSeperators[_nTagSeperatorStepCount]));
                this.tagSeperatorsRegex = new RegExp(_aTempEscapedSeperators.join('|'), 'i');
            } else this.tagSeperatorsRegex = new RegExp(',', 'i');
        }
        if (this.config.searchable) {
            this.input = util.createElement("input", {
                class: "jsl-input",
                tagIndex: -1,
                autocomplete: "off",
                autocorrect: "off",
                autocapitalize: "off",
                spellcheck: "false",
                role: "textbox",
                // type: "search",
                type: "text",
                placeholder: this.config.messages.searchPlaceholder
            });
            this.inputClear = util.createElement("button", {
                class: "jsl-input-clear",
                type: "button"
            });
            this.inputContainer = util.createElement("div", {
                class: "jsl-input-container"
            });
            this.inputContainer.appendChild(this.input);
            this.inputContainer.appendChild(this.inputClear);
            dropdown.appendChild(this.inputContainer);
        }
        dropdown.appendChild(this.notice);
        dropdown.appendChild(this.tree);
        // List of items for the dropdown
        this.items = [];
        // Establish options
        this.options = [];
        // Check for options in the element
        if (this.el.options.length) this.options = [].slice.call(this.el.options);
        // Element may have optgroups so
        // iterate element.children instead of element.options
        var group = false, j = 0;
        if (this.el.children.length) util.each(this.el.children, function(i, element) {
            if (element.nodeName === "OPTGROUP") {
                group = util.createElement("ul", {
                    class: "jsl-optgroup",
                    role: "group",
                    html: "<li class='jsl-optgroup--label'>" + element.label + "</li>"
                });
                util.each(element.children, function(x, el) {
                    el.idx = j;
                    var itm = createItem.call(this, el, group);
                    itm.optgroup = group;
                    // group.appendChild(util.toDom(itm));
                    j++;
                }, this);
            } else {
                element.idx = j;
                createItem.call(this, element);
                j++;
            }
        }, this);
        // Options defined by the data option
        if (this.config.data && Array.isArray(this.config.data)) {
            this.data = [];
            var optgroup = false, option;
            group = false;
            j = 0;
            util.each(this.config.data, function(i, opt) {
                // Check for group options
                if (isset(opt, "children")) {
                    optgroup = util.createElement("optgroup", {
                        label: opt.text
                    });
                    group = util.createElement("ul", {
                        class: "jsl-optgroup",
                        role: "group",
                        html: "<li class='jsl-optgroup--label'>" + opt.text + "</li>"
                    });
                    util.each(opt.children, function(x, data) {
                        option = new Option(data.text, data.value, false, data.hasOwnProperty("selected") && data.selected === true);
                        option.disabled = isset(data, "disabled");
                        this.options.push(option);
                        optgroup.appendChild(option);
                        option.idx = j;
                        var itm = createItem.call(this, option, data);
                        itm.optgroup = group;
                        // group.appendChild(util.toDom(itm));
                        this.data[j] = data;
                        j++;
                    }, this);
                    this.el.appendChild(optgroup);
                } else {
                    option = new Option(opt.text, opt.value, false, opt.hasOwnProperty("selected") && opt.selected === true);
                    option.disabled = isset(opt, "disabled");
                    this.options.push(option);
                    option.idx = j;
                    createItem.call(this, option, opt);
                    this.data[j] = opt;
                    j++;
                }
            }, this);
        }
        this.setSelected(true);
        var first;
        this.navIndex = 0;
        for(var i = 0; i < this.items.length; i++){
            first = this.items[i];
            if (!first.disabled) {
                first.active = true;
                this.navIndex = i;
                break;
            }
        // if (!util.hasClass(first, "disabled")) {
        //     util.addClass(first, "active");
        //     this.navIndex = i;
        //     break;
        // }
        }
        // Check for pagination / infinite scroll
        this.pageIndex = 1;
        // Create the pages
        this.paginate();
        this.container.appendChild(this.selected);
        this.container.appendChild(dropdown);
        this.placeEl = util.createElement("div", {
            class: "jsl-placeholder"
        });
        // Set the placeholder
        this.setPlaceholder();
        this.selected.appendChild(this.placeEl);
        // Disable if required
        if (this.disabled) this.disable();
        this.el.parentNode.insertBefore(this.container, this.el);
        this.container.appendChild(this.el);
    };
    /**
     * Navigate through the dropdown
     * @param  {obj} e
     * @return {void}
     */ var navigate = function(e) {
        e = e || window.event;
        // Filter out the keys we don"t want
        if (!this.items.length || !this.opened || !util.includes([
            13,
            38,
            40
        ], e.which)) {
            this.navigating = false;
            return;
        }
        e.preventDefault();
        if (e.which === 13) {
            if (this.noResults || this.config.taggable && this.input.value.length > 0) return false;
            return this.change(this.navIndex);
        }
        var direction, prevEl = this.items[this.navIndex];
        var lastIndex = this.navIndex;
        switch(e.which){
            case 38:
                direction = 0;
                if (this.navIndex > 0) this.navIndex--;
                break;
            case 40:
                direction = 1;
                if (this.navIndex < this.items.length - 1) this.navIndex++;
        }
        this.navigating = true;
        function validForSelection(itm) {
            if (itm == null || itm.dom == null) return false;
            return !util.hasClass(itm.dom, "disabled") && !util.hasClass(itm.dom, "excluded");
        }
        // Instead of wasting memory holding a copy of this.items
        // with disabled / excluded options omitted, skip them instead
        // while (util.hasClass(this.items[this.navIndex], "disabled") || util.hasClass(this.items[this.navIndex], "excluded")) {
        while(!validForSelection(this.items[this.navIndex])){
            if (this.navIndex > 0 && this.navIndex < this.items.length - 1) {
                if (direction) this.navIndex++;
                else this.navIndex--;
            } else {
                this.navIndex = lastIndex;
                break;
            }
            if (this.searching) {
                if (this.navIndex > this.tree.lastElementChild.idx) {
                    this.navIndex = this.tree.lastElementChild.idx;
                    break;
                } else if (this.navIndex < this.tree.firstElementChild.idx) {
                    this.navIndex = this.tree.firstElementChild.idx;
                    break;
                }
            }
        }
        // Autoscroll the dropdown during navigation
        var r = util.rect(this.items[this.navIndex].dom);
        if (!direction) {
            if (this.navIndex === 0) this.tree.scrollTop = 0;
            else if (r.top - this.optsRect.top < 0) this.tree.scrollTop = this.tree.scrollTop + (r.top - this.optsRect.top);
        } else {
            if (this.navIndex === 0) this.tree.scrollTop = 0;
            else if (r.top + r.height > this.optsRect.top + this.optsRect.height) this.tree.scrollTop = this.tree.scrollTop + (r.top + r.height - (this.optsRect.top + this.optsRect.height));
            // Load another page if needed
            if (this.navIndex === this.tree.childElementCount - 1 && this.requiresPagination) load.call(this);
        }
        if (prevEl) {
            removeActive(this.tree);
            prevEl.active = false;
        }
        util.addClass(this.items[this.navIndex].dom, "active");
        this.items[this.navIndex].active = true;
    };
    /**
     * Add a tag
     * @param  {HTMLElement} item
     */ var addTag = function(item) {
        var that = this, r;
        var docFrag = document.createDocumentFragment();
        var option = this.options[item.idx];
        var data = this.data ? this.data[item.idx] : option;
        var elementData = {
            class: "jsl-tag",
            html: undefined,
            textContent: undefined
        };
        if (this.customSelected) elementData.html = this.config.renderSelection(data); // asume xss prevention in custom render function
        else elementData.textContent = option.textContent;
        var tag = util.createElement("li", elementData);
        var btn = util.createElement("button", {
            class: "jsl-tag-remove",
            type: "button"
        });
        tag.appendChild(btn);
        // Set property to check against later
        tag.idx = item.idx;
        tag.tag = option.value;
        this.tags.push(tag);
        if (this.config.sortSelected) {
            var tags = this.tags.slice();
            // Deal with values that contain numbers
            r = function(val, arr) {
                val.replace(/(\d+)|(\D+)/g, function(that, $1, $2) {
                    arr.push([
                        $1 || Infinity,
                        $2 || ""
                    ]);
                });
            };
            tags.sort(function(a, b) {
                var x = [], y = [], ac, bc;
                if (that.config.sortSelected === true) {
                    ac = a.tag;
                    bc = b.tag;
                } else if (that.config.sortSelected === 'text') {
                    ac = a.textContent;
                    bc = b.textContent;
                }
                r(ac, x);
                r(bc, y);
                while(x.length && y.length){
                    var ax = x.shift();
                    var by = y.shift();
                    var nn = ax[0] - by[0] || ax[1].localeCompare(by[1]);
                    if (nn) return nn;
                }
                return x.length - y.length;
            });
            util.each(tags, function(i, tg) {
                docFrag.appendChild(tg);
            });
            this.label.innerHTML = "";
        } else docFrag.appendChild(tag);
        if (this.config.taggable) this.label.insertBefore(docFrag, this.input.parentNode);
        else this.label.appendChild(docFrag);
    };
    /**
     * Remove a tag
     * @param  {HTMLElement} item
     * @return {void}
     */ var removeTag = function(item) {
        var tag = false;
        util.each(this.tags, function(i, t) {
            if (t.idx === item.idx) tag = t;
        }, this);
        if (tag) {
            this.label.removeChild(tag);
            this.tags.splice(this.tags.indexOf(tag), 1);
        }
    };
    /**
     * Load the next page of items
     * @return {void}
     */ var load = function() {
        // sometimes atBottom = false when atBottom < 0.xxx pixel smaller than "this.pageIndex < this.pages.length"
        var margin = 1; // solution: add a bit of margin
        var tree = this.tree;
        var scrollTop = tree.scrollTop;
        var scrollHeight = tree.scrollHeight;
        var offsetHeight = tree.offsetHeight;
        var atBottom = scrollTop + margin >= scrollHeight - offsetHeight;
        if (atBottom && this.pageIndex < this.pages.length) {
            var f = document.createDocumentFragment();
            util.each(this.pages[this.pageIndex], function(i, item) {
                appendItem(item, f, this.customOption);
            }, this);
            tree.appendChild(f);
            this.pageIndex++;
            this.emit("selectr.paginate", {
                items: this.items.length,
                total: this.data.length,
                page: this.pageIndex,
                pages: this.pages.length
            });
        }
    };
    /**
     * Clear a search
     * @return {void}
     */ var clearSearch = function() {
        this.searchResults = null;
        if (this.config.searchable || this.config.taggable) {
            this.input.value = null;
            this.searching = false;
            if (this.config.searchable) util.removeClass(this.inputContainer, "active");
            if (util.hasClass(this.container, "notice")) {
                util.removeClass(this.container, "notice");
                util.addClass(this.container, "open");
                this.input.focus();
            }
            util.each(this.items, function(i, item) {
                // Items that didn't match need the class
                // removing to make them visible again
                if (item.dom) util.removeClass(item.dom, "excluded");
                // Remove the span element for underlining matched items
                if (!this.customOption) // without xss
                item.textContent = item.textContent;
            }, this);
            this.pageIndex = 1;
            this.paginate();
        }
    };
    // /**
    //  * Query matching for searches.
    //  * Wraps matching text in a span.jsl-match.
    //  *
    //  * @param  {string} query
    //  * @param  {HTMLOptionElement} option element
    //  * @return {bool} true if matched; false otherwise
    //  */
    // var match = function (query, option) {
    //     var text = option.textContent;
    //     var RX = new RegExp(query, "ig");
    //     var result = RX.exec(text);
    //     if (result) {
    //         // #102 stop xss
    //         option.innerHTML = "";
    //         var span = document.createElement("span");
    //         span.classList.add("jsl-match");
    //         span.textContent = result[0];
    //         option.appendChild(document.createTextNode(text.substring(0, result.index)));
    //         option.appendChild(span);
    //         option.appendChild(document.createTextNode(text.substring(RX.lastIndex)));
    //         return true;
    //     }
    //     return false;
    // };
    // Main Lib
    $17159033e823ecc2$var$Selectr = function(el, config) {
        if (!el) throw new Error("You must supply either a HTMLSelectElement or a CSS3 selector string.");
        this.el = el;
        // CSS3 selector string
        if (typeof el === "string") this.el = document.querySelector(el);
        if (this.el === null) throw new Error("The element you passed to Selectr can not be found.");
        if (this.el.nodeName.toLowerCase() !== "select") throw new Error("The element you passed to Selectr is not a HTMLSelectElement.");
        this.render(config);
    };
    /**
     * Render the instance
     * @param  {object} config
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.render = function(config) {
        if (this.rendered) return;
        /**
         * Default configuration options
         * @type {Object}
         */ var defaultConfig = {
            /**
             * Emulates browser behaviour by selecting the first option by default
             * @type {Boolean}
             */ defaultSelected: true,
            /**
             * Sets the width of the container
             * @type {String}
             */ width: "auto",
            /**
             * Enables/ disables the container
             * @type {Boolean}
             */ disabled: false,
            /**
             * Enables/ disables logic for mobile
             * @type {Boolean}
             */ disabledMobile: true,
            /**
             * Enables / disables the search function
             * @type {Boolean}
             */ searchable: true,
            /**
             * Enable disable the clear button
             * @type {Boolean}
             */ clearable: false,
            /**
             * Sort the tags / multiselect options
             * @type {Boolean}
             */ sortSelected: false,
            /**
             * Allow deselecting of select-one options
             * @type {Boolean}
             */ allowDeselect: false,
            /**
             * Close the dropdown when scrolling (@AlexanderReiswich, #11)
             * @type {Boolean}
             */ closeOnScroll: false,
            /**
             * Allow the use of the native dropdown (@jonnyscholes, #14)
             * @type {Boolean}
             */ nativeDropdown: false,
            /**
             * Allow the use of native typing behavior for toggling, searching, selecting
             * @type {boolean}
             */ nativeKeyboard: false,
            /**
             * Set the main placeholder
             * @type {String}
             */ placeholder: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).dropDown.SelectOption,
            /**
             * Allow the tagging feature
             * @type {Boolean}
             */ taggable: false,
            /**
             * Set the tag input placeholder (@labikmartin, #21, #22)
             * @type {String}
             */ tagPlaceholder: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).dropDown.SelectOptionMultiple,
            messages: {
                noResults: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).dropDown.NoResults,
                noOptions: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).dropDown.NoOptions,
                maxSelections: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).dropDown.MaxSelection,
                tagDuplicate: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).dropDown.AlreadyInUse,
                searchPlaceholder: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).dropDown.Search
            }
        };
        // add instance reference (#87)
        this.el.selectr = this;
        // Merge defaults with user set config
        this.config = util.extend(defaultConfig, config);
        // Store type
        this.originalType = this.el.type;
        // Store tabIndex
        this.originalIndex = this.el.tabIndex;
        // Store defaultSelected options for form reset
        this.defaultSelected = [];
        // Store the original option count
        this.originalOptionCount = this.el.options.length;
        if (this.config.multiple || this.config.taggable) this.el.multiple = true;
        // Disabled?
        this.disabled = isset(this.config, "disabled");
        this.opened = false;
        if (this.config.taggable) this.config.searchable = false;
        this.navigating = false;
        this.mobileDevice = false;
        if (!this.config.disabledMobile && /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) this.mobileDevice = true;
        this.customOption = this.config.hasOwnProperty("renderOption") && typeof this.config.renderOption === "function";
        this.customSelected = this.config.hasOwnProperty("renderSelection") && typeof this.config.renderSelection === "function";
        this.supportsEventPassiveOption = this.detectEventPassiveOption();
        // Enable event emitter
        Events.mixin(this);
        build.call(this);
        this.bindEvents();
        this.update();
        this.optsRect = util.rect(this.tree);
        this.rendered = true;
        // Fixes macOS Safari bug #28
        if (!this.el.multiple) this.el.selectedIndex = this.selectedIndex;
        var that = this;
        setTimeout(function() {
            that.emit("selectr.init");
        }, 20);
    };
    $17159033e823ecc2$var$Selectr.prototype.getSelected = function() {
        var selected = this.el.querySelectorAll('option:checked');
        return selected;
    };
    $17159033e823ecc2$var$Selectr.prototype.getSelectedProperties = function(prop) {
        var selected = this.getSelected();
        var values = [].slice.call(selected).map(function(option) {
            return option[prop];
        }).filter(function(i) {
            return i !== null && i !== undefined;
        });
        return values;
    };
    /**
     * Feature detection: addEventListener passive option
     * https://dom.spec.whatwg.org/#dom-addeventlisteneroptions-passive
     * https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
     */ $17159033e823ecc2$var$Selectr.prototype.detectEventPassiveOption = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('test', null, opts);
        } catch (e) {}
        return supportsPassiveOption;
    };
    /**
     * Attach the required event listeners
     */ $17159033e823ecc2$var$Selectr.prototype.bindEvents = function() {
        var that = this;
        this.events = {};
        this.events.dismiss = dismiss.bind(this);
        this.events.navigate = navigate.bind(this);
        this.events.reset = this.reset.bind(this);
        if (this.config.nativeDropdown || this.mobileDevice) {
            this.container.addEventListener("touchstart", function(e) {
                if (e.changedTouches[0].target === that.el) that.toggle();
            }, this.supportsEventPassiveOption ? {
                passive: true
            } : false);
            this.container.addEventListener("click", function(e) {
                if (e.target === that.el) that.toggle();
            });
            var getChangedOptions = function(last, current) {
                var added = [], removed = last.slice(0);
                var idx;
                for(var i = 0; i < current.length; i++){
                    idx = removed.indexOf(current[i]);
                    if (idx > -1) removed.splice(idx, 1);
                    else added.push(current[i]);
                }
                return [
                    added,
                    removed
                ];
            };
            // Listen for the change on the native select
            // and update accordingly
            this.el.addEventListener("change", function(e) {
                if (e.__selfTriggered) return;
                if (that.el.multiple) {
                    var indexes = that.getSelectedProperties('idx');
                    var changes = getChangedOptions(that.selectedIndexes, indexes);
                    util.each(changes[0], function(i, idx) {
                        that.select(idx);
                    }, that);
                    util.each(changes[1], function(i, idx) {
                        that.deselect(idx);
                    }, that);
                } else if (that.el.selectedIndex > -1) that.select(that.el.selectedIndex);
            });
        }
        // Open the dropdown with Enter key if focused
        if (this.config.nativeDropdown) this.container.addEventListener("keydown", function(e) {
            if (e.key === "Enter" && that.selected === document.activeElement) {
                // show native dropdown
                that.toggle();
                // focus on it
                setTimeout(function() {
                    that.el.focus();
                }, 200);
            }
        });
        // Non-native dropdown
        this.selected.addEventListener("click", function(e) {
            if (!that.disabled) that.toggle();
            e.preventDefault();
        });
        if (this.config.nativeKeyboard) {
            var typing = '';
            var typingTimeout = null;
            this.selected.addEventListener("keydown", function(e) {
                // Do nothing if disabled, not focused, or modifier keys are pressed
                if (that.disabled || that.selected !== document.activeElement || e.altKey || e.ctrlKey || e.metaKey) return;
                // Open the dropdown on [enter], [ ], [↓], and [↑] keys
                if (e.key === " " || !that.opened && [
                    "Enter",
                    "ArrowUp",
                    "ArrowDown"
                ].indexOf(e.key) > -1) {
                    that.toggle();
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                // Type to search if multiple; type to select otherwise
                // make sure e.key is a single, printable character
                // .length check is a short-circut to skip checking keys like "ArrowDown", etc.
                // prefer "codePoint" methods; they work with the full range of unicode
                if (e.key.length <= 2 && String[String.fromCodePoint ? "fromCodePoint" : "fromCharCode"](e.key[String.codePointAt ? "codePointAt" : "charCodeAt"](0)) === e.key) {
                    if (that.config.multiple) {
                        that.open();
                        if (that.config.searchable) {
                            that.input.value = e.key;
                            that.input.focus();
                            that.search(null, that.options.exactSearch);
                        }
                    } else {
                        if (typingTimeout) clearTimeout(typingTimeout);
                        typing += e.key;
                        var found = that.search(typing, that.options.exactSearch);
                        if (found && found.length) {
                            that.clear();
                            that.setValue(found[0].value);
                        }
                        setTimeout(function() {
                            typing = '';
                        }, 1000);
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
            });
            // Close the dropdown on [esc] key
            this.container.addEventListener("keyup", function(e) {
                if (that.opened && e.key === "Escape") {
                    that.close();
                    e.stopPropagation();
                    // keep focus so we can re-open easily if desired
                    that.selected.focus();
                }
            });
        }
        // Remove tag
        this.label.addEventListener("click", function(e) {
            if (!that.disabled && util.hasClass(e.target, "jsl-tag-remove")) that.deselect(e.target.parentNode.idx);
        });
        // Clear input
        if (this.selectClear) this.selectClear.addEventListener("click", this.clear.bind(this));
        // Prevent text selection
        this.tree.addEventListener("mousedown", function(e) {
            e.preventDefault();
        });
        // Select / deselect items
        this.tree.addEventListener("click", function(e) {
            var item = util.closest(e.target, function(el) {
                return el && util.hasClass(el, "jsl-option");
            });
            if (item) {
                if (!util.hasClass(item, "disabled")) {
                    if (util.hasClass(item, "selected")) {
                        if (that.el.multiple || !that.el.multiple && that.config.allowDeselect) that.deselect(item.idx);
                    } else that.select(item.idx);
                    if (that.opened && !that.el.multiple) that.close();
                }
            }
            e.preventDefault();
            e.stopPropagation();
        });
        // Mouseover list items
        this.tree.addEventListener("mouseover", function(e) {
            if (util.hasClass(e.target, "jsl-option")) {
                if (!util.hasClass(e.target, "disabled")) {
                    removeActive(that.tree);
                    util.addClass(e.target, "active");
                    that.navIndex = -1;
                    for(var idx = 0; idx < that.items.length; idx++)if (that.items[idx].dom === e.target) that.navIndex = idx;
                // that.navIndex = [].slice.call(that.items).indexOf(e.target);
                }
            }
        });
        // Searchable
        if (this.config.searchable) {
            // Show / hide the search input clear button
            this.input.addEventListener("focus", function(e) {
                that.searching = true;
            });
            this.input.addEventListener("blur", function(e) {
                that.searching = false;
            });
            this.input.addEventListener("input", function(e) {
                that.search();
                if (!that.config.taggable) {
                    // Show / hide the search input clear button
                    if (this.value.length) util.addClass(this.parentNode, "active");
                    else util.removeClass(this.parentNode, "active");
                }
            });
            // Clear the search input
            this.inputClear.addEventListener("click", function(e) {
                that.input.value = null;
                clearSearch.call(that);
                if (!that.tree.childElementCount) render.call(that);
            });
        }
        if (this.config.taggable) this.input.addEventListener("keyup", function(e) {
            that.search();
            if (that.config.taggable && this.value.length) {
                var _sVal = this.value.trim();
                if (_sVal.length && (e.which === 13 || that.tagSeperatorsRegex.test(_sVal))) {
                    var _sGrabbedTagValue = _sVal.replace(that.tagSeperatorsRegex, '');
                    _sGrabbedTagValue = util.escapeRegExp(_sGrabbedTagValue);
                    _sGrabbedTagValue = _sGrabbedTagValue.trim();
                    var _oOption;
                    if (_sGrabbedTagValue.length) _oOption = that.add({
                        value: _sGrabbedTagValue,
                        textContent: _sGrabbedTagValue,
                        selected: true
                    }, true);
                    if (_oOption) {
                        that.close();
                        clearSearch.call(that);
                    } else {
                        this.value = '';
                        that.setMessage(that.config.messages.tagDuplicate);
                    }
                }
            }
        });
        this.update = util.debounce(function() {
            // Optionally close dropdown on scroll / resize (#11)
            if (that.opened && that.config.closeOnScroll) that.close();
            if (that.width) that.container.style.width = that.width;
            that.invert();
        }, 50);
        if (this.requiresPagination) {
            this.paginateItems = util.debounce(function() {
                load.call(this);
            }, 50);
            this.tree.addEventListener("scroll", this.paginateItems.bind(this));
        }
        // Dismiss when clicking outside the container
        document.addEventListener("click", this.events.dismiss);
        this.container.addEventListener("keydown", this.events.navigate);
        window.addEventListener("resize", this.update);
        window.addEventListener("scroll", this.update);
        // remove event listeners on destroy()
        this.on('selectr.destroy', function() {
            document.removeEventListener("click", this.events.dismiss);
            this.container.removeEventListener("keydown", this.events.navigate);
            window.removeEventListener("resize", this.update);
            window.removeEventListener("scroll", this.update);
        });
        // Listen for form.reset() (@ambrooks, #13)
        if (this.el.form) {
            this.el.form.addEventListener("reset", this.events.reset);
            // remove listener on destroy()
            this.on('selectr.destroy', function() {
                this.el.form.removeEventListener("reset", this.events.reset);
            });
        }
    };
    /**
     * Check for selected options
     * @param {bool} reset
     */ $17159033e823ecc2$var$Selectr.prototype.setSelected = function(reset) {
        // Select first option as with a native select-one element - #21, #24
        if (!this.config.data && !this.el.multiple && this.el.options.length) {
            // Browser has selected the first option by default
            if (this.el.selectedIndex === 0) {
                if (!this.el.options[0].defaultSelected && !this.config.defaultSelected) this.el.selectedIndex = -1;
            }
            this.selectedIndex = this.el.selectedIndex;
            if (this.selectedIndex > -1) this.select(this.selectedIndex);
        }
        // If we're changing a select-one to select-multiple via the config
        // and there are no selected options, the first option will be selected by the browser
        // Let's prevent that here.
        if (this.config.multiple && this.originalType === "select-one" && !this.config.data) {
            if (this.el.options[0].selected && !this.el.options[0].defaultSelected) this.el.options[0].selected = false;
        }
        util.each(this.options, function(i, option) {
            if (option.selected && option.defaultSelected) this.select(option.idx);
        }, this);
        if (this.config.selectedValue) this.setValue(this.config.selectedValue);
        if (this.config.data) {
            if (!this.el.multiple && this.config.defaultSelected && this.el.selectedIndex < 0 && this.config.data.length > 0) this.select(0);
            var j = 0;
            util.each(this.config.data, function(i, opt) {
                // Check for group options
                if (isset(opt, "children")) util.each(opt.children, function(x, item) {
                    if (item.hasOwnProperty("selected") && item.selected === true) this.select(j);
                    j++;
                }, this);
                else {
                    if (opt.hasOwnProperty("selected") && opt.selected === true) this.select(j);
                    j++;
                }
            }, this);
        }
    };
    /**
     * Destroy the instance
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.destroy = function() {
        if (!this.rendered) return;
        this.emit("selectr.destroy");
        // Revert to select-single if programtically set to multiple
        if (this.originalType === 'select-one') this.el.multiple = false;
        if (this.config.data) this.el.innerHTML = "";
        // Remove the className from select element
        util.removeClass(this.el, 'jsl-hidden');
        // Replace the container with the original select element
        this.container.parentNode.replaceChild(this.el, this.container);
        this.rendered = false;
        // remove reference
        delete this.el.selectr;
    };
    /**
     * Change an options state
     * @param  {Number} index
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.change = function(index) {
        var item = this.items[index], option = this.options[index];
        if (option.disabled) return;
        if (option.selected && util.hasClass(item, "selected")) this.deselect(index);
        else this.select(index);
        if (this.opened && !this.el.multiple) this.close();
    };
    /**
     * Select an option
     * @param  {Number} index
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.select = function(index) {
        var item = this.items[index], options = [].slice.call(this.el.options), option = this.options[index];
        if (this.el.multiple) {
            if (util.includes(this.selectedIndexes, index)) return false;
            if (this.config.maxSelections && this.tags.length === this.config.maxSelections) {
                this.setMessage(this.config.messages.maxSelections.replace("{max}", this.config.maxSelections), true);
                return false;
            }
            this.selectedValues.push(option.value);
            this.selectedIndexes.push(index);
            addTag.call(this, item);
        } else {
            var data = this.data ? this.data[index] : option;
            if (this.customSelected) this.label.innerHTML = this.config.renderSelection(data);
            else // no xss
            this.label.textContent = option.textContent;
            this.selectedValue = option.value;
            this.selectedIndex = index;
            util.each(this.options, function(i, o) {
                var opt = this.items[i];
                if (i !== index) {
                    if (o) {
                        util.removeClass(o, "selected");
                        o.removeAttribute("selected");
                    }
                    opt.selected = false;
                    opt.active = false;
                }
            }, this);
        }
        if (!util.includes(options, option)) this.el.add(option);
        item.selected = true;
        // item.dom.setAttribute("aria-selected", true);
        // util.addClass(item.dom, "selected");
        util.addClass(this.container, "has-selected");
        option.selected = true;
        option.setAttribute("selected", "");
        this.emit("selectr.change", option);
        this.emit("selectr.select", option);
        // fire native change event
        if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", true, true);
            evt.__selfTriggered = true;
            this.el.dispatchEvent(evt);
        } else this.el.fireEvent("onchange");
    };
    /**
     * Deselect an option
     * @param  {Number} index
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.deselect = function(index, force) {
        var item = this.items[index], option = this.options[index];
        if (this.el.multiple) {
            var selIndex = this.selectedIndexes.indexOf(index);
            this.selectedIndexes.splice(selIndex, 1);
            var valIndex = this.selectedValues.indexOf(option.value);
            this.selectedValues.splice(valIndex, 1);
            removeTag.call(this, item);
            if (!this.tags.length) util.removeClass(this.container, "has-selected");
        } else {
            if (!force && !this.config.clearable && !this.config.allowDeselect) return false;
            this.label.innerHTML = "";
            this.selectedValue = null;
            this.el.selectedIndex = this.selectedIndex = -1;
            util.removeClass(this.container, "has-selected");
        }
        this.items[index].selected = false;
        if (this.items[index].dom) {
            this.items[index].dom.setAttribute("aria-selected", false);
            util.removeClass(this.items[index].dom, "selected");
            this.items[index].dom.selected = false;
        }
        option.selected = false;
        option.removeAttribute("selected");
        this.emit("selectr.change", null);
        this.emit("selectr.deselect", option);
        // fire native change event
        if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", true, true);
            evt.__selfTriggered = true;
            this.el.dispatchEvent(evt);
        } else this.el.fireEvent("onchange");
    };
    /**
     * Programmatically set selected values
     * @param {String|Array} value - A string or an array of strings
     */ $17159033e823ecc2$var$Selectr.prototype.setValue = function(value) {
        var isArray = Array.isArray(value);
        if (!isArray) value = value.toString().trim();
        // Can't pass array to select-one
        if (!this.el.multiple && isArray) return false;
        util.each(this.options, function(i, option) {
            if (isArray && value.indexOf(option.value) > -1 || option.value === value) this.change(option.idx);
        }, this);
    };
    /**
     * Set the selected value(s)
     * @param  {bool} toObject Return only the raw values or an object
     * @param  {bool} toJson   Return the object as a JSON string
     * @return {mixed}         Array or String
     */ $17159033e823ecc2$var$Selectr.prototype.getValue = function(toObject, toJson) {
        var value;
        if (this.el.multiple) {
            if (toObject) {
                if (this.selectedIndexes.length) {
                    value = {};
                    value.values = [];
                    util.each(this.selectedIndexes, function(i, index) {
                        var option = this.options[index];
                        value.values[i] = {
                            value: option.value,
                            text: option.textContent
                        };
                    }, this);
                }
            } else value = this.selectedValues.slice();
        } else if (toObject) {
            var option = this.options[this.selectedIndex];
            value = {
                value: option.value,
                text: option.textContent
            };
        } else value = this.selectedValue;
        if (toObject && toJson) value = JSON.stringify(value);
        return value;
    };
    /**
     * Add a new option or options
     * @param {object} data
     */ $17159033e823ecc2$var$Selectr.prototype.add = function(data, checkDuplicate) {
        if (data) {
            this.data = this.data || [];
            this.items = this.items || [];
            this.options = this.options || [];
            if (Array.isArray(data)) // We have an array on items
            util.each(data, function(i, obj) {
                this.add(obj, checkDuplicate);
            }, this);
            else if ("[object Object]" === Object.prototype.toString.call(data)) {
                if (checkDuplicate) {
                    var dupe = false;
                    util.each(this.options, function(i, option) {
                        if (option.value.toLowerCase() === data.value.toLowerCase()) dupe = true;
                    });
                    if (dupe) return false;
                }
                var option = util.createElement('option', data);
                this.data.push(data);
                // Add the new option to the list
                this.options.push(option);
                // Add the index for later use
                option.idx = this.options.length > 0 ? this.options.length - 1 : 0;
                // Create a new item
                createItem.call(this, option);
                // Select the item if required
                if (data.selected) this.select(option.idx);
                // We may have had an empty select so update
                // the placeholder to reflect the changes.
                this.setPlaceholder();
                return option;
            }
            // Recount the pages
            if (this.config.pagination) this.paginate();
            return true;
        }
    };
    /**
     * Remove an option or options
     * @param  {Mixed} o Array, integer (index) or string (value)
     * @return {Void}
     */ $17159033e823ecc2$var$Selectr.prototype.remove = function(o) {
        var options = [];
        if (Array.isArray(o)) util.each(o, function(i, opt) {
            if (util.isInt(opt)) options.push(this.getOptionByIndex(opt));
            else if (typeof opt === "string") options.push(this.getOptionByValue(opt));
        }, this);
        else if (util.isInt(o)) options.push(this.getOptionByIndex(o));
        else if (typeof o === "string") options.push(this.getOptionByValue(o));
        if (options.length) {
            var index;
            util.each(options, function(i, option) {
                index = option.idx;
                // Remove the HTMLOptionElement
                this.el.remove(option);
                // Remove the reference from the option array
                this.options.splice(index, 1);
                // If the item has a parentNode (group element) it needs to be removed
                // otherwise the render function will still append it to the dropdown
                var parentNode = this.items[index].parentNode;
                if (parentNode) parentNode.removeChild(this.items[index]);
                // Remove reference from the items array
                this.items.splice(index, 1);
                // Reset the indexes
                util.each(this.options, function(i, opt) {
                    opt.idx = i;
                    this.items[i].idx = i;
                }, this);
            }, this);
            // We may have had an empty select now so update
            // the placeholder to reflect the changes.
            this.setPlaceholder();
            // Recount the pages
            if (this.config.pagination) this.paginate();
        }
    };
    /**
     * Remove all options
     */ $17159033e823ecc2$var$Selectr.prototype.removeAll = function() {
        // Clear any selected options
        this.clear(true);
        // Remove the HTMLOptionElements
        util.each(this.el.options, function(i, option) {
            this.el.remove(option);
        }, this);
        // Empty the dropdown
        util.truncate(this.tree);
        // Reset variables
        this.items = [];
        this.options = [];
        this.data = [];
        this.navIndex = 0;
        if (this.requiresPagination) {
            this.requiresPagination = false;
            this.pageIndex = 1;
            this.pages = [];
        }
        // Update the placeholder
        this.setPlaceholder();
    };
    /**
     * Perform a search
     * @param {string}|{null} query The query string (taken from user input if null)
     * @param {boolean} anchor Anchor search to beginning of strings (defaults to false)?
     * @return {Array} Search results, as an array of {text, value} objects
     */ $17159033e823ecc2$var$Selectr.prototype.search = function(string, anchor) {
        if (this.navigating) return;
        // we're only going to alter the DOM for "live" searches
        var live = false;
        if (!string) {
            string = this.input.value;
            live = true;
            // Remove message and clear dropdown
            this.removeMessage();
            util.truncate(this.tree);
        }
        var results = [];
        var f = document.createDocumentFragment();
        string = string.trim().toLowerCase();
        if (string.length > 0) {
            var compare = anchor ? util.startsWith : util.includes;
            var counter = 0;
            this.searchResults = [];
            util.each(this.options, function(i, option) {
                var item = this.items[option.idx];
                var matches = compare(option.textContent.trim().toLowerCase(), string);
                if (matches && !option.disabled) {
                    results.push({
                        text: option.textContent,
                        value: option.value
                    });
                    if (live) {
                        this.searchResults.push(item);
                        if (counter < 50) {
                            appendItem(item, f, this.customOption);
                            counter++;
                            util.removeClass(item.dom, "excluded");
                        }
                    // // Underline the matching results
                    // if (!this.customOption) {
                    //     match(string, option);
                    // }
                    }
                } else if (live && item.dom) util.addClass(item.dom, "excluded");
            }, this);
            if (live) {
                // Append results
                if (!f.childElementCount && !f.childNodes.length) {
                    if (!this.config.taggable) {
                        this.noResults = true;
                        this.setMessage(this.config.messages.noResults);
                    }
                } else {
                    // Highlight top result (@binary-koan #26)
                    var prevEl = this.items[this.navIndex];
                    var firstEl = f.querySelector(".jsl-option:not(.excluded)");
                    this.noResults = false;
                    removeActive(this.tree);
                    // prevEl.active = false;
                    this.navIndex = firstEl.idx;
                    util.addClass(firstEl, "active");
                }
                this.tree.appendChild(f);
            }
        } else {
            clearSearch.call(this);
            render.call(this);
            return [];
        }
        this.pageIndex = 1;
        this.paginate();
        return results;
    };
    /**
     * Toggle the dropdown
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.toggle = function() {
        if (!this.disabled) {
            if (this.opened) this.close();
            else this.open();
        }
    };
    /**
     * Open the dropdown
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.open = function() {
        var that = this;
        if (!this.options.length) return false;
        if (!this.opened) this.emit("selectr.open");
        this.opened = true;
        if (this.mobileDevice || this.config.nativeDropdown) {
            util.addClass(this.container, "native-open");
            if (this.config.data) // Dump the options into the select
            // otherwise the native dropdown will be empty
            util.each(this.options, function(i, option) {
                this.el.add(option);
            }, this);
            return;
        }
        util.addClass(this.container, "open");
        render.call(this);
        this.invert();
        this.tree.scrollTop = 0;
        util.removeClass(this.container, "notice");
        this.selected.setAttribute("aria-expanded", true);
        this.tree.setAttribute("aria-hidden", false);
        this.tree.setAttribute("aria-expanded", true);
        if (this.config.searchable && !this.config.taggable) setTimeout(function() {
            that.input.focus();
            // Allow tab focus
            that.input.tabIndex = 0;
        }, 10);
    };
    /**
     * Close the dropdown
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.close = function() {
        if (this.opened) this.emit("selectr.close");
        this.opened = false;
        this.navigating = false;
        if (this.mobileDevice || this.config.nativeDropdown) {
            util.removeClass(this.container, "native-open");
            return;
        }
        var notice = util.hasClass(this.container, "notice");
        if (this.config.searchable && !notice) {
            this.input.blur();
            // Disable tab focus
            this.input.tabIndex = -1;
            this.searching = false;
        }
        if (notice) {
            util.removeClass(this.container, "notice");
            this.notice.textContent = "";
        }
        util.removeClass(this.container, "open");
        util.removeClass(this.container, "native-open");
        this.selected.setAttribute("aria-expanded", false);
        this.tree.setAttribute("aria-hidden", true);
        this.tree.setAttribute("aria-expanded", false);
        util.truncate(this.tree);
        clearSearch.call(this);
    };
    /**
     * Enable the element
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.enable = function() {
        this.disabled = false;
        this.el.disabled = false;
        this.selected.tabIndex = this.originalIndex;
        if (this.el.multiple) util.each(this.tags, function(i, t) {
            t.lastElementChild.tabIndex = 0;
        });
        util.removeClass(this.container, "jsl-disabled");
    };
    /**
     * Disable the element
     * @param  {boolean} container Disable the container only (allow value submit with form)
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.disable = function(container) {
        if (!container) this.el.disabled = true;
        this.selected.tabIndex = -1;
        if (this.el.multiple) util.each(this.tags, function(i, t) {
            t.lastElementChild.tabIndex = -1;
        });
        this.disabled = true;
        util.addClass(this.container, "jsl-disabled");
    };
    /**
     * Reset to initial state
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.reset = function() {
        if (!this.disabled) {
            this.clear();
            this.setSelected(true);
            util.each(this.defaultSelected, function(i, idx) {
                this.select(idx);
            }, this);
            this.emit("selectr.reset");
        }
    };
    /**
     * Clear all selections
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.clear = function(force, isClearLast) {
        if (this.el.multiple) // Loop over the selectedIndexes so we don't have to loop over all the options
        // which can be costly if there are a lot of them
        {
            if (this.selectedIndexes.length) {
                // Copy the array or we'll get an error
                var indexes = this.selectedIndexes.slice();
                if (isClearLast) this.deselect(indexes.slice(-1)[0]);
                else util.each(indexes, function(i, idx) {
                    this.deselect(idx);
                }, this);
            }
        } else if (this.selectedIndex > -1) this.deselect(this.selectedIndex, force);
        this.emit("selectr.clear");
    };
    /**
     * Return serialised data
     * @param  {boolean} toJson
     * @return {mixed} Returns either an object or JSON string
     */ $17159033e823ecc2$var$Selectr.prototype.serialise = function(toJson) {
        var data = [];
        util.each(this.options, function(i, option) {
            var obj = {
                value: option.value,
                text: option.textContent,
                selected: undefined,
                disabled: undefined
            };
            if (option.selected) obj.selected = true;
            if (option.disabled) obj.disabled = true;
            data[i] = obj;
        });
        return toJson ? JSON.stringify(data) : data;
    };
    /**
     * Localised version of serialise() method
     */ $17159033e823ecc2$var$Selectr.prototype.serialize = function(toJson) {
        return this.serialise(toJson);
    };
    /**
     * Sets the placeholder
     * @param {String} placeholder
     */ $17159033e823ecc2$var$Selectr.prototype.setPlaceholder = function(placeholder) {
        // Set the placeholder
        placeholder = placeholder || this.config.placeholder || this.el.getAttribute("placeholder");
        if (!this.options.length) placeholder = this.config.messages.noOptions;
        this.placeEl.innerHTML = placeholder;
    };
    /**
     * Paginate the option list
     * @return {Array}
     */ $17159033e823ecc2$var$Selectr.prototype.paginate = function() {
        if (!this.requiresPagination) return;
        var items = this.searching ? this.searchResults : this.items;
        if (items.length) {
            var that = this;
            this.pages = items.map(function(v, i) {
                return i % that.config.pagination === 0 ? items.slice(i, i + that.config.pagination) : null;
            }).filter(function(pages) {
                return pages;
            });
            return this.pages;
        }
    };
    /**
     * Display a message
     * @param  {String} message The message
     */ $17159033e823ecc2$var$Selectr.prototype.setMessage = function(message, close) {
        if (close) this.close();
        util.addClass(this.container, "notice");
        this.notice.textContent = message;
    };
    /**
     * Dismiss the current message
     */ $17159033e823ecc2$var$Selectr.prototype.removeMessage = function() {
        util.removeClass(this.container, "notice");
        this.notice.innerHTML = "";
    };
    /**
     * Keep the dropdown within the window
     * @return {void}
     */ $17159033e823ecc2$var$Selectr.prototype.invert = function() {
        var rt = util.rect(this.selected), oh = this.tree.parentNode.offsetHeight, wh = window.innerHeight, doInvert = rt.top + rt.height + oh > wh;
        if (doInvert) {
            util.addClass(this.container, "inverted");
            this.isInverted = true;
        } else {
            util.removeClass(this.container, "inverted");
            this.isInverted = false;
        }
        this.optsRect = util.rect(this.tree);
    };
    /**
     * Get an option via it's index
     * @param  {Integer} index The index of the HTMLOptionElement required
     * @return {HTMLOptionElement}
     */ $17159033e823ecc2$var$Selectr.prototype.getOptionByIndex = function(index) {
        return this.options[index];
    };
    /**
     * Get an option via it's value
     * @param  {String} value The value of the HTMLOptionElement required
     * @return {HTMLOptionElement}
     */ $17159033e823ecc2$var$Selectr.prototype.getOptionByValue = function(value) {
        var option = false;
        for(var i = 0, l = this.options.length; i < l; i++)if (this.options[i].value.trim() === value.toString().trim()) {
            option = this.options[i];
            break;
        }
        return option;
    };
})();
var $17159033e823ecc2$export$e7fbc454eee05098 = function(input, config) {
    return new $17159033e823ecc2$var$Selectr(input, config);
};





var $c28d60ad53da98d2$var$__assign = undefined && undefined.__assign || function() {
    $c28d60ad53da98d2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c28d60ad53da98d2$var$__assign.apply(this, arguments);
};
var $c28d60ad53da98d2$var$defaultOptions = {
    format: "0.###",
    formatOnBlur: true,
    commitOnEnter: true,
    placeholder: false,
    enabled: true
};
function $c28d60ad53da98d2$export$6bf0cd3a219bbade(input, options) {
    var el;
    var o = $c28d60ad53da98d2$var$__assign($c28d60ad53da98d2$var$__assign({}, $c28d60ad53da98d2$var$defaultOptions), options);
    o.onChange = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(o.onChange);
    if (typeof input === "string") el = document.querySelector(input);
    else el = input;
    if (o.value || o.value === 0) el.value = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(o.value, o.format);
    if (o.placeholder !== false) {
        if (o.placeholder === true) el.placeholder = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(0, o.format);
        else el.placeholder = o.placeholder;
    }
    el.classList.add("jsl-number");
    if (o.enabled === false) el.setAttribute("disabled", "disabled");
    else {
        if (o.formatOnBlur) el.addEventListener("blur", function(evt) {
            var val = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(el.value);
            el.value = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(val, o.format);
        });
        if (o.onChange != null) el.addEventListener("change", function(evt) {
            o.onChange.notify((0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(el.value));
        });
        el.addEventListener("keydown", function(evt) {
            if (evt.which === 13) {
                if (o.formatOnBlur) {
                    var val = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(el.value);
                    el.value = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(val, o.format);
                }
                o.onChange.notify((0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(el.value));
            }
        });
    }
    return el;
}





var $c6f234831e4b5fa1$export$14834abbfce3b8cd = /** @class */ function() {
    function Notification() {}
    Notification.show = function(options) {
        var _a;
        if (Notification.container == null) Notification.createContainer();
        // add
        var notification = {
            tag: "div",
            attr: {
                id: (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newDomGuid(),
                style: options.style,
                class: "jsl-notification " + (options.class || "")
            },
            animation: {
                attr: "opacity",
                from: 0,
                to: 1,
                duration: 600
            },
            children: [
                typeof options.content === "string" ? {
                    tag: "div",
                    content: options.content
                } : options.content
            ]
        };
        Notification.containerVNode.children.push(notification);
        Notification.renderer.refresh();
        // remove
        if (options.timeOut) setTimeout(function() {
            var idx = Notification.containerVNode.children.indexOf(notification);
            if (idx >= 0) Notification.containerVNode.children.splice(idx, 1);
            Notification.renderer.refresh();
        }, options.timeOut);
        if (((_a = options.closeOnClick) !== null && _a !== void 0 ? _a : true) === true) notification.attr.click = function() {
            var idx = Notification.containerVNode.children.indexOf(notification);
            if (idx >= 0) Notification.containerVNode.children.splice(idx, 1);
        };
    };
    Notification.clearAll = function() {
        Notification.containerVNode.children = [];
        Notification.renderer.refresh();
    };
    Notification.createContainer = function() {
        Notification.container = document.createElement("div");
        document.body.appendChild(Notification.container);
        Notification.container.className = "jsl-notification-container";
        Notification.containerVNode = {
            tag: "div",
            children: []
        };
        Notification.renderer = new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(Notification.container, false);
        Notification.renderer.render(Notification.containerVNode);
    };
    return Notification;
}();



var $35f562d52ec6d8f1$export$846056739d2a3e0b = {
    "Event": $35f562d52ec6d8f1$var$Event,
    "EventData": $35f562d52ec6d8f1$var$EventData,
    "EventHandler": $35f562d52ec6d8f1$var$EventHandler,
    "Range": $35f562d52ec6d8f1$export$9a58ef0d7ad3278c,
    "NonDataRow": $35f562d52ec6d8f1$var$NonDataItem,
    "Group": $35f562d52ec6d8f1$var$Group,
    "GroupTotals": $35f562d52ec6d8f1$var$GroupTotals,
    "EditorLock": $35f562d52ec6d8f1$var$EditorLock,
    /***
     * A global singleton editor lock.
     * @class GlobalEditorLock
     * @static
     * @constructor
     */ "GlobalEditorLock": new $35f562d52ec6d8f1$var$EditorLock(),
    // "TreeColumns": TreeColumns,
    "keyCode": {
        SPACE: 8,
        BACKSPACE: 8,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        INSERT: 45,
        LEFT: 37,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        RIGHT: 39,
        TAB: 9,
        UP: 38,
        A: 65
    },
    "preClickClassName": "slick-edit-preclick",
    $: (0, $b96b48278b8efa92$export$f01a81549a0f632f)
};
/***
 * An event object for passing data to event handlers and letting them control propagation.
 * <p>This is pretty much identical to how W3C and jQuery implement events.</p>
 * @class EventData
 * @constructor
 */ function $35f562d52ec6d8f1$var$EventData() {
    var isPropagationStopped = false;
    var isImmediatePropagationStopped = false;
    /***
     * Stops event from propagating up the DOM tree.
     * @method stopPropagation
     */ this.stopPropagation = function() {
        isPropagationStopped = true;
    };
    /***
     * Returns whether stopPropagation was called on this event object.
     * @method isPropagationStopped
     * @return {Boolean}
     */ this.isPropagationStopped = function() {
        return isPropagationStopped;
    };
    /***
     * Prevents the rest of the handlers from being executed.
     * @method stopImmediatePropagation
     */ this.stopImmediatePropagation = function() {
        isImmediatePropagationStopped = true;
    };
    /***
     * Returns whether stopImmediatePropagation was called on this event object.\
     * @method isImmediatePropagationStopped
     * @return {Boolean}
     */ this.isImmediatePropagationStopped = function() {
        return isImmediatePropagationStopped;
    };
}
/***
 * A simple publisher-subscriber implementation.
 * @class Event
 * @constructor
 */ function $35f562d52ec6d8f1$var$Event() {
    var handlers = [];
    /***
     * Adds an event handler to be called when the event is fired.
     * <p>Event handler will receive two arguments - an <code>EventData</code> and the <code>data</code>
     * object the event was fired with.<p>
     * @method subscribe
     * @param fn {Function} Event handler.
     */ this.subscribe = function(fn) {
        handlers.push(fn);
    };
    this.countHandlers = function() {
        return handlers.length;
    };
    /***
     * Removes an event handler added with <code>subscribe(fn)</code>.
     * @method unsubscribe
     * @param fn {Function} Event handler to be removed.
     */ this.unsubscribe = function(fn) {
        for(var i = handlers.length - 1; i >= 0; i--)if (handlers[i] === fn) handlers.splice(i, 1);
    };
    /***
     * Fires an event notifying all subscribers.
     * @method notify
     * @param args {Object} Additional data object to be passed to all handlers.
     * @param e {EventData}
     *      Optional.
     *      An <code>EventData</code> object to be passed to all handlers.
     *      For DOM events, an existing W3C/jQuery event object can be passed in.
     * @param scope {Object}
     *      Optional.
     *      The scope ("this") within which the handler will be executed.
     *      If not specified, the scope will be set to the <code>Event</code> instance.
     */ this.notify = function(args, e, scope) {
        e = e || new $35f562d52ec6d8f1$var$EventData();
        scope = scope || this;
        var returnValue;
        for(var i = 0; i < handlers.length && !(e.isPropagationStopped && e.isPropagationStopped() || e.isImmediatePropagationStopped && e.isImmediatePropagationStopped()); i++)returnValue = handlers[i].call(scope, e, args);
        return returnValue;
    };
}
function $35f562d52ec6d8f1$var$EventHandler() {
    var handlers = [];
    this.subscribe = function(event, handler) {
        handlers.push({
            event: event,
            handler: handler
        });
        event.subscribe(handler);
        return this; // allow chaining
    };
    this.unsubscribe = function(event, handler) {
        var i = handlers.length;
        while(i--)if (handlers[i].event === event && handlers[i].handler === handler) {
            handlers.splice(i, 1);
            event.unsubscribe(handler);
            return;
        }
        return this; // allow chaining
    };
    this.unsubscribeAll = function() {
        var i = handlers.length;
        while(i--)handlers[i].event.unsubscribe(handlers[i].handler);
        handlers = [];
        return this; // allow chaining
    };
}
function $35f562d52ec6d8f1$export$9a58ef0d7ad3278c(fromRow, fromCell, toRow, toCell) {
    if (toRow === undefined && toCell === undefined) {
        toRow = fromRow;
        toCell = fromCell;
    }
    /***
     * @property fromRow
     * @type {Integer}
     */ this.fromRow = Math.min(fromRow, toRow);
    /***
     * @property fromCell
     * @type {Integer}
     */ this.fromCell = Math.min(fromCell, toCell);
    /***
     * @property toRow
     * @type {Integer}
     */ this.toRow = Math.max(fromRow, toRow);
    /***
     * @property toCell
     * @type {Integer}
     */ this.toCell = Math.max(fromCell, toCell);
    /***
     * Returns whether a range represents a single row.
     * @method isSingleRow
     * @return {Boolean}
     */ this.isSingleRow = function() {
        return this.fromRow == this.toRow;
    };
    /***
     * Returns whether a range represents a single cell.
     * @method isSingleCell
     * @return {Boolean}
     */ this.isSingleCell = function() {
        return this.fromRow == this.toRow && this.fromCell == this.toCell;
    };
    /***
     * Returns whether a range contains a given cell.
     * @method contains
     * @param row {Integer}
     * @param cell {Integer}
     * @return {Boolean}
     */ this.contains = function(row, cell) {
        return row >= this.fromRow && row <= this.toRow && cell >= this.fromCell && cell <= this.toCell;
    };
    /***
     * Returns a readable representation of a range.
     * @method toString
     * @return {String}
     */ this.toString = function() {
        if (this.isSingleCell()) return "(" + this.fromRow + ":" + this.fromCell + ")";
        else return "(" + this.fromRow + ":" + this.fromCell + " - " + this.toRow + ":" + this.toCell + ")";
    };
}
/***
 * A base class that all special / non-data rows (like Group and GroupTotals) derive from.
 * @class NonDataItem
 * @constructor
 */ function $35f562d52ec6d8f1$var$NonDataItem() {
    this.__nonDataRow = true;
}
/***
 * Information about a group of rows.
 * @class Group
 * @extends Slick.NonDataItem
 * @constructor
 */ function $35f562d52ec6d8f1$var$Group() {
    this.__group = true;
    /**
     * Grouping level, starting with 0.
     * @property level
     * @type {Number}
     */ this.level = 0;
    /***
     * Number of rows in the group.
     * @property count
     * @type {Integer}
     */ this.count = 0;
    /***
     * Grouping value.
     * @property value
     * @type {Object}
     */ this.value = null;
    /***
     * Formatted display value of the group.
     * @property title
     * @type {String}
     */ this.title = null;
    /***
     * Whether a group is collapsed.
     * @property collapsed
     * @type {Boolean}
     */ this.collapsed = false;
    /***
     * Whether a group selection checkbox is checked.
     * @property selectChecked
     * @type {Boolean}
     */ this.selectChecked = false;
    /***
     * GroupTotals, if any.
     * @property totals
     * @type {GroupTotals}
     */ this.totals = null;
    /**
     * Rows that are part of the group.
     * @property rows
     * @type {Array}
     */ this.rows = [];
    /**
     * Sub-groups that are part of the group.
     * @property groups
     * @type {Array}
     */ this.groups = null;
    /**
     * A unique key used to identify the group.  This key can be used in calls to DataView
     * collapseGroup() or expandGroup().
     * @property groupingKey
     * @type {Object}
     */ this.groupingKey = null;
}
$35f562d52ec6d8f1$var$Group.prototype = new $35f562d52ec6d8f1$var$NonDataItem();
/***
 * Compares two Group instances.
 * @method equals
 * @return {Boolean}
 * @param group {Group} Group instance to compare to.
 */ $35f562d52ec6d8f1$var$Group.prototype.equals = function(group) {
    return this.value === group.value && this.count === group.count && this.collapsed === group.collapsed && this.title === group.title;
};
/***
 * Information about group totals.
 * An instance of GroupTotals will be created for each totals row and passed to the aggregators
 * so that they can store arbitrary data in it.  That data can later be accessed by group totals
 * formatters during the display.
 * @class GroupTotals
 * @extends Slick.NonDataItem
 * @constructor
 */ function $35f562d52ec6d8f1$var$GroupTotals() {
    this.__groupTotals = true;
    /***
     * Parent Group.
     * @param group
     * @type {Group}
     */ this.group = null;
    /***
     * Whether the totals have been fully initialized / calculated.
     * Will be set to false for lazy-calculated group totals.
     * @param initialized
     * @type {Boolean}
     */ this.initialized = false;
}
$35f562d52ec6d8f1$var$GroupTotals.prototype = new $35f562d52ec6d8f1$var$NonDataItem();
/***
 * A locking helper to track the active edit controller and ensure that only a single controller
 * can be active at a time.  This prevents a whole class of state and validation synchronization
 * issues.  An edit controller (such as SlickGrid) can query if an active edit is in progress
 * and attempt a commit or cancel before proceeding.
 * @class EditorLock
 * @constructor
 */ function $35f562d52ec6d8f1$var$EditorLock() {
    var activeEditController = null;
    /***
     * Returns true if a specified edit controller is active (has the edit lock).
     * If the parameter is not specified, returns true if any edit controller is active.
     * @method isActive
     * @param editController {EditController}
     * @return {Boolean}
     */ this.isActive = function(editController) {
        return editController ? activeEditController === editController : activeEditController !== null;
    };
    /***
     * Sets the specified edit controller as the active edit controller (acquire edit lock).
     * If another edit controller is already active, and exception will be throw new Error(.
     * @method activate
     * @param editController {EditController} edit controller acquiring the lock
     */ this.activate = function(editController) {
        if (editController === activeEditController) return;
        if (activeEditController !== null) throw new Error("SlickGrid.EditorLock.activate: an editController is still active, can't activate another editController");
        if (!editController.commitCurrentEdit) throw new Error("SlickGrid.EditorLock.activate: editController must implement .commitCurrentEdit()");
        if (!editController.cancelCurrentEdit) throw new Error("SlickGrid.EditorLock.activate: editController must implement .cancelCurrentEdit()");
        activeEditController = editController;
    };
    /***
     * Unsets the specified edit controller as the active edit controller (release edit lock).
     * If the specified edit controller is not the active one, an exception will be throw new Error(.
     * @method deactivate
     * @param editController {EditController} edit controller releasing the lock
     */ this.deactivate = function(editController) {
        if (activeEditController !== editController) throw new Error("SlickGrid.EditorLock.deactivate: specified editController is not the currently active one");
        activeEditController = null;
    };
    /***
     * Attempts to commit the current edit by calling "commitCurrentEdit" method on the active edit
     * controller and returns whether the commit attempt was successful (commit may fail due to validation
     * errors, etc.).  Edit controller's "commitCurrentEdit" must return true if the commit has succeeded
     * and false otherwise.  If no edit controller is active, returns true.
     * @method commitCurrentEdit
     * @return {Boolean}
     */ this.commitCurrentEdit = function() {
        return activeEditController ? activeEditController.commitCurrentEdit() : true;
    };
    /***
     * Attempts to cancel the current edit by calling "cancelCurrentEdit" method on the active edit
     * controller and returns whether the edit was successfully cancelled.  If no edit controller is
     * active, returns true.
     * @method cancelCurrentEdit
     * @return {Boolean}
     */ this.cancelCurrentEdit = function cancelCurrentEdit() {
        return activeEditController ? activeEditController.cancelCurrentEdit() : true;
    };
} // /**
 //  *
 //  * @param {Array} treeColumns Array com levels of columns
 //  * @returns {{hasDepth: 'hasDepth', getTreeColumns: 'getTreeColumns', extractColumns: 'extractColumns', getDepth: 'getDepth', getColumnsInDepth: 'getColumnsInDepth', getColumnsInGroup: 'getColumnsInGroup', visibleColumns: 'visibleColumns', filter: 'filter', reOrder: reOrder}}
 //  * @constructor
 //  */
 // function TreeColumns(treeColumns) {
 //   var columnsById = {};
 //   function init() {
 //     mapToId(treeColumns);
 //   }
 //   function mapToId(columns) {
 //     columns
 //       .forEach(function (column) {
 //         columnsById[column.id] = column;
 //         if (column.columns) {
 //           mapToId(column.columns);
 //         }
 //       });
 //   }
 //   function filter(node, condition) {
 //     return node.filter(function (column) {
 //       var valid = condition.call(column);
 //       if (valid && column.columns) {
 //         column.columns = filter(column.columns, condition);
 //       }
 //       return valid && (!column.columns || column.columns.length);
 //     });
 //   }
 //   function sort(columns, grid) {
 //     columns
 //       .sort(function (a, b) {
 //         var indexA = getOrDefault(grid.getColumnIndex(a.id)),
 //           indexB = getOrDefault(grid.getColumnIndex(b.id));
 //         return indexA - indexB;
 //       })
 //       .forEach(function (column) {
 //         if (column.columns) {
 //           sort(column.columns, grid);
 //         }
 //       });
 //   }
 //   function getOrDefault(value) {
 //     return typeof value === "undefined" ? -1 : value;
 //   }
 //   function getDepth(node) {
 //     if (node.length) {
 //       for (var i in node)
 //         return getDepth(node[i]);
 //     }
 //     else if (node.columns) {
 //       return 1 + getDepth(node.columns);
 //     }
 //     else {
 //       return 1;
 //     }
 //   }
 //   function getColumnsInDepth(node: any[], depth: number, current?: number) {
 //     var columns = [];
 //     current = current || 0;
 //     if (depth == current) {
 //       if (node.length) {
 //         node.forEach(function (n) {
 //           if (n.columns)
 //             n.extractColumns = function () {
 //               return extractColumns(n);
 //             };
 //         });
 //       }
 //       return node;
 //     } else {
 //       for (var i in node) {
 //         if (node[i].columns) {
 //           columns = columns.concat(getColumnsInDepth(node[i].columns, depth, current + 1));
 //         }
 //       }
 //     }
 //     return columns;
 //   }
 //   function extractColumns(node) {
 //     var result = [];
 //     if (node.hasOwnProperty("length")) {
 //       for (var i = 0; i < node.length; i++) {
 //         result = result.concat(extractColumns(node[i]));
 //       }
 //     } else {
 //       if (node.hasOwnProperty("columns")) {
 //         result = result.concat(extractColumns(node.columns));
 //       } else {
 //         return node;
 //       }
 //     }
 //     return result;
 //   }
 //   function cloneTreeColumns() {
 //     return (<any>window).Slick.$.shallowExtend([], treeColumns);
 //   }
 //   init();
 //   this.hasDepth = function () {
 //     for (var i in treeColumns) {
 //       if (treeColumns[i].hasOwnProperty('columns'))
 //         return true;
 //     }
 //     return false;
 //   };
 //   this.getTreeColumns = function () {
 //     return treeColumns;
 //   };
 //   this.extractColumns = function () {
 //     return this.hasDepth() ? extractColumns(treeColumns) : treeColumns;
 //   };
 //   this.getDepth = function () {
 //     return getDepth(treeColumns);
 //   };
 //   this.getColumnsInDepth = function (depth) {
 //     return getColumnsInDepth(treeColumns, depth);
 //   };
 //   this.getColumnsInGroup = function (groups) {
 //     return extractColumns(groups);
 //   };
 //   this.visibleColumns = function () {
 //     return filter(cloneTreeColumns(), function () {
 //       return this.visible;
 //     });
 //   };
 //   this.filter = function (condition) {
 //     return filter(cloneTreeColumns(), condition);
 //   };
 //   this.reOrder = function (grid) {
 //     return sort(treeColumns, grid);
 //   };
 //   this.getById = function (id) {
 //     return columnsById[id];
 //   };
 //   this.getInIds = function (ids) {
 //     return ids.map(function (id) {
 //       return columnsById[id];
 //     });
 //   };
 // }
 // (<any>window).Slick = Slick;



/**
 * @license
 * (c) 2009-2016 Michael Leibman
 * michael{dot}leibman{at}gmail{dot}com
 * http://github.com/mleibman/slickgrid
 *
 * Distributed under MIT license.
 * All rights reserved.
 *
 * SlickGrid v2.4
 */ 




var $7adda6f44168d508$var$$ = (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).$;
$7adda6f44168d508$var$$.deepExtend((0, $35f562d52ec6d8f1$export$846056739d2a3e0b), {
    Grid: $7adda6f44168d508$export$e8193cfe09a919d1
});
// shared across all grids on the page
var $7adda6f44168d508$var$scrollbarDimensions;
var $7adda6f44168d508$var$maxSupportedCssHeight; // = 500000;  // browser's breaking point
function $7adda6f44168d508$export$e8193cfe09a919d1(container, data, columns, options) {
    // settings
    var defaults = {
        // syncColumnCellResize: true, // TODO: remove this option
        alwaysShowVerticalScroll: false,
        alwaysShowHorizontalScroll: false,
        alwaysAllowHorizontalScroll: false,
        explicitInitialization: false,
        rowHeight: 28,
        defaultColumnWidth: 80,
        enableAddRow: false,
        leaveSpaceForNewRows: false,
        editable: false,
        autoEdit: true,
        suppressActiveCellChangeOnEdit: false,
        enableCellNavigation: true,
        enableColumnReorder: true,
        asyncEditorLoading: false,
        asyncEditorLoadDelay: 100,
        forceFitColumns: false,
        enableAsyncPostRender: false,
        asyncPostRenderDelay: 50,
        enableAsyncPostRenderCleanup: false,
        asyncPostRenderCleanupDelay: 40,
        autoHeight: false,
        editorLock: (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).GlobalEditorLock,
        showHeaderRow: false,
        headerRowHeight: 28,
        createFooterRow: false,
        showFooterRow: false,
        footerRowHeight: 28,
        createPreHeaderPanel: false,
        showPreHeaderPanel: false,
        preHeaderPanelHeight: 28,
        showTopPanel: false,
        topPanelHeight: 28,
        formatterFactory: null,
        editorFactory: null,
        cellFlashingCssClass: "flashing",
        selectedCellCssClass: "selected",
        multiSelect: true,
        enableTextSelectionOnCells: false,
        dataItemColumnValueExtractor: null,
        frozenBottom: false,
        frozenColumn: -1,
        frozenRow: -1,
        fullWidthRows: false,
        multiColumnSort: false,
        numberedMultiColumnSort: false,
        tristateMultiColumnSort: false,
        sortColNumberInSeparateSpan: false,
        defaultFormatter: defaultFormatter,
        forceSyncScrolling: false,
        addNewRowCssClass: "new-row",
        preserveCopiedSelectionOnPaste: false,
        showCellSelection: true,
        viewportClass: null,
        minRowBuffer: 3,
        emulatePagingWhenScrolling: true,
        editorCellNavOnLRKeys: false,
        doPaging: true,
        resizeDelta: 2,
        dragDelta: 3
    };
    var columnDefaults = {
        name: "",
        resizable: true,
        sortable: false,
        minWidth: 30,
        width: undefined,
        rerenderOnResize: false,
        headerCssClass: null,
        defaultSortAsc: true,
        focusable: true,
        selectable: true
    };
    // scroller
    var th; // virtual height
    var h; // real scrollable height
    var ph; // page height
    var n; // number of pages
    var cj; // "jumpiness" coefficient
    var page = 0; // current page
    var offset = 0; // current page offset
    var vScrollDir = 1;
    // var programmaticScrollingTimeout;
    // private
    var initialized = false;
    var $container;
    var uid = "slickgrid_" + Math.round(1000000 * Math.random());
    var self = this;
    var $focusSink, $focusSink2;
    var $groupHeaders = $7adda6f44168d508$var$$();
    var $headerScroller;
    var $headers;
    var $headerRow, $headerRowScroller, $headerRowSpacerL, $headerRowSpacerR;
    var $footerRow, $footerRowScroller, $footerRowSpacerL, $footerRowSpacerR;
    var $preHeaderPanel, $preHeaderPanelScroller, $preHeaderPanelSpacer;
    var $preHeaderPanelR, $preHeaderPanelScrollerR, $preHeaderPanelSpacerR;
    var $topPanelScroller;
    var $topPanel;
    var $viewport;
    var $canvas;
    var $style;
    var $boundAncestors;
    // var treeColumns;
    var stylesheet, columnCssRulesL, columnCssRulesR;
    var viewportH, viewportW;
    var canvasWidth, canvasWidthL, canvasWidthR;
    var headersWidth, headersWidthL, headersWidthR;
    var viewportHasHScroll, viewportHasVScroll;
    var headerColumnWidthDiff = 0, headerColumnHeightDiff = 0, cellWidthDiff = 0, cellHeightDiff = 0, jQueryNewWidthBehaviour = false;
    var absoluteColumnMinWidth;
    var hasFrozenRows = false;
    var frozenRowsHeight = 0;
    var actualFrozenRow = -1;
    var paneTopH = 0;
    var paneBottomH = 0;
    var viewportTopH = 0;
    var viewportBottomH = 0;
    var topPanelH = 0;
    var headerRowH = 0;
    var footerRowH = 0;
    var tabbingDirection = 1;
    var $activeCanvasNode;
    var $activeViewportNode;
    var activePosX;
    var activeRow, activeCell;
    var activeCellNode = null;
    var currentEditor = null;
    var serializedEditorValue;
    var editController;
    var rowsCache = {};
    var rowPositionCache = [];
    var renderedRows = 0;
    var numVisibleRows = 0;
    var prevScrollTop = 0;
    var scrollTop = 0;
    var lastRenderedScrollTop = 0;
    var lastRenderedScrollLeft = 0;
    var prevScrollLeft = 0;
    var scrollLeft = 0;
    var selectionModel;
    var selectedRows = [];
    var plugins = [];
    var cellCssClasses = {};
    var columnsById = {};
    var sortColumns = [];
    var columnPosLeft = [];
    var columnPosRight = [];
    var pagingActive = false;
    var pagingIsLastPage = false;
    var scrollThrottle = ActionThrottle(render, 50);
    // async call handles
    var h_editorLoader = null;
    var h_render = null;
    var h_postrender = null;
    var h_postrenderCleanup = null;
    var postProcessedRows = {};
    var postProcessToRow = null;
    var postProcessFromRow = null;
    var postProcessedCleanupQueue = [];
    var postProcessgroupId = 0;
    var $paneHeaderL;
    var $paneHeaderR;
    var $paneTopL;
    var $paneTopR;
    var $paneBottomL;
    var $paneBottomR;
    var $headerScrollerL;
    var $headerScrollerR;
    var $headerL;
    var $headerR;
    var $groupHeadersL;
    var $groupHeadersR;
    var $headerRowScrollerL;
    var $headerRowScrollerR;
    var $footerRowScrollerL;
    var $footerRowScrollerR;
    var $headerRowL;
    var $headerRowR;
    var $footerRowL;
    var $footerRowR;
    var $topPanelScrollerL;
    var $topPanelScrollerR;
    var $topPanelL;
    var $topPanelR;
    var $viewportTopL;
    var $viewportTopR;
    var $viewportBottomL;
    var $viewportBottomR;
    var $canvasTopL;
    var $canvasTopR;
    var $canvasBottomL;
    var $canvasBottomR;
    var $viewportScrollContainerX;
    var $viewportScrollContainerY;
    var $headerScrollContainer;
    var $headerRowScrollContainer;
    var $footerRowScrollContainer;
    var scrollEventHandler;
    // store css attributes if display:none is active in container or parent
    var cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    };
    var $hiddenParents;
    var oldProps = [];
    // var columnResizeDragging = false;
    // var columnDragging = false;
    //////////////////////////////////////////////////////////////////////////////////////////////
    // initialization
    function init() {
        $container = $7adda6f44168d508$var$$(container);
        if ($container.length < 1) throw new Error("SlickGrid requires a valid container, " + container + " does not exist in the DOM.");
        if (options.showFooterRow && !options.createFooterRow) throw new Error("option showFooterRow requires option createFooterRow to be set");
        cacheCssForHiddenInit();
        // calculate these only once and share between grid instances
        $7adda6f44168d508$var$maxSupportedCssHeight = $7adda6f44168d508$var$maxSupportedCssHeight || getMaxSupportedCssHeight();
        options = $7adda6f44168d508$var$$.shallowExtend({}, defaults, options);
        validateAndEnforceOptions();
        columnDefaults.width = options.defaultColumnWidth;
        // treeColumns = new Slick.TreeColumns(columns);
        // columns = treeColumns.extractColumns();
        updateColumnProps();
        //// validate loaded JavaScript modules against requested options
        // if (options.enableColumnReorder && !$.fn.sortable) {
        //  throw new Error("SlickGrid's 'enableColumnReorder = true' option requires jquery-ui.sortable module to be loaded");
        // }
        editController = {
            "commitCurrentEdit": commitCurrentEdit,
            "cancelCurrentEdit": cancelCurrentEdit
        };
        $container.empty().css("overflow", "hidden").css("outline", 0).addClass(uid).addClass("slickgrid").addClass("ui-widget");
        var isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
        if (isTouch) $container.addClass("js-touch");
        // $container.addClass("js-touch");
        // set up a positioning container if needed
        if (!/relative|absolute|fixed/.test($container.css("position"))) $container.css("position", "relative");
        $focusSink = $7adda6f44168d508$var$$("<div tabIndex='0' hideFocus style='position:fixed;width:0;height:0;top:0;left:0;outline:0;'></div>").appendTo($container);
        // containers used for scrolling frozen columns and rows
        $paneHeaderL = $7adda6f44168d508$var$$("<div class='slick-pane slick-pane-header slick-pane-left' tabIndex='0' />").appendTo($container);
        $paneHeaderR = $7adda6f44168d508$var$$("<div class='slick-pane slick-pane-header slick-pane-right' tabIndex='0' />").appendTo($container);
        $paneTopL = $7adda6f44168d508$var$$("<div class='slick-pane slick-pane-top slick-pane-left' tabIndex='0' />").appendTo($container);
        $paneTopR = $7adda6f44168d508$var$$("<div class='slick-pane slick-pane-top slick-pane-right' tabIndex='0' />").appendTo($container);
        $paneBottomL = $7adda6f44168d508$var$$("<div class='slick-pane slick-pane-bottom slick-pane-left' tabIndex='0' />").appendTo($container);
        $paneBottomR = $7adda6f44168d508$var$$("<div class='slick-pane slick-pane-bottom slick-pane-right' tabIndex='0' />").appendTo($container);
        if (options.createPreHeaderPanel) {
            $preHeaderPanelScroller = $7adda6f44168d508$var$$("<div class='slick-preheader-panel ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($paneHeaderL);
            $preHeaderPanel = $7adda6f44168d508$var$$("<div />").appendTo($preHeaderPanelScroller);
            $preHeaderPanelSpacer = $7adda6f44168d508$var$$("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").appendTo($preHeaderPanelScroller);
            $preHeaderPanelScrollerR = $7adda6f44168d508$var$$("<div class='slick-preheader-panel ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($paneHeaderR);
            $preHeaderPanelR = $7adda6f44168d508$var$$("<div />").appendTo($preHeaderPanelScrollerR);
            $preHeaderPanelSpacerR = $7adda6f44168d508$var$$("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").appendTo($preHeaderPanelScrollerR);
            if (!options.showPreHeaderPanel) {
                $preHeaderPanelScroller[0].style.display = "none";
                $preHeaderPanelScrollerR[0].style.display = "none";
            }
        }
        // append the header scroller containers
        $headerScrollerL = $7adda6f44168d508$var$$("<div class='slick-header ui-state-default slick-header-left' />").appendTo($paneHeaderL);
        $headerScrollerR = $7adda6f44168d508$var$$("<div class='slick-header ui-state-default slick-header-right' />").appendTo($paneHeaderR);
        // cache the header scroller containers
        $headerScroller = $7adda6f44168d508$var$$().add($headerScrollerL).add($headerScrollerR);
        $groupHeaders = $7adda6f44168d508$var$$();
        // if (treeColumns.hasDepth()) {
        //   $groupHeadersL = [], $groupHeadersR = [];
        //   for (var index = 0; index < treeColumns.getDepth() - 1; index++) {
        //     $groupHeadersL[index] = $("<div class='slick-group-header-columns slick-group-header-columns-left' style='left:-1000px' />").appendTo($headerScrollerL);
        //     $groupHeadersR[index] = $("<div class='slick-group-header-columns slick-group-header-columns-right' style='left:-1000px' />").appendTo($headerScrollerR);
        //     $groupHeaders.add($groupHeadersL[index]).add($groupHeadersR[index]);
        //   }
        // }
        // append the columnn containers to the headers
        var headerL = document.createElement("div");
        headerL.className = "slick-header-columns slick-header-columns-left";
        headerL.style.left = "-1000px";
        var headerR = document.createElement("div");
        headerR.className = "slick-header-columns slick-header-columns-right";
        headerR.style.left = "-1000px";
        $headerL = $7adda6f44168d508$var$$(headerL).appendTo($headerScrollerL);
        $headerR = $7adda6f44168d508$var$$(headerR).appendTo($headerScrollerR);
        // cache the header columns
        $headers = $7adda6f44168d508$var$$().add($headerL).add($headerR);
        $headers.on("selectstart", function(event) {
            event.preventDefault();
        });
        var headerRowScrollerL = document.createElement("div");
        headerRowScrollerL.className = "slick-headerrow ui-state-default";
        var headerRowScrollerR = document.createElement("div");
        headerRowScrollerR.className = "slick-headerrow ui-state-default";
        $headerRowScrollerL = $7adda6f44168d508$var$$(headerRowScrollerL).appendTo($paneTopL);
        $headerRowScrollerR = $7adda6f44168d508$var$$(headerRowScrollerR).appendTo($paneTopR);
        $headerRowScroller = $7adda6f44168d508$var$$().add($headerRowScrollerL).add($headerRowScrollerR);
        var headerRowSpacerL = document.createElement("div");
        headerRowSpacerL.style.display = "block";
        headerRowSpacerL.style.height = "1px";
        headerRowSpacerL.style.left = "0";
        headerRowSpacerL.style.top = "0";
        headerRowSpacerL.style.position = "absolute";
        var headerRowSpacerR = document.createElement("div");
        headerRowSpacerR.style.display = "block";
        headerRowSpacerR.style.height = "1px";
        headerRowSpacerR.style.left = "0";
        headerRowSpacerR.style.top = "0";
        headerRowSpacerR.style.position = "absolute";
        $headerRowSpacerL = $7adda6f44168d508$var$$(headerRowSpacerL).appendTo($headerRowScrollerL);
        $headerRowSpacerR = $7adda6f44168d508$var$$(headerRowSpacerR).appendTo($headerRowScrollerR);
        var headerRowL = document.createElement("div");
        headerRowL.className = "slick-headerrow-columns slick-headerrow-columns-left";
        var headerRowR = document.createElement("div");
        headerRowR.className = "slick-headerrow-columns slick-headerrow-columns-right";
        $headerRowL = $7adda6f44168d508$var$$(headerRowL).appendTo($headerRowScrollerL);
        $headerRowR = $7adda6f44168d508$var$$(headerRowR).appendTo($headerRowScrollerR);
        $headerRow = $7adda6f44168d508$var$$().add($headerRowL).add($headerRowR);
        // append the top panel scroller
        var topPanelScrollerL = document.createElement("div");
        topPanelScrollerL.className = "slick-top-panel-scroller ui-state-default";
        var topPanelScrollerR = document.createElement("div");
        topPanelScrollerR.className = "slick-top-panel-scroller ui-state-default";
        $topPanelScrollerL = $7adda6f44168d508$var$$(topPanelScrollerL).appendTo($paneTopL);
        $topPanelScrollerR = $7adda6f44168d508$var$$(topPanelScrollerR).appendTo($paneTopR);
        $topPanelScroller = $7adda6f44168d508$var$$().add($topPanelScrollerL).add($topPanelScrollerR);
        // append the top panel
        $topPanelL = $7adda6f44168d508$var$$("<div class='slick-top-panel' style='width:10000px' />").appendTo($topPanelScrollerL);
        $topPanelR = $7adda6f44168d508$var$$("<div class='slick-top-panel' style='width:10000px' />").appendTo($topPanelScrollerR);
        $topPanel = $7adda6f44168d508$var$$().add($topPanelL).add($topPanelR);
        if (!options.showTopPanel) $7adda6f44168d508$var$$.each($topPanelScroller, function(idx, el) {
            el.style.display = "none";
        });
        if (!options.showHeaderRow) $7adda6f44168d508$var$$.each($headerRowScroller, function(idx, el) {
            el.style.display = "none";
        });
        // append the viewport containers
        $viewportTopL = $7adda6f44168d508$var$$("<div class='slick-viewport slick-viewport-top slick-viewport-left' tabIndex='0' hideFocus />").appendTo($paneTopL);
        $viewportTopR = $7adda6f44168d508$var$$("<div class='slick-viewport slick-viewport-top slick-viewport-right' tabIndex='0' hideFocus />").appendTo($paneTopR);
        $viewportBottomL = $7adda6f44168d508$var$$("<div class='slick-viewport slick-viewport-bottom slick-viewport-left' tabIndex='0' hideFocus />").appendTo($paneBottomL);
        $viewportBottomR = $7adda6f44168d508$var$$("<div class='slick-viewport slick-viewport-bottom slick-viewport-right' tabIndex='0' hideFocus />").appendTo($paneBottomR);
        // cache the viewports
        $viewport = $7adda6f44168d508$var$$().add($viewportTopL).add($viewportTopR).add($viewportBottomL).add($viewportBottomR);
        // default the active viewport to the top left
        $activeViewportNode = $viewportTopL;
        // append the canvas containers
        $canvasTopL = $7adda6f44168d508$var$$("<div class='grid-canvas grid-canvas-top grid-canvas-left' tabIndex='0' hideFocus />").appendTo($viewportTopL);
        $canvasTopR = $7adda6f44168d508$var$$("<div class='grid-canvas grid-canvas-top grid-canvas-right' tabIndex='0' hideFocus />").appendTo($viewportTopR);
        $canvasBottomL = $7adda6f44168d508$var$$("<div class='grid-canvas grid-canvas-bottom grid-canvas-left' tabIndex='0' hideFocus />").appendTo($viewportBottomL);
        $canvasBottomR = $7adda6f44168d508$var$$("<div class='grid-canvas grid-canvas-bottom grid-canvas-right' tabIndex='0' hideFocus />").appendTo($viewportBottomR);
        if (options.viewportClass) $viewport.toggleClass(options.viewportClass, true);
        // cache the canvases
        $canvas = $7adda6f44168d508$var$$().add($canvasTopL).add($canvasTopR).add($canvasBottomL).add($canvasBottomR);
        $7adda6f44168d508$var$scrollbarDimensions = $7adda6f44168d508$var$scrollbarDimensions || measureScrollbar();
        // default the active canvas to the top left
        $activeCanvasNode = $canvasTopL;
        // pre-header
        if ($preHeaderPanelSpacer) $preHeaderPanelSpacer.css("width", getCanvasWidth() + $7adda6f44168d508$var$scrollbarDimensions.width + "px");
        $headers.width(getHeadersWidth());
        $headerRowSpacerL.css("width", getCanvasWidth() + $7adda6f44168d508$var$scrollbarDimensions.width + "px");
        $headerRowSpacerR.css("width", getCanvasWidth() + $7adda6f44168d508$var$scrollbarDimensions.width + "px");
        // footer Row
        if (options.createFooterRow) {
            $footerRowScrollerR = $7adda6f44168d508$var$$("<div class='slick-footerrow ui-state-default' />").appendTo($paneTopR);
            $footerRowScrollerL = $7adda6f44168d508$var$$("<div class='slick-footerrow ui-state-default' />").appendTo($paneTopL);
            $footerRowScroller = $7adda6f44168d508$var$$().add($footerRowScrollerL).add($footerRowScrollerR);
            $footerRowSpacerL = $7adda6f44168d508$var$$("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").css("width", getCanvasWidth() + $7adda6f44168d508$var$scrollbarDimensions.width + "px").appendTo($footerRowScrollerL);
            $footerRowSpacerR = $7adda6f44168d508$var$$("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").css("width", getCanvasWidth() + $7adda6f44168d508$var$scrollbarDimensions.width + "px").appendTo($footerRowScrollerR);
            $footerRowL = $7adda6f44168d508$var$$("<div class='slick-footerrow-columns slick-footerrow-columns-left' />").appendTo($footerRowScrollerL);
            $footerRowR = $7adda6f44168d508$var$$("<div class='slick-footerrow-columns slick-footerrow-columns-right' />").appendTo($footerRowScrollerR);
            $footerRow = $7adda6f44168d508$var$$().add($footerRowL).add($footerRowR);
            if (!options.showFooterRow) $7adda6f44168d508$var$$.each($footerRowScroller, function(idx, el) {
                el.style.display = "none";
            });
        }
        $focusSink2 = $7adda6f44168d508$var$$($focusSink[0].cloneNode(true)).appendTo($container);
        if (!options.explicitInitialization) finishInitialization();
    }
    function finishInitialization() {
        if (!initialized) {
            initialized = true;
            getViewportWidth();
            getViewportHeight();
            // header columns and cells may have different padding/border skewing width calculations (box-sizing, hello?)
            // calculate the diff so we can set consistent sizes
            measureCellPaddingAndBorder();
            // for usability reasons, all text selection in SlickGrid is disabled
            // with the exception of input and textarea elements (selection must
            // be enabled there so that editors work as expected); note that
            // selection in grid cells (grid body) is already unavailable in
            // all browsers except IE
            disableSelection($headers); // disable all text selection in header (including input and textarea)
            if (!options.enableTextSelectionOnCells) // disable text selection in grid cells except in input and textarea elements
            // (this is IE-specific, because selectstart event will only fire in IE)
            $viewport.on("selectstart", function(event) {
                if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
            });
            cacheRowPositions();
            setFrozenOptions();
            setPaneVisibility();
            setScroller();
            setOverflow();
            updateColumnCaches();
            createColumnHeaders();
            // createColumnGroupHeaders();
            createColumnFooter();
            setupColumnSort();
            setupColumnMoveAndResize();
            createCssRules();
            resizeCanvas();
            bindAncestorScrollEvents();
            $container.on("resize", resizeCanvas);
            $viewport.on("scroll", handleScroll);
            // tODO !!! TODOFIX
            // if (jQuery.fn.mousewheel) {
            //  $viewport.on("mousewheel", handleMouseWheel);
            // }
            $headerScroller.on("scroll", preventScroll) // .on("scroll", handleHeaderScroll)
            .on("contextmenu", handleHeaderContextMenu).on("click", handleHeaderClick);
            $headerRowScroller.on("scroll", preventScroll);
            if (options.createFooterRow) $footerRowScroller.on("scroll", preventScroll);
            if (options.createPreHeaderPanel) $preHeaderPanelScroller.on("scroll", preventScroll);
            // $headerRowScroller
            //   .on("scroll", handleHeaderRowScroll);
            // if (options.createFooterRow) {
            //   $footerRowScroller
            //     .on("scroll", handleFooterRowScroll);
            // }
            // if (options.createPreHeaderPanel) {
            //   $preHeaderPanelScroller
            //     .on("scroll", handlePreHeaderPanelScroll);
            // }
            $focusSink.add($focusSink2).on("keydown", handleKeyDown);
            $canvas.on("keydown", handleKeyDown).on("click", handleClick).on("dblclick", handleDblClick).on("contextmenu", handleContextMenu);
            // ---- BEGIN
            var dragStartX_1;
            var dragStartY_1;
            var isDown_1;
            var dragStartedDD_1 = null;
            var delta_1 = 3;
            // $canvas.on("touchstart", function (e, dd) {
            //   handleDragInit(e, dd);
            //   // TODO
            // });
            var _down = function(e, dd) {
                handleDragInit(e, dd); // TODO -> do something with result?
                dragStartX_1 = e.pageX != null ? e.pageX : e.touches[0].pageX;
                dragStartY_1 = e.pageY != null ? e.pageY : e.touches[0].pageY;
                isDown_1 = true;
                document.addEventListener("mouseup", handleUp_1);
                document.addEventListener("touchend", handleUp_1);
            };
            $canvas.on("mousedown", _down);
            $canvas.on("touchstart", _down);
            var _move = function(e, _dd) {
                if (isDown_1) {
                    var pageX_1 = e.pageX != null ? e.pageX : e.touches[0].pageX;
                    var pageY = e.pageY != null ? e.pageY : e.touches[0].pageY;
                    if (Math.abs(dragStartX_1 - pageX_1) < delta_1 && Math.abs(dragStartY_1 - pageY) < delta_1) return;
                    if (dragStartedDD_1 == null) {
                        dragStartedDD_1 = {};
                        dragStartedDD_1.dragging = null;
                        dragStartedDD_1.propagates = 1;
                        dragStartedDD_1.target = e.target;
                        dragStartedDD_1.pageX = pageX_1;
                        dragStartedDD_1.pageY = pageY;
                        dragStartedDD_1.startX = dragStartedDD_1.pageX;
                        dragStartedDD_1.startY = dragStartedDD_1.pageY;
                        var res = handleDragStart(e, dragStartedDD_1); // TODO -> do something with result?
                    }
                    dragStartedDD_1.pageX = pageX_1;
                    dragStartedDD_1.pageY = pageY;
                    dragStartedDD_1.startX = dragStartedDD_1.pageX;
                    dragStartedDD_1.startY = dragStartedDD_1.pageY;
                    handleDrag(e, dragStartedDD_1);
                    // e.stopImmediatePropagation();
                    // e.stopPropagation();
                    if (e.isImmediatePropagationStopped && e.isImmediatePropagationStopped()) e.preventDefault();
                }
            };
            $canvas.on("mousemove", _move);
            $canvas.on("touchmove", _move);
            var handleUp_1 = function(e) {
                if (isDown_1 && dragStartedDD_1 != null) handleDragEnd(e, dragStartedDD_1);
                isDown_1 = false;
                dragStartedDD_1 = null;
                document.removeEventListener("mouseup", handleUp_1);
                document.removeEventListener("touchend", handleUp_1);
            };
            // .on("draginit", handleDragInit) //TODO TODOFIX
            // .on("dragstart", {distance: 3}, handleDragStart) //TODO TODOFIX
            // .on("drag", handleDrag) //TODO TODOFIX
            // .on("dragend", handleDragEnd); //TODO TODOFIX
            // .on("mouseenter", ".slick-cell", handleMouseEnter) //TODO TODOFIX
            // .on("mouseleave", ".slick-cell", handleMouseLeave); //TODO TODOFIX
            restoreCssFromHiddenInit();
        }
    }
    function cacheCssForHiddenInit() {
        // handle display:none on container or container parents
        var all_parents = $7adda6f44168d508$var$$().add($container).add($container[0].parentElement);
        var hiddenParents = [];
        $hiddenParents = $7adda6f44168d508$var$$();
        for(var i = 0; i < all_parents.length; i++)if ((all_parents[i].display || "").toLowerCase() === "none") {
            hiddenParents.push(all_parents[i]);
            $hiddenParents.add(all_parents[i]);
        }
        hiddenParents.forEach(function(p) {
            var old = {};
            for(var name in cssShow){
                old[name] = p.style[name];
                p.style[name] = cssShow[name];
            }
            oldProps.push(old);
        });
    }
    function restoreCssFromHiddenInit() {
        // finish handle display:none on container or container parents
        // - put values back the way they were
        $7adda6f44168d508$var$$.each($hiddenParents, function(i) {
            var old = oldProps[i];
            for(var name in cssShow)this.style[name] = old[name];
        });
    }
    function hasFrozenColumns() {
        return options.frozenColumn > -1;
    }
    function registerPlugin(plugin) {
        plugins.unshift(plugin);
        plugin.init(self);
    }
    function unregisterPlugin(plugin) {
        for(var i = plugins.length; i >= 0; i--)if (plugins[i] === plugin) {
            if (plugins[i].destroy) plugins[i].destroy();
            plugins.splice(i, 1);
            break;
        }
    }
    function getPluginByName(name) {
        for(var i = plugins.length - 1; i >= 0; i--){
            if (plugins[i].pluginName === name) return plugins[i];
        }
        return undefined;
    }
    function setSelectionModel(model) {
        if (selectionModel) {
            selectionModel.onSelectedRangesChanged.unsubscribe(handleSelectedRangesChanged);
            if (selectionModel.destroy) selectionModel.destroy();
        }
        selectionModel = model;
        if (selectionModel) {
            selectionModel.init(self);
            selectionModel.onSelectedRangesChanged.subscribe(handleSelectedRangesChanged);
        }
    }
    function getSelectionModel() {
        return selectionModel;
    }
    function getCanvasNode(columnIdOrIdx, rowIndex) {
        if (!columnIdOrIdx) columnIdOrIdx = 0;
        if (!rowIndex) rowIndex = 0;
        var idx = typeof columnIdOrIdx === "number" ? columnIdOrIdx : getColumnIndex(columnIdOrIdx);
        return hasFrozenRows && rowIndex >= actualFrozenRow + (options.frozenBottom ? 0 : 1) ? hasFrozenColumns() && idx > options.frozenColumn ? $canvasBottomR[0] : $canvasBottomL[0] : hasFrozenColumns() && idx > options.frozenColumn ? $canvasTopR[0] : $canvasTopL[0];
    }
    function getActiveCanvasNode(element) {
        setActiveCanvasNode(element);
        return $activeCanvasNode[0];
    }
    function getCanvases() {
        return $canvas;
    }
    function setActiveCanvasNode(element) {
        if (element) $activeCanvasNode = $7adda6f44168d508$var$$(element.target).closestClass("grid-canvas");
    }
    function getViewportNode() {
        return $viewport[0];
    }
    function getActiveViewportNode(element) {
        setActiveViewportNode(element);
        return $activeViewportNode[0];
    }
    function setActiveViewportNode(element) {
        if (element) $activeViewportNode = $7adda6f44168d508$var$$(element.target).closestClass("slick-viewport");
    }
    function measureScrollbar() {
        //var $outerdiv = $("<div style=\"position:absolute; top:-10000px; left:-10000px; overflow:auto; width:100px; height:100px;\"></div>").appendTo($viewport);
        var $outerdiv = $7adda6f44168d508$var$$("<div style=\"position:absolute; top:-10000px; left:-10000px; overflow:auto; width:100px; height:100px;\"></div>").appendTo($7adda6f44168d508$var$$("body"));
        var $innerdiv = $7adda6f44168d508$var$$("<div style=\"width:200px; height:200px; overflow:auto;\"></div>").appendTo($outerdiv);
        var dim = {
            width: $outerdiv[0].offsetWidth - $outerdiv[0].clientWidth,
            height: $outerdiv[0].offsetHeight - $outerdiv[0].clientHeight
        };
        $innerdiv.remove();
        $outerdiv.remove();
        return dim;
    }
    function getHeadersWidth() {
        headersWidth = headersWidthL = headersWidthR = 0;
        var includeScrollbar = !options.autoHeight;
        for(var i = 0, ii = columns.length; i < ii; i++){
            var width = columns[i].width;
            if (options.frozenColumn > -1 && i > options.frozenColumn) headersWidthR += width;
            else headersWidthL += width;
        }
        if (includeScrollbar) {
            if (options.frozenColumn > -1 && i > options.frozenColumn) headersWidthR += $7adda6f44168d508$var$scrollbarDimensions.width;
            else headersWidthL += $7adda6f44168d508$var$scrollbarDimensions.width;
        }
        if (hasFrozenColumns()) {
            headersWidthL = headersWidthL + 1000;
            headersWidthR = Math.max(headersWidthR, viewportW) + headersWidthL;
            headersWidthR += $7adda6f44168d508$var$scrollbarDimensions.width;
        } else {
            headersWidthL += $7adda6f44168d508$var$scrollbarDimensions.width;
            headersWidthL = Math.max(headersWidthL, viewportW) + 1000;
        }
        headersWidth = headersWidthL + headersWidthR;
        return Math.max(headersWidth, viewportW) + 1000;
    }
    // function getHeadersWidthL() {
    //   headersWidthL = 0;
    //   columns.forEach(function (column, i) {
    //     if (!((options.frozenColumn) > -1 && (i > options.frozenColumn))) {
    //       headersWidthL += column.width;
    //     }
    //   });
    //   if (hasFrozenColumns()) {
    //     headersWidthL += 1000;
    //   } else {
    //     headersWidthL += scrollbarDimensions.width;
    //     headersWidthL = Math.max(headersWidthL, viewportW) + 1000;
    //   }
    //   return headersWidthL;
    // }
    // function getHeadersWidthR() {
    //   headersWidthR = 0;
    //   columns.forEach(function (column, i) {
    //     if ((options.frozenColumn) > -1 && (i > options.frozenColumn)) {
    //       headersWidthR += column.width;
    //     }
    //   });
    //   if (hasFrozenColumns()) {
    //     headersWidthR = Math.max(headersWidthR, viewportW) + getHeadersWidthL();
    //     headersWidthR += scrollbarDimensions.width;
    //   }
    //   return headersWidthR;
    // }
    function getCanvasWidth() {
        var availableWidth = viewportHasVScroll ? viewportW - $7adda6f44168d508$var$scrollbarDimensions.width : viewportW;
        var i = columns.length;
        canvasWidthL = canvasWidthR = 0;
        while(i--)if (hasFrozenColumns() && i > options.frozenColumn) canvasWidthR += columns[i].width;
        else canvasWidthL += columns[i].width;
        var totalRowWidth = canvasWidthL + canvasWidthR;
        return options.fullWidthRows ? Math.max(totalRowWidth, availableWidth) : totalRowWidth;
    }
    function updateCanvasWidth(forceColumnWidthsUpdate) {
        var oldCanvasWidth = canvasWidth;
        var oldCanvasWidthL = canvasWidthL;
        var oldCanvasWidthR = canvasWidthR;
        var widthChanged;
        canvasWidth = getCanvasWidth();
        widthChanged = canvasWidth !== oldCanvasWidth || canvasWidthL !== oldCanvasWidthL || canvasWidthR !== oldCanvasWidthR;
        if (widthChanged || hasFrozenColumns() || hasFrozenRows) {
            $canvasTopL.width(canvasWidthL);
            getHeadersWidth();
            $headerL.width(headersWidthL);
            $headerR.width(headersWidthR);
            if (hasFrozenColumns()) {
                $canvasTopR.width(canvasWidthR);
                $paneHeaderL.width(canvasWidthL);
                $paneHeaderR.css("left", canvasWidthL);
                // $paneHeaderR.css("width", viewportW - canvasWidthL);
                $paneHeaderR.css("width", "calc(100% - " + canvasWidthL + "px)");
                $paneTopL.width(canvasWidthL);
                $paneTopR.css("left", canvasWidthL);
                //$paneTopR.css("width", viewportW - canvasWidthL);
                $paneTopR.css("width", "calc(100% - " + canvasWidthL + "px)");
                $headerRowScrollerL.width(canvasWidthL);
                // $headerRowScrollerR.width(viewportW - canvasWidthL);
                $headerRowScrollerR.css("width", "100%");
                $headerRowL.width(canvasWidthL);
                $headerRowR.width(canvasWidthR);
                if (options.createFooterRow) {
                    $footerRowScrollerL.width(canvasWidthL);
                    //$footerRowScrollerR.width(viewportW - canvasWidthL);
                    $footerRowScrollerR.css("width", "100%");
                    $footerRowL.width(canvasWidthL);
                    $footerRowR.width(canvasWidthR);
                }
                if (options.createPreHeaderPanel) $preHeaderPanel.width(canvasWidth);
                $viewportTopL.width(canvasWidthL);
                //$viewportTopR.width(viewportW - canvasWidthL);
                $viewportTopR.css("width", "100%");
                if (hasFrozenRows) {
                    $paneBottomL.width(canvasWidthL);
                    $paneBottomR.css("left", canvasWidthL);
                    $viewportBottomL.width(canvasWidthL);
                    // $viewportBottomR.width(viewportW - canvasWidthL);
                    $viewportBottomR.width("100%");
                    $canvasBottomL.width(canvasWidthL);
                    $canvasBottomR.width(canvasWidthR);
                }
            } else {
                $paneHeaderL.width("100%");
                $paneTopL.width("100%");
                $headerRowScrollerL.width("100%");
                $headerRowL.width(canvasWidth);
                if (options.createFooterRow) {
                    $footerRowScrollerL.width("100%");
                    $footerRowL.width(canvasWidth);
                }
                if (options.createPreHeaderPanel) {
                    $preHeaderPanel.width("100%");
                    $preHeaderPanel.width(canvasWidth);
                }
                $viewportTopL.width("100%");
                if (hasFrozenRows) {
                    $viewportBottomL.width("100%");
                    $canvasBottomL.width(canvasWidthL);
                }
            }
            viewportHasHScroll = options.alwaysShowHorizontalScroll || canvasWidth > viewportW - $7adda6f44168d508$var$scrollbarDimensions.width;
        }
        $headerRowSpacerL.width(canvasWidth + (viewportHasVScroll ? $7adda6f44168d508$var$scrollbarDimensions.width : 0));
        $headerRowSpacerR.width(canvasWidth + (viewportHasVScroll ? $7adda6f44168d508$var$scrollbarDimensions.width : 0));
        if (options.createFooterRow) {
            $footerRowSpacerL.width(canvasWidth + (viewportHasVScroll ? $7adda6f44168d508$var$scrollbarDimensions.width : 0));
            $footerRowSpacerR.width(canvasWidth + (viewportHasVScroll ? $7adda6f44168d508$var$scrollbarDimensions.width : 0));
        }
        if (widthChanged || forceColumnWidthsUpdate) applyColumnWidths();
    }
    function disableSelection($target) {
        if ($target && $target.jquery) $target.attr("unselectable", "on").css("MozUserSelect", "none").on("selectstart.ui", function() {
            return false;
        }); // from jquery:ui.core.js 1.7.2
    }
    function getMaxSupportedCssHeight() {
        var supportedHeight = 1000000;
        // fF reports the height back but still renders blank after ~6M px
        var testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6000000 : 1000000000;
        var div = $7adda6f44168d508$var$$("<div />");
        div.appendTo(document.body);
        while(true){
            var test = supportedHeight * 2;
            div.height(test);
            if (test > testUpTo || div.height() !== test) break;
            else supportedHeight = test;
        }
        div.remove();
        return supportedHeight;
    }
    function getUID() {
        return uid;
    }
    function getHeaderColumnWidthDiff() {
        return headerColumnWidthDiff;
    }
    function getScrollbarDimensions() {
        return $7adda6f44168d508$var$scrollbarDimensions;
    }
    // tODO:  this is static.  need to handle page mutation.
    function bindAncestorScrollEvents() {
        var elem = hasFrozenRows && !options.frozenBottom ? $canvasBottomL[0] : $canvasTopL[0];
        while((elem = elem.parentNode) != document.body && elem != null)// bind to scroll containers only
        if (elem == $viewportTopL[0] || elem.scrollWidth != elem.clientWidth || elem.scrollHeight != elem.clientHeight) {
            var $elem = $7adda6f44168d508$var$$(elem);
            if (!$boundAncestors) $boundAncestors = $elem;
            else $boundAncestors = $boundAncestors.add($elem);
            scrollEventHandler = elem.addEventListener("scroll", handleActiveCellPositionChange);
        //$elem.on("scroll." + uid, handleActiveCellPositionChange); //TODOFIX
        }
    }
    function unbindAncestorScrollEvents() {
        if (!$boundAncestors) return;
        // $boundAncestors.off("scroll." + uid); //TODO TODOFIX
        if (scrollEventHandler) $boundAncestors[0].removeEventListener("scroll");
        $boundAncestors = null;
    }
    function updateColumnHeader(columnId, title, toolTip) {
        if (!initialized) return;
        var idx = getColumnIndex(columnId);
        if (idx == null) return;
        var columnDef = columns[idx];
        var $header = $7adda6f44168d508$var$$($headers.children()[idx]);
        if ($header) {
            if (title !== undefined) columns[idx].name = title;
            if (toolTip !== undefined) columns[idx].toolTip = toolTip;
            trigger(self.onBeforeHeaderCellDestroy, {
                "node": $header[0],
                "column": columnDef,
                "grid": self
            });
            $header.attr("title", toolTip || "").children()[0].innerHTML = title;
            trigger(self.onHeaderCellRendered, {
                "node": $header[0],
                "column": columnDef,
                "grid": self
            });
        }
    }
    function getHeader(columnDef) {
        if (!columnDef) return hasFrozenColumns() ? $headers : $headerL;
        var idx = getColumnIndex(columnDef.id);
        return hasFrozenColumns() ? idx <= options.frozenColumn ? $headerL : $headerR : $headerL;
    }
    function getHeaderColumn(columnIdOrIdx) {
        var idx = typeof columnIdOrIdx === "number" ? columnIdOrIdx : getColumnIndex(columnIdOrIdx);
        var targetHeader = hasFrozenColumns() ? idx <= options.frozenColumn ? $headerL : $headerR : $headerL;
        var targetIndex = hasFrozenColumns() ? idx <= options.frozenColumn ? idx : idx - options.frozenColumn - 1 : idx;
        var $rtn = targetHeader.children()[targetIndex];
        return $rtn && $rtn[0];
    }
    function getHeaderRow() {
        return hasFrozenColumns() ? $headerRow : $headerRow[0];
    }
    function getFooterRow() {
        return hasFrozenColumns() ? $footerRow : $footerRow[0];
    }
    function getPreHeaderPanel() {
        return $preHeaderPanel[0];
    }
    function getPreHeaderPanelRight() {
        return $preHeaderPanelR[0];
    }
    function getHeaderRowColumn(columnIdOrIdx) {
        var idx = typeof columnIdOrIdx === "number" ? columnIdOrIdx : getColumnIndex(columnIdOrIdx);
        var $headerRowTarget;
        if (hasFrozenColumns()) {
            if (idx <= options.frozenColumn) $headerRowTarget = $headerRowL;
            else {
                $headerRowTarget = $headerRowR;
                idx -= options.frozenColumn + 1;
            }
        } else $headerRowTarget = $headerRowL;
        var $header = $headerRowTarget.children().eq(idx);
        return $header && $header[0];
    }
    function getFooterRowColumn(columnIdOrIdx) {
        var idx = typeof columnIdOrIdx === "number" ? columnIdOrIdx : getColumnIndex(columnIdOrIdx);
        var $footerRowTarget;
        if (hasFrozenColumns()) {
            if (idx <= options.frozenColumn) $footerRowTarget = $footerRowL;
            else {
                $footerRowTarget = $footerRowR;
                idx -= options.frozenColumn + 1;
            }
        } else $footerRowTarget = $footerRowL;
        var $footer = $footerRowTarget.children().eq(idx);
        return $footer && $footer[0];
    }
    function createColumnFooter() {
        if (options.createFooterRow) {
            $7adda6f44168d508$var$$.each($footerRow.find(".slick-footerrow-column"), function() {
                var columnDef = $7adda6f44168d508$var$$(this).data("column");
                if (columnDef) trigger(self.onBeforeFooterRowCellDestroy, {
                    "node": this,
                    "column": columnDef,
                    "grid": self
                });
            });
            $footerRowL.empty();
            $footerRowR.empty();
            for(var i = 0; i < columns.length; i++){
                var m = columns[i];
                var footerRowCell = $7adda6f44168d508$var$$("<div class='ui-state-default slick-footerrow-column l" + i + " r" + i + "'></div>").data("column", m).addClass(hasFrozenColumns() && i <= options.frozenColumn ? "frozen" : "").appendTo(hasFrozenColumns() && i > options.frozenColumn ? $footerRowR : $footerRowL);
                trigger(self.onFooterRowCellRendered, {
                    "node": footerRowCell[0],
                    "column": m,
                    "grid": self
                });
            }
        }
    }
    // function createColumnGroupHeaders() {
    //   var columnsLength = 0;
    //   var frozenColumnsValid = false;
    //   if (!treeColumns.hasDepth()) {
    //     return;
    //   }
    //   for (var index = 0; index < $groupHeadersL.length; index++) {
    //     $groupHeadersL[index].empty();
    //     $groupHeadersR[index].empty();
    //     var groupColumns = treeColumns.getColumnsInDepth(index);
    //     for (var indexGroup in groupColumns) {
    //       var m = groupColumns[indexGroup];
    //       columnsLength += m.extractColumns().length;
    //       if (hasFrozenColumns() && index == 0 && (columnsLength - 1) === options.frozenColumn) {
    //         frozenColumnsValid = true;
    //       }
    //       var tmp = document.createElement("div");
    //       tmp.className = "ui-state-default slick-group-header-column";
    //       tmp.innerHTML = "<span class='slick-column-name'>" + m.name + "</span>";
    //       // tmp.innerHTML = m.name;
    //       tmp.id = "" + uid + m.id;
    //       tmp.title = m.toolTip || "";
    //       if (m.headerCssClass) {
    //         tmp.classList.add(m.headerCssClass);
    //       }
    //       if (hasFrozenColumns() && (columnsLength - 1) > options.frozenColumn) {
    //         tmp.classList.add("frozen");
    //       }
    //       var $tmp = $(tmp);
    //       $tmp.data("column", m);
    //       if (hasFrozenColumns() && (columnsLength - 1) > options.frozenColumn) {
    //         $tmp.appendTo($groupHeadersR[index]);
    //       } else {
    //         $tmp.appendTo($groupHeadersL[index]);
    //       }
    //     }
    //     if (hasFrozenColumns() && index == 0 && !frozenColumnsValid) {
    //       $groupHeadersL[index].empty();
    //       $groupHeadersR[index].empty();
    //       alert("All columns of group should to be grouped!");
    //       break;
    //     }
    //   }
    //   applyColumnGroupHeaderWidths();
    // }
    function createColumnHeaders() {
        function onMouseEnter() {
            $7adda6f44168d508$var$$(this).addClass("ui-state-hover");
        }
        function onMouseLeave() {
            $7adda6f44168d508$var$$(this).removeClass("ui-state-hover");
        }
        $7adda6f44168d508$var$$.each($headers.find(".slick-header-column"), function() {
            var columnDef = $7adda6f44168d508$var$$(this).data("column");
            if (columnDef) trigger(self.onBeforeHeaderCellDestroy, {
                "node": this,
                "column": columnDef,
                "grid": self
            });
        });
        $headerL.empty();
        $headerR.empty();
        getHeadersWidth();
        $headerL.width(headersWidthL);
        $headerR.width(headersWidthR);
        $7adda6f44168d508$var$$.each($headerRow.find(".slick-headerrow-column"), function() {
            var columnDef = $7adda6f44168d508$var$$(this).data("column");
            if (columnDef) trigger(self.onBeforeHeaderRowCellDestroy, {
                "node": this,
                "column": columnDef,
                "grid": self
            });
        });
        $headerRowL.empty();
        $headerRowR.empty();
        if (options.createFooterRow) {
            $7adda6f44168d508$var$$.each($footerRowL.find(".slick-footerrow-column"), function() {
                var columnDef = $7adda6f44168d508$var$$(this).data("column");
                if (columnDef) trigger(self.onBeforeFooterRowCellDestroy, {
                    "node": this,
                    "column": columnDef,
                    "grid": self
                });
            });
            $footerRowL.empty();
            if (hasFrozenColumns()) {
                $7adda6f44168d508$var$$.each($footerRowR.find(".slick-footerrow-column"), function() {
                    var columnDef = $7adda6f44168d508$var$$(this).data("column");
                    if (columnDef) trigger(self.onBeforeFooterRowCellDestroy, {
                        "node": this,
                        "column": columnDef,
                        "grid": self
                    });
                });
                $footerRowR.empty();
            }
        }
        for(var i = 0; i < columns.length; i++){
            var m = columns[i];
            var $headerTarget = hasFrozenColumns() ? i <= options.frozenColumn ? $headerL : $headerR : $headerL;
            var $headerRowTarget = hasFrozenColumns() ? i <= options.frozenColumn ? $headerRowL : $headerRowR : $headerRowL;
            var div = document.createElement("div");
            div.className = "ui-state-default slick-header-column";
            div.style.width = m.width - headerColumnWidthDiff + "px";
            div.id = "" + uid + m.id;
            div.title = m.toolTip || "";
            var html = "<span class='slick-column-name'>" + m.name + "</span>";
            if (m.resizable) {
                html += "<span class='rs-r'" + (options.resizeHandleWidth ? "style='width:" + options.resizeHandleWidth + "'" : "") + "></span>";
                div.className += " resizable";
            }
            div.innerHTML = html;
            if (m.headerCssClass) div.className += " " + m.headerCssClass;
            if (hasFrozenColumns() && i <= options.frozenColumn) div.classList.add("frozen");
            var header = $7adda6f44168d508$var$$(div);
            header.appendTo($headerTarget);
            header.data("column", m);
            // var header = $("<div class='ui-state-default slick-header-column' />")
            //     .html("<span class='slick-column-name'>" + m.name + "</span>")
            //     .width(m.width - headerColumnWidthDiff)
            //     .attr("id", "" + uid + m.id)
            //     .attr("title", m.toolTip || "")
            //     .data("column", m)
            //     .addClass(m.headerCssClass || "")
            //     .addClass(hasFrozenColumns() && i <= options.frozenColumn? 'frozen': '')
            //     .appendTo($headerTarget);
            if (options.enableColumnReorder || m.sortable) header.on("mouseenter", onMouseEnter).on("mouseleave", onMouseLeave);
            if (m.sortable) {
                header.addClass("slick-header-sortable");
                var sortIndicator = document.createElement("span");
                sortIndicator.className = "slick-sort-indicator" + (options.numberedMultiColumnSort && !options.sortColNumberInSeparateSpan ? " slick-sort-indicator-numbered" : "");
                header.append(sortIndicator);
                if (options.numberedMultiColumnSort && options.sortColNumberInSeparateSpan) {
                    var numIndicator = document.createElement("span");
                    numIndicator.className = "slick-sort-indicator-numbered";
                    header.append(numIndicator);
                }
            }
            trigger(self.onHeaderCellRendered, {
                "node": header[0],
                "column": m,
                "grid": self
            });
            if (options.showHeaderRow) {
                var headerRowCell = $7adda6f44168d508$var$$("<div class='ui-state-default slick-headerrow-column l" + i + " r" + i + "'></div>").data("column", m).addClass(hasFrozenColumns() && i <= options.frozenColumn ? "frozen" : "").appendTo($headerRowTarget);
                trigger(self.onHeaderRowCellRendered, {
                    "node": headerRowCell[0],
                    "column": m,
                    "grid": self
                });
            }
            if (options.createFooterRow && options.showFooterRow) {
                var footerRowCell = $7adda6f44168d508$var$$("<div class='ui-state-default slick-footerrow-column l" + i + " r" + i + "'></div>").data("column", m).appendTo($footerRow);
                trigger(self.onFooterRowCellRendered, {
                    "node": footerRowCell[0],
                    "column": m,
                    "grid": self
                });
            }
        }
        setSortColumns(sortColumns);
    // setupColumnResize();
    // if (options.enableColumnReorder) {
    //   if (typeof options.enableColumnReorder == 'function') {
    //       options.enableColumnReorder(self, $headers, headerColumnWidthDiff, setColumns, setupColumnResize, columns, getColumnIndex, uid, trigger);
    //   } else {
    //       setupColumnReorder();
    //   }
    // }
    }
    function setupColumnSort() {
        $headers.on("click", function(e) {
            var ctrlPressed = e.metaKey || e.ctrlKey;
            if ($7adda6f44168d508$var$$(e.target).hasClass("rs-r")) return;
            var $col = $7adda6f44168d508$var$$(e.target).closestClass("slick-header-column");
            if (!$col.length) return;
            var column = $col.data("column");
            if (column.sortable) {
                if (!getEditorLock().commitCurrentEdit()) return;
                var sortColumn = null;
                var i = 0;
                for(; i < sortColumns.length; i++)if (sortColumns[i].columnId == column.id) {
                    sortColumn = sortColumns[i];
                    sortColumn.sortAsc = !sortColumn.sortAsc;
                    break;
                }
                var hadSortCol = !!sortColumn;
                if (options.tristateMultiColumnSort) {
                    if (!sortColumn) sortColumn = {
                        columnId: column.id,
                        sortAsc: column.defaultSortAsc
                    };
                    if (hadSortCol && sortColumn.sortAsc) {
                        // three state: remove sort rather than go back to ASC
                        sortColumns.splice(i, 1);
                        sortColumn = null;
                    }
                    if (!options.multiColumnSort) sortColumns = [];
                    if (sortColumn && (!hadSortCol || !options.multiColumnSort)) sortColumns.push(sortColumn);
                } else {
                    // legacy behaviour
                    if (ctrlPressed && options.multiColumnSort) {
                        if (sortColumn) sortColumns.splice(i, 1);
                    } else {
                        if (!e.shiftKey && !ctrlPressed || !options.multiColumnSort) sortColumns = [];
                        if (!sortColumn) {
                            sortColumn = {
                                columnId: column.id,
                                sortAsc: column.defaultSortAsc
                            };
                            sortColumns.push(sortColumn);
                        } else if (sortColumns.length == 0) sortColumns.push(sortColumn);
                    }
                }
                setSortColumns(sortColumns);
                if (!options.multiColumnSort) trigger(self.onSort, {
                    multiColumnSort: false,
                    columnId: sortColumns.length > 0 ? column.id : null,
                    sortCol: sortColumns.length > 0 ? column : null,
                    sortAsc: sortColumns.length > 0 ? sortColumns[0].sortAsc : true
                }, e);
                else trigger(self.onSort, {
                    multiColumnSort: true,
                    sortCols: sortColumns.map(function(col) {
                        return {
                            columnId: columns[getColumnIndex(col.columnId)].id,
                            sortCol: columns[getColumnIndex(col.columnId)],
                            sortAsc: col.sortAsc
                        };
                    })
                }, e);
            }
        });
    }
    function currentPositionInHeader(id) {
        var currentPosition = 0;
        $7adda6f44168d508$var$$.each($headers.find(".slick-header-column"), function(i) {
            if (this.id == id) {
                currentPosition = i;
                return false;
            }
        });
        return currentPosition;
    }
    // function limitPositionInGroup(idColumn) {
    //   var groupColumnOfPreviousPosition,
    //     startLimit = 0,
    //     endLimit = 0;
    //   treeColumns
    //     .getColumnsInDepth($groupHeadersL.length - 1)
    //     .some(function (groupColumn) {
    //       startLimit = endLimit;
    //       endLimit += groupColumn.columns.length;
    //       groupColumn.columns.some(function (column) {
    //         if (column.id === idColumn) {
    //           groupColumnOfPreviousPosition = groupColumn;
    //         }
    //         return groupColumnOfPreviousPosition;
    //       });
    //       return groupColumnOfPreviousPosition;
    //     });
    //   endLimit--;
    //   return {
    //     start: startLimit,
    //     end: endLimit,
    //     group: groupColumnOfPreviousPosition
    //   };
    // }
    function remove(arr, elem) {
        var index = arr.lastIndexOf(elem);
        if (index > -1) {
            arr.splice(index, 1);
            remove(arr, elem);
        }
    }
    // function columnPositionValidInGroup($item: IjQueryWrapper) {
    //   var currentPosition = currentPositionInHeader($item[0].id);
    //   var limit = limitPositionInGroup($item.data("column").id);
    //   var positionValid = limit.start <= currentPosition && currentPosition <= limit.end;
    //   return {
    //     limit: limit,
    //     valid: positionValid,
    //     message: positionValid ? "" : "Column \"".concat($item[0].textContent, "\" can be reordered only within the \"", limit.group.name, "\" group!")
    //   };
    // }
    // function setupColumnReorder() {
    //   if (1) { return; }
    //   var columnScrollTimer = null;
    //   function scrollColumnsRight() {
    //     $viewportScrollContainerX[0].scrollLeft = $viewportScrollContainerX[0].scrollLeft + 10;
    //   }
    //   function scrollColumnsLeft() {
    //     $viewportScrollContainerX[0].scrollLeft = $viewportScrollContainerX[0].scrollLeft - 10;
    //   }
    //   var canDragScroll;
    //   // $headers.sortable({
    //   //   containment: "parent",
    //   //   distance: 3,
    //   //   axis: "x",
    //   //   cursor: "default",
    //   //   tolerance: "intersection",
    //   //   helper: "clone",
    //   //   placeholder: "slick-sortable-placeholder ui-state-default slick-header-column",
    //   //   start: function (e, ui) {
    //   //     ui.placeholder.width(ui.helper.outerWidth() - headerColumnWidthDiff);
    //   //     canDragScroll = !hasFrozenColumns() ||
    //   //       (ui.placeholder.offset().left + ui.placeholder.width()) > $viewportScrollContainerX.offset().left;
    //   //   $(ui.helper).addClass("slick-header-column-active");
    //   //   },
    //   //   beforeStop: function (e, ui) {
    //   //     $(ui.helper).removeClass("slick-header-column-active");
    //   //   },
    //   //   sort: function (e, ui) {
    //   //     if (canDragScroll && e.originalEvent.pageX > $container[0].clientWidth) {
    //   //       if (!(columnScrollTimer)) {
    //   //         columnScrollTimer = setInterval(
    //   //           scrollColumnsRight, 100);
    //   //       }
    //   //     } else if (canDragScroll && e.originalEvent.pageX < $viewportScrollContainerX.offset().left) {
    //   //       if (!(columnScrollTimer)) {
    //   //         columnScrollTimer = setInterval(
    //   //           scrollColumnsLeft, 100);
    //   //       }
    //   //     } else {
    //   //       clearInterval(columnScrollTimer);
    //   //       columnScrollTimer = null;
    //   //     }
    //   //   },
    //   //   stop: function (e, ui) {
    //   //     var cancel = false;
    //   //     clearInterval(columnScrollTimer);
    //   //     columnScrollTimer = null;
    //   //     var limit = null;
    //   //     if (treeColumns.hasDepth()) {
    //   //       var validPositionInGroup = columnPositionValidInGroup(ui.item);
    //   //       limit = validPositionInGroup.limit;
    //   //       cancel = !validPositionInGroup.valid;
    //   //       if (cancel)
    //   //         alert(validPositionInGroup.message);
    //   //     }
    //   //     if (cancel || !getEditorLock().commitCurrentEdit()) {
    //   //       //$(this).sortable("cancel");
    //   //       return;
    //   //     }
    //   //     var reorderedIds = $headerL.sortable("toArray");
    //   //     reorderedIds = reorderedIds.concat($headerR.sortable("toArray"));
    //   //     var reorderedColumns = [];
    //   //     for (var i = 0; i < reorderedIds.length; i++) {
    //   //       reorderedColumns.push(columns[getColumnIndex(reorderedIds[i].replace(uid, ""))]);
    //   //     }
    //   //     setColumns(reorderedColumns);
    //   //     trigger(self.onColumnsReordered, { impactedColumns : getImpactedColumns( limit ) });
    //   //     e.stopPropagation();
    //   //     setupColumnResize();
    //   //   }
    //   // });
    // }
    function getImpactedColumns(limit) {
        var impactedColumns = [];
        if (limit != undefined) for(var i = limit.start; i <= limit.end; i++)impactedColumns.push(columns[i]);
        else impactedColumns = columns;
        return impactedColumns;
    }
    function setupColumnMoveAndResize() {
        for(var _i = 0, _a = $container.find(".slick-header-columns"); _i < _a.length; _i++){
            var c = _a[_i];
            (0, $e452221c07eb14a0$export$e82068809229c83c)(c, {
                resizeDelta: options.resizeDelta,
                onResize: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(function(evt) {
                    processColumnResize(evt.target, evt.x);
                }),
                onStart: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(function(evt) {
                    startColumnResize(evt.target, evt.x);
                }),
                onStop: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(function(evt) {
                    finishColumnResize();
                })
            });
        // c.addEventListener("js-rs-resize", (evt) => {
        //   processColumnResize(evt.detail.target, evt.detail.pageX);
        // });
        // c.addEventListener("js-rs-start", (evt) => {
        //   startColumnResize(evt.detail.target, evt.detail.pageX);
        // });
        // c.addEventListener("js-rs-stop", (evt) => {
        //   finishColumnResize();
        // });
        }
        var mouseDownFnc = function(e) {
            var arg = e;
            var $target = $7adda6f44168d508$var$$(e.target).closestClass("slick-header-column");
            if ($target.length === 0) {
                // special case for last column
                if (e.target.classList.contains("slick-header-columns")) $target = $7adda6f44168d508$var$$(e.target.lastChild);
                else return;
            }
            var x = arg.pageX != null ? arg.pageX : arg.touches[0].pageX;
            var columnInfo = $target.data("column");
            if (options.enableColumnReorder) startColumnDragging($target, x);
        };
        $headers.on("mousedown", mouseDownFnc);
        $headers.on("touchstart", mouseDownFnc);
    }
    var dragColStartX = 0;
    var dragColCurrentX = 0;
    var draggedEl;
    var dragGhost;
    function startColumnDragging($target, x) {
        dragColStartX = x;
        dragColCurrentX = x;
        draggedEl = $target[0];
        dragGhost = document.createElement("div");
        dragGhost.className = "slick-col-ghost";
        dragGhost.style.left = draggedEl.offsetLeft + "px";
        dragGhost.style.height = draggedEl.clientHeight + "px";
        dragGhost.style.width = draggedEl.clientWidth + "px";
        var ghostContent = document.createElement("div");
        ghostContent.className = "slick-ghost-content";
        ghostContent.style.height = draggedEl.clientHeight + "px";
        dragGhost.appendChild(ghostContent);
        draggedEl.classList.add("slick-header-column-active");
        draggedEl.parentElement.appendChild(dragGhost);
        window.addEventListener("mousemove", processColumnDrag);
        window.addEventListener("touchmove", processColumnDrag);
        window.addEventListener("mouseup", finishColumnDrag);
        window.addEventListener("touchend", finishColumnDrag);
    }
    function processColumnDrag(evt) {
        var x = evt.pageX != null ? evt.pageX : evt.touches[0].pageX;
        var prevEl = draggedEl.previousElementSibling;
        var nextEl = draggedEl.nextElementSibling;
        var prevWidth = prevEl != null ? prevEl.offsetWidth : -1;
        var nextWidth = nextEl != null ? nextEl.offsetWidth : -1;
        var draggedDistance = x - dragColCurrentX;
        dragGhost.style.left = draggedEl.offsetLeft + draggedDistance + "px";
        if (prevWidth >= 0 && draggedDistance < -prevWidth) {
            if (prevEl != null) draggedEl.parentNode.insertBefore(draggedEl, prevEl);
        } else if (nextWidth >= 0 && draggedDistance > nextWidth) {
            if (nextEl != null) draggedEl.parentNode.insertBefore(nextEl, draggedEl);
        } else return;
        dragColCurrentX = x;
    }
    function applyColumnResort(arg) {
        if (!getEditorLock().commitCurrentEdit()) return;
        var $colsL = $headerL.find(".slick-header-column");
        var $colsR = $headerR.find(".slick-header-column");
        var reorderedIds = $colsL.map(function(e) {
            return e.id;
        });
        reorderedIds = reorderedIds.concat($colsR.map(function(e) {
            return e.id;
        }));
        var reorderedColumns = [];
        for(var i = 0; i < reorderedIds.length; i++)reorderedColumns.push(columns[getColumnIndex(reorderedIds[i].replace(uid, ""))]);
        setColumns(reorderedColumns);
        trigger(self.onColumnsReordered, {
            impactedColumns: getImpactedColumns(0 /*limit*/ )
        }); // tODO limit
    }
    function finishColumnDrag(arg) {
        var x = arg.pageX != null ? arg.pageX : (arg.touches.length > 0 ? arg.touches : arg.changedTouches)[0].pageX;
        window.removeEventListener("mousemove", processColumnDrag);
        window.removeEventListener("mouseup", finishColumnDrag);
        window.removeEventListener("touchmove", processColumnDrag);
        window.removeEventListener("touchend", finishColumnDrag);
        $headers.find(".slick-header-column-active").removeClass("slick-header-column-active");
        if (dragGhost != null) dragGhost.parentElement.removeChild(dragGhost);
        dragGhost = null;
        if (Math.abs(dragColStartX - x) > options.dragDelta) applyColumnResort(arg);
    }
    var pageX, minPageX, maxPageX;
    function startColumnResize(target, x) {
        var $target = $7adda6f44168d508$var$$(target);
        // columnResizeDragging = true;
        if (!getEditorLock().commitCurrentEdit()) return false;
        pageX = x;
        var colIdx = $target.index();
        var columnElements = $headers.children();
        var shrinkLeewayOnRight = null, stretchLeewayOnRight = null;
        $target.addClass("slick-header-column-active");
        // lock each column's width option to current width
        $7adda6f44168d508$var$$.each(columnElements, function(i, e) {
            if (i >= columns.length) return;
            columns[i].previousWidth = $7adda6f44168d508$var$$(e).width();
        });
        if (options.forceFitColumns) {
            shrinkLeewayOnRight = 0;
            stretchLeewayOnRight = 0;
            // colums on right affect maxPageX/minPageX
            for(var j = colIdx + 1; j < columns.length; j++){
                var c = columns[j];
                if (c.resizable) {
                    if (stretchLeewayOnRight !== null) {
                        if (c.maxWidth) stretchLeewayOnRight += c.maxWidth - c.previousWidth;
                        else stretchLeewayOnRight = null;
                    }
                    shrinkLeewayOnRight += c.previousWidth - Math.max(c.minWidth || 0, absoluteColumnMinWidth);
                }
            }
        }
        var shrinkLeewayOnLeft = 0, stretchLeewayOnLeft = 0;
        for(var j = 0; j <= colIdx; j++){
            // columns on left only affect minPageX
            var c = columns[j];
            if (c.resizable) {
                if (stretchLeewayOnLeft !== null) {
                    if (c.maxWidth) stretchLeewayOnLeft += c.maxWidth - c.previousWidth;
                    else stretchLeewayOnLeft = null;
                }
                shrinkLeewayOnLeft += c.previousWidth - Math.max(c.minWidth || 0, absoluteColumnMinWidth);
            }
        }
        if (shrinkLeewayOnRight === null) shrinkLeewayOnRight = 100000;
        if (shrinkLeewayOnLeft === null) shrinkLeewayOnLeft = 100000;
        if (stretchLeewayOnRight === null) stretchLeewayOnRight = 100000;
        if (stretchLeewayOnLeft === null) stretchLeewayOnLeft = 100000;
        maxPageX = pageX + Math.min(shrinkLeewayOnRight, stretchLeewayOnLeft);
        minPageX = pageX - Math.min(shrinkLeewayOnLeft, stretchLeewayOnRight);
    // $current_resize_target = $target;
    }
    function processColumnResize(target, currentX) {
        // if (options.resizeDelta && Math.abs(oldResizeX - newx) <= options.resizeDelta)
        //   return;
        var $target = $7adda6f44168d508$var$$(target);
        // const width = $target.width() as number;
        // oldResizeX = newx;
        var colIdx = $target.index();
        if (hasFrozenColumns() && $target.closestClass("slick-header-columns").hasClass("slick-header-columns-right")) colIdx += options.frozenColumn + 1;
        var actualMinWidth, d = Math.min(maxPageX, Math.max(minPageX, currentX)) - pageX, x;
        if (d < 0) {
            x = d;
            var newCanvasWidthL = 0, newCanvasWidthR = 0;
            for(var j = colIdx; j >= 0; j--){
                var c = columns[j];
                if (c.resizable) {
                    actualMinWidth = Math.max(c.minWidth || 0, absoluteColumnMinWidth);
                    if (x && c.previousWidth + x < actualMinWidth) {
                        x += c.previousWidth - actualMinWidth;
                        c.width = actualMinWidth;
                    } else {
                        c.width = c.previousWidth + x;
                        x = 0;
                    }
                }
            }
            // return;
            for(var k = 0; k <= colIdx; k++){
                var c = columns[k];
                if (hasFrozenColumns() && k > options.frozenColumn) newCanvasWidthR += c.width;
                else newCanvasWidthL += c.width;
            }
            if (options.forceFitColumns) {
                x = -d;
                for(var j = colIdx + 1; j < columns.length; j++){
                    var c = columns[j];
                    if (c.resizable) {
                        if (x && c.maxWidth && c.maxWidth - c.previousWidth < x) {
                            x -= c.maxWidth - c.previousWidth;
                            c.width = c.maxWidth;
                        } else {
                            c.width = c.previousWidth + x;
                            x = 0;
                        }
                        if (hasFrozenColumns() && j > options.frozenColumn) newCanvasWidthR += c.width;
                        else newCanvasWidthL += c.width;
                    }
                }
            } else for(var j = colIdx + 1; j < columns.length; j++){
                var c = columns[j];
                if (hasFrozenColumns() && j > options.frozenColumn) newCanvasWidthR += c.width;
                else newCanvasWidthL += c.width;
            }
            if (options.forceFitColumns) {
                x = -d;
                for(var j = colIdx + 1; j < columns.length; j++){
                    var c = columns[j];
                    if (c.resizable) {
                        if (x && c.maxWidth && c.maxWidth - c.previousWidth < x) {
                            x -= c.maxWidth - c.previousWidth;
                            c.width = c.maxWidth;
                        } else {
                            c.width = c.previousWidth + x;
                            x = 0;
                        }
                    }
                }
            }
        } else {
            x = d;
            var newCanvasWidthL = 0, newCanvasWidthR = 0;
            for(var j = colIdx; j >= 0; j--){
                var c = columns[j];
                if (c.resizable) {
                    if (x && c.maxWidth && c.maxWidth - c.previousWidth < x) {
                        x -= c.maxWidth - c.previousWidth;
                        c.width = c.maxWidth;
                    } else {
                        c.width = c.previousWidth + x;
                        x = 0;
                    }
                }
            }
            for(var k = 0; k <= colIdx; k++){
                var c = columns[k];
                if (hasFrozenColumns() && k > options.frozenColumn) newCanvasWidthR += c.width;
                else newCanvasWidthL += c.width;
            }
            if (options.forceFitColumns) {
                x = -d;
                for(var j = colIdx + 1; j < columns.length; j++){
                    var c = columns[j];
                    if (c.resizable) {
                        actualMinWidth = Math.max(c.minWidth || 0, absoluteColumnMinWidth);
                        if (x && c.previousWidth + x < actualMinWidth) {
                            x += c.previousWidth - actualMinWidth;
                            c.width = actualMinWidth;
                        } else {
                            c.width = c.previousWidth + x;
                            x = 0;
                        }
                        if (hasFrozenColumns() && j > options.frozenColumn) newCanvasWidthR += c.width;
                        else newCanvasWidthL += c.width;
                    }
                }
            } else for(var j = colIdx + 1; j < columns.length; j++){
                var c = columns[j];
                if (hasFrozenColumns() && j > options.frozenColumn) newCanvasWidthR += c.width;
                else newCanvasWidthL += c.width;
            }
        }
        if (hasFrozenColumns() && newCanvasWidthL != canvasWidthL) {
            $headerL.width(newCanvasWidthL + 1000);
            $paneHeaderR.css("left", newCanvasWidthL);
        }
        applyColumnHeaderWidths();
        // applyColumnGroupHeaderWidths();
        if (options.syncColumnCellResize) applyColumnWidths();
    }
    function finishColumnResize() {
        var changedColumns = [];
        var newWidth;
        var columnElements = $headers.children();
        $headers.find(".slick-header-column-active").removeClass("slick-header-column-active");
        for(var j = 0; j < columns.length; j++){
            var c = columns[j];
            newWidth = $7adda6f44168d508$var$$(columnElements[j]).width();
            if (c.previousWidth !== newWidth) {
                changedColumns.push({
                    cell: j,
                    width: newWidth,
                    previousWidth: c.previousWidth,
                    column: c
                });
                if (c.rerenderOnResize) {
                    invalidateAllRows();
                    break;
                }
            }
        }
        updateCanvasWidth(true);
        resizeCanvas();
        handleScroll();
        trigger(self.onColumnsResized, changedColumns);
    }
    // function setupColumnResize() {
    //   if (1) return;
    //   var $col, j, k, c, pageX, columnElements: IjQueryWrapper, minPageX, maxPageX, firstResizable, lastResizable;
    //   columnElements = $headers.children();
    //   columnElements.find(".slick-resizable-handle").remove();
    //   $.each(columnElements, function (i, e) {
    //     if (i >= columns.length) { return; }
    //     if (columns[i].resizable) {
    //       if (firstResizable === undefined) {
    //         firstResizable = i;
    //       }
    //       lastResizable = i;
    //     }
    //   });
    //   if (firstResizable === undefined) {
    //     return;
    //   }
    //   $.each(columnElements, function (i, e) {
    //     if (i >= columns.length) { return; }
    //     if (i < firstResizable || (options.forceFitColumns && i >= lastResizable)) {
    //       return;
    //     }
    //     $col = $(e);
    //     var resHandle = document.createElement("div");
    //     resHandle.className = "slick-resizable-handle";
    //         e.appendChild(resHandle);
    //         $(resHandle).on("dragstart", function (e, dd) {
    //           if (!getEditorLock().commitCurrentEdit()) {
    //             return false;
    //           }
    //           pageX = e.pageX;
    //           resHandle.parentElement.classList.add("slick-header-column-active");
    //           var shrinkLeewayOnRight = null, stretchLeewayOnRight = null;
    //           // lock each column's width option to current width
    //           $.each(columnElements, function (i, e) {
    //             if (i >= columns.length) { return; }
    //             columns[i].previousWidth = $(e).width(); //.outerWidth();
    //           });
    //           if (options.forceFitColumns) {
    //             shrinkLeewayOnRight = 0;
    //             stretchLeewayOnRight = 0;
    //             // colums on right affect maxPageX/minPageX
    //             for (j = i + 1; j < columns.length; j++) {
    //               c = columns[j];
    //               if (c.resizable) {
    //                 if (stretchLeewayOnRight !== null) {
    //                   if (c.maxWidth) {
    //                     stretchLeewayOnRight += c.maxWidth - c.previousWidth;
    //                   } else {
    //                     stretchLeewayOnRight = null;
    //                   }
    //                 }
    //                 shrinkLeewayOnRight += c.previousWidth - Math.max(c.minWidth || 0, absoluteColumnMinWidth);
    //               }
    //             }
    //           }
    //           var shrinkLeewayOnLeft = 0, stretchLeewayOnLeft = 0;
    //           for (j = 0; j <= i; j++) {
    //             // columns on left only affect minPageX
    //             c = columns[j];
    //             if (c.resizable) {
    //               if (stretchLeewayOnLeft !== null) {
    //                 if (c.maxWidth) {
    //                   stretchLeewayOnLeft += c.maxWidth - c.previousWidth;
    //                 } else {
    //                   stretchLeewayOnLeft = null;
    //                 }
    //               }
    //               shrinkLeewayOnLeft += c.previousWidth - Math.max(c.minWidth || 0, absoluteColumnMinWidth);
    //             }
    //           }
    //           if (shrinkLeewayOnRight === null) {
    //             shrinkLeewayOnRight = 100000;
    //           }
    //           if (shrinkLeewayOnLeft === null) {
    //             shrinkLeewayOnLeft = 100000;
    //           }
    //           if (stretchLeewayOnRight === null) {
    //             stretchLeewayOnRight = 100000;
    //           }
    //           if (stretchLeewayOnLeft === null) {
    //             stretchLeewayOnLeft = 100000;
    //           }
    //           maxPageX = pageX + Math.min(shrinkLeewayOnRight, stretchLeewayOnLeft);
    //           minPageX = pageX - Math.min(shrinkLeewayOnLeft, stretchLeewayOnRight);
    //         })
    //         .on("drag", function (e, dd) {
    //           columnResizeDragging = true;
    //           var actualMinWidth, d = Math.min(maxPageX, Math.max(minPageX, e.pageX)) - pageX, x;
    //           if (d < 0) { // shrink column
    //             x = d;
    //             var newCanvasWidthL = 0, newCanvasWidthR = 0;
    //             for (j = i; j >= 0; j--) {
    //               c = columns[j];
    //               if (c.resizable) {
    //                 actualMinWidth = Math.max(c.minWidth || 0, absoluteColumnMinWidth);
    //                 if (x && c.previousWidth + x < actualMinWidth) {
    //                   x += c.previousWidth - actualMinWidth;
    //                   c.width = actualMinWidth;
    //                 } else {
    //                   c.width = c.previousWidth + x;
    //                   x = 0;
    //                 }
    //               }
    //             }
    //             for (k = 0; k <= i; k++) {
    //               c = columns[k];
    //               if (hasFrozenColumns() && (k > options.frozenColumn)) {
    //                 newCanvasWidthR += c.width;
    //               } else {
    //                 newCanvasWidthL += c.width;
    //               }
    //             }
    //             if (options.forceFitColumns) {
    //               x = -d;
    //               for (j = i + 1; j < columns.length; j++) {
    //                 c = columns[j];
    //                 if (c.resizable) {
    //                   if (x && c.maxWidth && (c.maxWidth - c.previousWidth < x)) {
    //                     x -= c.maxWidth - c.previousWidth;
    //                     c.width = c.maxWidth;
    //                   } else {
    //                     c.width = c.previousWidth + x;
    //                     x = 0;
    //                   }
    //                   if (hasFrozenColumns() && (j > options.frozenColumn)) {
    //                     newCanvasWidthR += c.width;
    //                   } else {
    //                     newCanvasWidthL += c.width;
    //                   }
    //                 }
    //               }
    //             } else {
    //               for (j = i + 1; j < columns.length; j++) {
    //                 c = columns[j];
    //                 if (hasFrozenColumns() && (j > options.frozenColumn)) {
    //                   newCanvasWidthR += c.width;
    //                 } else {
    //                   newCanvasWidthL += c.width;
    //                 }
    //               }
    //             }
    //             if (options.forceFitColumns) {
    //               x = -d;
    //               for (j = i + 1; j < columns.length; j++) {
    //                 c = columns[j];
    //                 if (c.resizable) {
    //                   if (x && c.maxWidth && (c.maxWidth - c.previousWidth < x)) {
    //                     x -= c.maxWidth - c.previousWidth;
    //                     c.width = c.maxWidth;
    //                   } else {
    //                     c.width = c.previousWidth + x;
    //                     x = 0;
    //                   }
    //                 }
    //               }
    //             }
    //           } else { // stretch column
    //             x = d;
    //             var newCanvasWidthL = 0, newCanvasWidthR = 0;
    //             for (j = i; j >= 0; j--) {
    //               c = columns[j];
    //               if (c.resizable) {
    //                 if (x && c.maxWidth && (c.maxWidth - c.previousWidth < x)) {
    //                   x -= c.maxWidth - c.previousWidth;
    //                   c.width = c.maxWidth;
    //                 } else {
    //                   c.width = c.previousWidth + x;
    //                   x = 0;
    //                 }
    //               }
    //             }
    //             for (k = 0; k <= i; k++) {
    //               c = columns[k];
    //               if (hasFrozenColumns() && (k > options.frozenColumn)) {
    //                 newCanvasWidthR += c.width;
    //               } else {
    //                 newCanvasWidthL += c.width;
    //               }
    //             }
    //             if (options.forceFitColumns) {
    //               x = -d;
    //               for (j = i + 1; j < columns.length; j++) {
    //                 c = columns[j];
    //                 if (c.resizable) {
    //                   actualMinWidth = Math.max(c.minWidth || 0, absoluteColumnMinWidth);
    //                   if (x && c.previousWidth + x < actualMinWidth) {
    //                     x += c.previousWidth - actualMinWidth;
    //                     c.width = actualMinWidth;
    //                   } else {
    //                     c.width = c.previousWidth + x;
    //                     x = 0;
    //                   }
    //                   if (hasFrozenColumns() && (j > options.frozenColumn)) {
    //                     newCanvasWidthR += c.width;
    //                   } else {
    //                     newCanvasWidthL += c.width;
    //                   }
    //                 }
    //               }
    //             } else {
    //               for (j = i + 1; j < columns.length; j++) {
    //                 c = columns[j];
    //                 if (hasFrozenColumns() && (j > options.frozenColumn)) {
    //                   newCanvasWidthR += c.width;
    //                 } else {
    //                   newCanvasWidthL += c.width;
    //                 }
    //               }
    //             }
    //           }
    //           if (hasFrozenColumns() && newCanvasWidthL != canvasWidthL) {
    //             $headerL.width(newCanvasWidthL + 1000);
    //             $paneHeaderR.css('left', newCanvasWidthL);
    //           }
    //           applyColumnHeaderWidths();
    //           applyColumnGroupHeaderWidths();
    //           if (options.syncColumnCellResize) {
    //             applyColumnWidths();
    //           }
    //         })
    //         .on("dragend", function (e, dd) {
    //           var newWidth;
    //           resHandle.parentElement.classList.remove("slick-header-column-active");
    //           for (j = 0; j < columns.length; j++) {
    //             c = columns[j];
    //             newWidth = $(columnElements[j]).width(); //.outerWidth();
    //             if (c.previousWidth !== newWidth && c.rerenderOnResize) {
    //               invalidateAllRows();
    //             }
    //           }
    //           updateCanvasWidth(true);
    //           render();
    //           trigger(self.onColumnsResized, {});
    //           setTimeout(function () { columnResizeDragging = false; }, 300);
    //         });
    //   });
    // }
    function getVBoxDelta($el) {
        var p = [
            "borderTopWidth",
            "borderBottomWidth",
            "paddingTop",
            "paddingBottom"
        ];
        var delta = 0;
        $7adda6f44168d508$var$$.each(p, function(n, val) {
            delta += parseFloat($el.css(val)) || 0;
        });
        return delta;
    }
    function setFrozenOptions() {
        options.frozenColumn = options.frozenColumn >= 0 && options.frozenColumn < columns.length ? options.frozenColumn : -1;
        if (options.frozenRow > -1) {
            hasFrozenRows = true;
            frozenRowsHeight = getRowTop(options.frozenRow);
            var dataLength = getDataLength();
            actualFrozenRow = options.frozenBottom ? dataLength - options.frozenRow : options.frozenRow;
        } else hasFrozenRows = false;
    }
    function setPaneVisibility() {
        if (hasFrozenColumns()) {
            $7adda6f44168d508$var$$.each($paneHeaderR, function(idx, el) {
                el.style.display = "";
            });
            $7adda6f44168d508$var$$.each($paneTopR, function(idx, el) {
                el.style.display = "";
            });
            if (hasFrozenRows) {
                $7adda6f44168d508$var$$.each($paneBottomL, function(idx, el) {
                    el.style.display = "";
                });
                $7adda6f44168d508$var$$.each($paneBottomR, function(idx, el) {
                    el.style.display = "";
                });
            } else {
                $7adda6f44168d508$var$$.each($paneBottomR, function(idx, el) {
                    el.style.display = "none";
                });
                $7adda6f44168d508$var$$.each($paneBottomL, function(idx, el) {
                    el.style.display = "none";
                });
            }
        } else {
            $7adda6f44168d508$var$$.each($paneHeaderR, function(idx, el) {
                el.style.display = "none";
            });
            $7adda6f44168d508$var$$.each($paneTopR, function(idx, el) {
                el.style.display = "none";
            });
            $7adda6f44168d508$var$$.each($paneBottomR, function(idx, el) {
                el.style.display = "none";
            });
            if (hasFrozenRows) $7adda6f44168d508$var$$.each($paneBottomL, function(idx, el) {
                el.style.display = "";
            });
            else {
                $7adda6f44168d508$var$$.each($paneBottomR, function(idx, el) {
                    el.style.display = "none";
                });
                $7adda6f44168d508$var$$.each($paneBottomL, function(idx, el) {
                    el.style.display = "none";
                });
            }
        }
    }
    function setOverflow() {
        $viewportTopL.css("overflow-x", options.alwaysShowHorizontalScroll ? "scroll" : hasFrozenColumns() ? hasFrozenRows && !options.alwaysAllowHorizontalScroll ? "hidden" : "scroll" : hasFrozenRows && !options.alwaysAllowHorizontalScroll ? "hidden" : "auto").css("overflow-y", options.alwaysShowVerticalScroll ? "scroll" : hasFrozenColumns() ? hasFrozenRows ? "hidden" : "hidden" : hasFrozenRows ? "scroll" : "auto");
        $viewportTopR.css("overflow-x", options.alwaysShowHorizontalScroll ? "scroll" : hasFrozenColumns() ? hasFrozenRows && !options.alwaysAllowHorizontalScroll ? "hidden" : "scroll" : hasFrozenRows && !options.alwaysAllowHorizontalScroll ? "hidden" : "auto").css("overflow-y", options.alwaysShowVerticalScroll ? "scroll" : hasFrozenColumns() ? hasFrozenRows ? "scroll" : "auto" : hasFrozenRows ? "scroll" : "auto");
        $viewportBottomL.css("overflow-x", options.alwaysShowHorizontalScroll ? "scroll" : hasFrozenColumns() ? hasFrozenRows && !options.alwaysAllowHorizontalScroll ? "scroll" : "auto" : hasFrozenRows && !options.alwaysAllowHorizontalScroll ? "auto" : "auto").css("overflow-y", options.alwaysShowVerticalScroll ? "scroll" : hasFrozenColumns() ? hasFrozenRows ? "hidden" : "hidden" : hasFrozenRows ? "scroll" : "auto");
        $viewportBottomR.css("overflow-x", options.alwaysShowHorizontalScroll ? "scroll" : hasFrozenColumns() ? hasFrozenRows && !options.alwaysAllowHorizontalScroll ? "scroll" : "auto" : hasFrozenRows && !options.alwaysAllowHorizontalScroll ? "auto" : "auto").css("overflow-y", options.alwaysShowVerticalScroll ? "scroll" : hasFrozenColumns() ? hasFrozenRows ? "auto" : "auto" : hasFrozenRows ? "auto" : "auto");
        if (options.viewportClass) {
            $viewportTopL.toggleClass(options.viewportClass, true);
            $viewportTopR.toggleClass(options.viewportClass, true);
            $viewportBottomL.toggleClass(options.viewportClass, true);
            $viewportBottomR.toggleClass(options.viewportClass, true);
        }
    }
    function setScroller() {
        if (hasFrozenColumns()) {
            $headerScrollContainer = $headerScrollerR;
            $headerRowScrollContainer = $headerRowScrollerR;
            $footerRowScrollContainer = $footerRowScrollerR;
            if (hasFrozenRows) {
                if (options.frozenBottom) {
                    $viewportScrollContainerX = $viewportBottomR;
                    $viewportScrollContainerY = $viewportTopR;
                } else $viewportScrollContainerX = $viewportScrollContainerY = $viewportBottomR;
            } else $viewportScrollContainerX = $viewportScrollContainerY = $viewportTopR;
        } else {
            $headerScrollContainer = $headerScrollerL;
            $headerRowScrollContainer = $headerRowScrollerL;
            $footerRowScrollContainer = $footerRowScrollerL;
            if (hasFrozenRows) {
                if (options.frozenBottom) {
                    $viewportScrollContainerX = $viewportBottomL;
                    $viewportScrollContainerY = $viewportTopL;
                } else $viewportScrollContainerX = $viewportScrollContainerY = $viewportBottomL;
            } else $viewportScrollContainerX = $viewportScrollContainerY = $viewportTopL;
        }
    }
    function measureCellPaddingAndBorder() {
        var el;
        var h = [
            "borderLeftWidth",
            "borderRightWidth",
            "paddingLeft",
            "paddingRight"
        ];
        var v = [
            "borderTopWidth",
            "borderBottomWidth",
            "paddingTop",
            "paddingBottom"
        ];
        // jquery prior to version 1.8 handles .width setter/getter as a direct css write/read
        // jquery 1.8 changed .width to read the true inner element width if box-sizing is set to border-box, and introduced a setter for .outerWidth
        // so for equivalent functionality, prior to 1.8 use .width, and after use .outerWidth
        // var verArray = $.fn.jquery.split('.');
        jQueryNewWidthBehaviour = false; // (verArray[0]==1 && verArray[1]>=8) ||  verArray[0] >=2;
        el = $7adda6f44168d508$var$$("<div class='ui-state-default slick-header-column' style='visibility:hidden'>-</div>").appendTo($headers);
        headerColumnWidthDiff = headerColumnHeightDiff = 0;
        if (el.css("box-sizing") != "border-box" && el.css("-moz-box-sizing") != "border-box" && el.css("-webkit-box-sizing") != "border-box") {
            $7adda6f44168d508$var$$.each(h, function(n, val) {
                headerColumnWidthDiff += parseFloat(el.css(val)) || 0;
            });
            $7adda6f44168d508$var$$.each(v, function(n, val) {
                headerColumnHeightDiff += parseFloat(el.css(val)) || 0;
            });
        }
        el.remove();
        var r = $7adda6f44168d508$var$$("<div class='slick-row' />").appendTo($canvas);
        el = $7adda6f44168d508$var$$("<div class='slick-cell' id='' style='visibility:hidden'>-</div>").appendTo(r);
        cellWidthDiff = cellHeightDiff = 0;
        if (el.css("box-sizing") != "border-box" && el.css("-moz-box-sizing") != "border-box" && el.css("-webkit-box-sizing") != "border-box") {
            $7adda6f44168d508$var$$.each(h, function(n, val) {
                cellWidthDiff += parseFloat(el.css(val)) || 0;
            });
            $7adda6f44168d508$var$$.each(v, function(n, val) {
                cellHeightDiff += parseFloat(el.css(val)) || 0;
            });
        }
        r.remove();
        absoluteColumnMinWidth = Math.max(headerColumnWidthDiff, cellWidthDiff);
    }
    function createCssRules() {
        var style = document.createElement("style");
        style.type = "text/css";
        $7adda6f44168d508$var$$("head").append(style);
        $style = $7adda6f44168d508$var$$(style);
        // $style = $("<style type='text/css' rel='stylesheet' />").appendTo($("head"));
        var rowHeight = options.rowHeight - cellHeightDiff;
        var rules = [
            "." + uid + " .slick-group-header-column { left: 1000px; }",
            "." + uid + " .slick-header-column { left: 1000px; }",
            "." + uid + " .slick-top-panel { height:" + options.topPanelHeight + "px; }",
            "." + uid + " .slick-preheader-panel { height:" + options.preHeaderPanelHeight + "px; }",
            "." + uid + " .slick-headerrow-columns { height:" + options.headerRowHeight + "px; }",
            "." + uid + " .slick-footerrow-columns { height:" + options.footerRowHeight + "px; }",
            "." + uid + " .slick-cell { height:" + rowHeight + "px; }",
            "." + uid + " .slick-row { height:" + options.rowHeight + "px; }"
        ];
        for(var i = 0; i < columns.length; i++){
            rules.push("." + uid + " .l" + i + " { }");
            rules.push("." + uid + " .r" + i + " { }");
        }
        if ($style[0].styleSheet) $style[0].styleSheet.cssText = rules.join(" ");
        else $style[0].appendChild(document.createTextNode(rules.join(" ")));
    }
    function getColumnCssRules(idx) {
        var i;
        if (!stylesheet) {
            var sheets = document.styleSheets;
            for(i = 0; i < sheets.length; i++)if (sheets[i].ownerNode == $style[0]) {
                stylesheet = sheets[i];
                break;
            }
            if (!stylesheet) throw new Error("Cannot find stylesheet.");
            // find and cache column CSS rules
            columnCssRulesL = [];
            columnCssRulesR = [];
            var cssRules = stylesheet.cssRules || stylesheet.rules;
            var matches, columnIdx;
            for(i = 0; i < cssRules.length; i++){
                var selector = cssRules[i].selectorText;
                if (matches = /\.l\d+/.exec(selector)) {
                    columnIdx = parseInt(matches[0].substr(2, matches[0].length - 2), 10);
                    columnCssRulesL[columnIdx] = cssRules[i];
                } else if (matches = /\.r\d+/.exec(selector)) {
                    columnIdx = parseInt(matches[0].substr(2, matches[0].length - 2), 10);
                    columnCssRulesR[columnIdx] = cssRules[i];
                }
            }
        }
        return {
            "left": columnCssRulesL[idx],
            "right": columnCssRulesR[idx]
        };
    }
    function removeCssRules() {
        $style.remove();
        stylesheet = null;
    }
    function destroy() {
        getEditorLock().cancelCurrentEdit();
        trigger(self.onBeforeDestroy, {});
        var i = plugins.length;
        while(i--)unregisterPlugin(plugins[i]);
        unbindAncestorScrollEvents();
        // $container.off(".slickgrid"); //TODO TODOFIX
        removeCssRules();
        // $canvas.off("draginit dragstart dragend drag"); //TODO TODOFIX
        $container.empty().removeClass(uid);
    }
    //////////////////////////////////////////////////////////////////////////////////////////////
    // general
    function trigger(evt, args, e) {
        // if (evt.countHandlers() === 0) {
        //   return;
        // }
        e = e || new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).EventData();
        if (e.stopImmediatePropagation) {
            var tmp_fnc_1 = e.stopImmediatePropagation;
            e.stopImmediatePropagation = function() {
                tmp_fnc_1.apply(e);
                e._isImmediatePropagationStopped = true;
            };
            if (!e.isImmediatePropagationStopped) e.isImmediatePropagationStopped = function() {
                return e._isImmediatePropagationStopped;
            };
        }
        if (e.stopPropagation) {
            var tmp_fnc_2 = e.stopPropagation;
            e.stopPropagation = function() {
                tmp_fnc_2.apply(e);
                e._isPropagationStopped = true;
            };
            if (!e.isPropagationStopped) e.isPropagationStopped = function() {
                return e._isPropagationStopped;
            };
        }
        args = args || {};
        args.grid = self;
        return evt.notify(args, e, self);
    }
    function getEditorLock() {
        return options.editorLock;
    }
    function getEditController() {
        return editController;
    }
    function getColumnIndex(id) {
        return columnsById[id];
    }
    function getColumnById(id) {
        return columns[getColumnIndex(id)];
    }
    function autosizeColumns() {
        var i, c, widths = [], shrinkLeeway = 0, total = 0, prevTotal, availWidth = viewportHasVScroll ? viewportW - $7adda6f44168d508$var$scrollbarDimensions.width : viewportW;
        for(i = 0; i < columns.length; i++){
            c = columns[i];
            widths.push(c.width);
            total += c.width;
            if (c.resizable) shrinkLeeway += c.width - Math.max(c.minWidth, absoluteColumnMinWidth);
        }
        // shrink
        prevTotal = total;
        while(total > availWidth && shrinkLeeway){
            var shrinkProportion = (total - availWidth) / shrinkLeeway;
            for(i = 0; i < columns.length && total > availWidth; i++){
                c = columns[i];
                var width = widths[i];
                if (!c.resizable || width <= c.minWidth || width <= absoluteColumnMinWidth) continue;
                var absMinWidth = Math.max(c.minWidth, absoluteColumnMinWidth);
                var shrinkSize = Math.floor(shrinkProportion * (width - absMinWidth)) || 1;
                shrinkSize = Math.min(shrinkSize, width - absMinWidth);
                total -= shrinkSize;
                shrinkLeeway -= shrinkSize;
                widths[i] -= shrinkSize;
            }
            if (prevTotal <= total) break;
            prevTotal = total;
        }
        // grow
        prevTotal = total;
        while(total < availWidth){
            var growProportion = availWidth / total;
            for(i = 0; i < columns.length && total < availWidth; i++){
                c = columns[i];
                var currentWidth = widths[i];
                var growSize;
                if (!c.resizable || c.maxWidth <= currentWidth) growSize = 0;
                else growSize = Math.min(Math.floor(growProportion * currentWidth) - currentWidth, c.maxWidth - currentWidth || 1000000) || 1;
                total += growSize;
                widths[i] += total <= availWidth ? growSize : 0;
            }
            if (prevTotal >= total) break;
            prevTotal = total;
        }
        var reRender = false;
        for(i = 0; i < columns.length; i++){
            if (columns[i].rerenderOnResize && columns[i].width != widths[i]) reRender = true;
            columns[i].width = widths[i];
        }
        applyColumnHeaderWidths();
        // applyColumnGroupHeaderWidths();
        updateCanvasWidth(true);
        trigger(self.onAutosizeColumns, {
            "columns": columns
        });
        if (reRender) {
            invalidateAllRows();
            render();
        }
    }
    // function applyColumnGroupHeaderWidths() {
    //   if (!treeColumns.hasDepth()) {
    //     return;
    //   }
    //   for (var depth = $groupHeadersL.length - 1; depth >= 0; depth--) {
    //     var groupColumns = treeColumns.getColumnsInDepth(depth);
    //     $.each($().add($groupHeadersL[depth]).add($groupHeadersR[depth]), function (i, el) {
    //       var $groupHeader = $(el),
    //         currentColumnIndex = 0;
    //       $groupHeader.width(i == 0 ? getHeadersWidthL() : getHeadersWidthR());
    //       $.each($groupHeader.children(), function (idx2, el2) {
    //         var $groupHeaderColumn = $(el2);
    //         var m = $(this).data("column");
    //         m.width = 0;
    //         m.columns.forEach(function () {
    //           var headerColumn = <HTMLElement>(<HTMLElement>$groupHeader[0]).nextElementSibling.children[currentColumnIndex++];
    //           m.width += headerColumn.offsetWidth;
    //         });
    //         $groupHeaderColumn.width(m.width - headerColumnWidthDiff);
    //       });
    //     });
    //   }
    // }
    function applyColumnHeaderWidths() {
        if (!initialized) return;
        var h;
        for(var i = 0, headers = $headers.children(), ii = columns.length; i < ii; i++){
            h = $7adda6f44168d508$var$$(headers[i]);
            if (jQueryNewWidthBehaviour) {
                if (h.width() !== columns[i].width) h.width(columns[i].width);
            } else // if (<number>h.width() !== <number>h.width() - headerColumnWidthDiff) {
            h.width(columns[i].width - headerColumnWidthDiff);
        }
        updateColumnCaches();
    }
    function applyColumnWidths() {
        var x = 0, w, rule;
        for(var i = 0; i < columns.length; i++){
            w = columns[i].width;
            rule = getColumnCssRules(i);
            rule.left.style.left = x + "px";
            rule.right.style.right = (options.frozenColumn != -1 && i > options.frozenColumn ? canvasWidthR : canvasWidthL) - x - w + "px";
            // if this column is frozen, reset the css left value since the
            // column starts in a new viewport.
            if (options.frozenColumn == i) x = 0;
            else x += columns[i].width;
        }
    }
    function setSortColumn(columnId, ascending) {
        setSortColumns([
            {
                columnId: columnId,
                sortAsc: ascending
            }
        ]);
    }
    function setSortColumns(cols) {
        sortColumns = cols;
        var numberCols = options.numberedMultiColumnSort && sortColumns.length > 1;
        var headerColumnEls = $headers.children();
        headerColumnEls.removeClass("slick-header-column-sorted").find(".slick-sort-indicator").removeClass("slick-sort-indicator-asc slick-sort-indicator-desc");
        headerColumnEls.find(".slick-sort-indicator-numbered").text("");
        $7adda6f44168d508$var$$.each(sortColumns, function(i, col) {
            if (col.sortAsc == null) col.sortAsc = true;
            var columnIndex = getColumnIndex(col.columnId);
            if (columnIndex != null) {
                $7adda6f44168d508$var$$(headerColumnEls[columnIndex]).addClass("slick-header-column-sorted").find(".slick-sort-indicator").addClass(col.sortAsc ? "slick-sort-indicator-asc" : "slick-sort-indicator-desc");
                if (numberCols) $7adda6f44168d508$var$$(headerColumnEls[columnIndex]).find(".slick-sort-indicator-numbered").text((i + 1).toString());
            }
        });
    }
    function getSortColumns() {
        return sortColumns;
    }
    function handleSelectedRangesChanged(e, ranges) {
        var previousSelectedRows = selectedRows.slice(0); // shallow copy previously selected rows for later comparison
        selectedRows = [];
        var hash = {};
        for(var i = 0; i < ranges.length; i++)for(var j = ranges[i].fromRow; j <= ranges[i].toRow; j++){
            if (!hash[j]) {
                selectedRows.push(j);
                hash[j] = {};
            }
            for(var k = ranges[i].fromCell; k <= ranges[i].toCell; k++)if (canCellBeSelected(j, k)) hash[j][columns[k].id] = options.selectedCellCssClass;
        }
        setCellCssStyles(options.selectedCellCssClass, hash);
        if (simpleArrayEquals(previousSelectedRows, selectedRows)) trigger(self.onSelectedRowsChanged, {
            rows: getSelectedRows()
        }, e);
    }
    // compare 2 simple arrays (integers or strings only, do not use to compare object arrays)
    function simpleArrayEquals(arr1, arr2) {
        return Array.isArray(arr1) && Array.isArray(arr2) && arr2.sort().toString() !== arr1.sort().toString();
    }
    function getColumns() {
        return columns;
    }
    function updateColumnCaches() {
        // pre-calculate cell boundaries.
        columnPosLeft = [];
        columnPosRight = [];
        var x = 0;
        for(var i = 0, ii = columns.length; i < ii; i++){
            columnPosLeft[i] = x;
            columnPosRight[i] = x + columns[i].width;
            if (options.frozenColumn == i) x = 0;
            else x += columns[i].width;
        }
    }
    function updateColumnProps() {
        columnsById = {};
        for(var i = 0; i < columns.length; i++){
            if (columns[i].width) columns[i].widthRequest = columns[i].width;
            var m = columns[i] = $7adda6f44168d508$var$$.shallowExtend({}, columnDefaults, columns[i]);
            columnsById[m.id] = i;
            if (m.minWidth && m.width < m.minWidth) m.width = m.minWidth;
            if (m.maxWidth && m.width > m.maxWidth) m.width = m.maxWidth;
        }
    }
    function setColumns(columnDefinitions) {
        // var _treeColumns = new Slick.TreeColumns(columnDefinitions);
        // if (_treeColumns.hasDepth()) {
        //   treeColumns = _treeColumns;
        //   columns = treeColumns.extractColumns();
        // } else {
        columns = columnDefinitions;
        // }
        updateColumnProps();
        updateColumnCaches();
        if (initialized) {
            setPaneVisibility();
            setOverflow();
            invalidateAllRows();
            createColumnHeaders();
            // createColumnGroupHeaders();
            createColumnFooter();
            removeCssRules();
            createCssRules();
            resizeCanvas(); // does not work when not visible
            updateCanvasWidth();
            applyColumnWidths();
            handleScroll();
        }
    }
    function getOptions() {
        return options;
    }
    function setOptions(args, suppressRender) {
        if (!getEditorLock().commitCurrentEdit()) return;
        makeActiveCellNormal();
        if (options.enableAddRow !== args.enableAddRow) invalidateRow(getDataLength());
        options = $7adda6f44168d508$var$$.shallowExtend(options, args);
        validateAndEnforceOptions();
        $viewport.css("overflow-y", options.autoHeight ? "hidden" : "auto");
        if (!suppressRender) render();
        setFrozenOptions();
        setScroller();
        // zombieRowNodeFromLastMouseWheelEvent = null;
        setColumns(columns);
    }
    function validateAndEnforceOptions() {
        if (options.autoHeight) options.leaveSpaceForNewRows = false;
    }
    function setData(newData, scrollToTop) {
        data = newData;
        invalidateAllRows();
        updateRowCount();
        if (scrollToTop) scrollTo(0);
    }
    function getData() {
        return data;
    }
    function getDataLength() {
        if (data.getLength) return data.getLength();
        else return data && data.length || 0;
    }
    function getDataLengthIncludingAddNew() {
        return getDataLength() + (!options.enableAddRow ? 0 : !pagingActive || pagingIsLastPage ? 1 : 0);
    }
    function getDataItem(i) {
        if (data.getItem) return data.getItem(i);
        else return data[i];
    }
    function getTopPanel() {
        return $topPanel[0];
    }
    function setTopPanelVisibility(visible) {
        if (options.showTopPanel != visible) {
            options.showTopPanel = visible;
            if (visible) $topPanelScroller.slideDown("fast", resizeCanvas);
            else $topPanelScroller.slideUp("fast", resizeCanvas);
        }
    }
    function setHeaderRowVisibility(visible) {
        if (options.showHeaderRow != visible) {
            options.showHeaderRow = visible;
            if (visible) $headerRowScroller.slideDown("fast", resizeCanvas);
            else $headerRowScroller.slideUp("fast", resizeCanvas);
        }
    }
    function setFooterRowVisibility(visible) {
        if (options.showFooterRow != visible) {
            options.showFooterRow = visible;
            if (visible) $footerRowScroller.slideDown("fast", resizeCanvas);
            else $footerRowScroller.slideUp("fast", resizeCanvas);
        }
    }
    function setPreHeaderPanelVisibility(visible) {
        if (options.showPreHeaderPanel != visible) {
            options.showPreHeaderPanel = visible;
            if (visible) $preHeaderPanelScroller.slideDown("fast", resizeCanvas);
            else $preHeaderPanelScroller.slideUp("fast", resizeCanvas);
        }
    }
    function getContainerNode() {
        return $container[0];
    }
    //////////////////////////////////////////////////////////////////////////////////////////////
    // rendering / Scrolling
    function getRowTop(row) {
        var result;
        if (options.variableRowHeight) result = rowPositionCache[row].top - offset;
        else result = options.rowHeight * row - offset;
        if (hasFrozenRows && row < actualFrozenRow) result += offset;
        return result;
    }
    function getRowBottom(row) {
        if (options.variableRowHeight) return rowPositionCache[row].bottom - offset;
        return options.rowHeight * (row + 1) - offset;
    }
    function getRowFromPosition(y) {
        if (!options.variableRowHeight) return Math.floor((y + offset) / options.rowHeight);
        var rowsInPosCache = getDataLength();
        if (!rowsInPosCache) return 0;
        // loop through the row position cache and break when
        // the row is found
        var row = Math.max(0, binarySearch(rowPositionCache, y + offset, function(pos, cacheEntry) {
            if (cacheEntry.top <= pos) {
                if (cacheEntry.bottom > pos) return 0;
                else return 1;
            } else return -1;
        }));
        // for ( var i = 0; i < rowsInPosCache; i++ ) {
        //     if ( rowPositionCache[i].top <= y + offset
        //          && rowPositionCache[i].bottom >= y + offset
        //     ) {
        //         row = i;
        //         continue;
        //     }
        // }
        // return the last row in the grid
        if (y + offset > rowPositionCache[rowsInPosCache - 1].bottom) row = rowsInPosCache - 1;
        return row;
    }
    function binarySearch(ar, el, compare_fn) {
        var m = 0;
        var n = ar.length - 1;
        while(m <= n){
            var k = n + m >> 1;
            var cmp = compare_fn(el, ar[k]);
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return -m - 1;
    }
    function scrollTo(y) {
        y = Math.max(y, 0);
        y = Math.min(y, th - $viewportScrollContainerY.height() + (viewportHasHScroll || hasFrozenColumns() ? $7adda6f44168d508$var$scrollbarDimensions.height : 0));
        var oldOffset = offset;
        page = Math.min(n - 1, Math.floor(y / ph));
        offset = Math.round(page * cj);
        var newScrollTop = y - offset;
        if (offset != oldOffset) {
            var range = getVisibleRange(newScrollTop);
            cleanupRows(range);
            updateRowPositions();
        }
        if (prevScrollTop != newScrollTop) {
            vScrollDir = prevScrollTop + oldOffset < newScrollTop + offset ? 1 : -1;
            lastRenderedScrollTop = scrollTop = prevScrollTop = newScrollTop;
            if (hasFrozenColumns()) $viewportTopL[0].scrollTop = newScrollTop;
            if (hasFrozenRows) $viewportBottomL[0].scrollTop = $viewportBottomR[0].scrollTop = newScrollTop;
            $viewportScrollContainerY[0].scrollTop = newScrollTop;
            trigger(self.onViewportChanged, {});
        }
    }
    function defaultFormatter(row, cell, value, columnDef, dataContext) {
        if (value == null) return "";
        else return (value + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function getFormatter(row, column) {
        var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
        // look up by id, then index
        var columnOverrides = rowMetadata && rowMetadata.columns && (rowMetadata.columns[column.id] || rowMetadata.columns[getColumnIndex(column.id)]);
        return columnOverrides && columnOverrides.formatter || rowMetadata && rowMetadata.formatter || column.formatter || options.formatterFactory && options.formatterFactory.getFormatter(column, row) || options.defaultFormatter;
    }
    function callFormatter(row, cell, value, m, item, grid) {
        var result;
        // pass metadata to formatter
        var metadata = data.getItemMetadata && data.getItemMetadata(row);
        metadata = metadata && metadata.columns;
        if (metadata) {
            var columnData = metadata[m.id] || metadata[cell];
            result = getFormatter(row, m)(row, cell, value, m, item, columnData);
        } else result = getFormatter(row, m)(row, cell, value, m, item);
        return result;
    }
    function getEditor(row, cell) {
        var column = columns[cell];
        var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
        var columnMetadata = rowMetadata && rowMetadata.columns;
        if (columnMetadata && columnMetadata[column.id] && columnMetadata[column.id].editor !== undefined) return columnMetadata[column.id].editor;
        if (columnMetadata && columnMetadata[cell] && columnMetadata[cell].editor !== undefined) return columnMetadata[cell].editor;
        return column.editor || options.editorFactory && options.editorFactory.getEditor(column, row);
    }
    function getDataItemValueForColumn(item, columnDef) {
        if (options.dataItemColumnValueExtractor) return options.dataItemColumnValueExtractor(item, columnDef);
        if (item == null) return undefined;
        if (columnDef.field && columnDef.field.indexOf(".") > 0) {
            var fields = columnDef.field.split(".");
            var result = item;
            for(var i = 0; i < fields.length; i++)result = result[fields[i]];
            return result;
        }
        return item[columnDef.field];
    }
    function appendRowHtml(html, row, range, dataLength) {
        var d = getDataItem(row);
        var dataLoading = row < dataLength && !d;
        var rowCss = "slick-row" + (hasFrozenRows && row <= options.frozenRow ? " frozen" : "") + (dataLoading ? " loading" : "") + (row === activeRow && options.showCellSelection ? " active" : "") + (row % 2 === 1 ? " odd" : " even");
        if (!d && row >= dataLength) rowCss += " " + options.addNewRowCssClass;
        var metadata = data.getItemMetadata && data.getItemMetadata(row);
        if (metadata && metadata.cssClasses) rowCss += " " + metadata.cssClasses;
        rowCss += " " + (trigger(self.onAppendRow, {
            row: row,
            item: d
        }) || "");
        var frozenRowOffset = getFrozenRowOffset(row);
        var top = getRowTop(row) - frozenRowOffset;
        var rowHtml = "<div class='ui-widget-content " + rowCss + "' style='top:" + top + "px";
        if (getRowHeight(row) !== options.rowHeight) rowHtml += ";height:" + getRowHeight(row) + "px";
        rowHtml += "'>";
        html.L += rowHtml;
        if (hasFrozenColumns()) html.R += rowHtml;
        var colspan, m;
        for(var i = 0, ii = columns.length; i < ii; i++){
            m = columns[i];
            colspan = 1;
            if (metadata && metadata.columns) {
                var columnData = metadata.columns[m.id] || metadata.columns[i];
                colspan = columnData && columnData.colspan || 1;
                if (colspan === "*") colspan = ii - i;
            }
            // do not render cells outside of the viewport.
            if (columnPosRight[Math.min(ii - 1, i + colspan - 1)] > range.leftPx || m.alwaysRenderColumn) {
                if (!m.alwaysRenderColumn && columnPosLeft[i] > range.rightPx) break;
                if (hasFrozenColumns() && i > options.frozenColumn) html.R += appendCellHtml(row, i, colspan, d);
                else html.L += appendCellHtml(row, i, colspan, d);
            }
            // else if (m.alwaysRenderColumn || (hasFrozenColumns() && i <= options.frozenColumn)) {
            //   html.L += appendCellHtml(row, i, colspan, d);
            // }
            if (colspan > 1) i += colspan - 1;
        }
        html.L += "</div>";
        if (hasFrozenColumns()) html.R += "</div>";
    }
    function appendCellHtml(row, cell, colspan, item) {
        // result: string containing the HTML parts
        // row, cell: row and column index
        // colspan: HTML colspan
        // item: grid data for row
        var stringResult = "";
        var m = columns[cell];
        var cellCss = "slick-cell l" + cell + " r" + Math.min(columns.length - 1, cell + colspan - 1) + (m.cssClass ? " " + m.cssClass : "");
        if (hasFrozenColumns() && cell <= options.frozenColumn) cellCss += " frozen";
        if (row === activeRow && cell === activeCell && options.showCellSelection) cellCss += " active";
        for(var key in cellCssClasses)if (cellCssClasses[key][row] && cellCssClasses[key][row][m.id]) cellCss += " " + cellCssClasses[key][row][m.id];
        var value = null, formatterResult = "";
        if (item) {
            value = getDataItemValueForColumn(item, m);
            formatterResult = getFormatter(row, m)(row, cell, value, m, item, self);
            if (formatterResult === null || formatterResult === undefined) formatterResult = "";
        }
        // get addl css class names from object type formatter return
        var addlCssClasses = formatterResult && formatterResult.addClasses ? (addlCssClasses ? " " : "") + formatterResult.addClasses : "";
        var toolTip = formatterResult && formatterResult.toolTip ? "title='" + formatterResult.toolTip + "'" : "";
        stringResult += "<div class='" + cellCss + (addlCssClasses ? " " + addlCssClasses : "") + "' " + toolTip + (getRowHeight(row) !== options.rowHeight ? "style='height:" + (getRowHeight(row) - cellHeightDiff) + "px'>" : ">");
        // if there is a corresponding row (if not, this is the Add New row or this data hasn't been loaded yet)
        if (item) stringResult += Object.prototype.toString.call(formatterResult) !== "[object Object]" ? formatterResult : formatterResult.text;
        stringResult += "</div>";
        rowsCache[row].cellRenderQueue.push(cell);
        rowsCache[row].cellColSpans[cell] = colspan;
        return stringResult;
    }
    function cleanupRows(rangeToKeep) {
        for(var i in rowsCache){
            var idx = parseInt(i, 10);
            var removeFrozenRow = true;
            if (hasFrozenRows && (options.frozenBottom && idx >= actualFrozenRow // frozen bottom rows
             || !options.frozenBottom && idx <= actualFrozenRow // frozen top rows
            )) removeFrozenRow = false;
            if (idx !== activeRow && (idx < rangeToKeep.top || idx > rangeToKeep.bottom) && removeFrozenRow) removeRowFromCache(i);
        }
        if (options.enableAsyncPostRenderCleanup) startPostProcessingCleanup();
    }
    function invalidate() {
        var currentActiveCell = null;
        if (currentEditor) currentActiveCell = getActiveCell();
        updateRowCount();
        invalidateAllRows();
        render();
        if (currentActiveCell) makeActiveCellEditable(null, null, {});
    }
    function invalidateAllRows() {
        if (currentEditor) makeActiveCellNormal();
        for(var row in rowsCache)removeRowFromCache(row);
        if (options.enableAsyncPostRenderCleanup) startPostProcessingCleanup();
    }
    function queuePostProcessedRowForCleanup(cacheEntry, postProcessedRow, rowIdx) {
        postProcessgroupId++;
        // store and detach node for later async cleanup
        for(var column in postProcessedRow)if (postProcessedRow.hasOwnProperty(column)) {
            var columnIdx = parseInt(column, 10) | 0;
            postProcessedCleanupQueue.push({
                actionType: "C",
                groupId: postProcessgroupId,
                node: cacheEntry.cellNodesByColumnIdx[columnIdx],
                columnIdx: columnIdx,
                rowIdx: rowIdx
            });
        }
        postProcessedCleanupQueue.push({
            actionType: "R",
            groupId: postProcessgroupId,
            node: cacheEntry.rowNode
        });
        cacheEntry.rowNode.forEach(function(x) {
            return x.parent.removeChild(x);
        }); // $(cacheEntry.rowNode).detach();
    }
    function initializeRowPositions() {
        rowPositionCache = [
            {
                top: 0,
                height: options.rowHeight,
                bottom: options.rowHeight
            }
        ];
    }
    function cacheRowPositions() {
        if (!options.variableRowHeight) return;
        initializeRowPositions();
        for(var i = 0, l = getDataLength(); i <= l; i++){
            var metadata = data.getItemMetadata && data.getItemMetadata(i);
            rowPositionCache[i] = {
                top: rowPositionCache[i - 1] ? rowPositionCache[i - 1].bottom /* - offset */  : 0,
                height: metadata && metadata.height !== undefined ? metadata.height : options.rowHeight
            };
            rowPositionCache[i].bottom = rowPositionCache[i].top + rowPositionCache[i].height;
        }
    }
    function removeRowFromCache(row) {
        var cacheEntry = rowsCache[row];
        if (!cacheEntry) return;
        trigger(self.onBeforeRemoveRow, {
            row: row,
            dom: cacheEntry.rowNode
        });
        cacheEntry.rowNode.forEach(function(x) {
            x.parentElement.removeChild(x);
        });
        delete rowsCache[row];
        delete postProcessedRows[row];
    }
    function invalidateRows(rows) {
        var i, rl;
        if (!rows || !rows.length) return;
        vScrollDir = 0;
        rl = rows.length;
        for(i = 0; i < rl; i++){
            if (currentEditor && activeRow === rows[i]) makeActiveCellNormal();
            if (rowsCache[rows[i]]) removeRowFromCache(rows[i]);
        }
        if (options.enableAsyncPostRenderCleanup) startPostProcessingCleanup();
    }
    function invalidateRow(row) {
        if (!row && row !== 0) return;
        invalidateRows([
            row
        ]);
    }
    function applyFormatResultToCellNode(formatterResult, cellNode, suppressRemove) {
        if (formatterResult === null || formatterResult === undefined) formatterResult = "";
        if (Object.prototype.toString.call(formatterResult) !== "[object Object]") cellNode.innerHTML = formatterResult;
        else {
            cellNode.innerHTML = formatterResult.text;
            if (formatterResult.removeClasses && !suppressRemove) $7adda6f44168d508$var$$(cellNode).removeClass(formatterResult.removeClasses);
            if (formatterResult.addClasses) $7adda6f44168d508$var$$(cellNode).addClass(formatterResult.addClasses);
            if (formatterResult.toolTip) $7adda6f44168d508$var$$(cellNode).attr("title", formatterResult.toolTip);
        }
    }
    function updateCell(row, cell) {
        var cellNode = getCellNode(row, cell);
        if (!cellNode) return;
        var m = columns[cell], d = getDataItem(row);
        if (currentEditor && activeRow === row && activeCell === cell) currentEditor.loadValue(d);
        else {
            var formatterResult = d ? getFormatter(row, m)(row, cell, getDataItemValueForColumn(d, m), m, d, self) : "";
            applyFormatResultToCellNode(formatterResult, cellNode);
            if (self.onAppendCell.countHandlers() > 0) {
                var item = getDataItem(activeRow);
                var value = getDataItemValueForColumn(item, columns[activeCell]);
                trigger(self.onAppendCell, {
                    row: row,
                    cell: cell,
                    value: value,
                    item: item,
                    column: m,
                    dom: cellNode
                });
            }
            invalidatePostProcessingResults(row);
        }
    }
    function updateRow(row) {
        var cacheEntry = rowsCache[row];
        if (!cacheEntry) return;
        ensureCellNodesInRowsCache(row);
        var formatterResult, d = getDataItem(row);
        // if (d) {
        //   for (let cacheRow of cacheEntry.rowNode) {
        //     cacheRow.classList.remove("loading");
        //   }
        // }
        for(var column in cacheEntry.cellNodesByColumnIdx){
            if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(column)) continue;
            var columnIdx = parseInt(column, 10) | 0;
            var m = columns[columnIdx], node = cacheEntry.cellNodesByColumnIdx[columnIdx];
            if (row === activeRow && columnIdx === activeCell && currentEditor) currentEditor.loadValue(d);
            else if (d) {
                formatterResult = getFormatter(row, m)(row, columnIdx, getDataItemValueForColumn(d, m), m, d, self);
                applyFormatResultToCellNode(formatterResult, node);
                if (self.onAppendCell.countHandlers() > 0) {
                    var item = getDataItem(row);
                    var value = getDataItemValueForColumn(item, columns[columnIdx]);
                    trigger(self.onAppendCell, {
                        row: row,
                        cell: columnIdx,
                        value: value,
                        item: item,
                        column: columns[columnIdx],
                        dom: node
                    });
                }
            } else node.innerHTML = "";
        }
        invalidatePostProcessingResults(row);
    }
    function getViewportHeight() {
        if (options.autoHeight) {
            var fullHeight = $paneHeaderL.height();
            fullHeight += options.showHeaderRow ? options.headerRowHeight + getVBoxDelta($headerRowScroller) : 0;
            fullHeight += options.showFooterRow ? options.footerRowHeight + getVBoxDelta($footerRowScroller) : 0;
            fullHeight += getCanvasWidth() > viewportW ? $7adda6f44168d508$var$scrollbarDimensions.height : 0;
            if (options.variableRowHeight) viewportH = rowPositionCache[getDataLengthIncludingAddNew()].bottom; // tODO Test this (also with frozen columns)
            else viewportH = options.rowHeight * getDataLengthIncludingAddNew() + (options.frozenColumn == -1 ? fullHeight : 0);
        } else {
            topPanelH = options.showTopPanel ? options.topPanelHeight + getVBoxDelta($topPanelScroller) : 0;
            headerRowH = options.showHeaderRow ? options.headerRowHeight + getVBoxDelta($headerRowScroller) : 0;
            footerRowH = options.showFooterRow ? options.footerRowHeight + getVBoxDelta($footerRowScroller) : 0;
            var preHeaderH = options.createPreHeaderPanel && options.showPreHeaderPanel ? options.preHeaderPanelHeight + getVBoxDelta($preHeaderPanelScroller) : 0;
            viewportH = $container[0].clientHeight - $headerScroller[0].clientHeight - getVBoxDelta($headerScroller) - topPanelH - headerRowH - footerRowH - preHeaderH;
        }
        numVisibleRows = Math.ceil(viewportH / options.rowHeight); // tODO -> variable Row height
        return viewportH;
    }
    function getViewportWidth() {
        viewportW = $container.width() - 2; // 2 for border
    }
    function resizeCanvas() {
        if (!initialized) return;
        paneTopH = 0;
        paneBottomH = 0;
        viewportTopH = 0;
        viewportBottomH = 0;
        getViewportWidth();
        getViewportHeight();
        // account for Frozen Rows
        if (hasFrozenRows) {
            if (options.frozenBottom) {
                paneTopH = viewportH - frozenRowsHeight - $7adda6f44168d508$var$scrollbarDimensions.height;
                paneBottomH = frozenRowsHeight + $7adda6f44168d508$var$scrollbarDimensions.height;
            } else {
                paneTopH = frozenRowsHeight;
                paneBottomH = viewportH - frozenRowsHeight;
            }
        } else paneTopH = viewportH;
        // the top pane includes the top panel and the header row
        paneTopH += topPanelH + headerRowH + footerRowH;
        if (hasFrozenColumns() && options.autoHeight) paneTopH += $7adda6f44168d508$var$scrollbarDimensions.height;
        // the top viewport does not contain the top panel or header row
        viewportTopH = paneTopH - topPanelH - headerRowH - footerRowH;
        if (options.autoHeight) {
            if (hasFrozenColumns()) $container.height(paneTopH + $headerScrollerL[0].offsetHeight);
            $paneTopL.css("position", "relative");
        }
        $paneTopL.css("top", $paneHeaderL.height()).css("height", paneTopH);
        var paneBottomTop = $paneTopL[0].offsetTop + paneTopH;
        if (!options.autoHeight) $viewportTopL.height(viewportTopH);
        if (hasFrozenColumns()) {
            $paneTopR.css("top", $paneHeaderL.height()).css("height", paneTopH);
            $viewportTopR.height(viewportTopH);
            if (hasFrozenRows) {
                $paneBottomL.css("top", paneBottomTop).css("height", paneBottomH);
                $paneBottomR.css("top", paneBottomTop).css("height", paneBottomH);
                $viewportBottomR.height(paneBottomH);
            }
        } else if (hasFrozenRows) {
            $paneBottomL.css("width", "100%").css("height", paneBottomH);
            $paneBottomL.css("top", paneBottomTop);
        }
        if (hasFrozenRows) {
            $viewportBottomL.height(paneBottomH);
            if (options.frozenBottom) {
                $canvasBottomL.height(frozenRowsHeight);
                if (hasFrozenColumns()) $canvasBottomR.height(frozenRowsHeight);
            } else {
                $canvasTopL.height(frozenRowsHeight);
                if (hasFrozenColumns()) $canvasTopR.height(frozenRowsHeight);
            }
        } else $viewportTopR.height(viewportTopH);
        if (!$7adda6f44168d508$var$scrollbarDimensions || !$7adda6f44168d508$var$scrollbarDimensions.width) $7adda6f44168d508$var$scrollbarDimensions = measureScrollbar();
        if (options.forceFitColumns) autosizeColumns();
        updateRowCount();
        handleScroll();
        // since the width has changed, force the render() to reevaluate virtually rendered cells.
        lastRenderedScrollLeft = -1;
        render();
    }
    function updatePagingStatusFromView(pagingInfo) {
        pagingActive = pagingInfo.pageSize !== 0;
        pagingIsLastPage = pagingInfo.pageNum == pagingInfo.totalPages - 1;
    }
    function updateRowCount() {
        if (!initialized) return;
        cacheRowPositions();
        var dataLength = getDataLength();
        var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
        var numberOfRows = 0;
        var oldH = hasFrozenRows && !options.frozenBottom ? parseInt($canvasBottomL[0].style.height) : parseInt($canvasTopL[0].style.height);
        if (hasFrozenRows) numberOfRows = getDataLength() - options.frozenRow;
        else numberOfRows = dataLengthIncludingAddNew + (options.leaveSpaceForNewRows ? numVisibleRows - 1 : 0);
        var tempViewportH = $viewportScrollContainerY.height();
        var oldViewportHasVScroll = viewportHasVScroll;
        // with autoHeight, we do not need to accommodate the vertical scroll bar
        viewportHasVScroll = options.alwaysShowVerticalScroll || !options.autoHeight && (options.variableRowHeight ? rowPositionCache[numberOfRows - 1] && rowPositionCache[numberOfRows - 1].bottom > viewportH : numberOfRows * options.rowHeight > tempViewportH);
        makeActiveCellNormal();
        // remove the rows that are now outside of the data range
        // this helps avoid redundant calls to .removeRow() when the size of the data decreased by thousands of rows
        var r1 = dataLength - 1;
        for(var i in rowsCache)if (parseInt(i, 10) > r1) removeRowFromCache(i);
        if (options.enableAsyncPostRenderCleanup) startPostProcessingCleanup();
        if (activeCellNode && activeRow > r1) resetActiveCell();
        oldH = h;
        var rowH = options.variableRowHeight ? options.enableAddRow ? rowPositionCache[getDataLength()].bottom : rowPositionCache[getDataLength()].top : options.rowHeight * numberOfRows;
        if (options.autoHeight) h = rowH;
        else {
            th = Math.max(rowH, tempViewportH - $7adda6f44168d508$var$scrollbarDimensions.height);
            if (th < $7adda6f44168d508$var$maxSupportedCssHeight) {
                // just one page
                h = ph = th;
                n = 1;
                cj = 0;
            } else {
                // break into pages
                h = $7adda6f44168d508$var$maxSupportedCssHeight;
                ph = h / 100;
                n = Math.floor(th / ph);
                cj = (th - h) / (n - 1);
            }
        }
        if (h !== oldH) {
            if (hasFrozenRows && !options.frozenBottom) {
                $canvasBottomL.css("height", h);
                if (hasFrozenColumns()) $canvasBottomR.css("height", h);
            } else {
                $canvasTopL.css("height", h);
                $canvasTopR.css("height", h);
            }
            scrollTop = $viewportScrollContainerY[0].scrollTop;
        }
        var oldScrollTopInRange = scrollTop + offset <= th - tempViewportH;
        if (th == 0 || scrollTop == 0) page = offset = 0;
        else if (oldScrollTopInRange) // maintain virtual position
        scrollTo(scrollTop + offset);
        else // scroll to bottom
        scrollTo(th - tempViewportH);
        if (h != oldH && options.autoHeight) resizeCanvas();
        if (options.forceFitColumns && oldViewportHasVScroll != viewportHasVScroll) autosizeColumns();
        updateCanvasWidth(false);
    }
    function getVisibleRange(viewportTop, viewportLeft) {
        if (viewportTop == null) viewportTop = scrollTop;
        if (viewportLeft == null) viewportLeft = scrollLeft;
        return {
            top: getRowFromPosition(viewportTop),
            bottom: getRowFromPosition(viewportTop + viewportH) + 1,
            leftPx: viewportLeft,
            rightPx: viewportLeft + viewportW
        };
    }
    function getRenderedRangeFromVisibleRange(range) {
        var buffer = Math.round(viewportH / options.rowHeight); // TODO -> probably not correct for variableRowHeight
        var minBuffer = options.minRowBuffer;
        if (vScrollDir === -1) {
            range.top -= buffer;
            range.bottom += minBuffer;
        } else if (vScrollDir === 1) {
            range.top -= minBuffer;
            range.bottom += buffer;
        } else {
            range.top -= minBuffer;
            range.bottom += minBuffer;
        }
        range.top = Math.max(0, range.top);
        range.bottom = Math.min(getDataLengthIncludingAddNew() - 1, range.bottom);
        range.leftPx -= viewportW;
        range.rightPx += viewportW;
        range.leftPx = Math.max(0, range.leftPx);
        range.rightPx = Math.min(canvasWidth, range.rightPx);
        return range;
    }
    function getRenderedRange(viewportTop, viewportLeft) {
        var range = getVisibleRange(viewportTop, viewportLeft);
        return getRenderedRangeFromVisibleRange(range);
    }
    function ensureCellNodesInRowsCache(row) {
        var cacheEntry = rowsCache[row];
        if (cacheEntry) {
            if (cacheEntry.cellRenderQueue.length) {
                var lastNode = cacheEntry.rowNode[cacheEntry.rowNode.length - 1].lastElementChild; // cacheEntry.rowNode.children().last();
                while(lastNode && cacheEntry.cellRenderQueue.length){
                    var columnIdx = cacheEntry.cellRenderQueue.pop();
                    cacheEntry.cellNodesByColumnIdx[columnIdx] = lastNode;
                    lastNode = lastNode.previousElementSibling;
                    // hack to retrieve the frozen columns because
                    if (!lastNode) lastNode = cacheEntry.rowNode[0].lastElementChild;
                }
            }
        }
    }
    function cleanUpCells(range, row) {
        // ignore frozen rows
        if (hasFrozenRows && (options.frozenBottom && row > actualFrozenRow // frozen bottom rows
         || row <= actualFrozenRow // frozen top rows
        )) return;
        var totalCellsRemoved = 0;
        var cacheEntry = rowsCache[row];
        // remove cells outside the range.
        var cellsToRemove = [];
        for(var idx in cacheEntry.cellNodesByColumnIdx){
            // i really hate it when people mess with Array.prototype.
            if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(idx)) continue;
            // this is a string, so it needs to be cast back to a number.
            var i = parseInt(idx, 10) | 0;
            // ignore frozen columns
            if (i <= options.frozenColumn) continue;
            // ignore alwaysRenderedColumns
            if (Array.isArray(columns) && columns[i] && columns[i].alwaysRenderColumn) continue;
            var colspan = cacheEntry.cellColSpans[i];
            if (columnPosLeft[i] > range.rightPx || columnPosRight[Math.min(columns.length - 1, i + colspan - 1)] < range.leftPx) {
                if (!(row == activeRow && i == activeCell)) cellsToRemove.push(i);
            }
        }
        var cellToRemove;
        while((cellToRemove = cellsToRemove.pop()) != null){
            cacheEntry.cellNodesByColumnIdx[cellToRemove].parentElement.removeChild(cacheEntry.cellNodesByColumnIdx[cellToRemove]);
            delete cacheEntry.cellColSpans[cellToRemove];
            delete cacheEntry.cellNodesByColumnIdx[cellToRemove];
            if (postProcessedRows[row]) delete postProcessedRows[row][cellToRemove];
            totalCellsRemoved++;
        }
    }
    function cleanUpAndRenderCells(range) {
        var cacheEntry;
        var stringArray = "";
        var processedRows = [];
        var cellsAdded;
        var totalCellsAdded = 0;
        var colspan;
        for(var row = range.top, btm = range.bottom; row <= btm; row++){
            cacheEntry = rowsCache[row];
            if (!cacheEntry) continue;
            // cellRenderQueue populated in renderRows() needs to be cleared first
            ensureCellNodesInRowsCache(row);
            cleanUpCells(range, row);
            // render missing cells.
            cellsAdded = 0;
            var metadata = data.getItemMetadata && data.getItemMetadata(row);
            metadata = metadata && metadata.columns;
            var d = getDataItem(row);
            for(var i = 0, ii = columns.length; i < ii; i++){
                // cells to the right are outside the range.
                if (columnPosLeft[i] > range.rightPx) break;
                // already rendered.
                if ((colspan = cacheEntry.cellColSpans[i]) != null) {
                    i += colspan > 1 ? colspan - 1 : 0;
                    continue;
                }
                colspan = 1;
                if (metadata) {
                    var columnData = metadata[columns[i].id] || metadata[i];
                    colspan = columnData && columnData.colspan || 1;
                    if (colspan === "*") colspan = ii - i;
                }
                if (columnPosRight[Math.min(ii - 1, i + colspan - 1)] > range.leftPx) {
                    stringArray += appendCellHtml(row, i, colspan, d);
                    cellsAdded++;
                }
                i += colspan > 1 ? colspan - 1 : 0;
            }
            if (cellsAdded) {
                totalCellsAdded += cellsAdded;
                processedRows.push(row);
            }
        }
        if (!stringArray.length) return;
        var x = document.createElement("div");
        x.innerHTML = stringArray;
        // tODO TODOFIX -> call     var addlCssClasses = trigger(self.onAppendCell, { row: row, cell: cell, value: value, dataContext: item, column: m }) || '';
        var processedRow;
        while((processedRow = processedRows.pop()) != null){
            cacheEntry = rowsCache[processedRow];
            var columnIdx;
            while((columnIdx = cacheEntry.cellRenderQueue.pop()) != null){
                var node = x.lastElementChild;
                if (hasFrozenColumns() && columnIdx > options.frozenColumn) cacheEntry.rowNode[1].appendChild(node);
                else cacheEntry.rowNode[0].appendChild(node);
                if (self.onAppendCell.countHandlers() > 0) {
                    var item = getDataItem(processedRow);
                    var value = getDataItemValueForColumn(item, columns[columnIdx]);
                    trigger(self.onAppendCell, {
                        row: processedRow,
                        cell: columnIdx,
                        value: value,
                        item: item,
                        column: columns[columnIdx],
                        dom: node
                    });
                }
                cacheEntry.cellNodesByColumnIdx[columnIdx] = node;
            }
        }
    }
    function renderRows(range) {
        var html = {
            L: "",
            R: ""
        }, rows = [], needToReselectCell = false, dataLength = getDataLength();
        for(var i = range.top, ii = range.bottom; i <= ii; i++){
            if (rowsCache[i] || hasFrozenRows && options.frozenBottom && i == getDataLength()) continue;
            renderedRows++;
            rows.push(i);
            // create an entry right away so that appendRowHtml() can
            // start populatating it.
            rowsCache[i] = {
                rowNode: null,
                // colSpans of rendered cells (by column idx).
                // can also be used for checking whether a cell has been rendered.
                cellColSpans: [],
                // cell nodes (by column idx).  Lazy-populated by ensureCellNodesInRowsCache().
                cellNodesByColumnIdx: [],
                // column indices of cell nodes that have been rendered, but not yet indexed in
                // cellNodesByColumnIdx.  These are in the same order as cell nodes added at the
                // end of the row.
                cellRenderQueue: []
            };
            appendRowHtml(html, i, range, dataLength);
            if (activeCellNode && activeRow === i) needToReselectCell = true;
        }
        if (!rows.length) return;
        var x;
        if (html.L.length > 0) {
            x = document.createElement("div");
            x.innerHTML = html.L;
        }
        var xRight;
        if (html.R.length > 0) {
            xRight = document.createElement("div");
            xRight.innerHTML = html.R;
        }
        for(var i = 0, ii = rows.length; i < ii; i++){
            var xChild = void 0;
            var xChildRight = void 0;
            rowsCache[rows[i]].rowNode = [];
            if (x && x.children.length > 0) {
                xChild = x.children[0];
                rowsCache[rows[i]].rowNode.push(xChild);
            }
            if (xRight && xRight.children.length > 0) {
                xChildRight = xRight.children[0];
                rowsCache[rows[i]].rowNode.push(xChildRight);
            }
            if (hasFrozenRows && rows[i] >= actualFrozenRow) {
                $canvasBottomL[0].appendChild(xChild);
                if (hasFrozenColumns()) $canvasBottomR[0].appendChild(xChildRight);
            } else if (hasFrozenColumns()) {
                $canvasTopL[0].appendChild(xChild);
                $canvasTopR[0].appendChild(xChildRight);
            } else $canvasTopL[0].appendChild(xChild);
            if (self.onAppendCell.countHandlers() > 0) {
                var nodes = [];
                for(var idx = 0; idx < xChild.childNodes.length; idx++)nodes.push(xChild.childNodes[idx]);
                if (xChildRight) for(var idx = 0; idx < xChildRight.childNodes.length; idx++)nodes.push(xChildRight.childNodes[idx]);
                for(var cIdx = 0; cIdx < nodes.length; cIdx++){
                    var item = getDataItem(rows[i]);
                    var value = getDataItemValueForColumn(item, columns[cIdx]);
                    trigger(self.onAppendCell, {
                        row: rows[i],
                        cell: cIdx,
                        value: value,
                        item: item,
                        column: columns[cIdx],
                        dom: nodes[cIdx]
                    });
                }
            }
        }
        if (needToReselectCell) activeCellNode = getCellNode(activeRow, activeCell);
    }
    function startPostProcessing() {
        if (!options.enableAsyncPostRender) return;
        clearTimeout(h_postrender);
        h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay);
    }
    function startPostProcessingCleanup() {
        if (!options.enableAsyncPostRenderCleanup) return;
        clearTimeout(h_postrenderCleanup);
        h_postrenderCleanup = setTimeout(asyncPostProcessCleanupRows, options.asyncPostRenderCleanupDelay);
    }
    function invalidatePostProcessingResults(row) {
        // change status of columns to be re-rendered
        for(var columnIdx in postProcessedRows[row])if (postProcessedRows[row].hasOwnProperty(columnIdx)) postProcessedRows[row][columnIdx] = "C";
        postProcessFromRow = Math.min(postProcessFromRow, row);
        postProcessToRow = Math.max(postProcessToRow, row);
        startPostProcessing();
    }
    function updateRowPositions() {
        for(var row in rowsCache)rowsCache[row].rowNode.forEach(function(x) {
            return x.style.top = getRowTop(row) + "px";
        });
    }
    function render() {
        if (!initialized) return;
        scrollThrottle.dequeue();
        var visible = getVisibleRange();
        var rendered = getRenderedRangeFromVisibleRange(visible); // getRenderedRange();
        // remove rows no longer in the viewport
        cleanupRows(rendered);
        // add new rows & missing cells in existing rows
        if (lastRenderedScrollLeft != scrollLeft) {
            if (hasFrozenRows) {
                var renderedFrozenRows = $7adda6f44168d508$var$$.deepExtend({}, rendered);
                if (options.frozenBottom) {
                    renderedFrozenRows.top = actualFrozenRow;
                    renderedFrozenRows.bottom = getDataLength();
                } else {
                    renderedFrozenRows.top = 0;
                    renderedFrozenRows.bottom = options.frozenRow;
                }
                cleanUpAndRenderCells(renderedFrozenRows);
            }
            cleanUpAndRenderCells(rendered);
        }
        // render missing rows
        renderRows(rendered);
        // render frozen rows
        if (hasFrozenRows) {
            if (options.frozenBottom) renderRows({
                top: actualFrozenRow,
                bottom: getDataLength() - 1,
                leftPx: rendered.leftPx,
                rightPx: rendered.rightPx
            });
            else renderRows({
                top: 0,
                bottom: options.frozenRow - 1,
                leftPx: rendered.leftPx,
                rightPx: rendered.rightPx
            });
        }
        postProcessFromRow = visible.top;
        postProcessToRow = Math.min(getDataLengthIncludingAddNew() - 1, visible.bottom);
        startPostProcessing();
        lastRenderedScrollTop = scrollTop;
        lastRenderedScrollLeft = scrollLeft;
        h_render = null;
        trigger(self.onRendered, {
            startRow: visible.top,
            endRow: visible.bottom,
            grid: self
        });
    }
    function preventScroll(e) {
        e.preventDefault();
    }
    // function handleHeaderScroll() {
    //   handleElementScroll($headerScrollContainer[0]);
    // }
    //function handleHeaderRowScroll() {
    // if (programmaticScrollingTimeout) {
    //   return;
    // }
    // var scrollLeft = $headerRowScrollContainer[0].scrollLeft;
    // if (scrollLeft != $viewportScrollContainerX[0].scrollLeft) {
    //   $viewportScrollContainerX[0].scrollLeft = scrollLeft;
    // }
    // }
    // function handleFooterRowScroll(e) {
    //   if (programmaticScrollingTimeout) {
    //     return;
    //   }
    // var scrollLeft = $footerRowScrollContainer[0].scrollLeft;
    // if (scrollLeft != $viewportScrollContainerX[0].scrollLeft) {
    //   $viewportScrollContainerX[0].scrollLeft = scrollLeft;
    // }
    //}
    // function handlePreHeaderPanelScroll() {
    //   handleElementScroll($preHeaderPanelScroller[0]);
    // }
    //function handleElementScroll(element) {
    // if (programmaticScrollingTimeout) {
    //   return;
    // }
    //   var scrollLeft = element.scrollLeft;
    //   if (scrollLeft != $viewportScrollContainerX[0].scrollLeft) {
    //     $viewportScrollContainerX[0].scrollLeft = scrollLeft;
    //   }
    // }
    function handleScroll() {
        scrollTop = $viewportScrollContainerY[0].scrollTop;
        scrollLeft = $viewportScrollContainerX[0].scrollLeft;
        return _handleScroll(false);
    }
    function _handleScroll(isMouseWheel) {
        // if (programmaticScrollingTimeout) {
        //   clearTimeout(programmaticScrollingTimeout);
        // }
        // programmaticScrollingTimeout = setTimeout(() => {
        //   programmaticScrollingTimeout = null;
        // }, 600);
        // ceiling the max scroll values
        var vScrollDist = 0;
        if (!options.autoHeight) {
            var maxScrollDistanceY = $viewportScrollContainerY[0].scrollHeight - $viewportScrollContainerY[0].clientHeight;
            if (scrollTop > maxScrollDistanceY) scrollTop = maxScrollDistanceY;
            vScrollDist = Math.abs(scrollTop - prevScrollTop);
        }
        var maxScrollDistanceX = $viewportScrollContainerY[0].scrollWidth - $viewportScrollContainerY[0].clientWidth;
        if (scrollLeft > maxScrollDistanceX) scrollLeft = maxScrollDistanceX;
        var hScrollDist = Math.abs(scrollLeft - prevScrollLeft);
        if (hScrollDist) {
            prevScrollLeft = scrollLeft;
            $viewportScrollContainerX[0].scrollLeft = scrollLeft;
            $headerScrollContainer[0].scrollLeft = scrollLeft;
            $topPanelScroller[0].scrollLeft = scrollLeft;
            $headerRowScrollContainer[0].scrollLeft = scrollLeft;
            if (options.createFooterRow) $footerRowScrollContainer[0].scrollLeft = scrollLeft;
            if (options.createPreHeaderPanel) {
                if (hasFrozenColumns()) $preHeaderPanelScrollerR[0].scrollLeft = scrollLeft;
                else $preHeaderPanelScroller[0].scrollLeft = scrollLeft;
            }
            if (hasFrozenColumns()) {
                if (hasFrozenRows) $viewportTopR[0].scrollLeft = scrollLeft;
            } else if (hasFrozenRows) $viewportTopL[0].scrollLeft = scrollLeft;
        }
        if (vScrollDist) {
            vScrollDir = prevScrollTop < scrollTop ? 1 : -1;
            prevScrollTop = scrollTop;
            if (isMouseWheel) $viewportScrollContainerY[0].scrollTop = scrollTop;
            if (hasFrozenColumns()) {
                if (hasFrozenRows && !options.frozenBottom) $viewportBottomL[0].scrollTop = scrollTop;
                else $viewportTopL[0].scrollTop = scrollTop;
            }
            // switch virtual pages if needed
            if (vScrollDist < viewportH) scrollTo(scrollTop + offset);
            else {
                var oldOffset = offset;
                if (h == viewportH) page = 0;
                else page = Math.min(n - 1, Math.floor(scrollTop * ((th - viewportH) / (h - viewportH)) * (1 / ph)));
                offset = Math.round(page * cj);
                if (oldOffset != offset) invalidateAllRows();
            }
        }
        if (hScrollDist || vScrollDist) {
            var dx = Math.abs(lastRenderedScrollLeft - scrollLeft);
            var dy = Math.abs(lastRenderedScrollTop - scrollTop);
            if (dx > 20 || dy > 20) {
                // if rendering is forced or scrolling is small enough to be "easy", just render
                if (options.forceSyncScrolling || dy < viewportH && dx < viewportW) render();
                else // otherwise, perform "difficult" renders at a capped frequency
                scrollThrottle.enqueue();
                trigger(self.onViewportChanged, {});
            }
        }
        trigger(self.onScroll, {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        });
        if (hScrollDist || vScrollDist) return true;
        return false;
    }
    /*
    limits the frequency at which the provided action is executed.
    call enqueue to execute the action - it will execute either immediately or, if it was executed less than minPeriod_ms in the past, as soon as minPeriod_ms has expired.
    call dequeue to cancel any pending action.
    */ function ActionThrottle(action, minPeriod_ms) {
        var blocked = false;
        var queued = false;
        function enqueue() {
            if (!blocked) blockAndExecute();
            else queued = true;
        }
        function dequeue() {
            queued = false;
        }
        function blockAndExecute() {
            blocked = true;
            setTimeout(unblock, minPeriod_ms);
            action();
        }
        function unblock() {
            if (queued) {
                dequeue();
                blockAndExecute();
            } else blocked = false;
        }
        return {
            enqueue: enqueue,
            dequeue: dequeue
        };
    }
    function asyncPostProcessRows() {
        var dataLength = getDataLength();
        while(postProcessFromRow <= postProcessToRow){
            var row = vScrollDir >= 0 ? postProcessFromRow++ : postProcessToRow--;
            var cacheEntry = rowsCache[row];
            if (!cacheEntry || row >= dataLength) continue;
            if (!postProcessedRows[row]) postProcessedRows[row] = {};
            ensureCellNodesInRowsCache(row);
            for(var column in cacheEntry.cellNodesByColumnIdx){
                if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(column)) continue;
                var columnIdx = parseInt(column, 10) | 0;
                var m = columns[columnIdx];
                var processedStatus = postProcessedRows[row][columnIdx]; // c=cleanup and re-render, R=rendered
                if (m.asyncPostRender && processedStatus !== "R") {
                    var node = cacheEntry.cellNodesByColumnIdx[columnIdx];
                    if (node) m.asyncPostRender(node, row, getDataItem(row), m, processedStatus === "C");
                    postProcessedRows[row][columnIdx] = "R";
                }
            }
            h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay);
            return;
        }
    }
    function asyncPostProcessCleanupRows() {
        if (postProcessedCleanupQueue.length > 0) {
            var groupId = postProcessedCleanupQueue[0].groupId;
            // loop through all queue members with this groupID
            while(postProcessedCleanupQueue.length > 0 && postProcessedCleanupQueue[0].groupId == groupId){
                var entry = postProcessedCleanupQueue.shift();
                if (entry.actionType == "R") $7adda6f44168d508$var$$(entry.node).remove();
                if (entry.actionType == "C") {
                    var column = columns[entry.columnIdx];
                    if (column.asyncPostRenderCleanup && entry.node) // cleanup must also remove element
                    column.asyncPostRenderCleanup(entry.node, entry.rowIdx, column);
                }
            }
            // call this function again after the specified delay
            h_postrenderCleanup = setTimeout(asyncPostProcessCleanupRows, options.asyncPostRenderCleanupDelay);
        }
    }
    function updateCellCssStylesOnRenderedRows(addedHash, removedHash) {
        var node, columnId, addedRowHash, removedRowHash;
        for(var row in rowsCache){
            removedRowHash = removedHash && removedHash[row];
            addedRowHash = addedHash && addedHash[row];
            if (removedRowHash) {
                for(columnId in removedRowHash)if (!addedRowHash || removedRowHash[columnId] != addedRowHash[columnId]) {
                    node = getCellNode(row, getColumnIndex(columnId));
                    if (node) $7adda6f44168d508$var$$(node).removeClass(removedRowHash[columnId]);
                }
            }
            if (addedRowHash) {
                for(columnId in addedRowHash)if (!removedRowHash || removedRowHash[columnId] != addedRowHash[columnId]) {
                    node = getCellNode(row, getColumnIndex(columnId));
                    if (node) $7adda6f44168d508$var$$(node).addClass(addedRowHash[columnId]);
                }
            }
        }
    }
    function addCellCssStyles(key, hash) {
        if (cellCssClasses[key]) throw new Error("addCellCssStyles: cell CSS hash with key '" + key + "' already exists.");
        cellCssClasses[key] = hash;
        updateCellCssStylesOnRenderedRows(hash, null);
        trigger(self.onCellCssStylesChanged, {
            "key": key,
            "hash": hash,
            "grid": self
        });
    }
    function removeCellCssStyles(key) {
        if (!cellCssClasses[key]) return;
        updateCellCssStylesOnRenderedRows(null, cellCssClasses[key]);
        delete cellCssClasses[key];
        trigger(self.onCellCssStylesChanged, {
            "key": key,
            "hash": null,
            "grid": self
        });
    }
    function setCellCssStyles(key, hash) {
        var prevHash = cellCssClasses[key];
        cellCssClasses[key] = hash;
        updateCellCssStylesOnRenderedRows(hash, prevHash);
        trigger(self.onCellCssStylesChanged, {
            "key": key,
            "hash": hash,
            "grid": self
        });
    }
    function getCellCssStyles(key) {
        return cellCssClasses[key];
    }
    function flashCell(row, cell, speed, times) {
        speed = speed || 100;
        if (rowsCache[row]) {
            var $cell_1 = $7adda6f44168d508$var$$(getCellNode(row, cell));
            var toggleCellClass_1 = function(remaining) {
                if (!remaining) return;
                $cell_1.toggleClass(options.cellFlashingCssClass);
                setTimeout(function() {
                    toggleCellClass_1(remaining - 1);
                }, speed);
            };
            toggleCellClass_1((times || 4) * 2);
        }
    }
    function handleDragInit(e, dd) {
        var cell = getCellFromEvent(e);
        if (!cell || !cellExists(cell.row, cell.cell)) return false;
        // var retval = trigger(self.onDragInit, dd, e);
        trigger(self.onDragInit, dd, e);
    // if (e.isImmediatePropagationStopped()) {
    //   return retval;
    // }
    // // if nobody claims to be handling drag'n'drop by stopping immediate propagation,
    // // cancel out of it
    // return false;
    }
    function handleDragStart(e, dd) {
        var cell = getCellFromEvent(e);
        if (!cell || !cellExists(cell.row, cell.cell)) return false;
        var retval = trigger(self.onDragStart, dd, e);
        if (e.isImmediatePropagationStopped()) return retval;
        return false;
    }
    function handleDrag(e, dd) {
        return trigger(self.onDrag, dd, e);
    }
    function handleDragEnd(e, dd) {
        trigger(self.onDragEnd, dd, e);
    }
    function handleKeyDown(e) {
        trigger(self.onKeyDown, {
            row: activeRow,
            cell: activeCell
        }, e);
        var handled = e.isImmediatePropagationStopped();
        var keyCode = (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).keyCode;
        if (!handled) {
            if (!e.shiftKey && !e.altKey) {
                if (options.editable && currentEditor && currentEditor.keyCaptureList) {
                    if (typeof currentEditor.keyCaptureList === "function") {
                        if (currentEditor.keyCaptureList(e.which) === false) return;
                    } else if (currentEditor.keyCaptureList.indexOf(e.which) > -1) return;
                }
                if (e.which == keyCode.HOME) handled = e.ctrlKey ? navigateTop() : navigateRowStart();
                else if (e.which == keyCode.END) handled = e.ctrlKey ? navigateBottom() : navigateRowEnd();
            }
        }
        if (!handled) {
            if (!e.shiftKey && !e.altKey && !e.ctrlKey) {
                // editor may specify an array of keys to bubble
                if (options.editable && currentEditor && currentEditor.keyCaptureList) {
                    if (typeof currentEditor.keyCaptureList === "function") {
                        if (currentEditor.keyCaptureList(e.which) === false) return;
                    } else if (currentEditor.keyCaptureList.indexOf(e.which) > -1) return;
                }
                if (e.which == keyCode.ESCAPE) {
                    if (!getEditorLock().isActive()) return; // no editing mode to cancel, allow bubbling and default processing (exit without cancelling the event)
                    cancelEditAndSetFocus();
                } else if (e.which == keyCode.PAGE_DOWN) {
                    navigatePageDown();
                    handled = true;
                } else if (e.which == keyCode.PAGE_UP) {
                    navigatePageUp();
                    handled = true;
                } else if (e.which == keyCode.LEFT) handled = navigateLeft();
                else if (e.which == keyCode.RIGHT) handled = navigateRight();
                else if (e.which == keyCode.UP) handled = navigateUp();
                else if (e.which == keyCode.DOWN) handled = navigateDown();
                else if (e.which == keyCode.TAB) handled = navigateNext();
                else if (e.which == keyCode.ENTER) {
                    if (options.editable) {
                        if (currentEditor) {
                            // adding new row
                            if (activeRow === getDataLength()) navigateDown();
                            else commitEditAndNavDown();
                        } else if (getEditorLock().commitCurrentEdit()) makeActiveCellEditable(undefined, undefined, e);
                    }
                    handled = true;
                }
            } else if (e.which == keyCode.TAB && e.shiftKey && !e.ctrlKey && !e.altKey) handled = navigatePrev();
        }
        if (handled) {
            // the event has been handled so don't let parent element (bubbling/propagation) or browser (default) handle it
            e.stopPropagation();
            e.preventDefault();
            try {
                e.originalEvent.keyCode = 0; // prevent default behaviour for special keys in IE browsers (F3, F5, etc.)
            } catch (error) {}
        }
    }
    function handleClick(e) {
        if (!currentEditor) // if this click resulted in some cell child node getting focus,
        // don't steal it back - keyboard events will still bubble up
        // iE9+ seems to default DIVs to tabIndex=0 instead of -1, so check for cell clicks directly.
        {
            if (e.target != document.activeElement || $7adda6f44168d508$var$$(e.target).hasClass("slick-cell")) setFocus();
        }
        var cell = getCellFromEvent(e);
        if (!cell || currentEditor !== null && activeRow == cell.row && activeCell == cell.cell) return;
        trigger(self.onClick, {
            row: cell.row,
            cell: cell.cell
        }, e);
        if (e.isImmediatePropagationStopped()) return;
        // this optimisation causes trouble - MLeibman #329
        // if ((activeCell != cell.cell || activeRow != cell.row) && canCellBeActive(cell.row, cell.cell)) {
        if (canCellBeActive(cell.row, cell.cell)) {
            if (!getEditorLock().isActive() || getEditorLock().commitCurrentEdit()) {
                scrollRowIntoView(cell.row, false);
                var preClickModeOn = e.target && e.target.className === (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).preClickClassName;
                var column = columns[cell.cell];
                var suppressActiveCellChangedEvent = options.editable && column && column.editor && options.suppressActiveCellChangeOnEdit ? true : false;
                setActiveCellInternal(getCellNode(cell.row, cell.cell), null, preClickModeOn, suppressActiveCellChangedEvent, e);
            }
        }
    }
    function handleContextMenu(e) {
        var $cell = $7adda6f44168d508$var$$(e.target).closestClass("slick-cell", "grid-canvas");
        if ($cell.length === 0) return;
        // are we editing this cell?
        if (activeCellNode === $cell[0] && currentEditor !== null) return;
        trigger(self.onContextMenu, {}, e);
    }
    function handleDblClick(e) {
        var cell = getCellFromEvent(e);
        if (!cell || currentEditor !== null && activeRow == cell.row && activeCell == cell.cell) return;
        trigger(self.onDblClick, {
            row: cell.row,
            cell: cell.cell
        }, e);
        if (e.isImmediatePropagationStopped()) return;
        if (options.editable) gotoCell(cell.row, cell.cell, true, e);
    }
    // function handleHeaderMouseEnter(e) {
    //   trigger(self.onHeaderMouseEnter, {
    //     "column": $(this).data("column"),
    //     "grid": self
    //   }, e);
    // }
    // function handleHeaderMouseLeave(e) {
    //   trigger(self.onHeaderMouseLeave, {
    //     "column": $(this).data("column"),
    //     "grid": self
    //   }, e);
    // }
    function handleHeaderContextMenu(e) {
        var $header = $7adda6f44168d508$var$$(e.target).closestClass("slick-header-column", "slick-header-columns");
        var column = $header && $header.data("column");
        trigger(self.onHeaderContextMenu, {
            column: column
        }, e);
    }
    function handleHeaderClick(e) {
        // if (columnResizeDragging) return;
        var $header = $7adda6f44168d508$var$$(e.target).closestClass("slick-header-column", "slick-header-columns");
        var column = $header && $header.data("column");
        if (column) trigger(self.onHeaderClick, {
            column: column
        }, e);
    }
    function handleMouseEnter(e) {
        trigger(self.onMouseEnter, {}, e);
    }
    function handleMouseLeave(e) {
        trigger(self.onMouseLeave, {}, e);
    }
    function cellExists(row, cell) {
        return !(row < 0 || row >= getDataLength() || cell < 0 || cell >= columns.length);
    }
    function getCellFromPoint(x, y) {
        var row = getRowFromPosition(y);
        // tODO TODOFIX -> frozen rows at bottom
        if (hasFrozenRows && y <= getFrozenRowOffset(actualFrozenRow)) row = getRowFromPosition(y - offset);
        var cell = 0;
        var w = 0;
        for(var i = 0; i < columns.length && w < x; i++){
            w += columns[i].width;
            cell++;
        }
        if (cell < 0) cell = 0;
        return {
            row: row,
            cell: cell - 1
        };
    }
    function getCellFromNode(cellNode) {
        // read column number from .l<columnNumber> CSS class
        var cls = /l\d+/.exec(cellNode.className);
        if (!cls) throw new Error("getCellFromNode: cannot get cell - " + cellNode.className);
        return parseInt(cls[0].substr(1, cls[0].length - 1), 10);
    }
    function getRowFromNode(rowNode) {
        for(var row in rowsCache)for(var i in rowsCache[row].rowNode){
            if (rowsCache[row].rowNode[i] === rowNode) return parseInt(row, 10) | 0;
        }
        return null;
    }
    function getFrozenRowOffset(row) {
        var offset = hasFrozenRows ? options.frozenBottom ? row >= actualFrozenRow ? h < viewportTopH ? getRowBottom(actualFrozenRow) // (options.rowHeight * (row+1) - offset)
         : h : 0 : row >= actualFrozenRow ? frozenRowsHeight : 0 : 0;
        return offset;
    }
    function getCellFromEvent(e) {
        var row, cell;
        var $cell = $7adda6f44168d508$var$$(e.target).closestClass("slick-cell", "grid-canvas");
        if (!$cell.length) return null;
        row = getRowFromNode($cell[0].parentNode);
        if (hasFrozenRows) {
            var c = $cell.closestClass("grid-canvas").offset();
            var rowOffset = 0;
            var isBottom = $cell.closestClass("grid-canvas-bottom").length;
            if (isBottom) rowOffset = options.frozenBottom ? $canvasTopL.height() : frozenRowsHeight;
            row = getCellFromPoint(e.clientX - c.left, e.clientY - c.top + rowOffset /* + document.documentElement.scrollTop*/ ).row;
        }
        cell = getCellFromNode($cell[0]);
        if (row == null || cell == null) return null;
        else return {
            "row": row,
            "cell": cell
        };
    }
    function getCellNodeBox(row, cell) {
        if (!cellExists(row, cell)) return null;
        var frozenRowOffset = getFrozenRowOffset(row);
        var y1 = getRowTop(row) - frozenRowOffset;
        var y2 = y1 + getRowHeight(row) - 1;
        var x1 = 0;
        for(var i = 0; i < cell; i++){
            x1 += columns[i].width;
            if (options.frozenColumn == i) x1 = 0;
        }
        var x2 = x1 + columns[cell].width;
        return {
            top: y1,
            left: x1,
            bottom: y2,
            right: x2
        };
    }
    //////////////////////////////////////////////////////////////////////////////////////////////
    // cell switching
    function getRowHeight(row) {
        if (!options.variableRowHeight) return options.rowHeight;
        return rowPositionCache[row].height;
    }
    function resetActiveCell() {
        setActiveCellInternal(null, false);
    }
    function setFocus() {
        if (tabbingDirection == -1) $focusSink[0].focus();
        else $focusSink2[0].focus();
    }
    function scrollCellIntoView(row, cell, doPaging) {
        scrollRowIntoView(row, doPaging);
        if (cell <= options.frozenColumn) return;
        var colspan = getColspan(row, cell);
        internalScrollColumnIntoView(columnPosLeft[cell], columnPosRight[cell + (colspan > 1 ? colspan - 1 : 0)]);
    }
    function internalScrollColumnIntoView(left, right) {
        var scrollRight = scrollLeft + $viewportScrollContainerX.width();
        if (left < scrollLeft) {
            $7adda6f44168d508$var$$.each($viewportScrollContainerX, function(idx, el) {
                el.scrollLeft = left;
            });
            handleScroll();
            render();
        } else if (right > scrollRight) {
            $7adda6f44168d508$var$$.each($viewportScrollContainerX, function(idx, el) {
                el.scrollLeft = Math.min(left, right - $viewportScrollContainerX[0].clientWidth);
            });
            handleScroll();
            render();
        }
    }
    function scrollColumnIntoView(cell) {
        internalScrollColumnIntoView(columnPosLeft[cell], columnPosRight[cell]);
    }
    function setActiveCellInternal(newCell, opt_editMode, preClickModeOn, suppressActiveCellChangedEvent, e) {
        if (activeCellNode !== null) {
            makeActiveCellNormal();
            $7adda6f44168d508$var$$(activeCellNode).removeClass("active");
            if (rowsCache[activeRow]) rowsCache[activeRow].rowNode.forEach(function(x) {
                return x.classList.remove("active");
            }); // $(rowsCache[activeRow].rowNode).removeClass("active");
        }
        var activeCellChanged = activeCellNode !== newCell;
        activeCellNode = newCell;
        if (activeCellNode != null) {
            var $activeCellNode = $7adda6f44168d508$var$$(activeCellNode);
            var $activeCellOffset = $activeCellNode.offset();
            var rowOffset = Math.floor($activeCellNode.closestClass("grid-canvas").offset().top);
            var isBottom = $activeCellNode.closestClass("grid-canvas-bottom").length;
            if (hasFrozenRows && isBottom) rowOffset -= options.frozenBottom ? $canvasTopL.height() : frozenRowsHeight;
            var cell = getCellFromPoint($activeCellOffset.left, Math.ceil($activeCellOffset.top) - rowOffset);
            activeRow = cell.row;
            activeCell = activePosX = activeCell = activePosX = getCellFromNode(activeCellNode);
            $activeCellNode.addClass("active");
            if (rowsCache[activeRow]) rowsCache[activeRow].rowNode.forEach(function(x) {
                return x.classList.add("active");
            }); // $(rowsCache[activeRow].rowNode).addClass('active');
            if (opt_editMode == null) opt_editMode = activeRow == getDataLength() || options.autoEdit;
            if (options.showCellSelection) {
                $7adda6f44168d508$var$$(activeCellNode).addClass("active");
                rowsCache[activeRow].rowNode.forEach(function(x) {
                    return x.classList.add("active");
                }); // $(rowsCache[activeRow].rowNode).addClass("active");
            }
            if (options.editable && opt_editMode && isCellPotentiallyEditable(activeRow, activeCell)) {
                clearTimeout(h_editorLoader);
                if (options.asyncEditorLoading) h_editorLoader = setTimeout(function() {
                    makeActiveCellEditable(undefined, preClickModeOn, e);
                }, options.asyncEditorLoadDelay);
                else makeActiveCellEditable(undefined, preClickModeOn, e);
            }
        } else activeRow = activeCell = null;
        // this optimisation causes trouble - MLeibman #329
        // if (activeCellChanged) {
        if (!suppressActiveCellChangedEvent) trigger(self.onActiveCellChanged, getActiveCell(), e);
    // }
    }
    function clearTextSelection() {
        if (document.selection && document.selection.empty) try {
            // iE fails here if selected element is not in dom
            document.selection.empty();
        } catch (e) {}
        else if (window.getSelection) {
            var sel = window.getSelection();
            if (sel && sel.removeAllRanges) sel.removeAllRanges();
        }
    }
    function isCellPotentiallyEditable(row, cell) {
        var dataLength = getDataLength();
        // is the data for this row loaded?
        if (row < dataLength && !getDataItem(row)) return false;
        // are we in the Add New row?  can we create new from this cell?
        if (columns[cell].cannotTriggerInsert && row >= dataLength) return false;
        // does this cell have an editor?
        if (!getEditor(row, cell) || columns[cell].readonly) return false;
        return true;
    }
    function makeActiveCellNormal() {
        if (!currentEditor) return;
        trigger(self.onBeforeCellEditorDestroy, {
            editor: currentEditor
        });
        currentEditor.destroy();
        currentEditor = null;
        if (activeCellNode) {
            var d = getDataItem(activeRow);
            $7adda6f44168d508$var$$(activeCellNode).removeClass("editable invalid");
            if (d) {
                var column = columns[activeCell];
                var formatter = getFormatter(activeRow, column);
                var formatterResult = formatter(activeRow, activeCell, getDataItemValueForColumn(d, column), column, d, self);
                applyFormatResultToCellNode(formatterResult, activeCellNode);
                if (self.onAppendCell.countHandlers() > 0) {
                    var item = getDataItem(activeRow);
                    var value = getDataItemValueForColumn(item, columns[activeCell]);
                    trigger(self.onAppendCell, {
                        row: activeRow,
                        cell: activeCell,
                        value: value,
                        item: item,
                        column: column,
                        dom: activeCellNode
                    });
                }
                invalidatePostProcessingResults(activeRow);
            }
        }
        // if there previously was text selected on a page (such as selected text in the edit cell just removed),
        // iE can't set focus to anything else correctly
        if (navigator.userAgent.toLowerCase().match(/msie/)) clearTextSelection();
        getEditorLock().deactivate(editController);
    }
    function makeActiveCellEditable(editor, preClickModeOn, e) {
        if (!activeCellNode) return;
        if (!options.editable) throw new Error("Grid : makeActiveCellEditable : should never get called when options.editable is false");
        // cancel pending async call if there is one
        clearTimeout(h_editorLoader);
        if (!isCellPotentiallyEditable(activeRow, activeCell)) return;
        var columnDef = columns[activeCell];
        var item = getDataItem(activeRow);
        if (trigger(self.onBeforeEditCell, {
            row: activeRow,
            cell: activeCell,
            item: item,
            column: columnDef
        }) === false) {
            setFocus();
            return;
        }
        getEditorLock().activate(editController);
        $7adda6f44168d508$var$$(activeCellNode).addClass("editable");
        var useEditor = editor || getEditor(activeRow, activeCell);
        // don't clear the cell if a custom editor is passed through
        if (!editor && !useEditor.suppressClearOnEdit) activeCellNode.innerHTML = "";
        var metadata = data.getItemMetadata && data.getItemMetadata(activeRow);
        metadata = metadata && metadata.columns;
        var columnMetaData = metadata && (metadata[columnDef.id] || metadata[activeCell]);
        currentEditor = new useEditor({
            grid: self,
            gridPosition: absBox($container[0]),
            position: absBox(activeCellNode),
            container: activeCellNode,
            column: columnDef,
            columnMetaData: columnMetaData,
            item: item || {},
            event: e,
            commitChanges: commitEditAndNavDown,
            commitChangesOnly: commitEditAndSetFocus,
            cancelChanges: cancelEditAndSetFocus
        });
        if (item) {
            currentEditor.loadValue(item);
            if (preClickModeOn && currentEditor.preClick) currentEditor.preClick();
        }
        serializedEditorValue = currentEditor.serializeValue();
        if (currentEditor.position) handleActiveCellPositionChange();
    }
    function commitEditAndNavDown() {
        // if the commit fails, it would do so due to a validation error
        // if so, do not steal the focus from the editor
        if (getEditorLock().commitCurrentEdit()) {
            setFocus();
            if (options.autoEdit) navigateDown();
        }
    }
    function commitEditAndSetFocus() {
        // if the commit fails, it would do so due to a validation error
        // if so, do not steal the focus from the editor
        if (getEditorLock().commitCurrentEdit()) setFocus();
    }
    function cancelEditAndSetFocus() {
        if (getEditorLock().cancelCurrentEdit()) setFocus();
    }
    function absBox(elem) {
        var box = {
            top: elem.offsetTop,
            left: elem.offsetLeft,
            bottom: 0,
            right: 0,
            width: $7adda6f44168d508$var$$(elem).width(),
            height: $7adda6f44168d508$var$$(elem).height(),
            visible: true
        };
        box.bottom = box.top + box.height;
        box.right = box.left + box.width;
        // walk up the tree
        var offsetParent = elem.offsetParent;
        while((elem = elem.parentNode) != document.body){
            if (elem == null) break;
            if (box.visible && elem.scrollHeight != elem.offsetHeight && $7adda6f44168d508$var$$(elem).css("overflowY") != "visible") box.visible = box.bottom > elem.scrollTop && box.top < elem.scrollTop + elem.clientHeight;
            if (box.visible && elem.scrollWidth != elem.offsetWidth && $7adda6f44168d508$var$$(elem).css("overflowX") != "visible") box.visible = box.right > elem.scrollLeft && box.left < elem.scrollLeft + elem.clientWidth;
            box.left -= elem.scrollLeft;
            box.top -= elem.scrollTop;
            if (elem === offsetParent) {
                box.left += elem.offsetLeft;
                box.top += elem.offsetTop;
                offsetParent = elem.offsetParent;
            }
            box.bottom = box.top + box.height;
            box.right = box.left + box.width;
        }
        return box;
    }
    function getActiveCellPosition() {
        return absBox(activeCellNode);
    }
    function getGridPosition() {
        return absBox($container[0]);
    }
    function handleActiveCellPositionChange() {
        if (!activeCellNode) return;
        trigger(self.onActiveCellPositionChanged, {});
        if (currentEditor) {
            var cellBox = getActiveCellPosition();
            if (currentEditor.show && currentEditor.hide) {
                if (!cellBox.visible) currentEditor.hide();
                else currentEditor.show();
            }
            if (currentEditor.position) currentEditor.position(cellBox);
        }
    }
    function getCellEditor() {
        return currentEditor;
    }
    function getActiveCell() {
        if (!activeCellNode) return null;
        else return {
            row: activeRow,
            cell: activeCell
        };
    }
    function getActiveCellNode() {
        return activeCellNode;
    }
    function scrollRowIntoView(row, doPaging) {
        if (!hasFrozenRows || !options.frozenBottom && row > actualFrozenRow - 1 || options.frozenBottom && row < actualFrozenRow - 1) {
            var viewportScrollH = $viewportScrollContainerY.height();
            // if frozen row on top
            // subtract number of frozen row
            var rowNumber = hasFrozenRows && !options.frozenBottom ? row - options.frozenRow : row;
            var rowBottom = options.variableRowHeight ? rowPositionCache[row].bottom : (rowNumber + 1) * options.rowHeight;
            var rowAtTop = options.variableRowHeight ? rowPositionCache[row].top : rowNumber * options.rowHeight;
            var rowAtBottom = rowBottom - viewportScrollH + (viewportHasHScroll ? $7adda6f44168d508$var$scrollbarDimensions.height : 0);
            // need to page down?
            if (rowBottom > scrollTop + viewportScrollH + offset) {
                scrollTo(doPaging ? rowAtTop : rowAtBottom);
                render();
            } else if (rowAtTop < scrollTop + offset) {
                scrollTo(doPaging ? rowAtBottom : rowAtTop);
                render();
            }
        }
    }
    function scrollRowToTop(row) {
        scrollTo(options.variableRowHeight ? rowPositionCache[row].top : row * options.rowHeight);
        render();
    }
    function scrollPage(dir) {
        var deltaRows = dir * numVisibleRows;
        /// first fully visible row crosses the line with
        /// y == bottomOfTopmostFullyVisibleRow
        var bottomOfTopmostFullyVisibleRow = scrollTop + options.rowHeight - 1; // tODO
        scrollTo((getRowFromPosition(bottomOfTopmostFullyVisibleRow) + deltaRows) * options.rowHeight); // tODO
        render();
        if (options.enableCellNavigation && activeRow != null) {
            var row = activeRow + deltaRows;
            var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
            if (row >= dataLengthIncludingAddNew) row = dataLengthIncludingAddNew - 1;
            if (row < 0) row = 0;
            var cell = 0, prevCell = null;
            var prevActivePosX = activePosX;
            while(cell <= activePosX){
                if (canCellBeActive(row, cell)) prevCell = cell;
                cell += getColspan(row, cell);
            }
            if (prevCell !== null) {
                setActiveCellInternal(getCellNode(row, prevCell));
                activePosX = prevActivePosX;
            } else resetActiveCell();
        }
    }
    function navigatePageDown() {
        scrollPage(1);
    }
    function navigatePageUp() {
        scrollPage(-1);
    }
    function navigateTop() {
        navigateToRow(0);
    }
    function navigateBottom() {
        navigateToRow(getDataLength() - 1);
    }
    function navigateToRow(row) {
        var num_rows = getDataLength();
        if (!num_rows) return true;
        if (row < 0) row = 0;
        else if (row >= num_rows) row = num_rows - 1;
        scrollCellIntoView(row, 0, true);
        if (options.enableCellNavigation && activeRow != null) {
            var cell = 0, prevCell = null;
            var prevActivePosX = activePosX;
            while(cell <= activePosX){
                if (canCellBeActive(row, cell)) prevCell = cell;
                cell += getColspan(row, cell);
            }
            if (prevCell !== null) {
                setActiveCellInternal(getCellNode(row, prevCell));
                activePosX = prevActivePosX;
            } else resetActiveCell();
        }
        return true;
    }
    function getColspan(row, cell) {
        var metadata = data.getItemMetadata && data.getItemMetadata(row);
        if (!metadata || !metadata.columns) return 1;
        var columnData = metadata.columns[columns[cell].id] || metadata.columns[cell];
        var colspan = columnData && columnData.colspan;
        if (colspan === "*") colspan = columns.length - cell;
        else colspan = colspan || 1;
        return colspan;
    }
    function findFirstFocusableCell(row) {
        var cell = 0;
        while(cell < columns.length){
            if (canCellBeActive(row, cell)) return cell;
            cell += getColspan(row, cell);
        }
        return null;
    }
    function findLastFocusableCell(row) {
        var cell = 0;
        var lastFocusableCell = null;
        while(cell < columns.length){
            if (canCellBeActive(row, cell)) lastFocusableCell = cell;
            cell += getColspan(row, cell);
        }
        return lastFocusableCell;
    }
    function gotoRight(row, cell, posX) {
        if (cell >= columns.length) return null;
        do cell += getColspan(row, cell);
        while (cell < columns.length && !canCellBeActive(row, cell));
        if (cell < columns.length) return {
            "row": row,
            "cell": cell,
            "posX": cell
        };
        return null;
    }
    function gotoLeft(row, cell, posX) {
        if (cell <= 0) return null;
        var firstFocusableCell = findFirstFocusableCell(row);
        if (firstFocusableCell === null || firstFocusableCell >= cell) return null;
        var prev = {
            "row": row,
            "cell": firstFocusableCell,
            "posX": firstFocusableCell
        };
        var pos;
        while(true){
            pos = gotoRight(prev.row, prev.cell, prev.posX);
            if (!pos) return null;
            if (pos.cell >= cell) return prev;
            prev = pos;
        }
    }
    function gotoDown(row, cell, posX) {
        var prevCell;
        var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
        while(true){
            if (++row >= dataLengthIncludingAddNew) return null;
            prevCell = cell = 0;
            while(cell <= posX){
                prevCell = cell;
                cell += getColspan(row, cell);
            }
            if (canCellBeActive(row, prevCell)) return {
                "row": row,
                "cell": prevCell,
                "posX": posX
            };
        }
    }
    function gotoUp(row, cell, posX) {
        var prevCell;
        while(true){
            if (--row < 0) return null;
            prevCell = cell = 0;
            while(cell <= posX){
                prevCell = cell;
                cell += getColspan(row, cell);
            }
            if (canCellBeActive(row, prevCell)) return {
                "row": row,
                "cell": prevCell,
                "posX": posX
            };
        }
    }
    function gotoNext(row, cell, posX) {
        if (row == null && cell == null) {
            row = cell = posX = 0;
            if (canCellBeActive(row, cell)) return {
                "row": row,
                "cell": cell,
                "posX": cell
            };
        }
        var pos = gotoRight(row, cell, posX);
        if (pos) return pos;
        var firstFocusableCell = null;
        var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
        // if at last row, cycle through columns rather than get stuck in the last one
        if (row === dataLengthIncludingAddNew - 1) row--;
        while(++row < dataLengthIncludingAddNew){
            firstFocusableCell = findFirstFocusableCell(row);
            if (firstFocusableCell !== null) return {
                "row": row,
                "cell": firstFocusableCell,
                "posX": firstFocusableCell
            };
        }
        return null;
    }
    function gotoPrev(row, cell, posX) {
        if (row == null && cell == null) {
            row = getDataLengthIncludingAddNew() - 1;
            cell = posX = columns.length - 1;
            if (canCellBeActive(row, cell)) return {
                "row": row,
                "cell": cell,
                "posX": cell
            };
        }
        var pos;
        var lastSelectableCell;
        while(!pos){
            pos = gotoLeft(row, cell, posX);
            if (pos) break;
            if (--row < 0) return null;
            cell = 0;
            lastSelectableCell = findLastFocusableCell(row);
            if (lastSelectableCell !== null) pos = {
                "row": row,
                "cell": lastSelectableCell,
                "posX": lastSelectableCell
            };
        }
        return pos;
    }
    function gotoRowStart(row, cell, posX) {
        var newCell = findFirstFocusableCell(row);
        if (newCell === null) return null;
        return {
            "row": row,
            "cell": newCell,
            "posX": newCell
        };
    }
    function gotoRowEnd(row, cell, posX) {
        var newCell = findLastFocusableCell(row);
        if (newCell === null) return null;
        return {
            "row": row,
            "cell": newCell,
            "posX": newCell
        };
    }
    function navigateRight() {
        return navigate("right");
    }
    function navigateLeft() {
        return navigate("left");
    }
    function navigateDown() {
        return navigate("down");
    }
    function navigateUp() {
        return navigate("up");
    }
    function navigateNext() {
        return navigate("next");
    }
    function navigatePrev() {
        return navigate("prev");
    }
    function navigateRowStart() {
        return navigate("home");
    }
    function navigateRowEnd() {
        return navigate("end");
    }
    /**
     * @param {string} dir Navigation direction.
     * @return {boolean} Whether navigation resulted in a change of active cell.
     */ function navigate(dir) {
        if (!options.enableCellNavigation) return false;
        if (!activeCellNode && dir != "prev" && dir != "next") return false;
        if (!getEditorLock().commitCurrentEdit()) return true;
        setFocus();
        var tabbingDirections = {
            "up": -1,
            "down": 1,
            "left": -1,
            "right": 1,
            "prev": -1,
            "next": 1,
            "home": -1,
            "end": 1
        };
        tabbingDirection = tabbingDirections[dir];
        var stepFunctions = {
            "up": gotoUp,
            "down": gotoDown,
            "left": gotoLeft,
            "right": gotoRight,
            "prev": gotoPrev,
            "next": gotoNext,
            "home": gotoRowStart,
            "end": gotoRowEnd
        };
        var stepFn = stepFunctions[dir];
        var pos = stepFn(activeRow, activeCell, activePosX);
        if (pos) {
            if (hasFrozenRows && options.frozenBottom && pos.row == getDataLength()) return;
            var isAddNewRow = pos.row == getDataLength();
            if (!options.frozenBottom && pos.row >= actualFrozenRow || options.frozenBottom && pos.row < actualFrozenRow) scrollCellIntoView(pos.row, pos.cell, !isAddNewRow && options.emulatePagingWhenScrolling);
            setActiveCellInternal(getCellNode(pos.row, pos.cell));
            activePosX = pos.posX;
            return true;
        } else {
            setActiveCellInternal(getCellNode(activeRow, activeCell));
            return false;
        }
    }
    function getCellNode(row, cell) {
        if (rowsCache[row]) {
            ensureCellNodesInRowsCache(row);
            // try {
            //  return rowsCache[row].cellNodesByColumnIdx[cell][0];
            // } catch (e) {
            return rowsCache[row].cellNodesByColumnIdx[cell];
        // }
        }
        return null;
    }
    function setActiveCell(row, cell, opt_editMode, preClickModeOn, suppressActiveCellChangedEvent) {
        if (!initialized) return;
        if (row > getDataLength() || row < 0 || cell >= columns.length || cell < 0) return;
        if (!options.enableCellNavigation) return;
        scrollCellIntoView(row, cell, false);
        setActiveCellInternal(getCellNode(row, cell), opt_editMode, preClickModeOn, suppressActiveCellChangedEvent);
    }
    function canCellBeActive(row, cell) {
        if (!options.enableCellNavigation || row >= getDataLengthIncludingAddNew() || row < 0 || cell >= columns.length || cell < 0) return false;
        var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
        if (rowMetadata && typeof rowMetadata.focusable !== "undefined") return !!rowMetadata.focusable;
        var columnMetadata = rowMetadata && rowMetadata.columns;
        if (columnMetadata && columnMetadata[columns[cell].id] && typeof columnMetadata[columns[cell].id].focusable !== "undefined") return !!columnMetadata[columns[cell].id].focusable;
        if (columnMetadata && columnMetadata[cell] && typeof columnMetadata[cell].focusable !== "undefined") return !!columnMetadata[cell].focusable;
        return !!columns[cell].focusable;
    }
    function canCellBeSelected(row, cell) {
        if (row >= getDataLength() || row < 0 || cell >= columns.length || cell < 0) return false;
        var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
        if (rowMetadata && typeof rowMetadata.selectable !== "undefined") return !!rowMetadata.selectable;
        var columnMetadata = rowMetadata && rowMetadata.columns && (rowMetadata.columns[columns[cell].id] || rowMetadata.columns[cell]);
        if (columnMetadata && typeof columnMetadata.selectable !== "undefined") return !!columnMetadata.selectable;
        return !!columns[cell].selectable;
    }
    function gotoCell(row, cell, forceEdit, e) {
        if (!initialized) return;
        if (!canCellBeActive(row, cell)) return;
        if (!getEditorLock().commitCurrentEdit()) return;
        scrollCellIntoView(row, cell, false);
        var newCell = getCellNode(row, cell);
        // if selecting the 'add new' row, start editing right away
        var column = columns[cell];
        var suppressActiveCellChangedEvent = !!(options.editable && column && column.editor && options.suppressActiveCellChangeOnEdit);
        setActiveCellInternal(newCell, forceEdit || row === getDataLength() || options.autoEdit, null, suppressActiveCellChangedEvent, e);
        // if no editor was created, set the focus back on the grid
        if (!currentEditor) setFocus();
    }
    //////////////////////////////////////////////////////////////////////////////////////////////
    // iEditor implementation for the editor lock
    function commitCurrentEdit() {
        var item = getDataItem(activeRow);
        var column = columns[activeCell];
        if (currentEditor) {
            if (currentEditor.isValueChanged()) {
                var validationResults = currentEditor.validate();
                if (validationResults.valid) {
                    if (activeRow < getDataLength()) {
                        var editCommand = {
                            row: activeRow,
                            cell: activeCell,
                            editor: currentEditor,
                            serializedValue: currentEditor.serializeValue(),
                            prevSerializedValue: serializedEditorValue,
                            execute: function() {
                                this.editor.applyValue(item, this.serializedValue);
                                updateRow(this.row);
                                trigger(self.onCellChange, {
                                    row: this.row,
                                    cell: this.cell,
                                    item: item,
                                    value: this.serializedValue
                                });
                            },
                            undo: function() {
                                this.editor.applyValue(item, this.prevSerializedValue);
                                updateRow(this.row);
                                trigger(self.onCellChange, {
                                    row: this.row,
                                    cell: this.cell,
                                    item: item,
                                    value: this.prevSerializedValue
                                });
                            }
                        };
                        if (options.editCommandHandler) {
                            makeActiveCellNormal();
                            options.editCommandHandler(item, column, editCommand);
                        } else {
                            editCommand.execute();
                            makeActiveCellNormal();
                        }
                    } else {
                        var newItem = {};
                        currentEditor.applyValue(newItem, currentEditor.serializeValue());
                        makeActiveCellNormal();
                        trigger(self.onAddNewRow, {
                            item: newItem,
                            column: column
                        });
                    }
                    // check whether the lock has been re-acquired by event handlers
                    return !getEditorLock().isActive();
                } else {
                    // re-add the CSS class to trigger transitions, if any.
                    $7adda6f44168d508$var$$(activeCellNode).removeClass("invalid");
                    $7adda6f44168d508$var$$(activeCellNode).width(); // force layout
                    $7adda6f44168d508$var$$(activeCellNode).addClass("invalid");
                    trigger(self.onValidationError, {
                        editor: currentEditor,
                        cellNode: activeCellNode,
                        validationResults: validationResults,
                        row: activeRow,
                        cell: activeCell,
                        column: column
                    });
                    currentEditor.focus();
                    return false;
                }
            }
            makeActiveCellNormal();
        }
        return true;
    }
    function cancelCurrentEdit() {
        makeActiveCellNormal();
        return true;
    }
    function rowsToRanges(rows) {
        var ranges = [];
        var lastCell = columns.length - 1;
        for(var i = 0; i < rows.length; i++)ranges.push(new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Range(rows[i], 0, rows[i], lastCell));
        return ranges;
    }
    function getSelectedRows() {
        if (!selectionModel) throw new Error("Selection model is not set");
        return selectedRows;
    }
    function setSelectedRows(rows) {
        if (!selectionModel) throw new Error("Selection model is not set");
        // if (self && self.getEditorLock && !self.getEditorLock().isActive()) {
        selectionModel.setSelectedRanges(rowsToRanges(rows));
    // }
    }
    //////////////////////////////////////////////////////////////////////////////////////////////
    // public API
    $7adda6f44168d508$var$$.shallowExtend(this, {
        "slickGridVersion": "2.4.7",
        // events
        "onScroll": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onSort": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        // "onHeaderMouseEnter": new Slick.Event(),
        // "onHeaderMouseLeave": new Slick.Event(),
        "onHeaderContextMenu": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onHeaderClick": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onHeaderCellRendered": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onBeforeHeaderCellDestroy": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onHeaderRowCellRendered": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onFooterRowCellRendered": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onBeforeHeaderRowCellDestroy": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onBeforeFooterRowCellDestroy": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onMouseEnter": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onMouseLeave": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onClick": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onDblClick": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onContextMenu": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onKeyDown": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onAddNewRow": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onAppendCell": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onValidationError": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onViewportChanged": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onColumnsReordered": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onColumnsResized": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onCellChange": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onBeforeEditCell": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onBeforeCellEditorDestroy": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onBeforeDestroy": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onActiveCellChanged": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onActiveCellPositionChanged": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onDragInit": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onDragStart": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onDrag": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onDragEnd": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onSelectedRowsChanged": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onCellCssStylesChanged": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onAutosizeColumns": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onRendered": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onAppendRow": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onBeforeRemoveRow": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        // methods
        "registerPlugin": registerPlugin,
        "unregisterPlugin": unregisterPlugin,
        "getPluginByName": getPluginByName,
        "getColumns": getColumns,
        "setColumns": setColumns,
        "getColumnIndex": getColumnIndex,
        "getColumnById": getColumnById,
        "updateColumnHeader": updateColumnHeader,
        "setSortColumn": setSortColumn,
        "setSortColumns": setSortColumns,
        "getSortColumns": getSortColumns,
        "autosizeColumns": autosizeColumns,
        "getOptions": getOptions,
        "setOptions": setOptions,
        "getData": getData,
        "getDataLength": getDataLength,
        "getDataItem": getDataItem,
        "setData": setData,
        "getSelectionModel": getSelectionModel,
        "setSelectionModel": setSelectionModel,
        "getSelectedRows": getSelectedRows,
        "setSelectedRows": setSelectedRows,
        "getContainerNode": getContainerNode,
        "updatePagingStatusFromView": updatePagingStatusFromView,
        "applyFormatResultToCellNode": applyFormatResultToCellNode,
        "render": render,
        "invalidate": invalidate,
        "invalidateRow": invalidateRow,
        "invalidateRows": invalidateRows,
        "invalidateAllRows": invalidateAllRows,
        "updateCell": updateCell,
        "updateRow": updateRow,
        "getViewport": getVisibleRange,
        "getRenderedRange": getRenderedRange,
        "resizeCanvas": resizeCanvas,
        "updateRowCount": updateRowCount,
        "scrollRowIntoView": scrollRowIntoView,
        "scrollRowToTop": scrollRowToTop,
        "scrollCellIntoView": scrollCellIntoView,
        "scrollColumnIntoView": scrollColumnIntoView,
        "getCanvasNode": getCanvasNode,
        "getUID": getUID,
        "getHeaderColumnWidthDiff": getHeaderColumnWidthDiff,
        "getScrollbarDimensions": getScrollbarDimensions,
        "getHeadersWidth": getHeadersWidth,
        "getCanvasWidth": getCanvasWidth,
        "getCanvases": getCanvases,
        "getActiveCanvasNode": getActiveCanvasNode,
        "setActiveCanvasNode": setActiveCanvasNode,
        "getViewportNode": getViewportNode,
        "getActiveViewportNode": getActiveViewportNode,
        "setActiveViewportNode": setActiveViewportNode,
        "focus": setFocus,
        "scrollTo": scrollTo,
        "getCellFromPoint": getCellFromPoint,
        "getCellFromEvent": getCellFromEvent,
        "getActiveCell": getActiveCell,
        "setActiveCell": setActiveCell,
        "getActiveCellNode": getActiveCellNode,
        "getActiveCellPosition": getActiveCellPosition,
        "resetActiveCell": resetActiveCell,
        "editActiveCell": makeActiveCellEditable,
        "getCellEditor": getCellEditor,
        "getCellNode": getCellNode,
        "getCellNodeBox": getCellNodeBox,
        "canCellBeSelected": canCellBeSelected,
        "canCellBeActive": canCellBeActive,
        "navigatePrev": navigatePrev,
        "navigateNext": navigateNext,
        "navigateUp": navigateUp,
        "navigateDown": navigateDown,
        "navigateLeft": navigateLeft,
        "navigateRight": navigateRight,
        "navigatePageUp": navigatePageUp,
        "navigatePageDown": navigatePageDown,
        "navigateTop": navigateTop,
        "navigateBottom": navigateBottom,
        "navigateRowStart": navigateRowStart,
        "navigateRowEnd": navigateRowEnd,
        "gotoCell": gotoCell,
        "getTopPanel": getTopPanel,
        "setTopPanelVisibility": setTopPanelVisibility,
        "getPreHeaderPanel": getPreHeaderPanel,
        "getPreHeaderPanelRight": getPreHeaderPanelRight,
        "setPreHeaderPanelVisibility": setPreHeaderPanelVisibility,
        "getHeader": getHeader,
        "getHeaderColumn": getHeaderColumn,
        "setHeaderRowVisibility": setHeaderRowVisibility,
        "getHeaderRow": getHeaderRow,
        "getHeaderRowColumn": getHeaderRowColumn,
        "setFooterRowVisibility": setFooterRowVisibility,
        "getFooterRow": getFooterRow,
        "getFooterRowColumn": getFooterRowColumn,
        "getGridPosition": getGridPosition,
        "flashCell": flashCell,
        "addCellCssStyles": addCellCssStyles,
        "setCellCssStyles": setCellCssStyles,
        "removeCellCssStyles": removeCellCssStyles,
        "getCellCssStyles": getCellCssStyles,
        "getFrozenRowOffset": getFrozenRowOffset,
        "getDataItemValueForColumn": getDataItemValueForColumn,
        "init": finishInitialization,
        "destroy": destroy,
        // iEditor implementation
        "getEditorLock": getEditorLock,
        "getEditController": getEditController
    });
    init();
}




var $db3a1ddf1e35945b$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
// register namespace
$db3a1ddf1e35945b$var$$.deepExtend(window, {
    "Slick": {
        "RowSelectionModel": $db3a1ddf1e35945b$export$74355f455fb26b7b
    }
});
function $db3a1ddf1e35945b$export$74355f455fb26b7b(options) {
    var _grid;
    var _ranges = [];
    var _self = this;
    var _handler = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).EventHandler();
    var _inHandler;
    var _options;
    var _defaults = {
        selectActiveRow: true
    };
    function init(grid) {
        _options = $db3a1ddf1e35945b$var$$.deepExtend({}, _defaults, options);
        _grid = grid;
        _handler.subscribe(_grid.onActiveCellChanged, wrapHandler(handleActiveCellChange));
        _handler.subscribe(_grid.onKeyDown, wrapHandler(handleKeyDown));
        _handler.subscribe(_grid.onClick, wrapHandler(handleClick));
    }
    function destroy() {
        _handler.unsubscribeAll();
    }
    function wrapHandler(handler) {
        return function() {
            if (!_inHandler) {
                _inHandler = true;
                handler.apply(this, arguments);
                _inHandler = false;
            }
        };
    }
    function rangesToRows(ranges) {
        var rows = [];
        for(var i = 0; i < ranges.length; i++)for(var j = ranges[i].fromRow; j <= ranges[i].toRow; j++)rows.push(j);
        return rows;
    }
    function rowsToRanges(rows) {
        var ranges = [];
        var lastCell = _grid.getColumns().length - 1;
        for(var i = 0; i < rows.length; i++)ranges.push(new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Range(rows[i], 0, rows[i], lastCell));
        return ranges;
    }
    function getRowsRange(from, to) {
        var i, rows = [];
        for(i = from; i <= to; i++)rows.push(i);
        for(i = to; i < from; i++)rows.push(i);
        return rows;
    }
    function getSelectedRows() {
        return rangesToRows(_ranges);
    }
    function setSelectedRows(rows) {
        setSelectedRanges(rowsToRanges(rows));
    }
    function setSelectedRanges(ranges) {
        // simple check for: empty selection didn't change, prevent firing onSelectedRangesChanged
        if ((!_ranges || _ranges.length === 0) && (!ranges || ranges.length === 0)) return;
        _ranges = ranges;
        _self.onSelectedRangesChanged.notify(_ranges);
    }
    function getSelectedRanges() {
        return _ranges;
    }
    function handleActiveCellChange(e, data) {
        if (_options.selectActiveRow && data.row != null) setSelectedRanges([
            new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Range(data.row, 0, data.row, _grid.getColumns().length - 1)
        ]);
    }
    function handleKeyDown(e) {
        var activeRow = _grid.getActiveCell();
        if (_grid.getOptions().multiSelect && activeRow && e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey && (e.which == (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).keyCode.UP || e.which == (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).keyCode.DOWN)) {
            var selectedRows = getSelectedRows();
            selectedRows.sort(function(x, y) {
                return x - y;
            });
            if (!selectedRows.length) selectedRows = [
                activeRow.row
            ];
            var top = selectedRows[0];
            var bottom = selectedRows[selectedRows.length - 1];
            var active;
            if (e.which == (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).keyCode.DOWN) active = activeRow.row < bottom || top == bottom ? ++bottom : ++top;
            else active = activeRow.row < bottom ? --bottom : --top;
            if (active >= 0 && active < _grid.getDataLength()) {
                _grid.scrollRowIntoView(active);
                var tempRanges = rowsToRanges(getRowsRange(top, bottom));
                setSelectedRanges(tempRanges);
            }
            e.preventDefault();
            e.stopPropagation();
        }
    }
    function handleClick(e) {
        var cell = _grid.getCellFromEvent(e);
        if (!cell || !_grid.canCellBeActive(cell.row, cell.cell)) return false;
        if (!_grid.getOptions().multiSelect || !e.ctrlKey && !e.shiftKey && !e.metaKey) return false;
        var selection = rangesToRows(_ranges);
        var idx = selection.indexOf(cell.row);
        //var idx = $.inArray(cell.row, selection);
        if (idx === -1 && (e.ctrlKey || e.metaKey)) {
            selection.push(cell.row);
            _grid.setActiveCell(cell.row, cell.cell);
        } else if (idx !== -1 && (e.ctrlKey || e.metaKey)) {
            selection = selection.filter(function(o, i) {
                return o !== cell.row;
            });
            _grid.setActiveCell(cell.row, cell.cell);
        } else if (selection.length && e.shiftKey) {
            var last = selection.pop();
            var from = Math.min(cell.row, last);
            var to = Math.max(cell.row, last);
            selection = [];
            for(var i = from; i <= to; i++)if (i !== last) selection.push(i);
            selection.push(last);
            _grid.setActiveCell(cell.row, cell.cell);
        }
        var tempRanges = rowsToRanges(selection);
        setSelectedRanges(tempRanges);
        e.stopImmediatePropagation();
        return true;
    }
    $db3a1ddf1e35945b$var$$.shallowExtend(this, {
        "getSelectedRows": getSelectedRows,
        "setSelectedRows": setSelectedRows,
        "getSelectedRanges": getSelectedRanges,
        "setSelectedRanges": setSelectedRanges,
        "init": init,
        "destroy": destroy,
        "pluginName": "RowSelectionModel",
        "onSelectedRangesChanged": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event()
    });
}




var $44a0f294ad0c9e06$var$__assign = undefined && undefined.__assign || function() {
    $44a0f294ad0c9e06$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $44a0f294ad0c9e06$var$__assign.apply(this, arguments);
};
var $44a0f294ad0c9e06$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
function $44a0f294ad0c9e06$export$5e15d737b33a1c27(options) {
    var self = this;
    var defaults = {
        groupItemMetadataProvider: null,
        inlineFilters: false
    };
    // private
    var idProperty = "id"; // property holding a unique row id
    var items = []; // data by index
    var rows = []; // data by row
    var idxById = {}; // indexes by id
    var rowsById = null; // rows by id; lazy-calculated
    var filter = null; // filter function
    var updated = null; // updated item ids
    var suspend = false; // suspends the recalculation
    var sortAsc = true;
    // var fastSortField;
    var sortComparer;
    var refreshHints = {};
    var prevRefreshHints = {};
    var filterArgs;
    var filteredItems = [];
    // let compiledFilter;
    // let compiledFilterWithCaching;
    var filterCache = [];
    // grouping
    var groupingInfoDefaults = {
        getter: null,
        formatter: null,
        comparer: function(a, b) {
            return a.value === b.value ? 0 : a.value > b.value ? 1 : -1;
        },
        predefinedValues: [],
        aggregators: [],
        aggregateEmpty: false,
        aggregateCollapsed: false,
        aggregateChildGroups: false,
        collapsed: false,
        displayTotalsRow: true,
        lazyTotalsCalculation: false
    };
    var groupingInfos = [];
    var groups = [];
    var toggledGroupsByLevel = [];
    var groupingDelimiter = ":|:";
    var pagesize = 0;
    var pagenum = 0;
    var totalRows = 0;
    // events
    var onRowCountChanged = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event();
    var onRowsChanged = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event();
    var onRowsOrCountChanged = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event();
    var onPagingInfoChanged = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event();
    options = $44a0f294ad0c9e06$var$$.deepExtend({}, defaults, options);
    function beginUpdate() {
        suspend = true;
    }
    function endUpdate() {
        suspend = false;
        refresh();
    }
    function setRefreshHints(hints) {
        refreshHints = hints;
    }
    function setFilterArgs(args) {
        filterArgs = args;
    }
    function updateIdxById(startingIndex) {
        startingIndex = startingIndex || 0;
        var id;
        for(var i = startingIndex, l = items.length; i < l; i++){
            id = items[i][idProperty];
            if (id === undefined) // throw new Error("Each data element must implement a unique 'id' property");
            throw new Error("Id (" + idProperty + ") of element at index " + i + " was undefined");
            idxById[id] = i;
        }
    }
    function ensureIdUniqueness() {
        var id;
        for(var i = 0, l = items.length; i < l; i++){
            id = items[i][idProperty];
            if (id === undefined) throw new Error("Id (" + idProperty + ") of element at index " + i + " was undefined");
            else if (idxById[id] !== i) throw new Error("Duplicate id (" + idProperty + ") for " + id + " found at index (" + idxById[id] + ", " + i + ")");
        }
    }
    function getItems() {
        return items;
    }
    function setItems(data, objectIdProperty) {
        if (objectIdProperty !== undefined) idProperty = objectIdProperty;
        items = filteredItems = data;
        idxById = {};
        updateIdxById();
        ensureIdUniqueness();
        refresh();
    }
    function setPagingOptions(args) {
        if (args.pageSize != undefined) {
            pagesize = args.pageSize;
            pagenum = pagesize ? Math.min(pagenum, Math.max(0, Math.ceil(totalRows / pagesize) - 1)) : 0;
        }
        if (args.pageNum != undefined) pagenum = Math.min(args.pageNum, Math.max(0, Math.ceil(totalRows / pagesize) - 1));
        onPagingInfoChanged.notify(getPagingInfo(), null, self);
        refresh();
    }
    function getPagingInfo() {
        var totalPages = pagesize ? Math.max(1, Math.ceil(totalRows / pagesize)) : 1;
        return {
            pageSize: pagesize,
            pageNum: pagenum,
            totalRows: totalRows,
            totalPages: totalPages,
            dataView: self
        };
    }
    function sort(comparer, ascending) {
        sortAsc = ascending;
        sortComparer = comparer;
        // fastSortField = null;
        if (ascending === false) items.reverse();
        items.sort(comparer);
        if (ascending === false) items.reverse();
        idxById = {};
        updateIdxById();
        refresh();
    }
    function reSort() {
        if (sortComparer) sort(sortComparer, sortAsc);
    }
    function getFilteredItems() {
        return filteredItems;
    }
    function getFilter() {
        return filter;
    }
    function setFilter(filterFn) {
        filter = filterFn;
        // if (options.inlineFilters) {
        //   compiledFilter = compileFilter();
        //   compiledFilterWithCaching = compileFilterWithCaching();
        // }
        refresh();
    }
    function getGrouping() {
        return groupingInfos;
    }
    function setGrouping(groupingInfo) {
        if (!options.groupItemMetadataProvider) options.groupItemMetadataProvider = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Data.GroupItemMetadataProvider();
        groups = [];
        toggledGroupsByLevel = [];
        groupingInfo = groupingInfo || [];
        groupingInfos = groupingInfo instanceof Array ? groupingInfo : [
            groupingInfo
        ];
        for(var i = 0; i < groupingInfos.length; i++){
            var gi = groupingInfos[i] = $44a0f294ad0c9e06$var$$.deepExtend({}, groupingInfoDefaults, groupingInfos[i]);
            gi.getterIsAFn = typeof gi.getter === "function";
            // pre-compile accumulator loops
            gi.compiledAccumulators = [];
            var idx = gi.aggregators.length;
            while(idx--)gi.compiledAccumulators[idx] = compileAccumulatorLoop(gi.aggregators[idx]);
            toggledGroupsByLevel[i] = {};
        }
        refresh();
    }
    /**
     * @deprecated Please use {@link setGrouping}.
     */ function groupBy(valueGetter, valueFormatter, sortComparer) {
        if (valueGetter == null) {
            setGrouping([]);
            return;
        }
        setGrouping({
            getter: valueGetter,
            formatter: valueFormatter,
            comparer: sortComparer
        });
    }
    /**
     * @deprecated Please use {@link setGrouping}.
     */ function setAggregators(groupAggregators, includeCollapsed) {
        if (!groupingInfos.length) throw new Error("At least one grouping must be specified before calling setAggregators().");
        groupingInfos[0].aggregators = groupAggregators;
        groupingInfos[0].aggregateCollapsed = includeCollapsed;
        setGrouping(groupingInfos);
    }
    function getItemByIdx(i) {
        return items[i];
    }
    function getIdxById(id) {
        return idxById[id];
    }
    function getIdxByItem(item) {
        return idxById[item[idProperty]];
    }
    function ensureRowsByIdCache() {
        if (!rowsById) {
            rowsById = {};
            for(var i = 0, l = rows.length; i < l; i++)rowsById[rows[i][idProperty]] = i;
        }
    }
    function getRowByItem(item) {
        ensureRowsByIdCache();
        return rowsById[item[idProperty]];
    }
    function getRowById(id) {
        ensureRowsByIdCache();
        return rowsById[id];
    }
    function getItemById(id) {
        return items[idxById[id]];
    }
    function mapItemsToRows(itemArray) {
        var rows = [];
        ensureRowsByIdCache();
        for(var i = 0, l = itemArray.length; i < l; i++){
            var row = rowsById[itemArray[i][idProperty]];
            if (row != null) rows[rows.length] = row;
        }
        return rows;
    }
    function mapIdsToRows(idArray) {
        var rows = [];
        ensureRowsByIdCache();
        for(var i = 0, l = idArray.length; i < l; i++){
            var row = rowsById[idArray[i]];
            if (row != null) rows[rows.length] = row;
        }
        return rows;
    }
    function mapRowsToIds(rowArray) {
        var ids = [];
        for(var i = 0, l = rowArray.length; i < l; i++)if (rowArray[i] < rows.length) ids[ids.length] = rows[rowArray[i]][idProperty];
        return ids;
    }
    function updateItem(id, item) {
        // see also https://github.com/mleibman/SlickGrid/issues/1082
        if (idxById[id] === undefined) throw new Error("Invalid id");
        // what if the specified item also has an updated idProperty?
        // then we'll have to update the index as well, and possibly the `updated` cache too.
        if (id !== item[idProperty]) {
            // make sure the new id is unique:
            var newId = item[idProperty];
            if (newId == null) throw new Error("Cannot update item to associate with a null id");
            if (idxById[newId] !== undefined) throw new Error("Cannot update item to associate with a non-unique id");
            idxById[newId] = idxById[id];
            delete idxById[id];
            // also update the `updated` hashtable/markercache? Yes, `recalc()` inside `refresh()` needs that one!
            if (updated && updated[id]) delete updated[id];
            // also update the row indexes? no need since the `refresh()`, further down, blows away the `rowsById[]` cache!
            id = newId;
        }
        items[idxById[id]] = item;
        // also update the rows? no need since the `refresh()`, further down, blows away the `rows[]` cache and recalculates it via `recalc()`!
        if (!updated) updated = {};
        updated[id] = true;
        refresh();
    }
    function insertItem(insertBefore, item) {
        items.splice(insertBefore, 0, item);
        updateIdxById(insertBefore);
        refresh();
    }
    function addItem(item) {
        items.push(item);
        updateIdxById(items.length - 1);
        refresh();
    }
    function deleteItem(id) {
        var idx = idxById[id];
        if (idx === undefined) throw new Error("Invalid id");
        delete idxById[id];
        items.splice(idx, 1);
        updateIdxById(idx);
        refresh();
    }
    function sortedAddItem(item) {
        if (!sortComparer) throw new Error("sortedAddItem() requires a sort comparer, use sort()");
        insertItem(sortedIndex(item), item);
    }
    function sortedUpdateItem(id, item) {
        if (idxById[id] === undefined || id !== item[idProperty]) throw new Error("Invalid or non-matching id " + idxById[id]);
        if (!sortComparer) throw new Error("sortedUpdateItem() requires a sort comparer, use sort()");
        var oldItem = getItemById(id);
        if (sortComparer(oldItem, item) !== 0) {
            // item affects sorting -> must use sorted add
            deleteItem(id);
            sortedAddItem(item);
        } else updateItem(id, item);
    }
    function sortedIndex(searchItem) {
        var low = 0, high = items.length;
        while(low < high){
            var mid = low + high >>> 1;
            if (sortComparer(items[mid], searchItem) === -1) low = mid + 1;
            else high = mid;
        }
        return low;
    }
    function getLength() {
        return rows.length;
    }
    function getItem(i) {
        var item = rows[i];
        // if this is a group row, make sure totals are calculated and update the title
        if (item && item.__group && item.totals && !item.totals.initialized) {
            var gi = groupingInfos[item.level];
            if (!gi.displayTotalsRow) {
                calculateTotals(item.totals);
                item.title = gi.formatter ? gi.formatter(item) : item.value;
            }
        } else if (item && item.__groupTotals && !item.initialized) calculateTotals(item);
        return item;
    }
    function getItemMetadata(i) {
        var item = rows[i];
        if (item === undefined) return null;
        // overrides for grouping rows
        if (item.__group) return options.groupItemMetadataProvider.getGroupRowMetadata(item);
        // overrides for totals rows
        if (item.__groupTotals) return options.groupItemMetadataProvider.getTotalsRowMetadata(item);
        if (item.__height) {
            if (item.getItemMetadata != null) return $44a0f294ad0c9e06$var$__assign({
                height: item.__height
            }, item.getItemMetadata || {});
            return {
                height: item.__height
            };
        }
        return item.getItemMetadata != null ? item.getItemMetadata(i, item) : null;
    }
    function expandCollapseAllGroups(level, collapse) {
        if (level == null) for(var i = 0; i < groupingInfos.length; i++){
            toggledGroupsByLevel[i] = {};
            groupingInfos[i].collapsed = collapse;
        }
        else {
            toggledGroupsByLevel[level] = {};
            groupingInfos[level].collapsed = collapse;
        }
        refresh();
    }
    /**
     * @param level {Number} Optional level to collapse.  If not specified, applies to all levels.
     */ function collapseAllGroups(level) {
        expandCollapseAllGroups(level, true);
    }
    /**
     * @param level {Number} Optional level to expand.  If not specified, applies to all levels.
     */ function expandAllGroups(level) {
        expandCollapseAllGroups(level, false);
    }
    function expandCollapseGroup(level, groupingKey, collapse) {
        toggledGroupsByLevel[level][groupingKey] = groupingInfos[level].collapsed ^ collapse;
        refresh();
    }
    /**
     * @param varArgs Either a Slick.Group's "groupingKey" property, or a
     *     variable argument list of grouping values denoting a unique path to the row.  For
     *     example, calling collapseGroup('high', '10%') will collapse the '10%' subgroup of
     *     the 'high' group.
     */ function collapseGroup(varArgs) {
        var args = Array.prototype.slice.call(arguments);
        var arg0 = args[0];
        if (args.length == 1 && arg0.indexOf(groupingDelimiter) != -1) expandCollapseGroup(arg0.split(groupingDelimiter).length - 1, arg0, true);
        else expandCollapseGroup(args.length - 1, args.join(groupingDelimiter), true);
    }
    /**
     * @param varArgs Either a Slick.Group's "groupingKey" property, or a
     *     variable argument list of grouping values denoting a unique path to the row.  For
     *     example, calling expandGroup('high', '10%') will expand the '10%' subgroup of
     *     the 'high' group.
     */ function expandGroup(varArgs) {
        var args = Array.prototype.slice.call(arguments);
        var arg0 = args[0];
        if (args.length == 1 && arg0.indexOf(groupingDelimiter) != -1) expandCollapseGroup(arg0.split(groupingDelimiter).length - 1, arg0, false);
        else expandCollapseGroup(args.length - 1, args.join(groupingDelimiter), false);
    }
    function getGroups() {
        return groups;
    }
    function extractGroups(rows, parentGroup) {
        var group;
        var val;
        var groups = [];
        var groupsByVal = {};
        var r;
        var level = parentGroup ? parentGroup.level + 1 : 0;
        var gi = groupingInfos[level];
        for(var i = 0, l = gi.predefinedValues.length; i < l; i++){
            val = gi.predefinedValues[i];
            group = groupsByVal[val];
            if (!group) {
                group = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Group();
                group.value = val;
                group.level = level;
                group.groupingKey = (parentGroup ? parentGroup.groupingKey + groupingDelimiter : "") + val;
                groups[groups.length] = group;
                groupsByVal[val] = group;
            }
        }
        for(var i = 0, l = rows.length; i < l; i++){
            r = rows[i];
            val = gi.getterIsAFn ? gi.getter(r) : r[gi.getter];
            group = groupsByVal[val];
            if (!group) {
                group = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Group();
                group.value = val;
                group.level = level;
                group.groupingKey = (parentGroup ? parentGroup.groupingKey + groupingDelimiter : "") + val;
                groups[groups.length] = group;
                groupsByVal[val] = group;
            }
            group.rows[group.count++] = r;
        }
        if (level < groupingInfos.length - 1) for(var i = 0; i < groups.length; i++){
            group = groups[i];
            group.groups = extractGroups(group.rows, group);
        }
        groups.sort(groupingInfos[level].comparer);
        return groups;
    }
    function calculateTotals(totals) {
        var group = totals.group;
        var gi = groupingInfos[group.level];
        var isLeafLevel = group.level == groupingInfos.length;
        var agg, idx = gi.aggregators.length;
        if (!isLeafLevel && gi.aggregateChildGroups) {
            // make sure all the subgroups are calculated
            var i = group.groups.length;
            while(i--)if (!group.groups[i].totals.initialized) calculateTotals(group.groups[i].totals);
        }
        while(idx--){
            agg = gi.aggregators[idx];
            agg.init();
            if (!isLeafLevel && gi.aggregateChildGroups) gi.compiledAccumulators[idx].call(agg, group.groups);
            else gi.compiledAccumulators[idx].call(agg, group.rows);
            agg.storeResult(totals);
        }
        totals.initialized = true;
    }
    function addGroupTotals(group) {
        var gi = groupingInfos[group.level];
        var totals = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).GroupTotals();
        totals.group = group;
        group.totals = totals;
        if (!gi.lazyTotalsCalculation) calculateTotals(totals);
    }
    function addTotals(groups, level) {
        level = level || 0;
        var gi = groupingInfos[level];
        var groupCollapsed = gi.collapsed;
        var toggledGroups = toggledGroupsByLevel[level];
        var idx = groups.length, g;
        while(idx--){
            g = groups[idx];
            if (g.collapsed && !gi.aggregateCollapsed) continue;
            // do a depth-first aggregation so that parent group aggregators can access subgroup totals.
            if (g.groups) addTotals(g.groups, level + 1);
            if (gi.aggregators.length && (gi.aggregateEmpty || g.rows.length || g.groups && g.groups.length)) addGroupTotals(g);
            g.collapsed = groupCollapsed ^ toggledGroups[g.groupingKey];
            g.title = gi.formatter ? gi.formatter(g) : g.value;
        }
    }
    function flattenGroupedRows(groups, level) {
        level = level || 0;
        var gi = groupingInfos[level];
        var groupedRows = [], rows, gl = 0, g;
        for(var i = 0, l = groups.length; i < l; i++){
            g = groups[i];
            groupedRows[gl++] = g;
            if (!g.collapsed) {
                rows = g.groups ? flattenGroupedRows(g.groups, level + 1) : g.rows;
                for(var j = 0, jj = rows.length; j < jj; j++)groupedRows[gl++] = rows[j];
            }
            if (g.totals && gi.displayTotalsRow && (!g.collapsed || gi.aggregateCollapsed)) groupedRows[gl++] = g.totals;
        }
        return groupedRows;
    }
    function getFunctionInfo(fn) {
        var fnRegex = /^function[^(]*\(([^)]*)\)\s*{([\s\S]*)}$/;
        var matches = fn.toString().match(fnRegex);
        return {
            params: matches[1].split(","),
            body: matches[2]
        };
    }
    function compileAccumulatorLoop(aggregator) {
        var accumulatorInfo = getFunctionInfo(aggregator.accumulate);
        var fn = new Function("_items", "for (var " + accumulatorInfo.params[0] + ", _i=0, _il=_items.length; _i<_il; _i++) {" + accumulatorInfo.params[0] + " = _items[_i]; " + accumulatorInfo.body + "}");
        fn.displayName = "compiledAccumulatorLoop";
        return fn;
    }
    // function compileFilter() {
    //   let filterInfo = getFunctionInfo(filter);
    //   let filterPath1 = "{ continue _coreloop; }$1";
    //   let filterPath2 = "{ _retval[_idx++] = $item$; continue _coreloop; }$1";
    //   // make some allowances for minification - there's only so far we can go with RegEx
    //   let filterBody = filterInfo.body
    //     .replace(/return false\s*([;}]|\}|$)/gi, filterPath1)
    //     .replace(/return!1([;}]|\}|$)/gi, filterPath1)
    //     .replace(/return true\s*([;}]|\}|$)/gi, filterPath2)
    //     .replace(/return!0([;}]|\}|$)/gi, filterPath2)
    //     .replace(/return ([^;}]+?)\s*([;}]|$)/gi,
    //       "{ if ($1) { _retval[_idx++] = $item$; }; continue _coreloop; }$2");
    //   // This preserves the function template code after JS compression,
    //   // so that replace() commands still work as expected.
    //   let tpl = [
    //     // "function(_items, _args) { ",
    //     "var _retval = [], _idx = 0; ",
    //     "var $item$, $args$ = _args; ",
    //     "_coreloop: ",
    //     "for (var _i = 0, _il = _items.length; _i < _il; _i++) { ",
    //     "$item$ = _items[_i]; ",
    //     "$filter$; ",
    //     "} ",
    //     "return _retval; "
    //     // "}"
    //   ].join("");
    //   tpl = tpl.replace(/\$filter\$/gi, filterBody);
    //   tpl = tpl.replace(/\$item\$/gi, filterInfo.params[0]);
    //   tpl = tpl.replace(/\$args\$/gi, filterInfo.params[1]);
    //   let fn: any = new Function("_items,_args", tpl);
    //   fn.displayName = /*fn.name =*/ "compiledFilter";
    //   return fn;
    // }
    // function compileFilterWithCaching() {
    //   let filterInfo = getFunctionInfo(filter);
    //   let filterPath1 = "{ continue _coreloop; }$1";
    //   let filterPath2 = "{ _cache[_i] = true;_retval[_idx++] = $item$; continue _coreloop; }$1";
    //   // make some allowances for minification - there's only so far we can go with RegEx
    //   let filterBody = filterInfo.body
    //     .replace(/return false\s*([;}]|\}|$)/gi, filterPath1)
    //     .replace(/return!1([;}]|\}|$)/gi, filterPath1)
    //     .replace(/return true\s*([;}]|\}|$)/gi, filterPath2)
    //     .replace(/return!0([;}]|\}|$)/gi, filterPath2)
    //     .replace(/return ([^;}]+?)\s*([;}]|$)/gi,
    //       "{ if ((_cache[_i] = $1)) { _retval[_idx++] = $item$; }; continue _coreloop; }$2");
    //   // This preserves the function template code after JS compression,
    //   // so that replace() commands still work as expected.
    //   let tpl = [
    //     // "function(_items, _args, _cache) { ",
    //     "var _retval = [], _idx = 0; ",
    //     "var $item$, $args$ = _args; ",
    //     "_coreloop: ",
    //     "for (var _i = 0, _il = _items.length; _i < _il; _i++) { ",
    //     "$item$ = _items[_i]; ",
    //     "if (_cache[_i]) { ",
    //     "_retval[_idx++] = $item$; ",
    //     "continue _coreloop; ",
    //     "} ",
    //     "$filter$; ",
    //     "} ",
    //     "return _retval; "
    //     // "}"
    //   ].join("");
    //   tpl = tpl.replace(/\$filter\$/gi, filterBody);
    //   tpl = tpl.replace(/\$item\$/gi, filterInfo.params[0]);
    //   tpl = tpl.replace(/\$args\$/gi, filterInfo.params[1]);
    //   let fn: any = new Function("_items,_args,_cache", tpl);
    //   fn.displayName /*= fn.name*/ = "compiledFilterWithCaching";
    //   return fn;
    // }
    function uncompiledFilter(items, args) {
        var retval = [], idx = 0;
        for(var i = 0, ii = items.length; i < ii; i++)if (filter(items[i], args)) retval[idx++] = items[i];
        return retval;
    }
    function uncompiledFilterWithCaching(items, args, cache) {
        var retval = [], idx = 0, item;
        for(var i = 0, ii = items.length; i < ii; i++){
            item = items[i];
            if (cache[i]) retval[idx++] = item;
            else if (filter(item, args)) {
                retval[idx++] = item;
                cache[i] = true;
            }
        }
        return retval;
    }
    function getFilteredAndPagedItems(items) {
        if (filter) {
            var batchFilter = uncompiledFilter; // options.inlineFilters ? compiledFilter : uncompiledFilter;
            var batchFilterWithCaching = uncompiledFilterWithCaching; // options.inlineFilters ? compiledFilterWithCaching : uncompiledFilterWithCaching;
            if (refreshHints.isFilterNarrowing) filteredItems = batchFilter(filteredItems, filterArgs);
            else if (refreshHints.isFilterExpanding) filteredItems = batchFilterWithCaching(items, filterArgs, filterCache);
            else if (!refreshHints.isFilterUnchanged) filteredItems = batchFilter(items, filterArgs);
        } else // special case:  if not filtering and not paging, the resulting
        // rows collection needs to be a copy so that changes due to sort
        // can be caught
        filteredItems = pagesize ? items : items.concat();
        // get the current page
        var paged;
        if (pagesize) {
            if (filteredItems.length <= pagenum * pagesize) {
                if (filteredItems.length === 0) pagenum = 0;
                else pagenum = Math.floor((filteredItems.length - 1) / pagesize);
            }
            paged = filteredItems.slice(pagesize * pagenum, pagesize * pagenum + pagesize);
        } else paged = filteredItems;
        return {
            totalRows: filteredItems.length,
            rows: paged
        };
    }
    function getRowDiffs(rows, newRows) {
        var item, r, eitherIsNonData, diff = [];
        var from = 0, to = newRows.length;
        if (refreshHints && refreshHints.ignoreDiffsBefore) from = Math.max(0, Math.min(newRows.length, refreshHints.ignoreDiffsBefore));
        if (refreshHints && refreshHints.ignoreDiffsAfter) to = Math.min(newRows.length, Math.max(0, refreshHints.ignoreDiffsAfter));
        for(var i = from, rl = rows.length; i < to; i++)if (i >= rl) diff[diff.length] = i;
        else {
            item = newRows[i];
            r = rows[i];
            if (groupingInfos.length && (eitherIsNonData = item.__nonDataRow || r.__nonDataRow) && item.__group !== r.__group || item.__group && !item.equals(r) || eitherIsNonData && // no good way to compare totals since they are arbitrary DTOs
            // deep object comparison is pretty expensive
            // always considering them 'dirty' seems easier for the time being
            (item.__groupTotals || r.__groupTotals) || item[idProperty] != r[idProperty] || updated && updated[item[idProperty]]) diff[diff.length] = i;
        }
        return diff;
    }
    function recalc(_items, second) {
        rowsById = null;
        if (refreshHints.isFilterNarrowing != prevRefreshHints.isFilterNarrowing || refreshHints.isFilterExpanding != prevRefreshHints.isFilterExpanding) filterCache = [];
        var filteredItems = getFilteredAndPagedItems(_items);
        totalRows = filteredItems.totalRows;
        var newRows = filteredItems.rows;
        groups = [];
        if (groupingInfos.length) {
            groups = extractGroups(newRows);
            if (groups.length) {
                addTotals(groups);
                newRows = flattenGroupedRows(groups);
            }
        }
        var diff = getRowDiffs(rows, newRows);
        rows = newRows;
        return diff;
    }
    function refresh() {
        if (suspend) return;
        var countBefore = rows.length;
        var totalRowsBefore = totalRows;
        var diff = recalc(items, filter); // pass as direct refs to avoid closure perf hit
        // if the current page is no longer valid, go to last page and recalc
        // we suffer a performance penalty here, but the main loop (recalc) remains highly optimized
        if (pagesize && totalRows < pagenum * pagesize) {
            pagenum = Math.max(0, Math.ceil(totalRows / pagesize) - 1);
            diff = recalc(items, filter);
        }
        updated = null;
        prevRefreshHints = refreshHints;
        refreshHints = {};
        if (totalRowsBefore !== totalRows) onPagingInfoChanged.notify(getPagingInfo(), null, self);
        if (countBefore !== rows.length) onRowCountChanged.notify({
            previous: countBefore,
            current: rows.length,
            dataView: self,
            callingOnRowsChanged: diff.length > 0
        }, null, self);
        if (diff.length > 0) onRowsChanged.notify({
            rows: diff,
            dataView: self,
            calledOnRowCountChanged: countBefore !== rows.length
        }, null, self);
        if (countBefore !== rows.length || diff.length > 0) onRowsOrCountChanged.notify({
            rowsDiff: diff,
            previousRowCount: countBefore,
            currentRowCount: rows.length,
            rowCountChanged: countBefore !== rows.length,
            rowsChanged: diff.length > 0,
            dataView: self
        }, null, self);
    }
    /***
     * Wires the grid and the DataView together to keep row selection tied to item ids.
     * This is useful since, without it, the grid only knows about rows, so if the items
     * move around, the same rows stay selected instead of the selection moving along
     * with the items.
     *
     * NOTE:  This doesn't work with cell selection model.
     *
     * @param grid {Slick.Grid} The grid to sync selection with.
     * @param preserveHidden {Boolean} Whether to keep selected items that go out of the
     *     view due to them getting filtered out.
     * @param preserveHiddenOnSelectionChange {Boolean} Whether to keep selected items
     *     that are currently out of the view (see preserveHidden) as selected when selection
     *     changes.
     * @return {Slick.Event} An event that notifies when an internal list of selected row ids
     *     changes.  This is useful since, in combination with the above two options, it allows
     *     access to the full list selected row ids, and not just the ones visible to the grid.
     * @method syncGridSelection
     */ function syncGridSelection(grid, preserveHidden, preserveHiddenOnSelectionChange) {
        var self = this;
        var inHandler;
        var selectedRowIds = self.mapRowsToIds(grid.getSelectedRows());
        var onSelectedRowIdsChanged = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event();
        function setSelectedRowIds(rowIds) {
            if (selectedRowIds.join(",") == rowIds.join(",")) return;
            selectedRowIds = rowIds;
            onSelectedRowIdsChanged.notify({
                grid: grid,
                ids: selectedRowIds,
                dataView: self
            }, new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).EventData(), self);
        }
        function update() {
            if (selectedRowIds.length > 0) {
                inHandler = true;
                var selectedRows = self.mapIdsToRows(selectedRowIds);
                if (!preserveHidden) setSelectedRowIds(self.mapRowsToIds(selectedRows));
                grid.setSelectedRows(selectedRows);
                inHandler = false;
            }
        }
        grid.onSelectedRowsChanged.subscribe(function(e, args) {
            if (inHandler) return;
            var newSelectedRowIds = self.mapRowsToIds(grid.getSelectedRows());
            if (!preserveHiddenOnSelectionChange || !grid.getOptions().multiSelect) setSelectedRowIds(newSelectedRowIds);
            else {
                // keep the ones that are hidden
                var existing = [];
                for(var i = 0; i < selectedRowIds.length; i++)if (self.getRowById(selectedRowIds[i]) === undefined) existing.push(selectedRowIds[i]);
                // $.grep(selectedRowIds, function(id) { return self.getRowById(id) === undefined; });
                // add the newly selected ones
                setSelectedRowIds(existing.concat(newSelectedRowIds));
            }
        });
        this.onRowsOrCountChanged.subscribe(update);
        return onSelectedRowIdsChanged;
    }
    function syncGridCellCssStyles(grid, key) {
        var hashById;
        var inHandler;
        // since this method can be called after the cell styles have been set,
        // get the existing ones right away
        storeCellCssStyles(grid.getCellCssStyles(key));
        function storeCellCssStyles(hash) {
            hashById = {};
            for(var row in hash){
                var id = rows[row][idProperty];
                hashById[id] = hash[row];
            }
        }
        function update() {
            if (hashById) {
                inHandler = true;
                ensureRowsByIdCache();
                var newHash = {};
                for(var id in hashById){
                    var row = rowsById[id];
                    if (row != undefined) newHash[row] = hashById[id];
                }
                grid.setCellCssStyles(key, newHash);
                inHandler = false;
            }
        }
        grid.onCellCssStylesChanged.subscribe(function(e, args) {
            if (inHandler) return;
            if (key != args.key) return;
            if (args.hash) storeCellCssStyles(args.hash);
            else // grid.onCellCssStylesChanged.unsubscribe(styleChanged); //styleChanged not declared
            self.onRowsOrCountChanged.unsubscribe(update);
        });
        this.onRowsOrCountChanged.subscribe(update);
    }
    $44a0f294ad0c9e06$var$$.shallowExtend(this, {
        // methods
        beginUpdate: beginUpdate,
        endUpdate: endUpdate,
        setPagingOptions: setPagingOptions,
        getPagingInfo: getPagingInfo,
        getItems: getItems,
        setItems: setItems,
        setFilter: setFilter,
        getFilter: getFilter,
        getFilteredItems: getFilteredItems,
        sort: sort,
        // "fastSort": fastSort,
        reSort: reSort,
        setGrouping: setGrouping,
        getGrouping: getGrouping,
        groupBy: groupBy,
        setAggregators: setAggregators,
        collapseAllGroups: collapseAllGroups,
        expandAllGroups: expandAllGroups,
        collapseGroup: collapseGroup,
        expandGroup: expandGroup,
        getGroups: getGroups,
        getIdxById: getIdxById,
        getIdxByItem: getIdxByItem,
        getRowByItem: getRowByItem,
        getRowById: getRowById,
        getItemById: getItemById,
        getItemByIdx: getItemByIdx,
        mapItemsToRows: mapItemsToRows,
        mapRowsToIds: mapRowsToIds,
        mapIdsToRows: mapIdsToRows,
        setRefreshHints: setRefreshHints,
        setFilterArgs: setFilterArgs,
        refresh: refresh,
        updateItem: updateItem,
        insertItem: insertItem,
        addItem: addItem,
        deleteItem: deleteItem,
        sortedAddItem: sortedAddItem,
        sortedUpdateItem: sortedUpdateItem,
        syncGridSelection: syncGridSelection,
        syncGridCellCssStyles: syncGridCellCssStyles,
        // data provider methods
        getLength: getLength,
        getItem: getItem,
        getItemMetadata: getItemMetadata,
        // events
        onRowCountChanged: onRowCountChanged,
        onRowsChanged: onRowsChanged,
        onRowsOrCountChanged: onRowsOrCountChanged,
        onPagingInfoChanged: onPagingInfoChanged
    });
}
function $44a0f294ad0c9e06$export$8e1cd5f155d99da8(field) {
    this.field_ = field;
    this.init = function() {
        this.count_ = 0;
        this.nonNullCount_ = 0;
        this.sum_ = 0;
    };
    this.accumulate = function(item) {
        var val = item[this.field_];
        this.count_++;
        if (val != null && val !== "" && !isNaN(val)) {
            this.nonNullCount_++;
            this.sum_ += parseFloat(val);
        }
    };
    this.storeResult = function(groupTotals) {
        if (!groupTotals.avg) groupTotals.avg = {};
        if (this.nonNullCount_ != 0) groupTotals.avg[this.field_] = this.sum_ / this.nonNullCount_;
    };
}
function $44a0f294ad0c9e06$export$de6944aefc0a85d6(field) {
    this.field_ = field;
    this.init = function() {
        this.min_ = null;
    };
    this.accumulate = function(item) {
        var val = item[this.field_];
        if (val != null && val !== "" && !isNaN(val)) {
            if (this.min_ == null || val < this.min_) this.min_ = val;
        }
    };
    this.storeResult = function(groupTotals) {
        if (!groupTotals.min) groupTotals.min = {};
        groupTotals.min[this.field_] = this.min_;
    };
}
function $44a0f294ad0c9e06$export$252d364546e18594(field) {
    this.field_ = field;
    this.init = function() {
        this.max_ = null;
    };
    this.accumulate = function(item) {
        var val = item[this.field_];
        if (val != null && val !== "" && !isNaN(val)) {
            if (this.max_ == null || val > this.max_) this.max_ = val;
        }
    };
    this.storeResult = function(groupTotals) {
        if (!groupTotals.max) groupTotals.max = {};
        groupTotals.max[this.field_] = this.max_;
    };
}
function $44a0f294ad0c9e06$export$fca457a6bc362f99(field) {
    this.field_ = field;
    this.init = function() {
        this.sum_ = null;
    };
    this.accumulate = function(item) {
        var val = item[this.field_];
        if (val != null && val !== "" && !isNaN(val)) this.sum_ += parseFloat(val);
    };
    this.storeResult = function(groupTotals) {
        if (!groupTotals.sum) groupTotals.sum = {};
        groupTotals.sum[this.field_] = this.sum_;
    };
} // tODO:  add more built-in aggregators
 // tODO:  merge common aggregators in one to prevent needles iterating




var $904380656eea9a53$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
$904380656eea9a53$var$$.deepExtend((0, $35f562d52ec6d8f1$export$846056739d2a3e0b), {
    Data: {
        GroupItemMetadataProvider: $904380656eea9a53$export$1eebeefb78654a9b
    }
});
function $904380656eea9a53$export$1eebeefb78654a9b(options) {
    var _grid;
    var _defaults = {
        checkboxSelect: false,
        checkboxSelectCssClass: "slick-group-select-checkbox",
        checkboxSelectPlugin: null,
        groupCssClass: "slick-group",
        groupTitleCssClass: "slick-group-title",
        totalsCssClass: "slick-group-totals",
        groupFocusable: true,
        totalsFocusable: false,
        toggleCssClass: "slick-group-toggle",
        toggleExpandedCssClass: "expanded",
        toggleCollapsedCssClass: "collapsed",
        enableExpandCollapse: true,
        groupFormatter: defaultGroupCellFormatter,
        totalsFormatter: defaultTotalsCellFormatter
    };
    options = $904380656eea9a53$var$$.deepExtend({}, _defaults, options);
    function defaultGroupCellFormatter(row, cell, value, columnDef, item, grid) {
        if (!options.enableExpandCollapse) return item.title;
        var indentation = item.level * 15 + "px";
        return (options.checkboxSelect ? '<span class="' + options.checkboxSelectCssClass + ' ' + (item.selectChecked ? 'checked' : 'unchecked') + '"></span>' : '') + "<span class='" + options.toggleCssClass + " " + (item.collapsed ? options.toggleCollapsedCssClass : options.toggleExpandedCssClass) + "' style='margin-left:" + indentation + "'>" + "</span>" + "<span class='" + options.groupTitleCssClass + "' level='" + item.level + "'>" + item.title + "</span>";
    }
    function defaultTotalsCellFormatter(row, cell, value, columnDef, item, grid) {
        var formatter_res;
        if (columnDef.groupTotalsFormatter) formatter_res = columnDef.groupTotalsFormatter(item, columnDef, grid) || "";
        else {
            var res = item.avg && item.avg[columnDef.field] || item.sum && item.sum[columnDef.field] || item.max && item.max[columnDef.field] || item.min && item.min[columnDef.field];
            formatter_res = columnDef.formatter ? columnDef.formatter(row, cell, res, columnDef, item) : "";
        }
        return formatter_res;
    //return (Object.prototype.toString.call(formatter_res) !== '[object Object]' ? (<string>formatter_res) : (<ISlickFormatterResult>formatter_res).text);
    }
    function init(grid) {
        _grid = grid;
        _grid.onClick.subscribe(handleGridClick);
        _grid.onKeyDown.subscribe(handleGridKeyDown);
    }
    function destroy() {
        if (_grid) {
            _grid.onClick.unsubscribe(handleGridClick);
            _grid.onKeyDown.unsubscribe(handleGridKeyDown);
        }
    }
    function handleGridClick(e, args) {
        var $target = $904380656eea9a53$var$$(e.target);
        var item = this.getDataItem(args.row);
        if (item && item instanceof (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Group && $target.hasClass(options.toggleCssClass)) {
            var range = _grid.getRenderedRange();
            this.dataView.setRefreshHints({
                ignoreDiffsBefore: range.top,
                ignoreDiffsAfter: range.bottom + 1
            });
            if (item.collapsed) this.dataView.expandGroup(item.groupingKey);
            else this.dataView.collapseGroup(item.groupingKey);
            e.stopImmediatePropagation();
            e.preventDefault();
        }
        if (item && item instanceof (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Group && $target.hasClass(options.checkboxSelectCssClass)) {
            item.selectChecked = !item.selectChecked;
            $target.removeClass(item.selectChecked ? "unchecked" : "checked");
            $target.addClass(item.selectChecked ? "checked" : "unchecked");
            // get rowIndexes array
            var rowIndexes = _grid.dataView.mapItemsToRows(item.rows);
            (item.selectChecked ? options.checkboxSelectPlugin.selectRows : options.checkboxSelectPlugin.deSelectRows)(rowIndexes);
        }
    }
    // TODO:  add -/+ handling
    function handleGridKeyDown(e, args) {
        if (options.enableExpandCollapse && e.which == (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).keyCode.SPACE) {
            var activeCell = this.getActiveCell();
            if (activeCell) {
                var item = this.getDataItem(activeCell.row);
                if (item && item instanceof (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Group) {
                    var range = _grid.getRenderedRange();
                    this.dataView.setRefreshHints({
                        ignoreDiffsBefore: range.top,
                        ignoreDiffsAfter: range.bottom + 1
                    });
                    if (item.collapsed) this.dataView.expandGroup(item.groupingKey);
                    else this.dataView.collapseGroup(item.groupingKey);
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            }
        }
    }
    function getGroupRowMetadata(item) {
        return {
            selectable: false,
            focusable: options.groupFocusable,
            cssClasses: options.groupCssClass,
            columns: {
                0: {
                    colspan: "*",
                    formatter: options.groupFormatter,
                    editor: null
                }
            },
            height: options.calcGroupHeight ? options.calcGroupHeight(item) : undefined
        };
    }
    function getTotalsRowMetadata(item) {
        return {
            selectable: false,
            focusable: options.totalsFocusable,
            cssClasses: options.totalsCssClass,
            formatter: options.totalsFormatter,
            editor: null,
            height: options.calcTotalsHeight ? options.calcTotalsHeight(item) : undefined
        };
    }
    return {
        "init": init,
        "destroy": destroy,
        "getGroupRowMetadata": getGroupRowMetadata,
        "getTotalsRowMetadata": getTotalsRowMetadata
    };
}






var $c1bc8c5e97c70a11$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
// register namespace
$c1bc8c5e97c70a11$var$$.deepExtend(window, {
    "Slick": {
        "Plugins": {
            "HeaderMenu": $c1bc8c5e97c70a11$export$2730b686806681be
        }
    }
});
function $c1bc8c5e97c70a11$export$2730b686806681be(options) {
    var _grid;
    var _self = this;
    var _handler = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).EventHandler();
    var _defaults = {
        buttonCssClass: null,
        buttonImage: null,
        minWidth: 100,
        autoAlign: true,
        autoAlignOffset: 0
    };
    var $menu;
    var $activeHeaderColumn;
    function init(grid) {
        options = $c1bc8c5e97c70a11$var$$.deepExtend({}, _defaults, options);
        _grid = grid;
        _handler.subscribe(_grid.onHeaderCellRendered, handleHeaderCellRendered).subscribe(_grid.onBeforeHeaderCellDestroy, handleBeforeHeaderCellDestroy);
        // Force the grid to re-render the header now that the events are hooked up.
        //_grid.setColumns(_grid.getColumns()); //TODO TODOFIX try to optimize this
        // Hide the menu on outside click.
        $c1bc8c5e97c70a11$var$$(document.body).on("mousedown", handleBodyMouseDown);
    }
    function setOptions(newOptions) {
        options = $c1bc8c5e97c70a11$var$$.deepExtend({}, options, newOptions);
    }
    function destroy() {
        _handler.unsubscribeAll();
        document.body.removeEventListener("mousedown", handleBodyMouseDown);
    //$(document.body).off("mousedown", handleBodyMouseDown);
    }
    function handleBodyMouseDown(e) {
        if ($menu && $c1bc8c5e97c70a11$var$$(e.target).closestClass("slick-header-menu").length === 0) hideMenu();
    }
    function hideMenu() {
        if ($menu) {
            $menu.remove();
            $menu = null;
            $activeHeaderColumn.removeClass("slick-header-column-active");
        }
    }
    function handleHeaderCellRendered(e, args) {
        var column = args.column;
        var menu = $c1bc8c5e97c70a11$var$$.deepExtend({}, column.header && column.header.menu || {
            items: []
        });
        if (!column.hideMenu) {
            var $el = $c1bc8c5e97c70a11$var$$("<div></div>").addClass("slick-header-menubutton").data("column", column).data("menu", menu);
            if (column.resizable) $el.addClass("resize-offset");
            if (options.buttonCssClass) $el.addClass(options.buttonCssClass);
            if (options.buttonImage) $el.css("background-image", "url(" + options.buttonImage + ")");
            if (menu.tooltip) $el.attr("title", menu.tooltip);
            $el.on("click", showMenu).appendTo(args.node);
        }
    }
    function handleBeforeHeaderCellDestroy(e, args) {
        var column = args.column;
        if (column.header && column.header.menu) $c1bc8c5e97c70a11$var$$(args.node).find(".slick-header-menubutton").remove();
    }
    function showMenu(e) {
        var $menuButton = $c1bc8c5e97c70a11$var$$(e.target);
        var menu = $c1bc8c5e97c70a11$var$$.deepExtend({}, $menuButton.data("menu"));
        var columnDef = $menuButton.data("column");
        // Let the user modify the menu or cancel altogether,
        // or provide alternative menu implementation.
        if (_self.onBeforeMenuShow.notify({
            "grid": _grid,
            "column": columnDef,
            "menu": menu
        }, e, _self) == false) return;
        if (!$menu) $menu = $c1bc8c5e97c70a11$var$$("<div class='slick-header-menu' style='min-width: " + options.minWidth + "px'></div>").appendTo(_grid.getContainerNode());
        $menu.empty();
        // Construct the menu items.
        for(var i = 0; i < menu.items.length; i++){
            var item = menu.items[i];
            var $li = $c1bc8c5e97c70a11$var$$("<div class='slick-header-menuitem'></div>").data("command", item.command || '').data("column", columnDef).data("item", item).on("click", handleMenuItemClick).appendTo($menu);
            if (item.disabled) $li.addClass("slick-header-menuitem-disabled");
            if (item.divider) {
                $li.addClass("slick-header-menuitem-divider");
                continue;
            }
            if (item.tooltip) $li.attr("title", item.tooltip);
            var $icon = $c1bc8c5e97c70a11$var$$("<div class='slick-header-menuicon'></div>").appendTo($li);
            if (item.iconCssClass) $icon.addClass(item.iconCssClass);
            if (item.iconImage) $icon.css("background-image", "url(" + item.iconImage + ")");
            $c1bc8c5e97c70a11$var$$("<span class='slick-header-menucontent'></span>").text(item.title).appendTo($li);
        }
        var leftPos = $menuButton.offset().left;
        // when auto-align is set, it will calculate whether it has enough space in the viewport to show the drop menu on the right (default)
        // if there isn't enough space on the right, it will automatically align the drop menu to the left
        // to simulate an align left, we actually need to know the width of the drop menu
        if (options.autoAlign) {
            var gridPos = _grid.getGridPosition();
            if (leftPos + options.minWidth >= gridPos.width) leftPos = leftPos - options.minWidth + options.autoAlignOffset;
        }
        //$menu
        //  .offset({ top: $menuButton.offset().top + $menuButton.height(), left: leftPos });
        $menu[0].style.top = /*$menuButton.offset().top +*/ $menuButton.height() + "px";
        $menu[0].style.left = leftPos - $c1bc8c5e97c70a11$var$$(_grid.getContainerNode()).offset().left + "px";
        // Mark the header as active to keep the highlighting.
        $activeHeaderColumn = $menuButton.closestClass(".slick-header-column");
        $activeHeaderColumn.addClass("slick-header-column-active");
        // Stop propagation so that it doesn't register as a header click event.
        e.preventDefault();
        e.stopPropagation();
    }
    function handleMenuItemClick(e) {
        var command = $c1bc8c5e97c70a11$var$$(e.currentTarget).data("command");
        var columnDef = $c1bc8c5e97c70a11$var$$(e.currentTarget).data("column");
        var item = $c1bc8c5e97c70a11$var$$(e.currentTarget).data("item");
        if (item.disabled || item.divider) return;
        hideMenu();
        if (command != null && command != '') _self.onCommand.notify({
            "grid": _grid,
            "column": columnDef,
            "command": command,
            "item": item
        }, e, _self);
        // Stop propagation so that it doesn't register as a header click event.
        e.preventDefault();
        e.stopPropagation();
    }
    $c1bc8c5e97c70a11$var$$.shallowExtend(this, {
        "init": init,
        "destroy": destroy,
        "pluginName": "HeaderMenu",
        "setOptions": setOptions,
        "onBeforeMenuShow": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onCommand": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event()
    });
}





var $e808d74d2acf79f5$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
// register namespace
$e808d74d2acf79f5$var$$.deepExtend(window, {
    "Slick": {
        "Plugins": {
            "HeaderButtons": $e808d74d2acf79f5$export$ed80cdffa8822341
        }
    }
});
function $e808d74d2acf79f5$export$ed80cdffa8822341(options) {
    var _grid;
    var _self = this;
    var _handler = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).EventHandler();
    var _defaults = {
        buttonCssClass: "slick-header-button"
    };
    function init(grid) {
        options = $e808d74d2acf79f5$var$$.deepExtend({}, _defaults, options);
        _grid = grid;
        _handler.subscribe(_grid.onHeaderCellRendered, handleHeaderCellRendered).subscribe(_grid.onBeforeHeaderCellDestroy, handleBeforeHeaderCellDestroy);
        // Force the grid to re-render the header now that the events are hooked up.
        _grid.setColumns(_grid.getColumns());
    }
    function destroy() {
        _handler.unsubscribeAll();
    }
    function handleHeaderCellRendered(e, args) {
        var column = args.column;
        if (column.header && column.header.buttons) {
            // Append buttons in reverse order since they are floated to the right.
            var i = column.header.buttons.length;
            while(i--){
                var button = column.header.buttons[i];
                var btn = $e808d74d2acf79f5$var$$("<div></div>").addClass(options.buttonCssClass).data("column", column).data("button", button);
                if (button.showOnHover) btn.addClass("slick-header-button-hidden");
                if (button.image) btn.css("backgroundImage", "url(" + button.image + ")");
                if (button.html) btn.html(button.html);
                if (button.cssClass) btn.addClass(button.cssClass);
                if (button.tooltip) btn.attr("title", button.tooltip);
                if (button.command) btn.data("command", button.command);
                if (button.handler) btn.on("click", button.handler);
                btn.on("click", handleButtonClick).appendTo(args.node);
            }
        }
    }
    function handleBeforeHeaderCellDestroy(e, args) {
        var column = args.column;
        if (column.header && column.header.buttons) // Removing buttons via jQuery will also clean up any event handlers and data.
        // NOTE: If you attach event handlers directly or using a different framework,
        //       you must also clean them up here to avoid memory leaks.
        $e808d74d2acf79f5$var$$(args.node).find("." + options.buttonCssClass).remove();
    }
    function handleButtonClick(e) {
        var command = $e808d74d2acf79f5$var$$(this).data("command");
        var columnDef = $e808d74d2acf79f5$var$$(this).data("column");
        var button = $e808d74d2acf79f5$var$$(this).data("button");
        if (command != null) {
            _self.onCommand.notify({
                "grid": _grid,
                "column": columnDef,
                "command": command,
                "button": button
            }, e, _self);
            // Update the header in case the user updated the button definition in the handler.
            _grid.updateColumnHeader(columnDef.id);
        }
        // Stop propagation so that it doesn't register as a header click event.
        e.preventDefault();
        e.stopPropagation();
    }
    $e808d74d2acf79f5$var$$.shallowExtend(this, {
        "init": init,
        "destroy": destroy,
        "pluginName": "HeaderButtons",
        "onCommand": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event()
    });
}


/*
 * Contains basic SlickGrid formatters.
 *
 * NOTE:  These are merely examples.  You will most likely need to implement something more
 *        robust/extensible/localizable/etc. for your use!
 */ 

function $a73c3dbce15de2c5$var$escapeHTMLChars(text) {
    if (text == null) return "";
    if (typeof text.replace !== "function") return text;
    return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
var $a73c3dbce15de2c5$export$a5202877c0a7438e = function(row, cell, value, columnDef, dataContext) {
    return "";
};
var $a73c3dbce15de2c5$export$91bcf0ef8364d01f = $a73c3dbce15de2c5$export$a5202877c0a7438e;
var $a73c3dbce15de2c5$export$e38514fbfb7feec9 = function(row, cell, value, columnDef, dataContext) {
    return value ? "Yes" : "No";
};
var $a73c3dbce15de2c5$export$d9372a47ad98fbb4 = function(row, cell, value, columnDef, dataContext) {
    return '<div style="text-align:center">' + (value ? "\u2714" : "-") + '</div>'; // ❌
};
var $a73c3dbce15de2c5$export$221eaca3a149021a = function(row, cell, value, columnDef, dataContext) {
    return value ? "\u2714" : "";
};
var $a73c3dbce15de2c5$export$dbbb391d01199e6e = function(row, cell, value, columnDef, dataContext) {
    return {
        addClasses: [
            "right"
        ],
        text: (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(value, columnDef.format)
    };
};
var $a73c3dbce15de2c5$export$ad991b66133851cf = function(row, cell, value, columnDef, dataContext) {
    return (0, $f697fe55e25cf9d4$export$324d90190a8b822a).format(value, columnDef.format);
};
var $a73c3dbce15de2c5$export$68e42a99c2b2a216 = function(row, cell, value, columnDef, dataContext) {
    return value || "";
};
var $a73c3dbce15de2c5$export$8a67618a0f98d192 = function(row, cell, value, columnDef, dataContext) {
    var _a;
    var vl = columnDef.valueList;
    if (vl) {
        if (Array.isArray(vl)) {
            if (vl.length > 0) {
                if (typeof vl[0] === "string") return $a73c3dbce15de2c5$var$escapeHTMLChars(vl.indexOf(value) >= 0 ? value : ""); //TODO: desired?
                else {
                    var vlList = vl;
                    return $a73c3dbce15de2c5$var$escapeHTMLChars((_a = vlList.filter(function(x) {
                        return x.value === value;
                    })[0]) === null || _a === void 0 ? void 0 : _a.text);
                }
            } else return "";
        } else return $a73c3dbce15de2c5$var$escapeHTMLChars(vl[value]);
    } else console.warn("No values list found for column " + columnDef.id);
    return $a73c3dbce15de2c5$var$escapeHTMLChars(value);
};
var $a73c3dbce15de2c5$export$cb51f98fe660ad3f = function(row, cell, value, columnDef, dataContext) {
    if (value == null || value.length === 0) return "";
    var vl = columnDef.valueList;
    var result = "";
    if (vl == null) {
        console.warn("No values list found for column " + columnDef.id);
        return result;
    }
    if (Array.isArray(vl)) {
        if (vl.length > 0) {
            if (typeof vl[0] === "string") result = value.filter(function(v) {
                return vl.indexOf(v) >= 0;
            }).join(", ");
            else {
                var vlList = vl;
                result = vlList.filter(function(x) {
                    return value.indexOf(x.value) >= 0;
                }).map(function(x) {
                    var _a;
                    return (_a = x.text) !== null && _a !== void 0 ? _a : "";
                }).join(", ");
            }
        }
    } else result = value.map(function(v) {
        return vl[v];
    }).filter(function(v) {
        return v != null;
    }).join(", ");
    return result || "";
};
var $a73c3dbce15de2c5$export$cfc95f342033cc43 = function(row, cell, value, columnDef, dataContext) {
    if (value == null) return "";
    else return $a73c3dbce15de2c5$var$escapeHTMLChars(value + "");
};
var $a73c3dbce15de2c5$export$3ef60e24c131f5d3 = function(row, cell, value, columnDef, dataContext) {
    if (value == null) return "";
    else {
        var result = $a73c3dbce15de2c5$var$escapeHTMLChars(value + "");
        return {
            text: result,
            toolTip: result
        };
    }
};
var $a73c3dbce15de2c5$export$7c8b05ae20704c15 = function(row, cell, value, columnDef, dataContext) {
    var txt = "";
    if (value != null) txt = $a73c3dbce15de2c5$var$escapeHTMLChars(value + "");
    return {
        text: txt,
        addClasses: [
            "slick-wrap"
        ]
    };
};
function $a73c3dbce15de2c5$var$pad(nr) {
    if (nr < 10) return "0" + nr.toString();
    else return nr.toString();
}
var $a73c3dbce15de2c5$export$602249a0c7fd0a1c = function(row, cell, value, columnDef, dataContext) {
    return value ? $a73c3dbce15de2c5$var$pad(value.getHours()) + ":" + $a73c3dbce15de2c5$var$pad(value.getMinutes()) : "";
};
var $a73c3dbce15de2c5$export$3245e15bf4cbdd6c = function(row, cell, value, columnDef, dataContext) {
    return $a73c3dbce15de2c5$export$ad991b66133851cf(row, cell, value, columnDef, dataContext) + " " + $a73c3dbce15de2c5$export$602249a0c7fd0a1c(row, cell, value, columnDef, dataContext);
};
var $a73c3dbce15de2c5$export$57944922f8c6cca5 = function(row, cell, value, columnDef, dataContext) {
    return "<button class='grid-btn'>...</button>";
};






var $8641091d2d8811cd$var$__assign = undefined && undefined.__assign || function() {
    $8641091d2d8811cd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8641091d2d8811cd$var$__assign.apply(this, arguments);
};
var $8641091d2d8811cd$export$80990d9c432f0bfe = /** @class */ function() {
    function VirtualRenderComponent(options) {
        this.State = {
            scrollPos: 0
        };
        var defaultOptions = {
            data: null,
            renderRow: null,
            bufferSizeInPx: 200,
            rowHeight: 20,
            rowTag: "div",
            viewportSizeInPX: window.innerHeight
        };
        this.options = $8641091d2d8811cd$var$__assign($8641091d2d8811cd$var$__assign({}, defaultOptions), options);
    }
    VirtualRenderComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    VirtualRenderComponent.prototype.setData = function(data) {
        this.options.data = data;
    };
    VirtualRenderComponent.prototype.onInit = function(renderer) {
        this.State.renderer = renderer;
    };
    VirtualRenderComponent.prototype.render = function() {
        var _this = this;
        var _a, _b;
        var o = this.options;
        var vrBody = {
            tag: "div",
            attr: {
                class: "v-r-child",
                style: "height:" + o.data.length * o.rowHeight + "px;position:relative"
            },
            children: this.getChildren()
        };
        var vrContainer = {
            tag: "div",
            attr: {
                class: "v-r-comp " + ((_a = o.class) !== null && _a !== void 0 ? _a : ""),
                style: "overflow-y:auto;" + ((_b = o.style) !== null && _b !== void 0 ? _b : ""),
                scroll: function(e, node) {
                    var newScrollPos = node.dom.scrollTop;
                    if (Math.abs(_this.State.scrollPos - newScrollPos) < o.bufferSizeInPx) return false;
                    _this.State.scrollPos = newScrollPos;
                    vrBody.children = _this.getChildren();
                    node.children[0].children = [
                        {
                            tag: "dummy"
                        }
                    ];
                    _this.State.renderer.updateNode(node.children[0], vrBody);
                    return false;
                }
            },
            children: [
                vrBody
            ]
        };
        return vrContainer;
    };
    // public scrollRowToTop(idx: number) {
    // }
    // public scrollRowToCenter(idx: number) {
    // }
    // public scrollRowToBottom(idx: number) {
    // }
    VirtualRenderComponent.prototype.getChildren = function() {
        var o = this.options;
        var children = [];
        var viewport = {
            top: Math.floor((this.State.scrollPos - o.bufferSizeInPx) / o.rowHeight),
            bottom: Math.ceil((this.State.scrollPos + o.viewportSizeInPX + o.bufferSizeInPx) / o.rowHeight)
        };
        for(var idx = viewport.top; idx < viewport.bottom; idx++){
            if (idx < 0 || idx >= o.data.length) continue;
            var node = {
                tag: o.rowTag,
                attr: {
                    style: {
                        top: idx * o.rowHeight + "px",
                        height: o.rowHeight + "px",
                        position: "absolute",
                        left: "0",
                        right: "0"
                    }
                },
                children: []
            };
            var result = o.renderRow({
                index: idx,
                container: node,
                rowData: o.data[idx]
            });
            if (typeof result === "string") node.content = result;
            else if (result != null) node.children.push(result);
            children.push(node);
        }
        return children;
    };
    return VirtualRenderComponent;
}();



var $131d81e67ed3e476$var$__assign = undefined && undefined.__assign || function() {
    $131d81e67ed3e476$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $131d81e67ed3e476$var$__assign.apply(this, arguments);
};
var $131d81e67ed3e476$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $131d81e67ed3e476$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $131d81e67ed3e476$export$d4696dc82bf44c04 = /** @class */ function() {
    function ExcelFilter(grid) {
        this.grid = grid;
    }
    ExcelFilter.convertRemToPixels = function(rem) {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    };
    ExcelFilter.prototype.show = function(col) {
        return $131d81e67ed3e476$var$__awaiter(this, void 0, void 0, function() {
            var values, filters, currentFilters, mode, filterOptions, oldCheckedValues, _i, currentFilters_1, f, dlg, dlgBody, id, search, cbAllContainer, cbAll, cbAllLabel, sortedValues, _a, values_1, x, o, visibleValues, checkedValues, cbContainer, rowHeight, height, vr, renderer, dlgObj, dlgOkButton, dlgCancelButton, dlgClearButton;
            var _this = this;
            return $131d81e67ed3e476$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        filters = this.grid.getFilters();
                        currentFilters = filters.filter(function(f) {
                            return f.columnId === col.id;
                        });
                        mode = this.grid.getOptions().mode;
                        filterOptions = this.grid.getOptions().getFilterValues;
                        if (!(filterOptions == null)) return [
                            3 /*break*/ ,
                            1
                        ];
                        if (mode === "client") {
                            // remove any filters for this column
                            if (currentFilters.length > 0) this.grid.clearFilter(col.id);
                            values = this.getDistinctValues(col);
                        } else throw new Error("getFilterValues option has to be set when filter mode = server");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            filterOptions(col)
                        ];
                    case 2:
                        values = _b.sent();
                        _b.label = 3;
                    case 3:
                        oldCheckedValues = {};
                        if (currentFilters.length > 0) {
                            for(_i = 0, currentFilters_1 = currentFilters; _i < currentFilters_1.length; _i++){
                                f = currentFilters_1[_i];
                                if (f._checkedValues) oldCheckedValues = f._checkedValues;
                                if (mode === "client") filters.push(f);
                            }
                            if (mode === "client") this.grid.refreshFilters();
                        }
                        dlg = document.createElement("div");
                        dlg.classList.add("jsl-dialog-overlay");
                        dlg.innerHTML = '<div class="jsl-dialog" style="width:50vw;min-height:50vh;"><div class="dlg-header">' + (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.Filter + '</div><div class="dlg-body" style="max-height:calc(100vh - 7.5rem)"></div>' + '<div class="dlg-footer">' + '<button class="jsl-button ok-button">' + (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).core.Ok + "</button>" + (currentFilters.length > 0 ? '<button class="jsl-button clear-button">' + (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.ClearFilter + '</button>' : "") + '<button class="jsl-button close-button">' + (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).core.Cancel + "</button>" + "</div></div>";
                        dlgBody = dlg.querySelector(".dlg-body");
                        id = (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newDomGuid();
                        search = document.createElement("div");
                        search.innerHTML = "<input type='text' placeholder='" + (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.Search + "' />";
                        dlgBody.appendChild(search);
                        cbAllContainer = document.createElement("div");
                        cbAll = document.createElement("input");
                        cbAll.type = "checkbox";
                        cbAll.id = id;
                        cbAllContainer.appendChild(cbAll);
                        cbAllLabel = document.createElement("label");
                        cbAllLabel.setAttribute("for", id);
                        cbAllLabel.textContent = (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).core.All;
                        cbAllLabel.style.cursor = "pointer";
                        cbAllLabel.style.marginLeft = "0.2rem";
                        cbAllContainer.appendChild(cbAllLabel);
                        dlgBody.appendChild(cbAllContainer);
                        sortedValues = [];
                        if (Array.isArray(values)) for(_a = 0, values_1 = values; _a < values_1.length; _a++){
                            x = values_1[_a];
                            sortedValues.push({
                                id: [
                                    x
                                ],
                                txt: x !== null && x !== void 0 ? x : ""
                            });
                        }
                        else {
                            for(o in values)if (values.hasOwnProperty(o)) sortedValues.push({
                                id: values[o],
                                txt: o !== null && o !== void 0 ? o : ""
                            });
                        }
                        // TODO: use custom comparer when available
                        sortedValues.sort(function(a, b) {
                            return a.txt.toLocaleLowerCase() < b.txt.toLocaleLowerCase() ? -1 : a.txt.toLocaleLowerCase() > b.txt.toLocaleLowerCase() ? 1 : 0;
                        });
                        visibleValues = sortedValues;
                        checkedValues = $131d81e67ed3e476$var$__assign({}, oldCheckedValues);
                        cbContainer = document.createElement("div");
                        dlgBody.appendChild(cbContainer);
                        rowHeight = Math.round(ExcelFilter.convertRemToPixels(1.4));
                        height = sortedValues.length * rowHeight;
                        height = Math.min(height, Math.round(window.innerHeight - ExcelFilter.convertRemToPixels(13)));
                        vr = new (0, $8641091d2d8811cd$export$80990d9c432f0bfe)({
                            data: visibleValues,
                            renderRow: function(args) {
                                args.container.attr.style["padding-left"] = "1rem";
                                args.container.children.push({
                                    tag: "input",
                                    attr: {
                                        id: id + "_" + args.index,
                                        checked: checkedValues[args.rowData.id[0]] ? "checked" : undefined,
                                        change: function(_, node) {
                                            if (node.dom.checked) for(var _i = 0, _a = args.rowData.id; _i < _a.length; _i++){
                                                var selId = _a[_i];
                                                checkedValues[selId] = true;
                                            }
                                            else for(var _b = 0, _c = args.rowData.id; _b < _c.length; _b++){
                                                var selId = _c[_b];
                                                delete checkedValues[selId];
                                            }
                                            // check if all values or none are checked
                                            var allChecked = Object.getOwnPropertyNames(checkedValues).length === sortedValues.length;
                                            var allCb = dlgBody.querySelector("#" + id);
                                            allCb.checked = allChecked;
                                        },
                                        type: "checkbox"
                                    }
                                });
                                args.container.children.push({
                                    tag: "label",
                                    attr: {
                                        for: id + "_" + args.index,
                                        style: "margin-left:0.2rem;cursor:pointer"
                                    },
                                    raw: true,
                                    content: args.rowData.txt
                                });
                            },
                            rowHeight: rowHeight,
                            style: "height:" + height + "px"
                        });
                        renderer = new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(cbContainer, false);
                        renderer.render(vr);
                        search.addEventListener("input", function(evt) {
                            var _a;
                            var term = ((_a = evt.target.value) !== null && _a !== void 0 ? _a : "").toLowerCase();
                            if (term) visibleValues = sortedValues.filter(function(x) {
                                var _a;
                                return ((_a = x.txt) !== null && _a !== void 0 ? _a : "").toLowerCase().indexOf(term) >= 0;
                            });
                            else visibleValues = sortedValues;
                            vr.setData(visibleValues);
                            renderer.refresh();
                        });
                        cbAll.addEventListener("change", function() {
                            for(var i = 0; i < visibleValues.length; i++){
                                // if (cbAll.checked) {
                                //     checkedValues[visibleValues[i].id] = true;
                                // } else {
                                //     delete checkedValues[visibleValues[i].id];
                                // }
                                if (cbAll.checked) for(var _i = 0, _a = visibleValues[i].id; _i < _a.length; _i++){
                                    var selId = _a[_i];
                                    checkedValues[selId] = true;
                                }
                                else for(var _b = 0, _c = visibleValues[i].id; _b < _c.length; _b++){
                                    var selId = _c[_b];
                                    delete checkedValues[selId];
                                }
                            }
                            renderer.refresh();
                        });
                        document.body.appendChild(dlg);
                        dlgObj = (0, $7e905aba0f97004b$export$3ddf2d174ce01153)(dlg, {
                            autoOpen: true,
                            onClose: function() {
                                dlg.innerHTML = "";
                                dlg.parentElement.removeChild(dlg);
                            }
                        });
                        dlgOkButton = dlg.querySelector(".dlg-footer .ok-button");
                        dlgOkButton.addEventListener("click", function(evt) {
                            var selLength = Object.getOwnPropertyNames(checkedValues).length;
                            var allChecked = selLength === sortedValues.length;
                            var anyChecked = selLength > 0;
                            _this.grid.clearFilter(col.id, true);
                            if (!allChecked && anyChecked) {
                                // something (but not everything) was selected -> filter
                                var filterObject = {
                                    field: col.field,
                                    columnId: col.id,
                                    match: mode === "server" ? function() {
                                        return true;
                                    } : function(item, field) {
                                        return !!checkedValues[_this.grid.getDataItemValueForColumn(item, col)];
                                    }
                                };
                                filterObject._checkedValues = checkedValues;
                                _this.grid.addFilter(filterObject, true);
                            }
                            _this.grid.refreshFilters();
                            dlgObj.close();
                        });
                        dlgCancelButton = dlg.querySelector(".dlg-footer .close-button");
                        dlgCancelButton.addEventListener("click", function(evt) {
                            dlgObj.close();
                        });
                        dlgClearButton = dlg.querySelector(".dlg-footer .clear-button");
                        if (dlgClearButton != null) dlgClearButton.addEventListener("click", function(evt) {
                            _this.grid.clearFilter(col.id);
                            dlgObj.close();
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // private updateStateOfAllCheckebox(dlgBody: HTMLElement, id: string) {
    //     let counter = 0;
    //     let el: HTMLInputElement;
    //     const allCb: HTMLInputElement = dlgBody.querySelector("#" + id) as HTMLInputElement;
    //     // tslint:disable-next-line: no-conditional-assignment
    //     while (null != (el = dlgBody.querySelector("#" + id + "_" + counter) as HTMLInputElement)) {
    //         if (el.parentElement.style.display !== "none" && !el.checked) {
    //             allCb.checked = false;
    //             return;
    //         }
    //         counter++;
    //     }
    //     allCb.checked = true;
    // }
    // private checkAllVisibleBoxes(el: HTMLElement, state: boolean) {
    //     const checkboxes = el.querySelectorAll("input");
    //     for (let i = 0; i < checkboxes.length; i++) {
    //         if (checkboxes[i].type === "checkbox" &&
    //             checkboxes[i].parentElement.style.display !== "none") {
    //             checkboxes[i].checked = state;
    //         }
    //     }
    // }
    ExcelFilter.prototype.getDistinctValues = function(col) {
        var textToValues = {};
        for(var idx = 0, len = this.grid.getDataLength(); idx < len; idx++){
            var item = this.grid.getDataItem(idx);
            var value = this.grid.getDataItemValueForColumn(item, col);
            var text = this.grid.getFormattedValue(col, value, item);
            var valueList = textToValues[text];
            if (valueList == null) valueList = textToValues[text] = [];
            if (valueList.indexOf(value) < 0) valueList.push(value);
        }
        return textToValues;
    };
    return ExcelFilter;
}();



/**
 * Row Move Manager options:
 *    cssClass:                 A CSS class to be added to the menu item container.
 *    columnId:                 Column definition id (defaults to "_move")
 *    cancelEditOnDrag:         Do we want to cancel any Editing while dragging a row (defaults to false)
 *    disableRowSelection:      Do we want to disable the row selection? (defaults to false)
 *    hideRowMoveShadow:        Do we want to hide the row move shadow clone? (defaults to true)
 *    rowMoveShadowMarginTop:   When row move shadow is shown, optional margin-top (defaults to 0)
 *    rowMoveShadowMarginLeft:  When row move shadow is shown, optional margin-left (defaults to 0)
 *    rowMoveShadowOpacity:     When row move shadow is shown, what is its opacity? (defaults to 0.95)
 *    rowMoveShadowScale:       When row move shadow is shown, what is its size scale? (default to 0.75)
 *    singleRowMove:            Do we want a single row move? Setting this to false means that it's a multple row move (defaults to false)
 *    width:                    Width of the column
 *    usabilityOverride:        Callback method that user can override the default behavior of the row being moveable or not
 *
 */ 


var $03e298249b9b1ce5$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
// register namespace
$03e298249b9b1ce5$var$$.deepExtend(window, {
    "Slick": {
        "RowMoveManager": $03e298249b9b1ce5$export$df422edf07831381
    }
});
function $03e298249b9b1ce5$export$df422edf07831381(options) {
    var _grid;
    var _canvas;
    var _dragging;
    var _self = this;
    var _usabilityOverride = null;
    var _handler = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).EventHandler();
    var _defaults = {
        columnId: "_move",
        cssClass: null,
        cancelEditOnDrag: false,
        disableRowSelection: false,
        hideRowMoveShadow: true,
        rowMoveShadowMarginTop: 0,
        rowMoveShadowMarginLeft: 0,
        rowMoveShadowOpacity: 0.95,
        rowMoveShadowScale: 0.75,
        singleRowMove: false,
        width: 40
    };
    // user could override the expandable icon logic from within the options or after instantiating the plugin
    if (options && typeof options.usabilityOverride === 'function') usabilityOverride(options.usabilityOverride);
    function init(grid) {
        options = $03e298249b9b1ce5$var$$.deepExtend({}, _defaults, options);
        _grid = grid;
        _canvas = _grid.getCanvasNode();
        _handler.subscribe(_grid.onDragInit, handleDragInit).subscribe(_grid.onDragStart, handleDragStart).subscribe(_grid.onDrag, handleDrag).subscribe(_grid.onDragEnd, handleDragEnd);
    }
    function destroy() {
        _handler.unsubscribeAll();
    }
    function setOptions(newOptions) {
        options = $03e298249b9b1ce5$var$$.shallowExtend({}, options, newOptions);
    }
    function handleDragInit(e) {
    // // prevent the grid from cancelling drag'n'drop by default
    // e.stopImmediatePropagation();
    }
    function handleDragStart(e, dd) {
        var cell = _grid.getCellFromEvent(e);
        var currentRow = cell && cell.row;
        var dataContext = _grid.getDataItem(currentRow);
        if (!checkUsabilityOverride(currentRow, dataContext, _grid)) return;
        if (options.cancelEditOnDrag && _grid.getEditorLock().isActive()) _grid.getEditorLock().cancelCurrentEdit();
        if (_grid.getEditorLock().isActive() || !isHandlerColumn(cell.cell)) return false;
        _dragging = true;
        e.stopImmediatePropagation();
        // optionally create a shadow element of the row so that we can see all the time which row exactly we're dragging
        if (!options.hideRowMoveShadow) {
            var $slickRowElm = $03e298249b9b1ce5$var$$(_grid.getCellNode(cell.row, cell.cell)).closestClass('slick-row');
            if ($slickRowElm.length) dd.clonedSlickRow = $03e298249b9b1ce5$var$$($slickRowElm[0].cloneNode(true)).addClass('slick-reorder-shadow-row').css("marginTop", options.rowMoveShadowMarginTop || 0).css("marginLeft", options.rowMoveShadowMarginLeft || 0).css("opacity", options.rowMoveShadowOpacity || 0.95).css("transform", "scale(" + options.rowMoveShadowScale + ")").css("display", "none").appendTo(_canvas);
        }
        var selectedRows = options.singleRowMove ? [
            cell.row
        ] : _grid.getSelectedRows();
        if (selectedRows.length === 0 || selectedRows.indexOf(cell.row) === -1) {
            selectedRows = [
                cell.row
            ];
            if (!options.disableRowSelection) _grid.setSelectedRows(selectedRows);
        }
        var rowHeight = _grid.getOptions().rowHeight;
        dd.selectedRows = selectedRows;
        var canvasWidth = _canvas.getBoundingClientRect().width;
        dd.selectionProxy = $03e298249b9b1ce5$var$$(document.createElement("div")) //"<div class='slick-reorder-proxy'/>")
        .addClass("slick-reorder-proxy").css("position", "absolute").css("zIndex", "99999").css("width", canvasWidth) // $(_canvas).innerWidth())
        .css("height", rowHeight * selectedRows.length).css("display", "none").appendTo(_canvas);
        dd.guide = $03e298249b9b1ce5$var$$(document.createElement("div")) // "<div class='slick-reorder-guide'/>")
        .addClass("slick-reorder-guide").css("position", "absolute").css("zIndex", "99998").css("width", canvasWidth).css("top", -1000).appendTo(_canvas);
        dd.insertBefore = -1;
    }
    function handleDrag(e, dd) {
        if (!_dragging) return;
        // e.preventDefault();
        e.stopImmediatePropagation();
        var top = dd.pageY - $03e298249b9b1ce5$var$$(_canvas).offset().top;
        dd.selectionProxy.css("top", top - 5).css("display", ""); //.show();
        // if the row move shadow is enabled, we'll also make it follow the mouse cursor
        if (dd.clonedSlickRow) {
            var offsetY = dd.pageY - $03e298249b9b1ce5$var$$(_canvas).offset().top;
            dd.clonedSlickRow.css("top", offsetY - 6).css("display", ""); //.show();
        }
        var insertBefore = Math.max(0, Math.min(Math.round(top / _grid.getOptions().rowHeight), _grid.getDataLength()));
        if (insertBefore !== dd.insertBefore) {
            var eventData = {
                "grid": _grid,
                "rows": dd.selectedRows,
                "insertBefore": insertBefore
            };
            if (_self.onBeforeMoveRows.notify(eventData) === false) dd.canMove = false;
            else dd.canMove = true;
            // if there's a UsabilityOverride defined, we also need to verify that the condition is valid
            if (_usabilityOverride && dd.canMove) {
                var insertBeforeDataContext = _grid.getDataItem(insertBefore);
                dd.canMove = checkUsabilityOverride(insertBefore, insertBeforeDataContext, _grid);
            }
            // if the new target is possible we'll display the dark blue bar (representin the acceptability) at the target position
            // else it won't show up (it will be off the screen)
            if (!dd.canMove) dd.guide.css("top", -1000);
            else dd.guide.css("top", insertBefore * _grid.getOptions().rowHeight);
            dd.insertBefore = insertBefore;
        }
    }
    function handleDragEnd(e, dd) {
        if (!_dragging) return;
        _dragging = false;
        e.stopImmediatePropagation();
        if (dd.guide == null) console.log("dd.guide");
        else dd.guide.remove();
        if (dd.selectionProxy == null) console.log(" dd.selectionProxy");
        else dd.selectionProxy.remove();
        if (dd.clonedSlickRow) {
            dd.clonedSlickRow.remove();
            dd.clonedSlickRow = null;
        }
        if (dd.canMove) {
            var eventData = {
                "grid": _grid,
                "rows": dd.selectedRows,
                "insertBefore": dd.insertBefore
            };
            // TODO:  _grid.remapCellCssClasses ?
            _self.onMoveRows.notify(eventData);
        }
    }
    function getColumnDefinition() {
        return {
            id: options.columnId || "_move",
            name: "",
            field: "move",
            width: options.width || 40,
            behavior: "selectAndMove",
            selectable: false,
            resizable: false,
            cssClass: options.cssClass,
            formatter: moveIconFormatter
        };
    }
    function moveIconFormatter(row, cell, value, columnDef, dataContext, grid) {
        if (!checkUsabilityOverride(row, dataContext, grid)) return null;
        else return {
            addClasses: "cell-reorder dnd",
            text: ""
        };
    }
    function checkUsabilityOverride(row, dataContext, grid) {
        if (typeof _usabilityOverride === 'function') return _usabilityOverride(row, dataContext, grid);
        return true;
    }
    /**
     * Method that user can pass to override the default behavior or making every row moveable.
     * In order word, user can choose which rows to be an available as moveable (or not) by providing his own logic show/hide icon and usability.
     * @param overrideFn: override function callback
     */ function usabilityOverride(overrideFn) {
        _usabilityOverride = overrideFn;
    }
    function isHandlerColumn(columnIndex) {
        return /move|selectAndMove/.test(_grid.getColumns()[columnIndex].behavior);
    }
    $03e298249b9b1ce5$var$$.shallowExtend(this, {
        "onBeforeMoveRows": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onMoveRows": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "init": init,
        "destroy": destroy,
        "getColumnDefinition": getColumnDefinition,
        "setOptions": setOptions,
        "usabilityOverride": usabilityOverride,
        "isHandlerColumn": isHandlerColumn,
        "pluginName": "RowMoveManager"
    });
} // })(jQuery);







var $b26535a80c28c13e$var$selectinOverlayWidth = 1;
var $b26535a80c28c13e$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
// register namespace
$b26535a80c28c13e$var$$.deepExtend(window, {
    "Ext": {
        "Plugins": {
            "Overlays": $b26535a80c28c13e$export$55aa2daecc2e1e7b
        }
    }
});
function $b26535a80c28c13e$export$55aa2daecc2e1e7b(options) {
    var $headerOverlay;
    var $rowOverlay;
    var selectionOverlay;
    var currentColumn;
    var handleDragging;
    var grid;
    var self = this;
    var handler = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).EventHandler();
    var dragDecorator;
    var defaults = {
        buttonCssClass: null,
        buttonImage: "../images/down.gif",
        decoratorWidth: 2
    };
    function init(g) {
        options = $b26535a80c28c13e$var$$.deepExtend({}, defaults, options);
        grid = g;
        dragDecorator = overlayRangeDecorator(grid);
        $headerOverlay = createRowHeaderOverlay(100);
        $rowOverlay = createRowHeaderOverlay(100);
        selectionOverlay = createSelectionOverlay();
        handler.subscribe(grid.onActiveCellChanged, activeCellChanged).subscribe(grid.onColumnsResized, columnResized).subscribe(grid.onScroll, gridScrolled);
    }
    function destroy() {
        handler.unsubscribeAll();
    }
    function createRowHeaderOverlay(zIndex) {
        return $b26535a80c28c13e$var$$(document.createElement("div")).addClass("header-overlay").css("position", "absolute").css("z-index", zIndex).appendTo(grid.getContainerNode());
    }
    function createSelectionOverlay() {
        var canvas = grid.getCanvasNode();
        var overlay = new Overlay(canvas, true);
        return overlay;
    }
    function activeCellChanged(e, args) {
        dragDecorator.hide();
        moveSelectionOverlay(e, args);
        moveHeaderRowOverlays(e, args);
    }
    function columnResized(e, args) {
        moveHeaderRowOverlays(e, args);
        moveSelectionOverlay(e, args);
    }
    function gridScrolled(e, args) {
        moveHeaderRowOverlays(e, args);
        moveSelectionOverlay(e, args);
    }
    function moveHeaderRowOverlays(e, args) {
        if (typeof args.cell != 'undefined') currentColumn = args.cell;
        else {
            if (!currentColumn) return;
        }
        if (!grid.getActiveCell()) {
            $rowOverlay.css("display", "none");
            return;
        }
        $rowOverlay.css("display", "");
        var headerHeight = grid.getContainerNode().querySelector('.slick-header').getBoundingClientRect().height;
        var cellPosition = grid.getActiveCellPosition();
        var gridPosition = grid.getGridPosition();
        $rowOverlay.css("display", cellPosition.visible ? "" : "none");
        $headerOverlay.css("display", cellPosition.visible ? "" : "none");
        var headerWidth = cellPosition.width;
        $headerOverlay.css("left", cellPosition.left - gridPosition.left + "px").css("top", headerHeight - 2 + "px").css("width", headerWidth + "px").css("height", "2px");
        $rowOverlay.css("left", "0px").css("top", cellPosition.top - gridPosition.top + "px").css("width", "2px").css("height", cellPosition.height + "px");
    }
    function moveSelectionOverlay(e, args) {
        var activeCell = grid.getActiveCell();
        if (!activeCell) {
            selectionOverlay.toggle(false);
            return;
        }
        var column = grid.getColumns()[activeCell.cell];
        selectionOverlay.toggle(true);
        // Only show the handle if the cell is editable
        selectionOverlay.handle.style.display = column.editor != null && !column.readonly && grid.getOptions().editable ? "" : "none";
        var position = grid.getCellNodeBox(activeCell.row, activeCell.cell);
        // Not coming through on the property so re-calculated
        position.height = position.bottom - position.top;
        position.width = position.right - position.left;
        selectionOverlay.$left.css({
            left: position.left - $b26535a80c28c13e$var$selectinOverlayWidth + "px",
            top: position.top + "px",
            width: $b26535a80c28c13e$var$selectinOverlayWidth + "px",
            height: position.height + "px"
        });
        selectionOverlay.$right.css({
            left: position.left + position.width + "px",
            top: position.top + "px",
            width: $b26535a80c28c13e$var$selectinOverlayWidth + "px",
            height: position.height + "px"
        });
        selectionOverlay.$top.css({
            left: position.left - $b26535a80c28c13e$var$selectinOverlayWidth + "px",
            top: position.top - $b26535a80c28c13e$var$selectinOverlayWidth + "px",
            width: position.width + $b26535a80c28c13e$var$selectinOverlayWidth + 1 + "px",
            height: $b26535a80c28c13e$var$selectinOverlayWidth + "px"
        });
        selectionOverlay.$bottom.css({
            left: position.left - $b26535a80c28c13e$var$selectinOverlayWidth + "px",
            top: position.top + position.height + "px",
            width: position.width + $b26535a80c28c13e$var$selectinOverlayWidth + 1 + "px",
            height: $b26535a80c28c13e$var$selectinOverlayWidth + "px"
        });
        selectionOverlay.handle.style.left = position.left + position.width - 4 + "px";
        selectionOverlay.handle.style.top = position.top + position.height - 4 + "px";
        // console.log("row: " + activeCell.row + " - cell: "+ activeCell.cell);
        // console.log("container: " + grid.getCanvasNode(activeCell.row, activeCell.cell).className);
        selectionOverlay.moveToContainer(grid.getCanvasNode(activeCell.cell, activeCell.row));
    }
    var dd_range;
    function handleOverlayDragStart(e) {
        var cell = grid.getActiveCell();
        if (grid.canCellBeSelected(cell.row, cell.cell)) handleDragging = true;
        if (!handleDragging) {
            e.cancelEvent();
            return null;
        }
        grid.focus();
        dd_range = {
            start: cell,
            end: {}
        };
        return dragDecorator.show(new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Range(cell.row, cell.cell));
    }
    function handleOverlayDrag(e) {
        if (!handleDragging) return;
        var end = {
            cell: dd_range.start.cell,
            row: grid.getCellFromPoint(0, e.y /* + grid.getCanvasNode().scrollTop*/ ).row - 1
        };
        if (!grid.canCellBeSelected(end.row, end.cell)) {
            e.cancelEvent(); // ?
            return;
        }
        dd_range.end = end;
        dragDecorator.show(new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Range(dd_range.start.row, dd_range.start.cell, end.row, dd_range.start.cell));
    }
    function handleOverlayDragEnd(e) {
        if (!handleDragging) return;
        handleDragging = false;
        selectionOverlay.handle.style.display = "none";
        self.onFillUpDown.notify({
            "grid": grid,
            "range": dragDecorator.getSelectedRange(),
            direction: dd_range.end.row >= dd_range.start.row ? "down" : "up"
        }, e, self);
    }
    function Overlay(target, withHandel, prefix) {
        var className = (prefix || '') + 'cell-overlay';
        this.$left = $b26535a80c28c13e$var$$(document.createElement("div")).addClass(className).addClass('left').appendTo(target);
        this.$right = $b26535a80c28c13e$var$$(document.createElement("div")).addClass(className).addClass('right').appendTo(target);
        this.$top = $b26535a80c28c13e$var$$(document.createElement("div")).addClass(className).addClass('top').appendTo(target);
        this.$bottom = $b26535a80c28c13e$var$$(document.createElement("div")).addClass(className).addClass('bottom').appendTo(target);
        if (withHandel) {
            this.handle = document.createElement("div");
            this.handle.classList.add("handle-overlay");
            target.appendChild(this.handle);
            var gridContainer = target.closest(".slickgrid");
            var viewports = gridContainer.querySelectorAll(".grid-canvas");
            for(var idx = 0; idx < viewports.length; idx++){
                console.log(idx);
                (0, $13f81d53256d6031$export$4f463cee1ac70b5b)(viewports[idx], {
                    selector: ".handle-overlay",
                    direction: "y",
                    gridY: grid.getOptions().rowHeight,
                    containInParent: false,
                    onStart: (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(function(e) {
                        handleOverlayDragStart(e);
                    }),
                    onMove: (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(function(e) {
                        handleOverlayDrag(e);
                    }),
                    onStop: (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(function(e) {
                        handleOverlayDragEnd(e);
                    })
                });
            }
        }
        this.moveToContainer = function(container) {
            this.$left.appendTo(container);
            this.$right.appendTo(container);
            this.$top.appendTo(container);
            this.$bottom.appendTo(container);
            if (this.handle) $b26535a80c28c13e$var$$(this.handle).appendTo(container);
        };
        this.toggle = function(showOrHide) {
            this.$left.css("display", showOrHide ? "" : "none");
            this.$right.css("display", showOrHide ? "" : "none");
            this.$top.css("display", showOrHide ? "" : "none");
            this.$bottom.css("display", showOrHide ? "" : "none");
            if (this.handle) this.handle.style.display = showOrHide ? "" : "none";
        };
    }
    function overlayRangeDecorator(targetGrid) {
        var decorator;
        var r;
        function show(range) {
            r = range;
            if (!decorator) decorator = new Overlay(grid.getCanvasNode(range.fromCell, range.fromRow), false, 'selection-');
            var from = targetGrid.getCellNodeBox(range.fromRow, range.fromCell);
            var to = targetGrid.getCellNodeBox(range.toRow, range.toCell);
            decorator.$left.css({
                top: from.top - 2,
                left: from.left - 2,
                height: to.bottom - from.top + 2,
                width: options.decoratorWidth
            });
            decorator.$right.css({
                top: from.top - 2,
                left: to.right - 1,
                height: to.bottom - from.top + 2,
                width: options.decoratorWidth
            });
            decorator.$top.css({
                top: from.top - 2,
                left: to.left - 1,
                height: options.decoratorWidth,
                width: to.right - from.left + 2
            });
            decorator.$bottom.css({
                top: to.bottom - 1,
                left: from.left - 2,
                height: options.decoratorWidth,
                width: to.right - from.left + 3
            });
            return decorator;
        }
        function getSelectedRange() {
            return r;
        }
        function hide() {
            if (decorator) {
                decorator.toggle(false);
                decorator = null;
            }
        }
        return {
            hide: hide,
            show: show,
            getSelectedRange: getSelectedRange
        };
    }
    $b26535a80c28c13e$var$$.shallowExtend(this, {
        "init": init,
        "destroy": destroy,
        "onFillUpDown": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event()
    });
}


var $2e6e333d8ae6bd57$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
function $2e6e333d8ae6bd57$export$ad55d0f282934b51(selector, data, columns, option) {
    var formulaObjects = [];
    var headerMenu;
    var headerButtons;
    var formulas = {};
    var container;
    var filters = [];
    var customCommandHandler;
    var grid;
    var dataView;
    var rowMoveManager;
    //let options: ISlickCreatorOptions;
    function createMe() {
        sanitizeColumns(columns);
        var options = $2e6e333d8ae6bd57$var$$.shallowExtend({
            explicitInitialization: true,
            mode: "client"
        }, option);
        container = typeof selector === "string" ? document.querySelector(selector) : selector;
        if (!container) throw new Error("error: selector for SlickCreator is invalid");
        if (options.showColumnGroups) {
            options.createPreHeaderPanel = true;
            options.showPreHeaderPanel = true;
        }
        customCommandHandler = option.editCommandHandler;
        options.editCommandHandler = function(a, b, c) {
            handleEditCommand(a, b, c);
        };
        var groupItemMetadataProvider = options.groupItemMetadataProvider || (0, $904380656eea9a53$export$1eebeefb78654a9b)(options.groupItemOptions);
        if (options.dataView != null) dataView = options.dataView;
        else {
            dataView = new (0, $44a0f294ad0c9e06$export$5e15d737b33a1c27)({
                inlineFilters: true,
                groupItemMetadataProvider: groupItemMetadataProvider
            });
            dataView.setItems(data, options.primaryKey);
        }
        grid = new (0, $7adda6f44168d508$export$e8193cfe09a919d1)(container, dataView, columns, options);
        grid.registerPlugin(groupItemMetadataProvider);
        grid.setSelectionModel(new (0, $db3a1ddf1e35945b$export$74355f455fb26b7b)());
        grid.onHeaderCellRendered.subscribe(function(e, args) {
            if (columnHasFilter(args.column.id)) //this column is filtered
            args.node.classList.add("slick-filtered-header");
        });
        addCustomEvents();
        setupDefaultSort();
        setupChangeEvents();
        if (options.showHeaderMenu) setupHeaderMenu();
        setupHeaderButtons();
        if (options.allowRowMove) {
            rowMoveManager = new (0, $03e298249b9b1ce5$export$df422edf07831381)({
                cancelEditOnDrag: true,
                singleRowMove: true,
                disableRowSelection: true,
                hideRowMoveShadow: false,
                rowMoveShadowScale: 0.7,
                rowMoveShadowOpacity: 0.9 // defaults to 0.95
            });
            grid.registerPlugin(rowMoveManager);
            rowMoveManager.onBeforeMoveRows.subscribe(function(e, args) {
            // debugger;
            });
            rowMoveManager.onMoveRows.subscribe(function(e, args) {
                var extractedRows = [], left, right;
                var rows = args.rows;
                var insertBefore = args.insertBefore;
                left = data.slice(0, insertBefore);
                right = data.slice(insertBefore, data.length);
                rows.sort(function(a, b) {
                    return a - b;
                });
                for(var i = 0; i < rows.length; i++)extractedRows.push(data[rows[i]]);
                rows.reverse();
                for(var i = 0; i < rows.length; i++){
                    var row = rows[i];
                    if (row < insertBefore) left.splice(row, 1);
                    else right.splice(row - insertBefore, 1);
                }
                data = left.concat(extractedRows.concat(right));
                var selectedRows = [];
                for(var i = 0; i < rows.length; i++)selectedRows.push(left.length + i);
                // grid.resetActiveCell();
                dataView.beginUpdate();
                dataView.setItems(data);
                dataView.endUpdate();
                grid.render();
            });
        }
        if (option.enableFillDown) {
            var overlayPlugin = new (0, $b26535a80c28c13e$export$55aa2daecc2e1e7b)({});
            // Event fires when a range is selected
            overlayPlugin.onFillUpDown.subscribe(function(e, args) {
                var column = grid.getColumns()[args.range.fromCell];
                // Ensure the column is editable
                if (column.editor == null || column.readonly || !grid.getOptions().editable) return;
                // Find the initial value
                dataView.beginUpdate();
                var value;
                var items = [];
                if (args.direction === "down") {
                    var item = dataView.getItem(args.range.fromRow);
                    value = grid.getDataItemValueForColumn(item, column); // item[column.field];
                    // Copy the value down
                    for(var i = args.range.fromRow + 1; i <= args.range.toRow; i++)if (grid.onBeforeEditCell.notify({
                        row: i,
                        cell: args.range.fromCell,
                        item: dataView.getItem(i),
                        column: column
                    }, e) !== false) {
                        var currentItem = dataView.getItem(i);
                        items.push(currentItem);
                    // if (options.setDataItemValueForColumn != null) {
                    //     options.setDataItemValueForColumn(currentItem, column, value);
                    // } else {
                    //     dataView.getItem(i)[column.field] = value;
                    // }
                    // grid.invalidateRow(i);
                    // grid.onAfterEdit.notify({ grid, oldValue, newValue: value, column, item: dataView.getItem(i) }, e);
                    }
                } else {
                    var item = dataView.getItem(args.range.toRow);
                    items.push(item);
                    value = grid.getDataItemValueForColumn(item, column); // item[column.field];
                    // Copy the value up
                    for(var i = args.range.fromRow; i <= args.range.toRow - 1; i++)if (grid.onBeforeEditCell.notify({
                        row: i,
                        cell: args.range.fromCell,
                        item: dataView.getItem(i),
                        column: column
                    }, e) !== false) {
                        var currentItem = dataView.getItem(i);
                        items.push(currentItem);
                    // if (options.setDataItemValueForColumn != null) {
                    //     options.setDataItemValueForColumn(currentItem, column, value);
                    // } else {
                    //     dataView.getItem(i)[column.field] = value;
                    // }
                    // grid.invalidateRow(i);
                    // grid.onAfterEdit.notify({ grid, oldValue, newValue: value, column, item: dataView.getItem(i) }, e);
                    }
                }
                grid.onAfterFillDown.notify({
                    grid: grid,
                    value: value,
                    column: column,
                    direction: args.direction,
                    range: args.range,
                    items: items
                }, e);
                dataView.endUpdate();
                grid.render();
            });
            grid.registerPlugin(overlayPlugin);
        }
        if (!option.explicitInitialization) grid.init();
        if (options.showColumnGroups) setTimeout(function() {
            // TODO -> find better solution then timeout
            grid.onColumnsResized.subscribe(function() {
                CreateColumnGroups();
            });
            CreateColumnGroups();
        }, 1);
        if (options.saveColumnsKey) {
            grid.onColumnsResized.subscribe(function() {
                storeColumnSettings();
            });
            grid.onColumnsReordered.subscribe(function() {
                storeColumnSettings();
            });
            loadColumnSettings();
        }
    }
    function CreateColumnGroups() {
        var options = grid.getOptions();
        var columns = grid.getColumns();
        if (options.frozenColumn >= 0) {
            // Add column groups to left panel
            var $preHeaderPanel = $2e6e333d8ae6bd57$var$$(grid.getPreHeaderPanel());
            renderHeaderGroups($preHeaderPanel, 0, options.frozenColumn + 1);
            // Add column groups to right panel
            $preHeaderPanel = $2e6e333d8ae6bd57$var$$(grid.getPreHeaderPanelRight());
            renderHeaderGroups($preHeaderPanel, options.frozenColumn + 1, columns.length);
        } else {
            var $preHeaderPanel = $2e6e333d8ae6bd57$var$$(grid.getPreHeaderPanel());
            renderHeaderGroups($preHeaderPanel, 0, columns.length);
        }
        function renderHeaderGroups(preHeaderPanel, start, end) {
            preHeaderPanel.empty().addClass("slick-header-columns").css("left", "-1000px").width(grid.getHeadersWidth());
            preHeaderPanel[0].parentElement.classList.add("slick-header");
            var headerColumnWidthDiff = grid.getHeaderColumnWidthDiff();
            var header;
            var lastColumnGroup = "";
            var widthTotal = 0;
            for(var i = start; i < end; i++){
                var m = columns[i];
                if (lastColumnGroup === m.columnGroup && i > start) {
                    widthTotal += m.width;
                    header.width(widthTotal - headerColumnWidthDiff);
                } else {
                    widthTotal = m.width;
                    header = $2e6e333d8ae6bd57$var$$("<div class='ui-state-default slick-header-column' />").html("<span class='slick-column-name'>" + (m.columnGroup || '') + "</span>").width(m.width - headerColumnWidthDiff).appendTo(preHeaderPanel);
                }
                lastColumnGroup = m.columnGroup;
            }
        }
    }
    function storeColumnSettings() {
        var cols = grid.getColumns();
        var options = grid.getOptions();
        var colSettings = cols.map(function(c) {
            return {
                id: c.id,
                width: c.width
            };
        });
        if (window.localStorage) localStorage.setItem("_grid_col_settings_" + options.saveColumnsKey, JSON.stringify(colSettings));
    }
    function loadColumnSettings() {
        if (!window.localStorage) return;
        var options = grid.getOptions();
        var key = options.saveColumnsKey;
        if (key) {
            var cols = grid.getColumns();
            var colSettings = JSON.parse(localStorage.getItem("_grid_col_settings_" + key));
            if (!colSettings) return;
            for(var i = 0; i < colSettings.length; i++){
                for(var j = 0; j < cols.length; j++)if (cols[j].id === colSettings[i].id) {
                    var c = cols[j];
                    c.width = colSettings[i].width;
                    if (i !== j) {
                        cols.splice(j, 1);
                        cols.splice(i, 0, c);
                    }
                    break;
                }
            }
            grid.setColumns(cols);
        }
    }
    function sanitizeColumns(cols) {
        for(var i = 0; i < cols.length; i++){
            var c = cols[i];
            if (c.field === undefined && c.id) c.field = c.id;
        }
    }
    function addCustomEvents() {
        grid.onAfterEdit = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event();
        grid.onFiltersChanged = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event();
        grid.onAfterFillDown = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event();
    }
    function setupChangeEvents() {
        dataView.onRowsChanged.subscribe(function(e, args) {
            grid.invalidateRows(args.rows);
            grid.render();
        // for (let idx = 0; idx < args.rows.length; idx++) {
        //     grid.updateRow(args.rows[idx]);
        // }
        // grid.invalidate();
        });
        dataView.onRowCountChanged.subscribe(function(e, args) {
            grid.updateRowCount();
            grid.render();
        });
        grid.onAddNewRow.subscribe(function(e, args) {
            var options = grid.getOptions();
            if (options.provideDefaultValues != null) {
                var result = options.provideDefaultValues(args.item);
                if (result === false) return;
            }
            dataView.addItem(args.item);
            grid.onAfterEdit.notify({
                grid: grid,
                oldValue: undefined,
                newValue: grid.getDataItemValueForColumn(args.item, args.column),
                column: args.column,
                item: args.item
            });
        });
    }
    function setupDefaultSort() {
        var options = grid.getOptions();
        if (options.mode === "client") grid.onSort.subscribe(function(e, args) {
            sort(args.sortCol, args.sortAsc);
        });
    // TODO: multi column sort
    }
    function setupHeaderButtons() {
        headerButtons = new (0, $e808d74d2acf79f5$export$ed80cdffa8822341)({});
        grid.registerPlugin(headerButtons);
    }
    function setupHeaderMenu() {
        headerMenu = new (0, $c1bc8c5e97c70a11$export$2730b686806681be)({});
        grid.registerPlugin(headerMenu);
        headerMenu.onBeforeMenuShow.subscribe(function(e, args) {
            var column = args.column;
            var menu = args.menu;
            if (column.sortable) {
                menu.items.push({
                    title: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.Sort + " " + (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.Asc,
                    command: "sort-asc"
                });
                menu.items.push({
                    title: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.Sort + " " + (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.Desc,
                    command: "sort-desc"
                });
            }
            if (column.filterable) {
                menu.items.push({
                    title: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.Filter,
                    command: "filter"
                });
                if (filters.filter(function(f) {
                    return f.columnId === column.id;
                }).length > 0) menu.items.push({
                    title: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).grid.ClearFilter,
                    command: "clear-filter"
                });
            }
        });
        headerMenu.onCommand.subscribe(function(e, args) {
            if (args.command === "sort-asc" || args.command === "sort-desc") grid.onSort.notify({
                sortAsc: args.command === "sort-asc",
                sortCol: args.column,
                columnId: args.column.id,
                sortCols: [
                    {
                        columnId: args.column.id,
                        sortCol: args.column,
                        sortAsc: args.command === "sort-asc"
                    }
                ],
                multiColumnSort: false
            }, e);
            else if (args.command === "filter") {
                var options = grid.getOptions();
                if (options.showFilterDialog != null) options.showFilterDialog(args.column, grid);
                else new (0, $131d81e67ed3e476$export$d4696dc82bf44c04)(grid).show(args.column);
            } else if (args.command === "clear-filter") clearFilter(args.column.id);
        });
    }
    // refresh formulas depending on the given column
    function triggerFormula(column, item) {
        var options = grid.getOptions();
        var f = formulas[column];
        if (f) {
            for(var i = 0, l = f.length; i < l; i++)if (options.setDataItemValueForColumn != null) options.setDataItemValueForColumn(item, f[i].column, f[i].fnc(item, column));
            else item[f[i].column] = f[i].fnc(item, column);
        }
    }
    function handleEditCommand(item, column, editCommand) {
        var options = grid.getOptions();
        var oldVal = grid.getDataItemValueForColumn(item, column);
        if (customCommandHandler) customCommandHandler(item, column, editCommand);
        else editCommand.execute();
        triggerFormula(column.field, item);
        dataView.updateItem(item[options.primaryKey], item);
        var afterEditResult = grid.onAfterEdit.notify({
            grid: grid,
            oldValue: oldVal,
            newValue: grid.getDataItemValueForColumn(item, column),
            column: column,
            item: item
        });
        if (afterEditResult === false) {
            if (options.setDataItemValueForColumn != null) options.setDataItemValueForColumn(item, column, oldVal);
            else item[column.field] = oldVal;
            triggerFormula(column.field, item);
            dataView.updateItem(item[options.primaryKey], item);
        }
    }
    function setHeight(height) {
        $2e6e333d8ae6bd57$var$$(container).height(height);
        grid.resizeCanvas();
    }
    function getHeight() {
        return $2e6e333d8ae6bd57$var$$(container).height();
    }
    function sort(column, sortAsc) {
        function _comparer(a, b) {
            var x = grid.getDataItemValueForColumn(a, column);
            var y = grid.getDataItemValueForColumn(b, column);
            if (typeof x === "string" && typeof y === "string") {
                x = x.toLocaleLowerCase();
                y = y.toLocaleLowerCase();
            }
            if (x == null && y != null) return -1;
            else if (x != null && y == null) return 1;
            else return x === y ? 0 : x > y ? 1 : -1;
        }
        function _visibleComparer(a, b) {
            var x = column.formatter(0, 0, grid.getDataItemValueForColumn(a, column), column, a);
            var y = column.formatter(0, 0, grid.getDataItemValueForColumn(b, column), column, b);
            var xStr = Object.prototype.toString.call(x) !== "[object Object]" ? x : x.text;
            var yStr = Object.prototype.toString.call(y) !== "[object Object]" ? y : y.text;
            if (typeof x === "string" && typeof y === "string") {
                xStr = x.toLocaleLowerCase();
                yStr = y.toLocaleLowerCase();
            }
            return xStr === yStr ? 0 : xStr > yStr ? 1 : -1;
        }
        var comparer = column.comparer || (column.sortByVisibleValue ? _visibleComparer : _comparer);
        dataView.sort(comparer, sortAsc ? true : false);
    }
    function setData(newData) {
        data = newData;
        dataView.setItems(data);
        refresh();
    }
    function getData() {
        return data;
    }
    function refreshData() {
        // var selrows = self.getSelectedRows();
        dataView.setItems(data);
        // self.setSelectedRows(selrows);
        refresh();
    }
    function refresh() {
        grid.invalidate();
    }
    function addFormula(field, fnc, usedColumns) {
        formulaObjects.push({
            fnc: fnc,
            column: field
        });
        for(var i = 0; i < usedColumns.length; i++){
            if (!formulas[usedColumns[i]]) formulas[usedColumns[i]] = [];
            formulas[usedColumns[i]].push({
                fnc: fnc,
                column: field
            });
        }
    }
    /**
     * returns the string representation of a value based on column settings
     */ function getFormattedValue(column, value, item) {
        var formatter = column.formatter || (0, $a73c3dbce15de2c5$export$cfc95f342033cc43);
        var formatterResult = formatter(0, 0, value, column, item, grid);
        return Object.prototype.toString.call(formatterResult) !== "[object Object]" ? formatterResult : formatterResult.text;
    }
    function getContentWidth(column, row) {
        var item = dataView.getItem(row);
        var html = getFormattedValue(column, grid.getDataItemValueForColumn(item, column), item);
        if (html.indexOf("<") >= 0) return calcLengthInternal(html, true) + 12;
        else {
            if (convertElement == null) convertElement = document.createElement("span");
            convertElement.innerHTML = html;
            return calcTextLength(convertElement.textContent) + 12;
        }
    }
    var measureElement;
    var convertElement;
    var charWidth = {};
    function calcTextLength(text) {
        var result = 0;
        for(var i = 0; i < text.length; i++){
            var c = text[i];
            var w = charWidth[c];
            if (w == null) charWidth[c] = w = calcLengthInternal(c, false);
            result += w;
        }
        return result;
    }
    function calcLengthInternal(c, isHTML) {
        if (measureElement == null) {
            measureElement = document.createElement("span");
            measureElement.style.top = "-100000px";
            measureElement.style.position = "absolute";
            measureElement.style.whiteSpace = "pre";
            document.body.appendChild(measureElement);
            grid.onBeforeDestroy.subscribe(function() {
                if (measureElement.parentElement != null) measureElement.parentElement.removeChild(measureElement);
            });
        }
        if (isHTML) measureElement.innerHTML = c;
        else measureElement.textContent = c;
        return measureElement.getBoundingClientRect().width;
    }
    function fitToContent(column) {
        var width = 10;
        for(var idx = 0, len = grid.getDataLength(); idx < len; idx++)//const d = grid.getDataItem(idx);
        width = Math.max(width, getContentWidth(column, idx));
        column.width = width;
        grid.setColumns(grid.getColumns());
    // TODO: raise column resize event
    // TODO (2): find more performant way to refresh columns
    }
    function triggerAllFormulas() {
        if (formulaObjects.length === 0) return;
        for(var j = 0; j < formulaObjects.length; j++)for(var i = 0; i < data.length; i++){
            var val = formulaObjects[j].fnc(data[i], grid, formulaObjects[j].column);
            data[i][formulaObjects[j].column] = val;
        }
        refreshData();
    }
    function columnHasFilter(columnId) {
        for(var i = 0, l = filters ? filters.length : 0; i < l; i++){
            if (filters[i].columnId === columnId) return true;
        }
        return false;
    }
    function refreshDataItem(item) {
        var options = grid.getOptions();
        dataView.updateItem(item[options.primaryKey], item);
        // formula refresh
        for(var f in formulas)if (formulas.hasOwnProperty(f)) triggerFormula(f, item);
        grid.updateRow(dataView.getRowByItem(item));
    }
    function addFilter(filter, dontrefresh) {
        var filterArray;
        if (Array.isArray(filter)) filterArray = filter;
        else filterArray = [
            filter
        ];
        for(var idx = 0; idx < filterArray.length; idx++)// add filter
        filters.push(filterArray[idx]);
        if (!dontrefresh) refreshFilters();
    }
    function setFilters(f, dontrefresh) {
        filters = f;
        if (!dontrefresh) refreshFilters();
    }
    function getFilters() {
        return filters;
    }
    function clearFilter(columnId, dontrefresh) {
        if (columnId === undefined) filters.length = 0;
        else {
            for(var i = 0; i < filters.length; i++)if (filters[i].columnId === columnId) {
                filters.splice(i, 1);
                i--;
            }
        }
        if (!dontrefresh) refreshFilters();
    }
    function refreshFilters(noColumnHeaderRefresh) {
        var options = grid.getOptions();
        function client_filter(item, args) {
            var filterArray = args;
            // no filter present -> show all rows
            if (filterArray.length === 0) return true;
            if (filterArray.length === 1) return filterArray[0].match.call(null, item, filterArray[0].field);
            else {
                var result = true;
                var i = 0;
                while(i < filterArray.length){
                    var orResult = false;
                    while(i < filterArray.length){
                        if (orResult || filterArray[i].match.call(null, item, filterArray[i].field)) orResult = true;
                        if (filterArray[i].combine !== "or") break;
                        else i++;
                    }
                    if (!orResult) {
                        result = false;
                        break;
                    }
                    i++;
                }
                return result;
            }
        }
        if (options.mode === "client") {
            dataView.setFilterArgs(filters);
            dataView.setFilter(client_filter);
        }
        // redraw columns
        if (!noColumnHeaderRefresh) grid.setColumns(grid.getColumns());
        grid.onFiltersChanged.notify();
    }
    function getSelectedItems() {
        var selRows = grid.getSelectedRows();
        var rows = [];
        for(var i = 0; i < selRows.length; i++){
            var rowIdx = selRows[i];
            var toPush = dataView.getItem(rowIdx);
            if (toPush !== undefined && !toPush.__group && !toPush.__groupTotals) rows.push(toPush);
        }
        return rows;
    }
    function getRowMoveManager() {
        return rowMoveManager;
    }
    function getHeaderMenu() {
        return headerMenu;
    }
    // function setHierachy(o: IGridTreeOptions): GridTree {
    //     return new GridTree(this, o);
    // }
    createMe();
    return $2e6e333d8ae6bd57$var$$.shallowExtend(grid, {
        dataView: dataView,
        setHeight: setHeight,
        getHeight: getHeight,
        sort: sort,
        refreshData: refreshData,
        setData: setData,
        getData: getData,
        refresh: refresh,
        addFormula: addFormula,
        getFormattedValue: getFormattedValue,
        getContentWidth: getContentWidth,
        fitToContent: fitToContent,
        triggerAllFormulas: triggerAllFormulas,
        columnHasFilter: columnHasFilter,
        refreshDataItem: refreshDataItem,
        addFilter: addFilter,
        setFilters: setFilters,
        getFilters: getFilters,
        clearFilter: clearFilter,
        refreshFilters: refreshFilters,
        getSelectedItems: getSelectedItems,
        getRowMoveManager: getRowMoveManager,
        getHeaderMenu: getHeaderMenu // ,
    });
}



/*
 * Contains basic SlickGrid editors.
 */ 
var $3a42d280e31bdca5$export$6d3e562ac77a9517 = {
    LEFT: 37,
    RIGHT: 39
};
function $3a42d280e31bdca5$export$b1c04d4da2f40c22(e) {
    var cursorPosition = e.target.selectionStart;
    var textLength = e.target.value.length;
    if (e.which === $3a42d280e31bdca5$export$6d3e562ac77a9517.LEFT && cursorPosition > 0 || e.which === $3a42d280e31bdca5$export$6d3e562ac77a9517.RIGHT && cursorPosition < textLength) e.stopImmediatePropagation();
}
function $3a42d280e31bdca5$export$2168f8b210fee1c6(e) {
    if (e.which === $3a42d280e31bdca5$export$6d3e562ac77a9517.LEFT || e.which === $3a42d280e31bdca5$export$6d3e562ac77a9517.RIGHT) e.stopImmediatePropagation();
}


function $4a86594dc9c8ba91$export$3e10f1206980ab22(args) {
    var input;
    var defaultValue;
    var scope = this;
    this.init = function() {
        var navOnLR = args.grid.getOptions().editorCellNavOnLRKeys;
        input = document.createElement("input");
        input.type = "text";
        input.className = "editor-text";
        if (args.column.maxLength > 0) input.maxLength = args.column.maxLength;
        input.addEventListener("keydown", navOnLR ? (0, $3a42d280e31bdca5$export$b1c04d4da2f40c22) : (0, $3a42d280e31bdca5$export$2168f8b210fee1c6));
        args.container.appendChild(input);
        input.focus();
        input.select();
    };
    this.destroy = function() {
        input.parentElement.removeChild(input);
    };
    this.focus = function() {
        input.focus();
    };
    this.getValue = function() {
        return input.value;
    };
    this.setValue = function(val) {
        input.value = val;
    };
    this.loadValue = function(item) {
        defaultValue = item[args.column.field] || "";
        input.value = defaultValue;
        input.defaultValue = defaultValue;
        input.select();
    };
    this.serializeValue = function() {
        return input.value;
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        return !(input.value == "" && defaultValue == null) && input.value != defaultValue;
    };
    this.validate = function() {
        if (args.column.validator) {
            var validationResults = args.column.validator(input.value);
            if (!validationResults.valid) return validationResults;
        }
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}
function $4a86594dc9c8ba91$export$795255552f9897dd(args) {
    var input;
    var defaultValue;
    var scope = this;
    this.init = function() {
        var navOnLR = args.grid.getOptions().editorCellNavOnLRKeys;
        input = document.createElement("textarea");
        if (args.column.maxLength > 0) input.maxLength = args.column.maxLength;
        input.className = "editor-text";
        input.addEventListener("keydown", navOnLR ? (0, $3a42d280e31bdca5$export$b1c04d4da2f40c22) : (0, $3a42d280e31bdca5$export$2168f8b210fee1c6));
        args.container.appendChild(input);
        input.focus();
        input.select();
    };
    this.destroy = function() {
        input.parentElement.removeChild(input);
    };
    this.focus = function() {
        input.focus();
    };
    this.getValue = function() {
        return input.value;
    };
    this.setValue = function(val) {
        input.value = val;
    };
    this.loadValue = function(item) {
        defaultValue = item[args.column.field] || "";
        input.value = defaultValue;
        input.defaultValue = defaultValue;
        input.select();
    };
    this.serializeValue = function() {
        return input.value;
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        return !(input.value == "" && defaultValue == null) && input.value != defaultValue;
    };
    this.validate = function() {
        if (args.column.validator) {
            var validationResults = args.column.validator(input.value);
            if (!validationResults.valid) return validationResults;
        }
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}
function $4a86594dc9c8ba91$export$ef9fab39e217a22e(args) {
    var input;
    var defaultValue;
    var scope = this;
    this.init = function() {
        var navOnLR = args.grid.getOptions().editorCellNavOnLRKeys;
        input = document.createElement("input");
        input.type = "text";
        input.className = "editor-text right";
        input.addEventListener("keydown", navOnLR ? (0, $3a42d280e31bdca5$export$b1c04d4da2f40c22) : (0, $3a42d280e31bdca5$export$2168f8b210fee1c6));
        args.container.appendChild(input);
        input.focus();
        input.select();
    };
    this.destroy = function() {
        input.parentElement.removeChild(input);
    };
    this.focus = function() {
        input.focus();
    };
    // function getDecimalPlaces() {
    //     // returns the number of fixed decimal places or null
    //     var rtn = args.column.editorFixedDecimalPlaces;
    //     if (typeof rtn == 'undefined') {
    //         rtn = (<any>FloatEditor).DefaultDecimalPlaces;
    //     }
    //     return (!rtn && rtn!==0 ? null : rtn);
    // }
    this.loadValue = function(item) {
        defaultValue = item[args.column.field];
        var val_as_str = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(defaultValue, args.column.format);
        input.value = val_as_str;
        input.select();
    };
    this.serializeValue = function() {
        return (0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(input.value);
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        return (0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(input.value) !== defaultValue;
    };
    this.validate = function() {
        if (input.value !== "" && (0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(input.value) === undefined) return {
            valid: false,
            msg: "Please enter a valid number"
        };
        if (args.column.validator) {
            var validationResults = args.column.validator((0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(input.value));
            if (!validationResults.valid) return validationResults;
        }
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}
function $4a86594dc9c8ba91$export$816e9ef2f3259b59(args) {
    var $select;
    var defaultValue;
    var scope = this;
    this.init = function() {
        $select = document.createElement("select");
        $select.setAttribute("tabIndex", "0");
        $select.className = "editor-yesno"; // <OPTION value='-'>-</OPTION>
        $select.innerHTML = "<OPTION value='yes'>\u2714</OPTION><OPTION value='no'>-</OPTION>";
        args.container.appendChild($select);
        args.container.style.textAlign = "center";
        $select.focus();
    };
    this.destroy = function() {
        $select.parentElement.removeChild($select);
    };
    this.focus = function() {
        $select.focus();
    };
    this.loadValue = function(item) {
        defaultValue = item[args.column.field];
        $select.value = defaultValue == null ? "-" : defaultValue ? "yes" : "no";
        $select.focus();
    //$select.select();
    };
    this.serializeValue = function() {
        if ($select.value === "-") return null;
        return $select.value === "yes";
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        if ($select.value === "-" && defaultValue == null) return false;
        var v = $select.value === "yes";
        return v !== defaultValue;
    };
    this.validate = function() {
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}





function $e9838cfe75711a3f$export$1636d2c28ffb4b6d(args) {
    var input;
    var defaultValue;
    var scope = this;
    var datePicker;
    this.init = function() {
        var navOnLR = args.grid.getOptions().editorCellNavOnLRKeys;
        input = document.createElement("input");
        input.type = "text";
        input.className = "editor-text";
        input.addEventListener("keydown", navOnLR ? (0, $3a42d280e31bdca5$export$b1c04d4da2f40c22) : (0, $3a42d280e31bdca5$export$2168f8b210fee1c6));
        args.container.appendChild(input);
        datePicker = (0, $ce1e5b161faa04c4$export$5109c6dd95d8fb00)(input, {
            mode: 'dp-below'
        });
        datePicker.on("close", function() {
            input.focus();
            input.select();
        });
        input.focus();
    };
    this.destroy = function() {
        datePicker.destroy();
        input.remove();
    };
    this.show = function() {
    //so far not necessary
    };
    this.hide = function() {
        datePicker.close();
    };
    this.position = function(position) {
    //so far not necessary
    };
    this.focus = function() {
        input.focus();
    };
    this.loadValue = function(item) {
        defaultValue = (0, $f697fe55e25cf9d4$export$324d90190a8b822a).onlyDate(item[args.column.field]);
        var val_as_str = (0, $f697fe55e25cf9d4$export$324d90190a8b822a).format(defaultValue, args.column.format);
        input.value = val_as_str;
        input.select();
    };
    this.serializeValue = function() {
        return (0, $f697fe55e25cf9d4$export$324d90190a8b822a).onlyDate((0, $f697fe55e25cf9d4$export$324d90190a8b822a).parse(input.value, args.column.format));
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        return !(input.value == "" && !defaultValue) && !(0, $f697fe55e25cf9d4$export$324d90190a8b822a).equal((0, $f697fe55e25cf9d4$export$324d90190a8b822a).onlyDate((0, $f697fe55e25cf9d4$export$324d90190a8b822a).parse(input.value, args.column.format)), defaultValue);
    };
    this.validate = function() {
        if (args.column.validator) {
            var validationResults = args.column.validator((0, $f697fe55e25cf9d4$export$324d90190a8b822a).onlyDate((0, $f697fe55e25cf9d4$export$324d90190a8b822a).parse(input.value, args.column.format)));
            if (!validationResults.valid) return validationResults;
        }
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}
function $e9838cfe75711a3f$export$ecbebdf5d5f6fc08(args) {
    var input;
    var defaultValue;
    var scope = this;
    this.init = function() {
        var navOnLR = args.grid.getOptions().editorCellNavOnLRKeys;
        input = document.createElement("input");
        input.type = "time";
        input.className = "editor-text";
        if (args.column.maxLength > 0) input.maxLength = args.column.maxLength;
        input.addEventListener("keydown", navOnLR ? (0, $3a42d280e31bdca5$export$b1c04d4da2f40c22) : (0, $3a42d280e31bdca5$export$2168f8b210fee1c6));
        args.container.appendChild(input);
        input.focus();
        input.select();
    };
    this.destroy = function() {
        input.parentElement.removeChild(input);
    };
    this.focus = function() {
        input.focus();
    };
    this.getValue = function() {
        return input.value;
    };
    this.setValue = function(val) {
        input.value = val;
    };
    this.loadValue = function(item) {
        defaultValue = item[args.column.field] || "";
        input.value = defaultValue;
        input.defaultValue = defaultValue;
        input.select();
    };
    this.serializeValue = function() {
        return input.value;
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        return !(input.value == "" && defaultValue == null) && input.value != defaultValue;
    };
    this.validate = function() {
        if (args.column.validator) {
            var validationResults = args.column.validator(input.value);
            if (!validationResults.valid) return validationResults;
        }
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}







var $de461283a21b56d7$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $de461283a21b56d7$var$isInternetExplorer() {
    return window.navigator.userAgent.indexOf("MSIE ") > 0 || !!window.navigator.userAgent.match(/Trident.*rv\:11\./);
}
var $de461283a21b56d7$export$5a8fb7c74098ef2b = /** @class */ function() {
    function SelectDDAreaComponent(options, component, args) {
        this.options = options;
        this.component = component;
        this.args = args;
        this.onRender = new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)();
        this.isScrolling = false;
        if (args.searchTxt) this.search(args.searchTxt);
        this.focusFirst();
    }
    SelectDDAreaComponent.prototype.onCreate = function(node) {
        var _this = this;
        var _a, _b;
        this.dom = node.dom;
        this.scrollContainer = this.dom.querySelector(".sel-dd-items");
        var item = this.component.getSelected();
        if (item != null) {
            if (Array.isArray(item)) item = item[0];
            if (item != null) {
                var d = (_b = (_a = this.renderedData) !== null && _a !== void 0 ? _a : this.filteredData) !== null && _b !== void 0 ? _b : this.options.data;
                var idx = d.indexOf(item);
                this.scrollContainer.scrollTop = this.options.rowHeight * idx;
            }
        }
        //bugfix for IE -> blur event of search box is called when user clicks scroll bar
        if ($de461283a21b56d7$var$isInternetExplorer()) {
            this.scrollContainer.addEventListener("scroll", function(e) {
                _this.isScrolling = true;
                setTimeout(function() {
                    _this.isScrolling = false;
                    _this.dom.querySelector(".sel-search input").focus();
                }, 20);
            });
            this.scrollContainer.addEventListener("mousedown", function(e) {
                if (e.offsetX > _this.scrollContainer.clientWidth || e.offsetY > _this.scrollContainer.clientHeight) {
                    _this.isScrolling = true;
                    setTimeout(function() {
                        _this.isScrolling = false;
                        _this.dom.querySelector(".sel-search input").focus();
                    }, 20);
                }
            });
        }
    };
    SelectDDAreaComponent.prototype.render = function() {
        var _this = this;
        var _a;
        var data = (_a = this.filteredData) !== null && _a !== void 0 ? _a : this.options.data;
        if (this.options.groupProperty != null) {
            var sortedData = $de461283a21b56d7$var$__spreadArray([], data, true);
            sortedData.sort(function(a, b) {
                return a[_this.options.groupProperty] < b[_this.options.groupProperty] ? -1 : a[_this.options.groupProperty] > b[_this.options.groupProperty] ? 1 : data.indexOf(a) - data.indexOf(b) // preserve order if it is for same group
                ;
            });
            data = [];
            var prevGroupVal = NaN;
            for(var _i = 0, sortedData_1 = sortedData; _i < sortedData_1.length; _i++){
                var x = sortedData_1[_i];
                if (x[this.options.groupProperty] !== prevGroupVal) {
                    // create group entry
                    data.push({
                        __isGroup: true,
                        __groupValue: x[this.options.groupProperty]
                    });
                    prevGroupVal = x[this.options.groupProperty];
                }
                data.push(x);
            }
        }
        this.onRender.notify(data);
        this.renderedData = data;
        var ddNode = {
            tag: "div",
            animation: this.options.enableAnimation ? {
                attr: "opacity",
                from: "0",
                to: "1",
                duration: 400
            } : undefined,
            children: [
                {
                    tag: "div",
                    attr: {
                        class: "sel-search",
                        style: this.options.enableSearch ? undefined : "height:0;padding:0;margin:0;border:none;"
                    },
                    children: [
                        {
                            tag: "input",
                            attr: {
                                type: "text",
                                value: this.args.searchTxt,
                                placeholder: "Search",
                                blur: function(e) {
                                    e.preventDefault();
                                    if ($de461283a21b56d7$var$isInternetExplorer()) requestAnimationFrame(function() {
                                        if (!_this.isScrolling) _this.component.close();
                                    });
                                    else _this.component.close();
                                    return false;
                                },
                                input: function(e, node) {
                                    if (!_this.options.enableSearch) return false;
                                    var term = node.dom.value;
                                    if (!term) _this.clearSearch();
                                    else _this.search(term);
                                },
                                keydown: function(e, node) {
                                    var _a;
                                    if (!_this.options.enableKeyboard) return;
                                    if (e.which === SelectDDAreaComponent.ESCAPE_KEY) node.dom.blur();
                                    else if (e.which === SelectDDAreaComponent.DOWN_KEY) _this.navigateDown();
                                    else if (e.which === SelectDDAreaComponent.UP_KEY) _this.navigateUp();
                                    else if (e.which === SelectDDAreaComponent.ENTER_KEY) {
                                        var focus_1 = _this.component.getFocus();
                                        if (focus_1 == null) {
                                            // if only 1 result is left then auto select this entry
                                            var d = (_a = _this.filteredData) !== null && _a !== void 0 ? _a : _this.options.data;
                                            if (d.length === 1) focus_1 = d[0];
                                        }
                                        if (_this.options.multiple) {
                                            if (focus_1 != null) {
                                                var currentSelection = _this.component.getSelected();
                                                if (currentSelection.indexOf(focus_1) >= 0) currentSelection.splice(currentSelection.indexOf(focus_1), 1);
                                                else currentSelection.push(focus_1);
                                                _this.component.setSelected(currentSelection);
                                            }
                                        } else {
                                            if (focus_1 != null) _this.component.setSelected(focus_1);
                                            node.dom.blur();
                                        }
                                    } else if (e.which === SelectDDAreaComponent.TAB_KEY) {
                                        e.preventDefault();
                                        node.dom.blur();
                                    }
                                }
                            }
                        }
                    ]
                },
                new (0, $8641091d2d8811cd$export$80990d9c432f0bfe)({
                    class: "sel-dd-items" + (this.options.multiple ? " multiple" : ""),
                    data: data,
                    style: this.options.enableSearch ? "height:calc(100% - 1.8rem)" : "height:100%",
                    viewportSizeInPX: this.args.renderHeight + 20,
                    bufferSizeInPx: 20,
                    renderRow: function(args) {
                        var result = {
                            tag: "div",
                            attr: {
                                class: "sel-dd-item"
                            }
                        };
                        if (_this.options.groupProperty && args.rowData.__isGroup) {
                            result.attr.class += " sel-dd-group";
                            var groupValue = args.rowData.__groupValue;
                            var groupArgs = {
                                groupValue: groupValue,
                                node: result
                            };
                            var resGroup = _this.options.onRenderGroup(groupArgs);
                            if (resGroup != null) result.children = [
                                resGroup
                            ];
                            result.attr.mousedown = function(evt) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                evt.stopImmediatePropagation();
                            };
                            return result;
                        }
                        var renderArg = {
                            data: args.rowData,
                            node: result,
                            isFocused: _this.component.getFocus() === args.rowData,
                            isSelected: _this.options.multiple ? _this.component.getSelected().indexOf(args.rowData) >= 0 : _this.component.getSelected() === args.rowData,
                            isCurrent: false
                        };
                        if (renderArg.isFocused) result.attr.class += " focused";
                        if (renderArg.isSelected) result.attr.class += " selected";
                        result.attr.mousedown = function(evt) {
                            if (_this.options.multiple) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                evt.stopImmediatePropagation();
                                var currentSelection = _this.component.getSelected();
                                if (currentSelection.indexOf(args.rowData) >= 0) {
                                    currentSelection.splice(currentSelection.indexOf(args.rowData), 1);
                                    _this.component.setSelected(currentSelection);
                                } else _this.component.setSelected(args.rowData);
                            } else _this.component.setSelected(args.rowData);
                        };
                        var res = _this.options.onRender(renderArg);
                        if (res != null) result.children = [
                            res
                        ];
                        return result;
                    },
                    rowHeight: this.options.rowHeight
                })
            ]
        };
        return ddNode;
    };
    SelectDDAreaComponent.prototype.navigateDown = function() {
        var _a, _b, _c;
        var d = (_b = (_a = this.renderedData) !== null && _a !== void 0 ? _a : this.filteredData) !== null && _b !== void 0 ? _b : this.options.data;
        var selItem = (_c = this.component.getFocus()) !== null && _c !== void 0 ? _c : this.component.getSelected();
        if (selItem == null) {
            this.component.setFocus(d.filter(function(x) {
                return !x.__isGroup;
            })[0]);
            return;
        }
        if (Array.isArray(selItem)) selItem = selItem[0];
        var idx = d.indexOf(selItem);
        if (idx < 0) this.component.setFocus(d.filter(function(x) {
            return !x.__isGroup;
        })[0]);
        else while(idx < d.length - 1){
            idx++;
            if (!d[idx].__isGroup) {
                this.component.setFocus(d[idx]);
                this.scrollContainer.scrollTop = this.options.rowHeight * idx;
                break;
            }
        }
    };
    SelectDDAreaComponent.prototype.navigateUp = function() {
        var _a, _b, _c;
        var d = (_b = (_a = this.renderedData) !== null && _a !== void 0 ? _a : this.filteredData) !== null && _b !== void 0 ? _b : this.options.data;
        var selItem = (_c = this.component.getFocus()) !== null && _c !== void 0 ? _c : this.component.getSelected();
        if (selItem == null) {
            this.component.setFocus(d.filter(function(x) {
                return !x.__isGroup;
            })[0]);
            return;
        }
        if (Array.isArray(selItem)) selItem = selItem[0];
        var idx = d.indexOf(selItem);
        while(idx > 0){
            idx--;
            if (!d[idx].__isGroup) {
                this.component.setFocus(d[idx]);
                this.scrollContainer.scrollTop = this.options.rowHeight * idx;
                return;
            }
        }
        this.component.setFocus(d.filter(function(x) {
            return !x.__isGroup;
        })[0]);
    };
    SelectDDAreaComponent.prototype.search = function(term) {
        var _this = this;
        var _a, _b, _c, _d;
        var oldLen = (_b = (_a = this.filteredData) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        this.filteredData = this.options.data.filter(function(d) {
            return _this.options.matchSearch(d, term);
        });
        var newLen = (_d = (_c = this.filteredData) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
        if (oldLen !== newLen && this.scrollContainer != null) this.scrollContainer.scrollTop = 0;
        this.focusFirst();
    };
    SelectDDAreaComponent.prototype.clearSearch = function() {
        this.filteredData = null;
        this.focusFirst();
    };
    SelectDDAreaComponent.prototype.focusFirst = function() {
        var _a;
        if (this.options.focusFirstItem && (this.component.getSelected() == null || this.component.getSelected().length === 0)) this.component.setFocus(((_a = this.filteredData) !== null && _a !== void 0 ? _a : this.options.data)[0]);
    };
    SelectDDAreaComponent.ESCAPE_KEY = 27;
    SelectDDAreaComponent.DOWN_KEY = 40;
    SelectDDAreaComponent.UP_KEY = 38;
    SelectDDAreaComponent.ENTER_KEY = 13;
    SelectDDAreaComponent.TAB_KEY = 9;
    return SelectDDAreaComponent;
}();



var $92830e10ec4ab123$var$__assign = undefined && undefined.__assign || function() {
    $92830e10ec4ab123$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $92830e10ec4ab123$var$__assign.apply(this, arguments);
};
var $92830e10ec4ab123$export$c006741a65b06687 = /** @class */ function() {
    function SelectComponent(o) {
        var _this = this;
        var _a;
        this.expanded = false;
        this.doNotFocus = false;
        var defaultOptions = {
            data: undefined,
            keyColumn: "value",
            textColumn: "text",
            dropdownHeight: "10rem",
            dropDirection: "auto",
            enableSearch: true,
            enableAnimation: true,
            enableKeyboard: true,
            rowHeight: 28,
            allowEmpty: true,
            enabled: true,
            openOnEnter: true,
            focusFirstItem: true,
            autoShrink: true,
            bindMode: "toModel",
            onAppend: function(dom) {
                document.body.appendChild(dom);
            },
            onRenderGroup: function(args) {
                args.node.content = args.groupValue;
            },
            onRender: o.multiple ? function(args) {
                if (args.isCurrent) args.node.content = args.data.map(function(d) {
                    return d[_this.options.textColumn];
                }).join(", ");
                else args.node.content = args.data[_this.options.textColumn];
            } : function(args) {
                args.node.content = args.data[_this.options.textColumn];
            },
            matchSearch: function(data, term) {
                var _a;
                return ((_a = data[_this.options.textColumn]) !== null && _a !== void 0 ? _a : "").toString().toLowerCase().indexOf(term.toLowerCase()) >= 0;
            }
        };
        this.options = $92830e10ec4ab123$var$__assign($92830e10ec4ab123$var$__assign({}, defaultOptions), o);
        this.options.onChange = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(o.onChange);
        if (this.options.bindTo != null && this.options.property != null && this.options.value == null) this.options.value = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
        this.setValue(this.options.value);
    }
    SelectComponent.prototype.render = function() {
        var _this = this;
        var _a, _b;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            var value_1 = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
            if (value_1 != null) {
                if (this.options.multiple) this.selected = this.options.data.filter(function(x) {
                    return value_1.indexOf(x[_this.options.keyColumn]) >= 0;
                });
                else this.selected = this.options.data.filter(function(x) {
                    return x[_this.options.keyColumn] === value_1;
                })[0];
            } else this.selected = this.options.multiple ? [] : null;
        }
        return {
            tag: "div",
            attr: {
                style: this.options.style,
                class: "select-comp " + (this.expanded ? "expanded " : "") + (!this.options.enabled ? "disabled " : "") + ((_b = this.options.class) !== null && _b !== void 0 ? _b : ""),
                mousedown: function(e) {
                    if (_this.expanded || e.which === 3) return;
                    _this.doNotFocus = true;
                    _this.show();
                }
            },
            children: [
                this.renderSelection(),
                {
                    tag: "button",
                    attr: {
                        disabled: this.options.enabled ? undefined : "disabled",
                        class: "sel-expander",
                        keydown: function(e) {
                            if (_this.options.openOnEnter && _this.options.enabled) {
                                if (e.which === SelectComponent.ENTER_KEY) _this.toggle();
                                else if (!_this.expanded) {
                                    if (e.key && e.key.length === 1) _this.show(e.key);
                                }
                            }
                        },
                        focus: function(e) {
                            if (!_this.doNotFocus && _this.options.openOnFocus && _this.options.enabled) _this.toggle();
                            if (_this.doNotFocus) _this.doNotFocus = false;
                        }
                    },
                    content: this.expanded ? "\u25B2" : "\u25BC"
                }
            ]
        };
    };
    SelectComponent.prototype.onCreate = function(node) {
        this.dom = node.dom;
    };
    SelectComponent.prototype.onUpdate = function(node) {
        this.dom = node.dom;
    };
    SelectComponent.prototype.onInit = function(renderer) {
        this.renderer = renderer;
    };
    SelectComponent.prototype.toggle = function() {
        this.expanded = !this.expanded;
        if (this.expanded) this.show();
        else this.close();
    };
    SelectComponent.prototype.isExpanded = function() {
        return this.expanded;
    };
    SelectComponent.prototype.show = function(searchTxt) {
        var _this = this;
        var _a;
        if (!this.options.enabled) return;
        this.expanded = true;
        var dimension = this.dom.getBoundingClientRect();
        var left = Math.round(dimension.left + window.pageXOffset);
        var top = Math.round(dimension.top + window.pageYOffset);
        this.dropdownArea = document.createElement("div");
        this.dropdownArea.className = "sel-comp-dd " + ((_a = this.options.dropdownClass) !== null && _a !== void 0 ? _a : "");
        this.dropdownArea.style.width = this.options.dropdownWidth || Math.round(dimension.width) + "px";
        this.dropdownArea.style.height = this.options.dropdownHeight;
        this.dropdownArea.style.left = left + "px";
        if (this.options.dropDirection === "up") {
            this.dropdownArea.style.top = "calc(" + top + "px - " + this.options.dropdownHeight + ")";
            this.dropdownArea.classList.add("sel-comp-dd-up");
        } else {
            this.dropdownArea.style.top = Math.round(top + dimension.height) + "px";
            this.dropdownArea.classList.add("sel-comp-dd-down");
        }
        this.options.onAppend(this.dropdownArea);
        var ddDimension = this.dropdownArea.getBoundingClientRect();
        if (this.options.dropDirection === "auto") // check if there is enought room for dropdown at bottom
        {
            if (ddDimension.bottom > window.innerHeight) {
                // position "up"
                this.dropdownArea.style.top = "calc(" + Math.round(top) + "px - " + this.options.dropdownHeight + ")";
                this.dropdownArea.classList.add("sel-comp-dd-up");
                this.dropdownArea.classList.remove("sel-comp-dd-down");
            }
        }
        var ddAreaComp = new (0, $de461283a21b56d7$export$5a8fb7c74098ef2b)(this.options, this, {
            renderHeight: ddDimension.height - 2,
            searchTxt: searchTxt
        });
        if (this.options.autoShrink) ddAreaComp.onRender.subscribe(function(data) {
            var ddHeight;
            if (_this.options.enableSearch) {
                ddHeight = Math.min(data.length * _this.options.rowHeight + 4, ddDimension.height - 2) + "px + 1.8rem";
                _this.dropdownArea.style.height = "calc(" + ddHeight + ")";
            } else {
                ddHeight = Math.min(data.length * _this.options.rowHeight + 4, ddDimension.height - 2) + "px";
                _this.dropdownArea.style.height = ddHeight;
            }
            if (_this.dropdownArea.classList.contains("sel-comp-dd-up")) _this.dropdownArea.style.top = "calc(" + Math.round(top) + "px - (" + ddHeight + "))";
        });
        new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(this.dropdownArea, false).render(ddAreaComp);
        requestAnimationFrame(function() {
            var s = _this.dropdownArea.querySelector(".sel-search input");
            s.focus();
            s.selectionStart = s.selectionEnd = s.value.length;
        });
    };
    SelectComponent.prototype.destroy = function() {
        var x = document.querySelector(".sel-comp-dd");
        if (x != null && x.parentElement != null) try {
            x.parentElement.removeChild(x);
        } catch (ex) {
        // under certain conditions the child may not be in the parentElements child collection anymore, although the child node still has that element as its parent (e.g. blur event handler) - weird JavaScript stuff eh
        }
        this.expanded = false;
    };
    SelectComponent.prototype.close = function() {
        var _a;
        this.expanded = false;
        this.focused = null;
        this.doNotFocus = true;
        try {
            if (((_a = this.dropdownArea) === null || _a === void 0 ? void 0 : _a.parentElement) != null) this.dropdownArea.parentElement.removeChild(this.dropdownArea);
            if (this.renderer != null) this.renderer.refresh();
            this.dom.querySelector(".sel-expander").focus();
        } catch (e) {
        // https://stackoverflow.com/questions/21926083/failed-to-execute-removechild-on-node
        }
    };
    SelectComponent.prototype.setFocus = function(item) {
        this.focused = item;
    };
    SelectComponent.prototype.getFocus = function() {
        return this.focused;
    };
    SelectComponent.prototype.getValue = function() {
        var _this = this;
        if (this.selected == null) return null;
        if (this.options.multiple) return this.selected.map(function(itm) {
            return itm[_this.options.keyColumn];
        });
        else return this.selected[this.options.keyColumn];
    };
    SelectComponent.prototype.setValue = function(value) {
        var _this = this;
        if (value != null) {
            if (this.options.multiple) this.selected = this.options.data.filter(function(x) {
                return value.indexOf(x[_this.options.keyColumn]) >= 0;
            });
            else this.selected = this.options.data.filter(function(x) {
                return x[_this.options.keyColumn] === value;
            })[0];
        } else this.selected = this.options.multiple ? [] : null;
        if (this.renderer != null) this.renderer.refresh();
    };
    SelectComponent.prototype.getSelected = function() {
        return this.selected;
    };
    SelectComponent.prototype.setSelected = function(item) {
        var _a;
        if (this.options.multiple) {
            if (item == null) this.selected = [];
            else if (Array.isArray(item)) this.selected = item;
            else this.selected.push(item);
        } else this.selected = item;
        var value = this.getValue();
        if (this.options.bindMode !== "fromModel" && this.options.bindTo != null && this.options.property != null) this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(value) : value;
        if (this.options.onChange != null) this.options.onChange.notify(value, this.selected);
        this.renderer.refresh();
    };
    SelectComponent.prototype.focus = function() {
        var _this = this;
        var _a;
        if (this.dom == null) requestAnimationFrame(function() {
            var _a;
            if (_this.dom != null) (_a = _this.dom.querySelector(".sel-expander")) === null || _a === void 0 || _a.focus();
        });
        else (_a = this.dom.querySelector(".sel-expander")) === null || _a === void 0 || _a.focus();
    };
    SelectComponent.prototype.hasSelection = function() {
        if (this.options.multiple) return this.selected.length > 0;
        return this.selected != null;
    };
    SelectComponent.prototype.renderSelection = function() {
        var _this = this;
        var node;
        if (this.hasSelection()) {
            node = {
                tag: "div",
                attr: {
                    class: "sel-dd-item"
                }
            };
            var res = this.options.onRender({
                isSelected: true,
                isCurrent: true,
                isFocused: false,
                data: this.selected,
                node: node
            });
            if (res != null) node.children = [
                res
            ];
        }
        var clearbtn;
        if (this.options.allowEmpty) clearbtn = {
            tag: "button",
            content: "\u2717",
            attr: {
                disabled: this.options.enabled ? undefined : "disabled",
                title: "clear",
                class: "clear-btn",
                mousedown: function(e) {
                    if (!_this.options.enabled) return;
                    e.stopImmediatePropagation();
                    _this.setSelected(null);
                },
                click: function(e) {
                    _this.setSelected(null);
                }
            }
        };
        return {
            tag: "div",
            attr: {
                class: "sel-result"
            },
            content: node != null ? undefined : this.options.placehoder,
            children: node == null ? undefined : [
                node,
                clearbtn
            ]
        };
    };
    SelectComponent.ENTER_KEY = 13;
    return SelectComponent;
}();



var $c5cc4e8b84f597b8$var$__assign = undefined && undefined.__assign || function() {
    $c5cc4e8b84f597b8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c5cc4e8b84f597b8$var$__assign.apply(this, arguments);
};
var $c5cc4e8b84f597b8$var$autoComplete = function() {
    function autoComplete(options) {
        // helpers
        function hasClass(el, className) {
            return el.classList.contains(className);
        }
        function addEvent(el, type, handler) {
            el.addEventListener(type, handler);
        }
        function removeEvent(el, type, handler) {
            // if (el.removeEventListener) not working in IE11
            el.removeEventListener(type, handler);
        }
        function live(elClass, event, cb, context) {
            addEvent(context || document, event, function(e) {
                var found;
                var el = e.target || e.srcElement;
                while(el && !(found = hasClass(el, elClass)))el = el.parentElement;
                if (found) cb.call(el, e);
            });
        }
        var o = {
            selector: "",
            source: function(val, s) {
                return [];
            },
            minChars: 0,
            delay: 150,
            offsetLeft: 0,
            offsetTop: 1,
            cache: false,
            menuClass: '',
            renderItem: function(item, search) {
                // escape special characters
                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
            },
            onSelect: function(e, term, item) {}
        };
        for(var k in options)if (options.hasOwnProperty(k)) o[k] = options[k];
        // init
        var elems = typeof o.selector === 'object' ? [
            o.selector
        ] : document.querySelectorAll(o.selector);
        var _loop_1 = function(i) {
            var that = elems[i];
            // create suggestions container "sc"
            that.sc = document.createElement('div');
            that.sc.className = 'autocomplete-suggestions ' + o.menuClass;
            that.autocompleteAttr = that.getAttribute('autocomplete');
            that.setAttribute('autocomplete', 'off');
            that.cache = {};
            that.last_val = '';
            that.updateSC = function(resize, next) {
                var rect = that.getBoundingClientRect();
                that.sc.style.left = Math.round(rect.left + (window.pageXOffset || document.documentElement.scrollLeft) + o.offsetLeft) + 'px';
                that.sc.style.top = Math.round(rect.bottom + (window.pageYOffset || document.documentElement.scrollTop) + o.offsetTop) + 'px';
                that.sc.style.width = Math.round(rect.right - rect.left) + 'px'; // outerWidth
                if (!resize) {
                    that.sc.style.display = 'block';
                    if (!that.sc.maxHeight) that.sc.maxHeight = parseInt((window.getComputedStyle ? getComputedStyle(that.sc, null) : that.sc.currentStyle).maxHeight, 10);
                    if (!that.sc.suggestionHeight) that.sc.suggestionHeight = that.sc.querySelector('.autocomplete-suggestion').offsetHeight;
                    if (that.sc.suggestionHeight) {
                        if (!next) that.sc.scrollTop = 0;
                        else {
                            var scrTop = that.sc.scrollTop, selTop = next.getBoundingClientRect().top - that.sc.getBoundingClientRect().top;
                            if (selTop + that.sc.suggestionHeight - that.sc.maxHeight > 0) that.sc.scrollTop = selTop + that.sc.suggestionHeight + scrTop - that.sc.maxHeight;
                            else if (selTop < 0) that.sc.scrollTop = selTop + scrTop;
                        }
                    }
                }
            };
            addEvent(window, 'resize', that.updateSC);
            document.body.appendChild(that.sc);
            live('autocomplete-suggestion', 'mouseleave', function(e) {
                var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                if (sel) setTimeout(function() {
                    sel.className = sel.className.replace('selected', '');
                }, 20);
            }, that.sc);
            live('autocomplete-suggestion', 'mouseover', function(e) {
                var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                if (sel) sel.className = sel.className.replace('selected', '');
                this.className += ' selected';
            }, that.sc);
            live('autocomplete-suggestion', 'mousedown', function(e) {
                // window.setTimeout(() => {
                if (hasClass(this, 'autocomplete-suggestion')) {
                    var v = this.getAttribute('data-val');
                    that.value = v;
                    o.onSelect(e, v, this);
                    that.sc.style.display = 'none';
                }
            // }, 1000);
            }, that.sc);
            that.blurHandler = function() {
                //var over_sb;
                //try { over_sb = document.querySelector('.autocomplete-suggestions:hover'); } catch (e) { over_sb = 0; }
                //if (!over_sb) {
                that.last_val = that.value;
                that.sc.style.display = 'none';
            //setTimeout(function() { that.sc.style.display = 'none'; }, 350); // hide suggestions on fast input
            //} else if (that !== document.activeElement) { setTimeout(function() { that.focus(); }, 200); }
            };
            addEvent(that, 'blur', that.blurHandler);
            that.inputHandler = function() {
                options.onChange(that.value);
            };
            addEvent(that, 'input', that.inputHandler);
            suggest = function(data) {
                var val = that.value;
                that.cache[val] = data;
                if (data.length && val.length >= o.minChars) {
                    var s = '';
                    for(var i = 0; i < data.length; i++)s += o.renderItem(data[i], val);
                    that.sc.innerHTML = s;
                    that.updateSC(0);
                } else that.sc.style.display = 'none';
            };
            that.keydownHandler = function(e) {
                var key = window.event ? e.keyCode : e.which;
                // down (40), up (38)
                if ((key === 40 || key === 38) && that.sc.innerHTML) {
                    var next, sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                    if (!sel) {
                        next = key == 40 ? that.sc.querySelector('.autocomplete-suggestion') : that.sc.childNodes[that.sc.childNodes.length - 1]; // first : last
                        next.className += ' selected';
                        that.value = next.getAttribute('data-val');
                    } else {
                        next = key == 40 ? sel.nextSibling : sel.previousSibling;
                        if (next) {
                            sel.className = sel.className.replace('selected', '');
                            next.className += ' selected';
                            that.value = next.getAttribute('data-val');
                        } else {
                            sel.className = sel.className.replace('selected', '');
                            that.value = that.last_val;
                            next = 0;
                        }
                    }
                    that.updateSC(0, next);
                    return false;
                } else if (key == 27) {
                    that.value = that.last_val;
                    that.sc.style.display = 'none';
                } else if (key == 13 || key == 9) {
                    var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                    if (sel && that.sc.style.display != 'none') {
                        o.onSelect(e, sel.getAttribute('data-val'), sel);
                        setTimeout(function() {
                            that.sc.style.display = 'none';
                        }, 20);
                    }
                }
            };
            addEvent(that, 'keydown', that.keydownHandler);
            that.keyupHandler = function(e) {
                var key = window.event ? e.keyCode : e.which;
                if (!key || (key < 35 || key > 40) && key != 13 && key != 27) {
                    var val = that.value;
                    if (val.length >= o.minChars) {
                        if (val != that.last_val) {
                            that.last_val = val;
                            clearTimeout(that.timer);
                            if (o.cache) {
                                if (val in that.cache) {
                                    suggest(that.cache[val]);
                                    return;
                                }
                                // no requests if previous suggestions were empty
                                for(var i = 1; i < val.length - o.minChars; i++){
                                    var part = val.slice(0, val.length - i);
                                    if (part in that.cache && !that.cache[part].length) {
                                        suggest([]);
                                        return;
                                    }
                                }
                            }
                            that.timer = setTimeout(function() {
                                o.source(val, suggest);
                            }, o.delay);
                        }
                    } else {
                        that.last_val = val;
                        that.sc.style.display = 'none';
                    }
                }
            };
            addEvent(that, 'keyup', that.keyupHandler);
            that.focusHandler = function(e) {
                that.last_val = '\n';
                that.keyupHandler(e);
            };
            if (!o.minChars) addEvent(that, 'focus', that.focusHandler);
        };
        var suggest;
        for(var i = 0; i < elems.length; i++)_loop_1(i);
        // public destroy method
        this.destroy = function() {
            for(var i = 0; i < elems.length; i++){
                var that = elems[i];
                removeEvent(window, 'resize', that.updateSC);
                removeEvent(that, 'blur', that.blurHandler);
                removeEvent(that, 'focus', that.focusHandler);
                removeEvent(that, 'keydown', that.keydownHandler);
                removeEvent(that, 'keyup', that.keyupHandler);
                if (that.autocompleteAttr) that.setAttribute('autocomplete', that.autocompleteAttr);
                else that.removeAttribute('autocomplete');
                document.body.removeChild(that.sc);
                that = null;
            }
        };
    }
    return autoComplete;
}();
function $c5cc4e8b84f597b8$export$a25e9aefbe210e53(input, opts) {
    return new $c5cc4e8b84f597b8$var$autoComplete($c5cc4e8b84f597b8$var$__assign({
        selector: input
    }, opts));
}


var $26960af31ff54e4a$export$a34dd0f9e0ffa463 = /** @class */ function() {
    function AutoSuggestComponent(options) {
        this.options = options;
    // this.id = this.options.id ?? helper.newDomGuid();
    }
    AutoSuggestComponent.prototype.render = function() {
        var _a;
        return {
            tag: "input",
            attr: {
                value: this.options.value,
                class: this.options.class,
                style: this.options.style,
                placeholder: (_a = this.options.placeholder) !== null && _a !== void 0 ? _a : ""
            }
        };
    };
    AutoSuggestComponent.prototype.getRef = function() {
        return this.ref;
    };
    AutoSuggestComponent.prototype.getValue = function() {
        if (this.dom == null) return "";
        return this.dom.value;
    };
    AutoSuggestComponent.prototype.setValue = function(val) {
        if (this.dom == null) return;
        this.dom.value = val;
    };
    AutoSuggestComponent.prototype.focus = function() {
        if (this.dom == null) return;
        this.dom.focus();
    };
    AutoSuggestComponent.prototype.onCreate = function(node) {
        this.dom = node.dom;
        (0, $c5cc4e8b84f597b8$export$a25e9aefbe210e53)(node.dom, this.options);
    };
    AutoSuggestComponent.prototype.onUpdate = function(node) {
        this.dom = node.dom;
    };
    AutoSuggestComponent.prototype.onRemove = function() {
        if (this.ref != null) this.ref.destroy();
    };
    return AutoSuggestComponent;
}();


var $9a93254ee7930cf1$var$__assign = undefined && undefined.__assign || function() {
    $9a93254ee7930cf1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9a93254ee7930cf1$var$__assign.apply(this, arguments);
};
function $9a93254ee7930cf1$export$f0c41f47643b7ba5(args) {
    var select;
    var defaultValue;
    // var scope = this;
    this.init = function() {
        // input = document.createElement("select");
        args.container.addEventListener("keydown", function(e) {
            if (e.which === 38 || e.which === 40) e.stopImmediatePropagation();
        // if (e.which === 13) {
        //     e.stopImmediatePropagation();
        // }
        });
        var vl = args.column.valueList;
        var data = [];
        if (vl) {
            if (Array.isArray(vl)) for(var _i = 0, vl_1 = vl; _i < vl_1.length; _i++){
                var element = vl_1[_i];
                if (typeof element === "string") data.push({
                    text: element,
                    value: element
                });
                else data.push(element);
            }
            else for(var key in vl){
                if (!vl.hasOwnProperty(key)) continue;
                data.push({
                    text: vl[key],
                    value: key
                });
            }
        } else console.warn("No value list found for column " + args.column.id);
        select = new (0, $92830e10ec4ab123$export$c006741a65b06687)($9a93254ee7930cf1$var$__assign({
            data: data,
            dropdownWidth: args.column.width + "px",
            multiple: true,
            style: "min-width:0;width:100%;position:absolute;top:0;right:0;bottom:0;left:0;",
            openOnEnter: false
        }, args.column.editorOptions));
        new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(args.container).render(select);
    //dropdown = DropDown(input, { data: data, multiple: true, searchable: false, defaultSelected: false });
    };
    this.destroy = function() {
    // TODO ? - or not?
    // dropdown.destroy();
    // input.parentElement.removeChild(input);
    };
    this.focus = function() {
        select.show();
    };
    this.getValue = function() {
        return select.getValue();
    };
    this.setValue = function(val) {
        select.setValue(val);
    };
    this.loadValue = function(item) {
        defaultValue = item[args.column.field] || [];
        select.setValue(defaultValue);
        setTimeout(function() {
            select.show();
        }, 1);
    };
    this.serializeValue = function() {
        return select.getValue();
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        var a = defaultValue || [];
        var b = select.getValue() || [];
        return a.toString() !== b.toString();
    };
    this.validate = function() {
        if (args.column.validator) {
            var validationResults = args.column.validator(select.getValue());
            if (!validationResults.valid) return validationResults;
        }
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}
function $9a93254ee7930cf1$export$b1da2be273f0232(args) {
    // var input: HTMLDivElement;
    var dropdown;
    var defaultValue;
    var scope = this;
    var reposition = true;
    this.keyCaptureList = function(which) {
        if (which === 13) {
            dropdown.show();
            return false;
        }
        if (which === 38 || which === 40) {
            if (dropdown.isExpanded()) return false;
        }
    };
    this.init = function() {
        // input = document.createElement("div");
        var vl = args.column.valueList;
        var data = [];
        if (vl) {
            if (Array.isArray(vl)) for(var _i = 0, vl_2 = vl; _i < vl_2.length; _i++){
                var element = vl_2[_i];
                if (typeof element === "string") data.push({
                    text: element,
                    value: element
                });
                else data.push(element);
            }
            else for(var key in vl){
                if (!vl.hasOwnProperty(key)) continue;
                data.push({
                    text: vl[key],
                    value: key
                });
            }
        } else console.warn("No value list found for column " + args.column.id);
        // args.container.appendChild(input);
        dropdown = new (0, $92830e10ec4ab123$export$c006741a65b06687)($9a93254ee7930cf1$var$__assign({
            data: data,
            dropdownWidth: args.column.width + "px",
            style: "min-width:0;width:100%;position:absolute;top:0;right:0;bottom:0;left:0;",
            openOnEnter: false,
            // onAppend: (dom) => {
            //     (args.grid as ISlickGrid<any>).getContainerNode().appendChild(dom);
            // },
            onChange: function(e) {
                args.commitChangesOnly();
            // args.grid.getEditorLock().commitChangesOnly();
            }
        }, args.column.editorOptions));
        //dropdown = DropDown(input, { ...{ data, searchable: false, defaultSelected: false, pagination: 100 }, ...args.column.editorOptions });
        new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(args.container, false).render(dropdown);
    // dropdown.show();
    };
    this.show = function() {
        reposition = true;
    // if (dropdown.isExpanded()) {
    //     const dd = document.querySelector(".sel-comp-dd") as HTMLDivElement;
    //     dd.style.display = "";
    // }
    };
    this.hide = function() {
        reposition = false;
    };
    this.position = function(position) {
        if (dropdown.isExpanded() && reposition) {
            var dd = document.querySelector(".sel-comp-dd");
            if (dd.classList.contains("sel-comp-dd-up")) dd.style.top = position.top - dd.getBoundingClientRect().height + "px";
            else dd.style.top = position.top + args.grid.getOptions().rowHeight + "px";
            dd.style.left = position.left + "px";
        }
    };
    this.destroy = function() {
        dropdown.destroy();
    // input.parentElement.removeChild(input);
    };
    this.focus = function() {
        // input.focus();
        dropdown.show();
    };
    this.getValue = function() {
        return dropdown.getValue();
    };
    this.setValue = function(val) {
        dropdown.setValue(val != null ? val.toString() : val);
    };
    this.loadValue = function(item) {
        defaultValue = item[args.column.field];
        dropdown.setValue(defaultValue);
    };
    this.serializeValue = function() {
        return dropdown.getValue();
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        return dropdown.getValue() !== defaultValue;
    };
    this.validate = function() {
        if (args.column.validator) {
            var validationResults = args.column.validator(dropdown.getValue());
            if (!validationResults.valid) return validationResults;
        }
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}
function $9a93254ee7930cf1$export$d796b93e22462ab5(args) {
    // var input: HTMLDivElement;
    var dropdown;
    var defaultValue;
    var scope = this;
    var reposition = true;
    this.keyCaptureList = function(which) {
        // if (which === 13) {
        //     dropdown.show();
        //     return false;
        // }
        if (which === 38 || which === 40) // if (dropdown.isExpanded()) {
        return false;
    };
    this.init = function() {
        // input = document.createElement("div");
        var vl = args.column.valueList;
        var data = [];
        if (vl) {
            if (Array.isArray(vl)) for(var _i = 0, vl_3 = vl; _i < vl_3.length; _i++){
                var element = vl_3[_i];
                if (typeof element === "string") data.push({
                    text: element,
                    value: element
                });
                else data.push(element);
            }
            else for(var key in vl){
                if (!vl.hasOwnProperty(key)) continue;
                data.push({
                    text: vl[key],
                    value: key
                });
            }
        } else console.warn("No value list found for column " + args.column.id);
        // dropdown = new SelectComponent({
        //     data,
        //     dropdownWidth: args.column.width + "px",
        //     style: "min-width:0;width:100%;position:absolute;top:0;right:0;bottom:0;left:0;",
        //     openOnEnter: false,
        //     // onAppend: (dom) => {
        //     //     (args.grid as ISlickGrid<any>).getContainerNode().appendChild(dom);
        //     // },
        //     ...args.column.editorOptions
        // });
        dropdown = new (0, $26960af31ff54e4a$export$a34dd0f9e0ffa463)({
            style: "min-width:0;width:100%;position:absolute;top:0;right:0;bottom:0;left:0;box-sizing:border-box;",
            source: function(val, suggest) {
                var term = (val || "").toLowerCase();
                suggest(data.filter(function(x) {
                    return term === "" || x.text.toLowerCase().indexOf(term) >= 0;
                }).map(function(x) {
                    return x.text;
                }));
            },
            cache: false
        });
        new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(args.container, false).render(dropdown);
        dropdown.focus();
    };
    this.show = function() {
        reposition = true;
    };
    this.hide = function() {
        reposition = false;
    };
    this.position = function(position) {
    // if (dropdown.isExpanded() && reposition) {
    //     const dd = document.querySelector(".sel-comp-dd") as HTMLDivElement;
    //     if (dd.classList.contains("sel-comp-dd-up")) {
    //         dd.style.top = (position.top - dd.getBoundingClientRect().height) + "px";
    //     } else {
    //         dd.style.top = (position.top + args.grid.getOptions().rowHeight) + "px";
    //     }
    //     dd.style.left = (position.left) + "px";
    // }
    };
    this.destroy = function() {
        var _a;
        (_a = dropdown.getRef()) === null || _a === void 0 || _a.destroy();
    };
    this.focus = function() {
        dropdown.focus();
    };
    this.getValue = function() {
        return dropdown.getValue();
    };
    this.setValue = function(val) {
        // dropdown.setValue(val != null ? val.toString() : val);
        dropdown.setValue(val || "");
    };
    this.loadValue = function(item) {
        defaultValue = item[args.column.field];
        // dropdown.setValue(defaultValue);
        dropdown.setValue(defaultValue || "");
    };
    this.serializeValue = function() {
        return dropdown.getValue();
    };
    this.applyValue = function(item, state) {
        item[args.column.field] = state;
    };
    this.isValueChanged = function() {
        return dropdown.getValue() !== defaultValue;
    };
    this.validate = function() {
        if (args.column.validator) {
            var validationResults = args.column.validator(dropdown.getValue());
            if (!validationResults.valid) return validationResults;
        }
        return {
            valid: true,
            msg: null
        };
    };
    this.init();
}







var $6c4fe022f1e7bd5a$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
// register namespace
$6c4fe022f1e7bd5a$var$$.deepExtend((0, $35f562d52ec6d8f1$export$846056739d2a3e0b), {
    "CellRangeDecorator": $6c4fe022f1e7bd5a$export$909d716a4dc01bdf
});
function $6c4fe022f1e7bd5a$export$909d716a4dc01bdf(grid, options) {
    var _elem;
    var _defaults = {
        selectionCssClass: 'slick-range-decorator',
        selectionCss: {
            "zIndex": "9999",
            "border": "2px dashed red"
        },
        offset: {
            top: -1,
            left: -1,
            height: -2,
            width: -2
        }
    };
    options = $6c4fe022f1e7bd5a$var$$.deepExtend({}, _defaults, options);
    function show(range) {
        if (!_elem) {
            _elem = $6c4fe022f1e7bd5a$var$$("<div></div>" /*, {css: options.selectionCss}*/ ).addClass(options.selectionCssClass).css("position", "absolute").appendTo(grid.getActiveCanvasNode());
            if (options.selectionCss) for(var key in options.selectionCss)_elem.css(key, options.selectionCss[key]);
        }
        var from = grid.getCellNodeBox(range.fromRow, range.fromCell);
        var to = grid.getCellNodeBox(range.toRow, range.toCell);
        _elem.css({
            top: from.top + options.offset.top,
            left: from.left + options.offset.left,
            height: to.bottom - from.top + options.offset.height,
            width: to.right - from.left + options.offset.width
        });
        return _elem;
    }
    function hide() {
        if (_elem) {
            _elem.remove();
            _elem = null;
        }
    }
    $6c4fe022f1e7bd5a$var$$.shallowExtend(this, {
        "pluginName": "CellRangeDecorator",
        "show": show,
        "hide": hide
    });
}





var $7605b062515279a0$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
// register namespace
$7605b062515279a0$var$$.deepExtend(window, {
    "Slick": {
        "CellRangeSelector": $7605b062515279a0$export$64c8c7564669c232
    }
});
function $7605b062515279a0$export$64c8c7564669c232(options) {
    var _grid;
    var _currentlySelectedRange;
    var _canvas;
    var _gridOptions;
    var _$activeCanvas;
    var _dragging;
    var _decorator;
    var _self = this;
    var _handler = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).EventHandler();
    var _defaults = {
        selectionCss: {
            "border": "2px dashed blue"
        }
    };
    // Frozen row & column variables
    var _rowOffset;
    var _columnOffset;
    var _isRightCanvas;
    var _isBottomCanvas;
    // Scrollings
    var _scrollTop = 0;
    var _scrollLeft = 0;
    function init(grid) {
        options = $7605b062515279a0$var$$.deepExtend({}, _defaults, options);
        _decorator = options.cellDecorator || new (0, $6c4fe022f1e7bd5a$export$909d716a4dc01bdf)(grid, options);
        _grid = grid;
        _canvas = _grid.getCanvasNode();
        _gridOptions = _grid.getOptions();
        _handler.subscribe(_grid.onScroll, handleScroll).subscribe(_grid.onDragInit, handleDragInit).subscribe(_grid.onDragStart, handleDragStart).subscribe(_grid.onDrag, handleDrag).subscribe(_grid.onDragEnd, handleDragEnd);
    }
    function destroy() {
        _handler.unsubscribeAll();
    }
    function getCellDecorator() {
        return _decorator;
    }
    function handleScroll(e, args) {
        _scrollTop = args.scrollTop;
        _scrollLeft = args.scrollLeft;
    }
    function handleDragInit(e, dd) {
        // Set the active canvas node because the decorator needs to append its
        // box to the correct canvas
        _$activeCanvas = $7605b062515279a0$var$$(_grid.getActiveCanvasNode(e));
        var c = _$activeCanvas.offset();
        _rowOffset = 0;
        _columnOffset = 0;
        _isBottomCanvas = _$activeCanvas.hasClass('grid-canvas-bottom');
        if (_gridOptions.frozenRow > -1 && _isBottomCanvas) _rowOffset = _gridOptions.frozenBottom ? $7605b062515279a0$var$$('.grid-canvas-bottom').height() : $7605b062515279a0$var$$('.grid-canvas-top').height();
        _isRightCanvas = _$activeCanvas.hasClass('grid-canvas-right');
        if (_gridOptions.frozenColumn > -1 && _isRightCanvas) _columnOffset = $7605b062515279a0$var$$('.grid-canvas-left').width();
    // // prevent the grid from cancelling drag'n'drop by default
    // e.stopImmediatePropagation();
    }
    function handleDragStart(e, dd) {
        var cell = _grid.getCellFromEvent(e);
        if (_self.onBeforeCellRangeSelected.notify(cell) !== false) {
            if (_grid.canCellBeSelected(cell.row, cell.cell)) {
                _dragging = true;
                e.stopImmediatePropagation();
            }
        }
        if (!_dragging) return;
        _grid.focus();
        var startX = dd.startX - $7605b062515279a0$var$$(_canvas).offset().left;
        if (_gridOptions.frozenColumn >= 0 && _isRightCanvas) startX += _scrollLeft;
        var startY = dd.startY - $7605b062515279a0$var$$(_canvas).offset().top;
        if (_gridOptions.frozenRow >= 0 && _isBottomCanvas) startY += _scrollTop;
        var start = _grid.getCellFromPoint(startX, startY);
        dd.range = {
            start: start,
            end: {}
        };
        _currentlySelectedRange = dd.range;
        return _decorator.show(new (0, $35f562d52ec6d8f1$export$9a58ef0d7ad3278c)(start.row, start.cell));
    }
    function handleDrag(e, dd) {
        if (!_dragging) return;
        e.stopImmediatePropagation();
        var end = _grid.getCellFromPoint(e.pageX - _$activeCanvas.offset().left + _columnOffset, e.pageY - _$activeCanvas.offset().top + _rowOffset);
        // ... frozen column(s), 
        if (_gridOptions.frozenColumn >= 0 && !_isRightCanvas && end.cell > _gridOptions.frozenColumn || _isRightCanvas && end.cell <= _gridOptions.frozenColumn) return;
        // ... or frozen row(s)
        if (_gridOptions.frozenRow >= 0 && !_isBottomCanvas && end.row >= _gridOptions.frozenRow || _isBottomCanvas && end.row < _gridOptions.frozenRow) return;
        // ... or regular grid (without any frozen options)
        if (!_grid.canCellBeSelected(end.row, end.cell)) return;
        dd.range.end = end;
        _decorator.show(new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Range(dd.range.start.row, dd.range.start.cell, end.row, end.cell));
    }
    function handleDragEnd(e, dd) {
        if (!_dragging) return;
        _dragging = false;
        e.stopImmediatePropagation();
        _decorator.hide();
        _self.onCellRangeSelected.notify({
            range: new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Range(dd.range.start.row, dd.range.start.cell, dd.range.end.row, dd.range.end.cell)
        });
    }
    function getCurrentRange() {
        return _currentlySelectedRange;
    }
    $7605b062515279a0$var$$.shallowExtend(this, {
        "init": init,
        "destroy": destroy,
        "pluginName": "CellRangeSelector",
        "getCellDecorator": getCellDecorator,
        "getCurrentRange": getCurrentRange,
        "onBeforeCellRangeSelected": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event(),
        "onCellRangeSelected": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event()
    });
}





var $5a47e6a890a29bb7$var$$ = (0, $b96b48278b8efa92$export$f01a81549a0f632f);
// register namespace
$5a47e6a890a29bb7$var$$.deepExtend(window, {
    "Slick": {
        "CellSelectionModel": $5a47e6a890a29bb7$export$8723ce1971778930
    }
});
function $5a47e6a890a29bb7$export$8723ce1971778930(options) {
    var _grid;
    var _canvas;
    var _ranges = [];
    var _self = this;
    var _selector;
    if (typeof options === "undefined" || typeof options.cellRangeSelector === "undefined") _selector = new (0, $7605b062515279a0$export$64c8c7564669c232)({
        "selectionCss": {
            "border": "2px solid black"
        }
    });
    else _selector = options.cellRangeSelector;
    var _options;
    var _defaults = {
        selectActiveCell: true
    };
    function init(grid) {
        _options = $5a47e6a890a29bb7$var$$.deepExtend({}, _defaults, options);
        _grid = grid;
        _canvas = _grid.getCanvasNode();
        _grid.onActiveCellChanged.subscribe(handleActiveCellChange);
        _grid.onKeyDown.subscribe(handleKeyDown);
        grid.registerPlugin(_selector);
        _selector.onCellRangeSelected.subscribe(handleCellRangeSelected);
        _selector.onBeforeCellRangeSelected.subscribe(handleBeforeCellRangeSelected);
    }
    function destroy() {
        _grid.onActiveCellChanged.unsubscribe(handleActiveCellChange);
        _grid.onKeyDown.unsubscribe(handleKeyDown);
        _selector.onCellRangeSelected.unsubscribe(handleCellRangeSelected);
        _selector.onBeforeCellRangeSelected.unsubscribe(handleBeforeCellRangeSelected);
        _grid.unregisterPlugin(_selector);
    }
    function removeInvalidRanges(ranges) {
        var result = [];
        for(var i = 0; i < ranges.length; i++){
            var r = ranges[i];
            if (_grid.canCellBeSelected(r.fromRow, r.fromCell) && _grid.canCellBeSelected(r.toRow, r.toCell)) result.push(r);
        }
        return result;
    }
    function rangesAreEqual(range1, range2) {
        var areDifferent = range1.length !== range2.length;
        if (!areDifferent) {
            for(var i = 0; i < range1.length; i++)if (range1[i].fromCell !== range2[i].fromCell || range1[i].fromRow !== range2[i].fromRow || range1[i].toCell !== range2[i].toCell || range1[i].toRow !== range2[i].toRow) {
                areDifferent = true;
                break;
            }
        }
        return !areDifferent;
    }
    function setSelectedRanges(ranges) {
        // simple check for: empty selection didn't change, prevent firing onSelectedRangesChanged
        if ((!_ranges || _ranges.length === 0) && (!ranges || ranges.length === 0)) return;
        // if range has not changed, don't fire onSelectedRangesChanged
        var rangeHasChanged = !rangesAreEqual(_ranges, ranges);
        _ranges = removeInvalidRanges(ranges);
        if (rangeHasChanged) _self.onSelectedRangesChanged.notify(_ranges);
    }
    function getSelectedRanges() {
        return _ranges;
    }
    function handleBeforeCellRangeSelected(e, args) {
        if (_grid.getEditorLock().isActive()) {
            e.stopPropagation();
            return false;
        }
    }
    function handleCellRangeSelected(e, args) {
        _grid.setActiveCell(args.range.fromRow, args.range.fromCell, false, false, true);
        setSelectedRanges([
            args.range
        ]);
    }
    var lastActiveCell;
    function handleActiveCellChange(e, args) {
        if (_options.selectActiveCell && args.row != null && args.cell != null) {
            var metaKey = e.ctrlKey || e.metaKey;
            if (metaKey) {
                var ranges = getSelectedRanges().slice();
                ranges.push(new (0, $35f562d52ec6d8f1$export$9a58ef0d7ad3278c)(args.row, args.cell));
                setSelectedRanges(ranges);
                lastActiveCell = {
                    row: args.row,
                    cell: args.cell
                };
            } else if (e.shiftKey) {
                var ranges = getSelectedRanges().slice();
                if (ranges.length > 0) {
                    var currentRange = ranges.pop();
                    if (lastActiveCell == null) lastActiveCell = {
                        row: currentRange.fromRow,
                        cell: currentRange.fromCell
                    };
                    var newRange = new (0, $35f562d52ec6d8f1$export$9a58ef0d7ad3278c)(Math.min(lastActiveCell.row, args.row), Math.min(lastActiveCell.cell, args.cell), Math.max(lastActiveCell.row, args.row), Math.max(lastActiveCell.cell, args.cell));
                    ranges.push(newRange);
                } else {
                    ranges.push(new (0, $35f562d52ec6d8f1$export$9a58ef0d7ad3278c)(args.row, args.cell));
                    lastActiveCell = {
                        row: args.row,
                        cell: args.cell
                    };
                }
                setSelectedRanges(ranges);
            } else {
                setSelectedRanges([
                    new (0, $35f562d52ec6d8f1$export$9a58ef0d7ad3278c)(args.row, args.cell)
                ]);
                lastActiveCell = {
                    row: args.row,
                    cell: args.cell
                };
            }
        } else if (!_options.selectActiveCell) // clear the previous selection once the cell changes
        setSelectedRanges([]);
    }
    function handleKeyDown(e) {
        /***
         * Кey codes
         * 37 left
         * 38 up
         * 39 right
         * 40 down
         */ var ranges, last;
        var active = _grid.getActiveCell();
        var metaKey = e.ctrlKey || e.metaKey;
        if (active && e.shiftKey && !metaKey && !e.altKey && (e.which == 37 || e.which == 39 || e.which == 38 || e.which == 40)) {
            ranges = getSelectedRanges().slice();
            if (!ranges.length) ranges.push(new (0, $35f562d52ec6d8f1$export$9a58ef0d7ad3278c)(active.row, active.cell));
            // keyboard can work with last range only
            last = ranges.pop();
            // can't handle selection out of active cell
            if (!last.contains(active.row, active.cell)) last = new (0, $35f562d52ec6d8f1$export$9a58ef0d7ad3278c)(active.row, active.cell);
            var dRow = last.toRow - last.fromRow, dCell = last.toCell - last.fromCell, // walking direction
            dirRow = active.row == last.fromRow ? 1 : -1, dirCell = active.cell == last.fromCell ? 1 : -1;
            if (e.which == 37) dCell -= dirCell;
            else if (e.which == 39) dCell += dirCell;
            else if (e.which == 38) dRow -= dirRow;
            else if (e.which == 40) dRow += dirRow;
            // define new selection range
            var new_last = new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Range(active.row, active.cell, active.row + dirRow * dRow, active.cell + dirCell * dCell);
            if (removeInvalidRanges([
                new_last
            ]).length) {
                ranges.push(new_last);
                var viewRow = dirRow > 0 ? new_last.toRow : new_last.fromRow;
                var viewCell = dirCell > 0 ? new_last.toCell : new_last.fromCell;
                _grid.scrollRowIntoView(viewRow);
                _grid.scrollCellIntoView(viewRow, viewCell);
            } else ranges.push(last);
            setSelectedRanges(ranges);
            e.preventDefault();
            e.stopPropagation();
        }
    }
    $5a47e6a890a29bb7$var$$.shallowExtend(this, {
        "getSelectedRanges": getSelectedRanges,
        "setSelectedRanges": setSelectedRanges,
        "init": init,
        "destroy": destroy,
        "pluginName": "CellSelectionModel",
        "onSelectedRangesChanged": new (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).Event()
    });
}






var $ee2ddc691633277f$export$bfc60255dde20874 = /** @class */ function() {
    function ProgressComponent(progress, options) {
        this.progress = progress;
        this.options = options;
    }
    ProgressComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    ProgressComponent.prototype.render = function() {
        var _a, _b, _c, _d, _e, _f, _g;
        var style = "width: " + this.progress + "%";
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.color) style += ";background:" + this.options.color;
        if ((_b = this.options) === null || _b === void 0 ? void 0 : _b.style) style += ";" + this.options.style;
        var content = "";
        if ((_c = this.options) === null || _c === void 0 ? void 0 : _c.showPercent) content = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(this.progress, (_e = (_d = this.options) === null || _d === void 0 ? void 0 : _d.percentFormat) !== null && _e !== void 0 ? _e : "0. %");
        return {
            tag: "div",
            attr: {
                class: "progress-comp " + ((_g = (_f = this.options) === null || _f === void 0 ? void 0 : _f.class) !== null && _g !== void 0 ? _g : "")
            },
            children: [
                {
                    tag: "div",
                    attr: {
                        class: "bar",
                        style: style
                    },
                    content: content
                }
            ]
        };
    };
    ProgressComponent.prototype.setProgress = function(progress) {
        this.progress = progress;
    };
    ProgressComponent.prototype.getProgress = function() {
        return this.progress;
    };
    return ProgressComponent;
}();






var $c9acd7efe2a931e2$var$__assign = undefined && undefined.__assign || function() {
    $c9acd7efe2a931e2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c9acd7efe2a931e2$var$__assign.apply(this, arguments);
};
var $c9acd7efe2a931e2$export$19285a5b05c4ea7c = /** @class */ function() {
    function DateComponent(options) {
        var _a;
        this.options = $c9acd7efe2a931e2$var$__assign({
            enabled: true,
            id: (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newDomGuid(),
            bindMode: "toModel"
        }, options);
        if (this.options.bindTo != null && this.options.property != null && this.options.value == null) this.options.value = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
        this.options.onChange = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(this.options.onChange);
    }
    Object.defineProperty(DateComponent.prototype, "onChange", {
        get: function() {
            return this.options.onChange;
        },
        enumerable: false,
        configurable: true
    });
    DateComponent.prototype.render = function() {
        var _a;
        var val = this.options.value;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            var current = this.getValue();
            var newVal = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
            var newValStr = (0, $f697fe55e25cf9d4$export$324d90190a8b822a).format(newVal);
            if (newValStr !== current) {
                val = newVal;
                if (this.currentDom != null) this.currentDom.value = newValStr;
            }
        }
        return {
            tag: "input",
            attr: {
                id: this.options.id,
                class: this.options.class,
                style: this.options.style,
                disabled: !this.options.enabled ? "disabled" : undefined,
                placeholder: this.options.placeholder,
                value: (0, $f697fe55e25cf9d4$export$324d90190a8b822a).format(val),
                change: this.raiseEvent
            }
        };
    };
    DateComponent.prototype.getValue = function() {
        if (this.currentDom == null) return "";
        return this.currentDom.value;
    };
    DateComponent.prototype.getValueAsDate = function() {
        if (this.currentDom == null) return null;
        if (this.options.parse) return this.options.parse(this.currentDom.value);
        return (0, $f697fe55e25cf9d4$export$324d90190a8b822a).parse(this.currentDom.value);
    };
    DateComponent.prototype.getRef = function() {
        return this.ref;
    };
    DateComponent.prototype.onCreate = function(node) {
        this.currentDom = node.dom;
        this.ref = (0, $ce1e5b161faa04c4$export$5109c6dd95d8fb00)(this.currentDom, this.options);
    };
    DateComponent.prototype.onUpdate = function(node) {
        this.currentDom = node.dom;
    };
    DateComponent.prototype.onRemove = function() {
        if (this.ref != null) this.ref.destroy();
    };
    DateComponent.prototype.raiseEvent = function(e, node) {
        var _a;
        if (this.options.enabled) {
            var val = (0, $f697fe55e25cf9d4$export$324d90190a8b822a).parse(node.dom.value);
            if (this.options.bindTo && this.options.bindMode !== "fromModel" && this.options.property) this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(val) : val;
            this.options.onChange.notify(val);
        }
    };
    return DateComponent;
}();






var $a713f3e2c7022ccd$var$__assign = undefined && undefined.__assign || function() {
    $a713f3e2c7022ccd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a713f3e2c7022ccd$var$__assign.apply(this, arguments);
};
var $a713f3e2c7022ccd$export$ef6ddd4748dac183 = /** @class */ function() {
    function TimeComponent(options) {
        var _a;
        this.options = $a713f3e2c7022ccd$var$__assign({
            enabled: true,
            id: (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newDomGuid(),
            inputMode: "HourMinute",
            bindMode: "toModel",
            placeholder: (options === null || options === void 0 ? void 0 : options.inputMode) === "HourMinuteSecond" ? "__:__:__" : "__:__"
        }, options);
        if (this.options.bindTo != null && this.options.bindMode !== "fromModel" && this.options.property != null && this.options.value == null) this.options.value = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
        this.options.onChange = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(this.options.onChange);
    }
    TimeComponent.prototype.render = function() {
        var _a, _b;
        var val = this.options.value;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            var current = this.getValue();
            var newVal = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
            var newValStr = (0, $f697fe55e25cf9d4$export$324d90190a8b822a).formatTime(newVal, this.options.inputMode);
            if (newValStr !== current) {
                val = newVal;
                if (this.currentDom != null) this.currentDom.value = newValStr;
            }
        }
        return {
            tag: "input",
            attr: {
                id: this.options.id,
                enabled: this.options.enabled,
                value: (0, $f697fe55e25cf9d4$export$324d90190a8b822a).formatTime(val, this.options.inputMode),
                class: "time-comp " + ((_b = this.options.class) !== null && _b !== void 0 ? _b : ""),
                style: this.options.style,
                placeholder: this.options.placeholder,
                change: this.raiseChangeEvent
            }
        };
    };
    TimeComponent.prototype.onCreate = function(node) {
        this.currentDom = node.dom;
    };
    TimeComponent.prototype.onUpdate = function(node) {
        this.currentDom = node.dom;
    };
    TimeComponent.prototype.getValue = function() {
        if (this.currentDom == null) return "";
        return this.currentDom.value;
    };
    TimeComponent.prototype.getValueAsDate = function(datePart) {
        var x = datePart ? new Date(datePart.getTime()) : new Date();
        try {
            var parts = this.getValue().split(":");
            x.setHours(parseInt(parts[0], 10));
            if (parts.length > 1) x.setMinutes(parseInt(parts[1], 10));
            else x.setMinutes(0);
            if (this.options.inputMode === "HourMinuteSecond" && parts.length > 2) x.setSeconds(parseInt(parts[2], 10));
            else x.setSeconds(0);
        } catch (e) {
            console.log(e);
            this.currentDom.value = "";
            x.setHours(0);
            x.setMinutes(0);
            x.setSeconds(0);
        }
        return x;
    };
    TimeComponent.prototype.raiseChangeEvent = function(e, node) {
        var _a;
        if (this.options.enabled) {
            var val = this.getValueAsDate(this.options.value);
            if (this.options.bindTo && this.options.bindMode !== "fromModel" && this.options.property) this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(val) : val;
            this.options.onChange.notify(val);
        }
    };
    return TimeComponent;
}();






var $425668d49c34fd3b$var$__assign = undefined && undefined.__assign || function() {
    $425668d49c34fd3b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $425668d49c34fd3b$var$__assign.apply(this, arguments);
};
var $425668d49c34fd3b$export$38ecc82ad0887889 = /** @class */ function() {
    function DateTimeComponent(options) {
        var _this = this;
        if (options.bindMode && options.bindMode !== "toModel") throw new Error("Currently DateTimeComponent only supports toModel as bindMode");
        this.options = $425668d49c34fd3b$var$__assign({}, options);
        this.options.onChange = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(this.options.onChange);
        var optionsCopy = $425668d49c34fd3b$var$__assign({}, options);
        optionsCopy.bindTo = null;
        optionsCopy.property = null;
        optionsCopy.converter = null;
        optionsCopy.onChange = function() {
            var _a;
            var val = _this.getValueAsDate();
            if (_this.options.bindTo && options.property) _this.options.bindTo[options.property] = ((_a = _this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? _this.options.converter.toData(val) : val;
            _this.options.onChange.notify(val);
        };
        this.dateComp = new (0, $c9acd7efe2a931e2$export$19285a5b05c4ea7c)(optionsCopy);
        this.timeComp = new (0, $a713f3e2c7022ccd$export$ef6ddd4748dac183)(optionsCopy);
    }
    DateTimeComponent.prototype.render = function() {
        return {
            tag: "div",
            attr: {
                class: "date-time-comp"
            },
            children: [
                this.dateComp,
                this.timeComp
            ]
        };
    };
    DateTimeComponent.prototype.getValue = function() {
        return this.dateComp.getValue() + " " + this.timeComp.getValue();
    };
    DateTimeComponent.prototype.getValueAsDate = function() {
        return this.timeComp.getValueAsDate(this.dateComp.getValueAsDate());
    };
    return DateTimeComponent;
}();



var $563aca4f433537ec$export$dda1456c77c606e0 = /** @class */ function() {
    function ExpanderComponent(optionsOrHeader, body, expanded) {
        var _a;
        this.State = {
            expanded: false,
            waitingForAnimation: false
        };
        if (body != null) // old syntax
        this.options = {
            header: optionsOrHeader,
            body: body,
            expanded: expanded !== null && expanded !== void 0 ? expanded : true
        };
        else {
            this.options = optionsOrHeader;
            this.options.expanded = (_a = this.options.expanded) !== null && _a !== void 0 ? _a : true;
        }
        this.State.expanded = this.options.expanded;
    }
    ExpanderComponent.prototype.getIcon = function(expanded) {
        var _a, _b, _c, _d;
        return {
            tag: "span",
            attr: {
                class: "expand-collapse-icon",
                style: "padding:0 0.2rem 0 0.2rem;"
            },
            raw: true,
            content: "<svg style='min-width:" + ((_a = this.options.iconSize) !== null && _a !== void 0 ? _a : "1.5rem") + "; min-height:" + ((_b = this.options.iconSize) !== null && _b !== void 0 ? _b : "1.5rem") + ";max-width:" + ((_c = this.options.iconSize) !== null && _c !== void 0 ? _c : "1.5rem") + "; max-height:" + ((_d = this.options.iconSize) !== null && _d !== void 0 ? _d : "1.5rem") + ";' " + "xml:space='preserve' width='1024px' height='1024px' shape-rendering='geometricPrecision' text-rendering='geometricPrecision' image-rendering='optimizeQuality' fill-rule='nonzero' clip-rule='evenodd' viewBox='0 0 10240 10240'>" + (expanded ? "<path id='curve0' fill='#FFFFFF' d='M1273 3989l3621 3620c124,125 328,125 452,0l3621 -3620c124,-125 124,-328 0,-453l-905 -905c-125,-125 -328,-125 -453,0l-2489 2489 -2489 -2489c-125,-125 -328,-125 -453,0l-905 905c-124,125 -124,328 0,453z'/>" : "<path id='curve0' fill='#FFFFFF' d='M3989 1273l3620 3621c125,124 125,328 0,452l-3620 3621c-125,124 -328,124 -453,0l-905 -905c-125,-125 -125,-328 0,-453l2489 -2489 -2489 -2489c-125,-125 -125,-328 0,-453l905 -905c125,-124 328,-124 453,0z'/>") + "</svg>"
        };
    };
    ExpanderComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    ExpanderComponent.prototype.render = function() {
        var _this = this;
        var _a, _b, _c;
        var animate = this.State.waitingForAnimation;
        this.State.waitingForAnimation = false;
        return {
            tag: "div",
            attr: {
                class: "expander-comp " + (this.options.class || ""),
                style: (_a = this.options.style) !== null && _a !== void 0 ? _a : ""
            },
            children: [
                {
                    tag: "div",
                    attr: {
                        class: "header",
                        click: function(evt) {
                            var _a;
                            if ((_a = _this.options.isToggleOnHeader) !== null && _a !== void 0 ? _a : true) {
                                evt.stopPropagation();
                                _this.toggleExpand();
                            }
                        }
                    },
                    children: [
                        {
                            tag: "span",
                            attr: {
                                class: "toggler",
                                click: function(evt) {
                                    evt.stopPropagation();
                                    _this.toggleExpand();
                                }
                            },
                            children: [
                                this.State.expanded ? (_b = this.options.expandedIcon) !== null && _b !== void 0 ? _b : this.getIcon(true) : (_c = this.options.collapsedIcon) !== null && _c !== void 0 ? _c : this.getIcon(false)
                            ]
                        },
                        {
                            tag: "span",
                            attr: {
                                class: "content"
                            },
                            children: [
                                this.toNode(this.options.header)
                            ]
                        }
                    ]
                },
                {
                    tag: "div",
                    attr: {
                        class: "body",
                        style: this.State.expanded ? undefined : {
                            display: "none"
                        }
                    },
                    animation: animate ? {
                        attr: "opacity",
                        from: "0",
                        to: "1",
                        duration: 500
                    } : undefined,
                    children: [
                        this.toNode(this.options.body)
                    ]
                }
            ]
        };
    };
    ExpanderComponent.prototype.toggleExpand = function() {
        var newVal = !this.State.expanded;
        if (this.options.onToggle != null) {
            if (this.options.onToggle(newVal) === false) return;
        }
        if (newVal) this.State.waitingForAnimation = true;
        this.State.expanded = newVal;
    };
    ExpanderComponent.prototype.toNode = function(content) {
        if (typeof content === "string") return {
            tag: "div",
            content: content
        };
        return content;
    };
    return ExpanderComponent;
}();



var $0d00c7f89a9659aa$export$7db30d367db7d20a = /** @class */ function() {
    function LoadingComponent(sizeInRem) {
        this.sizeInRem = sizeInRem;
        if (sizeInRem == null) this.sizeInRem = 6;
    }
    LoadingComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    LoadingComponent.prototype.render = function() {
        return {
            tag: "div",
            attr: {
                style: "font-size:" + this.sizeInRem + "rem"
            },
            content: "<div class='lds-dual-ring'></div>",
            raw: true
        };
    };
    return LoadingComponent;
}();


var $66f8eca7165650d3$export$cec7cafc710f5d68 = /** @class */ function() {
    function FormComponent(children, options) {
        this.children = children;
        this.options = options;
    }
    FormComponent.prototype.render = function() {
        var _a, _b;
        return {
            tag: "form",
            attr: {
                class: (_a = this.options) === null || _a === void 0 ? void 0 : _a.class,
                style: (_b = this.options) === null || _b === void 0 ? void 0 : _b.style
            },
            children: this.children
        };
    };
    FormComponent.prototype.validate = function() {
        var valid = true;
        for(var _i = 0, _a = this.children; _i < _a.length; _i++){
            var c = _a[_i];
            if (c.validate && !c.validate()) valid = false;
        }
        return valid;
    };
    return FormComponent;
}();







var $b7d0a33f2abdbd6d$export$1642bf9bcd0984c9 = /** @class */ function() {
    function FormFieldComponent(options) {
        this.options = options;
        this.id = options.id || (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newDomGuid();
        this.type = this.options.type === "password" ? "password" : "text";
    }
    FormFieldComponent.prototype.render = function() {
        var _a, _b;
        return {
            tag: "div",
            attr: {
                class: "form-field " + (this.options.value ? "form-field--is-filled " : "") + ((_a = this.options.class) !== null && _a !== void 0 ? _a : "")
            },
            children: [
                {
                    tag: "div",
                    attr: {
                        class: "form-field__control" + (this.validationMessage ? " failed__valid" : "")
                    },
                    children: [
                        {
                            tag: "label",
                            attr: {
                                for: this.id,
                                class: "form-field__label"
                            },
                            content: this.options.label + (this.options.required ? " *" : "") + (this.validationMessage ? " " + ((_b = this.validationMessage) !== null && _b !== void 0 ? _b : "") : "")
                        },
                        {
                            tag: "input",
                            attr: {
                                id: this.id,
                                type: this.type,
                                value: this.options.value,
                                maxLength: this.options.maxLength,
                                class: "form-field__input",
                                blur: this.setInActive,
                                focus: this.setActive,
                                input: this.onInput
                            }
                        }
                    ]
                }
            ]
        };
    };
    FormFieldComponent.prototype.onCreate = function(node) {
        var InputDom = node.dom.firstElementChild.children[1];
        if (this.options.type === "number") (0, $c28d60ad53da98d2$export$6bf0cd3a219bbade)(InputDom, this.options.numberOptions);
        else if (this.options.type === "date") this.datepickerRef = (0, $ce1e5b161faa04c4$export$5109c6dd95d8fb00)(InputDom, this.options.dateOptions);
        else if (this.options.type === "autosuggest") (0, $c5cc4e8b84f597b8$export$a25e9aefbe210e53)(InputDom, this.options.autoSuggestOptions);
    };
    FormFieldComponent.prototype.onRemove = function(node) {
        if (this.datepickerRef != null) this.datepickerRef.destroy();
    };
    FormFieldComponent.prototype.validate = function() {
        var value = this.getValue();
        if (this.options.required && !value) {
            this.validationMessage = " ";
            return false;
        }
        if (this.options.onValidate) {
            var validationResult = this.options.onValidate(value);
            if (validationResult === false) {
                this.validationMessage = " ";
                return false;
            }
            if (validationResult !== true) {
                this.validationMessage = validationResult;
                return false;
            }
        }
        this.validationMessage = null;
        return true;
    };
    FormFieldComponent.prototype.getValue = function() {
        var _a;
        return (_a = document.getElementById(this.id)) === null || _a === void 0 ? void 0 : _a.value;
    };
    FormFieldComponent.prototype.setValue = function(value) {
        var el = document.getElementById(this.id);
        if (el == null) return;
        el.value = value || "";
        if (value) el.parentElement.classList.add("form-field--is-filled");
        else el.parentElement.classList.remove("form-field--is-filled");
    };
    FormFieldComponent.prototype.setInActive = function(evt, node) {
        var formField = node.dom.parentElement.parentElement;
        if (formField == null) return;
        setTimeout(function() {
            formField.classList.remove("form-field--is-active");
            if (node.dom.value === "") formField.classList.remove("form-field--is-filled");
            else formField.classList.add("form-field--is-filled");
        }, 250);
        if (this.options.onBlur) {
            this.options.onBlur(evt, node);
            return;
        }
        return false;
    };
    FormFieldComponent.prototype.setActive = function(evt, node) {
        var formField = node.dom.parentElement.parentElement;
        if (formField == null) return;
        formField.classList.add("form-field--is-active");
        if (this.options.onFocus) {
            this.options.onFocus(evt, node);
            return;
        }
        return false;
    };
    FormFieldComponent.prototype.onInput = function(evt, node) {
        if (this.options.onInput) {
            this.options.onInput(evt, node);
            return;
        }
    };
    return FormFieldComponent;
}();




var $cbfdf46f7a19bd94$export$439a99b941ac57a6 = /** @class */ function() {
    function GridComponent(data, columns, options, height) {
        var _this = this;
        this.data = data;
        this.columns = columns;
        this.options = options;
        this.currentlyVisible = true;
        this.checkVisibleTimeout = 0;
        this.initEventsFnc = [];
        this.resizeEventListener = function() {
            _this.ref.then(function(g) {
                if (_this.isVisible(g) && !_this.anyInputIsFocused()) g.resizeCanvas();
            });
        };
        var style = "";
        if (!options.autoHeight) style = "height:" + (height !== null && height !== void 0 ? height : "400px");
        this.rootTag = {
            tag: "div",
            attr: {
                style: style
            }
        };
        this.ref = new Promise(function(resolve, reject) {
            _this.refResolver = resolve;
        });
    }
    GridComponent.prototype.getRootTag = function() {
        return this.rootTag;
    };
    GridComponent.prototype.getRef = function() {
        return this.ref;
    };
    GridComponent.prototype.initEvents = function(fnc) {
        this.initEventsFnc.push(fnc);
    };
    GridComponent.prototype.onCreate = function(vnode) {
        var _this = this;
        // let grid;
        setTimeout(function() {
            if (Array.isArray(_this.data)) _this.gridRef = (0, $2e6e333d8ae6bd57$export$ad55d0f282934b51)(vnode.dom, _this.data, _this.columns, _this.options);
            else {
                var rawData_1 = [];
                _this.gridRef = (0, $2e6e333d8ae6bd57$export$ad55d0f282934b51)(vnode.dom, rawData_1, _this.columns, _this.options);
                _this.data.then(function(result) {
                    for(var i = 0; i < result.length; i++)rawData_1.push(result[i]);
                    _this.gridRef.refreshData();
                });
            }
            _this.refResolver(_this.gridRef);
            for(var idx = 0; idx < _this.initEventsFnc.length; idx++)_this.initEventsFnc[idx](_this.gridRef);
            window.addEventListener("resize", _this.resizeEventListener);
            _this.checkVisibility(_this.gridRef);
        }, 1);
    };
    GridComponent.prototype.onRemove = function(vnode) {
        var _this = this;
        if (this.gridRef != null) {
            this.gridRef.destroy();
            this.gridRef = null;
        }
        this.ref = new Promise(function(resolve, reject) {
            _this.refResolver = resolve;
        });
        if (this.checkVisibleTimeout !== 0) clearTimeout(this.checkVisibleTimeout);
        window.removeEventListener("resize", this.resizeEventListener);
    };
    GridComponent.prototype.render = function() {
        return this.rootTag;
    };
    GridComponent.prototype.checkVisibility = function(g) {
        var _this = this;
        if (!this.isVisible(g)) {
            this.currentlyVisible = false;
            this.checkVisibleTimeout = setTimeout(function() {
                _this.checkVisibility(g);
            }, 1000);
        } else {
            if (!this.currentlyVisible) {
                this.currentlyVisible = true;
                g.invalidateAllRows();
                g.resizeCanvas();
            }
            this.checkVisibleTimeout = 0;
        }
    };
    GridComponent.prototype.anyInputIsFocused = function() {
        // this check is necessary because of mobile virtual keyboard
        // -> virtual keyboard triggers window resize event -> which would reset any editors
        return (0, $35f562d52ec6d8f1$export$846056739d2a3e0b).GlobalEditorLock.isActive() && document.querySelector("input:focus") != null;
    };
    GridComponent.prototype.isVisible = function(g) {
        var el = g.getViewportNode().parentElement;
        while(el != null && el !== document.body){
            if (getComputedStyle(el, null).display === "none") return false;
            el = el.parentElement;
        }
        return el != null;
    };
    return GridComponent;
}();



var $6460040bc9df5728$export$7cd347c814201819 = /** @class */ function() {
    function TreeViewComponent(options) {
        this.options = options;
    }
    TreeViewComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    TreeViewComponent.prototype.render = function() {
        var _a, _b;
        return {
            tag: "div",
            attr: {
                style: this.options.style,
                class: "treeview-comp hover " + ((_a = this.options.class) !== null && _a !== void 0 ? _a : "")
            },
            children: [
                {
                    tag: "ul",
                    attr: {
                        class: "tv-ul"
                    },
                    children: [
                        this.renderNode((_b = this.filteredData) !== null && _b !== void 0 ? _b : this.options.data)
                    ]
                }
            ]
        };
    };
    TreeViewComponent.prototype.renderNode = function(el) {
        var _this = this;
        function getInput() {
            var res = {
                tag: "input",
                attr: {
                    class: "tv-input",
                    type: "checkbox",
                    id: el.id
                }
            };
            if (el.collapsed) res.attr.checked = "checked";
            return res;
        }
        return el.children && el.children.length > 0 ? {
            tag: "li",
            children: [
                getInput(),
                this.addChild({
                    tag: "label",
                    attr: {
                        for: el.id
                    }
                }, this.options.renderItem != null ? this.options.renderItem(el) : el.content),
                {
                    tag: "ul",
                    attr: {
                        class: "tv-ul"
                    },
                    children: el.children.map(function(c) {
                        return _this.renderNode(c);
                    })
                }
            ]
        } : this.addChild({
            tag: "li"
        }, this.options.renderItem != null ? this.options.renderItem(el) : el.content);
    };
    TreeViewComponent.prototype.addChild = function(parent, content) {
        if (typeof content === "string") parent.content = content;
        else parent.children = [
            content
        ];
        return parent;
    };
    return TreeViewComponent;
}();




var $29dd01f18dbc6ead$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $29dd01f18dbc6ead$export$fb3aab15d866de8f = /** @class */ function() {
    function TabsComponent(options) {
        var _a, _b, _c;
        this.options = options;
        this.State = {
            selectedIndex: null
        };
        this.options = (_a = this.options) !== null && _a !== void 0 ? _a : {};
        this.options.tabs = (_b = this.options.tabs) !== null && _b !== void 0 ? _b : [];
        this.options.selectedIndex = (_c = this.options.selectedIndex) !== null && _c !== void 0 ? _c : 0;
    }
    TabsComponent.prototype.render = function() {
        var _this = this;
        var _a, _b, _c, _d, _e;
        this.checkForDuplicateIds();
        var index = -1;
        var activeIndex = (_a = this.State.selectedIndex) !== null && _a !== void 0 ? _a : this.options.selectedIndex;
        if (activeIndex > -1 && this.options.tabs[activeIndex].content == null && this.options.tabs[activeIndex].onCreate) this.options.tabs[activeIndex].content = this.options.tabs[activeIndex].onCreate();
        var tabs = [];
        for(var idx = 0; idx < this.options.tabs.length; idx++){
            if (!this.options.tabs[idx].id) this.options.tabs[idx].id = (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newDomGuid();
            if (idx === activeIndex) tabs.push({
                tag: "div",
                attr: {
                    class: "tab-content " + ((_b = this.options.contentClass) !== null && _b !== void 0 ? _b : ""),
                    style: {
                        "max-height": (_c = this.options.maxHeight) !== null && _c !== void 0 ? _c : "100%"
                    },
                    id: this.options.tabs[idx].id
                },
                children: [
                    this.toNode(this.options.tabs[idx].content)
                ]
            });
            else if (this.options.preserveContent) tabs.push({
                tag: "div",
                attr: {
                    class: "tab-content tab-hidden " + ((_d = this.options.contentClass) !== null && _d !== void 0 ? _d : ""),
                    style: {
                        "max-height": (_e = this.options.maxHeight) !== null && _e !== void 0 ? _e : "100%"
                    },
                    id: this.options.tabs[idx].id
                },
                children: [
                    this.toNode(this.options.tabs[idx].content)
                ]
            });
        }
        return {
            tag: "div",
            attr: {
                class: "stabcomponent " + (this.options.class || ""),
                style: this.options.style
            },
            children: $29dd01f18dbc6ead$var$__spreadArray([
                {
                    tag: "div",
                    attr: {
                        class: "tab-header-row"
                    },
                    children: this.options.tabs.map(function(x) {
                        index++;
                        var currIndex = index;
                        return {
                            tag: "div",
                            attr: {
                                class: "tab-item " + (index === activeIndex ? "active " : "") + (_this.options.tabs[currIndex].enabled === false ? "disabled " : ""),
                                click: function(evt) {
                                    var _a;
                                    if ((_a = _this.options.tabs[currIndex].enabled) !== null && _a !== void 0 ? _a : true) {
                                        _this.SetSelectedTab(currIndex);
                                        if (_this.options.onSelect) _this.options.onSelect(currIndex);
                                    }
                                }
                            },
                            children: [
                                {
                                    tag: "span",
                                    attr: {
                                        style: "vertical-align: middle; vertical-align: -webkit-baseline-middle; vertical-align: -moz-middle-with-baseline;"
                                    },
                                    children: [
                                        _this.toNode(x.header, "span")
                                    ]
                                },
                                _this.options.tabs[index].canClose ? {
                                    tag: "div",
                                    attr: {
                                        class: "close-button",
                                        click: function(evt) {
                                            var _a;
                                            if ((_a = _this.options.tabs[currIndex].enabled) !== null && _a !== void 0 ? _a : true) {
                                                evt.stopPropagation();
                                                _this.closeTabIndex(currIndex);
                                            }
                                        }
                                    },
                                    content: "X"
                                } : undefined
                            ]
                        };
                    })
                }
            ], tabs, true)
        };
    };
    TabsComponent.prototype.AddTab = function(tabItem) {
        var _a;
        tabItem.enabled = (_a = tabItem.enabled) !== null && _a !== void 0 ? _a : true;
        this.options.tabs.push(tabItem);
        this.checkForDuplicateIds();
        return this.options.tabs.length - 1;
    };
    TabsComponent.prototype.EnableAll = function() {
        for(var i = 0; i < this.options.tabs.length; i++)this.options.tabs[i].enabled = true;
        this.renderer.refresh();
    };
    TabsComponent.prototype.DisableAll = function() {
        for(var i = 0; i < this.options.tabs.length; i++)this.options.tabs[i].enabled = false;
        this.renderer.refresh();
    };
    TabsComponent.prototype.GetByID = function(id) {
        return this.options.tabs.filter(function(f) {
            return f.id === id;
        })[0];
    };
    TabsComponent.prototype.closeTabIndex = function(index) {
        var _a, _b;
        // console.log("closing tab index " + index);
        if (this.options.tabs[index].onClosing) {
            if (this.options.tabs[index].onClosing() === false) return;
        }
        var currIdx = 0;
        this.options.tabs = this.options.tabs.filter(function(x) {
            return currIdx++ !== index;
        });
        if (this.options.tabs.length <= ((_a = this.State.selectedIndex) !== null && _a !== void 0 ? _a : this.options.selectedIndex)) this.SetSelectedTab(((_b = this.State.selectedIndex) !== null && _b !== void 0 ? _b : this.options.selectedIndex) - 1);
    };
    // public onCreate(node: IJSLVNode) {
    //     this.ref = node.dom as HTMLDivElement;
    // }
    // public onUpdate(node: IJSLVNode) {
    //     this.ref = node.dom as HTMLDivElement;
    // }
    TabsComponent.prototype.onInit = function(renderer) {
        this.renderer = renderer;
    };
    TabsComponent.prototype.SetSelectedTab = function(index) {
        // console.log("setActiveTab: " + index);
        if (this.options.tabs[index].content == null) this.options.tabs[index].content = this.options.tabs[index].onCreate();
        this.options.selectedIndex = index;
        this.State.selectedIndex = index;
        this.renderer.refresh();
    };
    TabsComponent.prototype.toNode = function(content, tag) {
        if (content == null) return undefined;
        if (typeof content === "string") return {
            tag: tag !== null && tag !== void 0 ? tag : "div",
            content: content
        };
        return content;
    };
    TabsComponent.prototype.checkForDuplicateIds = function() {
        if (this.options.tabs == null || this.options.tabs.length === 0) return;
        var ids = {};
        for(var _i = 0, _a = this.options.tabs; _i < _a.length; _i++){
            var tab = _a[_i];
            if (tab.id && ids[tab.id] !== undefined) throw new Error("Tab Control has duplicate id " + tab.id);
        }
    };
    return TabsComponent;
}();






var $54d87a6f0ffec68f$var$__assign = undefined && undefined.__assign || function() {
    $54d87a6f0ffec68f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $54d87a6f0ffec68f$var$__assign.apply(this, arguments);
};
var $54d87a6f0ffec68f$export$1aa4bc36b5d11f02 = /** @class */ function() {
    function NumberComponent(options) {
        var _a;
        this.options = $54d87a6f0ffec68f$var$__assign({
            onChange: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(),
            bindMode: "toModel"
        }, options);
        if (this.options.bindTo != null && this.options.property != null && this.options.value == null) this.options.value = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
        this.options.onChange = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(this.options.onChange);
        this.id = options.id || (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newDomGuid();
    }
    Object.defineProperty(NumberComponent.prototype, "onChange", {
        get: function() {
            return this.options.onChange;
        },
        enumerable: false,
        configurable: true
    });
    NumberComponent.prototype.render = function() {
        var _a;
        var val = this.options.value;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            var current = this.getValue();
            var newVal = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
            var newValStr = (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(newVal, this.options.format);
            if (newValStr !== current) {
                val = newVal;
                if (this.currentDom != null) this.currentDom.value = newValStr;
            }
        }
        return {
            tag: "input",
            attr: {
                id: this.id,
                class: this.options.class,
                style: this.options.style,
                value: (0, $b075d9931c098fde$export$b7a508fa8dae59fc).format(val, this.options.format),
                placeholder: this.options.placeholder
            }
        };
    };
    NumberComponent.prototype.getValue = function() {
        if (this.currentDom == null) return null;
        return this.currentDom.value;
    };
    NumberComponent.prototype.getValueAsNumber = function() {
        return (0, $b075d9931c098fde$export$b7a508fa8dae59fc).parse(this.getValue());
    };
    NumberComponent.prototype.onCreate = function(node) {
        var _this = this;
        this.currentDom = node.dom;
        var handler = new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(function(value) {
            var _a;
            if (_this.options.bindTo != null && _this.options.bindMode !== "fromModel" && _this.options.property != null) {
                if (_this.options.bindTo && _this.options.property) _this.options.bindTo[_this.options.property] = ((_a = _this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? _this.options.converter.toData(value) : value;
            }
            _this.options.onChange.notify(value);
        });
        (0, $c28d60ad53da98d2$export$6bf0cd3a219bbade)(this.currentDom, $54d87a6f0ffec68f$var$__assign($54d87a6f0ffec68f$var$__assign({}, this.options), {
            onChange: handler
        }));
    };
    return NumberComponent;
}();








var $a5215e39a2de1874$var$__assign = undefined && undefined.__assign || function() {
    $a5215e39a2de1874$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a5215e39a2de1874$var$__assign.apply(this, arguments);
};
var $a5215e39a2de1874$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a5215e39a2de1874$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a5215e39a2de1874$export$24ec15341293d56f = /** @class */ function() {
    function DialogComponent(options) {
        var _this = this;
        this.closeIcon = {
            tag: "div",
            content: "\u2716" /*"🗙"*/ ,
            attr: {
                class: "dlg-close-btn",
                click: function() {
                    _this.ref.close();
                }
            }
        };
        this.resizeHandle = {
            tag: "div",
            attr: {
                class: "dlg-res-handle rs-b rs-r"
            }
        };
        this.options = $a5215e39a2de1874$var$__assign({
            maxHeight: "calc(100vh - 7.5rem)",
            width: "50vw"
        }, options);
    }
    DialogComponent.Button = function(options) {
        var _this = this;
        var _a, _b, _c;
        var res = {
            tag: "button",
            attr: {
                class: "jsl-button " + ((_a = options.class) !== null && _a !== void 0 ? _a : ""),
                click: function() {
                    return $a5215e39a2de1874$var$__awaiter(_this, void 0, void 0, function() {
                        var clickRes, isPromise;
                        return $a5215e39a2de1874$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    if (!(options.onClick != null)) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    clickRes = options.onClick();
                                    isPromise = clickRes && typeof clickRes.then === "function" && typeof clickRes.catch === "function";
                                    if (!isPromise) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        clickRes
                                    ];
                                case 1:
                                    clickRes = _a.sent();
                                    _a.label = 2;
                                case 2:
                                    if (clickRes === false) return [
                                        2 /*return*/ 
                                    ];
                                    _a.label = 3;
                                case 3:
                                    if (DialogComponent.lastRenderedDlg != null) DialogComponent.lastRenderedDlg.getRef().close();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }
            },
            content: (_b = options.content) !== null && _b !== void 0 ? _b : "OK",
            raw: (_c = options.raw) !== null && _c !== void 0 ? _c : false
        };
        return res;
    };
    DialogComponent.Ok = function(onClick) {
        return DialogComponent.Button({
            content: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).core.Ok,
            onClick: onClick,
            class: "dlg-ok-btn"
        });
    };
    DialogComponent.Cancel = function() {
        return DialogComponent.Button({
            content: (0, $1e1dd0d8dd8c7753$export$2ba0acbbdabbe208).core.Cancel,
            class: "dlg-cancel-btn jsl-button-outline"
        });
    };
    DialogComponent.show = function(options) {
        var container = document.createElement("div");
        document.body.appendChild(container);
        var oldRenderer = (0, $83d498fca38a60e6$export$8beec2e5b8623754).lastCreatedRenderer;
        var oldLastDlg = DialogComponent.lastRenderedDlg;
        var renderer = new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(container, oldRenderer != null);
        if (oldRenderer != null) (0, $83d498fca38a60e6$export$8beec2e5b8623754).lastCreatedRenderer = renderer;
        var o = $a5215e39a2de1874$var$__assign({}, options);
        if (o.autoOpen == null) o.autoOpen = true;
        o.onClose = function() {
            if (options.onClose) {
                if (options.onClose() === false) return;
            }
            document.body.removeChild(container);
            (0, $83d498fca38a60e6$export$8beec2e5b8623754).lastCreatedRenderer = oldRenderer;
            if (oldRenderer != null) oldRenderer.refresh();
            DialogComponent.lastRenderedDlg = oldLastDlg;
        };
        var dlg = new DialogComponent(o);
        DialogComponent.lastRenderedDlg = dlg;
        renderer.render(dlg);
        return dlg;
    };
    DialogComponent.prototype.render = function() {
        var header = this.toNode(this.options.header);
        var body = this.toNode(this.options.content);
        var footer = this.toNode(this.options.footer);
        var styleW = "";
        var styleH = "";
        if (this.options.width != null) styleW += "width:" + this.options.width + ";";
        if (this.options.minWidth != null) styleW += "min-width:" + this.options.minWidth + ";";
        if (this.options.maxWidth != null) styleW += "max-width:" + this.options.maxWidth + ";";
        if (this.options.height != null) styleH += "height:" + this.options.height + ";";
        if (this.options.minHeight != null) styleH += "min-height:" + this.options.minHeight + ";";
        if (this.options.maxHeight != null) styleH += "max-height:" + this.options.maxHeight + ";";
        var headerStyle = this.options.allowMove ? "cursor:move" : undefined;
        return {
            tag: "div",
            attr: {
                class: "jsl-dialog-overlay",
                wheel: function(e) {
                    e.preventDefault();
                }
            },
            children: [
                {
                    tag: "div",
                    attr: {
                        class: "jsl-dialog " + (this.options.class || ""),
                        style: styleW,
                        wheel: function(e) {
                            e.stopImmediatePropagation();
                            e.stopPropagation();
                        }
                    },
                    children: [
                        {
                            tag: "div",
                            attr: {
                                class: "dlg-header",
                                style: headerStyle
                            },
                            children: this.options.showCloseButton ? [
                                header,
                                this.closeIcon
                            ] : [
                                header
                            ]
                        },
                        {
                            tag: "div",
                            attr: {
                                class: "dlg-body",
                                style: styleH
                            },
                            children: [
                                body
                            ]
                        },
                        {
                            tag: "div",
                            attr: {
                                class: "dlg-footer"
                            },
                            children: [
                                footer
                            ]
                        },
                        this.options.allowResize ? this.resizeHandle : undefined
                    ]
                }
            ]
        };
    };
    DialogComponent.prototype.onCreate = function(node) {
        this.ref = (0, $7e905aba0f97004b$export$3ddf2d174ce01153)(node.dom, this.options);
        if (this.options.allowMove) (0, $13f81d53256d6031$export$4f463cee1ac70b5b)(this.ref.getOverlay(), $a5215e39a2de1874$var$__assign({
            onStart: new (0, $5fd26a1369f72280$export$ce0ba2422a1c7815)(function(e) {
                var headerWasClicked = false;
                var parent = e.evt.target;
                while(parent != null && !parent.classList.contains("jsl-dialog-overlay")){
                    if (parent.classList.contains("dlg-header")) {
                        headerWasClicked = true;
                        break;
                    }
                    parent = parent.parentElement;
                }
                if (headerWasClicked) {
                    var rect = e.target.getBoundingClientRect();
                    e.target.style.transform = "translate(0, 0)";
                    e.target.style.left = rect.left + "px";
                    e.target.style.top = rect.top + "px";
                } else e.cancelEvent();
            })
        }, this.options.moveOptions));
        if (this.options.allowResize) {
            var dlgEl = this.ref.getOverlay().querySelector(".jsl-dialog");
            (0, $e452221c07eb14a0$export$e82068809229c83c)(dlgEl, this.options.resizeOptions);
            var rect = dlgEl.getBoundingClientRect();
            dlgEl.style.transform = "translate(0, 0)";
            dlgEl.style.left = rect.left + "px";
            dlgEl.style.top = rect.top + "px";
            var bodyEl = dlgEl.querySelector(".dlg-body");
            var bodyRect = bodyEl.getBoundingClientRect();
            bodyEl.style.height = "calc(100% - " + (rect.height - bodyRect.height) + "px)";
        }
    };
    DialogComponent.prototype.getRef = function() {
        return this.ref;
    };
    DialogComponent.prototype.toNode = function(content) {
        if (typeof content === "string") return {
            tag: "div",
            content: content
        };
        return content;
    };
    return DialogComponent;
}();




var $f9ae366378e5324c$var$__assign = undefined && undefined.__assign || function() {
    $f9ae366378e5324c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f9ae366378e5324c$var$__assign.apply(this, arguments);
};
var $f9ae366378e5324c$export$3b0c38219ddaf128 = /** @class */ function() {
    function ButtonComponent(options) {
        this.options = $f9ae366378e5324c$var$__assign({
            enabled: true,
            class: ""
        }, options);
        this.options.click = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(this.options.click);
    }
    Object.defineProperty(ButtonComponent.prototype, "click", {
        get: function() {
            return this.options.click;
        },
        enumerable: false,
        configurable: true
    });
    ButtonComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    ButtonComponent.prototype.render = function() {
        return {
            tag: "button",
            attr: {
                class: "jsl-button " + (this.options.outlined ? "jsl-button-outline " : "") + this.options.class + (!this.options.enabled ? " disabled" : ""),
                style: this.options.style,
                click: this.raiseEvent
            },
            content: typeof this.options.content === "string" ? this.options.content : "",
            children: typeof this.options.content !== "string" ? [
                this.options.content
            ] : []
        };
    };
    ButtonComponent.prototype.raiseEvent = function(evt) {
        if (this.options.enabled) this.options.click.notify(evt);
    };
    return ButtonComponent;
}();



var $0db63c4ff60d6668$var$__assign = undefined && undefined.__assign || function() {
    $0db63c4ff60d6668$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0db63c4ff60d6668$var$__assign.apply(this, arguments);
};
// tslint:disable-next-line: max-classes-per-file
var $0db63c4ff60d6668$export$99ca0c5cb670cc62 = /** @class */ function() {
    function InputComponent(options) {
        var _a;
        this.options = $0db63c4ff60d6668$var$__assign({
            type: "text",
            enabled: true,
            bindMode: "toModel"
        }, options);
        if (this.options.bindTo != null && this.options.property != null && this.options.value == null) this.options.value = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
        this.options.onChange = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(this.options.onChange);
        this.options.onInput = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(this.options.onInput);
        if (this.options.type === "input") this.options.type = "text";
    }
    Object.defineProperty(InputComponent.prototype, "onChange", {
        get: function() {
            return this.options.onChange;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "onInput", {
        get: function() {
            return this.options.onInput;
        },
        enumerable: false,
        configurable: true
    });
    // public isEqual(node: IJSLComponent): boolean {
    //     return (this as any).__proto__ === (node as any).__proto__;
    // }
    InputComponent.prototype.render = function() {
        var _a;
        var val = this.options.value;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            if (this.onInput.count() > 0) this.options.bindOnInput = true;
            var current = this.getValue();
            var newVal = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
            if (newVal !== current) {
                val = newVal;
                if (this.currentDom != null) this.currentDom.value = val !== null && val !== void 0 ? val : "";
            }
        }
        return {
            tag: this.options.type !== "textarea" ? "input" : "textarea",
            attr: {
                type: this.options.type !== "textarea" ? this.options.type : undefined,
                disabled: !this.options.enabled ? "disabled" : undefined,
                class: this.options.class,
                style: this.options.style,
                change: this.raiseChangeEvent,
                input: this.raiseInputEvent,
                value: this.options.type !== "textarea" ? val : undefined,
                placeholder: this.options.placeholder,
                id: typeof this.options.id === "string" ? this.options.id : undefined,
                maxLength: this.options.maxLength
            },
            content: this.options.type === "textarea" ? val : undefined
        };
    };
    InputComponent.prototype.getValue = function() {
        if (this.currentDom == null) return "";
        return this.currentDom.value;
    };
    InputComponent.prototype.setValue = function(value) {
        var _a;
        if (this.currentDom != null) this.currentDom.value = value;
        if (this.options.bindMode !== "fromModel" && this.options.bindTo && this.options.property) this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(value) : value;
    };
    InputComponent.prototype.onCreate = function(node) {
        this.currentDom = node.dom;
    };
    // public onUpdate(node: IJSLVNode) {
    //     this.currentDom = node.dom as HTMLInputElement;
    //     if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
    //         if (this.onInput.count() > 0) {
    //             this.options.bindOnInput = true;
    //         }
    //         const current = this.getValue();
    //         const newVal = (this.options.converter?.toUI ?
    //             this.options.converter.toUI(this.options.bindTo[this.options.property]) :
    //             this.options.bindTo[this.options.property]) as string;
    //         if (newVal !== current) {
    //             if (this.currentDom != null) {
    //                 this.currentDom.value = newVal ?? "";
    //             }
    //         }
    //     }
    // }
    InputComponent.prototype.raiseChangeEvent = function(e, node) {
        var _a;
        if (this.options.enabled) {
            var value = node.dom.value;
            if (this.options.bindMode !== "fromModel" && this.options.bindTo && this.options.property) this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(value) : value;
            this.options.onChange.notify(value);
        }
    };
    InputComponent.prototype.raiseInputEvent = function(e, node) {
        var _a;
        if (this.onInput.count() === 0) return false;
        if (this.options.enabled) {
            var value = node.dom.value;
            if (this.options.bindOnInput && this.options.bindMode !== "fromModel" && this.options.bindTo && this.options.property) this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(value) : value;
            this.options.onInput.notify(value);
        }
    };
    return InputComponent;
}();





var $f24bc78b87634ab6$var$__assign = undefined && undefined.__assign || function() {
    $f24bc78b87634ab6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f24bc78b87634ab6$var$__assign.apply(this, arguments);
};
var $f24bc78b87634ab6$export$e3ad28a1fdd217f6 = /** @class */ function() {
    function CheckBoxComponent(options) {
        var _a;
        this.options = $f24bc78b87634ab6$var$__assign({
            enabled: true,
            class: "",
            bindMode: "toModel"
        }, options);
        if (!this.options.id) this.options.id = (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newDomGuid();
        if (this.options.bindTo != null && this.options.property != null && this.options.value == null) this.options.value = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
        this.options.onChange = (0, $5fd26a1369f72280$export$ce0ba2422a1c7815).Create(this.options.onChange);
    }
    Object.defineProperty(CheckBoxComponent.prototype, "onChange", {
        get: function() {
            return this.options.onChange;
        },
        enumerable: false,
        configurable: true
    });
    // public isEqual(node: IJSLComponent): boolean {
    //     return (this as any).__proto__ === (node as any).__proto__;
    // }
    CheckBoxComponent.prototype.render = function() {
        var _a;
        var val = this.options.value;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            var current = this.getValue();
            var newVal = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ? this.options.converter.toUI(this.options.bindTo[this.options.property]) : this.options.bindTo[this.options.property];
            if (newVal !== current) {
                val = newVal;
                if (this.currentDom != null) this.currentDom.checked = val;
            }
        }
        return {
            tag: "span",
            attr: {
                style: this.options.style
            },
            children: [
                {
                    tag: "input",
                    attr: {
                        type: "checkbox",
                        disabled: !this.options.enabled ? "disabled" : undefined,
                        class: "checkbox-comp " + (this.options.class || ""),
                        change: this.raiseEvent,
                        checked: val ? "checked" : undefined,
                        id: typeof this.options.id === "string" ? this.options.id : undefined
                    }
                },
                {
                    tag: "label",
                    content: this.options.label,
                    attr: {
                        for: this.options.id
                    }
                }
            ]
        };
    };
    CheckBoxComponent.prototype.getValue = function() {
        var _a;
        return ((_a = this.currentDom) === null || _a === void 0 ? void 0 : _a.checked) || false;
    };
    CheckBoxComponent.prototype.setValue = function(val) {
        if (this.currentDom != null) this.currentDom.checked = val;
    };
    CheckBoxComponent.prototype.onCreate = function(node) {
        this.currentDom = node.dom.querySelector("input");
    };
    CheckBoxComponent.prototype.raiseEvent = function(e, node) {
        var _a;
        if (this.options.enabled) {
            var value = node.dom.checked;
            if (this.options.bindTo && this.options.bindMode !== "fromModel" && this.options.property) this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(value) : value;
            this.options.onChange.notify(value);
        }
    };
    return CheckBoxComponent;
}();


var $2e59c6bc566ad951$export$22afcbd7ba73fa73 = /** @class */ function() {
    function IntervalComponent(fnc, options) {
        this.fnc = fnc;
        this.options = options;
    }
    IntervalComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    IntervalComponent.prototype.render = function() {
        return {
            tag: "input",
            attr: {
                type: "hidden"
            }
        };
    };
    IntervalComponent.prototype.onInit = function(render) {
        this.renderer = render;
    };
    IntervalComponent.prototype.onCreate = function(node) {
        var _this = this;
        var timeoutRef = node.dom.value;
        if (timeoutRef && timeoutRef !== "0") {
            clearTimeout(parseInt(timeoutRef, 10));
            node.dom.value = "";
        }
        var f = function() {
            var result;
            try {
                result = _this.fnc();
            } catch (e) {
                console.error(e);
                if (_this.options.stopOnError) return;
            }
            var isPromise = result && typeof result.then === "function" && typeof result.catch === "function";
            if (isPromise) result.then(function() {
                if (!_this.options.noRefresh) _this.renderer.refresh();
                node.dom.value = setTimeout(f, _this.options.interval).toString();
            }).catch(function(e) {
                console.error(e);
                if (!_this.options.stopOnError) {
                    if (!_this.options.noRefresh) _this.renderer.refresh();
                    node.dom.value = setTimeout(f, _this.options.interval).toString();
                }
            });
            else {
                if (!_this.options.noRefresh) _this.renderer.refresh();
                node.dom.value = setTimeout(f, _this.options.interval).toString();
            }
        };
        f();
    };
    IntervalComponent.prototype.onRemove = function(node) {
        var timeoutRef = node.dom.value;
        if (timeoutRef && timeoutRef !== "0") {
            clearTimeout(parseInt(timeoutRef, 10));
            node.dom.value = "";
        }
    };
    return IntervalComponent;
}();




var $e58f9f5386b72872$var$__assign = undefined && undefined.__assign || function() {
    $e58f9f5386b72872$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e58f9f5386b72872$var$__assign.apply(this, arguments);
};
var $e58f9f5386b72872$export$989fb497e9419607 = /** @class */ function() {
    function StackPanelComponent(children, options) {
        this.children = children;
        this.options = $e58f9f5386b72872$var$__assign({
            orientation: "horizontal",
            valign: "stretch"
        }, options);
    }
    StackPanelComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    StackPanelComponent.prototype.render = function() {
        var _this = this;
        var c = this.options.orientation === "horizontal" ? "stackpanel-comp hstackpanel" : "stackpanel-comp vstackpanel";
        if (this.options.responsive) c += " responsive";
        if (this.options.wrap) c += " wrap";
        if (this.options.class) c += " " + this.options.class;
        var va = this.options.valign;
        var s = "align-items:" + (va === "top" ? "flex-start" : va === "bottom" ? "flex-end" : va);
        if (this.options.style) s += ";" + this.options.style;
        return {
            tag: "div",
            attr: {
                class: c,
                style: s
            },
            children: this.children.map(function(x, idx) {
                return x != null && x._is_splitter === true ? x : {
                    tag: "div",
                    attr: {
                        style: _this.getSize(idx) + (_this.options.flexForChildren ? ";display:flex" : "")
                    },
                    children: [
                        x
                    ]
                };
            })
        };
    };
    StackPanelComponent.prototype.getSize = function(idx) {
        if (this.options.sizes != null && this.options.sizes[idx] != null) {
            var s = this.options.sizes[idx];
            if (s === "*") return undefined;
            if (this.options.orientation === "vertical") return "height: " + s;
            else return "width:" + s;
        }
        return "flex-grow:1;";
    };
    return StackPanelComponent;
}();



var $de62f6288a5b4e8e$export$41da1a319244c692 = /** @class */ function() {
    function SplitterComponent(options) {
        // tslint:disable-next-line: variable-name
        this._is_splitter = true;
        this.options = options !== null && options !== void 0 ? options : {};
        if (this.options.minSizesInPX == null) this.options.minSizesInPX = [];
        if (this.options.minSizesInPX[0] == null) this.options.minSizesInPX[0] = 0;
        if (this.options.minSizesInPX[1] == null) this.options.minSizesInPX[1] = 0;
        if (this.options.maxSizesInPX == null) this.options.maxSizesInPX = [];
        if (!SplitterComponent.listenerRegistered) {
            SplitterComponent.listenerRegistered = true;
            this.registerListener();
        }
    }
    SplitterComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    SplitterComponent.prototype.render = function() {
        return {
            tag: "div",
            attr: {
                class: "split-comp"
            }
        };
    };
    SplitterComponent.prototype.registerListener = function() {
        var dragStartX = 0;
        var draggedEl;
        var elLeft;
        var elRight;
        var elLeftWidth;
        var elRightWidth;
        var isDown;
        function mousemove(e) {
            var _a;
            if (!isDown) return;
            e.preventDefault();
            // e.stopPropagation();
            // e.stopImmediatePropagation();
            var x;
            var orientation = draggedEl.parentElement.classList.contains("vstackpanel") ? "vertical" : "horizontal";
            var component = draggedEl._component;
            if (orientation === "horizontal") x = e.pageX != null ? e.pageX : e.touches[0].pageX;
            else x = e.pageY != null ? e.pageY : e.touches[0].pageY;
            var delta = dragStartX - x;
            if (elLeftWidth - delta < component.options.minSizesInPX[0] || elRightWidth + delta < component.options.minSizesInPX[1]) return;
            if (elLeftWidth - delta > component.options.maxSizesInPX[0] || elRightWidth + delta > component.options.maxSizesInPX[1]) return;
            if (orientation === "horizontal") {
                elLeft.style.width = elLeftWidth - delta + "px";
                elRight.style.width = elRightWidth + delta + "px";
            } else {
                elLeft.style.height = elLeftWidth - delta + "px";
                elRight.style.height = elRightWidth + delta + "px";
            }
            (_a = component.options.onResize) === null || _a === void 0 || _a.notify();
        }
        function mouseup(e) {
            var _a;
            isDown = false;
            // document.removeEventListener("mousemove", mousemove);
            // document.removeEventListener("touchmove", mousemove);
            document.removeEventListener("mouseup", mousedown);
            document.removeEventListener("touchend", mousedown);
            var component = draggedEl._component;
            var area1 = draggedEl.previousElementSibling;
            var args = {};
            if (area1 != null) args.size1InPX = area1.getBoundingClientRect().width;
            (_a = component.options.onResizeDone) === null || _a === void 0 || _a.notify(args);
        }
        function mousedown(e) {
            if (e.target.classList.contains("split-comp")) {
                isDown = true;
                var orientation_1 = e.target.parentElement.classList.contains("vstackpanel") ? "vertical" : "horizontal";
                if (orientation_1 === "horizontal") dragStartX = e.pageX != null ? e.pageX : e.touches[0].pageX;
                else dragStartX = e.pageY != null ? e.pageY : e.touches[0].pageY;
                draggedEl = e.target;
                elLeft = draggedEl.previousElementSibling;
                elRight = draggedEl.nextElementSibling;
                if (elLeft != null && elRight != null) {
                    if (orientation_1 === "horizontal") {
                        elLeftWidth = elLeft.getBoundingClientRect().width;
                        elRightWidth = elRight.getBoundingClientRect().width;
                    } else {
                        elLeftWidth = elLeft.getBoundingClientRect().height;
                        elRightWidth = elRight.getBoundingClientRect().height;
                    }
                    document.body.addEventListener("mousemove", mousemove, {
                        passive: false
                    });
                    document.body.addEventListener("touchmove", mousemove, {
                        passive: false
                    });
                    document.body.addEventListener("mouseup", mouseup, false);
                    document.body.addEventListener("touchend", mouseup, false);
                }
            }
        }
        document.addEventListener("mousedown", mousedown);
        document.addEventListener("touchstart", mousedown);
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("touchmove", mousemove);
    };
    SplitterComponent.listenerRegistered = false;
    return SplitterComponent;
}();




var $412ef7b931c6e343$var$__assign = undefined && undefined.__assign || function() {
    $412ef7b931c6e343$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $412ef7b931c6e343$var$__assign.apply(this, arguments);
};
var $412ef7b931c6e343$export$17f4cf7f636f0812 = function(row, cell, value, columnDef, dataContext, grid) {
    var result = "";
    var hierachy = grid._hierachy;
    if (hierachy != null) {
        var options = hierachy.getOptions();
        var level = hierachy.getLevel(dataContext);
        if (level > 0) result += "<span class='jsl-indent' style='min-width:" + level * hierachy.getOptions().indentInRem + "rem;'></span>";
        if (options.enableCollapsing) {
            var hasChildren = hierachy.hasChildren(dataContext);
            if (hasChildren) {
                if (dataContext[options.collapsedStateField]) result += "<span class='jsl-toggle'>" + options.expandIconHTML + "</span>";
                else result += "<span class='jsl-toggle'>" + options.collapseIconHTML + "</span>";
            } else result += "<span class='jsl-toggle-spacer'></span>";
        }
    }
    if (value != null) result += (value + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return result;
};
var $412ef7b931c6e343$export$4e2cd65dc360e058 = /** @class */ function() {
    function GridTree(grid, o) {
        this.grid = grid;
        this.options = $412ef7b931c6e343$var$__assign({
            enableCollapsing: true,
            indentInRem: 1,
            hiddenStateField: "_hidden_by_h",
            collapsedStateField: "_callapsed",
            expandIconHTML: "\u25B6",
            collapseIconHTML: "\u25BC" // "˅"
        }, o);
        this.primaryKey = this.grid.getOptions().primaryKey;
        grid._hierachy = this;
        grid.refresh();
        this.initEvents();
    }
    GridTree.prototype.getOptions = function() {
        return this.options;
    };
    GridTree.prototype.getLevel = function(item) {
        var level = 0;
        var parent = this.getParent(item);
        while(parent != null){
            parent = this.getParent(parent);
            level++;
        }
        return level;
    };
    GridTree.prototype.getParent = function(item) {
        return this.grid.dataView.getItemById(item[this.options.parentColumn]);
    };
    GridTree.prototype.hasChildren = function(item) {
        return this.rowHasChildren(this.grid.dataView.getIdxByItem(item));
    };
    GridTree.prototype.getDirectChildren = function(item) {
        var id = item[this.primaryKey];
        var result = [];
        var data = this.grid.getData();
        for(var i = 0; i < data.length; i++){
            var pid = data[i][this.options.parentColumn];
            if (pid === id) result.push(data[i]);
        }
        return result;
    };
    GridTree.prototype.getAllChildren = function(item) {
        var parentid = item[this.primaryKey];
        var result = [];
        var data = this.grid.getData();
        for(var i = 0; i < data.length; i++)if (data[i][this.options.parentColumn] === parentid) {
            result.push(data[i]);
            result.push.apply(result, this.getAllChildren(data[i]));
        }
        return result;
    };
    GridTree.prototype.rowHasChildren = function(row) {
        var data = this.grid.getData();
        if (data.length > row + 1) return data[row + 1][this.options.parentColumn] === data[row][this.primaryKey];
        return false;
    };
    GridTree.prototype.toggleExpand = function(item) {
        if (item[this.options.collapsedStateField]) this.expand(item);
        else this.collapse(item);
    };
    GridTree.prototype.expand = function(item) {
        item[this.options.collapsedStateField] = false;
        var data = this.grid.getData();
        var i = this.grid.dataView.getIdxByItem(item);
        while(i < data.length){
            data[i][this.options.hiddenStateField] = false;
            if (this.rowHasChildren(i)) {
                if (data[i][this.options.collapsedStateField]) //skip children
                i += this.getAllChildren(data[i]).length;
            }
            i++;
        }
        this.grid.refreshData();
    };
    GridTree.prototype.indent = function(rows) {
        var realRows = this.filterChildren(rows);
        var data = this.grid.getData();
        //get indexes of rows
        var indexes = [];
        for(var i = 0; i < realRows.length; i++)indexes.push(this.grid.dataView.getIdxByItem(realRows[i]));
        //sort indexes
        indexes.sort(function(a, b) {
            return a > b ? 1 : a < b ? -1 : 0;
        });
        //change parents to indent rows
        for(var i = 0; i < indexes.length; i++){
            var rowIdx = indexes[i];
            var parentID = data[rowIdx][this.options.parentColumn];
            for(var tmp = rowIdx - 1; tmp >= 0; tmp--)if (data[tmp][this.options.parentColumn] === parentID) {
                data[rowIdx][this.options.parentColumn] = data[tmp][this.primaryKey];
                break;
            }
        }
        this.grid.refreshData();
    };
    GridTree.prototype.outdent = function(rows) {
        var rows2 = this.filterChildren(rows);
        var data = this.grid.getData();
        for(var i = 0; i < rows2.length; i++){
            var row = rows2[i];
            var oldparent = row[this.options.parentColumn];
            if (oldparent) {
                var newparent = data[this.grid.dataView.getIdxById(oldparent)][this.options.parentColumn];
                row[this.options.parentColumn] = newparent;
                //make all subsequent items with same ParentID have current row as new parentid
                var idx = this.grid.dataView.getIdxById(row[this.primaryKey]);
                while(++idx < data.length)if (data[idx][this.options.parentColumn] === oldparent) data[idx][this.options.parentColumn] = row[this.primaryKey];
            }
        }
        this.grid.refreshData();
    };
    GridTree.prototype.filterChildren = function(rows) {
        var result = [];
        var dict = {};
        for(var i = 0; i < rows.length; i++)dict[rows[i][this.primaryKey]] = true;
        for(var i = 0; i < rows.length; i++){
            var row = rows[i];
            var parentid = row[this.options.parentColumn];
            if (!parentid || !dict[parentid]) result.push(row);
        }
        return result;
    };
    GridTree.prototype.collapse = function(item) {
        item[this.options.collapsedStateField] = true;
        var children = this.getAllChildren(item);
        for(var i = 0; i < children.length; i++)children[i][this.options.hiddenStateField] = true;
        this.grid.refreshData();
    };
    GridTree.prototype.initEvents = function() {
        var _this = this;
        // collapse / expand click events
        if (this.options.enableCollapsing) this.grid.onClick.subscribe(function(e, args) {
            if (e.target.classList.contains("jsl-toggle")) {
                e.stopImmediatePropagation();
                _this.toggleExpand(_this.grid.dataView.getItem(args.row));
            }
        });
        // filters
        var hiddenFilter = {
            field: this.options.hiddenStateField,
            match: function(itm, field) {
                return !itm[_this.options.hiddenStateField];
            }
        };
        this.grid.addFilter(hiddenFilter);
    };
    return GridTree;
}();



var $e62f5af080b2a7de$var$__assign = undefined && undefined.__assign || function() {
    $e62f5af080b2a7de$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e62f5af080b2a7de$var$__assign.apply(this, arguments);
};
var $e62f5af080b2a7de$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $e62f5af080b2a7de$export$bce6195d5e5246cd = /** @class */ function() {
    function NavigationComponent(options) {
        this.options = $e62f5af080b2a7de$var$__assign({
            position: "fixed",
            id: "luxbar-checkbox",
            alignment: "left"
        }, options);
    }
    NavigationComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    NavigationComponent.prototype.render = function() {
        var _this = this;
        var _a, _b;
        return {
            tag: "header",
            attr: {
                style: this.options.style,
                class: "nav-comp " + ((_a = this.options.class) !== null && _a !== void 0 ? _a : "")
            },
            children: [
                {
                    tag: "div",
                    attr: {
                        class: "luxbar luxbar-" + this.options.position
                    },
                    children: [
                        {
                            tag: "input",
                            attr: {
                                type: "checkbox",
                                class: "luxbar-checkbox",
                                id: this.options.id
                            }
                        },
                        {
                            tag: "div",
                            attr: {
                                class: "luxbar-menu luxbar-menu-" + this.options.alignment + " luxbar-menu-light"
                            },
                            children: [
                                {
                                    tag: "ul",
                                    attr: {
                                        class: "luxbar-navigation"
                                    },
                                    children: $e62f5af080b2a7de$var$__spreadArray([
                                        {
                                            tag: "li",
                                            attr: {
                                                class: "luxbar-header"
                                            },
                                            children: [
                                                {
                                                    tag: "a",
                                                    attr: {
                                                        href: (_b = this.options.titleLink) !== null && _b !== void 0 ? _b : "#",
                                                        class: "luxbar-brand"
                                                    },
                                                    children: [
                                                        this.toNode(this.options.title)
                                                    ]
                                                },
                                                {
                                                    tag: "label",
                                                    attr: {
                                                        class: "luxbar-hamburger luxbar-hamburger-spin",
                                                        for: this.options.id
                                                    },
                                                    children: [
                                                        {
                                                            tag: "span"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ], this.options.data.map(function(x) {
                                        return _this.itemToNode(x);
                                    }), true)
                                }
                            ]
                        }
                    ]
                }
            ]
        };
    };
    NavigationComponent.prototype.itemToNode = function(x) {
        var _this = this;
        var _a, _b, _c;
        return {
            tag: "li",
            attr: {
                class: "luxbar-item" + (((_a = x.children) === null || _a === void 0 ? void 0 : _a.length) > 0 ? " dropdown" : "") + (this.isActive(x.link) ? " active" : "")
            },
            children: [
                {
                    tag: "a",
                    attr: {
                        href: (_b = x.link) !== null && _b !== void 0 ? _b : "#",
                        target: x.target,
                        click: x.click
                    },
                    children: [
                        this.toNode(x.content)
                    ]
                },
                ((_c = x.children) === null || _c === void 0 ? void 0 : _c.length) > 0 ? {
                    tag: "ul",
                    children: x.children.map(function(c) {
                        return _this.itemToNode(c);
                    })
                } : undefined
            ]
        };
    };
    NavigationComponent.prototype.isActive = function(link) {
        return location.hash.startsWith(link);
    };
    NavigationComponent.prototype.toNode = function(content) {
        if (typeof content === "string") return {
            tag: "span",
            content: content
        };
        return content;
    };
    return NavigationComponent;
}();



var $4f26493869e06e8f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $4f26493869e06e8f$export$bf5277e7582ba06f = /** @class */ function() {
    // private options: IStackPanelOptions;
    function RibbonMenuComponent(groups) {
        this.groups = groups;
    // this.options = {...{orientation: "horizontal", verticalAlign: "stretch"}, ...options};
    }
    RibbonMenuComponent.prototype.isEqual = function(node) {
        return this.__proto__ === node.__proto__;
    };
    RibbonMenuComponent.prototype.render = function() {
        return {
            tag: "div",
            attr: {
                class: "ribbon-menu-comp"
            },
            children: this.groups.map(function(g) {
                var _a;
                return {
                    tag: "div",
                    attr: {
                        class: "ribbon-group"
                    },
                    children: $4f26493869e06e8f$var$__spreadArray([
                        {
                            tag: "div",
                            attr: {
                                class: "ribbon-legend"
                            },
                            content: (_a = g.title) !== null && _a !== void 0 ? _a : ""
                        }
                    ], g.children, true)
                };
            })
        };
    };
    return RibbonMenuComponent;
}();




var $4454ae2cf42875e3$var$__assign = undefined && undefined.__assign || function() {
    $4454ae2cf42875e3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4454ae2cf42875e3$var$__assign.apply(this, arguments);
};
var $4454ae2cf42875e3$export$e95d4d8452a7885c = /** @class */ function() {
    function OverlayComponent(options) {
        var _this = this;
        this.closeIcon = {
            tag: "div",
            content: "\u2716" /*"🗙"*/ ,
            attr: {
                class: "overl-close-btn",
                click: function() {
                    _this.close();
                }
            }
        };
        this.options = $4454ae2cf42875e3$var$__assign({
            closeOnEscape: true,
            closeOnOverlayClick: true,
            showCloseButton: true,
            direction: "left",
            animate: true
        }, options);
        if (this.options.closeOnEscape) this.onKeydownEvent = document.addEventListener("keydown", function(args) {
            if (args.keyCode === 27) _this.close();
        });
    }
    OverlayComponent.show = function(options) {
        var container = document.createElement("div");
        document.body.appendChild(container);
        var oldRenderer = (0, $83d498fca38a60e6$export$8beec2e5b8623754).lastCreatedRenderer;
        var oldLastDlg = OverlayComponent.lastRenderedDlg;
        var renderer = new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(container, oldRenderer != null);
        if (oldRenderer != null) (0, $83d498fca38a60e6$export$8beec2e5b8623754).lastCreatedRenderer = renderer;
        var o = $4454ae2cf42875e3$var$__assign({}, options);
        o.onClose = function() {
            if (options.onClose) {
                if (options.onClose() === false) return;
            }
            document.body.removeChild(container);
            (0, $83d498fca38a60e6$export$8beec2e5b8623754).lastCreatedRenderer = oldRenderer;
            if (oldRenderer != null) oldRenderer.refresh();
            OverlayComponent.lastRenderedDlg = oldLastDlg;
        };
        var dlg = new OverlayComponent(o);
        OverlayComponent.lastRenderedDlg = dlg;
        renderer.render(dlg);
        return dlg;
    };
    OverlayComponent.prototype.close = function() {
        if (this.options.onClose) {
            if (this.options.onClose() === false) return;
        }
        // this.overlay.style.display = "none";
        if (this.onKeydownEvent != null) document.removeEventListener("keydown", this.onKeydownEvent);
    };
    OverlayComponent.prototype.onCreate = function(node) {
        var bodyDom = node.dom.querySelector(".overl-body");
        if (bodyDom != null) {
            if (this.options.direction === "left") {
                node.dom.style.width = this.options.size;
                if (this.options.animate) {
                    var realWidth = bodyDom.getBoundingClientRect().width;
                    node.dom.style.left = -realWidth + "px";
                    (0, $83d498fca38a60e6$export$8beec2e5b8623754).animate(node, {
                        attr: "left",
                        from: -realWidth + "px",
                        to: "0px",
                        duration: 500,
                        easing: "easeOutSine"
                    });
                }
            } else {
                node.dom.style.height = this.options.size;
                if (this.options.animate) {
                    var realHeight = bodyDom.getBoundingClientRect().height;
                    node.dom.style.top = -realHeight + "px";
                    (0, $83d498fca38a60e6$export$8beec2e5b8623754).animate(node, {
                        attr: "top",
                        from: -realHeight + "px",
                        to: "0px",
                        duration: 500,
                        easing: "easeOutSine"
                    });
                }
            }
        } else console.error("overl-body class not found");
    };
    OverlayComponent.prototype.render = function() {
        var _this = this;
        var body = this.toNode(this.options.content);
        // let styleW = "";
        // let styleH = "";
        // if (this.options.width != null) {
        //     styleW += "width:" + this.options.width + ";";
        // }
        // if (this.options.minWidth != null) {
        //     styleW += "min-width:" + this.options.minWidth + ";";
        // }
        // if (this.options.maxWidth != null) {
        //     styleW += "max-width:" + this.options.maxWidth + ";";
        // }
        // if (this.options.height != null) {
        //     styleH += "height:" + this.options.height + ";";
        // }
        // if (this.options.minHeight != null) {
        //     styleH += "min-height:" + this.options.minHeight + ";";
        // }
        // if (this.options.maxHeight != null) {
        //     styleH += "max-height:" + this.options.maxHeight + ";";
        // }
        // const headerStyle = this.options.allowMove ? "cursor:move" : undefined;
        return {
            tag: "div",
            attr: {
                class: "jsl-overlay-overlay",
                click: function(e) {
                    if (_this.options.closeOnOverlayClick && e.target.classList.contains("jsl-overlay-overlay")) _this.close();
                },
                wheel: function(e) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
            },
            children: [
                {
                    tag: "div",
                    attr: {
                        class: "overl-body-" + this.options.direction + " overl-body " + (this.options.class || ""),
                        style: this.options.style
                    },
                    children: [
                        {
                            tag: "div",
                            attr: {
                                class: "overl-header"
                            },
                            children: this.options.showCloseButton ? [
                                this.closeIcon
                            ] : []
                        },
                        body
                    ]
                }
            ]
        };
    };
    OverlayComponent.prototype.toNode = function(content) {
        if (typeof content === "string") return {
            tag: "div",
            content: content
        };
        return content;
    };
    return OverlayComponent;
}();




var $125d1ceb57662f9a$exports = {};

$125d1ceb57662f9a$exports = (parcelRequire("81tj9"));


function $f3d7bca1b355a7b4$export$2c456d3202acb568(data) {
    if (typeof data !== "string") for(let key in data){
        if (data[key] && typeof data[key] === "object") data[key] = $f3d7bca1b355a7b4$export$2c456d3202acb568(data[key]);
        else if (data[key] && $f3d7bca1b355a7b4$var$dateISO.test(data[key].toString())) {
            let x = Date.fromString(data[key]);
            data[key] = new Date(x.getTime() + x.getTimezoneOffset() * 60000);
        }
    }
    return data;
}
var $f3d7bca1b355a7b4$var$dateISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*/i;
(function() {
    var d = window.Date;
    var regexIso8601 = /^(\d{4})-(\d{2})-(\d{2})((T)(\d{2}):(\d{2})(:(\d{2})(\.\d*)?)?)?(Z)?$/;
    d._myparse = function(v) {
        if (v.charAt(v.length - 1) !== "Z") v += "Z";
        var m = regexIso8601.exec(v);
        if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt(+m[10] * 1000) || 0));
        return d.parse.apply(this, arguments);
    };
    d.fromString = function(v) {
        return d._myparse(v);
    };
})();


function $ed995c3feec4175b$var$mapUrl(url) {
    return _root_url + url;
}
class $ed995c3feec4175b$export$e0c8ff32d779851f {
    static async GetReperaturstatus(token) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/GetReperaturstatus"), {
            token: token
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async GetNewDownloadImage(artikelnummer) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/GetNewDownloadImage"), {
            artikelnummer: artikelnummer
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async SetKVABedingung(decision, proposid, kva_option, Token, user_kto) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/SetKVABedingung"), {
            decision: decision,
            proposid: proposid,
            kva_option: kva_option,
            Token: Token,
            user_kto: user_kto
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async AddComment(ProPosID, comment, Token) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/AddComment"), {
            ProPosID: ProPosID,
            comment: comment,
            Token: Token
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async SearchTokenAfterProjektPosAndPLZ(projektposid, plz) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/SearchTokenAfterProjektPosAndPLZ"), {
            projektposid: projektposid,
            plz: plz
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async GetFilesToProjektPosID(ProjektPosId, token) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/GetFilesToProjektPosID"), {
            ProjektPosId: ProjektPosId,
            token: token
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async CheckZKDVorkassaForKVARechnung(kto, token) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/CheckZKDVorkassaForKVARechnung"), {
            kto: kto,
            token: token
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async GetHaendler() {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/GetHaendler"), {});
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async Dummy() {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/Dummy"), {});
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async Dummy1() {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($ed995c3feec4175b$var$mapUrl("Ajax/Dummy1"), {});
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
}



class $eedeb63e9324d300$export$88d4154653f6832e {
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            class: "contact-box"
        }, /*#__PURE__*/ React.createElement("table", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, "Website:"), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("a", {
            href: "https://nivona.com",
            alt: ""
        }, "nivona.com"))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, "EMail:"), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("a", {
            href: "mailto:service@nivona.com",
            alt: ""
        }, "service@nivona.com"))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, "Telefonnummer:"), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("a", {
            href: "tel:0911-252663 - 90",
            alt: ""
        }, "0911-252663 - 90"))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", {
            colspan: "2",
            style: "text-align:center"
        }, "(Mo-Fr 8:00 - 17:00 Uhr)"))));
    }
}



class $2a52b400a362c5e5$export$ad96b2d0e7eb81f {
    constructor(){
        this.projektPosId = "";
        this.plz = "";
        this.init();
    }
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            class: "main-comp"
        }, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("form", null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h1", null, "Auftragssuche nach Service-ID und Postleitzahl")), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
                /*#__PURE__*/ React.createElement("label", null, "Service-ID: "),
                /*#__PURE__*/ React.createElement("div", null, this.projektPosField)
            ], {
                sizes: [
                    "15%",
                    "20%"
                ],
                responsive: true,
                class: "panel-comp"
            }), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
                /*#__PURE__*/ React.createElement("label", null, "Postleitzahl: "),
                /*#__PURE__*/ React.createElement("div", null, this.plzField)
            ], {
                sizes: [
                    "15%",
                    "20%"
                ],
                responsive: true,
                class: "panel-comp"
            }), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
                /*#__PURE__*/ React.createElement("div", null),
                /*#__PURE__*/ React.createElement("button", {
                    style: "submit",
                    click: (e)=>{
                        e.preventDefault();
                        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).SearchTokenAfterProjektPosAndPLZ(this.projektPosId, this.plz).then((token)=>{
                            if (token && token !== "-") // console.log(token);
                            (0, $0c412a07a28a0d02$export$f6ff04b41b36f7bc).navigate("status/" + token);
                            else this.showErrorDialog(); //alert("Es konnte kein Eintrag zu den angegebenen Daten gefunden werden!");    
                        }).catch((error)=>{
                            this.showErrorDialog(); //alert("Es konnte kein Eintrag zu den angegebenen Daten gefunden werden!");
                        });
                    }
                }, "Suche")
            ], {
                sizes: [
                    "15%",
                    "20%"
                ],
                responsive: true,
                class: "panel-comp"
            })),
            /*#__PURE__*/ React.createElement("div", {
                class: "contact-comp"
            }, new (0, $eedeb63e9324d300$export$88d4154653f6832e)())
        ], {
            sizes: [
                "45%",
                "42%"
            ],
            responsive: true,
            class: "panel-comp"
        }));
    }
    init() {
        this.plzField = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            value: this.plz + "",
            type: "input",
            placeholder: "Postleitzahl",
            onChange: (value)=>{
                this.plz = value;
                const n = +this.plz;
                if (isNaN(n)) {
                    this.plz = "";
                    alert("Keine g\xfcltige Postleitzahl");
                    this.plzField.setValue(this.plz);
                }
            }
        });
        this.projektPosField = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            value: this.projektPosId,
            type: "input",
            placeholder: "Service-ID",
            onChange: (value)=>{
                this.projektPosId = value;
                const n = +this.projektPosId;
                if (isNaN(n)) {
                    this.projektPosId = "";
                    alert("Keine g\xfcltige Postleitzahl");
                    this.projektPosField.setValue(this.projektPosId);
                }
            }
        });
    }
    showErrorDialog() {
        (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
            header: "Fehler",
            content: /*#__PURE__*/ React.createElement("div", null, "Es konnte kein Eintrag zu den angegebenen Daten gefunden werden!"),
            footer: (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok(),
            // height: "5rem",
            maxWidth: "50rem",
            width: "75vw"
        });
    }
}







function $fb350c3721d80fcd$export$791c4e50320e809e(url) {
    return _root_url + url;
}



class $cd0cd22f4ce6ec31$export$2ed33cce1e9a2709 {
    // private partedMatchcode: string;
    constructor(objektInfo){
        this.objektInfo = objektInfo;
    // this.partedMatchcode = objektInfo.Objekt.ArtMatchcode?.replace("Vollautomat", "") + "(PNG)";
    // console.log(this.objektInfo.Objekt?.Artikelnummer);
    // console.log(mapUrl("Ajax/GetNewDownloadImage?artikelnummer=" + this.objektInfo.Objekt?.Artikelnummer));
    }
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            class: "info-box",
            id: "machine-info",
            style: "text-align:center;"
        }, /*#__PURE__*/ React.createElement("div", {
            style: "text-align:left"
        }, /*#__PURE__*/ React.createElement("div", {
            class: "norm-info"
        }, "Ihr Ger\xe4t mit der Seriennummer: ", this.objektInfo.Objekt?.Seriennummer), /*#__PURE__*/ React.createElement("div", {
            class: "norm-info"
        }, "Ihre Service-ID: ", this.objektInfo.ProjektePositionen?.ProjektPosID), /*#__PURE__*/ React.createElement("div", {
            class: "norm-info"
        }, "Ihr Modell: ", this.objektInfo.Objekt?.ArtMatchcode)), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetNewDownloadImage?artikelnummer=" + this.objektInfo.Objekt?.Artikelnummer),
                style: "max-width:95%;max-height:18rem;"
            })),
            new (0, $eedeb63e9324d300$export$88d4154653f6832e)()
        ], {
            sizes: [
                "40%",
                "60%"
            ],
            responsive: true,
            valign: "center"
        }), this.objektInfo.VerpackungsBild ? /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
            style: "height:9rem",
            src: this.objektInfo.VerpackungsBild,
            alt: "Verpackungsinformation"
        })) : undefined, this.objektInfo.VerpackungsLink ? /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("a", {
            href: this.objektInfo.VerpackungsLink,
            target: "_blank"
        }, "Youtube Video")) : undefined);
    }
}






class $a356dde23eb6c2f6$export$65db35c377fab04b {
    constructor(message){
        this.message = "Es tut uns leid, ein Fehler ist aufgetreten. Bitte versuchen Sie es in einigen Minuten erneut.";
        if (message != null && message !== "") this.message = message;
    }
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            class: "error-comp"
        }, /*#__PURE__*/ React.createElement("div", {
            class: "info-box",
            id: "error-message"
        }, /*#__PURE__*/ React.createElement("p", null, this.message)), /*#__PURE__*/ React.createElement("div", {
            class: "center"
        }, /*#__PURE__*/ React.createElement("img", {
            src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/images/smiley.png"),
            style: "height:12rem"
        })), /*#__PURE__*/ React.createElement("div", {
            class: "info-box"
        }, new (0, $eedeb63e9324d300$export$88d4154653f6832e)()));
    }
}







var $80619c09a94b56b7$export$f6f58ebd4483bea = /*#__PURE__*/ function(RepStatusEnum) {
    RepStatusEnum[RepStatusEnum["Neu"] = 100] = "Neu";
    RepStatusEnum[RepStatusEnum["EndkundeAngemeldet"] = 180] = "EndkundeAngemeldet";
    RepStatusEnum[RepStatusEnum["EndkundeAngemeldetLeerkarton"] = 185] = "EndkundeAngemeldetLeerkarton";
    RepStatusEnum[RepStatusEnum["LeerkartonAngefordert"] = 195] = "LeerkartonAngefordert";
    RepStatusEnum[RepStatusEnum["Leerkarton"] = 200] = "Leerkarton";
    RepStatusEnum[RepStatusEnum["EinsendeetikettGesendetAngefordert"] = 205] = "EinsendeetikettGesendetAngefordert";
    RepStatusEnum[RepStatusEnum["EinsendeetikettGesendet"] = 210] = "EinsendeetikettGesendet";
    RepStatusEnum[RepStatusEnum["Zulauf"] = 290] = "Zulauf";
    RepStatusEnum[RepStatusEnum["Eingelagert"] = 299] = "Eingelagert";
    RepStatusEnum[RepStatusEnum["Wareneingang"] = 300] = "Wareneingang";
    RepStatusEnum[RepStatusEnum["KVANeuErstellen"] = 305] = "KVANeuErstellen";
    RepStatusEnum[RepStatusEnum["HotlineGeparkt"] = 310] = "HotlineGeparkt";
    RepStatusEnum[RepStatusEnum["InPruefung"] = 320] = "InPruefung";
    RepStatusEnum[RepStatusEnum["KaufbelegFreigeben"] = 325] = "KaufbelegFreigeben";
    RepStatusEnum[RepStatusEnum["LagerGeparktKVA"] = 400] = "LagerGeparktKVA";
    RepStatusEnum[RepStatusEnum["KVAGesendet"] = 410] = "KVAGesendet";
    RepStatusEnum[RepStatusEnum["RechnungAnfordern"] = 420] = "RechnungAnfordern";
    RepStatusEnum[RepStatusEnum["ZKD_Vorrauskassa"] = 430] = "ZKD_Vorrauskassa";
    RepStatusEnum[RepStatusEnum["KeineR\xfcckmeldungKVA1"] = 440] = "KeineR\xfcckmeldungKVA1";
    RepStatusEnum[RepStatusEnum["KeineR\xfcckmeldungKVA2"] = 441] = "KeineR\xfcckmeldungKVA2";
    RepStatusEnum[RepStatusEnum["Nachforschung"] = 450] = "Nachforschung";
    RepStatusEnum[RepStatusEnum["LagerWarteschlange"] = 500] = "LagerWarteschlange";
    RepStatusEnum[RepStatusEnum["WartenAufMeister"] = 501] = "WartenAufMeister";
    RepStatusEnum[RepStatusEnum["Reperatur"] = 600] = "Reperatur";
    RepStatusEnum[RepStatusEnum["Ruecklaeufer"] = 700] = "Ruecklaeufer";
    RepStatusEnum[RepStatusEnum["RueckgestelltSP"] = 790] = "RueckgestelltSP";
    RepStatusEnum[RepStatusEnum["Abgeschlossen"] = 800] = "Abgeschlossen";
    RepStatusEnum[RepStatusEnum["AbgeschlossenUnerledigtRetour"] = 810] = "AbgeschlossenUnerledigtRetour";
    RepStatusEnum[RepStatusEnum["AbgeschlossenVerschrotten"] = 820] = "AbgeschlossenVerschrotten";
    RepStatusEnum[RepStatusEnum["AbgeschlossenSPUngepr\xfcft"] = 850] = "AbgeschlossenSPUngepr\xfcft";
    RepStatusEnum[RepStatusEnum["Archiviert"] = 901] = "Archiviert";
    return RepStatusEnum;
}({});


class $61f45555e47b0735$export$88cc75586c36ad22 {
    constructor(statusText, projektepositionen, token){
        this.statusText = statusText;
        this.projektepositionen = projektepositionen;
        this.token = token;
        this.isLoading = false;
        this.isAllowedToAcceptKVA = false;
        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).CheckZKDVorkassaForKVARechnung(this.projektepositionen.USER_KTO, this.token).then((val)=>{
            this.isAllowedToAcceptKVA = !val;
            //   console.log(this.isAllowedToAcceptKVA);
            //   this.isAllowedToAcceptKVA = false;
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        }).catch((error)=>{
            console.log(error);
        });
    }
    render() {
        if (this.isLoading) return new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)().render();
        let kva_anzeige = "";
        let rep_status_anzeige = "";
        let rep_vorkassa_rechnung_anzeige = "";
        let img_anzeige = "";
        // this.projektepositionen.USER_RechnungBelid = 10000008;
        // this.projektepositionen.USER_KVABelid = 10000008;
        //console.log(this.projektepositionen.USER_RepStatus);c
        //console.log(this.projektepositionen.USER_RechnungBelid);
        if (this.projektepositionen.USER_RepStatus === 410 /*&& this.projektepositionen.USER_KVABelid*/ ) {
            //console.log("yes");
            img_anzeige = /*#__PURE__*/ React.createElement("a", {
                target: "_blank",
                href: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetKVA?ProPosId=" + this.projektepositionen.ProjektPosID + "&BelegId=" + this.projektepositionen.USER_KVABelid + "&Token=" + this.token),
                style: "vertical-align: middle;"
            }, /*#__PURE__*/ React.createElement("img", {
                class: "download-icon",
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Download")
            }));
            kva_anzeige = this.isAllowedToAcceptKVA ? /*#__PURE__*/ React.createElement("div", {
                class: "info-box",
                id: "akt-status",
                style: "background:rgb(240,240,240)"
            }, /*#__PURE__*/ React.createElement("div", {
                class: "sub-heading"
            }, /*#__PURE__*/ React.createElement("span", {
                style: "font-weight:bold"
            }, "Wie m\xf6chten Sie fortfahren?")), /*#__PURE__*/ React.createElement("form", {
                name: "kva",
                id: "radio-container"
            }, /*#__PURE__*/ React.createElement("label", {
                class: "radio"
            }, /*#__PURE__*/ React.createElement("span", {
                class: "radio_input"
            }, /*#__PURE__*/ React.createElement("input", {
                type: "radio",
                id: "kva_yes",
                name: "kva_decision",
                value: "yes",
                change: ()=>(0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)()
            }), /*#__PURE__*/ React.createElement("span", {
                class: "radio_control"
            })), /*#__PURE__*/ React.createElement("span", {
                class: "radio_label",
                for: "kva_yes"
            }, " Kostenvoranschlag ", /*#__PURE__*/ React.createElement("span", {
                style: "color: green; font-weight: bold"
            }, "akzeptieren"), " (Ger\xe4t wird laut Kostenvoranschlag repariert und zur\xfcckgesendet)")), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("label", {
                class: "radio"
            }, /*#__PURE__*/ React.createElement("span", {
                class: "radio_input"
            }, /*#__PURE__*/ React.createElement("input", {
                type: "radio",
                id: "kva_no",
                name: "kva_decision",
                value: "no",
                change: ()=>(0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)()
            }), /*#__PURE__*/ React.createElement("span", {
                class: "radio_control"
            }, " ")), /*#__PURE__*/ React.createElement("span", {
                class: "radio_label",
                for: "kva_no"
            }, " Kostenvoranschlag ", /*#__PURE__*/ React.createElement("span", {
                style: "color: red; font-weight: bold"
            }, "ablehnen"), " (M\xf6glichkeit der R\xfccksendung oder Verschrottung)"))), /*#__PURE__*/ React.createElement("p", {
                style: "text-align:center"
            }, /*#__PURE__*/ React.createElement("button", {
                class: "jsl-button",
                disabled: document.forms.kva?.kva_decision.value ? undefined : "disabled",
                click: ()=>{
                    const form = document.forms.kva;
                    const valueAsString = form.elements.kva_decision.value;
                    if (!valueAsString) {
                        alert("Bitte ja oder nein ausw\xe4hlen");
                        return;
                    }
                    const value = valueAsString === "yes";
                    if (value) {
                        this.isLoading = true;
                        (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
                        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).SetKVABedingung(value, this.projektepositionen.ProjektPosID, (0, $80619c09a94b56b7$export$f6f58ebd4483bea).Reperatur, this.token, this.projektepositionen.USER_KTO).then((kvaIsSet)=>{
                            if (kvaIsSet) // location.reload();
                            (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
                                modal: true,
                                allowResize: true,
                                header: "Kostenvoranschlag akzeptiert",
                                footer: (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok(),
                                content: "Sie erhalten in K\xfcrze eine Best\xe4tigung per E-Mail! Vielen Dank!",
                                maxWidth: "400px"
                            });
                            else {
                                this.isLoading = false;
                                (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
                                alert("Akzeptieren des Kostenvoranschlags hat nicht funktioniert!");
                            }
                        }).catch((error)=>{
                            this.isLoading = false;
                            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
                            alert("ERROR: Kostenvoranschlag konnte nicht akzeptiert werden");
                        });
                    } else this.showAbgeschlossenDialog(value);
                }
            }, "Auswahl annehmen"))) : /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("span", null, "Kontaktiere Sie bitte die Hotline!"));
        } else if ((this.projektepositionen.USER_RepStatus === 790 || this.projektepositionen.USER_RepStatus === 800) && this.projektepositionen.USER_RechnungBelid) {
            img_anzeige = /*#__PURE__*/ React.createElement("a", {
                href: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetRechnung?ProPosId=" + this.projektepositionen.ProjektPosID + "&BelegId=" + this.projektepositionen.USER_RechnungBelid + "&Token=" + this.token),
                target: "_blank",
                style: "vertical-align: middle"
            }, /*#__PURE__*/ React.createElement("img", {
                class: "download-icon",
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Download")
            }));
            rep_status_anzeige = /*#__PURE__*/ React.createElement("div", null, img_anzeige, /*#__PURE__*/ React.createElement("label", {
                style: "padding-left: 0.5rem"
            }, this.projektepositionen.USER_RepArt === 30 && !this.projektepositionen.USER_RENummerPREKassa ? "Rechnung herunterladen" : "Reparaturbericht herunterladen"));
        }
        if (this.projektepositionen.USER_RENummerPREKassa) rep_vorkassa_rechnung_anzeige = /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("a", {
            href: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetRechnung?ProPosId=" + this.projektepositionen.ProjektPosID + "&BelegId=" + this.projektepositionen.USER_RENummerPREKassa + "&Token=" + this.token),
            target: "_blank",
            style: "vertical-align: middle"
        }, /*#__PURE__*/ React.createElement("img", {
            class: "download-icon",
            src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Download")
        })), /*#__PURE__*/ React.createElement("label", {
            style: "padding-left: 0.5rem"
        }, "Rechnung herunterladen"));
        return /*#__PURE__*/ React.createElement("div", {
            class: "status-info"
        }, /*#__PURE__*/ React.createElement("span", {
            style: "text-align: left; font-size: 20px; font-weight: normal;"
        }, "Ihr Ger\xe4t befindet sich derzeit im Status:", /*#__PURE__*/ React.createElement("span", {
            style: "font-weight: bold; padding-left: 0.5rem; padding-right: 0.5rem"
        }, this.statusText)), kva_anzeige, rep_vorkassa_rechnung_anzeige, rep_status_anzeige ? "" : img_anzeige, rep_status_anzeige);
    }
    showAbgeschlossenDialog(value) {
        const selectComp = new (0, $92830e10ec4ab123$export$c006741a65b06687)({
            data: [
                {
                    value: 810,
                    text: "Unrepariert retour"
                },
                {
                    value: 820,
                    text: "Verschrottung"
                }
            ],
            style: "max-width:80vw;width:20rem",
            enableSearch: false,
            focusFirstItem: true
        });
        (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
            modal: true,
            header: "Eine M\xf6glichkeit ausw\xe4hlen",
            minWidth: "20rem",
            maxWidth: "40rem",
            footer: /*#__PURE__*/ React.createElement("div", null, (0, $a5215e39a2de1874$export$24ec15341293d56f).Cancel(), (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok(()=>{
                this.isVerschrotten = selectComp.getValue() === (0, $80619c09a94b56b7$export$f6f58ebd4483bea).AbgeschlossenVerschrotten;
                if (this.isVerschrotten) (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
                    modal: true,
                    header: "Verschrottung",
                    minWidth: "25rem",
                    footer: /*#__PURE__*/ React.createElement("div", null, (0, $a5215e39a2de1874$export$24ec15341293d56f).Cancel(), (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok(()=>{
                        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).SetKVABedingung(value, this.projektepositionen.ProjektPosID, (0, $80619c09a94b56b7$export$f6f58ebd4483bea).AbgeschlossenVerschrotten, this.token, this.projektepositionen.USER_KTO).then((kvaIsSet)=>{
                            // console.log(kvaIsSet);
                            if (kvaIsSet) location.reload();
                            else alert("KVA ablehnen hat nicht funktioniert!");
                        });
                    })),
                    content: /*#__PURE__*/ React.createElement("div", null, "M\xf6chten Sie mit der ", /*#__PURE__*/ React.createElement("span", {
                        style: "color: red; font-weight: bold"
                    }, "Verschrottung"), " der Maschine wirklich fortfahren?")
                });
                else (0, $ed995c3feec4175b$export$e0c8ff32d779851f).SetKVABedingung(value, this.projektepositionen.ProjektPosID, (0, $80619c09a94b56b7$export$f6f58ebd4483bea).AbgeschlossenUnerledigtRetour, this.token, this.projektepositionen.USER_KTO).then((kvaIsSet)=>{
                    // console.log(kvaIsSet);
                    if (kvaIsSet) location.reload();
                    else alert("KVA ablehnen hat nicht funktioniert!");
                });
                return false;
            })),
            content: /*#__PURE__*/ React.createElement("div", null, selectComp)
        });
    }
}




var $470bf0e1b200d2af$export$ebc69b971ca4e526 = /*#__PURE__*/ function(NivEventStatus) {
    NivEventStatus[NivEventStatus["Done"] = 0] = "Done";
    NivEventStatus[NivEventStatus["inProgress"] = 1] = "inProgress";
    return NivEventStatus;
}({});



var $a09e14cca412b416$export$bbc7b2b1507dd245 = /*#__PURE__*/ function(LogistikanbieterEnum) {
    LogistikanbieterEnum[LogistikanbieterEnum["Abholung"] = 0] = "Abholung";
    LogistikanbieterEnum[LogistikanbieterEnum["DPD"] = 10] = "DPD";
    LogistikanbieterEnum[LogistikanbieterEnum["DHL"] = 20] = "DHL";
    LogistikanbieterEnum[LogistikanbieterEnum["Post"] = 40] = "Post";
    return LogistikanbieterEnum;
}({});


function $b9d55af760e9069c$export$e3c9b97a93628279(packageNo, anbieter) {
    if (anbieter === (0, $a09e14cca412b416$export$bbc7b2b1507dd245).DHL) return /*#__PURE__*/ React.createElement("div", {
        class: "tracking"
    }, /*#__PURE__*/ React.createElement("span", null, "Tracking: "), /*#__PURE__*/ React.createElement("a", {
        href: "https://www.dhl.de/de/privatkunden/dhl-sendungsverfolgung.html?piececode=" + packageNo,
        target: "_blank"
    }, packageNo));
    else if (anbieter === (0, $a09e14cca412b416$export$bbc7b2b1507dd245).DPD) return /*#__PURE__*/ React.createElement("div", {
        class: "tracking"
    }, /*#__PURE__*/ React.createElement("span", null, "Tracking: "), /*#__PURE__*/ React.createElement("a", {
        href: "https://my.dpd.de/myParcel.aspx?parcelno=" + packageNo,
        target: "_blank"
    }, packageNo));
    return /*#__PURE__*/ React.createElement("div", {
        class: "tracking"
    }, packageNo);
}


class $22756eb02ab2c686$export$59dbeb50b6fba760 {
    constructor(entry, index){
        this.entry = entry;
        this.index = index;
        this.State = {
            animationDone: false
        };
    }
    render() {
        let animation = {
            attr: "left",
            from: "-110%",
            to: "0%",
            duration: 500,
            delay: 200 * this.index,
            easing: "easeOutExpo"
        };
        if (this.State.animationDone) animation = null;
        if (this.entry.Status === (0, $470bf0e1b200d2af$export$ebc69b971ca4e526).Done) return this.getStackPanelWithImage("Content/images/ticck.png", animation);
        else return this.getStackPanelWithImage("Content/images/hourglass.png", animation, [
            235,
            235,
            235
        ]);
    }
    onCreate() {
        // if (this.animate) {
        this.State.animationDone = true;
    // }
    }
    getStackPanelWithImage(url, animation, background) {
        let dateString = "";
        if ((0, $f697fe55e25cf9d4$export$324d90190a8b822a).format(this.entry.Occured) !== "") dateString += (0, $f697fe55e25cf9d4$export$324d90190a8b822a).format(this.entry.Occured);
        let backgroundString = "";
        if (background !== undefined) backgroundString = "background:rgb(" + background[0] + ", " + background[1] + ", " + background[2] + ")";
        else backgroundString = "";
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                left: animation ? "-110%" : "0%",
                position: "relative"
            },
            animation: animation
        }, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("div", {
                class: "status-entry-info"
            }, /*#__PURE__*/ React.createElement("img", {
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)(url),
                style: "max-width:2.2rem; max-height: 2.2rem;"
            })),
            /*#__PURE__*/ React.createElement("div", {
                class: "info-box status-entry-info",
                style: backgroundString
            }, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
                /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", null, this.entry.Text), this.entry.PaketNr ? (0, $b9d55af760e9069c$export$e3c9b97a93628279)(this.entry.PaketNr, this.entry.Logistikanbieter) : undefined),
                /*#__PURE__*/ React.createElement("div", null, dateString)
            ], {
                valign: "top",
                sizes: [
                    undefined,
                    "*"
                ]
            }))
        ], {
            responsive: false,
            sizes: [
                "*"
            ],
            valign: "center"
        }));
    }
}


class $ba9f541b620e5ffb$export$d71560eb52d5398a {
    // public showAnimation: boolean;
    constructor(entries){
        this.entries = entries;
    }
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            class: "status-info"
        }, this.entries.map((item, idx)=>new (0, $22756eb02ab2c686$export$59dbeb50b6fba760)(item, idx)));
    }
}









class $ac35f7b4e0ed9e8e$export$c6861759eaf17d6d {
    constructor(Objekt, ProjektePositionen, token){
        this.Objekt = Objekt;
        this.ProjektePositionen = ProjektePositionen;
        this.token = token;
        this.fileNames = [];
        this.oldFiles = [];
        this.fileCount = 0;
        this.content = /*#__PURE__*/ React.createElement("div", null);
        this.textarea_content = "";
        this.allowedExtensions = ".jpg, .jpeg, .png, .mp4, .mov";
        this.isLoading = false;
        this.init();
    }
    render() {
        const maxDateigroesse = "max. 300MB";
        return !this.isLoading ? /*#__PURE__*/ React.createElement("div", {
            class: "file-upload-comp"
        }, /*#__PURE__*/ React.createElement("table", {
            class: "box-input"
        }, /*#__PURE__*/ React.createElement("tr", null, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("td", {
                style: "text-align: left"
            }, /*#__PURE__*/ React.createElement("label", {
                for: "file"
            }, /*#__PURE__*/ React.createElement("strong", null, "W\xe4hle eine Datei aus: "), /*#__PURE__*/ React.createElement("div", {
                style: "font-size: 0.9em;text-align: center"
            }, this.allowedExtensions, " - ", maxDateigroesse))),
            /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("input", {
                type: "file",
                id: "filesToUpload",
                style: "position: absolute; top: -10000px;",
                multiple: true,
                change: (e, node)=>{
                    const el = node.dom;
                    this.fileNames = [];
                    for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                    this.fileCount = el.files.length;
                }
            }), /*#__PURE__*/ React.createElement("button", {
                class: this.fileCount > 0 ? "has-files jsl-button" : "jsl-button",
                dragenter: (e)=>{
                    e.preventDefault();
                    e.target.classList.add("drag-over");
                },
                dragover: (e)=>e.preventDefault(),
                dragleave: (e)=>{
                    e.preventDefault();
                    e.target.classList.remove("drag-over");
                },
                drop: (e)=>{
                    e.preventDefault();
                    e.target.classList.remove("drag-over");
                    const droppedFiles = e.dataTransfer?.files;
                    if (droppedFiles != null) {
                        const el = document.querySelector("#filesToUpload");
                        el.files = droppedFiles;
                        this.fileNames = [];
                        for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                        this.fileCount = el.files.length;
                    } else {
                        this.fileNames = [];
                        this.fileCount = 0;
                    }
                },
                click: ()=>{
                    const el = document.querySelector("#filesToUpload");
                    el.click();
                }
            }, "Datei ausw\xe4hlen / drag & drop"), /*#__PURE__*/ React.createElement("span", {
                id: "file-count",
                style: "padding-left: 0.7vw"
            }, "(", this.fileCount, ")"), /*#__PURE__*/ React.createElement("br", null), this.oldFiles == undefined ? /*#__PURE__*/ React.createElement("ul", null) : /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h3", null, "Uploaded Files"), /*#__PURE__*/ React.createElement("ul", {
                class: "data-list"
            }, this.oldFiles.map((file)=>/*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("span", {
                    style: "min-height: 1.5rem;"
                }, /*#__PURE__*/ React.createElement("img", {
                    style: "max-height: 1.2rem; padding-right: 0.5rem;",
                    src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Datei")
                }), /*#__PURE__*/ React.createElement("span", null, file)))))), this.fileNames == undefined || this.fileCount == 0 ? /*#__PURE__*/ React.createElement("div", null) : /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h3", null, "New Files"), /*#__PURE__*/ React.createElement("ul", {
                class: "data-list"
            }, this.fileNames.map((f)=>/*#__PURE__*/ React.createElement("li", null, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
                    /*#__PURE__*/ React.createElement("span", {
                        style: "min-height: 1.5rem;"
                    }, /*#__PURE__*/ React.createElement("img", {
                        style: "max-height: 1.2rem; padding-right: 0.5rem;",
                        src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Datei")
                    }), /*#__PURE__*/ React.createElement("span", {
                        style: "max-width: 9.5rem; overflow: hidden; display: inline-block;"
                    }, f)),
                    /*#__PURE__*/ React.createElement("div", {
                        class: "click-delete",
                        click: ()=>{
                            const dt = new DataTransfer();
                            this.fileNames = [];
                            const el = document.querySelector("#filesToUpload");
                            const files = el.files;
                            for(let i = 0; i < files.length; i++)if (files[i].name !== f) {
                                dt.items.add(files[i]);
                                this.fileNames.push(files[i].name);
                            }
                            el.files = dt.files;
                            this.fileCount = el.files.length;
                        }
                    }, /*#__PURE__*/ React.createElement("img", {
                        style: "max-height: 1.2rem; padding-right: 0.5rem; padding-left: 0.5rem;",
                        src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Delete")
                    }))
                ], {
                    responsive: false,
                    sizes: [
                        "90%",
                        "*"
                    ]
                }))))))
        ], {
            responsive: true,
            sizes: [
                "30%",
                "*"
            ],
            style: "min-height: 5rem; max-height: 25rem; overflow: auto"
        })), /*#__PURE__*/ React.createElement("tr", {
            style: "height: 6rem"
        }, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("td", {
                style: "text-align: left"
            }, /*#__PURE__*/ React.createElement("label", {
                for: "comment_field"
            }, "Kommentare: ")),
            /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("textarea", {
                class: "txtarea",
                id: "comment_field",
                style: "font-size: 0.8em",
                rows: "10",
                cols: "60",
                form: "box",
                change: ()=>{
                    this.textarea_content = document.getElementById("comment_field").value;
                }
            }), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("button", {
                class: "jsl-button",
                style: "margin-top: 0.6rem;",
                click: async ()=>{
                    let content;
                    this.upload();
                }
            }, "Speichern"))
        ], {
            responsive: true,
            sizes: [
                "30%",
                "*"
            ]
        })))) : /*#__PURE__*/ React.createElement("div", null, new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)());
    }
    init() {
        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).GetFilesToProjektPosID(this.ProjektePositionen.ProjektPosID, this.token).then((values)=>{
            for (const val of values)this.oldFiles.push(val.SourceFile);
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        });
        (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
    }
    shiftLeft(files, startIdx, endIdx) {
        for(let i = startIdx; i < endIdx - 1; i++)files[i] = files[i + 1];
        files[endIdx - 1] = undefined;
    }
    async upload() {
        const el = document.querySelector("#filesToUpload");
        const files = el.files;
        let upload_successful = true;
        if (files.length > 0) {
            const imgformData = new FormData();
            for(let i = 0; i < files.length; i++)imgformData.append("files", files[i]);
            this.isLoading = true;
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
            await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post((0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/AddFiles?Objektnummer=") + this.Objekt.Objektnummer + "&ProPosID=" + this.ProjektePositionen.ProjektPosID + "&Token=" + this.token, imgformData, {}).then((result)=>{
                if (result.data && result.data === "OK") {
                    this.fileNames = [];
                    this.fileCount = 0;
                    (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
                    this.upload_worked();
                } else {
                    upload_successful = false;
                    this.content = /*#__PURE__*/ React.createElement("div", {
                        style: "min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center"
                    }, /*#__PURE__*/ React.createElement("img", {
                        style: "max-height: 1.5rem; max-height: 1.5rem",
                        src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Delete")
                    }), "\xa0Datei/en konnten", /*#__PURE__*/ React.createElement("span", {
                        style: "font-weight: bold; color: red"
                    }, " nicht "), "hochgeladen werden! Erlaubte Dateiendungen sind: ", this.allowedExtensions);
                    this.upload_failed();
                }
                this.isLoading = false;
                (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
            }).catch((e)=>{
                upload_successful = false;
                this.content = /*#__PURE__*/ React.createElement("div", {
                    style: "min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center"
                }, /*#__PURE__*/ React.createElement("img", {
                    style: "max-height: 1.5rem; max-height: 1.5rem",
                    src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Delete")
                }), "\xa0Datei/en konnten", /*#__PURE__*/ React.createElement("span", {
                    style: "font-weight: bold; color: red"
                }, " nicht "), "hochgeladen werden! Erlaubte Dateiendungen sind: ", this.allowedExtensions);
                this.upload_failed();
                this.isLoading = false;
                (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
            });
        } else {
            upload_successful = false;
            this.content = /*#__PURE__*/ React.createElement("div", {
                style: "min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center;"
            }, /*#__PURE__*/ React.createElement("div", {
                style: "margin: 0.4rem"
            }, /*#__PURE__*/ React.createElement("img", {
                style: "max-height: 1.5rem; max-height: 1.5rem; margin:auto",
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Delete")
            }), "\xa0Datei/en konnten", /*#__PURE__*/ React.createElement("span", {
                style: "font-weight: bold; color: red"
            }, " nicht "), "hochgeladen werden! "), /*#__PURE__*/ React.createElement("div", {
                style: "margin: 0.4rem"
            }, /*#__PURE__*/ React.createElement("strong", null, " Keine "), " Dateien ausgew\xe4hlt"));
            this.upload_failed();
        }
        if (this.textarea_content !== "" && upload_successful) (0, $ed995c3feec4175b$export$e0c8ff32d779851f).AddComment(this.ProjektePositionen.ProjektPosID, this.textarea_content, this.token).then(()=>{
            //result ?
            const doc = document.getElementById("comment_field");
            if (doc) doc.value = "";
            //   : alert("Kommentar konnte nicht gespeichert werden");
            this.textarea_content = "";
        }).catch((e)=>{
            console.log(e);
            alert("Error: Kommentar konnte nicht gespeichert werden");
        });
    }
    upload_worked() {
        // AjaxController.SetRepStatus(RepStatusEnum.KaufbelegFreigeben, this.ProjektePositionen.ProjektPosID).then(() => {
        (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
            content: /*#__PURE__*/ React.createElement("div", {
                style: "min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center"
            }, /*#__PURE__*/ React.createElement("img", {
                style: "max-height: 1.5rem; max-height: 1.5rem",
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Check")
            }), "\xa0Datei/en", /*#__PURE__*/ React.createElement("span", {
                style: "font-weight: bold; color: green"
            }, " erfolgreich "), "hochgeladen!"),
            footer: /*#__PURE__*/ React.createElement("div", null, (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok(()=>{
                location.reload();
            })),
            header: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("strong", null, "Upload erfolgreich")),
            maxHeight: "20vh",
            maxWidth: "85vw",
            minHeight: "5vh",
            minWidth: "20vw"
        });
    // });
    }
    upload_failed() {
        (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
            content: this.content,
            footer: /*#__PURE__*/ React.createElement("div", null, (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok(()=>{
            //location.reload();
            })),
            header: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("strong", null, "Upload nicht erfolgreich!")),
            maxHeight: "10rem",
            maxWidth: "30rem",
            minHeight: "6rem",
            minWidth: "20rem"
        });
    }
}









class $39beb69654dce46d$export$fc2dd8fab5efd204 {
    constructor(Objekt, ProjektePositionen, token){
        this.Objekt = Objekt;
        this.ProjektePositionen = ProjektePositionen;
        this.token = token;
        this.fileNames = [];
        this.fileCount = 0;
        this.content = /*#__PURE__*/ React.createElement("div", null);
        this.textarea_content = "";
        this.allowedExtensions = ".jpg, .jpeg, .png, .pdf";
    }
    render() {
        const maxDateigroesse = "max. 20MB";
        return /*#__PURE__*/ React.createElement("div", {
            class: "file-upload-comp"
        }, /*#__PURE__*/ React.createElement("table", {
            class: "box-input"
        }, /*#__PURE__*/ React.createElement("tr", null, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("td", {
                style: "text-align: left"
            }, /*#__PURE__*/ React.createElement("label", {
                for: "file"
            }, /*#__PURE__*/ React.createElement("strong", null, "W\xe4hle eine Datei aus: "), /*#__PURE__*/ React.createElement("div", {
                style: "font-size: 0.9em;text-align: center"
            }, this.allowedExtensions, " - ", maxDateigroesse))),
            /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("input", {
                type: "file",
                id: "filesToUpload",
                style: "position: absolute; top: -10000px;",
                multiple: true,
                change: (e, node)=>{
                    const el = node.dom;
                    this.fileNames = [];
                    for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                    this.fileCount = el.files.length;
                }
            }), /*#__PURE__*/ React.createElement("button", {
                class: this.fileCount > 0 ? "has-files jsl-button" : "jsl-button",
                dragenter: (e)=>{
                    e.preventDefault();
                    e.target.classList.add("drag-over");
                },
                dragover: (e)=>e.preventDefault(),
                dragleave: (e)=>{
                    e.preventDefault();
                    e.target.classList.remove("drag-over");
                },
                drop: (e)=>{
                    e.preventDefault();
                    e.target.classList.remove("drag-over");
                    const droppedFiles = e.dataTransfer?.files;
                    if (droppedFiles != null) {
                        const el = document.querySelector("#filesToUpload");
                        el.files = droppedFiles;
                        this.fileNames = [];
                        for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                        this.fileCount = el.files.length;
                    } else {
                        this.fileNames = [];
                        this.fileCount = 0;
                    }
                },
                click: ()=>{
                    const el = document.querySelector("#filesToUpload");
                    el.click();
                }
            }, "Datei ausw\xe4hlen / drag & drop"), /*#__PURE__*/ React.createElement("span", {
                id: "file-count",
                style: "padding-left: 0.7vw"
            }, "(", this.fileCount, ")"), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("ul", {
                class: "data-list"
            }, this.fileNames.map((f)=>/*#__PURE__*/ React.createElement("li", null, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
                    /*#__PURE__*/ React.createElement("span", {
                        class: "datei-span",
                        style: "min-height: 1.5rem;"
                    }, /*#__PURE__*/ React.createElement("img", {
                        style: "max-height: 1.2rem; padding-right: 0.5rem;",
                        src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Datei")
                    }), /*#__PURE__*/ React.createElement("span", {
                        style: "max-width: 9.5rem; overflow: hidden; display: inline-block;"
                    }, f)),
                    /*#__PURE__*/ React.createElement("div", {
                        class: "click-delete",
                        click: ()=>{
                            const dt = new DataTransfer();
                            this.fileNames = [];
                            const el = document.querySelector("#filesToUpload");
                            const files = el.files;
                            for(let i = 0; i < files.length; i++)if (files[i].name !== f) {
                                dt.items.add(files[i]);
                                this.fileNames.push(files[i].name);
                            }
                            el.files = dt.files;
                            this.fileCount = el.files.length;
                        }
                    }, /*#__PURE__*/ React.createElement("img", {
                        style: "max-height: 1.2rem; padding-right: 0.5rem; padding-left: 0.5rem;",
                        src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Delete")
                    }))
                ], {
                    responsive: false,
                    sizes: [
                        "90%",
                        "*"
                    ]
                })))))
        ], {
            responsive: true,
            sizes: [
                "30%",
                "*"
            ],
            style: "min-height: 5rem; max-height: 20rem;"
        })), /*#__PURE__*/ React.createElement("tr", {
            style: "height: 6rem"
        }, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("td", {
                style: "text-align: left"
            }, /*#__PURE__*/ React.createElement("label", {
                for: "comment_field"
            }, "Kommentare: ")),
            /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement("textarea", {
                class: "txtarea",
                id: "comment_field",
                style: "font-size: 0.8em",
                rows: "10",
                cols: "60",
                form: "box",
                change: ()=>{
                    this.textarea_content = document.getElementById("comment_field").value;
                }
            }), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("button", {
                class: "jsl-button",
                style: "margin-top: 0.6rem;",
                click: async ()=>{
                    let content;
                    this.upload(); /* {
                  AjaxController.SetRepStatus(RepStatusEnum.KaufbelegFreigeben, this.ProjektePositionen.ProjektPosID).then(() => {
                    DialogComponent.show({
                      content: <div style="min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center">
                        <img style="max-height: 1.5rem; max-height: 1.5rem" src={mapUrl("Ajax/GetDownloadImage/Check")}/>
                        &nbsp;Datei/en
                          <span style="font-weight: bold; color: green"> erfolgreich </span>
                        hochgeladen!</div>,
                      footer: <div>{DialogComponent.Ok(() => {
                        location.reload();
                      })}</div>,
                      header: <div><strong>Upload erfolgreich</strong></div>,
                      maxHeight: "20vh",
                      maxWidth: "85vw",
                      minHeight: "5vh",
                      minWidth: "20vw",
                    });
                  });
                } else {
                  if(this.fileCount === 0){
                    this.content = <div style="min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center;">
                      <div style="margin: 0.4rem"><img style="max-height: 1.5rem; max-height: 1.5rem; margin:auto" src={mapUrl("Ajax/GetDownloadImage/Delete")}/>
                      &nbsp;Datei/en konnten
                        <span style="font-weight: bold; color: red"> nicht </span>
                      hochgeladen werden! </div>
                      <div style="margin: 0.4rem"><strong> Keine </strong> Dateien ausgewählt</div></div>;
                  } else {
                    this.content = <div style="min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center">
                      <img style="max-height: 1.5rem; max-height: 1.5rem" src={mapUrl("Ajax/GetDownloadImage/Delete")}/>
                      &nbsp;Datei/en konnten
                        <span style="font-weight: bold; color: red"> nicht </span>
                      hochgeladen werden! Erlaubte Dateiendungen sind: {this.allowedExtensions}</div>;
                  }
                  
                }*/ 
                }
            }, "Speichern"))
        ], {
            responsive: true,
            sizes: [
                "30%",
                "*"
            ]
        }))));
    }
    shiftLeft(files, startIdx, endIdx) {
        for(let i = startIdx; i < endIdx - 1; i++)files[i] = files[i + 1];
        files[endIdx - 1] = undefined;
    }
    upload() {
        const el = document.querySelector("#filesToUpload");
        const files = el.files;
        let upload_successful = true;
        if (files.length > 0) {
            const imgformData = new FormData();
            for(let i = 0; i < files.length; i++)imgformData.append("files", files[i]);
            (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post((0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/AddKaufbelege?Objektnummer=") + this.Objekt.Objektnummer + "&ProPosID=" + this.ProjektePositionen.ProjektPosID + "&Kategorie=Kaufbeleg&Token=" + this.token, imgformData, {}).then((result)=>{
                if (result.data && result.data === "OK") {
                    if (this.textarea_content !== "" && upload_successful) (0, $ed995c3feec4175b$export$e0c8ff32d779851f).AddComment(this.ProjektePositionen.ProjektPosID, this.textarea_content, this.token).then(()=>{
                        // result ?
                        const doc = document.getElementById("comment_field");
                        if (doc) doc.value = "";
                        // : alert("Kommentar konnte nicht gespeichert werden");
                        this.textarea_content = "";
                    }).catch((e)=>{
                        console.log(e);
                        alert("Error: Kommentar konnte nicht gespeichert werden");
                    });
                    this.fileNames = [];
                    this.fileCount = 0;
                    (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
                    this.upload_worked();
                } else {
                    upload_successful = false;
                    this.content = /*#__PURE__*/ React.createElement("div", {
                        style: "min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center"
                    }, /*#__PURE__*/ React.createElement("img", {
                        style: "max-height: 1.5rem; max-height: 1.5rem",
                        src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Delete")
                    }), "\xa0Datei/en konnten", /*#__PURE__*/ React.createElement("span", {
                        style: "font-weight: bold; color: red"
                    }, " nicht "), "hochgeladen werden! Erlaubte Dateiendungen sind: ", this.allowedExtensions);
                    this.upload_failed();
                }
            }).catch((e)=>{
                upload_successful = false;
                this.content = /*#__PURE__*/ React.createElement("div", {
                    style: "min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center"
                }, /*#__PURE__*/ React.createElement("img", {
                    style: "max-height: 1.5rem; max-height: 1.5rem",
                    src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Delete")
                }), "\xa0Datei/en konnten", /*#__PURE__*/ React.createElement("span", {
                    style: "font-weight: bold; color: red"
                }, " nicht "), "hochgeladen werden! Erlaubte Dateiendungen sind: ", this.allowedExtensions);
                this.upload_failed();
            });
        } else {
            upload_successful = false;
            this.content = /*#__PURE__*/ React.createElement("div", {
                style: "min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center;"
            }, /*#__PURE__*/ React.createElement("div", {
                style: "margin: 0.4rem"
            }, /*#__PURE__*/ React.createElement("img", {
                style: "max-height: 1.5rem; max-height: 1.5rem; margin:auto",
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Delete")
            }), "\xa0Datei/en konnten", /*#__PURE__*/ React.createElement("span", {
                style: "font-weight: bold; color: red"
            }, " nicht "), "hochgeladen werden! "), /*#__PURE__*/ React.createElement("div", {
                style: "margin: 0.4rem"
            }, /*#__PURE__*/ React.createElement("strong", null, " Keine "), " Dateien ausgew\xe4hlt"));
            this.upload_failed();
        }
    }
    upload_worked() {
        // AjaxController.SetRepStatus(RepStatusEnum.KaufbelegFreigeben, this.ProjektePositionen.ProjektPosID).then(() => {
        (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
            content: /*#__PURE__*/ React.createElement("div", {
                style: "min-height: 1.8rem; max-height: 2.2rem; text-align: center; align-content: center"
            }, /*#__PURE__*/ React.createElement("img", {
                style: "max-height: 1.5rem; max-height: 1.5rem",
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Ajax/GetDownloadImage/Check")
            }), "\xa0Datei/en", /*#__PURE__*/ React.createElement("span", {
                style: "font-weight: bold; color: green"
            }, " erfolgreich "), "hochgeladen!"),
            footer: /*#__PURE__*/ React.createElement("div", null, (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok(()=>{
                location.reload();
            })),
            header: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("strong", null, "Upload erfolgreich")),
            maxHeight: "20vh",
            maxWidth: "85vw",
            minHeight: "5vh",
            minWidth: "20vw"
        });
    // });
    }
    upload_failed() {
        (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
            content: this.content,
            footer: /*#__PURE__*/ React.createElement("div", null, (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok(()=>{
            //location.reload();
            })),
            header: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("strong", null, "Upload nicht erfolgreich!")),
            maxHeight: "10rem",
            maxWidth: "30rem",
            minHeight: "6rem",
            minWidth: "20rem"
        });
    }
}


class $aa56e06b8c23d3a3$export$fb63530bed1f6351 {
    constructor(accessToken){
        this.accessToken = accessToken;
        this.expanderComponents = [];
        this.errorText = null;
        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).GetReperaturstatus(accessToken).then((infoObject)=>{
            if (infoObject != null && infoObject.Entries != null && infoObject.Objekt != null && infoObject.ProjektePositionen != null) {
                this.infoObject = infoObject;
                //console.log("ProPosId = " + this.infoObject.ProjektePositionen.ProjektPosID);
                this.initExpanders();
                (0, $ed995c3feec4175b$export$e0c8ff32d779851f).Dummy();
            } else throw "No Information found";
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        }).catch((details)=>{
            this.errorText = details?.response?.data ?? details;
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        });
    }
    render() {
        if (this.errorText) return /*#__PURE__*/ React.createElement("div", null, new (0, $a356dde23eb6c2f6$export$65db35c377fab04b)(this.errorText));
        if (this.infoObject == null) return /*#__PURE__*/ React.createElement("div", {
            class: "center"
        }, new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)(10));
        const animation = {
            attr: "opacity",
            from: 0,
            to: 1,
            duration: 400,
            easing: "easeInExpo"
        };
        return /*#__PURE__*/ React.createElement("div", {
            class: "status-comp"
        }, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("div", {
                style: "vertical-align: middle"
            }, this.expanderComponents),
            new (0, $cd0cd22f4ce6ec31$export$2ed33cce1e9a2709)(this.infoObject)
        ], {
            responsive: true,
            sizes: [
                "60%",
                "40%"
            ],
            style: "vertical-align: middle"
        }));
    }
    initExpanders() {
        // header vertikal zentrieren, aber wie?!
        const options_akt_status = {
            header: "Aktueller Status",
            body: new (0, $61f45555e47b0735$export$88cc75586c36ad22)(this.infoObject.Entries[this.infoObject.Entries.length - 1].Text, this.infoObject.ProjektePositionen, this.accessToken),
            expanded: true
        };
        const history_comp = new (0, $ba9f541b620e5ffb$export$d71560eb52d5398a)(this.infoObject.Entries);
        const options_status_history = {
            header: "Status History",
            body: history_comp,
            expanded: true
        };
        const options_file_upload = {
            header: "Laden Sie hier Fotos und Videos hoch",
            body: new (0, $ac35f7b4e0ed9e8e$export$c6861759eaf17d6d)(this.infoObject.Objekt, this.infoObject.ProjektePositionen, this.accessToken),
            expanded: true
        };
        const options_kaufbeleg_upload = {
            header: "Laden Sie Ihren Kaufbeleg hoch",
            body: new (0, $39beb69654dce46d$export$fc2dd8fab5efd204)(this.infoObject.Objekt, this.infoObject.ProjektePositionen, this.accessToken),
            expanded: true
        };
        const options_kontakt = {
            header: "Kontakt",
            body: new (0, $eedeb63e9324d300$export$88d4154653f6832e)(),
            expanded: false
        };
        let akt_status_expander = new (0, $563aca4f433537ec$export$dda1456c77c606e0)(options_akt_status);
        let status_hist = new (0, $563aca4f433537ec$export$dda1456c77c606e0)(options_status_history);
        let kontakt_expander = new (0, $563aca4f433537ec$export$dda1456c77c606e0)(options_kontakt);
        let file_upload;
        let kaufbeleg_upload;
        if (this.infoObject.ProjektePositionen.USER_RepStatus === (0, $80619c09a94b56b7$export$f6f58ebd4483bea).RechnungAnfordern) kaufbeleg_upload = new (0, $563aca4f433537ec$export$dda1456c77c606e0)(options_kaufbeleg_upload);
        else if (this.infoObject.ProjektePositionen.USER_RepStatus <= 600) file_upload = new (0, $563aca4f433537ec$export$dda1456c77c606e0)(options_file_upload); //nur für jpg, jpeg, png, "videos"
        this.expanderComponents = [
            /*#__PURE__*/ React.createElement("div", {
                class: "info-box"
            }, akt_status_expander),
            kaufbeleg_upload != undefined ? /*#__PURE__*/ React.createElement("div", {
                class: "info-box"
            }, kaufbeleg_upload) : undefined,
            file_upload != undefined ? /*#__PURE__*/ React.createElement("div", {
                class: "info-box"
            }, file_upload) : undefined,
            /*#__PURE__*/ React.createElement("div", {
                class: "info-box"
            }, status_hist)
        ];
    }
}



// import "./LayoutStyle.scss";

class $2636d2675110968f$export$2f814a82e6b7c8e3 {
    constructor(bodyComponent){
        this.bodyComponent = bodyComponent;
    }
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            style: "padding-top:5rem;padding-bottom: 1px;"
        }, /*#__PURE__*/ React.createElement("div", {
            class: "nav-header"
        }, /*#__PURE__*/ React.createElement("img", {
            src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/images/logo.png"),
            style: "height:3.1rem"
        })), this.bodyComponent, /*#__PURE__*/ React.createElement("div", {
            class: "wave"
        }), /*#__PURE__*/ React.createElement("div", {
            class: "wave-red"
        }));
    }
}










function $5dcd30bd130f7584$var$mapUrl(url) {
    return _root_url + url;
}
class $5dcd30bd130f7584$export$845d5624d355ee33 {
    static async SendGarantieCustomerData(garantieData) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($5dcd30bd130f7584$var$mapUrl("OldLanding/SendGarantieCustomerData"), {
            garantieData: garantieData
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async IsValidSeriennummer(seriennummer) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($5dcd30bd130f7584$var$mapUrl("OldLanding/IsValidSeriennummer"), {
            seriennummer: seriennummer
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async IsValidSeriennummer9er(seriennummer) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($5dcd30bd130f7584$var$mapUrl("OldLanding/IsValidSeriennummer9er"), {
            seriennummer: seriennummer
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
}




class $f1867584a546ecb4$export$36424a9b7ecf3dc1 {
    isEqual(node) {
        return this.__proto__ === node.__proto__;
    }
    showLoading(show) {
        this.show = show;
        (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
    }
    render() {
        return this.show ? /*#__PURE__*/ React.createElement("div", {
            class: "div-lds-dual-ring"
        }, /*#__PURE__*/ React.createElement("div", {
            class: "lds-dual-ring"
        })) : /*#__PURE__*/ React.createElement("div", null);
    }
    constructor(){
        this.show = true;
    }
}



class $57f3a842a837cf6c$export$669f6ea7d267feaf {
    static showLoading() {
        if ($57f3a842a837cf6c$export$669f6ea7d267feaf.el == null) {
            $57f3a842a837cf6c$export$669f6ea7d267feaf.el = document.createElement("div");
            new (0, $83d498fca38a60e6$export$8beec2e5b8623754)($57f3a842a837cf6c$export$669f6ea7d267feaf.el).render(new (0, $f1867584a546ecb4$export$36424a9b7ecf3dc1)());
        }
        document.body.appendChild($57f3a842a837cf6c$export$669f6ea7d267feaf.el);
    }
    static hideLoading() {
        if ($57f3a842a837cf6c$export$669f6ea7d267feaf.el != null && $57f3a842a837cf6c$export$669f6ea7d267feaf.el.parentElement != null) $57f3a842a837cf6c$export$669f6ea7d267feaf.el.parentElement.removeChild($57f3a842a837cf6c$export$669f6ea7d267feaf.el);
    }
}


class $0a4ecc7e34f5db32$export$3dafe66f8a8e062b {
    constructor(){
        this.haendlerList = [
            {},
            {}
        ];
        this.fileNames = [];
        this.isLoading = true;
        this.erlaubteDateiendungen = [
            "jpg",
            "jpeg",
            "png",
            "pdf"
        ];
        this.vornameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Vorname eingeben...",
            onChange: (value)=>{
                this.vorname = value ?? "";
            }
        });
        this.nachnameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Nachname eingeben...",
            onChange: (value)=>{
                this.nachname = value ?? "";
            }
        });
        this.stra\u00dfeHausnummerInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Stra\xdfe und Hausnummer eingeben...",
            onChange: (value)=>{
                this.stra\u00dfeHausnummer = value ?? "";
            }
        });
        this.postleitzahlInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Postleitzahl eingeben...",
            onChange: (value)=>{
                const val = value ?? "0";
                if (isNaN(Number(val))) alert("Keine g\xfcltige Postleitzahl!");
                else this.plz = Number(val);
            }
        });
        this.unternehmenInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Unternehmen / Firma eingeben...",
            onChange: (value)=>{
                this.unternehmen = value ?? "";
            }
        });
        this.stadtInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Stadt eingeben...",
            onChange: (value)=>{
                this.stadt = value ?? "";
            }
        });
        this.emailInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "E-Mail-Adresse eingeben...",
            onChange: (value)=>{
                this.email = value ?? "";
            }
        });
        this.geraeteSeriennummer = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Ger\xe4te Seriennummer eingeben...",
            onChange: (value)=>{
                this.seriennummer = value ?? "";
            }
        });
        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).GetHaendler().then((haendler)=>{
            this.haendlerList = haendler;
            this.isLoading = false;
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        });
    }
    render() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "garantie-extend-comp"
        }, this.isLoading ? new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)(3) : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            style: "font-size: 2.6em; font-weight: bold"
        }, "B\xfcropaket 1040"), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-vorname"
            }, "Vorname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.vornameInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-nachname"
            }, "Nachname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.nachnameInput)
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-stra\xdfe"
        }, "Stra\xdfe und Hausnummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stra\u00dfeHausnummerInput), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-plz"
            }, "Postleitzahl*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.postleitzahlInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-stadt"
            }, "Stadt*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stadtInput)
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", null, "Unternehmen / Firma"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.unternehmenInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-email"
        }, "E-Mail-Adresse*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.emailInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-seriennummer"
        }, "Ger\xe4te Seriennummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.geraeteSeriennummer), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-haendler"
        }, "H\xe4ndler, bei dem die Maschine gekauft wurde*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $92830e10ec4ab123$export$c006741a65b06687)({
            class: "large-size-input-comp",
            data: this.haendlerList.map((haendler)=>({
                    text: haendler.Matchcode + " - " + haendler.LieferStrasse + " - " + haendler.LieferPLZ + " " + haendler.LieferOrt,
                    value: haendler.Kto
                })),
            value: this.haendlerKto,
            onChange: (value)=>{
                this.haendlerKto = value ?? "";
            }
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-kaufdatum"
        }, "Wann wurde die Maschine gekauft*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $c9acd7efe2a931e2$export$19285a5b05c4ea7c)({
            class: "large-size-input-comp",
            placeholder: "tt.mm.jjjj",
            max: new Date(),
            value: this.kaufdatum,
            onChange: (value)=>{
                this.kaufdatum = value;
            }
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-rechnung"
        }, "Rechnung*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("input", {
            type: "file",
            id: "filesToUpload",
            style: "position: absolute; top: -10000px;",
            class: "large-size-input-comp",
            multiple: true,
            change: (e, node)=>{
                const el = node.dom;
                this.fileNames = [];
                for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button large-size-input-comp",
            style: "opacity: 1",
            dragenter: (e)=>{
                e.preventDefault();
                e.target.classList.add("drag-over");
            },
            dragover: (e)=>e.preventDefault(),
            dragleave: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
            },
            drop: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
                const droppedFiles = e.dataTransfer?.files;
                if (droppedFiles != null) {
                    if (droppedFiles.length > 1) {
                        alert("Sie d\xfcrfen maximal eine Datei hochladen!");
                        return;
                    }
                    const fileName = droppedFiles[0].name;
                    const el = document.querySelector("#filesToUpload");
                    el.files = droppedFiles;
                    this.fileNames = [];
                    for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                } else this.fileNames = [];
            },
            click: ()=>{
                const el = document.querySelector("#filesToUpload");
                el.click();
            }
        }, "Datei ausw\xe4hlen / drag & drop"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("label", {
            style: "font-size: 0.7em; font-weight: normal"
        }, "Maximal 5MB; M\xf6gliche Dateien: jpg, png, pdf"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, this.fileNames.length <= 0 ? undefined : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 1em"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hochzuladende Dateien:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("ul", null, this.fileNames.map((file)=>/*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("li", {
                style: "font-size: 0.8em; font-weight: normal"
            }, file)))))), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, "Die mit einem Stern (*) markierten Felder sind Pflichtfelder."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-datenschutz"
        }, "Datenschutz*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Ich habe die Datenschutzbestimmungen zur Kenntnis genommen.",
            value: this.checkedDatenschutz,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedDatenschutz = value;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "info-button",
            click: ()=>{
                (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
                    header: "Datenschutzbestimmungen",
                    content: this.getDatenschutzbestimmungenText(),
                    footer: (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok()
                });
            }
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("img", {
            src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/images/information.png"),
            style: "max-width: 0.8rem; max-height: 0.8rem; opacity: 1"
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Hiermit stimme ich zu, dass die NIVONA Apparate GmbH, S\xfcdwestpark 49, 90449 N\xfcrnberg, meine Daten f\xfcr werbliche Zwecke und im Rahmen der Aktion nutzen darf, um mich zu kontaktieren. Diese Zustimmung kann ich jederzeit bei der NIVONA Apparate GmbH widerrufen.",
            value: this.checkedPermission,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedPermission = value;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button",
            style: "font-size: 0.9em; height: auto; padding: 0.3vw",
            click: ()=>{
                if (this.allRequiredFieldsFilledIn()) {
                    if (this.checkEmail(this.email)) {
                        const gm = {
                            ID: (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newGuid(),
                            Vorname: this.vorname,
                            Nachname: this.nachname,
                            "Stra\xdfeHausnummer": this.stra\u00dfeHausnummer,
                            PLZ: this.plz,
                            Stadt: this.stadt,
                            Unternehmen: this.unternehmen,
                            Email: this.email,
                            Seriennummer: this.seriennummer,
                            HaendlerKto: this.haendlerList.find((haendler)=>{
                                if (haendler.Kto === this.haendlerKto) return true;
                                return false;
                            })?.Kto,
                            Kaufdatum: this.kaufdatum,
                            SourcePage: "garantie"
                        };
                        const files = document.querySelector("#filesToUpload").files;
                        const imgFormData = new FormData();
                        for(let i = 0; i < files.length; i++)imgFormData.append("files", files[i]);
                        if (gm.ID != null) {
                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).showLoading();
                            (0, $5dcd30bd130f7584$export$845d5624d355ee33).IsValidSeriennummer(gm.Seriennummer ?? "").then((result)=>{
                                if (result) (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post((0, $fb350c3721d80fcd$export$791c4e50320e809e)("OldLanding/SendGarantieKaufbeleg?ID=" + gm.ID + "&sourcePage=garantie"), imgFormData, {}).then((val)=>{
                                    if (val.data === "OK") (0, $5dcd30bd130f7584$export$845d5624d355ee33).SendGarantieCustomerData(gm /*, "garantie"*/ ).then((guid)=>{
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("Ihre Garantie-Verl\xe4ngerung wird nun verarbeitet, vielen Dank!");
                                        location.reload();
                                    }).catch((error)=>{
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        const x = error?.response?.data ?? error ?? "unkown";
                                        alert(x);
                                    });
                                    else if (val.data === "FILES") {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("\xdcberpr\xfcfen Sie bitte, ob mit ihren hochgeladenen Dateien alles in Ordnung ist!");
                                    } else if (val.data === "FILEENDUNG") {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("\xdcberpr\xfcfen Sie bitte, ob Ihre hochgeladene Datei intakt ist und ob sie das richtige Format hat.\nErlaubt sind: .jpg, .png, .pdf!");
                                    } else {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("Ein Fehler ist aufgetreten, bitte versuchen Sie es in wenigen Augenblick erneut!");
                                    }
                                }).catch((error)=>{
                                    (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                    const x = error?.response?.data ?? error ?? "unkown";
                                    alert(x);
                                // alert("Überprüfen Sie bitte Ihre Datei auf zulässige Größe und zulässige Dateitypen!");
                                });
                                else {
                                    (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                    alert("\xdcberpr\xfcfen Sie bitte Ihre Seriennummer!");
                                }
                            }).catch((error)=>{
                                (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                const x = error?.response?.data ?? error ?? "unkown";
                                alert(x);
                            });
                        }
                    } else alert("Bitte geben Sie eine g\xfcltige Email-Adresse ein!");
                } else {
                    this.highlightAllNotFilledInRequired();
                    alert("Bitte f\xfcllen Sie alle geforderten Felder aus!");
                }
            }
        }, "Absenden")))));
    }
    allRequiredFieldsFilledIn() {
        if (this.vorname == undefined) return false;
        if (this.nachname == undefined) return false;
        if (this.stra\u00dfeHausnummer == undefined) return false;
        if (this.plz == undefined) return false;
        if (this.stadt == undefined) return false;
        if (this.email == undefined) return false;
        if (this.seriennummer == undefined) return false;
        if (this.haendlerKto == undefined || this.haendlerKto === "") return false;
        if (this.kaufdatum == undefined) return false;
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) return false;
        if (this.checkedDatenschutz == undefined) return false;
         /*if (this.checkedPermission == undefined) {
            return false;
        }*/ 
        return true;
    }
    highlightAllNotFilledInRequired() {
        this.undoStyleChangesBeforehand();
        if (this.vorname == undefined) {
            document.getElementById("span-vorname").style.color = "red";
            document.getElementById("span-vorname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.nachname == undefined) {
            document.getElementById("span-nachname").style.color = "red";
            document.getElementById("span-nachname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stra\u00dfeHausnummer == undefined) {
            document.getElementById("span-stra\xdfe").style.color = "red";
            document.getElementById("span-stra\xdfe").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.plz == undefined) {
            document.getElementById("span-plz").style.color = "red";
            document.getElementById("span-plz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stadt == undefined) {
            document.getElementById("span-stadt").style.color = "red";
            document.getElementById("span-stadt").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.email == undefined) {
            document.getElementById("span-email").style.color = "red";
            document.getElementById("span-email").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.seriennummer == undefined) {
            document.getElementById("span-seriennummer").style.color = "red";
            document.getElementById("span-seriennummer").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.haendlerKto == undefined || this.haendlerKto === "") {
            document.getElementById("span-haendler").style.color = "red";
            document.getElementById("span-haendler").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.kaufdatum == undefined) {
            document.getElementById("span-kaufdatum").style.color = "red";
            document.getElementById("span-kaufdatum").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) {
            document.getElementById("span-rechnung").style.color = "red";
            document.getElementById("span-rechnung").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.checkedDatenschutz == undefined) {
            document.getElementById("span-datenschutz").style.color = "red";
            document.getElementById("span-datenschutz").style.textShadow = "0.7px 0.7px 0.5px black";
        } /*if (this.checkedPermission == undefined) {
            (document.getElementById("span-datenschutz") as HTMLInputElement).style.color = "red";
            (document.getElementById("span-datenschutz") as HTMLInputElement).style.textShadow = "0.7px 0.7px 0.5px black";
        }*/ 
    }
    undoStyleChangesBeforehand() {
        document.getElementById("span-vorname").style.color = "black";
        document.getElementById("span-vorname").style.textShadow = "none";
        document.getElementById("span-nachname").style.color = "black";
        document.getElementById("span-nachname").style.textShadow = "none";
        document.getElementById("span-stra\xdfe").style.color = "black";
        document.getElementById("span-stra\xdfe").style.textShadow = "none";
        document.getElementById("span-plz").style.color = "black";
        document.getElementById("span-plz").style.textShadow = "none";
        document.getElementById("span-stadt").style.color = "black";
        document.getElementById("span-stadt").style.textShadow = "none";
        document.getElementById("span-email").style.color = "black";
        document.getElementById("span-email").style.textShadow = "none";
        document.getElementById("span-seriennummer").style.color = "black";
        document.getElementById("span-seriennummer").style.textShadow = "none";
        document.getElementById("span-haendler").style.color = "black";
        document.getElementById("span-haendler").style.textShadow = "none";
        document.getElementById("span-kaufdatum").style.color = "black";
        document.getElementById("span-kaufdatum").style.textShadow = "none";
        document.getElementById("span-rechnung").style.color = "black";
        document.getElementById("span-rechnung").style.textShadow = "none";
        document.getElementById("span-datenschutz").style.color = "black";
        document.getElementById("span-datenschutz").style.textShadow = "none";
    }
    checkEmail(email) {
        if (email.indexOf("@") === -1) return false;
        const split_arr = email.split("@");
        if (split_arr[0].length <= 0) return false;
        if (split_arr[1].length <= 0) return false;
        return true;
    }
    getDatenschutzbestimmungenText() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-sections"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section  pos-0 cms-section-default",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section-default boxed"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block  pos-0 cms-block-text",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container",
            style: "padding: 20px 20px 20px 20px;"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container-row row cms-row "
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "col-12",
            "data-cms-element-id": "eb20ee63af314345b702de452230f323"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-element-text"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("hr", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "1. Datenschutz auf einen Blick"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Allgemeine Hinweise"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die folgenden Hinweise geben einen einfachen \xdcberblick dar\xfcber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Ausf\xfchrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef\xfchrten Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Analyse-Tools und Tools von Drittanbietern", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zur\xfcckverfolgt werden. Sie k\xf6nnen dieser Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen dazu finden Sie in der folgenden Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen dieser Analyse widersprechen. \xdcber die Widerspruchsm\xf6glichkeiten werden wir Sie in dieser Datenschutzerkl\xe4rung informieren."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "2. Allgemeine Hinweise und Pflichtinformationen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Datenschutz"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers\xf6nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Die vorliegende Datenschutzerkl\xe4rung erl\xe4utert, welche Daten wir erheben und wof\xfcr wir sie nutzen. Sie erl\xe4utert auch, wie und zu welchem Zweck das geschieht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir weisen darauf hin, dass die Daten\xfcbertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitsl\xfccken aufweisen kann. Ein l\xfcckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xf6glich.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hinweis zur verantwortlichen Stelle", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die verantwortliche Stelle f\xfcr die Datenverarbeitung auf dieser Website ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Nivona Apparte GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 0911 2526630", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://info@nivona.com"
        }, "info@nivona.com"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Verantwortliche Stelle ist die nat\xfcrliche oder juristische Person, die allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. \xc4.) entscheidet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Widerruf Ihrer Einwilligung zur Datenverarbeitung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Viele Datenverarbeitungsvorg\xe4nge sind nur mit Ihrer ausdr\xfccklichen Einwilligung m\xf6glich. Sie k\xf6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtm\xe4\xdfigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Falle datenschutzrechtlicher Verst\xf6\xdfe steht dem Betroffenen ein Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde zu. Zust\xe4ndige Aufsichtsbeh\xf6rde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten k\xf6nnen folgendem Link entnommen werden: https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Recht auf Daten\xfcbertragbarkeit", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xfcllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g\xe4ngigen, maschinenlesbaren Format aush\xe4ndigen zu lassen. Sofern Sie die direkte \xdcbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft, Sperrung, L\xf6schung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xfcber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xe4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder L\xf6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xf6nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "3. Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Gesetzlich vorgeschriebener Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben f\xfcr unser Unternehmen einen Datenschutzbeauftragten bestellt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sigmundstra\xdfe 172", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "4. Datenerfassung auf unserer Website"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Cookies"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die meisten der von uns verwendeten Cookies sind so genannte \u201CSession-Cookies\u201D. Sie werden nach Ende Ihres Besuchs automatisch gel\xf6scht. Andere Cookies bleiben auf Ihrem Endger\xe4t gespeichert bis Sie diese l\xf6schen. Diese Cookies erm\xf6glichen es uns, Ihren Browser beim n\xe4chsten Besuch wiederzuerkennen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen Ihren Browser so einstellen, dass Sie \xfcber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f\xfcr bestimmte F\xe4lle oder generell ausschlie\xdfen sowie das automatische L\xf6schen der Cookies beim Schlie\xdfen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit\xe4t dieser Website eingeschr\xe4nkt sein.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Cookies, die zur Durchf\xfchrung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erw\xfcnschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerkl\xe4rung gesondert behandelt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "5. Analyse Tools und Werbung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Analytics"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), 'Google Analytics verwendet so genannte "Cookies". Das sind Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm\xf6glichen. Die durch den Cookie erzeugten Informationen \xfcber Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert.', /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "IP Anonymisierung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europ\xe4ischen Union oder in anderen Vertragsstaaten des Abkommens \xfcber den Europ\xe4ischen Wirtschaftsraum vor der \xdcbermittlung in die USA gek\xfcrzt. Nur in Ausnahmef\xe4llen wird die volle IP-Adresse an einen Server von Google in den USA \xfcbertragen und dort gek\xfcrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xfcber die Websiteaktivit\xe4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xfcber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser \xfcbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xfchrt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Browser Plugin"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht s\xe4mtliche Funktionen dieser Website vollumf\xe4nglich werden nutzen k\xf6nnen. Sie k\xf6nnen dar\xfcber hinaus die Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verf\xfcgbare Browser-Plugin herunterladen und installieren: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://tools.google.com/dlpage/gaoptout?hl=de"
        }, "https://tools.google.com/dlpage/gaoptout?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Widerspruch gegen Datenerfassung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zuk\xfcnftigen Besuchen dieser Website verhindert: Google Analytics deaktivieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://support.google.com/analytics/answer/6004245?hl=de"
        }, "https://support.google.com/analytics/answer/6004245?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Auftragsdatenverarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die strengen Vorgaben der deutschen Datenschutzbeh\xf6rden bei der Nutzung von Google Analytics vollst\xe4ndig um."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "6. Plugins und Tools"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "YouTube"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unsere Website nutzt Plugins der von Google betriebenen Seite YouTube. Betreiber der Seiten ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie in Ihrem YouTube-Account eingeloggt sind, erm\xf6glichen Sie YouTube, Ihr Surfverhalten direkt Ihrem pers\xf6nlichen Profil zuzuordnen. Dies k\xf6nnen Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von YouTube unter: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy"
        }, "https://www.google.de/intl/de/policies/privacy")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Maps"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Seite nutzt \xfcber eine API den Kartendienst Google Maps. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Daten\xfcbertragung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy/"
        }, "https://www.google.de/intl/de/policies/privacy/"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\xa0", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h4", null, "Pflichtinformationen gem. Art. 12 ff. DS-GVO"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Kontaktdaten des Verantwortlichen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Name: Peter", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Vorname: Wildner", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: NIVONA Apparate GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://peter.wildner@nivona.com"
        }, "peter.wildner@nivona.com")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten des Datenschutzbeauftragten", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: Sigmundstra\xdfe 172; 90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Woher beziehen wir Ihre personenbezogenen Daten?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Erhebung Ihrer Daten findet grunds\xe4tzlich bei Ihnen selbst statt. Die Verarbeitung der von Ihnen \xfcberlassenen personenbezogenen Daten ist zur Erf\xfcllung der vertraglichen Pflichten, die sich aus dem mit uns geschlossenen Vertrag ergeben, notwendig. Aufgrund Ihrer Mitwirkungspflichten ist es unumg\xe4nglich die von uns angeforderten personenbezogenen Daten zur Verf\xfcgung zu stellen, da wir ansonsten unseren vertraglichen Pflichten nicht nachkommen k\xf6nnen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen vorvertraglicher Ma\xdfnahmen (z. B. Stammdatenerfassung im Interessentenprozess) ist die Bereitstellung Ihrer personenbezogenen Daten notwendig. Sollten die angeforderten Daten nicht von Ihnen bereitgestellt werden, kann ein Vertrag nicht abgeschlossen werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Erbringung unserer Dienstleistungen kann es erforderlich sein, personenbezogene Daten zu verarbeiten, die wir von anderen Unternehmen oder sonstigen Dritten, z. B. Finanz\xe4mtern, Ihren Gesch\xe4ftspartner o. \xe4. zul\xe4ssigerweise und zu dem jeweiligen Zweck erhalten haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weiterhin verarbeiten wir ggf. personenbezogene Daten aus \xf6ffentlich zug\xe4nglichen Quellen, z. B. Internetauftritten, die wir zul\xe4ssigerweise und nur zu dem jeweiligen Vertragszweck nutzen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zwecke und Rechtsgrundlagen der Verarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die von Ihnen \xfcberlassenen personenbezogenen Daten werden im Einklang mit den Bestimmungen der europ\xe4ischen Datenschutzverordnung (DS-GVO) und dem Bundesdatenschutzgesetz (BDSG) verarbeitet:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund einer Einwilligung (gem. Art. 6 Abs. 1 Lit. a DS-GVO)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Verarbeitung personenbezogener Daten ergeben sich aus der Erteilung einer Einwilligung. Eine erteilte Einwilligung kann jederzeit von Ihnen mit Wirkung f\xfcr die Zukunft widerrufen werden. Auch Einwilligungen, die vor der Geltung der DS-GVO (25. Mai 2018) erteilt worden sind, k\xf6nnen widerrufen werden. Verarbeitungen, die vor dem Widerruf erfolgt sind, bleiben vom Widerruf unber\xfchrt. Beispiel: Zusendung eines Newsletters, Einwilligung zur Weitergabe der von Ihnen \xfcberlassenen Daten auf Ihren Wunsch hin an Dritte (z. B. Banken, Versicherungen, Anteilseigner etc.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zur Erf\xfcllung von vertraglichen Pflichten (gem. Art. 6 Abs. 1 Lit. b DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Datenverarbeitung ergeben sich zum einen aus der Einleitung vorvertraglicher Ma\xdfnahmen, die einer vertraglich geregelten Gesch\xe4ftsbeziehung vorausgehen und zum anderen zur Erf\xfcllung der Pflichten aus dem mit Ihnen geschlossenen Vertrag.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund gesetzlicher Vorgaben (gem. Art. 6 Abs.1 Lit. c DS-GVO) oder im \xf6ffentlichen Interesse (gem. Art. 6 Abs.1 Lit. e DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Datenverarbeitung ergeben sich aus gesetzlichen Vorgaben oder liegen im \xf6ffentlichen Interesse (z. B. Einhaltung von Aufbewahrungspflichten, Nachweis der Einhaltung von Hinweis- und Informationspflichten des Steuerberaters).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Im Rahmen der Interessenabw\xe4gung (gem. Art. 6 Abs. 1 Lit. f DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Verarbeitung ergeben sich aus der Wahrung unserer berechtigten Interessen. Es kann erforderlich sein, die von Ihnen \xfcberlassenen Daten \xfcber die eigentliche Erf\xfcllung des Vertrages hinaus zu verarbeiten. Unser berechtigtes Interesse kann zur Begr\xfcndung der weiteren Verarbeitung der von Ihnen \xfcberlassenen Daten herangezogen werden, sofern Ihre Interessen oder Grundrechte und Grundfreiheiten nicht \xfcberwiegen. Unser berechtigtes Interesse kann im Einzelfall sein: Geltendmachung rechtlicher Anspr\xfcche, Abwehr von Haftungsanspr\xfcchen, Verhinderung von Straftaten.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wer erh\xe4lt die von Ihnen \xfcberlassenen personenbezogenen Daten?", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Innerhalb unseres Unternehmens erhalten diejenigen Bereiche Zugriff auf die von Ihnen \xfcberlassenen personenbezogenen Daten, die diese zur Erf\xfcllung der vertraglichen und gesetzlichen Pflichten ben\xf6tigen und die zur Verarbeitung dieser Daten berechtigt sind.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "In Erf\xfcllung des mit Ihnen geschlossenen Vertrages erhalten ausschlie\xdflich diejenigen Stellen die von Ihnen \xfcberlassenen Daten, die diese aus gesetzlichen Gr\xfcnden ben\xf6tigen, z. B. Finanzbeh\xf6rden, Sozialversicherungstr\xe4ger, zust\xe4ndige Beh\xf6rden und Gerichte.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Empf\xe4nger erhalten die von Ihnen \xfcberlassenen Daten nur auf Ihren Wunsch hin, wenn Sie uns die hierf\xfcr notwendige Einwilligung erteilen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen unserer Leistungserbringung beauftragen wir Auftragsverarbeiter, die zur Erf\xfcllung der vertraglichen Pflichten beitragen, z. B. EDV-Partner, Aktenvernichter, Fachh\xe4ndler etc. Diese Auftragsverarbeiter werden von uns vertraglich zur Einhaltung der Vorgaben der DS-GVO und des BDSG verpflichtet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Werden die von Ihnen \xfcberlassenen Daten an Drittl\xe4nder oder internationale Organisationen \xfcbermittelt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Eine \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation erfolgt in keinem Fall. Sollten Sie im Einzelfall die \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation w\xfcnschen, f\xfchren wir dies nur nach Ihrer schriftlichen Einwilligung durch."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Findet automatisierte Entscheidungsfindung einschlie\xdflich Profiling statt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Verarbeitung der von Ihnen \xfcberlassenen Daten kommt keine vollautomatisierte Entscheidungsfindung (einschlie\xdflich Profiling) gem. Art. 22 DS-GVO zum Einsatz."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Dauer der Verarbeitung (Kriterien der L\xf6schung)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Verarbeitung der von Ihnen \xfcberlassenen Daten erfolgt so lange, wie sie zur Erreichung des vertraglich vereinbarten Zweckes notwendig ist, grunds\xe4tzlich so lange das Vertragsverh\xe4ltnis mit Ihnen besteht. Nach der Beendigung des Vertragsverh\xe4ltnisses werden die von Ihnen \xfcberlassenen Daten zur Einhaltung gesetzlicher Aufbewahrungspflichten oder aufgrund unserer berechtigten Interessen verarbeitet. Nach dem Ablauf der gesetzlichen Aufbewahrungsfristen und/oder dem Wegfall unserer berechtigten Interessen werden die von Ihnen \xfcberlassenen Daten gel\xf6scht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Voraussichtliche Fristen der uns treffenden Aufbewahrungspflichten und unserer berechtigten Interessen:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erf\xfcllung handels- und steuerrechtlicher Aufbewahrungsfristen. Die dort vorgegebenen Fristen zur Aufbewahrung bzw. Dokumentation betragen zwei bis zehn Jahre.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erhaltung von Beweismitteln im Rahmen der Verj\xe4hrungsvorschriften. Nach den \xa7\xa7 195 ff. des B\xfcrgerlichen Gesetzbuches (BGB) k\xf6nnen diese Verj\xe4hrungsfristen bis zu 30 Jahre betragen, wobei die regelm\xe4\xdfige Verj\xe4hrungsfrist drei Jahre betr\xe4gt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft \xfcber Ihre Rechte", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Auskunft gem. Art. 15 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, auf Antrag unentgeltlich Auskunft zu erhalten, ob und welche Daten \xfcber Sie gespeichert sind und zu welchem Zweck die Speicherung erfolgt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Berichtigung gem. Art. 16 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen unverz\xfcglich die Berichtigung Ihrer unrichtigen personenbezogenen Daten zu verlangen. Unter Ber\xfccksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollst\xe4ndigung unvollst\xe4ndiger personenbezogener Daten \u2014 auch mittels einer erg\xe4nzenden Erkl\xe4rung \u2014 zu verlangen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf L\xf6schung (\u201ERecht auf Vergessenwerden\u201C) gem. Art. 17 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen zu verlangen, dass Ihre Daten unverz\xfcglich gel\xf6scht werden. Der Verantwortliche ist verpflichtet, personenbezogene Daten unverz\xfcglich zu l\xf6schen, sofern einer der folgenden Gr\xfcnde zutrifft:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Zwecke, f\xfcr die die personenbezogenen Daten erhoben wurden, entfallen", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Sie widerrufen Ihre Einwilligung der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Sie widersprechen der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Die personenbezogenen Daten wurden unrechtm\xe4\xdfig verarbeitet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "e) Die L\xf6schung der personenbezogenen Daten ist zur Erf\xfcllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "f) Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gem\xe4\xdf Artikel 8 Absatz 1 erhoben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Einschr\xe4nkung der Verarbeitung gem. Art. 18 DS-GVO &. \xa7 35 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die Einschr\xe4nkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Die Richtigkeit der personenbezogenen Daten wird von Ihnen angezweifelt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Die Verarbeitung ist unrechtm\xe4\xdfig; Sie lehnen eine L\xf6schung jedoch ab.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Personenbezogene Daten werden f\xfcr die Zwecke der Verarbeitung nicht l\xe4nger ben\xf6tigt; Sie ben\xf6tigen die Daten jedoch zur Geltendmachung, Aus\xfcbung oder Verteidigung von Rechtsanspr\xfcchen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Sie haben Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt. Solange noch nicht feststeht, ob die berechtigten Gr\xfcnde des Verantwortlichen Ihnen gegen\xfcber \xfcberwiegen, wird die Verarbeitung eingeschr\xe4nkt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Daten\xfcbertragbarkeit gem. Art. 20 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die von Ihnen bereitgestellten Daten in einem strukturierten, g\xe4ngigen und maschinenlesbaren Format von dem Verantwortlichen zu erhalten. Eine Weiterleitung an einen andern Verantwortlichen darf von uns nicht behindert werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Widerspruchsrecht gem. Art. 21 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hierzu wenden Sie sich bitte an den Verantwortlichen der Verarbeitung (s. o.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Beschwerderecht bei der Aufsichtsbeh\xf6rde gem. Art. 13 Abs. 2 Lit. d, 77 DS-GVO", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "i. V. m \xa7 19 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen die DS-GVO verst\xf6\xdft, haben Sie das Recht Beschwerde bei der Aufsichtsbeh\xf6rde einzulegen. Hierzu wenden Sie sich bitte an die zust\xe4ndige Aufsichtsbeh\xf6rde", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Zur\xfcckziehen der Einwilligung gem. Art. 7 Abs. 3 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beruht die Verarbeitung auf Ihrer Einwilligung gem. Art. 6 Abs. 1 Lit. a oder Art. 9 Abs. 2 Lit. a (Verarbeitung besonderer Kategorien personenbezogener Daten), sind Sie jederzeit dazu berechtigt die zweckm\xe4\xdfig gebundene Einwilligung zur\xfcckzuziehen, ohne dass die Rechtm\xe4\xdfigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung ber\xfchrt wird. ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null))))))))));
    }
}










function $03a6e665f65a3887$var$mapUrl(url) {
    return _root_url + url;
}
class $03a6e665f65a3887$export$5e12a1e07cfbd77a {
    static async GetLandingForm(name) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($03a6e665f65a3887$var$mapUrl("Landing/GetLandingForm"), {
            name: name
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async IsValidSeriennummer(seriennummer, sourcepage) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($03a6e665f65a3887$var$mapUrl("Landing/IsValidSeriennummer"), {
            seriennummer: seriennummer,
            sourcepage: sourcepage
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
    static async SendGarantieCustomerData(garantieData) {
        const result = await (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post($03a6e665f65a3887$var$mapUrl("Landing/SendGarantieCustomerData"), {
            garantieData: garantieData
        });
        return (0, $f3d7bca1b355a7b4$export$2c456d3202acb568)(result.data);
    }
}




class $daadc7667501bd5c$export$fb8d0680d466ed30 {
    constructor(options){
        this.options = options;
        this.haendlerList = [
            {},
            {}
        ];
        this.fileNames = [];
        this.isLoading = true;
        this.erlaubteDateiendungen = [
            "jpg",
            "jpeg",
            "png",
            "pdf"
        ];
        this.vornameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Vorname eingeben...",
            onChange: (value)=>{
                this.vorname = value ?? "";
            }
        });
        this.nachnameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Nachname eingeben...",
            onChange: (value)=>{
                this.nachname = value ?? "";
            }
        });
        this.stra\u00dfeHausnummerInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Stra\xdfe und Hausnummer eingeben...",
            onChange: (value)=>{
                this.stra\u00dfeHausnummer = value ?? "";
            }
        });
        this.postleitzahlInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Postleitzahl eingeben...",
            onChange: (value)=>{
                const val = value ?? "0";
                if (isNaN(Number(val))) alert("Keine g\xfcltige Postleitzahl!");
                else this.plz = Number(val);
            }
        });
        this.unternehmenInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Unternehmen / Firma eingeben...",
            onChange: (value)=>{
                this.unternehmen = value ?? "";
            }
        });
        this.stadtInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Stadt eingeben...",
            onChange: (value)=>{
                this.stadt = value ?? "";
            }
        });
        this.emailInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "E-Mail-Adresse eingeben...",
            onChange: (value)=>{
                this.email = value ?? "";
            }
        });
        this.geraeteSeriennummer = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Ger\xe4te Seriennummer eingeben...",
            onChange: (value)=>{
                this.seriennummer = value ?? "";
            }
        });
        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).GetHaendler().then((haendler)=>{
            this.haendlerList = haendler;
            this.isLoading = false;
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        });
    }
    render() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "garantie-comp"
        }, this.isLoading ? new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)(3) : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-vorname"
            }, "Vorname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.vornameInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-nachname"
            }, "Nachname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.nachnameInput)
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-stra\xdfe"
        }, "Stra\xdfe und Hausnummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stra\u00dfeHausnummerInput), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-plz"
            }, "Postleitzahl*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.postleitzahlInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-stadt"
            }, "Stadt*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stadtInput)
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", null, "Unternehmen / Firma"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.unternehmenInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-email"
        }, "E-Mail-Adresse*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.emailInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-seriennummer"
        }, "Ger\xe4te Seriennummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.geraeteSeriennummer), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-haendler"
        }, "H\xe4ndler, bei dem die Maschine gekauft wurde*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $92830e10ec4ab123$export$c006741a65b06687)({
            class: "large-size-input-comp",
            data: this.haendlerList.map((haendler)=>({
                    text: haendler.Matchcode + " - " + haendler.LieferStrasse + " - " + haendler.LieferPLZ + " " + haendler.LieferOrt,
                    value: haendler.Kto
                })),
            value: this.haendlerKto,
            onChange: (value)=>{
                this.haendlerKto = value ?? "";
            }
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-kaufdatum"
        }, "Wann wurde die Maschine gekauft*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $c9acd7efe2a931e2$export$19285a5b05c4ea7c)({
            class: "large-size-input-comp",
            placeholder: "tt.mm.jjjj",
            max: new Date(),
            value: this.kaufdatum,
            onChange: (value)=>{
                this.kaufdatum = value;
            }
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-rechnung"
        }, "Rechnung*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("input", {
            type: "file",
            id: "filesToUpload",
            style: "position: absolute; top: -10000px;",
            class: "large-size-input-comp",
            multiple: true,
            change: (e, node)=>{
                const el = node.dom;
                if (el?.files != null) {
                    this.fileNames = [];
                    for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                }
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button large-size-input-comp",
            style: "opacity: 1",
            dragenter: (e)=>{
                e.preventDefault();
                e.target.classList.add("drag-over");
            },
            dragover: (e)=>e.preventDefault(),
            dragleave: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
            },
            drop: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
                const droppedFiles = e.dataTransfer?.files;
                if (droppedFiles != null) {
                    if (droppedFiles.length > 1) {
                        alert("Sie d\xfcrfen maximal eine Datei hochladen!");
                        return;
                    }
                    // const fileName = droppedFiles[0].name;
                    const el = document.querySelector("#filesToUpload");
                    el.files = droppedFiles;
                    this.fileNames = [];
                    if (el?.files != null) for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                } else this.fileNames = [];
            },
            click: ()=>{
                const el = document.querySelector("#filesToUpload");
                el.click();
            }
        }, "Datei ausw\xe4hlen / drag & drop"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("label", {
            style: "font-size: 0.7em; font-weight: normal"
        }, "Maximal 5MB; M\xf6gliche Dateien: jpg, png, pdf"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, this.fileNames.length <= 0 ? undefined : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 1em"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hochzuladende Dateien:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("ul", null, this.fileNames.map((file)=>/*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("li", {
                style: "font-size: 0.8em; font-weight: normal"
            }, file)))))), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, "Die mit einem Stern (*) markierten Felder sind Pflichtfelder."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-datenschutz"
        }, "Datenschutz*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Ich habe die Datenschutzbestimmungen zur Kenntnis genommen.",
            value: this.checkedDatenschutz,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedDatenschutz = value;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "info-button",
            click: ()=>{
                (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
                    header: "Datenschutzbestimmungen",
                    content: this.getDatenschutzbestimmungenText(),
                    footer: (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok()
                });
            }
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("img", {
            src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/images/information.png"),
            style: "max-width: 0.8rem; max-height: 0.8rem; opacity: 1"
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Hiermit stimme ich zu, dass die NIVONA Apparate GmbH, S\xfcdwestpark 49, 90449 N\xfcrnberg, meine Daten f\xfcr werbliche Zwecke und im Rahmen der Aktion nutzen darf, um mich zu kontaktieren. Diese Zustimmung kann ich jederzeit bei der NIVONA Apparate GmbH widerrufen.",
            value: this.checkedPermission,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedPermission = value;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button",
            style: "font-size: 0.9em; height: auto; padding: 0.6vw",
            click: ()=>{
                if (this.allRequiredFieldsFilledIn()) {
                    if (this.checkEmail(this.email)) {
                        const gm = {
                            ID: (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newGuid(),
                            Vorname: this.vorname,
                            Nachname: this.nachname,
                            "Stra\xdfeHausnummer": this.stra\u00dfeHausnummer,
                            PLZ: this.plz,
                            Stadt: this.stadt,
                            Unternehmen: this.unternehmen,
                            Email: this.email,
                            Seriennummer: this.seriennummer,
                            HaendlerKto: this.haendlerList.find((haendler)=>{
                                if (haendler.Kto === this.haendlerKto) return true;
                                return false;
                            })?.Kto,
                            Kaufdatum: this.kaufdatum,
                            SourcePage: this.options.Name,
                            HasContactPermission: this.checkedPermission == undefined ? 0 : this.checkedPermission === false ? 0 : -1
                        };
                        console.log(this.options.Name);
                        const files = document.querySelector("#filesToUpload").files;
                        const imgFormData = new FormData();
                        if (files != null) {
                            for(let i = 0; i < files.length; i++)imgFormData.append("files", files[i]);
                            if (gm.ID != null) {
                                (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).showLoading();
                                (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).IsValidSeriennummer(gm.Seriennummer ?? "", this.options.Name).then((result)=>{
                                    // console.log(result);
                                    if (result == "Seriennummer g\xfcltig") (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post((0, $fb350c3721d80fcd$export$791c4e50320e809e)("Landing/SendGarantieKaufbeleg?ID=" + gm.ID + "&sourcePage=" + this.options.Name), imgFormData, {}).then((val)=>{
                                        if (val.data === "OK") (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).SendGarantieCustomerData(gm /*, "garantie"*/ ).then((guid)=>{
                                            // alert("Ihre Garantie-Verlängerung wird nun verarbeitet, vielen Dank!");
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            (0, $0c412a07a28a0d02$export$f6ff04b41b36f7bc).navigate("#sucessGarantie/" + this.options.Name);
                                        // location.reload();
                                        }).catch((error)=>{
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            const x = error?.response?.data ?? error ?? "unkown";
                                            alert(x);
                                        });
                                        else if (val.data === "FILES") {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("\xdcberpr\xfcfen Sie bitte, ob mit ihren hochgeladenen Dateien alles in Ordnung ist!");
                                        } else if (val.data === "FILEENDUNG") {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("\xdcberpr\xfcfen Sie bitte, ob Ihre hochgeladene Datei intakt ist und ob sie das richtige Format hat.\nErlaubt sind: .jpg, .png, .pdf!");
                                        } else {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("Ein Fehler ist aufgetreten, bitte versuchen Sie es in wenigen Augenblick erneut!");
                                        }
                                    }).catch((error)=>{
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("\xdcberpr\xfcfen Sie bitte Ihre Datei auf zul\xe4ssige Gr\xf6\xdfe und zul\xe4ssige Dateitypen!");
                                    });
                                    else {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert(result);
                                    }
                                }).catch((error)=>{
                                    (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                    const x = error?.response?.data ?? error ?? "unkown";
                                    alert(x);
                                });
                            }
                        }
                    } else alert("Bitte geben Sie eine g\xfcltige Email-Adresse ein!");
                } else {
                    this.highlightAllNotFilledInRequired();
                    alert("Bitte f\xfcllen Sie alle geforderten Felder aus!");
                }
            }
        }, "Absenden")))));
    }
    allRequiredFieldsFilledIn() {
        if (this.vorname == undefined) return false;
        if (this.nachname == undefined) return false;
        if (this.stra\u00dfeHausnummer == undefined) return false;
        if (this.plz == undefined) return false;
        if (this.stadt == undefined) return false;
        if (this.email == undefined) return false;
        if (this.seriennummer == undefined) return false;
        if (this.haendlerKto == undefined || this.haendlerKto === "") return false;
        if (this.kaufdatum == undefined) return false;
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) return false;
        if (this.checkedDatenschutz == undefined || this.checkedDatenschutz === false) return false;
         /*if (this.checkedPermission == undefined) {
            return false;
        }*/ 
        return true;
    }
    highlightAllNotFilledInRequired() {
        this.undoStyleChangesBeforehand();
        if (this.vorname == undefined) {
            document.getElementById("span-vorname").style.color = "red";
            document.getElementById("span-vorname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.nachname == undefined) {
            document.getElementById("span-nachname").style.color = "red";
            document.getElementById("span-nachname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stra\u00dfeHausnummer == undefined) {
            document.getElementById("span-stra\xdfe").style.color = "red";
            document.getElementById("span-stra\xdfe").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.plz == undefined) {
            document.getElementById("span-plz").style.color = "red";
            document.getElementById("span-plz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stadt == undefined) {
            document.getElementById("span-stadt").style.color = "red";
            document.getElementById("span-stadt").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.email == undefined) {
            document.getElementById("span-email").style.color = "red";
            document.getElementById("span-email").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.seriennummer == undefined) {
            document.getElementById("span-seriennummer").style.color = "red";
            document.getElementById("span-seriennummer").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.haendlerKto == undefined || this.haendlerKto === "") {
            document.getElementById("span-haendler").style.color = "red";
            document.getElementById("span-haendler").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.kaufdatum == undefined) {
            document.getElementById("span-kaufdatum").style.color = "red";
            document.getElementById("span-kaufdatum").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) {
            document.getElementById("span-rechnung").style.color = "red";
            document.getElementById("span-rechnung").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.checkedDatenschutz == undefined) {
            document.getElementById("span-datenschutz").style.color = "red";
            document.getElementById("span-datenschutz").style.textShadow = "0.7px 0.7px 0.5px black";
        } /*if (this.checkedPermission == undefined) {
            (document.getElementById("span-datenschutz") as HTMLInputElement).style.color = "red";
            (document.getElementById("span-datenschutz") as HTMLInputElement).style.textShadow = "0.7px 0.7px 0.5px black";
        }*/ 
    }
    undoStyleChangesBeforehand() {
        document.getElementById("span-vorname").style.color = "black";
        document.getElementById("span-vorname").style.textShadow = "none";
        document.getElementById("span-nachname").style.color = "black";
        document.getElementById("span-nachname").style.textShadow = "none";
        document.getElementById("span-stra\xdfe").style.color = "black";
        document.getElementById("span-stra\xdfe").style.textShadow = "none";
        document.getElementById("span-plz").style.color = "black";
        document.getElementById("span-plz").style.textShadow = "none";
        document.getElementById("span-stadt").style.color = "black";
        document.getElementById("span-stadt").style.textShadow = "none";
        document.getElementById("span-email").style.color = "black";
        document.getElementById("span-email").style.textShadow = "none";
        document.getElementById("span-seriennummer").style.color = "black";
        document.getElementById("span-seriennummer").style.textShadow = "none";
        document.getElementById("span-haendler").style.color = "black";
        document.getElementById("span-haendler").style.textShadow = "none";
        document.getElementById("span-kaufdatum").style.color = "black";
        document.getElementById("span-kaufdatum").style.textShadow = "none";
        document.getElementById("span-rechnung").style.color = "black";
        document.getElementById("span-rechnung").style.textShadow = "none";
        document.getElementById("span-datenschutz").style.color = "black";
        document.getElementById("span-datenschutz").style.textShadow = "none";
    }
    checkEmail(email) {
        if (email.indexOf("@") === -1) return false;
        const split_arr = email.split("@");
        if (split_arr[0].length <= 0) return false;
        if (split_arr[1].length <= 0) return false;
        return true;
    }
    getDatenschutzbestimmungenText() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-sections"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section  pos-0 cms-section-default",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section-default boxed"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block  pos-0 cms-block-text",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container",
            style: "padding: 20px 20px 20px 20px;"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container-row row cms-row "
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "col-12",
            "data-cms-element-id": "eb20ee63af314345b702de452230f323"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-element-text"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("hr", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "1. Datenschutz auf einen Blick"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Allgemeine Hinweise"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die folgenden Hinweise geben einen einfachen \xdcberblick dar\xfcber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Ausf\xfchrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef\xfchrten Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Analyse-Tools und Tools von Drittanbietern", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zur\xfcckverfolgt werden. Sie k\xf6nnen dieser Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen dazu finden Sie in der folgenden Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen dieser Analyse widersprechen. \xdcber die Widerspruchsm\xf6glichkeiten werden wir Sie in dieser Datenschutzerkl\xe4rung informieren."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "2. Allgemeine Hinweise und Pflichtinformationen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Datenschutz"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers\xf6nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Die vorliegende Datenschutzerkl\xe4rung erl\xe4utert, welche Daten wir erheben und wof\xfcr wir sie nutzen. Sie erl\xe4utert auch, wie und zu welchem Zweck das geschieht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir weisen darauf hin, dass die Daten\xfcbertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitsl\xfccken aufweisen kann. Ein l\xfcckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xf6glich.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hinweis zur verantwortlichen Stelle", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die verantwortliche Stelle f\xfcr die Datenverarbeitung auf dieser Website ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Nivona Apparte GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 0911 2526630", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://info@nivona.com"
        }, "info@nivona.com"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Verantwortliche Stelle ist die nat\xfcrliche oder juristische Person, die allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. \xc4.) entscheidet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Widerruf Ihrer Einwilligung zur Datenverarbeitung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Viele Datenverarbeitungsvorg\xe4nge sind nur mit Ihrer ausdr\xfccklichen Einwilligung m\xf6glich. Sie k\xf6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtm\xe4\xdfigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Falle datenschutzrechtlicher Verst\xf6\xdfe steht dem Betroffenen ein Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde zu. Zust\xe4ndige Aufsichtsbeh\xf6rde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten k\xf6nnen folgendem Link entnommen werden: https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Recht auf Daten\xfcbertragbarkeit", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xfcllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g\xe4ngigen, maschinenlesbaren Format aush\xe4ndigen zu lassen. Sofern Sie die direkte \xdcbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft, Sperrung, L\xf6schung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xfcber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xe4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder L\xf6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xf6nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "3. Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Gesetzlich vorgeschriebener Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben f\xfcr unser Unternehmen einen Datenschutzbeauftragten bestellt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sigmundstra\xdfe 172", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "4. Datenerfassung auf unserer Website"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Cookies"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die meisten der von uns verwendeten Cookies sind so genannte \u201CSession-Cookies\u201D. Sie werden nach Ende Ihres Besuchs automatisch gel\xf6scht. Andere Cookies bleiben auf Ihrem Endger\xe4t gespeichert bis Sie diese l\xf6schen. Diese Cookies erm\xf6glichen es uns, Ihren Browser beim n\xe4chsten Besuch wiederzuerkennen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen Ihren Browser so einstellen, dass Sie \xfcber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f\xfcr bestimmte F\xe4lle oder generell ausschlie\xdfen sowie das automatische L\xf6schen der Cookies beim Schlie\xdfen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit\xe4t dieser Website eingeschr\xe4nkt sein.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Cookies, die zur Durchf\xfchrung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erw\xfcnschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerkl\xe4rung gesondert behandelt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "5. Analyse Tools und Werbung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Analytics"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), 'Google Analytics verwendet so genannte "Cookies". Das sind Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm\xf6glichen. Die durch den Cookie erzeugten Informationen \xfcber Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert.', /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "IP Anonymisierung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europ\xe4ischen Union oder in anderen Vertragsstaaten des Abkommens \xfcber den Europ\xe4ischen Wirtschaftsraum vor der \xdcbermittlung in die USA gek\xfcrzt. Nur in Ausnahmef\xe4llen wird die volle IP-Adresse an einen Server von Google in den USA \xfcbertragen und dort gek\xfcrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xfcber die Websiteaktivit\xe4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xfcber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser \xfcbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xfchrt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Browser Plugin"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht s\xe4mtliche Funktionen dieser Website vollumf\xe4nglich werden nutzen k\xf6nnen. Sie k\xf6nnen dar\xfcber hinaus die Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verf\xfcgbare Browser-Plugin herunterladen und installieren: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://tools.google.com/dlpage/gaoptout?hl=de"
        }, "https://tools.google.com/dlpage/gaoptout?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Widerspruch gegen Datenerfassung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zuk\xfcnftigen Besuchen dieser Website verhindert: Google Analytics deaktivieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://support.google.com/analytics/answer/6004245?hl=de"
        }, "https://support.google.com/analytics/answer/6004245?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Auftragsdatenverarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die strengen Vorgaben der deutschen Datenschutzbeh\xf6rden bei der Nutzung von Google Analytics vollst\xe4ndig um."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "6. Plugins und Tools"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "YouTube"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unsere Website nutzt Plugins der von Google betriebenen Seite YouTube. Betreiber der Seiten ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie in Ihrem YouTube-Account eingeloggt sind, erm\xf6glichen Sie YouTube, Ihr Surfverhalten direkt Ihrem pers\xf6nlichen Profil zuzuordnen. Dies k\xf6nnen Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von YouTube unter: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy"
        }, "https://www.google.de/intl/de/policies/privacy")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Maps"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Seite nutzt \xfcber eine API den Kartendienst Google Maps. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Daten\xfcbertragung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy/"
        }, "https://www.google.de/intl/de/policies/privacy/"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\xa0", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h4", null, "Pflichtinformationen gem. Art. 12 ff. DS-GVO"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Kontaktdaten des Verantwortlichen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Name: Peter", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Vorname: Wildner", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: NIVONA Apparate GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://peter.wildner@nivona.com"
        }, "peter.wildner@nivona.com")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten des Datenschutzbeauftragten", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: Sigmundstra\xdfe 172; 90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Woher beziehen wir Ihre personenbezogenen Daten?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Erhebung Ihrer Daten findet grunds\xe4tzlich bei Ihnen selbst statt. Die Verarbeitung der von Ihnen \xfcberlassenen personenbezogenen Daten ist zur Erf\xfcllung der vertraglichen Pflichten, die sich aus dem mit uns geschlossenen Vertrag ergeben, notwendig. Aufgrund Ihrer Mitwirkungspflichten ist es unumg\xe4nglich die von uns angeforderten personenbezogenen Daten zur Verf\xfcgung zu stellen, da wir ansonsten unseren vertraglichen Pflichten nicht nachkommen k\xf6nnen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen vorvertraglicher Ma\xdfnahmen (z. B. Stammdatenerfassung im Interessentenprozess) ist die Bereitstellung Ihrer personenbezogenen Daten notwendig. Sollten die angeforderten Daten nicht von Ihnen bereitgestellt werden, kann ein Vertrag nicht abgeschlossen werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Erbringung unserer Dienstleistungen kann es erforderlich sein, personenbezogene Daten zu verarbeiten, die wir von anderen Unternehmen oder sonstigen Dritten, z. B. Finanz\xe4mtern, Ihren Gesch\xe4ftspartner o. \xe4. zul\xe4ssigerweise und zu dem jeweiligen Zweck erhalten haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weiterhin verarbeiten wir ggf. personenbezogene Daten aus \xf6ffentlich zug\xe4nglichen Quellen, z. B. Internetauftritten, die wir zul\xe4ssigerweise und nur zu dem jeweiligen Vertragszweck nutzen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zwecke und Rechtsgrundlagen der Verarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die von Ihnen \xfcberlassenen personenbezogenen Daten werden im Einklang mit den Bestimmungen der europ\xe4ischen Datenschutzverordnung (DS-GVO) und dem Bundesdatenschutzgesetz (BDSG) verarbeitet:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund einer Einwilligung (gem. Art. 6 Abs. 1 Lit. a DS-GVO)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Verarbeitung personenbezogener Daten ergeben sich aus der Erteilung einer Einwilligung. Eine erteilte Einwilligung kann jederzeit von Ihnen mit Wirkung f\xfcr die Zukunft widerrufen werden. Auch Einwilligungen, die vor der Geltung der DS-GVO (25. Mai 2018) erteilt worden sind, k\xf6nnen widerrufen werden. Verarbeitungen, die vor dem Widerruf erfolgt sind, bleiben vom Widerruf unber\xfchrt. Beispiel: Zusendung eines Newsletters, Einwilligung zur Weitergabe der von Ihnen \xfcberlassenen Daten auf Ihren Wunsch hin an Dritte (z. B. Banken, Versicherungen, Anteilseigner etc.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zur Erf\xfcllung von vertraglichen Pflichten (gem. Art. 6 Abs. 1 Lit. b DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Datenverarbeitung ergeben sich zum einen aus der Einleitung vorvertraglicher Ma\xdfnahmen, die einer vertraglich geregelten Gesch\xe4ftsbeziehung vorausgehen und zum anderen zur Erf\xfcllung der Pflichten aus dem mit Ihnen geschlossenen Vertrag.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund gesetzlicher Vorgaben (gem. Art. 6 Abs.1 Lit. c DS-GVO) oder im \xf6ffentlichen Interesse (gem. Art. 6 Abs.1 Lit. e DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Datenverarbeitung ergeben sich aus gesetzlichen Vorgaben oder liegen im \xf6ffentlichen Interesse (z. B. Einhaltung von Aufbewahrungspflichten, Nachweis der Einhaltung von Hinweis- und Informationspflichten des Steuerberaters).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Im Rahmen der Interessenabw\xe4gung (gem. Art. 6 Abs. 1 Lit. f DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Verarbeitung ergeben sich aus der Wahrung unserer berechtigten Interessen. Es kann erforderlich sein, die von Ihnen \xfcberlassenen Daten \xfcber die eigentliche Erf\xfcllung des Vertrages hinaus zu verarbeiten. Unser berechtigtes Interesse kann zur Begr\xfcndung der weiteren Verarbeitung der von Ihnen \xfcberlassenen Daten herangezogen werden, sofern Ihre Interessen oder Grundrechte und Grundfreiheiten nicht \xfcberwiegen. Unser berechtigtes Interesse kann im Einzelfall sein: Geltendmachung rechtlicher Anspr\xfcche, Abwehr von Haftungsanspr\xfcchen, Verhinderung von Straftaten.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wer erh\xe4lt die von Ihnen \xfcberlassenen personenbezogenen Daten?", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Innerhalb unseres Unternehmens erhalten diejenigen Bereiche Zugriff auf die von Ihnen \xfcberlassenen personenbezogenen Daten, die diese zur Erf\xfcllung der vertraglichen und gesetzlichen Pflichten ben\xf6tigen und die zur Verarbeitung dieser Daten berechtigt sind.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "In Erf\xfcllung des mit Ihnen geschlossenen Vertrages erhalten ausschlie\xdflich diejenigen Stellen die von Ihnen \xfcberlassenen Daten, die diese aus gesetzlichen Gr\xfcnden ben\xf6tigen, z. B. Finanzbeh\xf6rden, Sozialversicherungstr\xe4ger, zust\xe4ndige Beh\xf6rden und Gerichte.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Empf\xe4nger erhalten die von Ihnen \xfcberlassenen Daten nur auf Ihren Wunsch hin, wenn Sie uns die hierf\xfcr notwendige Einwilligung erteilen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen unserer Leistungserbringung beauftragen wir Auftragsverarbeiter, die zur Erf\xfcllung der vertraglichen Pflichten beitragen, z. B. EDV-Partner, Aktenvernichter, Fachh\xe4ndler etc. Diese Auftragsverarbeiter werden von uns vertraglich zur Einhaltung der Vorgaben der DS-GVO und des BDSG verpflichtet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Werden die von Ihnen \xfcberlassenen Daten an Drittl\xe4nder oder internationale Organisationen \xfcbermittelt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Eine \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation erfolgt in keinem Fall. Sollten Sie im Einzelfall die \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation w\xfcnschen, f\xfchren wir dies nur nach Ihrer schriftlichen Einwilligung durch."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Findet automatisierte Entscheidungsfindung einschlie\xdflich Profiling statt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Verarbeitung der von Ihnen \xfcberlassenen Daten kommt keine vollautomatisierte Entscheidungsfindung (einschlie\xdflich Profiling) gem. Art. 22 DS-GVO zum Einsatz."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Dauer der Verarbeitung (Kriterien der L\xf6schung)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Verarbeitung der von Ihnen \xfcberlassenen Daten erfolgt so lange, wie sie zur Erreichung des vertraglich vereinbarten Zweckes notwendig ist, grunds\xe4tzlich so lange das Vertragsverh\xe4ltnis mit Ihnen besteht. Nach der Beendigung des Vertragsverh\xe4ltnisses werden die von Ihnen \xfcberlassenen Daten zur Einhaltung gesetzlicher Aufbewahrungspflichten oder aufgrund unserer berechtigten Interessen verarbeitet. Nach dem Ablauf der gesetzlichen Aufbewahrungsfristen und/oder dem Wegfall unserer berechtigten Interessen werden die von Ihnen \xfcberlassenen Daten gel\xf6scht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Voraussichtliche Fristen der uns treffenden Aufbewahrungspflichten und unserer berechtigten Interessen:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erf\xfcllung handels- und steuerrechtlicher Aufbewahrungsfristen. Die dort vorgegebenen Fristen zur Aufbewahrung bzw. Dokumentation betragen zwei bis zehn Jahre.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erhaltung von Beweismitteln im Rahmen der Verj\xe4hrungsvorschriften. Nach den \xa7\xa7 195 ff. des B\xfcrgerlichen Gesetzbuches (BGB) k\xf6nnen diese Verj\xe4hrungsfristen bis zu 30 Jahre betragen, wobei die regelm\xe4\xdfige Verj\xe4hrungsfrist drei Jahre betr\xe4gt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft \xfcber Ihre Rechte", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Auskunft gem. Art. 15 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, auf Antrag unentgeltlich Auskunft zu erhalten, ob und welche Daten \xfcber Sie gespeichert sind und zu welchem Zweck die Speicherung erfolgt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Berichtigung gem. Art. 16 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen unverz\xfcglich die Berichtigung Ihrer unrichtigen personenbezogenen Daten zu verlangen. Unter Ber\xfccksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollst\xe4ndigung unvollst\xe4ndiger personenbezogener Daten \u2014 auch mittels einer erg\xe4nzenden Erkl\xe4rung \u2014 zu verlangen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf L\xf6schung (\u201ERecht auf Vergessenwerden\u201C) gem. Art. 17 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen zu verlangen, dass Ihre Daten unverz\xfcglich gel\xf6scht werden. Der Verantwortliche ist verpflichtet, personenbezogene Daten unverz\xfcglich zu l\xf6schen, sofern einer der folgenden Gr\xfcnde zutrifft:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Zwecke, f\xfcr die die personenbezogenen Daten erhoben wurden, entfallen", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Sie widerrufen Ihre Einwilligung der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Sie widersprechen der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Die personenbezogenen Daten wurden unrechtm\xe4\xdfig verarbeitet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "e) Die L\xf6schung der personenbezogenen Daten ist zur Erf\xfcllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "f) Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gem\xe4\xdf Artikel 8 Absatz 1 erhoben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Einschr\xe4nkung der Verarbeitung gem. Art. 18 DS-GVO &. \xa7 35 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die Einschr\xe4nkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Die Richtigkeit der personenbezogenen Daten wird von Ihnen angezweifelt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Die Verarbeitung ist unrechtm\xe4\xdfig; Sie lehnen eine L\xf6schung jedoch ab.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Personenbezogene Daten werden f\xfcr die Zwecke der Verarbeitung nicht l\xe4nger ben\xf6tigt; Sie ben\xf6tigen die Daten jedoch zur Geltendmachung, Aus\xfcbung oder Verteidigung von Rechtsanspr\xfcchen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Sie haben Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt. Solange noch nicht feststeht, ob die berechtigten Gr\xfcnde des Verantwortlichen Ihnen gegen\xfcber \xfcberwiegen, wird die Verarbeitung eingeschr\xe4nkt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Daten\xfcbertragbarkeit gem. Art. 20 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die von Ihnen bereitgestellten Daten in einem strukturierten, g\xe4ngigen und maschinenlesbaren Format von dem Verantwortlichen zu erhalten. Eine Weiterleitung an einen andern Verantwortlichen darf von uns nicht behindert werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Widerspruchsrecht gem. Art. 21 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hierzu wenden Sie sich bitte an den Verantwortlichen der Verarbeitung (s. o.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Beschwerderecht bei der Aufsichtsbeh\xf6rde gem. Art. 13 Abs. 2 Lit. d, 77 DS-GVO", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "i. V. m \xa7 19 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen die DS-GVO verst\xf6\xdft, haben Sie das Recht Beschwerde bei der Aufsichtsbeh\xf6rde einzulegen. Hierzu wenden Sie sich bitte an die zust\xe4ndige Aufsichtsbeh\xf6rde", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Zur\xfcckziehen der Einwilligung gem. Art. 7 Abs. 3 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beruht die Verarbeitung auf Ihrer Einwilligung gem. Art. 6 Abs. 1 Lit. a oder Art. 9 Abs. 2 Lit. a (Verarbeitung besonderer Kategorien personenbezogener Daten), sind Sie jederzeit dazu berechtigt die zweckm\xe4\xdfig gebundene Einwilligung zur\xfcckzuziehen, ohne dass die Rechtm\xe4\xdfigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung ber\xfchrt wird. ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null))))))))));
    }
}










class $45038dfb870da572$export$f33daeb3232faaeb {
    constructor(options, minDate){
        this.options = options;
        this.minDate = minDate;
        this.haendlerList = [];
        this.isLoading = true;
        this.fileNames = [];
        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).GetHaendler().then((data)=>{
            this.haendlerList = data;
            this.initComponents();
            this.isLoading = false;
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        });
    }
    render() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, this.isLoading ? new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)(4) : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "starterset-comp"
        }, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-vorname"
            }, "Vorname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.vornameInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-nachname"
            }, "Nachname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.nachnameInput)
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-stra\xdfe"
        }, "Stra\xdfe und Hausnummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stra\u00dfeHausnummerInput), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-plz"
            }, "Postleitzahl*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.postleitzahlInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-stadt"
            }, "Stadt*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stadtInput)
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", null, "Unternehmen / Firma"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.unternehmenInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-email"
        }, "E-Mail-Adresse*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.emailInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-seriennummer"
        }, "Ger\xe4te Seriennummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.geraeteSeriennummer), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-haendler"
        }, "H\xe4ndler, bei dem die Maschine gekauft wurde*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $92830e10ec4ab123$export$c006741a65b06687)({
            class: "large-size-input-comp",
            data: this.haendlerList.map((haendler)=>({
                    text: haendler.Matchcode + " - " + haendler.LieferStrasse + " - " + haendler.LieferPLZ + " " + haendler.LieferOrt,
                    value: haendler.Kto
                })),
            value: this.haendlerKto,
            onChange: (value)=>{
                this.haendlerKto = value ?? "";
            }
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-kaufdatum"
        }, "Wann wurde die Maschine gekauft*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $c9acd7efe2a931e2$export$19285a5b05c4ea7c)({
            class: "large-size-input-comp",
            placeholder: "tt.mm.jjjj",
            max: new Date(),
            min: this.minDate,
            value: this.kaufdatum,
            onChange: (value)=>{
                this.kaufdatum = value;
            }
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-rechnung"
        }, "Rechnung*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("input", {
            type: "file",
            id: "filesToUpload",
            style: "position: absolute; top: -10000px;",
            class: "large-size-input-comp",
            multiple: true,
            change: (e, node)=>{
                const el = node.dom;
                this.fileNames = [];
                for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button large-size-input-comp",
            style: "opacity: 1",
            dragenter: (e)=>{
                e.preventDefault();
                e.target.classList.add("drag-over");
            },
            dragover: (e)=>e.preventDefault(),
            dragleave: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
            },
            drop: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
                const droppedFiles = e.dataTransfer?.files;
                if (droppedFiles != null) {
                    if (droppedFiles.length > 1) {
                        alert("Sie d\xfcrfen maximal eine Datei hochladen!");
                        return;
                    }
                    // const fileName = droppedFiles[0].name;
                    const el = document.querySelector("#filesToUpload");
                    el.files = droppedFiles;
                    this.fileNames = [];
                    for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                } else this.fileNames = [];
            },
            click: ()=>{
                const el = document.querySelector("#filesToUpload");
                el.click();
            }
        }, "Datei ausw\xe4hlen / drag & drop"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("label", {
            style: "font-size: 0.7em; font-weight: normal"
        }, "Maximal 5MB; M\xf6gliche Dateien: jpg, png, pdf"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, this.fileNames.length <= 0 ? undefined : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 1em"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hochzuladende Dateien:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("ul", null, this.fileNames.map((file)=>/*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("li", {
                style: "font-size: 0.8em; font-weight: normal"
            }, file)))))), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, "Die mit einem Stern (*) markierten Felder sind Pflichtfelder."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-datenschutz"
        }, "Datenschutz*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Ich habe die Datenschutzbestimmungen zur Kenntnis genommen.",
            value: this.checkedDatenschutz,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedDatenschutz = value;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "info-button",
            click: ()=>{
                (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
                    header: "Datenschutzbestimmungen",
                    content: this.getDatenschutzbestimmungenText(),
                    footer: (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok()
                });
            }
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("img", {
            src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/images/information.png"),
            style: "max-width: 0.8rem; max-height: 0.8rem; opacity: 1"
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Hiermit stimme ich zu, dass die NIVONA Apparate GmbH, S\xfcdwestpark 49, 90449 N\xfcrnberg, meine Daten f\xfcr werbliche Zwecke und im Rahmen der Aktion nutzen darf, um mich zu kontaktieren. Diese Zustimmung kann ich jederzeit bei der NIVONA Apparate GmbH widerrufen.",
            value: this.checkedPermission,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedPermission = value;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp",
            style: "text-align:center"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button send-button",
            style: "font-size: 0.9em; height: auto; padding: 0.6vw",
            click: ()=>{
                if (this.allRequiredFieldsFilledIn()) {
                    if (this.checkEmail(this.email)) {
                        const gm = {
                            ID: (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newGuid(),
                            Vorname: this.vorname,
                            Nachname: this.nachname,
                            "Stra\xdfeHausnummer": this.stra\u00dfeHausnummer,
                            PLZ: this.plz,
                            Stadt: this.stadt,
                            Unternehmen: this.unternehmen,
                            Email: this.email,
                            Seriennummer: this.seriennummer,
                            HaendlerKto: this.haendlerList.find((haendler)=>{
                                if (haendler.Kto === this.haendlerKto) return true;
                                return false;
                            })?.Kto,
                            Kaufdatum: this.kaufdatum,
                            SourcePage: this.options.Name,
                            HasContactPermission: this.checkedPermission == undefined ? 0 : this.checkedPermission === false ? 0 : -1
                        };
                        const files = document.querySelector("#filesToUpload").files;
                        const imgFormData = new FormData();
                        for(let i = 0; i < files.length; i++)imgFormData.append("files", files[i]);
                        if (gm.ID != null) {
                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).showLoading();
                            (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).IsValidSeriennummer(gm.Seriennummer ?? "", this.options.Name).then((result)=>{
                                if (result == "Seriennummer g\xfcltig") (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post((0, $fb350c3721d80fcd$export$791c4e50320e809e)("Landing/SendGarantieKaufbeleg?ID=" + gm.ID + "&SourcePage=" + this.options.Name), imgFormData, {}).then((val)=>{
                                    if (val.data === "OK") (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).SendGarantieCustomerData(gm).then((guid)=>{
                                        alert("Das Senden Ihrer Daten war erfolgreich! Sie erhalten in K\xfcrze eine Best\xe4tigung per Email.");
                                        location.reload();
                                    }).catch((error)=>{
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        const x = error?.response?.data ?? error ?? "unkown";
                                        alert(x);
                                    });
                                    else if (val.data === "FILES") {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("\xdcberpr\xfcfen Sie bitte, ob mit ihren hochgeladenen Dateien alles in Ordnung ist!");
                                    } else if (val.data === "FILEENDUNG") {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("\xdcberpr\xfcfen Sie bitte, ob Ihre hochgeladene Datei intakt ist und ob sie das richtige Format hat.\nErlaubt sind: .jpg, .png, .pdf!");
                                    } else {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("Ein Fehler ist aufgetreten, bitte versuchen Sie es in wenigen Augenblick erneut!");
                                    }
                                }).catch((error)=>{
                                    (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                    alert("\xdcberpr\xfcfen Sie bitte Ihre Datei auf zul\xe4ssige Gr\xf6\xdfe und zul\xe4ssige Dateitypen!");
                                });
                                else {
                                    (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                    alert(result);
                                }
                            }).catch((error)=>{
                                (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                const x = error?.response?.data ?? error ?? "unkown";
                                alert(x);
                            });
                        }
                    } else alert("Bitte geben Sie eine g\xfcltige Email-Adresse ein!");
                } else {
                    this.highlightAllNotFilledInRequired();
                    alert("Bitte f\xfcllen Sie alle geforderten Felder aus!");
                }
            }
        }, "Absenden")))));
    }
    initComponents() {
        this.vornameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Vorname eingeben...",
            onChange: (value)=>{
                this.vorname = value ?? "";
            }
        });
        this.nachnameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Nachname eingeben...",
            onChange: (value)=>{
                this.nachname = value ?? "";
            }
        });
        this.stra\u00dfeHausnummerInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Stra\xdfe und Hausnummer eingeben...",
            onChange: (value)=>{
                this.stra\u00dfeHausnummer = value ?? "";
            }
        });
        this.postleitzahlInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Postleitzahl eingeben...",
            onChange: (value)=>{
                const val = value ?? "0";
                if (isNaN(Number(val))) alert("Keine g\xfcltige Postleitzahl!");
                else this.plz = Number(val);
            }
        });
        this.unternehmenInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Unternehmen / Firma eingeben...",
            onChange: (value)=>{
                this.unternehmen = value ?? "";
            }
        });
        this.stadtInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Stadt eingeben...",
            onChange: (value)=>{
                this.stadt = value ?? "";
            }
        });
        this.emailInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "E-Mail-Adresse eingeben...",
            onChange: (value)=>{
                this.email = value ?? "";
            }
        });
        this.geraeteSeriennummer = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Ger\xe4te Seriennummer eingeben...",
            onChange: (value)=>{
                this.seriennummer = value ?? "";
            }
        });
    // this.haendlerSelection = new SelectComponent({
    //     data: this.haendlerList.map((haendler) => ({text: haendler.Matchcode + " - " + haendler.LieferStrasse + " - " + haendler.LieferPLZ + " " + haendler.LieferOrt, value: haendler.Kto})),
    //     class: "large-size-input-comp",
    //     value: this.haendlerKto,
    //     onChange: (value) => {
    //         this.haendlerKto = value ?? "";
    //     }
    // });
    }
    allRequiredFieldsFilledIn() {
        if (this.vorname == undefined) return false;
        if (this.nachname == undefined) return false;
        if (this.stra\u00dfeHausnummer == undefined) return false;
        if (this.plz == undefined) return false;
        if (this.stadt == undefined) return false;
        if (this.email == undefined) return false;
        if (this.seriennummer == undefined) return false;
        if (this.haendlerKto == undefined || this.haendlerKto === "") return false;
        if (this.kaufdatum == undefined) return false;
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) return false;
        if (this.checkedDatenschutz == undefined || this.checkedDatenschutz === false) return false;
         /*if (this.checkedPermission == undefined) {
            return false;
        }*/ 
        return true;
    }
    highlightAllNotFilledInRequired() {
        this.undoStyleChangesBeforehand();
        if (this.vorname == undefined) {
            document.getElementById("span-vorname").style.color = "red";
            document.getElementById("span-vorname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.nachname == undefined) {
            document.getElementById("span-nachname").style.color = "red";
            document.getElementById("span-nachname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stra\u00dfeHausnummer == undefined) {
            document.getElementById("span-stra\xdfe").style.color = "red";
            document.getElementById("span-stra\xdfe").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.plz == undefined) {
            document.getElementById("span-plz").style.color = "red";
            document.getElementById("span-plz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stadt == undefined) {
            document.getElementById("span-stadt").style.color = "red";
            document.getElementById("span-stadt").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.email == undefined) {
            document.getElementById("span-email").style.color = "red";
            document.getElementById("span-email").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.seriennummer == undefined) {
            document.getElementById("span-seriennummer").style.color = "red";
            document.getElementById("span-seriennummer").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.haendlerKto == undefined || this.haendlerKto === "") {
            document.getElementById("span-haendler").style.color = "red";
            document.getElementById("span-haendler").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.kaufdatum == undefined) {
            document.getElementById("span-kaufdatum").style.color = "red";
            document.getElementById("span-kaufdatum").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) {
            document.getElementById("span-rechnung").style.color = "red";
            document.getElementById("span-rechnung").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.checkedDatenschutz == undefined) {
            document.getElementById("span-datenschutz").style.color = "red";
            document.getElementById("span-datenschutz").style.textShadow = "0.7px 0.7px 0.5px black";
        } /*if (this.checkedPermission == undefined) {
            (document.getElementById("span-datenschutz") as HTMLInputElement).style.color = "red";
            (document.getElementById("span-datenschutz") as HTMLInputElement).style.textShadow = "0.7px 0.7px 0.5px black";
        }*/ 
    }
    undoStyleChangesBeforehand() {
        document.getElementById("span-vorname").style.color = "black";
        document.getElementById("span-vorname").style.textShadow = "none";
        document.getElementById("span-nachname").style.color = "black";
        document.getElementById("span-nachname").style.textShadow = "none";
        document.getElementById("span-stra\xdfe").style.color = "black";
        document.getElementById("span-stra\xdfe").style.textShadow = "none";
        document.getElementById("span-plz").style.color = "black";
        document.getElementById("span-plz").style.textShadow = "none";
        document.getElementById("span-stadt").style.color = "black";
        document.getElementById("span-stadt").style.textShadow = "none";
        document.getElementById("span-email").style.color = "black";
        document.getElementById("span-email").style.textShadow = "none";
        document.getElementById("span-seriennummer").style.color = "black";
        document.getElementById("span-seriennummer").style.textShadow = "none";
        document.getElementById("span-haendler").style.color = "black";
        document.getElementById("span-haendler").style.textShadow = "none";
        document.getElementById("span-kaufdatum").style.color = "black";
        document.getElementById("span-kaufdatum").style.textShadow = "none";
        document.getElementById("span-rechnung").style.color = "black";
        document.getElementById("span-rechnung").style.textShadow = "none";
        document.getElementById("span-datenschutz").style.color = "black";
        document.getElementById("span-datenschutz").style.textShadow = "none";
    }
    checkEmail(email) {
        if (email.indexOf("@") === -1) return false;
        const split_arr = email.split("@");
        if (split_arr[0].length <= 0) return false;
        if (split_arr[1].length <= 0) return false;
        return true;
    }
    getDatenschutzbestimmungenText() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-sections"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section  pos-0 cms-section-default",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section-default boxed"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block  pos-0 cms-block-text",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container",
            style: "padding: 20px 20px 20px 20px;"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container-row row cms-row "
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "col-12",
            "data-cms-element-id": "eb20ee63af314345b702de452230f323"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-element-text"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("hr", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "1. Datenschutz auf einen Blick"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Allgemeine Hinweise"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die folgenden Hinweise geben einen einfachen \xdcberblick dar\xfcber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Ausf\xfchrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef\xfchrten Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Analyse-Tools und Tools von Drittanbietern", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zur\xfcckverfolgt werden. Sie k\xf6nnen dieser Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen dazu finden Sie in der folgenden Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen dieser Analyse widersprechen. \xdcber die Widerspruchsm\xf6glichkeiten werden wir Sie in dieser Datenschutzerkl\xe4rung informieren."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "2. Allgemeine Hinweise und Pflichtinformationen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Datenschutz"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers\xf6nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Die vorliegende Datenschutzerkl\xe4rung erl\xe4utert, welche Daten wir erheben und wof\xfcr wir sie nutzen. Sie erl\xe4utert auch, wie und zu welchem Zweck das geschieht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir weisen darauf hin, dass die Daten\xfcbertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitsl\xfccken aufweisen kann. Ein l\xfcckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xf6glich.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hinweis zur verantwortlichen Stelle", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die verantwortliche Stelle f\xfcr die Datenverarbeitung auf dieser Website ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Nivona Apparte GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 0911 2526630", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://info@nivona.com"
        }, "info@nivona.com"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Verantwortliche Stelle ist die nat\xfcrliche oder juristische Person, die allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. \xc4.) entscheidet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Widerruf Ihrer Einwilligung zur Datenverarbeitung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Viele Datenverarbeitungsvorg\xe4nge sind nur mit Ihrer ausdr\xfccklichen Einwilligung m\xf6glich. Sie k\xf6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtm\xe4\xdfigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Falle datenschutzrechtlicher Verst\xf6\xdfe steht dem Betroffenen ein Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde zu. Zust\xe4ndige Aufsichtsbeh\xf6rde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten k\xf6nnen folgendem Link entnommen werden: https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Recht auf Daten\xfcbertragbarkeit", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xfcllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g\xe4ngigen, maschinenlesbaren Format aush\xe4ndigen zu lassen. Sofern Sie die direkte \xdcbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft, Sperrung, L\xf6schung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xfcber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xe4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder L\xf6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xf6nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "3. Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Gesetzlich vorgeschriebener Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben f\xfcr unser Unternehmen einen Datenschutzbeauftragten bestellt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sigmundstra\xdfe 172", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "4. Datenerfassung auf unserer Website"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Cookies"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die meisten der von uns verwendeten Cookies sind so genannte \u201CSession-Cookies\u201D. Sie werden nach Ende Ihres Besuchs automatisch gel\xf6scht. Andere Cookies bleiben auf Ihrem Endger\xe4t gespeichert bis Sie diese l\xf6schen. Diese Cookies erm\xf6glichen es uns, Ihren Browser beim n\xe4chsten Besuch wiederzuerkennen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen Ihren Browser so einstellen, dass Sie \xfcber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f\xfcr bestimmte F\xe4lle oder generell ausschlie\xdfen sowie das automatische L\xf6schen der Cookies beim Schlie\xdfen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit\xe4t dieser Website eingeschr\xe4nkt sein.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Cookies, die zur Durchf\xfchrung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erw\xfcnschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerkl\xe4rung gesondert behandelt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "5. Analyse Tools und Werbung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Analytics"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), 'Google Analytics verwendet so genannte "Cookies". Das sind Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm\xf6glichen. Die durch den Cookie erzeugten Informationen \xfcber Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert.', /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "IP Anonymisierung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europ\xe4ischen Union oder in anderen Vertragsstaaten des Abkommens \xfcber den Europ\xe4ischen Wirtschaftsraum vor der \xdcbermittlung in die USA gek\xfcrzt. Nur in Ausnahmef\xe4llen wird die volle IP-Adresse an einen Server von Google in den USA \xfcbertragen und dort gek\xfcrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xfcber die Websiteaktivit\xe4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xfcber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser \xfcbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xfchrt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Browser Plugin"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht s\xe4mtliche Funktionen dieser Website vollumf\xe4nglich werden nutzen k\xf6nnen. Sie k\xf6nnen dar\xfcber hinaus die Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verf\xfcgbare Browser-Plugin herunterladen und installieren: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://tools.google.com/dlpage/gaoptout?hl=de"
        }, "https://tools.google.com/dlpage/gaoptout?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Widerspruch gegen Datenerfassung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zuk\xfcnftigen Besuchen dieser Website verhindert: Google Analytics deaktivieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://support.google.com/analytics/answer/6004245?hl=de"
        }, "https://support.google.com/analytics/answer/6004245?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Auftragsdatenverarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die strengen Vorgaben der deutschen Datenschutzbeh\xf6rden bei der Nutzung von Google Analytics vollst\xe4ndig um."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "6. Plugins und Tools"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "YouTube"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unsere Website nutzt Plugins der von Google betriebenen Seite YouTube. Betreiber der Seiten ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie in Ihrem YouTube-Account eingeloggt sind, erm\xf6glichen Sie YouTube, Ihr Surfverhalten direkt Ihrem pers\xf6nlichen Profil zuzuordnen. Dies k\xf6nnen Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von YouTube unter: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy"
        }, "https://www.google.de/intl/de/policies/privacy")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Maps"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Seite nutzt \xfcber eine API den Kartendienst Google Maps. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Daten\xfcbertragung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy/"
        }, "https://www.google.de/intl/de/policies/privacy/"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\xa0", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h4", null, "Pflichtinformationen gem. Art. 12 ff. DS-GVO"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Kontaktdaten des Verantwortlichen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Name: Peter", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Vorname: Wildner", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: NIVONA Apparate GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://peter.wildner@nivona.com"
        }, "peter.wildner@nivona.com")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten des Datenschutzbeauftragten", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: Sigmundstra\xdfe 172; 90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Woher beziehen wir Ihre personenbezogenen Daten?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Erhebung Ihrer Daten findet grunds\xe4tzlich bei Ihnen selbst statt. Die Verarbeitung der von Ihnen \xfcberlassenen personenbezogenen Daten ist zur Erf\xfcllung der vertraglichen Pflichten, die sich aus dem mit uns geschlossenen Vertrag ergeben, notwendig. Aufgrund Ihrer Mitwirkungspflichten ist es unumg\xe4nglich die von uns angeforderten personenbezogenen Daten zur Verf\xfcgung zu stellen, da wir ansonsten unseren vertraglichen Pflichten nicht nachkommen k\xf6nnen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen vorvertraglicher Ma\xdfnahmen (z. B. Stammdatenerfassung im Interessentenprozess) ist die Bereitstellung Ihrer personenbezogenen Daten notwendig. Sollten die angeforderten Daten nicht von Ihnen bereitgestellt werden, kann ein Vertrag nicht abgeschlossen werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Erbringung unserer Dienstleistungen kann es erforderlich sein, personenbezogene Daten zu verarbeiten, die wir von anderen Unternehmen oder sonstigen Dritten, z. B. Finanz\xe4mtern, Ihren Gesch\xe4ftspartner o. \xe4. zul\xe4ssigerweise und zu dem jeweiligen Zweck erhalten haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weiterhin verarbeiten wir ggf. personenbezogene Daten aus \xf6ffentlich zug\xe4nglichen Quellen, z. B. Internetauftritten, die wir zul\xe4ssigerweise und nur zu dem jeweiligen Vertragszweck nutzen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zwecke und Rechtsgrundlagen der Verarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die von Ihnen \xfcberlassenen personenbezogenen Daten werden im Einklang mit den Bestimmungen der europ\xe4ischen Datenschutzverordnung (DS-GVO) und dem Bundesdatenschutzgesetz (BDSG) verarbeitet:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund einer Einwilligung (gem. Art. 6 Abs. 1 Lit. a DS-GVO)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Verarbeitung personenbezogener Daten ergeben sich aus der Erteilung einer Einwilligung. Eine erteilte Einwilligung kann jederzeit von Ihnen mit Wirkung f\xfcr die Zukunft widerrufen werden. Auch Einwilligungen, die vor der Geltung der DS-GVO (25. Mai 2018) erteilt worden sind, k\xf6nnen widerrufen werden. Verarbeitungen, die vor dem Widerruf erfolgt sind, bleiben vom Widerruf unber\xfchrt. Beispiel: Zusendung eines Newsletters, Einwilligung zur Weitergabe der von Ihnen \xfcberlassenen Daten auf Ihren Wunsch hin an Dritte (z. B. Banken, Versicherungen, Anteilseigner etc.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zur Erf\xfcllung von vertraglichen Pflichten (gem. Art. 6 Abs. 1 Lit. b DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Datenverarbeitung ergeben sich zum einen aus der Einleitung vorvertraglicher Ma\xdfnahmen, die einer vertraglich geregelten Gesch\xe4ftsbeziehung vorausgehen und zum anderen zur Erf\xfcllung der Pflichten aus dem mit Ihnen geschlossenen Vertrag.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund gesetzlicher Vorgaben (gem. Art. 6 Abs.1 Lit. c DS-GVO) oder im \xf6ffentlichen Interesse (gem. Art. 6 Abs.1 Lit. e DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Datenverarbeitung ergeben sich aus gesetzlichen Vorgaben oder liegen im \xf6ffentlichen Interesse (z. B. Einhaltung von Aufbewahrungspflichten, Nachweis der Einhaltung von Hinweis- und Informationspflichten des Steuerberaters).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Im Rahmen der Interessenabw\xe4gung (gem. Art. 6 Abs. 1 Lit. f DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Verarbeitung ergeben sich aus der Wahrung unserer berechtigten Interessen. Es kann erforderlich sein, die von Ihnen \xfcberlassenen Daten \xfcber die eigentliche Erf\xfcllung des Vertrages hinaus zu verarbeiten. Unser berechtigtes Interesse kann zur Begr\xfcndung der weiteren Verarbeitung der von Ihnen \xfcberlassenen Daten herangezogen werden, sofern Ihre Interessen oder Grundrechte und Grundfreiheiten nicht \xfcberwiegen. Unser berechtigtes Interesse kann im Einzelfall sein: Geltendmachung rechtlicher Anspr\xfcche, Abwehr von Haftungsanspr\xfcchen, Verhinderung von Straftaten.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wer erh\xe4lt die von Ihnen \xfcberlassenen personenbezogenen Daten?", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Innerhalb unseres Unternehmens erhalten diejenigen Bereiche Zugriff auf die von Ihnen \xfcberlassenen personenbezogenen Daten, die diese zur Erf\xfcllung der vertraglichen und gesetzlichen Pflichten ben\xf6tigen und die zur Verarbeitung dieser Daten berechtigt sind.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "In Erf\xfcllung des mit Ihnen geschlossenen Vertrages erhalten ausschlie\xdflich diejenigen Stellen die von Ihnen \xfcberlassenen Daten, die diese aus gesetzlichen Gr\xfcnden ben\xf6tigen, z. B. Finanzbeh\xf6rden, Sozialversicherungstr\xe4ger, zust\xe4ndige Beh\xf6rden und Gerichte.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Empf\xe4nger erhalten die von Ihnen \xfcberlassenen Daten nur auf Ihren Wunsch hin, wenn Sie uns die hierf\xfcr notwendige Einwilligung erteilen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen unserer Leistungserbringung beauftragen wir Auftragsverarbeiter, die zur Erf\xfcllung der vertraglichen Pflichten beitragen, z. B. EDV-Partner, Aktenvernichter, Fachh\xe4ndler etc. Diese Auftragsverarbeiter werden von uns vertraglich zur Einhaltung der Vorgaben der DS-GVO und des BDSG verpflichtet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Werden die von Ihnen \xfcberlassenen Daten an Drittl\xe4nder oder internationale Organisationen \xfcbermittelt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Eine \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation erfolgt in keinem Fall. Sollten Sie im Einzelfall die \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation w\xfcnschen, f\xfchren wir dies nur nach Ihrer schriftlichen Einwilligung durch."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Findet automatisierte Entscheidungsfindung einschlie\xdflich Profiling statt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Verarbeitung der von Ihnen \xfcberlassenen Daten kommt keine vollautomatisierte Entscheidungsfindung (einschlie\xdflich Profiling) gem. Art. 22 DS-GVO zum Einsatz."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Dauer der Verarbeitung (Kriterien der L\xf6schung)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Verarbeitung der von Ihnen \xfcberlassenen Daten erfolgt so lange, wie sie zur Erreichung des vertraglich vereinbarten Zweckes notwendig ist, grunds\xe4tzlich so lange das Vertragsverh\xe4ltnis mit Ihnen besteht. Nach der Beendigung des Vertragsverh\xe4ltnisses werden die von Ihnen \xfcberlassenen Daten zur Einhaltung gesetzlicher Aufbewahrungspflichten oder aufgrund unserer berechtigten Interessen verarbeitet. Nach dem Ablauf der gesetzlichen Aufbewahrungsfristen und/oder dem Wegfall unserer berechtigten Interessen werden die von Ihnen \xfcberlassenen Daten gel\xf6scht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Voraussichtliche Fristen der uns treffenden Aufbewahrungspflichten und unserer berechtigten Interessen:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erf\xfcllung handels- und steuerrechtlicher Aufbewahrungsfristen. Die dort vorgegebenen Fristen zur Aufbewahrung bzw. Dokumentation betragen zwei bis zehn Jahre.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erhaltung von Beweismitteln im Rahmen der Verj\xe4hrungsvorschriften. Nach den \xa7\xa7 195 ff. des B\xfcrgerlichen Gesetzbuches (BGB) k\xf6nnen diese Verj\xe4hrungsfristen bis zu 30 Jahre betragen, wobei die regelm\xe4\xdfige Verj\xe4hrungsfrist drei Jahre betr\xe4gt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft \xfcber Ihre Rechte", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Auskunft gem. Art. 15 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, auf Antrag unentgeltlich Auskunft zu erhalten, ob und welche Daten \xfcber Sie gespeichert sind und zu welchem Zweck die Speicherung erfolgt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Berichtigung gem. Art. 16 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen unverz\xfcglich die Berichtigung Ihrer unrichtigen personenbezogenen Daten zu verlangen. Unter Ber\xfccksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollst\xe4ndigung unvollst\xe4ndiger personenbezogener Daten \u2014 auch mittels einer erg\xe4nzenden Erkl\xe4rung \u2014 zu verlangen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf L\xf6schung (\u201ERecht auf Vergessenwerden\u201C) gem. Art. 17 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen zu verlangen, dass Ihre Daten unverz\xfcglich gel\xf6scht werden. Der Verantwortliche ist verpflichtet, personenbezogene Daten unverz\xfcglich zu l\xf6schen, sofern einer der folgenden Gr\xfcnde zutrifft:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Zwecke, f\xfcr die die personenbezogenen Daten erhoben wurden, entfallen", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Sie widerrufen Ihre Einwilligung der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Sie widersprechen der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Die personenbezogenen Daten wurden unrechtm\xe4\xdfig verarbeitet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "e) Die L\xf6schung der personenbezogenen Daten ist zur Erf\xfcllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "f) Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gem\xe4\xdf Artikel 8 Absatz 1 erhoben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Einschr\xe4nkung der Verarbeitung gem. Art. 18 DS-GVO &. \xa7 35 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die Einschr\xe4nkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Die Richtigkeit der personenbezogenen Daten wird von Ihnen angezweifelt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Die Verarbeitung ist unrechtm\xe4\xdfig; Sie lehnen eine L\xf6schung jedoch ab.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Personenbezogene Daten werden f\xfcr die Zwecke der Verarbeitung nicht l\xe4nger ben\xf6tigt; Sie ben\xf6tigen die Daten jedoch zur Geltendmachung, Aus\xfcbung oder Verteidigung von Rechtsanspr\xfcchen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Sie haben Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt. Solange noch nicht feststeht, ob die berechtigten Gr\xfcnde des Verantwortlichen Ihnen gegen\xfcber \xfcberwiegen, wird die Verarbeitung eingeschr\xe4nkt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Daten\xfcbertragbarkeit gem. Art. 20 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die von Ihnen bereitgestellten Daten in einem strukturierten, g\xe4ngigen und maschinenlesbaren Format von dem Verantwortlichen zu erhalten. Eine Weiterleitung an einen andern Verantwortlichen darf von uns nicht behindert werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Widerspruchsrecht gem. Art. 21 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hierzu wenden Sie sich bitte an den Verantwortlichen der Verarbeitung (s. o.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Beschwerderecht bei der Aufsichtsbeh\xf6rde gem. Art. 13 Abs. 2 Lit. d, 77 DS-GVO", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "i. V. m \xa7 19 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen die DS-GVO verst\xf6\xdft, haben Sie das Recht Beschwerde bei der Aufsichtsbeh\xf6rde einzulegen. Hierzu wenden Sie sich bitte an die zust\xe4ndige Aufsichtsbeh\xf6rde", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Zur\xfcckziehen der Einwilligung gem. Art. 7 Abs. 3 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beruht die Verarbeitung auf Ihrer Einwilligung gem. Art. 6 Abs. 1 Lit. a oder Art. 9 Abs. 2 Lit. a (Verarbeitung besonderer Kategorien personenbezogener Daten), sind Sie jederzeit dazu berechtigt die zweckm\xe4\xdfig gebundene Einwilligung zur\xfcckzuziehen, ohne dass die Rechtm\xe4\xdfigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung ber\xfchrt wird. ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null))))))))));
    }
}









class $84c9ca7b981f069c$export$23ed401b9a56e6b2 {
    constructor(options){
        this.options = options;
        this.haendlerList = [
            {},
            {}
        ];
        this.fileNames = [];
        this.checkedKomplettschutz = false;
        this.isLoading = true;
        this.erlaubteDateiendungen = [
            "jpg",
            "jpeg",
            "png",
            "pdf"
        ];
        this.vornameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Vorname eingeben...",
            onChange: (value)=>{
                this.vorname = value ?? "";
            }
        });
        this.anredeInput = new (0, $92830e10ec4ab123$export$c006741a65b06687)({
            class: "small-size-input-comp",
            enableSearch: false,
            style: "width:8rem;min-width:0;margin-top:.5rem",
            data: [
                "Herr",
                "Frau",
                "Divers"
            ].map((x)=>({
                    value: x,
                    text: x
                })),
            onChange: (value)=>{
                this.anrede = value ?? "";
            }
        });
        this.nachnameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Nachname eingeben...",
            onChange: (value)=>{
                this.nachname = value ?? "";
            }
        });
        this.stra\u00dfeHausnummerInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Stra\xdfe und Hausnummer eingeben...",
            onChange: (value)=>{
                this.stra\u00dfeHausnummer = value ?? "";
            }
        });
        this.postleitzahlInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Postleitzahl eingeben...",
            onChange: (value)=>{
                const val = value ?? "0";
                if (isNaN(Number(val))) alert("Keine g\xfcltige Postleitzahl!");
                else this.plz = Number(val);
            }
        });
        this.unternehmenInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Unternehmen / Firma eingeben...",
            onChange: (value)=>{
                this.unternehmen = value ?? "";
            }
        });
        this.stadtInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Stadt eingeben...",
            onChange: (value)=>{
                this.stadt = value ?? "";
            }
        });
        this.emailInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "E-Mail-Adresse eingeben...",
            onChange: (value)=>{
                this.email = value ?? "";
            }
        });
        this.geraeteSeriennummer = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Ger\xe4te Seriennummer eingeben...",
            onChange: (value)=>{
                this.seriennummer = value ?? "";
            }
        });
        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).GetHaendler().then((haendler)=>{
            this.haendlerList = haendler;
            this.isLoading = false;
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        });
    }
    render() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "garantie-comp"
        }, this.isLoading ? new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)(3) : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-anrede"
            }, "Anrede*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.anredeInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-vorname"
            }, "Vorname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.vornameInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-nachname"
            }, "Nachname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.nachnameInput)
        ], {
            responsive: true,
            sizes: [
                "20%",
                "40%",
                "40%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-stra\xdfe"
        }, "Stra\xdfe und Hausnummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stra\u00dfeHausnummerInput), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-plz"
            }, "Postleitzahl*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.postleitzahlInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-stadt"
            }, "Stadt*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stadtInput)
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", null, "Unternehmen / Firma"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.unternehmenInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-email"
        }, "E-Mail-Adresse*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.emailInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-seriennummer"
        }, "Ger\xe4te Seriennummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.geraeteSeriennummer), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-haendler"
        }, "H\xe4ndler, bei dem die Maschine gekauft wurde*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $92830e10ec4ab123$export$c006741a65b06687)({
            class: "large-size-input-comp",
            data: this.haendlerList.map((haendler)=>({
                    text: haendler.Matchcode + " - " + haendler.LieferStrasse + " - " + haendler.LieferPLZ + " " + haendler.LieferOrt,
                    value: haendler.Kto
                })),
            value: this.haendlerKto,
            onChange: (value)=>{
                this.haendlerKto = value ?? "";
            }
        })), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-kaufdatum"
            }, "Wann wurde die Maschine gekauft*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $c9acd7efe2a931e2$export$19285a5b05c4ea7c)({
                class: "small-size-input-comp",
                placeholder: "tt.mm.jjjj",
                max: new Date(),
                value: this.kaufdatum,
                onChange: (value)=>{
                    this.kaufdatum = value;
                }
            })),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-kaufpreis"
            }, "Kaufpreis*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $54d87a6f0ffec68f$export$1aa4bc36b5d11f02)({
                class: "small-size-input-comp",
                value: this.kaufpreis,
                onChange: (value)=>{
                    this.kaufpreis = value;
                }
            }))
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-rechnung"
        }, "Rechnung*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("input", {
            type: "file",
            id: "filesToUpload",
            style: "position: absolute; top: -10000px;",
            class: "large-size-input-comp",
            multiple: true,
            change: (e, node)=>{
                const el = node.dom;
                if (el?.files != null) {
                    this.fileNames = [];
                    for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                }
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button large-size-input-comp",
            style: "opacity: 1",
            dragenter: (e)=>{
                e.preventDefault();
                e.target.classList.add("drag-over");
            },
            dragover: (e)=>e.preventDefault(),
            dragleave: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
            },
            drop: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
                const droppedFiles = e.dataTransfer?.files;
                if (droppedFiles != null) {
                    if (droppedFiles.length > 1) {
                        alert("Sie d\xfcrfen maximal eine Datei hochladen!");
                        return;
                    }
                    // const fileName = droppedFiles[0].name;
                    const el = document.querySelector("#filesToUpload");
                    el.files = droppedFiles;
                    this.fileNames = [];
                    if (el?.files != null) for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                } else this.fileNames = [];
            },
            click: ()=>{
                const el = document.querySelector("#filesToUpload");
                el.click();
            }
        }, "Datei ausw\xe4hlen / drag & drop"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("label", {
            style: "font-size: 0.7em; font-weight: normal"
        }, "Maximal 5MB; M\xf6gliche Dateien: jpg, png, pdf"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, this.fileNames.length <= 0 ? undefined : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 1em"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hochzuladende Dateien:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("ul", null, this.fileNames.map((file)=>/*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("li", {
                style: "font-size: 0.8em; font-weight: normal"
            }, file)))))), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "text-align:left;padding:.8vw;"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", {
            id: "komplettSchutzOption"
        }, "Bitte kreuzen Sie eine der beiden folgenden Optionen an:*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Option 1: Registrieren Sie Ihren Kunden f\xfcr den WERTGARANTIE Aktionsger\xe4teschutz.",
            value: this.checkedKomplettschutz === false,
            style: "font-size: 1em;font-weight:600",
            onChange: (value)=>{
                this.checkedKomplettschutz = false;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 0.9em"
        }, "Ihre Kunden erhalten 3 Jahre Aktionsger\xe4teschutz (eine kostenfreie Verl\xe4ngerung der 2-j\xe4hrigen Gew\xe4hrleistung). Damit sind alle Reparaturkosten bei Material-, Konstruktions- und Produktionsfehlern abgedeckt. Als NIVONA-Fachh\xe4ndler erhalten Sie f\xfcr jede im Aktionszeitraum verkaufte und registrierte NIVO 8112 eine R\xfcckverg\xfctung in H\xf6he von 40 Euro.")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Option 2: Registrieren Sie Ihren Kunden f\xfcr den WERTGARANTIE Komplettschutz mit drei Monaten Beitragsfreiheit.",
            value: this.checkedKomplettschutz === true,
            style: "font-size: 1em;font-weight:600",
            onChange: (value)=>{
                this.checkedKomplettschutz = true;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 0.9em"
        }, "Die ersten drei Monate des WERTGARANTIE Komplettschutzes sind f\xfcr Ihren Kunden beitragsfrei. Zudem erhalten Sie als NIVONA-Fachh\xe4ndler auch bei dieser Variante eine R\xfcckverg\xfctung in H\xf6he von 40 Euro von uns.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("strong", null, "Bitte beachten Sie:"), " Sie m\xfcssen Ihren Kunden zus\xe4tzlich unter Angabe des Aktionscodes NIVONA im WERTGARANTIE Fachh\xe4ndler-Portal (", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            href: "https://www.wertgarantie.de/partner",
            target: "_blank"
        }, "https://www.wertgarantie.de/partner"), ") registrieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Bei Abschluss eines WERTGARANTIE Komplettschutzes mit Premium-Option gelten die beitragsfreien Monate auf den Monatsbeitrag inklusive der Premium-Option. Die Aktion ist auch g\xfcltig in Kombination mit dem WERTGARANTIE \u201E3 f\xfcr 2\u201C- Angebot, sowie den verschiedenen Zahlungsm\xf6glichkeiten, wie viertelj\xe4hrlich; halbj\xe4hrlich und j\xe4hrlich. Weitere Informationen finden Sie im gesonderten Aktionsblatt \u2013", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_bank",
            href: "Content/files/Wertgarantie_2026.pdf"
        }, "bitte hier klicken.")))), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-datenschutz"
        }, "Datenschutz*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Ich habe die Datenschutzbestimmungen zur Kenntnis genommen.",
            value: this.checkedDatenschutz,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedDatenschutz = value;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "info-button",
            click: ()=>{
                (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
                    header: "Datenschutzbestimmungen",
                    content: this.getDatenschutzbestimmungenText(),
                    footer: (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok()
                });
            }
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("img", {
            src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/images/information.png"),
            style: "max-width: 0.8rem; max-height: 0.8rem; opacity: 1"
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Versicherungsbedingungen an Endkunden \xfcbergeben",
            value: this.checkedPermission,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedPermission = value;
            }
        }), " ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_blank",
            href: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/files/21067 WG Aktionsgeraeteschutz Broschuere 1221_1802a.pdf")
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("strong", null, "Bedingungen anzeigen"), " "), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die mit einem Stern (*) markierten Felder sind Pflichtfelder."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button",
            style: "font-size: 0.9em; height: auto; padding: 0.6vw",
            click: ()=>{
                if (this.allRequiredFieldsFilledIn()) {
                    if (this.kaufpreis > 10000) alert("Kaufpreis ist zu hoch. Bitte pr\xfcfen.");
                    if (this.checkEmail(this.email)) {
                        const gm = {
                            ID: (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newGuid(),
                            Vorname: this.vorname,
                            Anrede: this.anrede,
                            Nachname: this.nachname,
                            "Stra\xdfeHausnummer": this.stra\u00dfeHausnummer,
                            PLZ: this.plz,
                            Stadt: this.stadt,
                            Unternehmen: this.unternehmen,
                            Email: this.email,
                            Seriennummer: this.seriennummer,
                            HaendlerKto: this.haendlerList.find((haendler)=>{
                                if (haendler.Kto === this.haendlerKto) return true;
                                return false;
                            })?.Kto,
                            Kaufdatum: this.kaufdatum,
                            Kaufpreis: this.kaufpreis,
                            SourcePage: this.options.Name,
                            HasContactPermission: this.checkedPermission == undefined ? 0 : this.checkedPermission === false ? 0 : -1,
                            KomplettSchutz: this.checkedKomplettschutz === false ? 0 : -1
                        };
                        console.log(this.options.Name);
                        const files = document.querySelector("#filesToUpload").files;
                        const imgFormData = new FormData();
                        if (files != null) {
                            for(let i = 0; i < files.length; i++)imgFormData.append("files", files[i]);
                            if (gm.ID != null) {
                                (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).showLoading();
                                (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).IsValidSeriennummer(gm.Seriennummer ?? "", this.options.Name).then((result)=>{
                                    // console.log(result);
                                    if (result == "Seriennummer g\xfcltig") (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post((0, $fb350c3721d80fcd$export$791c4e50320e809e)("Landing/SendGarantieKaufbeleg?ID=" + gm.ID + "&sourcePage=" + this.options.Name), imgFormData, {}).then((val)=>{
                                        if (val.data === "OK") (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).SendGarantieCustomerData(gm /*, "garantie"*/ ).then((guid)=>{
                                            alert("Ihr Antrag wird nun verarbeitet, vielen Dank!");
                                            location.reload();
                                        }).catch((error)=>{
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            const x = error?.response?.data ?? error ?? "unkown";
                                            alert(x);
                                        });
                                        else if (val.data === "FILES") {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("\xdcberpr\xfcfen Sie bitte, ob mit ihren hochgeladenen Dateien alles in Ordnung ist!");
                                        } else if (val.data === "FILEENDUNG") {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("\xdcberpr\xfcfen Sie bitte, ob Ihre hochgeladene Datei intakt ist und ob sie das richtige Format hat.\nErlaubt sind: .jpg, .png, .pdf!");
                                        } else {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("Ein Fehler ist aufgetreten, bitte versuchen Sie es in wenigen Augenblick erneut!");
                                        }
                                    }).catch((error)=>{
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("\xdcberpr\xfcfen Sie bitte Ihre Datei auf zul\xe4ssige Gr\xf6\xdfe und zul\xe4ssige Dateitypen!");
                                    });
                                    else {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert(result);
                                    }
                                }).catch((error)=>{
                                    (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                    const x = error?.response?.data ?? error ?? "unkown";
                                    alert(x);
                                });
                            }
                        }
                    } else alert("Bitte geben Sie eine g\xfcltige Email-Adresse ein!");
                } else {
                    this.highlightAllNotFilledInRequired();
                    alert("Bitte f\xfcllen Sie alle geforderten Felder aus!");
                }
            }
        }, "Absenden")))));
    }
    allRequiredFieldsFilledIn() {
        if (!this.anrede) return false;
        if (!this.vorname) return false;
        if (!this.nachname) return false;
        if (!this.stra\u00dfeHausnummer) return false;
        if (!this.plz) return false;
        if (!this.stadt) return false;
        if (!this.email) return false;
        if (!this.seriennummer) return false;
        if (!this.haendlerKto) return false;
        if (!this.kaufdatum) return false;
        if (!this.kaufpreis) return false;
        // if (this.checkedKomplettschutz == null) {
        //     document.getElementById("komplettSchutzOption").style.color = "red";
        //     return false;
        // } else {
        //     document.getElementById("komplettSchutzOption").style.color = "black";
        // }
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) return false;
        if (this.checkedDatenschutz == undefined || this.checkedDatenschutz === false) return false;
        if (this.checkedPermission == undefined || this.checkedPermission === false) return false;
        return true;
    }
    highlightAllNotFilledInRequired() {
        this.undoStyleChangesBeforehand();
        if (this.anrede == undefined) {
            document.getElementById("span-anrede").style.color = "red";
            document.getElementById("span-anrede").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.vorname == undefined) {
            document.getElementById("span-vorname").style.color = "red";
            document.getElementById("span-vorname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.nachname == undefined) {
            document.getElementById("span-nachname").style.color = "red";
            document.getElementById("span-nachname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stra\u00dfeHausnummer == undefined) {
            document.getElementById("span-stra\xdfe").style.color = "red";
            document.getElementById("span-stra\xdfe").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.plz == undefined) {
            document.getElementById("span-plz").style.color = "red";
            document.getElementById("span-plz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stadt == undefined) {
            document.getElementById("span-stadt").style.color = "red";
            document.getElementById("span-stadt").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.email == undefined) {
            document.getElementById("span-email").style.color = "red";
            document.getElementById("span-email").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.seriennummer == undefined) {
            document.getElementById("span-seriennummer").style.color = "red";
            document.getElementById("span-seriennummer").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.haendlerKto == undefined || this.haendlerKto === "") {
            document.getElementById("span-haendler").style.color = "red";
            document.getElementById("span-haendler").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.kaufdatum == undefined) {
            document.getElementById("span-kaufdatum").style.color = "red";
            document.getElementById("span-kaufdatum").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (!this.kaufpreis) {
            document.getElementById("span-kaufpreis").style.color = "red";
            document.getElementById("span-kaufpreis").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) {
            document.getElementById("span-rechnung").style.color = "red";
            document.getElementById("span-rechnung").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.checkedDatenschutz == undefined) {
            document.getElementById("span-datenschutz").style.color = "red";
            document.getElementById("span-datenschutz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.checkedPermission == undefined) {
            document.getElementById("span-datenschutz").style.color = "red";
            document.getElementById("span-datenschutz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
    }
    undoStyleChangesBeforehand() {
        document.getElementById("span-anrede").style.color = "black";
        document.getElementById("span-anrede").style.textShadow = "none";
        document.getElementById("span-vorname").style.color = "black";
        document.getElementById("span-vorname").style.textShadow = "none";
        document.getElementById("span-nachname").style.color = "black";
        document.getElementById("span-nachname").style.textShadow = "none";
        document.getElementById("span-stra\xdfe").style.color = "black";
        document.getElementById("span-stra\xdfe").style.textShadow = "none";
        document.getElementById("span-plz").style.color = "black";
        document.getElementById("span-plz").style.textShadow = "none";
        document.getElementById("span-stadt").style.color = "black";
        document.getElementById("span-stadt").style.textShadow = "none";
        document.getElementById("span-email").style.color = "black";
        document.getElementById("span-email").style.textShadow = "none";
        document.getElementById("span-seriennummer").style.color = "black";
        document.getElementById("span-seriennummer").style.textShadow = "none";
        document.getElementById("span-haendler").style.color = "black";
        document.getElementById("span-haendler").style.textShadow = "none";
        document.getElementById("span-kaufdatum").style.color = "black";
        document.getElementById("span-kaufdatum").style.textShadow = "none";
        document.getElementById("span-rechnung").style.color = "black";
        document.getElementById("span-rechnung").style.textShadow = "none";
        document.getElementById("span-datenschutz").style.color = "black";
        document.getElementById("span-datenschutz").style.textShadow = "none";
    }
    checkEmail(email) {
        if (email.indexOf("@") === -1) return false;
        const split_arr = email.split("@");
        if (split_arr[0].length <= 0) return false;
        if (split_arr[1].length <= 0) return false;
        return true;
    }
    getDatenschutzbestimmungenText() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-sections"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section  pos-0 cms-section-default",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section-default boxed"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block  pos-0 cms-block-text",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container",
            style: "padding: 20px 20px 20px 20px;"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container-row row cms-row "
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "col-12",
            "data-cms-element-id": "eb20ee63af314345b702de452230f323"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-element-text"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("hr", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "1. Datenschutz auf einen Blick"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Allgemeine Hinweise"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die folgenden Hinweise geben einen einfachen \xdcberblick dar\xfcber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Ausf\xfchrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef\xfchrten Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Analyse-Tools und Tools von Drittanbietern", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zur\xfcckverfolgt werden. Sie k\xf6nnen dieser Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen dazu finden Sie in der folgenden Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen dieser Analyse widersprechen. \xdcber die Widerspruchsm\xf6glichkeiten werden wir Sie in dieser Datenschutzerkl\xe4rung informieren."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "2. Allgemeine Hinweise und Pflichtinformationen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Datenschutz"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers\xf6nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Die vorliegende Datenschutzerkl\xe4rung erl\xe4utert, welche Daten wir erheben und wof\xfcr wir sie nutzen. Sie erl\xe4utert auch, wie und zu welchem Zweck das geschieht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir weisen darauf hin, dass die Daten\xfcbertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitsl\xfccken aufweisen kann. Ein l\xfcckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xf6glich.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hinweis zur verantwortlichen Stelle", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die verantwortliche Stelle f\xfcr die Datenverarbeitung auf dieser Website ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Nivona Apparte GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 0911 2526630", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://info@nivona.com"
        }, "info@nivona.com"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Verantwortliche Stelle ist die nat\xfcrliche oder juristische Person, die allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. \xc4.) entscheidet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Widerruf Ihrer Einwilligung zur Datenverarbeitung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Viele Datenverarbeitungsvorg\xe4nge sind nur mit Ihrer ausdr\xfccklichen Einwilligung m\xf6glich. Sie k\xf6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtm\xe4\xdfigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Falle datenschutzrechtlicher Verst\xf6\xdfe steht dem Betroffenen ein Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde zu. Zust\xe4ndige Aufsichtsbeh\xf6rde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten k\xf6nnen folgendem Link entnommen werden: https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Recht auf Daten\xfcbertragbarkeit", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xfcllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g\xe4ngigen, maschinenlesbaren Format aush\xe4ndigen zu lassen. Sofern Sie die direkte \xdcbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft, Sperrung, L\xf6schung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xfcber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xe4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder L\xf6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xf6nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "3. Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Gesetzlich vorgeschriebener Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben f\xfcr unser Unternehmen einen Datenschutzbeauftragten bestellt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sigmundstra\xdfe 172", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "4. Datenerfassung auf unserer Website"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Cookies"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die meisten der von uns verwendeten Cookies sind so genannte \u201CSession-Cookies\u201D. Sie werden nach Ende Ihres Besuchs automatisch gel\xf6scht. Andere Cookies bleiben auf Ihrem Endger\xe4t gespeichert bis Sie diese l\xf6schen. Diese Cookies erm\xf6glichen es uns, Ihren Browser beim n\xe4chsten Besuch wiederzuerkennen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen Ihren Browser so einstellen, dass Sie \xfcber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f\xfcr bestimmte F\xe4lle oder generell ausschlie\xdfen sowie das automatische L\xf6schen der Cookies beim Schlie\xdfen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit\xe4t dieser Website eingeschr\xe4nkt sein.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Cookies, die zur Durchf\xfchrung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erw\xfcnschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerkl\xe4rung gesondert behandelt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "5. Analyse Tools und Werbung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Analytics"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), 'Google Analytics verwendet so genannte "Cookies". Das sind Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm\xf6glichen. Die durch den Cookie erzeugten Informationen \xfcber Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert.', /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "IP Anonymisierung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europ\xe4ischen Union oder in anderen Vertragsstaaten des Abkommens \xfcber den Europ\xe4ischen Wirtschaftsraum vor der \xdcbermittlung in die USA gek\xfcrzt. Nur in Ausnahmef\xe4llen wird die volle IP-Adresse an einen Server von Google in den USA \xfcbertragen und dort gek\xfcrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xfcber die Websiteaktivit\xe4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xfcber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser \xfcbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xfchrt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Browser Plugin"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht s\xe4mtliche Funktionen dieser Website vollumf\xe4nglich werden nutzen k\xf6nnen. Sie k\xf6nnen dar\xfcber hinaus die Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verf\xfcgbare Browser-Plugin herunterladen und installieren: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://tools.google.com/dlpage/gaoptout?hl=de"
        }, "https://tools.google.com/dlpage/gaoptout?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Widerspruch gegen Datenerfassung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zuk\xfcnftigen Besuchen dieser Website verhindert: Google Analytics deaktivieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://support.google.com/analytics/answer/6004245?hl=de"
        }, "https://support.google.com/analytics/answer/6004245?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Auftragsdatenverarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die strengen Vorgaben der deutschen Datenschutzbeh\xf6rden bei der Nutzung von Google Analytics vollst\xe4ndig um."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "6. Plugins und Tools"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "YouTube"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unsere Website nutzt Plugins der von Google betriebenen Seite YouTube. Betreiber der Seiten ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie in Ihrem YouTube-Account eingeloggt sind, erm\xf6glichen Sie YouTube, Ihr Surfverhalten direkt Ihrem pers\xf6nlichen Profil zuzuordnen. Dies k\xf6nnen Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von YouTube unter: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy"
        }, "https://www.google.de/intl/de/policies/privacy")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Maps"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Seite nutzt \xfcber eine API den Kartendienst Google Maps. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Daten\xfcbertragung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy/"
        }, "https://www.google.de/intl/de/policies/privacy/"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\xa0", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h4", null, "Pflichtinformationen gem. Art. 12 ff. DS-GVO"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Kontaktdaten des Verantwortlichen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Name: Peter", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Vorname: Wildner", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: NIVONA Apparate GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://peter.wildner@nivona.com"
        }, "peter.wildner@nivona.com")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten des Datenschutzbeauftragten", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: Sigmundstra\xdfe 172; 90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Woher beziehen wir Ihre personenbezogenen Daten?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Erhebung Ihrer Daten findet grunds\xe4tzlich bei Ihnen selbst statt. Die Verarbeitung der von Ihnen \xfcberlassenen personenbezogenen Daten ist zur Erf\xfcllung der vertraglichen Pflichten, die sich aus dem mit uns geschlossenen Vertrag ergeben, notwendig. Aufgrund Ihrer Mitwirkungspflichten ist es unumg\xe4nglich die von uns angeforderten personenbezogenen Daten zur Verf\xfcgung zu stellen, da wir ansonsten unseren vertraglichen Pflichten nicht nachkommen k\xf6nnen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen vorvertraglicher Ma\xdfnahmen (z. B. Stammdatenerfassung im Interessentenprozess) ist die Bereitstellung Ihrer personenbezogenen Daten notwendig. Sollten die angeforderten Daten nicht von Ihnen bereitgestellt werden, kann ein Vertrag nicht abgeschlossen werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Erbringung unserer Dienstleistungen kann es erforderlich sein, personenbezogene Daten zu verarbeiten, die wir von anderen Unternehmen oder sonstigen Dritten, z. B. Finanz\xe4mtern, Ihren Gesch\xe4ftspartner o. \xe4. zul\xe4ssigerweise und zu dem jeweiligen Zweck erhalten haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weiterhin verarbeiten wir ggf. personenbezogene Daten aus \xf6ffentlich zug\xe4nglichen Quellen, z. B. Internetauftritten, die wir zul\xe4ssigerweise und nur zu dem jeweiligen Vertragszweck nutzen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zwecke und Rechtsgrundlagen der Verarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die von Ihnen \xfcberlassenen personenbezogenen Daten werden im Einklang mit den Bestimmungen der europ\xe4ischen Datenschutzverordnung (DS-GVO) und dem Bundesdatenschutzgesetz (BDSG) verarbeitet:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund einer Einwilligung (gem. Art. 6 Abs. 1 Lit. a DS-GVO)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Verarbeitung personenbezogener Daten ergeben sich aus der Erteilung einer Einwilligung. Eine erteilte Einwilligung kann jederzeit von Ihnen mit Wirkung f\xfcr die Zukunft widerrufen werden. Auch Einwilligungen, die vor der Geltung der DS-GVO (25. Mai 2018) erteilt worden sind, k\xf6nnen widerrufen werden. Verarbeitungen, die vor dem Widerruf erfolgt sind, bleiben vom Widerruf unber\xfchrt. Beispiel: Zusendung eines Newsletters, Einwilligung zur Weitergabe der von Ihnen \xfcberlassenen Daten auf Ihren Wunsch hin an Dritte (z. B. Banken, Versicherungen, Anteilseigner etc.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zur Erf\xfcllung von vertraglichen Pflichten (gem. Art. 6 Abs. 1 Lit. b DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Datenverarbeitung ergeben sich zum einen aus der Einleitung vorvertraglicher Ma\xdfnahmen, die einer vertraglich geregelten Gesch\xe4ftsbeziehung vorausgehen und zum anderen zur Erf\xfcllung der Pflichten aus dem mit Ihnen geschlossenen Vertrag.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund gesetzlicher Vorgaben (gem. Art. 6 Abs.1 Lit. c DS-GVO) oder im \xf6ffentlichen Interesse (gem. Art. 6 Abs.1 Lit. e DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Datenverarbeitung ergeben sich aus gesetzlichen Vorgaben oder liegen im \xf6ffentlichen Interesse (z. B. Einhaltung von Aufbewahrungspflichten, Nachweis der Einhaltung von Hinweis- und Informationspflichten des Steuerberaters).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Im Rahmen der Interessenabw\xe4gung (gem. Art. 6 Abs. 1 Lit. f DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Verarbeitung ergeben sich aus der Wahrung unserer berechtigten Interessen. Es kann erforderlich sein, die von Ihnen \xfcberlassenen Daten \xfcber die eigentliche Erf\xfcllung des Vertrages hinaus zu verarbeiten. Unser berechtigtes Interesse kann zur Begr\xfcndung der weiteren Verarbeitung der von Ihnen \xfcberlassenen Daten herangezogen werden, sofern Ihre Interessen oder Grundrechte und Grundfreiheiten nicht \xfcberwiegen. Unser berechtigtes Interesse kann im Einzelfall sein: Geltendmachung rechtlicher Anspr\xfcche, Abwehr von Haftungsanspr\xfcchen, Verhinderung von Straftaten.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wer erh\xe4lt die von Ihnen \xfcberlassenen personenbezogenen Daten?", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Innerhalb unseres Unternehmens erhalten diejenigen Bereiche Zugriff auf die von Ihnen \xfcberlassenen personenbezogenen Daten, die diese zur Erf\xfcllung der vertraglichen und gesetzlichen Pflichten ben\xf6tigen und die zur Verarbeitung dieser Daten berechtigt sind.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "In Erf\xfcllung des mit Ihnen geschlossenen Vertrages erhalten ausschlie\xdflich diejenigen Stellen die von Ihnen \xfcberlassenen Daten, die diese aus gesetzlichen Gr\xfcnden ben\xf6tigen, z. B. Finanzbeh\xf6rden, Sozialversicherungstr\xe4ger, zust\xe4ndige Beh\xf6rden und Gerichte.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Empf\xe4nger erhalten die von Ihnen \xfcberlassenen Daten nur auf Ihren Wunsch hin, wenn Sie uns die hierf\xfcr notwendige Einwilligung erteilen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen unserer Leistungserbringung beauftragen wir Auftragsverarbeiter, die zur Erf\xfcllung der vertraglichen Pflichten beitragen, z. B. EDV-Partner, Aktenvernichter, Fachh\xe4ndler etc. Diese Auftragsverarbeiter werden von uns vertraglich zur Einhaltung der Vorgaben der DS-GVO und des BDSG verpflichtet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Werden die von Ihnen \xfcberlassenen Daten an Drittl\xe4nder oder internationale Organisationen \xfcbermittelt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Eine \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation erfolgt in keinem Fall. Sollten Sie im Einzelfall die \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation w\xfcnschen, f\xfchren wir dies nur nach Ihrer schriftlichen Einwilligung durch."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Findet automatisierte Entscheidungsfindung einschlie\xdflich Profiling statt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Verarbeitung der von Ihnen \xfcberlassenen Daten kommt keine vollautomatisierte Entscheidungsfindung (einschlie\xdflich Profiling) gem. Art. 22 DS-GVO zum Einsatz."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Dauer der Verarbeitung (Kriterien der L\xf6schung)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Verarbeitung der von Ihnen \xfcberlassenen Daten erfolgt so lange, wie sie zur Erreichung des vertraglich vereinbarten Zweckes notwendig ist, grunds\xe4tzlich so lange das Vertragsverh\xe4ltnis mit Ihnen besteht. Nach der Beendigung des Vertragsverh\xe4ltnisses werden die von Ihnen \xfcberlassenen Daten zur Einhaltung gesetzlicher Aufbewahrungspflichten oder aufgrund unserer berechtigten Interessen verarbeitet. Nach dem Ablauf der gesetzlichen Aufbewahrungsfristen und/oder dem Wegfall unserer berechtigten Interessen werden die von Ihnen \xfcberlassenen Daten gel\xf6scht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Voraussichtliche Fristen der uns treffenden Aufbewahrungspflichten und unserer berechtigten Interessen:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erf\xfcllung handels- und steuerrechtlicher Aufbewahrungsfristen. Die dort vorgegebenen Fristen zur Aufbewahrung bzw. Dokumentation betragen zwei bis zehn Jahre.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erhaltung von Beweismitteln im Rahmen der Verj\xe4hrungsvorschriften. Nach den \xa7\xa7 195 ff. des B\xfcrgerlichen Gesetzbuches (BGB) k\xf6nnen diese Verj\xe4hrungsfristen bis zu 30 Jahre betragen, wobei die regelm\xe4\xdfige Verj\xe4hrungsfrist drei Jahre betr\xe4gt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft \xfcber Ihre Rechte", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Auskunft gem. Art. 15 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, auf Antrag unentgeltlich Auskunft zu erhalten, ob und welche Daten \xfcber Sie gespeichert sind und zu welchem Zweck die Speicherung erfolgt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Berichtigung gem. Art. 16 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen unverz\xfcglich die Berichtigung Ihrer unrichtigen personenbezogenen Daten zu verlangen. Unter Ber\xfccksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollst\xe4ndigung unvollst\xe4ndiger personenbezogener Daten \u2014 auch mittels einer erg\xe4nzenden Erkl\xe4rung \u2014 zu verlangen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf L\xf6schung (\u201ERecht auf Vergessenwerden\u201C) gem. Art. 17 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen zu verlangen, dass Ihre Daten unverz\xfcglich gel\xf6scht werden. Der Verantwortliche ist verpflichtet, personenbezogene Daten unverz\xfcglich zu l\xf6schen, sofern einer der folgenden Gr\xfcnde zutrifft:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Zwecke, f\xfcr die die personenbezogenen Daten erhoben wurden, entfallen", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Sie widerrufen Ihre Einwilligung der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Sie widersprechen der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Die personenbezogenen Daten wurden unrechtm\xe4\xdfig verarbeitet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "e) Die L\xf6schung der personenbezogenen Daten ist zur Erf\xfcllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "f) Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gem\xe4\xdf Artikel 8 Absatz 1 erhoben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Einschr\xe4nkung der Verarbeitung gem. Art. 18 DS-GVO &. \xa7 35 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die Einschr\xe4nkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Die Richtigkeit der personenbezogenen Daten wird von Ihnen angezweifelt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Die Verarbeitung ist unrechtm\xe4\xdfig; Sie lehnen eine L\xf6schung jedoch ab.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Personenbezogene Daten werden f\xfcr die Zwecke der Verarbeitung nicht l\xe4nger ben\xf6tigt; Sie ben\xf6tigen die Daten jedoch zur Geltendmachung, Aus\xfcbung oder Verteidigung von Rechtsanspr\xfcchen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Sie haben Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt. Solange noch nicht feststeht, ob die berechtigten Gr\xfcnde des Verantwortlichen Ihnen gegen\xfcber \xfcberwiegen, wird die Verarbeitung eingeschr\xe4nkt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Daten\xfcbertragbarkeit gem. Art. 20 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die von Ihnen bereitgestellten Daten in einem strukturierten, g\xe4ngigen und maschinenlesbaren Format von dem Verantwortlichen zu erhalten. Eine Weiterleitung an einen andern Verantwortlichen darf von uns nicht behindert werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Widerspruchsrecht gem. Art. 21 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hierzu wenden Sie sich bitte an den Verantwortlichen der Verarbeitung (s. o.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Beschwerderecht bei der Aufsichtsbeh\xf6rde gem. Art. 13 Abs. 2 Lit. d, 77 DS-GVO", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "i. V. m \xa7 19 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen die DS-GVO verst\xf6\xdft, haben Sie das Recht Beschwerde bei der Aufsichtsbeh\xf6rde einzulegen. Hierzu wenden Sie sich bitte an die zust\xe4ndige Aufsichtsbeh\xf6rde", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Zur\xfcckziehen der Einwilligung gem. Art. 7 Abs. 3 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beruht die Verarbeitung auf Ihrer Einwilligung gem. Art. 6 Abs. 1 Lit. a oder Art. 9 Abs. 2 Lit. a (Verarbeitung besonderer Kategorien personenbezogener Daten), sind Sie jederzeit dazu berechtigt die zweckm\xe4\xdfig gebundene Einwilligung zur\xfcckzuziehen, ohne dass die Rechtm\xe4\xdfigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung ber\xfchrt wird. ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null))))))))));
    }
}









class $31fa76e2b35f3ee9$export$69e06b009b0ee08e {
    constructor(options){
        this.options = options;
        this.haendlerList = [
            {},
            {}
        ];
        this.fileNames = [];
        this.checkedKomplettschutz = false;
        this.isLoading = true;
        this.erlaubteDateiendungen = [
            "jpg",
            "jpeg",
            "png",
            "pdf"
        ];
        this.vornameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Vorname eingeben...",
            onChange: (value)=>{
                this.vorname = value ?? "";
            }
        });
        this.anredeInput = new (0, $92830e10ec4ab123$export$c006741a65b06687)({
            class: "small-size-input-comp",
            enableSearch: false,
            style: "width:8rem;min-width:0;margin-top:.5rem",
            data: [
                "Herr",
                "Frau",
                "Divers"
            ].map((x)=>({
                    value: x,
                    text: x
                })),
            onChange: (value)=>{
                this.anrede = value ?? "";
            }
        });
        this.nachnameInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Nachname eingeben...",
            onChange: (value)=>{
                this.nachname = value ?? "";
            }
        });
        this.stra\u00dfeHausnummerInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Stra\xdfe und Hausnummer eingeben...",
            onChange: (value)=>{
                this.stra\u00dfeHausnummer = value ?? "";
            }
        });
        this.postleitzahlInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Postleitzahl eingeben...",
            onChange: (value)=>{
                const val = value ?? "0";
                if (isNaN(Number(val))) alert("Keine g\xfcltige Postleitzahl!");
                else this.plz = Number(val);
            }
        });
        this.unternehmenInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Unternehmen / Firma eingeben...",
            onChange: (value)=>{
                this.unternehmen = value ?? "";
            }
        });
        this.stadtInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "small-size-input-comp",
            placeholder: "Stadt eingeben...",
            onChange: (value)=>{
                this.stadt = value ?? "";
            }
        });
        this.emailInput = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "E-Mail-Adresse eingeben...",
            onChange: (value)=>{
                this.email = value ?? "";
            }
        });
        this.geraeteSeriennummer = new (0, $0db63c4ff60d6668$export$99ca0c5cb670cc62)({
            class: "large-size-input-comp",
            placeholder: "Ger\xe4te Seriennummer eingeben...",
            onChange: (value)=>{
                this.seriennummer = value ?? "";
            }
        });
        (0, $ed995c3feec4175b$export$e0c8ff32d779851f).GetHaendler().then((haendler)=>{
            this.haendlerList = haendler;
            this.isLoading = false;
            (0, $83d498fca38a60e6$export$2d6e9b4c68afb6c8)();
        });
    }
    render() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "garantie-comp"
        }, this.isLoading ? new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)(3) : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-anrede"
            }, "Anrede*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.anredeInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-vorname"
            }, "Vorname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.vornameInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-nachname"
            }, "Nachname*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.nachnameInput)
        ], {
            responsive: true,
            sizes: [
                "20%",
                "40%",
                "40%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-stra\xdfe"
        }, "Stra\xdfe und Hausnummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stra\u00dfeHausnummerInput), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-plz"
            }, "Postleitzahl*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.postleitzahlInput),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-stadt"
            }, "Stadt*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.stadtInput)
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", null, "Unternehmen / Firma"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.unternehmenInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-email"
        }, "E-Mail-Adresse*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.emailInput), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-seriennummer"
        }, "Ger\xe4te Seriennummer*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), this.geraeteSeriennummer), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-haendler"
        }, "H\xe4ndler, bei dem die Maschine gekauft wurde*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $92830e10ec4ab123$export$c006741a65b06687)({
            class: "large-size-input-comp",
            data: this.haendlerList.map((haendler)=>({
                    text: haendler.Matchcode + " - " + haendler.LieferStrasse + " - " + haendler.LieferPLZ + " " + haendler.LieferOrt,
                    value: haendler.Kto
                })),
            value: this.haendlerKto,
            onChange: (value)=>{
                this.haendlerKto = value ?? "";
            }
        })), new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-kaufdatum"
            }, "Wann wurde die Maschine gekauft*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $c9acd7efe2a931e2$export$19285a5b05c4ea7c)({
                class: "small-size-input-comp",
                placeholder: "tt.mm.jjjj",
                max: new Date(),
                value: this.kaufdatum,
                onChange: (value)=>{
                    this.kaufdatum = value;
                }
            })),
            /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
                id: "span-kaufpreis"
            }, "Kaufpreis*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $54d87a6f0ffec68f$export$1aa4bc36b5d11f02)({
                class: "small-size-input-comp",
                value: this.kaufpreis,
                onChange: (value)=>{
                    this.kaufpreis = value;
                }
            }))
        ], {
            responsive: true,
            sizes: [
                "50%",
                "50%"
            ],
            class: "stack-panel-comp"
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-rechnung"
        }, "Rechnung*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("input", {
            type: "file",
            id: "filesToUpload",
            style: "position: absolute; top: -10000px;",
            class: "large-size-input-comp",
            multiple: true,
            change: (e, node)=>{
                const el = node.dom;
                if (el?.files != null) {
                    this.fileNames = [];
                    for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                }
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button large-size-input-comp",
            style: "opacity: 1",
            dragenter: (e)=>{
                e.preventDefault();
                e.target.classList.add("drag-over");
            },
            dragover: (e)=>e.preventDefault(),
            dragleave: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
            },
            drop: (e)=>{
                e.preventDefault();
                e.target.classList.remove("drag-over");
                const droppedFiles = e.dataTransfer?.files;
                if (droppedFiles != null) {
                    if (droppedFiles.length > 1) {
                        alert("Sie d\xfcrfen maximal eine Datei hochladen!");
                        return;
                    }
                    // const fileName = droppedFiles[0].name;
                    const el = document.querySelector("#filesToUpload");
                    el.files = droppedFiles;
                    this.fileNames = [];
                    if (el?.files != null) for(let i = 0; i < el.files.length; i++)this.fileNames.push(el.files[i].name);
                } else this.fileNames = [];
            },
            click: ()=>{
                const el = document.querySelector("#filesToUpload");
                el.click();
            }
        }, "Datei ausw\xe4hlen / drag & drop"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("label", {
            style: "font-size: 0.7em; font-weight: normal"
        }, "Maximal 5MB; M\xf6gliche Dateien: jpg, png, pdf"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", null, this.fileNames.length <= 0 ? undefined : /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 1em"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hochzuladende Dateien:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("ul", null, this.fileNames.map((file)=>/*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("li", {
                style: "font-size: 0.8em; font-weight: normal"
            }, file)))))), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "text-align:left;padding:.8vw;"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", {
            id: "komplettSchutzOption"
        }, "Bitte kreuzen Sie eine der beiden folgenden Optionen an:*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Option 1: Registrieren Sie Ihren Kunden f\xfcr den WERTGARANTIE Aktionsger\xe4teschutz.",
            value: this.checkedKomplettschutz === false,
            style: "font-size: 1em;font-weight:600",
            onChange: (value)=>{
                this.checkedKomplettschutz = false;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 0.9em"
        }, "Ihre Kunden erhalten 3 Jahre Aktionsger\xe4teschutz (eine kostenfreie Verl\xe4ngerung der 2-j\xe4hrigen Gew\xe4hrleistung). Damit sind alle Reparaturkosten bei Material-, Konstruktions- und Produktionsfehlern abgedeckt. Als NIVONA-Fachh\xe4ndler erhalten Sie f\xfcr jede im Aktionszeitraum verkaufte und registrierte NICR 793 eine R\xfcckverg\xfctung in H\xf6he von 25 Euro.")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Option 2: Registrieren Sie Ihren Kunden f\xfcr den WERTGARANTIE Komplettschutz mit drei Monaten Beitragsfreiheit.",
            value: this.checkedKomplettschutz === true,
            style: "font-size: 1em;font-weight:600",
            onChange: (value)=>{
                this.checkedKomplettschutz = true;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            style: "font-size: 0.9em"
        }, "Die ersten drei Monate des WERTGARANTIE Komplettschutzes sind f\xfcr Ihren Kunden beitragsfrei. Zudem erhalten Sie als NIVONA-Fachh\xe4ndler auch bei dieser Variante eine R\xfcckverg\xfctung in H\xf6he von 25 Euro von uns.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("strong", null, "Bitte beachten Sie:"), " Sie m\xfcssen Ihren Kunden zus\xe4tzlich unter Angabe des Aktionscodes 20JAHRENIVONA im WERTGARANTIE Fachh\xe4ndler-Portal (", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            href: "https://www.wertgarantie.de/partner",
            target: "_blank"
        }, "https://www.wertgarantie.de/partner"), ") registrieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Bei Abschluss eines WERTGARANTIE Komplettschutzes mit Premium-Option gelten die beitragsfreien Monate auf den Monatsbeitrag inklusive der Premium-Option. Die Aktion ist auch g\xfcltig in Kombination mit dem WERTGARANTIE \u201E3 f\xfcr 2\u201C- Angebot, sowie den verschiedenen Zahlungsm\xf6glichkeiten, wie viertelj\xe4hrlich; halbj\xe4hrlich und j\xe4hrlich. Weitere Informationen finden Sie im gesonderten Aktionsblatt \u2013", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_bank",
            href: "Content/files/Nivona_Aktion Feb-Dez.pdf"
        }, "bitte hier klicken.")))), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("span", {
            id: "span-datenschutz"
        }, "Datenschutz*"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Ich habe die Datenschutzbestimmungen zur Kenntnis genommen.",
            value: this.checkedDatenschutz,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedDatenschutz = value;
            }
        }), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "info-button",
            click: ()=>{
                (0, $a5215e39a2de1874$export$24ec15341293d56f).show({
                    header: "Datenschutzbestimmungen",
                    content: this.getDatenschutzbestimmungenText(),
                    footer: (0, $a5215e39a2de1874$export$24ec15341293d56f).Ok()
                });
            }
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("img", {
            src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/images/information.png"),
            style: "max-width: 0.8rem; max-height: 0.8rem; opacity: 1"
        })), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), new (0, $f24bc78b87634ab6$export$e3ad28a1fdd217f6)({
            label: "Versicherungsbedingungen an Endkunden \xfcbergeben",
            value: this.checkedPermission,
            style: "font-size: 0.8em; font-weight: normal",
            onChange: (value)=>{
                this.checkedPermission = value;
            }
        }), " ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_blank",
            href: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/files/21067 WG Aktionsgeraeteschutz Broschuere 1221_1802a.pdf")
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("strong", null, "Bedingungen anzeigen"), " "), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die mit einem Stern (*) markierten Felder sind Pflichtfelder."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "stack-panel-comp"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("button", {
            class: "jsl-button",
            style: "font-size: 0.9em; height: auto; padding: 0.6vw",
            click: ()=>{
                if (this.allRequiredFieldsFilledIn()) {
                    if (this.kaufpreis > 10000) alert("Kaufpreis ist zu hoch. Bitte pr\xfcfen.");
                    if (this.checkEmail(this.email)) {
                        const gm = {
                            ID: (0, $49e64dbd3190ba7b$export$4bbbbc0a0e57a7f).newGuid(),
                            Vorname: this.vorname,
                            Anrede: this.anrede,
                            Nachname: this.nachname,
                            "Stra\xdfeHausnummer": this.stra\u00dfeHausnummer,
                            PLZ: this.plz,
                            Stadt: this.stadt,
                            Unternehmen: this.unternehmen,
                            Email: this.email,
                            Seriennummer: this.seriennummer,
                            HaendlerKto: this.haendlerList.find((haendler)=>{
                                if (haendler.Kto === this.haendlerKto) return true;
                                return false;
                            })?.Kto,
                            Kaufdatum: this.kaufdatum,
                            Kaufpreis: this.kaufpreis,
                            SourcePage: this.options.Name,
                            HasContactPermission: this.checkedPermission == undefined ? 0 : this.checkedPermission === false ? 0 : -1,
                            KomplettSchutz: this.checkedKomplettschutz === false ? 0 : -1
                        };
                        console.log(this.options.Name);
                        const files = document.querySelector("#filesToUpload").files;
                        const imgFormData = new FormData();
                        if (files != null) {
                            for(let i = 0; i < files.length; i++)imgFormData.append("files", files[i]);
                            if (gm.ID != null) {
                                (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).showLoading();
                                (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).IsValidSeriennummer(gm.Seriennummer ?? "", this.options.Name).then((result)=>{
                                    // console.log(result);
                                    if (result == "Seriennummer g\xfcltig") (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).post((0, $fb350c3721d80fcd$export$791c4e50320e809e)("Landing/SendGarantieKaufbeleg?ID=" + gm.ID + "&sourcePage=" + this.options.Name), imgFormData, {}).then((val)=>{
                                        if (val.data === "OK") (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).SendGarantieCustomerData(gm /*, "garantie"*/ ).then((guid)=>{
                                            alert("Ihr Antrag wird nun verarbeitet, vielen Dank!");
                                            location.reload();
                                        }).catch((error)=>{
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            const x = error?.response?.data ?? error ?? "unkown";
                                            alert(x);
                                        });
                                        else if (val.data === "FILES") {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("\xdcberpr\xfcfen Sie bitte, ob mit ihren hochgeladenen Dateien alles in Ordnung ist!");
                                        } else if (val.data === "FILEENDUNG") {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("\xdcberpr\xfcfen Sie bitte, ob Ihre hochgeladene Datei intakt ist und ob sie das richtige Format hat.\nErlaubt sind: .jpg, .png, .pdf!");
                                        } else {
                                            (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                            alert("Ein Fehler ist aufgetreten, bitte versuchen Sie es in wenigen Augenblick erneut!");
                                        }
                                    }).catch((error)=>{
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert("\xdcberpr\xfcfen Sie bitte Ihre Datei auf zul\xe4ssige Gr\xf6\xdfe und zul\xe4ssige Dateitypen!");
                                    });
                                    else {
                                        (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                        alert(result);
                                    }
                                }).catch((error)=>{
                                    (0, $57f3a842a837cf6c$export$669f6ea7d267feaf).hideLoading();
                                    const x = error?.response?.data ?? error ?? "unkown";
                                    alert(x);
                                });
                            }
                        }
                    } else alert("Bitte geben Sie eine g\xfcltige Email-Adresse ein!");
                } else {
                    this.highlightAllNotFilledInRequired();
                    alert("Bitte f\xfcllen Sie alle geforderten Felder aus!");
                }
            }
        }, "Absenden")))));
    }
    allRequiredFieldsFilledIn() {
        if (!this.anrede) return false;
        if (!this.vorname) return false;
        if (!this.nachname) return false;
        if (!this.stra\u00dfeHausnummer) return false;
        if (!this.plz) return false;
        if (!this.stadt) return false;
        if (!this.email) return false;
        if (!this.seriennummer) return false;
        if (!this.haendlerKto) return false;
        if (!this.kaufdatum) return false;
        if (!this.kaufpreis) return false;
        // if (this.checkedKomplettschutz == null) {
        //     document.getElementById("komplettSchutzOption").style.color = "red";
        //     return false;
        // } else {
        //     document.getElementById("komplettSchutzOption").style.color = "black";
        // }
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) return false;
        if (this.checkedDatenschutz == undefined || this.checkedDatenschutz === false) return false;
        if (this.checkedPermission == undefined || this.checkedPermission === false) return false;
        return true;
    }
    highlightAllNotFilledInRequired() {
        this.undoStyleChangesBeforehand();
        if (this.anrede == undefined) {
            document.getElementById("span-anrede").style.color = "red";
            document.getElementById("span-anrede").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.vorname == undefined) {
            document.getElementById("span-vorname").style.color = "red";
            document.getElementById("span-vorname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.nachname == undefined) {
            document.getElementById("span-nachname").style.color = "red";
            document.getElementById("span-nachname").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stra\u00dfeHausnummer == undefined) {
            document.getElementById("span-stra\xdfe").style.color = "red";
            document.getElementById("span-stra\xdfe").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.plz == undefined) {
            document.getElementById("span-plz").style.color = "red";
            document.getElementById("span-plz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.stadt == undefined) {
            document.getElementById("span-stadt").style.color = "red";
            document.getElementById("span-stadt").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.email == undefined) {
            document.getElementById("span-email").style.color = "red";
            document.getElementById("span-email").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.seriennummer == undefined) {
            document.getElementById("span-seriennummer").style.color = "red";
            document.getElementById("span-seriennummer").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.haendlerKto == undefined || this.haendlerKto === "") {
            document.getElementById("span-haendler").style.color = "red";
            document.getElementById("span-haendler").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.kaufdatum == undefined) {
            document.getElementById("span-kaufdatum").style.color = "red";
            document.getElementById("span-kaufdatum").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (!this.kaufpreis) {
            document.getElementById("span-kaufpreis").style.color = "red";
            document.getElementById("span-kaufpreis").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        const doc = document.querySelector("#filesToUpload");
        if (doc.files == null || doc.files == undefined || doc.files.length == 0 || doc.files.length > 1) {
            document.getElementById("span-rechnung").style.color = "red";
            document.getElementById("span-rechnung").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.checkedDatenschutz == undefined) {
            document.getElementById("span-datenschutz").style.color = "red";
            document.getElementById("span-datenschutz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
        if (this.checkedPermission == undefined) {
            document.getElementById("span-datenschutz").style.color = "red";
            document.getElementById("span-datenschutz").style.textShadow = "0.7px 0.7px 0.5px black";
        }
    }
    undoStyleChangesBeforehand() {
        document.getElementById("span-anrede").style.color = "black";
        document.getElementById("span-anrede").style.textShadow = "none";
        document.getElementById("span-vorname").style.color = "black";
        document.getElementById("span-vorname").style.textShadow = "none";
        document.getElementById("span-nachname").style.color = "black";
        document.getElementById("span-nachname").style.textShadow = "none";
        document.getElementById("span-stra\xdfe").style.color = "black";
        document.getElementById("span-stra\xdfe").style.textShadow = "none";
        document.getElementById("span-plz").style.color = "black";
        document.getElementById("span-plz").style.textShadow = "none";
        document.getElementById("span-stadt").style.color = "black";
        document.getElementById("span-stadt").style.textShadow = "none";
        document.getElementById("span-email").style.color = "black";
        document.getElementById("span-email").style.textShadow = "none";
        document.getElementById("span-seriennummer").style.color = "black";
        document.getElementById("span-seriennummer").style.textShadow = "none";
        document.getElementById("span-haendler").style.color = "black";
        document.getElementById("span-haendler").style.textShadow = "none";
        document.getElementById("span-kaufdatum").style.color = "black";
        document.getElementById("span-kaufdatum").style.textShadow = "none";
        document.getElementById("span-rechnung").style.color = "black";
        document.getElementById("span-rechnung").style.textShadow = "none";
        document.getElementById("span-datenschutz").style.color = "black";
        document.getElementById("span-datenschutz").style.textShadow = "none";
    }
    checkEmail(email) {
        if (email.indexOf("@") === -1) return false;
        const split_arr = email.split("@");
        if (split_arr[0].length <= 0) return false;
        if (split_arr[1].length <= 0) return false;
        return true;
    }
    getDatenschutzbestimmungenText() {
        return /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-sections"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section  pos-0 cms-section-default",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-section-default boxed"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block  pos-0 cms-block-text",
            style: ""
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container",
            style: "padding: 20px 20px 20px 20px;"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-block-container-row row cms-row "
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "col-12",
            "data-cms-element-id": "eb20ee63af314345b702de452230f323"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("div", {
            class: "cms-element-text"
        }, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("hr", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "1. Datenschutz auf einen Blick"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Allgemeine Hinweise"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die folgenden Hinweise geben einen einfachen \xdcberblick dar\xfcber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Ausf\xfchrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef\xfchrten Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Analyse-Tools und Tools von Drittanbietern", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zur\xfcckverfolgt werden. Sie k\xf6nnen dieser Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen dazu finden Sie in der folgenden Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen dieser Analyse widersprechen. \xdcber die Widerspruchsm\xf6glichkeiten werden wir Sie in dieser Datenschutzerkl\xe4rung informieren."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "2. Allgemeine Hinweise und Pflichtinformationen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Datenschutz"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers\xf6nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xe4rung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Die vorliegende Datenschutzerkl\xe4rung erl\xe4utert, welche Daten wir erheben und wof\xfcr wir sie nutzen. Sie erl\xe4utert auch, wie und zu welchem Zweck das geschieht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir weisen darauf hin, dass die Daten\xfcbertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitsl\xfccken aufweisen kann. Ein l\xfcckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xf6glich.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hinweis zur verantwortlichen Stelle", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die verantwortliche Stelle f\xfcr die Datenverarbeitung auf dieser Website ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Nivona Apparte GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 0911 2526630", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://info@nivona.com"
        }, "info@nivona.com"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Verantwortliche Stelle ist die nat\xfcrliche oder juristische Person, die allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. \xc4.) entscheidet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Widerruf Ihrer Einwilligung zur Datenverarbeitung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Viele Datenverarbeitungsvorg\xe4nge sind nur mit Ihrer ausdr\xfccklichen Einwilligung m\xf6glich. Sie k\xf6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtm\xe4\xdfigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Falle datenschutzrechtlicher Verst\xf6\xdfe steht dem Betroffenen ein Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde zu. Zust\xe4ndige Aufsichtsbeh\xf6rde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten k\xf6nnen folgendem Link entnommen werden: https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Recht auf Daten\xfcbertragbarkeit", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xfcllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g\xe4ngigen, maschinenlesbaren Format aush\xe4ndigen zu lassen. Sofern Sie die direkte \xdcbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft, Sperrung, L\xf6schung", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xfcber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xe4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder L\xf6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xf6nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "3. Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Gesetzlich vorgeschriebener Datenschutzbeauftragter"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben f\xfcr unser Unternehmen einen Datenschutzbeauftragten bestellt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sigmundstra\xdfe 172", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "E-Mail: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "4. Datenerfassung auf unserer Website"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Cookies"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die meisten der von uns verwendeten Cookies sind so genannte \u201CSession-Cookies\u201D. Sie werden nach Ende Ihres Besuchs automatisch gel\xf6scht. Andere Cookies bleiben auf Ihrem Endger\xe4t gespeichert bis Sie diese l\xf6schen. Diese Cookies erm\xf6glichen es uns, Ihren Browser beim n\xe4chsten Besuch wiederzuerkennen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen Ihren Browser so einstellen, dass Sie \xfcber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f\xfcr bestimmte F\xe4lle oder generell ausschlie\xdfen sowie das automatische L\xf6schen der Cookies beim Schlie\xdfen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit\xe4t dieser Website eingeschr\xe4nkt sein.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Cookies, die zur Durchf\xfchrung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erw\xfcnschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerkl\xe4rung gesondert behandelt."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "5. Analyse Tools und Werbung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Analytics"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), 'Google Analytics verwendet so genannte "Cookies". Das sind Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm\xf6glichen. Die durch den Cookie erzeugten Informationen \xfcber Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert.', /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "IP Anonymisierung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europ\xe4ischen Union oder in anderen Vertragsstaaten des Abkommens \xfcber den Europ\xe4ischen Wirtschaftsraum vor der \xdcbermittlung in die USA gek\xfcrzt. Nur in Ausnahmef\xe4llen wird die volle IP-Adresse an einen Server von Google in den USA \xfcbertragen und dort gek\xfcrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xfcber die Websiteaktivit\xe4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xfcber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser \xfcbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xfchrt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Browser Plugin"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht s\xe4mtliche Funktionen dieser Website vollumf\xe4nglich werden nutzen k\xf6nnen. Sie k\xf6nnen dar\xfcber hinaus die Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verf\xfcgbare Browser-Plugin herunterladen und installieren: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://tools.google.com/dlpage/gaoptout?hl=de"
        }, "https://tools.google.com/dlpage/gaoptout?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Widerspruch gegen Datenerfassung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie k\xf6nnen die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zuk\xfcnftigen Besuchen dieser Website verhindert: Google Analytics deaktivieren.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://support.google.com/analytics/answer/6004245?hl=de"
        }, "https://support.google.com/analytics/answer/6004245?hl=de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Auftragsdatenverarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die strengen Vorgaben der deutschen Datenschutzbeh\xf6rden bei der Nutzung von Google Analytics vollst\xe4ndig um."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h2", null, "6. Plugins und Tools"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "YouTube"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unsere Website nutzt Plugins der von Google betriebenen Seite YouTube. Betreiber der Seiten ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie in Ihrem YouTube-Account eingeloggt sind, erm\xf6glichen Sie YouTube, Ihr Surfverhalten direkt Ihrem pers\xf6nlichen Profil zuzuordnen. Dies k\xf6nnen Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von YouTube unter: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy"
        }, "https://www.google.de/intl/de/policies/privacy")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h3", null, "Google Maps"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Diese Seite nutzt \xfcber eine API den Kartendienst Google Maps. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Daten\xfcbertragung.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerkl\xe4rung von Google: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "https://www.google.de/intl/de/policies/privacy/"
        }, "https://www.google.de/intl/de/policies/privacy/"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\xa0", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null)), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("h4", null, "Pflichtinformationen gem. Art. 12 ff. DS-GVO"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Kontaktdaten des Verantwortlichen"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Name: Peter", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Vorname: Wildner", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: NIVONA Apparate GmbH", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: S\xfcdwestpark 49", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Telefon: 90449 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://peter.wildner@nivona.com"
        }, "peter.wildner@nivona.com")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten des Datenschutzbeauftragten", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Kontaktdaten (gesch\xe4ftlich)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Unternehmen: Marc Fuchs (DATEV eG)", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Anschrift: Sigmundstra\xdfe 172; 90329 N\xfcrnberg", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Email: ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("a", {
            target: "_self",
            href: "http://marc.fuchs@datev.de"
        }, "marc.fuchs@datev.de"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Woher beziehen wir Ihre personenbezogenen Daten?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Erhebung Ihrer Daten findet grunds\xe4tzlich bei Ihnen selbst statt. Die Verarbeitung der von Ihnen \xfcberlassenen personenbezogenen Daten ist zur Erf\xfcllung der vertraglichen Pflichten, die sich aus dem mit uns geschlossenen Vertrag ergeben, notwendig. Aufgrund Ihrer Mitwirkungspflichten ist es unumg\xe4nglich die von uns angeforderten personenbezogenen Daten zur Verf\xfcgung zu stellen, da wir ansonsten unseren vertraglichen Pflichten nicht nachkommen k\xf6nnen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen vorvertraglicher Ma\xdfnahmen (z. B. Stammdatenerfassung im Interessentenprozess) ist die Bereitstellung Ihrer personenbezogenen Daten notwendig. Sollten die angeforderten Daten nicht von Ihnen bereitgestellt werden, kann ein Vertrag nicht abgeschlossen werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Erbringung unserer Dienstleistungen kann es erforderlich sein, personenbezogene Daten zu verarbeiten, die wir von anderen Unternehmen oder sonstigen Dritten, z. B. Finanz\xe4mtern, Ihren Gesch\xe4ftspartner o. \xe4. zul\xe4ssigerweise und zu dem jeweiligen Zweck erhalten haben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weiterhin verarbeiten wir ggf. personenbezogene Daten aus \xf6ffentlich zug\xe4nglichen Quellen, z. B. Internetauftritten, die wir zul\xe4ssigerweise und nur zu dem jeweiligen Vertragszweck nutzen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zwecke und Rechtsgrundlagen der Verarbeitung"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die von Ihnen \xfcberlassenen personenbezogenen Daten werden im Einklang mit den Bestimmungen der europ\xe4ischen Datenschutzverordnung (DS-GVO) und dem Bundesdatenschutzgesetz (BDSG) verarbeitet:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund einer Einwilligung (gem. Art. 6 Abs. 1 Lit. a DS-GVO)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Verarbeitung personenbezogener Daten ergeben sich aus der Erteilung einer Einwilligung. Eine erteilte Einwilligung kann jederzeit von Ihnen mit Wirkung f\xfcr die Zukunft widerrufen werden. Auch Einwilligungen, die vor der Geltung der DS-GVO (25. Mai 2018) erteilt worden sind, k\xf6nnen widerrufen werden. Verarbeitungen, die vor dem Widerruf erfolgt sind, bleiben vom Widerruf unber\xfchrt. Beispiel: Zusendung eines Newsletters, Einwilligung zur Weitergabe der von Ihnen \xfcberlassenen Daten auf Ihren Wunsch hin an Dritte (z. B. Banken, Versicherungen, Anteilseigner etc.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Zur Erf\xfcllung von vertraglichen Pflichten (gem. Art. 6 Abs. 1 Lit. b DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Zwecke der Datenverarbeitung ergeben sich zum einen aus der Einleitung vorvertraglicher Ma\xdfnahmen, die einer vertraglich geregelten Gesch\xe4ftsbeziehung vorausgehen und zum anderen zur Erf\xfcllung der Pflichten aus dem mit Ihnen geschlossenen Vertrag.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Aufgrund gesetzlicher Vorgaben (gem. Art. 6 Abs.1 Lit. c DS-GVO) oder im \xf6ffentlichen Interesse (gem. Art. 6 Abs.1 Lit. e DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Datenverarbeitung ergeben sich aus gesetzlichen Vorgaben oder liegen im \xf6ffentlichen Interesse (z. B. Einhaltung von Aufbewahrungspflichten, Nachweis der Einhaltung von Hinweis- und Informationspflichten des Steuerberaters).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Im Rahmen der Interessenabw\xe4gung (gem. Art. 6 Abs. 1 Lit. f DS-GVO)")), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, "Die Zwecke der Verarbeitung ergeben sich aus der Wahrung unserer berechtigten Interessen. Es kann erforderlich sein, die von Ihnen \xfcberlassenen Daten \xfcber die eigentliche Erf\xfcllung des Vertrages hinaus zu verarbeiten. Unser berechtigtes Interesse kann zur Begr\xfcndung der weiteren Verarbeitung der von Ihnen \xfcberlassenen Daten herangezogen werden, sofern Ihre Interessen oder Grundrechte und Grundfreiheiten nicht \xfcberwiegen. Unser berechtigtes Interesse kann im Einzelfall sein: Geltendmachung rechtlicher Anspr\xfcche, Abwehr von Haftungsanspr\xfcchen, Verhinderung von Straftaten.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wer erh\xe4lt die von Ihnen \xfcberlassenen personenbezogenen Daten?", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Innerhalb unseres Unternehmens erhalten diejenigen Bereiche Zugriff auf die von Ihnen \xfcberlassenen personenbezogenen Daten, die diese zur Erf\xfcllung der vertraglichen und gesetzlichen Pflichten ben\xf6tigen und die zur Verarbeitung dieser Daten berechtigt sind.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "In Erf\xfcllung des mit Ihnen geschlossenen Vertrages erhalten ausschlie\xdflich diejenigen Stellen die von Ihnen \xfcberlassenen Daten, die diese aus gesetzlichen Gr\xfcnden ben\xf6tigen, z. B. Finanzbeh\xf6rden, Sozialversicherungstr\xe4ger, zust\xe4ndige Beh\xf6rden und Gerichte.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Weitere Empf\xe4nger erhalten die von Ihnen \xfcberlassenen Daten nur auf Ihren Wunsch hin, wenn Sie uns die hierf\xfcr notwendige Einwilligung erteilen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Im Rahmen unserer Leistungserbringung beauftragen wir Auftragsverarbeiter, die zur Erf\xfcllung der vertraglichen Pflichten beitragen, z. B. EDV-Partner, Aktenvernichter, Fachh\xe4ndler etc. Diese Auftragsverarbeiter werden von uns vertraglich zur Einhaltung der Vorgaben der DS-GVO und des BDSG verpflichtet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Werden die von Ihnen \xfcberlassenen Daten an Drittl\xe4nder oder internationale Organisationen \xfcbermittelt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Eine \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation erfolgt in keinem Fall. Sollten Sie im Einzelfall die \xdcbermittlung der von Ihnen \xfcberlassenen Daten an ein Drittland oder eine internationale Organisation w\xfcnschen, f\xfchren wir dies nur nach Ihrer schriftlichen Einwilligung durch."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Findet automatisierte Entscheidungsfindung einschlie\xdflich Profiling statt?"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Zur Verarbeitung der von Ihnen \xfcberlassenen Daten kommt keine vollautomatisierte Entscheidungsfindung (einschlie\xdflich Profiling) gem. Art. 22 DS-GVO zum Einsatz."), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("p", null, /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("b", null, "Dauer der Verarbeitung (Kriterien der L\xf6schung)"), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Die Verarbeitung der von Ihnen \xfcberlassenen Daten erfolgt so lange, wie sie zur Erreichung des vertraglich vereinbarten Zweckes notwendig ist, grunds\xe4tzlich so lange das Vertragsverh\xe4ltnis mit Ihnen besteht. Nach der Beendigung des Vertragsverh\xe4ltnisses werden die von Ihnen \xfcberlassenen Daten zur Einhaltung gesetzlicher Aufbewahrungspflichten oder aufgrund unserer berechtigten Interessen verarbeitet. Nach dem Ablauf der gesetzlichen Aufbewahrungsfristen und/oder dem Wegfall unserer berechtigten Interessen werden die von Ihnen \xfcberlassenen Daten gel\xf6scht.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Voraussichtliche Fristen der uns treffenden Aufbewahrungspflichten und unserer berechtigten Interessen:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erf\xfcllung handels- und steuerrechtlicher Aufbewahrungsfristen. Die dort vorgegebenen Fristen zur Aufbewahrung bzw. Dokumentation betragen zwei bis zehn Jahre.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Erhaltung von Beweismitteln im Rahmen der Verj\xe4hrungsvorschriften. Nach den \xa7\xa7 195 ff. des B\xfcrgerlichen Gesetzbuches (BGB) k\xf6nnen diese Verj\xe4hrungsfristen bis zu 30 Jahre betragen, wobei die regelm\xe4\xdfige Verj\xe4hrungsfrist drei Jahre betr\xe4gt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Auskunft \xfcber Ihre Rechte", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Auskunft gem. Art. 15 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, auf Antrag unentgeltlich Auskunft zu erhalten, ob und welche Daten \xfcber Sie gespeichert sind und zu welchem Zweck die Speicherung erfolgt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Berichtigung gem. Art. 16 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen unverz\xfcglich die Berichtigung Ihrer unrichtigen personenbezogenen Daten zu verlangen. Unter Ber\xfccksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollst\xe4ndigung unvollst\xe4ndiger personenbezogener Daten \u2014 auch mittels einer erg\xe4nzenden Erkl\xe4rung \u2014 zu verlangen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf L\xf6schung (\u201ERecht auf Vergessenwerden\u201C) gem. Art. 17 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht, von dem Verantwortlichen zu verlangen, dass Ihre Daten unverz\xfcglich gel\xf6scht werden. Der Verantwortliche ist verpflichtet, personenbezogene Daten unverz\xfcglich zu l\xf6schen, sofern einer der folgenden Gr\xfcnde zutrifft:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Zwecke, f\xfcr die die personenbezogenen Daten erhoben wurden, entfallen", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Sie widerrufen Ihre Einwilligung der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Sie widersprechen der Verarbeitung. Eine anderweitige Rechtsgrundlage f\xfcr die Verarbeitung liegt nicht vor.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Die personenbezogenen Daten wurden unrechtm\xe4\xdfig verarbeitet.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "e) Die L\xf6schung der personenbezogenen Daten ist zur Erf\xfcllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "f) Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gem\xe4\xdf Artikel 8 Absatz 1 erhoben.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Einschr\xe4nkung der Verarbeitung gem. Art. 18 DS-GVO &. \xa7 35 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die Einschr\xe4nkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "a) Die Richtigkeit der personenbezogenen Daten wird von Ihnen angezweifelt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "b) Die Verarbeitung ist unrechtm\xe4\xdfig; Sie lehnen eine L\xf6schung jedoch ab.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "c) Personenbezogene Daten werden f\xfcr die Zwecke der Verarbeitung nicht l\xe4nger ben\xf6tigt; Sie ben\xf6tigen die Daten jedoch zur Geltendmachung, Aus\xfcbung oder Verteidigung von Rechtsanspr\xfcchen.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "d) Sie haben Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt. Solange noch nicht feststeht, ob die berechtigten Gr\xfcnde des Verantwortlichen Ihnen gegen\xfcber \xfcberwiegen, wird die Verarbeitung eingeschr\xe4nkt.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Recht auf Daten\xfcbertragbarkeit gem. Art. 20 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Sie haben das Recht die von Ihnen bereitgestellten Daten in einem strukturierten, g\xe4ngigen und maschinenlesbaren Format von dem Verantwortlichen zu erhalten. Eine Weiterleitung an einen andern Verantwortlichen darf von uns nicht behindert werden.", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Widerspruchsrecht gem. Art. 21 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Hierzu wenden Sie sich bitte an den Verantwortlichen der Verarbeitung (s. o.).", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Beschwerderecht bei der Aufsichtsbeh\xf6rde gem. Art. 13 Abs. 2 Lit. d, 77 DS-GVO", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "i. V. m \xa7 19 BDSG:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen die DS-GVO verst\xf6\xdft, haben Sie das Recht Beschwerde bei der Aufsichtsbeh\xf6rde einzulegen. Hierzu wenden Sie sich bitte an die zust\xe4ndige Aufsichtsbeh\xf6rde", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "\u2022 Zur\xfcckziehen der Einwilligung gem. Art. 7 Abs. 3 DS-GVO:", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null), "Beruht die Verarbeitung auf Ihrer Einwilligung gem. Art. 6 Abs. 1 Lit. a oder Art. 9 Abs. 2 Lit. a (Verarbeitung besonderer Kategorien personenbezogener Daten), sind Sie jederzeit dazu berechtigt die zweckm\xe4\xdfig gebundene Einwilligung zur\xfcckzuziehen, ohne dass die Rechtm\xe4\xdfigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung ber\xfchrt wird. ", /*#__PURE__*/ (0, $94d9b987c06daf61$export$7679def1e07eb2d1).createElement("br", null))))))))));
    }
}


class $12c30f411bd46e56$export$3aff8a2cdcff0633 {
    constructor(options){
        this.options = options;
        switch(options.Type){
            case "garantie":
                this.actualForm = new (0, $daadc7667501bd5c$export$fb8d0680d466ed30)(options);
                break;
            case "wert":
                if (options.Name === "wertgarantie25") this.actualForm = new (0, $31fa76e2b35f3ee9$export$69e06b009b0ee08e)(options);
                else this.actualForm = new (0, $84c9ca7b981f069c$export$23ed401b9a56e6b2)(options);
                break;
            case "starterset":
                this.actualForm = new (0, $45038dfb870da572$export$f33daeb3232faaeb)(options);
                break;
            default:
                this.actualForm = new (0, $a356dde23eb6c2f6$export$65db35c377fab04b)("Unbekannte Formular Art");
        }
    // if (options.Type === "garantie") {
    //   this.actualForm = new GarantieComponent(options);
    // } else if (options.Type === "wert") {
    //   this.actualForm = new GarantieComponent(options); // TODO
    // } else if (options.Type === "starterset") {
    //   this.actualForm = new StartersetComponent(options);
    // } else {
    //   this.actualForm = new ErrorComponent("Unbekannte Formular Art");
    // }
    }
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            class: "landing-page-comp"
        }, /*#__PURE__*/ React.createElement("h1", null, this.options.Title), {
            tag: "div",
            content: this.options.TextAsHTML,
            raw: true
        }, this.actualForm);
    }
}









class $f7b886fb189e9366$export$a4b645333aea1a0 {
    constructor(options){
        this.options = options;
        this.actualForm = new (0, $45038dfb870da572$export$f33daeb3232faaeb)(options, new Date(2025, 7 /* TODO: change to 8 later on - not 9 - we are in javascript */ , 1));
    }
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            class: "moelk-page-comp",
            style: "padding-top:5rem;padding-bottom: 1px;"
        }, /*#__PURE__*/ React.createElement("div", {
            class: "sommer-cover"
        }, new (0, $e58f9f5386b72872$export$989fb497e9419607)([
            /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h1", null, "Mehr. Ganz einfach."), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("strong", null, "Mehr Vielfalt. Mehr Genuss. Mehr Kaffeemomente.")), /*#__PURE__*/ React.createElement("p", null, "Sie haben sich f\xfcr eine NIVO 9000er entschieden? Dann gibt es jetzt noch mehr dazu: Registrieren Sie Ihr neues Ger\xe4t nach dem Kauf einfach hier und sichern Sie sich unser exklusives ", /*#__PURE__*/ React.createElement("strong", null, "Genuss-Set im Wert von \xfcber 50 Euro."))),
            /*#__PURE__*/ React.createElement("div", {
                style: "margin-left:2rem;"
            }, /*#__PURE__*/ React.createElement("img", {
                src: (0, $fb350c3721d80fcd$export$791c4e50320e809e)("Content/images/sommer/nivona_transparency.png"),
                alt: "Nivona x eismann",
                style: "width:80vw;max-width:36rem;margin-top:-2.8rem;"
            }))
        ], {
            orientation: "horizontal",
            responsive: true
        }), /*#__PURE__*/ React.createElement("p", null, "Freuen Sie sich auf:", /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("strong", null, "eine NIVONA Milchlanze "), " \u2013 f\xfcr Milch oder Hafermilch direkt aus der Verpackung"), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("strong", null, "8 Liter M\xf8lk Hafer Barista "), " \u2013 f\xfcr cremigen Cappuccino und Co."), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("strong", null, "eine Chilled Brew-Box "), " \u2013 f\xfcr einen besonderen kalten Kaffeemoment"))), /*#__PURE__*/ React.createElement("p", null, "F\xfcllen Sie einfach das Formular auf dieser Seite aus und senden Sie Ihre Daten ab. Wir k\xfcmmern uns um den Rest."), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("button", {
            class: "jsl-button",
            style: "width:16rem;",
            click: ()=>{
                const el = document.getElementById("anchor-register");
                if (el != null) el.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        }, "JETZT REGISTRIEREN")), /*#__PURE__*/ React.createElement("p", null, "\xa0"), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("strong", null, "Hei\xdf oder kalt. Mit Milch oder Hafer. Hauptsache einfach gut.")), /*#__PURE__*/ React.createElement("p", null, "Mit Ihrer NIVO 9000er k\xf6nnen Sie Kaffeegenuss ganz nach Ihrem Geschmack genie\xdfen. Die Milchlanze macht den Wechsel zwischen Milch und Pflanzendrink besonders unkompliziert. Und mit der Chilled Brew-Box k\xf6nnen Sie direkt eine ganz andere Seite Ihrer NIVONA ausprobieren."), /*#__PURE__*/ React.createElement("p", null, "Die ", /*#__PURE__*/ React.createElement("strong", null, "Chilled Brew-Box"), " enth\xe4lt zwei NIVONA-Kaffeegl\xe4ser, Kaffee, ein Rezeptheft sowie eine Flasche ", /*#__PURE__*/ React.createElement("strong", null, "Aqua Monaco Tonic Water (0,33 l)"), " \u2013 perfekt f\xfcr einen erfrischenden Chilled Brew Tonic."), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("strong", null, "Nur solange der Vorrat reicht.")), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("i", null, "Die Aktion gilt beim Kauf eines Modells der NIVO 9000er-Serie im Aktionszeitraum bis 31. Januar 2027 bei einem autorisierten NIVONA-Fachh\xe4ndler in Deutschland und anschlie\xdfender Online-Registrierung. Teilnahmeberechtigt sind Endkunden ab 18 Jahren mit Wohnsitz in Deutschland. Die Zugabe ist nur erh\xe4ltlich, solange der Vorrat reicht."))), /*#__PURE__*/ React.createElement("div", {
            style: "background:#F0EAE7;"
        }, /*#__PURE__*/ React.createElement("div", {
            id: "anchor-register",
            class: "landing-page-comp",
            style: "background:none;max-width:1200px;margin:auto;"
        }, /*#__PURE__*/ React.createElement("div", {
            class: "register-header"
        }, /*#__PURE__*/ React.createElement("h1", null, "Registrierung")), this.actualForm)));
    }
}


class $081439d2931ec53b$export$4e7c44975c5969f5 {
    constructor(form){
        this.form = form;
    }
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            style: "padding:1rem;font-size:1.1rem;z-index:10;position: relative;"
        }, /*#__PURE__*/ React.createElement("p", null, "Vielen Dank f\xfcr Ihre Angaben und Ihre Registrierung bei unserer Ausgezeichnet-Aktion zur 7er-Serie. Sie erhalten in K\xfcrze eine Mail mit allen weiteren Informationen."), /*#__PURE__*/ React.createElement("p", null, "Ihr NIVONA-Team"), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("a", {
            href: "#" + this.form
        }, "Weitere Maschine registrieren")));
    }
}


(0, $3f4c5ccf8da2a18c$export$2e2bcd8739ae039).set("de");
// const regex: RegExp = new RegExp('.+');
const $c4a57d39a9183f39$var$renderer = new (0, $83d498fca38a60e6$export$8beec2e5b8623754)(document.body, true);
const $c4a57d39a9183f39$var$routes = {
    "": ()=>{
        (0, $0c412a07a28a0d02$export$f6ff04b41b36f7bc).navigate("search");
    },
    /* service portal routes */ "status": (parameters)=>{
        if (parameters.length === 0) $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $a356dde23eb6c2f6$export$65db35c377fab04b)("")));
        else if (parameters[0] === "") $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $a356dde23eb6c2f6$export$65db35c377fab04b)("")));
        else $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $aa56e06b8c23d3a3$export$fb63530bed1f6351)(parameters[0])));
    },
    "error": ()=>{
        $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $a356dde23eb6c2f6$export$65db35c377fab04b)("")));
    },
    "search": ()=>{
        if (location.href.toLocaleLowerCase().startsWith("https://office.nivona.online")) (0, $0c412a07a28a0d02$export$f6ff04b41b36f7bc).navigate("#garantie");
        else if (location.href.toLocaleLowerCase().startsWith("https://sorgenfrei.nivona.online")) (0, $0c412a07a28a0d02$export$f6ff04b41b36f7bc).navigate("#wertgarantie25");
        else if (location.href.toLocaleLowerCase().startsWith("https://ausgezeichnet.nivona.online")) (0, $0c412a07a28a0d02$export$f6ff04b41b36f7bc).navigate("#ausgezeichnet");
        else if (location.href.toLocaleLowerCase().startsWith("https://sicheristsicher.nivona.online")) (0, $0c412a07a28a0d02$export$f6ff04b41b36f7bc).navigate("#wertgarantie26");
        else if (location.href.toLocaleLowerCase().startsWith("https://starter.nivona.online")) (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).GetLandingForm("m\xf6lk").then((form)=>{
            if (form != null) $c4a57d39a9183f39$var$renderer.render(new (0, $f7b886fb189e9366$export$a4b645333aea1a0)(form));
            else alert("Error - Aktion ausgelaufen");
        }).catch((e)=>{
            console.log(e);
            $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $a356dde23eb6c2f6$export$65db35c377fab04b)("Ein Fehler ist aufgetreten, bitte versuchen Sie es sp\xe4ter erneut")));
        });
        else $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $2a52b400a362c5e5$export$ad96b2d0e7eb81f)()));
    },
    /* deprecated landing page routes */ "garantie": ()=>{
        $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $0a4ecc7e34f5db32$export$3dafe66f8a8e062b)()));
    },
    // "starterset": () => {
    //     renderer.render(new LayoutComponent(new GarantieVerlaengerungComponent9er()));
    // },
    "sucessGarantie": (params)=>{
        $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $081439d2931ec53b$export$4e7c44975c5969f5)(params[0])));
    }
};
$c4a57d39a9183f39$var$renderer.render(new (0, $0d00c7f89a9659aa$export$7db30d367db7d20a)(4));
(0, $0c412a07a28a0d02$export$f6ff04b41b36f7bc).setup($c4a57d39a9183f39$var$routes, async (name)=>{
    if (location.hash.length > 1) // check if this hash is a valid landing page - otherwise 404 error
    try {
        const form = await (0, $03a6e665f65a3887$export$5e12a1e07cfbd77a).GetLandingForm(name);
        if (form != null) $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $12c30f411bd46e56$export$3aff8a2cdcff0633)(form)));
        else $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $a356dde23eb6c2f6$export$65db35c377fab04b)("Diese Seite existiert leider nicht mehr")));
    } catch (e) {
        console.log(e);
        $c4a57d39a9183f39$var$renderer.render(new (0, $2636d2675110968f$export$2f814a82e6b7c8e3)(new (0, $a356dde23eb6c2f6$export$65db35c377fab04b)("Ein Fehler ist aufgetreten, bitte versuchen Sie es sp\xe4ter erneut")));
    }
});

})();
//# sourceMappingURL=index.js.map
